/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Created.ai API
 * OpenAPI spec version: 1
 */
import * as zod from 'zod';

export const TeamRole = zod.enum(['owner', 'admin', 'editor']).describe('The three team roles (decision D7). `teams.can()` decides what each may do.');

export type TeamRole = zod.input<typeof TeamRole>;
export type TeamRoleOutput = zod.output<typeof TeamRole>;

export const TeamScope = zod.object({
  "brand_ids": zod.array(zod.uuid()),
  "role": TeamRole,
  "team_id": zod.uuid()
}).describe('One team of the actor: their role and the team\'s brands.');

export type TeamScope = zod.input<typeof TeamScope>;
export type TeamScopeOutput = zod.output<typeof TeamScope>;

export const AccessScope = zod.object({
  "teams": zod.array(TeamScope),
  "user_id": zod.uuid()
}).describe('`GET /v1/me/access-scope`: the one source for the SPA\'s gates, and the contract later\nservices use instead of a user token (proposal 6.1, D13). A PAT sees only its own team.');

export type AccessScope = zod.input<typeof AccessScope>;
export type AccessScopeOutput = zod.output<typeof AccessScope>;

export const EarnedIn = zod.object({
  "earned_at": zod.iso.datetime({"offset":true}),
  "team_id": zod.union([zod.uuid(),zod.null()])
}).describe('One place the user earned an achievement: a team, or their account (`team_id` null).');

export type EarnedIn = zod.input<typeof EarnedIn>;
export type EarnedInOutput = zod.output<typeof EarnedIn>;

export const Progress = zod.object({
  "have": zod.int(),
  "need": zod.int()
}).describe('A locked achievement\'s counters against its rule: `have` of `need`, "312 of 500".');

export type Progress = zod.input<typeof Progress>;
export type ProgressOutput = zod.output<typeof Progress>;

export const Stage = zod.enum(['account', 'team', 'brands', 'library', 'generations', 'templates', 'editor', 'saving', 'sounds', 'actors', 'credits', 'across']).describe('Where an entry sits on the board, as 3.6 groups them, in the board\'s order.');

export type Stage = zod.input<typeof Stage>;
export type StageOutput = zod.output<typeof Stage>;

export const Tier = zod.enum(['extra', 'supporting-role', 'leading-role', 'directors-cut', 'cult-classic']).describe('The five tiers (3.1), rarest last.');

export type Tier = zod.input<typeof Tier>;
export type TierOutput = zod.output<typeof Tier>;

export const achievementViewIdOneRegExp = new RegExp('^[a-z0-9][a-z0-9_.:-]{0,63}$');


export const AchievementView = zod.object({
  "description": zod.union([zod.string(),zod.null()]),
  "earned_in": zod.array(EarnedIn),
  "glyph": zod.union([zod.string(),zod.null()]),
  "hint": zod.union([zod.string(),zod.null()]),
  "id": zod.union([zod.string().regex(achievementViewIdOneRegExp),zod.null()]),
  "name": zod.string(),
  "progress": zod.union([Progress,zod.null()]),
  "secret": zod.boolean(),
  "stage": Stage,
  "tier": Tier
}).describe('One offered achievement as its user may see it (7.2, 7.4). Earned: all of it, with each\nplace it was earned. Locked: its copy and, for a rule that counts, its best team\'s progress.\nA locked secret: "???", its stage, tier and hint, and no id or glyph, which would give it\naway.');

export type AchievementView = zod.input<typeof AchievementView>;
export type AchievementViewOutput = zod.output<typeof AchievementView>;

export const TeamSharing = zod.object({
  "shared": zod.boolean(),
  "team_id": zod.uuid()
}).describe('Whether the user shares the awards they earned in one of their teams with its members.');

export type TeamSharing = zod.input<typeof TeamSharing>;
export type TeamSharingOutput = zod.output<typeof TeamSharing>;

export const unseenAwardAchievementIdRegExp = new RegExp('^[a-z0-9][a-z0-9_.:-]{0,63}$');


export const UnseenAward = zod.object({
  "achievement_id": zod.string().regex(unseenAwardAchievementIdRegExp),
  "award_id": zod.uuid(),
  "earned_at": zod.iso.datetime({"offset":true}),
  "team_id": zod.union([zod.uuid(),zod.null()])
}).describe('An unlock the user has not seen: the trophy counts it and its popover shows it (7.1).');

export type UnseenAward = zod.input<typeof UnseenAward>;
export type UnseenAwardOutput = zod.output<typeof UnseenAward>;

export const AchievementBoard = zod.object({
  "achievements": zod.array(AchievementView),
  "earned": zod.int(),
  "hidden": zod.boolean(),
  "offered": zod.int(),
  "quiet": zod.int(),
  "secrets": zod.int(),
  "secrets_found": zod.int(),
  "sharing": zod.array(TeamSharing),
  "unseen": zod.array(UnseenAward)
}).describe('`GET /v1/me/achievements`: the user\'s board across every team they are in (5). Each\noffered achievement once, by stage, earned first; the totals, `earned` of `offered` and\n`secrets_found` of `secrets`, as the tab says them; `quiet`, how many were earned before the\njourney counted, the tab\'s one line (3.4); the unseen unlocks, newest first; the user\'s\nswitch, Hide, and their sharing in each team.');

export type AchievementBoard = zod.input<typeof AchievementBoard>;
export type AchievementBoardOutput = zod.output<typeof AchievementBoard>;

export const achievementUnlockedFrameAchievementIdRegExp = new RegExp('^[a-z0-9][a-z0-9_.:-]{0,63}$');


export const AchievementUnlockedFrame = zod.object({
  "achievement_id": zod.string().regex(achievementUnlockedFrameAchievementIdRegExp),
  "award_id": zod.uuid()
}).describe('The `data:` of an `achievement_unlocked` frame (spec journey/achievements.md, 4): a\n`platform.stream_event` row that names its user and its team, sent to that user\'s streams of\nthe team alone, live and on replay; no teammate\'s stream carries it or its id. The\nachievement, a catalog id, and the award; the card reads the rest through the API, so no\nname or roast reaches the channel, and nothing names the user, who is the stream\'s own.');

export type AchievementUnlockedFrame = zod.input<typeof AchievementUnlockedFrame>;
export type AchievementUnlockedFrameOutput = zod.output<typeof AchievementUnlockedFrame>;

export const ActorKind = zod.enum(['system', 'user', 'staff']).describe('Who wrote an entry: the system, a user\'s request, or a staff action.');

export type ActorKind = zod.input<typeof ActorKind>;
export type ActorKindOutput = zod.output<typeof ActorKind>;

export const ActorRef = zod.object({
  "actor_id": zod.uuid(),
  "kind": zod.enum(['actor', 'global_actor'])
}).describe('An actor\'s portrait as a source (#222): one of the team\'s own actors (`actor`,\nG8-team-actors) or a global actor (`global_actor`, G8-global-actors), as live\'s Talking Head\ntakes an "Add Actors" pick. Only a field typed `ActorSource` takes one.');

export type ActorRef = zod.input<typeof ActorRef>;
export type ActorRefOutput = zod.output<typeof ActorRef>;

export const outputRefOutputIndexMin = 0;
export const outputRefOutputIndexMax = 99;



export const OutputRef = zod.object({
  "job_id": zod.uuid(),
  "kind": zod.enum(['job_output']),
  "output_index": zod.int().min(outputRefOutputIndexMin).max(outputRefOutputIndexMax)
}).describe('A source: a delivered output of an earlier job of the same team and brand.');

export type OutputRef = zod.input<typeof OutputRef>;
export type OutputRefOutput = zod.output<typeof OutputRef>;

export const AssetRef = zod.object({
  "asset_id": zod.uuid(),
  "kind": zod.enum(['asset'])
}).describe('A source: a ready file of the team\'s library, from any of its brands. Spec:\ndocs/specs/generation/S1-sources.md.');

export type AssetRef = zod.input<typeof AssetRef>;
export type AssetRefOutput = zod.output<typeof AssetRef>;

export const ActorSource = zod.union([OutputRef,AssetRef,ActorRef]);

export type ActorSource = zod.input<typeof ActorSource>;
export type ActorSourceOutput = zod.output<typeof ActorSource>;

export const exampleRefKeyMax = 200;


export const exampleRefKeyRegExp = new RegExp('^g/tpl/[a-z0-9]+(?:-[a-z0-9]+)*/(?:input-[1-9][0-9]?|file-[a-z0-9]+(?:-[a-z0-9]+)*)\\.(?:png|jpe?g|webp|mp4)$');


export const ExampleRef = zod.object({
  "key": zod.string().max(exampleRefKeyMax).regex(exampleRefKeyRegExp),
  "kind": zod.enum(['example'])
}).describe('A template card\'s example input as a source (G14, live\'s "Reuse example"): its file where\nit lies, `g/tpl/{card}/input-N.ext` (a picture, or a clip: Actor Swap\'s, Language\nChanger\'s), as live passes its own example files to a step. Only a template\'s inputs and its\nrun\'s steps take one: the template\'s start accepts its own card\'s keys alone, and every\nother start refuses one at its field.');

export type ExampleRef = zod.input<typeof ExampleRef>;
export type ExampleRefOutput = zod.output<typeof ExampleRef>;

export const ReferenceSource = zod.union([OutputRef,AssetRef,ActorRef,ExampleRef]);

export type ReferenceSource = zod.input<typeof ReferenceSource>;
export type ReferenceSourceOutput = zod.output<typeof ReferenceSource>;

export const SwapActor = zod.object({
  "actor": ReferenceSource,
  "voice_id": zod.uuid()
}).describe('One actor of an Actor Swap, one tile (live\'s actor card): the portrait the person in the\nclip becomes (an actor, a global actor or a library picture, as live\'s Add Actors offers\nthem; the card\'s example portrait in its "Reuse example") and the voice it speaks with (a\nteam or global voice; the example\'s own, hidden from every list).');

export type SwapActor = zod.input<typeof SwapActor>;
export type SwapActorOutput = zod.output<typeof SwapActor>;

export const TemplateSource = zod.union([OutputRef,AssetRef,ExampleRef]);

export type TemplateSource = zod.input<typeof TemplateSource>;
export type TemplateSourceOutput = zod.output<typeof TemplateSource>;

export const actorSwapInputsLipSyncDefault = true;

export const ActorSwapInputs = zod.object({
  "actors": zod.array(SwapActor),
  "lip_sync": zod.boolean().default(actorSwapInputsLipSyncDefault),
  "template": zod.enum(['main-character-actor-swap']),
  "video": TemplateSource
}).describe('Main Character - Actor Swap\'s form (live\'s `MainCharacterActorSwapForm`): the talking-head\nclip whose main character is replaced ("Pick the clip whose main character is replaced"),\nat most 15 seconds; its actors, 1 to 4, one tile each; and live\'s Lip sync switch, on by\ndefault: on, each actor says the clip\'s words anew and the lips are synced to the new\nspeech; off, the clip\'s own delivery is said again in the actor\'s voice (G14 decision 5).');

export type ActorSwapInputs = zod.input<typeof ActorSwapInputs>;
export type ActorSwapInputsOutput = zod.output<typeof ActorSwapInputs>;

export const AdCopyKind = zod.enum(['generated', 'custom']).describe('Live\'s `CreativeTextCopyType`: written by an LLM job, or by hand (the Write tab).');

export type AdCopyKind = zod.input<typeof AdCopyKind>;
export type AdCopyKindOutput = zod.output<typeof AdCopyKind>;

export const SourceRef = zod.union([OutputRef,AssetRef]);

export type SourceRef = zod.input<typeof SourceRef>;
export type SourceRefOutput = zod.output<typeof SourceRef>;

export const AdCopyStatus = zod.enum(['in_progress', 'completed', 'failed']).describe('A generated copy is `in_progress` from its job\'s start until its output fills it, or\n`failed` when the job ends without one (failed, expired or canceled). A copy written by\nhand, or duplicated, is `completed`.');

export type AdCopyStatus = zod.input<typeof AdCopyStatus>;
export type AdCopyStatusOutput = zod.output<typeof AdCopyStatus>;

export const BenefitBulletsModeEnum = zod.enum(['standard', 'comparison']);

export type BenefitBulletsModeEnum = zod.input<typeof BenefitBulletsModeEnum>;
export type BenefitBulletsModeEnumOutput = zod.output<typeof BenefitBulletsModeEnum>;

export const AdCopyElements = zod.object({
  "badge": zod.union([zod.array(zod.string()),zod.null()]).exactOptional(),
  "benefit_bullets": zod.union([zod.array(zod.string()),zod.null()]).exactOptional(),
  "benefit_bullets_mode": zod.union([BenefitBulletsModeEnum,zod.null()]).exactOptional(),
  "call_to_action": zod.union([zod.array(zod.string()),zod.null()]).exactOptional(),
  "discount": zod.union([zod.array(zod.string()),zod.null()]).exactOptional(),
  "feature": zod.union([zod.array(zod.string()),zod.null()]).exactOptional(),
  "headline": zod.union([zod.array(zod.string()),zod.null()]).exactOptional(),
  "subheadline": zod.union([zod.array(zod.string()),zod.null()]).exactOptional(),
  "testimonial": zod.union([zod.array(zod.string()),zod.null()]).exactOptional(),
  "trust_signal": zod.union([zod.array(zod.string()),zod.null()]).exactOptional(),
  "value_proposition": zod.union([zod.array(zod.string()),zod.null()]).exactOptional()
}).describe('An ad copy\'s texts under live\'s ten keys, each a list of values or null where the copy has\nnone, and how its benefit bullets read. As stored: an LLM\'s values are kept as written.');

export type AdCopyElements = zod.input<typeof AdCopyElements>;
export type AdCopyElementsOutput = zod.output<typeof AdCopyElements>;

export const AdCopy = zod.object({
  "audience": zod.union([zod.string(),zod.null()]),
  "brand_id": zod.uuid(),
  "copies": zod.union([zod.int(),zod.null()]),
  "created_at": zod.iso.datetime({"offset":true}),
  "created_by": zod.union([zod.uuid(),zod.null()]),
  "id": zod.uuid(),
  "job_id": zod.union([zod.uuid(),zod.null()]),
  "kind": AdCopyKind,
  "name": zod.string(),
  "product_id": zod.uuid(),
  "reference": zod.union([SourceRef,zod.null()]),
  "status": AdCopyStatus,
  "text_elements": AdCopyElements,
  "updated_at": zod.iso.datetime({"offset":true})
}).describe('One of a brand\'s ad copies. `job_id` is the `text.ad_copy` job that drafted it; the\nreference and the brief\'s audience and count are the job\'s, kept as live keeps them.');

export type AdCopy = zod.input<typeof AdCopy>;
export type AdCopyOutput = zod.output<typeof AdCopy>;

export const adCopyBriefAwarenessLevelOneMax = 100;

export const adCopyBriefCopiesDefault = 3;
export const adCopyBriefCopiesMax = 5;

export const adCopyBriefCurrencyOneMax = 10;

export const adCopyBriefCurrentPriceOneMax = 50;

export const adCopyBriefDiscountOffersOneMax = 500;

export const adCopyBriefFreeGiftOffersOneMax = 500;

export const adCopyBriefFunnelStageOneMax = 100;

export const adCopyBriefOriginalPriceOneMax = 50;

export const adCopyBriefSavingsOneMax = 50;

export const adCopyBriefTargetAudienceOneMax = 2000;

export const adCopyBriefToneOfVoiceOneMax = 100;



export const AdCopyBrief = zod.object({
  "awareness_level": zod.union([zod.string().max(adCopyBriefAwarenessLevelOneMax),zod.null()]).exactOptional(),
  "copies": zod.int().min(1).max(adCopyBriefCopiesMax).default(adCopyBriefCopiesDefault),
  "currency": zod.union([zod.string().max(adCopyBriefCurrencyOneMax),zod.null()]).exactOptional(),
  "current_price": zod.union([zod.string().max(adCopyBriefCurrentPriceOneMax),zod.null()]).exactOptional(),
  "discount_offers": zod.union([zod.string().max(adCopyBriefDiscountOffersOneMax),zod.null()]).exactOptional(),
  "free_gift_offers": zod.union([zod.string().max(adCopyBriefFreeGiftOffersOneMax),zod.null()]).exactOptional(),
  "funnel_stage": zod.union([zod.string().max(adCopyBriefFunnelStageOneMax),zod.null()]).exactOptional(),
  "original_price": zod.union([zod.string().max(adCopyBriefOriginalPriceOneMax),zod.null()]).exactOptional(),
  "product_id": zod.union([zod.uuid(),zod.null()]).exactOptional(),
  "reference": zod.union([SourceRef,zod.null()]).exactOptional(),
  "savings": zod.union([zod.string().max(adCopyBriefSavingsOneMax),zod.null()]).exactOptional(),
  "target_audience": zod.union([zod.string().max(adCopyBriefTargetAudienceOneMax),zod.null()]).exactOptional(),
  "tone_of_voice": zod.union([zod.string().max(adCopyBriefToneOfVoiceOneMax),zod.null()]).exactOptional()
}).describe('Live\'s AI Generate tab for ad copies (G8 section 2; its `StartCreativeTextCopyGenerationDto`,\nfield for field): the product, an optional reference whose analysed structure the copies\nfollow, the strategy and the offers, each as the user typed it, and how many variations of\neach ad text to write. Live\'s form sends an empty string for a field left empty. The\nproduct is the brand\'s; none only where a template\'s step gives one as data (#749).');

export type AdCopyBrief = zod.input<typeof AdCopyBrief>;
export type AdCopyBriefOutput = zod.output<typeof AdCopyBrief>;

export const AdCopyCategoryName = zod.enum(['Promotional / Special Offer', 'Discount/Percentage Off', 'BOGO (Buy One Get One)', 'Limited-Time Offer / FOMO-Last Call', 'Free Gift/GWP (Gift with Purchase)', 'Features & Benefits', 'Product-Headline-Benefits', 'Social Proof + Discount', 'Product Comparison', 'Before + After', 'Problem-Solution', 'Product in Action', 'Product Launch/New Arrival', 'Bundle/Value Pack', 'Unboxing', 'Longform Review + CTA', 'Educational/How-To', 'Scientific Stat - Mechanism', '4-Panel', 'Other']);

export type AdCopyCategoryName = zod.input<typeof AdCopyCategoryName>;
export type AdCopyCategoryNameOutput = zod.output<typeof AdCopyCategoryName>;

export const AdCopyCategory = zod.object({
  "description": zod.string().describe('Category description.'),
  "name": AdCopyCategoryName.describe('Category name.')
});

export type AdCopyCategory = zod.input<typeof AdCopyCategory>;
export type AdCopyCategoryOutput = zod.output<typeof AdCopyCategory>;

export const AdCopyNameMax = 200;


export const AdCopyNameRegExp = new RegExp('[^\\t\\n\\v\\f\\r \\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000\\ufeff]');


export const AdCopyName = zod.string().min(1).max(AdCopyNameMax).regex(AdCopyNameRegExp);

export type AdCopyName = zod.input<typeof AdCopyName>;
export type AdCopyNameOutput = zod.output<typeof AdCopyName>;

export const AdTextMax = 2000;


export const AdTextRegExp = new RegExp('[^\\t\\n\\v\\f\\r \\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000\\ufeff]');


export const AdText = zod.string().min(1).max(AdTextMax).regex(AdTextRegExp);

export type AdText = zod.input<typeof AdText>;
export type AdTextOutput = zod.output<typeof AdText>;

export const AdTextsMax = 100;



export const AdTexts = zod.array(AdText).max(AdTextsMax);

export type AdTexts = zod.input<typeof AdTexts>;
export type AdTextsOutput = zod.output<typeof AdTexts>;

export const AdCopyValues = zod.union([AdTexts,zod.null()]);

export type AdCopyValues = zod.input<typeof AdCopyValues>;
export type AdCopyValuesOutput = zod.output<typeof AdCopyValues>;

export const AdCopyElementsBody = zod.object({
  "badge": AdCopyValues.exactOptional(),
  "benefit_bullets": AdCopyValues.exactOptional(),
  "benefit_bullets_mode": zod.union([BenefitBulletsModeEnum,zod.null()]).exactOptional(),
  "call_to_action": AdCopyValues.exactOptional(),
  "discount": AdCopyValues.exactOptional(),
  "feature": AdCopyValues.exactOptional(),
  "headline": AdCopyValues.exactOptional(),
  "subheadline": AdCopyValues.exactOptional(),
  "testimonial": AdCopyValues.exactOptional(),
  "trust_signal": AdCopyValues.exactOptional(),
  "value_proposition": AdCopyValues.exactOptional()
}).describe('An ad copy\'s texts as a request writes them: no value blank, at most 2,000 characters a\nvalue and 100 values a text. A key left out is left as it is on an edit; null clears it.');

export type AdCopyElementsBody = zod.input<typeof AdCopyElementsBody>;
export type AdCopyElementsBodyOutput = zod.output<typeof AdCopyElementsBody>;

export const AdCopyCreate = zod.object({
  "name": AdCopyName,
  "product_id": zod.uuid(),
  "text_elements": AdCopyElementsBody
}).describe('`POST .../ad-copies`: live\'s Write tab, a copy written by hand for one of the brand\'s\nproducts, with at least one text.');

export type AdCopyCreate = zod.input<typeof AdCopyCreate>;
export type AdCopyCreateOutput = zod.output<typeof AdCopyCreate>;

export const AdCopyList = zod.object({
  "items": zod.array(AdCopy)
}).describe('The brand\'s ad copies, last changed first. Live\'s form never pages: a brand has few.');

export type AdCopyList = zod.input<typeof AdCopyList>;
export type AdCopyListOutput = zod.output<typeof AdCopyList>;

export const AdCopyTextElements = zod.object({
  "badge": zod.union([zod.string(),zod.null()]).exactOptional().describe('Text in a badge/sticker/ribbon ("NEW", "BEST SELLER") + urgency ("ENDS SUNDAY"). Not discounts, on-pack slogans, brand names, page numbers/dates.'),
  "badge_placement": zod.union([zod.string(),zod.null()]).exactOptional(),
  "benefit_bullets": zod.union([zod.string(),zod.null()]).exactOptional().describe('Benefits joined by " | ". Standard: "B1 | B2". Comparison: "ours; theirs | ours; theirs".'),
  "benefit_bullets_mode": zod.union([BenefitBulletsModeEnum,zod.null()]).exactOptional().describe('"standard" = simple list, "comparison" = us-vs-them pairs.'),
  "benefit_bullets_placement": zod.union([zod.string(),zod.null()]).exactOptional(),
  "call_to_action": zod.union([zod.string(),zod.null()]).exactOptional().describe('Button/link text ("Shop Now", "Buy Today").'),
  "call_to_action_placement": zod.union([zod.string(),zod.null()]).exactOptional().describe('Position for CTA'),
  "discount": zod.union([zod.string(),zod.null()]).exactOptional().describe('OFFER shown as its OWN standalone element (% off, $ off, BOGO, free gift, free shipping). If it appears ONLY inside a CTA/headline, leave null.'),
  "discount_placement": zod.union([zod.string(),zod.null()]).exactOptional().describe('Position for discount display'),
  "feature": zod.union([zod.string(),zod.null()]).exactOptional().describe('Spec/attribute callouts composited as pills/tags ("0g Sugar" pill). Exclude the same spec printed ON the package; exclude quotes and in-scene text.'),
  "feature_placement": zod.union([zod.string(),zod.null()]).exactOptional(),
  "headline": zod.union([zod.string(),zod.null()]).exactOptional().describe('PRIMARY HEADLINE: biggest designer-composited hook. A brand/flavor name IS the headline when it\'s the largest hook ("Wassup Watermelon."), NOT when it\'s only a logo/wordmark. Never on-package text.'),
  "headline_placement": zod.union([zod.string(),zod.null()]).exactOptional().describe('Position for primary headline'),
  "subheadline": zod.union([zod.string(),zod.null()]).exactOptional().describe('Support line elaborating/qualifying the headline; home for secondary taglines. Distinct from value_proposition.'),
  "subheadline_placement": zod.union([zod.string(),zod.null()]).exactOptional().describe('Position for subheadline'),
  "testimonial": zod.union([zod.string(),zod.null()]).exactOptional().describe('Customer review/quote, usually attributed. Format: "Quote" - Name. Sticky notes / speech bubbles / star-rating quotes belong here. Excludes on-package quotes.'),
  "testimonial_placement": zod.union([zod.string(),zod.null()]).exactOptional().describe('Position for social proof quote'),
  "trust_signal": zod.union([zod.string(),zod.null()]).exactOptional().describe('Credibility/verification ONLY (certifications, clinical claims, guarantees, review counts, awards). Not disclaimers, brand names, or urgency.'),
  "trust_signal_placement": zod.union([zod.string(),zod.null()]).exactOptional(),
  "value_proposition": zod.union([zod.string(),zod.null()]).exactOptional().describe('ONE unique-differentiator sentence. Narrow, often null. Route specs->feature, elaborations->subheadline, guarantees->trust_signal, lists->omit.'),
  "value_proposition_placement": zod.union([zod.string(),zod.null()]).exactOptional()
}).describe('All text content extracted from the ad with their placements.');

export type AdCopyTextElements = zod.input<typeof AdCopyTextElements>;
export type AdCopyTextElementsOutput = zod.output<typeof AdCopyTextElements>;

export const AdCopyUpdate = zod.object({
  "name": zod.union([AdCopyName,zod.null()]).exactOptional(),
  "text_elements": zod.union([AdCopyElementsBody,zod.null()]).exactOptional()
}).describe('`PATCH .../ad-copies/{id}`: a new name, and the texts sent replace theirs (live\'s edit\nsends all ten); a text left out keeps its values.');

export type AdCopyUpdate = zod.input<typeof AdCopyUpdate>;
export type AdCopyUpdateOutput = zod.output<typeof AdCopyUpdate>;

export const AdCopyVisualStyle = zod.object({
  "arrows_connectors": zod.union([zod.string(),zod.null()]).exactOptional().describe('Directional elements guiding eye flow (arrows, lines, curves). No text or labels.'),
  "arrows_connectors_placement": zod.union([zod.string(),zod.null()]).exactOptional(),
  "background_treatment": zod.union([zod.string(),zod.null()]).exactOptional().describe('Background style (solid, gradient, texture) setting mood.'),
  "background_treatment_placement": zod.union([zod.string(),zod.null()]).exactOptional(),
  "circular_badges": zod.union([zod.string(),zod.null()]).exactOptional().describe('ORIGINAL promotional badge/seal designed for this ad (e.g., \'Sale\' starburst, promo ribbon). Must NOT reproduce or mimic nutritional callouts, ingredient badges, or any data from the product packaging.'),
  "circular_badges_placement": zod.union([zod.string(),zod.null()]).exactOptional(),
  "color_blocking": zod.union([zod.string(),zod.null()]).exactOptional().describe('Original color scheme for the ad layout. Describe colors and geometric shapes. Must NOT replicate badge colors or callout shapes from the product packaging.'),
  "color_blocking_placement": zod.union([zod.string(),zod.null()]).exactOptional(),
  "decorative_elements": zod.union([zod.string(),zod.null()]).exactOptional().describe('Original illustrations, seasonal graphics, sparkles, abstract shapes. Must NOT include text, numbers, or any content extracted from the product packaging.'),
  "decorative_elements_placement": zod.union([zod.string(),zod.null()]).exactOptional(),
  "hero_product_image": zod.union([zod.string(),zod.null()]).exactOptional().describe('Physical appearance and presentation of the product (shape, packaging, colors, size). This is the ONLY field that may reference the product itself.'),
  "hero_product_image_placement": zod.union([zod.string(),zod.null()]).exactOptional(),
  "lifestyle_photography": zod.union([zod.string(),zod.null()]).exactOptional().describe('Context imagery resonating with audience lifestyle.'),
  "lifestyle_photography_placement": zod.union([zod.string(),zod.null()]).exactOptional(),
  "people": zod.union([zod.string(),zod.null()]).exactOptional().describe('Human subjects matching target audience demographics.'),
  "people_placement": zod.union([zod.string(),zod.null()]).exactOptional(),
  "problem_visualization": zod.union([zod.string(),zod.null()]).exactOptional().describe('Before/after or problem demonstration imagery.'),
  "problem_visualization_placement": zod.union([zod.string(),zod.null()]).exactOptional(),
  "product_grouping": zod.union([zod.string(),zod.null()]).exactOptional().describe('Arrangement of multiple products or loose product items (e.g., scattered candies, stacked boxes). Describe physical objects only — no text or data callouts.'),
  "product_grouping_placement": zod.union([zod.string(),zod.null()]).exactOptional(),
  "white_space": zod.union([zod.string(),zod.null()]).exactOptional().describe('Strategic use of negative space.'),
  "white_space_placement": zod.union([zod.string(),zod.null()]).exactOptional()
});

export type AdCopyVisualStyle = zod.input<typeof AdCopyVisualStyle>;
export type AdCopyVisualStyleOutput = zod.output<typeof AdCopyVisualStyle>;

export const AdCreativeStructure = zod.object({
  "ad_categories": zod.array(AdCopyCategory).describe('List of ad categories with name and description.'),
  "text_elements": AdCopyTextElements.describe('All text content extracted from the ad with their placements'),
  "visual_style": AdCopyVisualStyle.describe('All visual design elements with their placements.')
});

export type AdCreativeStructure = zod.input<typeof AdCreativeStructure>;
export type AdCreativeStructureOutput = zod.output<typeof AdCreativeStructure>;

export const adProductColorsDefault = false;
export const adProductImageIdsMax = 5;



export const AdProduct = zod.object({
  "colors": zod.boolean().default(adProductColorsDefault),
  "image_ids": zod.array(zod.uuid()).min(1).max(adProductImageIdsMax),
  "product_id": zod.uuid()
}).describe('The product the ads show: which of its images to attach (assets among the product\'s), and\nwhether its brand\'s colors steer the design.');

export type AdProduct = zod.input<typeof AdProduct>;
export type AdProductOutput = zod.output<typeof AdProduct>;

export const AdTextPlacements = zod.object({
  "badge_placement": zod.union([AdText,zod.null()]).exactOptional(),
  "benefit_bullets_placement": zod.union([AdText,zod.null()]).exactOptional(),
  "call_to_action_placement": zod.union([AdText,zod.null()]).exactOptional(),
  "discount_placement": zod.union([AdText,zod.null()]).exactOptional(),
  "feature_placement": zod.union([AdText,zod.null()]).exactOptional(),
  "headline_placement": zod.union([AdText,zod.null()]).exactOptional(),
  "subheadline_placement": zod.union([AdText,zod.null()]).exactOptional(),
  "testimonial_placement": zod.union([AdText,zod.null()]).exactOptional(),
  "trust_signal_placement": zod.union([AdText,zod.null()]).exactOptional(),
  "value_proposition_placement": zod.union([AdText,zod.null()]).exactOptional()
}).describe('Where each text goes on the image, in the user\'s words ("top center"), under live\'s\n`<key>_placement` names; left out, the inspiration\'s placement.');

export type AdTextPlacements = zod.input<typeof AdTextPlacements>;
export type AdTextPlacementsOutput = zod.output<typeof AdTextPlacements>;

export const AdTextValues = zod.object({
  "badge": AdTexts.exactOptional(),
  "benefit_bullets": AdTexts.exactOptional(),
  "call_to_action": AdTexts.exactOptional(),
  "discount": AdTexts.exactOptional(),
  "feature": AdTexts.exactOptional(),
  "headline": AdTexts.exactOptional(),
  "subheadline": AdTexts.exactOptional(),
  "testimonial": AdTexts.exactOptional(),
  "trust_signal": AdTexts.exactOptional(),
  "value_proposition": AdTexts.exactOptional()
}).describe('The values of an ad copy chosen for an Advanced job, under live\'s ten text keys (spec\nG8-ad-copy): one image per combination of one value of each key that has any.');

export type AdTextValues = zod.input<typeof AdTextValues>;
export type AdTextValuesOutput = zod.output<typeof AdTextValues>;

export const AdTextVariation = zod.object({
  "placements": AdTextPlacements.exactOptional(),
  "values": AdTextValues
}).describe('One ad copy\'s chosen values for one reference, and their placements.');

export type AdTextVariation = zod.input<typeof AdTextVariation>;
export type AdTextVariationOutput = zod.output<typeof AdTextVariation>;

export const adReferenceVariationsMax = 100;



export const AdReference = zod.object({
  "source": zod.union([TemplateSource,zod.null()]).exactOptional(),
  "structure": zod.union([AdCreativeStructure,zod.null()]).exactOptional(),
  "variations": zod.array(AdTextVariation).min(1).max(adReferenceVariationsMax)
}).describe('An inspiration image (an earlier output or a library image, analysed first), or none\nwhere the job follows the Style alone, with the ad copies chosen for it.');

export type AdReference = zod.input<typeof AdReference>;
export type AdReferenceOutput = zod.output<typeof AdReference>;

export const AdSpecification = zod.object({
  "ad_categories": zod.array(AdCopyCategory),
  "text_elements": AdCopyTextElements,
  "visual_style": AdCopyVisualStyle
}).describe('An Advanced image\'s specification, as live keeps it on each image\n(`inspirationImageStructure`, G8-ad-copy PR 3d): its texts with their placements, its\nreference\'s visual style, and the reference\'s ad categories (Other for the Style alone).');

export type AdSpecification = zod.input<typeof AdSpecification>;
export type AdSpecificationOutput = zod.output<typeof AdSpecification>;

export const AdStructureStatus = zod.enum(['in_progress', 'completed', 'failed']).describe('A reference\'s analysis: `in_progress` from its `image.analysis` job\'s start until the\njob\'s output fills it, or `failed` when the job ends without one.');

export type AdStructureStatus = zod.input<typeof AdStructureStatus>;
export type AdStructureStatusOutput = zod.output<typeof AdStructureStatus>;

export const AdStructure = zod.object({
  "job_id": zod.uuid(),
  "source": SourceRef,
  "status": AdStructureStatus,
  "structure": zod.union([AdCreativeStructure,zod.null()]),
  "updated_at": zod.iso.datetime({"offset":true})
}).describe('A reference\'s ad structure (`GET .../ad-structures`): the state of its latest analysis\nand, once completed, what it read. `job_id` is that analysis.');

export type AdStructure = zod.input<typeof AdStructure>;
export type AdStructureOutput = zod.output<typeof AdStructure>;

export const adStructureUpdateAdCategoriesOneMax = 20;



export const AdStructureUpdate = zod.object({
  "ad_categories": zod.union([zod.array(AdCopyCategory).max(adStructureUpdateAdCategoriesOneMax),zod.null()]).exactOptional(),
  "text_elements": zod.union([AdCopyTextElements,zod.null()]).exactOptional(),
  "visual_style": zod.union([AdCopyVisualStyle,zod.null()]).exactOptional()
}).describe('`PATCH .../ad-structures`: live\'s edit. The texts and the visual pairs sent replace\ntheirs (null clears one) and the rest stay; `ad_categories`, when sent, replaces the list.');

export type AdStructureUpdate = zod.input<typeof AdStructureUpdate>;
export type AdStructureUpdateOutput = zod.output<typeof AdStructureUpdate>;

export const PackshotPick = zod.object({
  "image_id": zod.uuid(),
  "kind": zod.enum(['product']),
  "product_id": zod.uuid()
}).describe('One of the brand\'s products and its packshot, one of its own pictures.');

export type PackshotPick = zod.input<typeof PackshotPick>;
export type PackshotPickOutput = zod.output<typeof PackshotPick>;

export const UploadedPackshot = zod.object({
  "asset_id": zod.uuid(),
  "kind": zod.enum(['upload'])
}).describe('A packshot uploaded to the library (live\'s product added by hand): its name and text are\nthe form\'s `product_name` and `product_text`, read off the pack where left empty.');

export type UploadedPackshot = zod.input<typeof UploadedPackshot>;
export type UploadedPackshotOutput = zod.output<typeof UploadedPackshot>;

export const PackshotProduct = zod.union([PackshotPick,UploadedPackshot,ExampleRef]);

export type PackshotProduct = zod.input<typeof PackshotProduct>;
export type PackshotProductOutput = zod.output<typeof PackshotProduct>;

export const adSwapPickedInputsActorNoteDefault = ``;
export const adSwapPickedInputsActorNoteMax = 600;

export const adSwapPickedInputsProductCategoryDefault = ``;
export const adSwapPickedInputsProductCategoryMax = 200;

export const adSwapPickedInputsProductNameDefault = ``;
export const adSwapPickedInputsProductNameMax = 200;

export const adSwapPickedInputsProductTextDefault = ``;
export const adSwapPickedInputsProductTextMax = 20000;

export const adSwapPickedInputsResolutionDefault = `720p`;
export const adSwapPickedInputsRightsDefault = false;

export const AdSwapPickedInputs = zod.object({
  "actor_note": zod.string().max(adSwapPickedInputsActorNoteMax).default(adSwapPickedInputsActorNoteDefault),
  "product": PackshotProduct,
  "product_category": zod.string().max(adSwapPickedInputsProductCategoryMax).default(adSwapPickedInputsProductCategoryDefault),
  "product_name": zod.string().max(adSwapPickedInputsProductNameMax).default(adSwapPickedInputsProductNameDefault),
  "product_text": zod.string().max(adSwapPickedInputsProductTextMax).default(adSwapPickedInputsProductTextDefault),
  "resolution": zod.enum(['480p', '720p', '1080p']).default(adSwapPickedInputsResolutionDefault),
  "rights": zod.boolean().default(adSwapPickedInputsRightsDefault),
  "source_ad": zod.union([AssetRef,zod.null()]).exactOptional()
}).describe('The form with its product picked, as Generate Script and Approve script need it (422 at\n`product` with the drafts\' pick words).');

export type AdSwapPickedInputs = zod.input<typeof AdSwapPickedInputs>;
export type AdSwapPickedInputsOutput = zod.output<typeof AdSwapPickedInputs>;

export const adSwapChangeNewMax = 200;

export const adSwapChangeSourceMax = 200;



export const AdSwapChange = zod.object({
  "new": zod.string().max(adSwapChangeNewMax),
  "reason": zod.enum(['noun', 'fact', 'name']),
  "source": zod.string().max(adSwapChangeSourceMax)
}).describe('A word or phrase of the source\'s line the new product forces to change (G14-ad-swap): a\nnoun of the product\'s form, a fact the brand does not claim, or the product\'s name.');

export type AdSwapChange = zod.input<typeof AdSwapChange>;
export type AdSwapChangeOutput = zod.output<typeof AdSwapChange>;

export const adSwapClaimClaimMax = 300;

export const adSwapClaimSourceQuoteMax = 600;



export const AdSwapClaim = zod.object({
  "claim": zod.string().max(adSwapClaimClaimMax),
  "source_quote": zod.string().max(adSwapClaimSourceQuoteMax)
}).describe('A benefit the new line claims, with the words of the product\'s page it rests on.');

export type AdSwapClaim = zod.input<typeof AdSwapClaim>;
export type AdSwapClaimOutput = zod.output<typeof AdSwapClaim>;

export const adSwapPartBeatsMax = 12;

export const adSwapPartLineMax = 600;

export const adSwapPartPackPlacesMax = 300;



export const AdSwapPart = zod.object({
  "beats": zod.array(zod.string()).max(adSwapPartBeatsMax),
  "line": zod.string().max(adSwapPartLineMax),
  "pack_places": zod.string().max(adSwapPartPackPlacesMax),
  "tone": zod.enum(['excited', 'convinced'])
}).describe('One part of Ad swap\'s script (G14-ad-swap): what the new actor says over it, the tone, one\nbeat for each of its source shots (the source\'s action rewritten for the new product, each\nafter the first opening with its cut) and where the source\'s pack shows in it.');

export type AdSwapPart = zod.input<typeof AdSwapPart>;
export type AdSwapPartOutput = zod.output<typeof AdSwapPart>;

export const adSwapScriptActorDescriptionMax = 600;

export const adSwapScriptAmbientMax = 120;

export const adSwapScriptChangesMax = 20;

export const adSwapScriptClaimsMax = 12;

export const adSwapScriptPartsMax = 6;

export const adSwapScriptProductDescriptionMax = 1200;

export const adSwapScriptProductInsideMax = 400;

export const adSwapScriptSettingMax = 300;

export const adSwapScriptSourceProductMax = 200;



export const AdSwapScript = zod.object({
  "actor_description": zod.string().max(adSwapScriptActorDescriptionMax),
  "ambient": zod.string().max(adSwapScriptAmbientMax),
  "changes": zod.array(AdSwapChange).max(adSwapScriptChangesMax),
  "claims": zod.array(AdSwapClaim).max(adSwapScriptClaimsMax),
  "parts": zod.array(AdSwapPart).max(adSwapScriptPartsMax),
  "person": zod.enum(['Woman', 'Man']),
  "product_description": zod.string().max(adSwapScriptProductDescriptionMax),
  "product_inside": zod.string().max(adSwapScriptProductInsideMax),
  "pronoun": zod.enum(['she', 'he']),
  "setting": zod.string().max(adSwapScriptSettingMax),
  "source_product": zod.string().max(adSwapScriptSourceProductMax)
}).describe('Ad swap\'s script (G14-ad-swap): the swap director\'s answer, as the member edits and\napproves it. The source\'s pack and set as seen; the new pack from its packshot, what is inside\nit and how it is used; the new actor, a person and a pronoun; the set\'s sounds; one part for\neach planned part; the changes made and the claims kept.');

export type AdSwapScript = zod.input<typeof AdSwapScript>;
export type AdSwapScriptOutput = zod.output<typeof AdSwapScript>;

export const AdSwapApproval = zod.object({
  "inputs": AdSwapPickedInputs,
  "script": AdSwapScript
}).describe('`POST .../draft/approve`: Approve script, the form and the script as edited.');

export type AdSwapApproval = zod.input<typeof AdSwapApproval>;
export type AdSwapApprovalOutput = zod.output<typeof AdSwapApproval>;

export const adSwapInputsActorNoteDefault = ``;
export const adSwapInputsActorNoteMax = 600;

export const adSwapInputsProductCategoryDefault = ``;
export const adSwapInputsProductCategoryMax = 200;

export const adSwapInputsProductNameDefault = ``;
export const adSwapInputsProductNameMax = 200;

export const adSwapInputsProductTextDefault = ``;
export const adSwapInputsProductTextMax = 20000;

export const adSwapInputsResolutionDefault = `720p`;
export const adSwapInputsRightsDefault = false;

export const AdSwapInputs = zod.object({
  "actor_note": zod.string().max(adSwapInputsActorNoteMax).default(adSwapInputsActorNoteDefault),
  "product": zod.union([PackshotProduct,zod.null()]).exactOptional(),
  "product_category": zod.string().max(adSwapInputsProductCategoryMax).default(adSwapInputsProductCategoryDefault),
  "product_name": zod.string().max(adSwapInputsProductNameMax).default(adSwapInputsProductNameDefault),
  "product_text": zod.string().max(adSwapInputsProductTextMax).default(adSwapInputsProductTextDefault),
  "resolution": zod.enum(['480p', '720p', '1080p']).default(adSwapInputsResolutionDefault),
  "rights": zod.boolean().default(adSwapInputsRightsDefault),
  "source_ad": zod.union([AssetRef,zod.null()]).exactOptional()
}).describe('Ad swap\'s form so far: the product (none until picked), and the rest.');

export type AdSwapInputs = zod.input<typeof AdSwapInputs>;
export type AdSwapInputsOutput = zod.output<typeof AdSwapInputs>;

export const DirectorState = zod.enum(['idle', 'working', 'failed']).describe('Where a director stands: `idle` (never asked, or its answer taken), `working` (its job\nrunning, or redone), or `failed` (`problem` says why).');

export type DirectorState = zod.input<typeof DirectorState>;
export type DirectorStateOutput = zod.output<typeof DirectorState>;

export const sourceAdPartEndSecondsExclusiveMin = 0;
export const sourceAdPartEndSecondsMax = 60;

export const sourceAdPartShotsMax = 12;

export const sourceAdPartStartSecondsMin = 0;
export const sourceAdPartStartSecondsMax = 60;

export const sourceAdPartWordsDefault = ``;
export const sourceAdPartWordsMax = 2000;



export const SourceAdPart = zod.object({
  "end_seconds": zod.number().gt(sourceAdPartEndSecondsExclusiveMin).max(sourceAdPartEndSecondsMax),
  "shots": zod.array(zod.int()).min(1).max(sourceAdPartShotsMax),
  "start_seconds": zod.number().min(sourceAdPartStartSecondsMin).max(sourceAdPartStartSecondsMax),
  "words": zod.string().max(sourceAdPartWordsMax).default(sourceAdPartWordsDefault)
}).describe('One part of a member\'s source ad, as a remake of it (Ad swap, Cartoon clone) makes one clip\nof each (G14-ad-swap, "F5\'s shared engine"): its cut of the source, the source\'s shots it\nshows (their indexes in the reading\'s shots, in order) and the source\'s words spoken in it.');

export type SourceAdPart = zod.input<typeof SourceAdPart>;
export type SourceAdPartOutput = zod.output<typeof SourceAdPart>;

export const videoShotEndSecondsExclusiveMin = 0;

export const videoShotStartSecondsMin = 0;



export const VideoShot = zod.object({
  "end_seconds": zod.number().gt(videoShotEndSecondsExclusiveMin),
  "start_seconds": zod.number().min(videoShotStartSecondsMin)
}).describe('One shot of a video, from one hard cut to the next (`video.shots`, G14-ad-swap).');

export type VideoShot = zod.input<typeof VideoShot>;
export type VideoShotOutput = zod.output<typeof VideoShot>;

export const AdSwapSourceRead = zod.object({
  "duration_seconds": zod.number(),
  "frames": zod.array(OutputRef),
  "parts": zod.array(SourceAdPart),
  "shots": zod.array(VideoShot)
}).describe('The reading as the draft shows it: its length, shots, frames and parts, each part with the\nwords heard in it; the timed words stay on the draft. The family\'s view (Cartoon clone\'s draft\nshows it too) keeps Ad swap\'s name, the draft routes\' contract as it shipped.');

export type AdSwapSourceRead = zod.input<typeof AdSwapSourceRead>;
export type AdSwapSourceReadOutput = zod.output<typeof AdSwapSourceRead>;

export const DraftStage = zod.enum(['script', 'cast']).describe('Live\'s stages: the script, then the cast (the shot spec and the stills) once approved.');

export type DraftStage = zod.input<typeof DraftStage>;
export type DraftStageOutput = zod.output<typeof DraftStage>;

export const StillStatus = zod.enum(['pending', 'working', 'done', 'failed']).describe('Where a cast still stands (live\'s `STILL_STATUSES`): `pending` (waiting for the still it\nis drawn from), `working`, `done` (its picture at `url`), or `failed` (`problem` says why).');

export type StillStatus = zod.input<typeof StillStatus>;
export type StillStatusOutput = zod.output<typeof StillStatus>;

export const AdSwapDraftStill = zod.object({
  "name": zod.literal("actor").meta({ title: 'Name' }),
  "output": zod.union([OutputRef,zod.null()]).exactOptional(),
  "problem": zod.union([zod.string(),zod.null()]),
  "status": StillStatus,
  "url": zod.union([zod.string(),zod.null()])
}).describe('Ad swap\'s one still, the new actor, as `DraftStill`.');

export type AdSwapDraftStill = zod.input<typeof AdSwapDraftStill>;
export type AdSwapDraftStillOutput = zod.output<typeof AdSwapDraftStill>;

export const AdSwapDraft = zod.object({
  "inputs": AdSwapInputs,
  "pack_director": DirectorState,
  "pack_warning": zod.boolean(),
  "problem": zod.union([zod.string(),zod.null()]),
  "reading": zod.union([AdSwapSourceRead,zod.null()]),
  "reading_director": DirectorState,
  "script": zod.union([AdSwapScript,zod.null()]),
  "script_director": DirectorState,
  "script_problems": zod.array(zod.string()),
  "stage": DraftStage,
  "stills": zod.array(AdSwapDraftStill),
  "updated_at": zod.iso.datetime({"offset":true}),
  "urls_expire_at": zod.union([zod.iso.datetime({"offset":true}),zod.null()])
}).describe('A member\'s Ad swap draft in the brand (G14-ad-swap): the form, the stage, the script and\nthe steps that make it (the pack reader\'s, the source ad\'s reading, the swap director\'s), the\nreading and its parts, what is still off in the script after the director\'s redo, the last\nstep that failed for good (`problem`), and the actor\'s still once the script is approved.');

export type AdSwapDraft = zod.input<typeof AdSwapDraft>;
export type AdSwapDraftOutput = zod.output<typeof AdSwapDraft>;

export const AdSwapDraftWrite = zod.object({
  "inputs": AdSwapInputs,
  "script": zod.union([AdSwapScript,zod.null()]).exactOptional()
}).describe('`PUT .../templates/ad-swap/draft`: the form as it stands, its script as edited.');

export type AdSwapDraftWrite = zod.input<typeof AdSwapDraftWrite>;
export type AdSwapDraftWriteOutput = zod.output<typeof AdSwapDraftWrite>;

export const AdSwapScriptAsk = zod.object({
  "inputs": AdSwapPickedInputs
}).describe('`POST .../draft/script`: Generate Script, on the form as it stands.');

export type AdSwapScriptAsk = zod.input<typeof AdSwapScriptAsk>;
export type AdSwapScriptAskOutput = zod.output<typeof AdSwapScriptAsk>;

export const adSwapVideoInputsPartsMax = 6;

export const adSwapVideoInputsResolutionDefault = `720p`;

export const AdSwapVideoInputs = zod.object({
  "actor": OutputRef,
  "packshot": TemplateSource,
  "parts": zod.array(SourceAdPart).min(1).max(adSwapVideoInputsPartsMax),
  "product_id": zod.union([zod.uuid(),zod.null()]).exactOptional(),
  "resolution": zod.enum(['480p', '720p', '1080p']).default(adSwapVideoInputsResolutionDefault),
  "script": AdSwapScript,
  "source_ad": AssetRef,
  "template": zod.enum(['ad-swap'])
}).describe('Ad swap\'s "Generate video" (G14-ad-swap, its run): the source ad, the product (the\nbrand\'s, for the library\'s filter; none for an upload) and its packshot, the new actor\'s\nstill, the approved script, the parts it was planned in and the clips\' resolution. One tile:\neach part cut from the source muted, remade on Seedance 2.5 with the actor and the packshot,\nthen the parts joined.');

export type AdSwapVideoInputs = zod.input<typeof AdSwapVideoInputs>;
export type AdSwapVideoInputsOutput = zod.output<typeof AdSwapVideoInputs>;




export const TextOptions = zod.object({
  "default": zod.string(),
  "values": zod.array(zod.string()).min(1)
}).describe('The values a model accepts for one option, and the one it uses when none is given.');

export type TextOptions = zod.input<typeof TextOptions>;
export type TextOptionsOutput = zod.output<typeof TextOptions>;

export const NumberRange = zod.object({
  "max": zod.number(),
  "min": zod.number()
}).describe('A closed range of numbers, as a guidance scale\'s.');

export type NumberRange = zod.input<typeof NumberRange>;
export type NumberRangeOutput = zod.output<typeof NumberRange>;

export const negativePromptCapsMaxCharsOneMax = 32000;



export const NegativePromptCaps = zod.object({
  "max_chars": zod.union([zod.int().min(1).max(negativePromptCapsMaxCharsOneMax),zod.null()]).exactOptional()
});

export type NegativePromptCaps = zod.input<typeof NegativePromptCaps>;
export type NegativePromptCapsOutput = zod.output<typeof NegativePromptCaps>;


export const advancedCapsPromptEnhancerDefault = false;
export const advancedCapsSeedDefault = false;

export const AdvancedCaps = zod.object({
  "bitrate": zod.union([TextOptions,zod.null()]).exactOptional(),
  "cfg_scale": zod.union([NumberRange,zod.null()]).exactOptional(),
  "fps": zod.union([zod.array(zod.int()).min(1),zod.null()]).exactOptional(),
  "negative_prompt": zod.union([NegativePromptCaps,zod.null()]).exactOptional(),
  "prompt_enhancer": zod.boolean().default(advancedCapsPromptEnhancerDefault),
  "seed": zod.boolean().default(advancedCapsSeedDefault)
}).describe('Live\'s advanced settings a model takes; a setting left out is not taken.');

export type AdvancedCaps = zod.input<typeof AdvancedCaps>;
export type AdvancedCapsOutput = zod.output<typeof AdvancedCaps>;

export const advancedSettingsBitrateOneMax = 40;

export const advancedSettingsFpsOneMax = 240;

export const advancedSettingsNegativePromptOneMax = 50000;

export const advancedSettingsSeedOneMin = 0;
export const advancedSettingsSeedOneMax = 4294967295;



export const AdvancedSettings = zod.object({
  "bitrate": zod.union([zod.string().min(1).max(advancedSettingsBitrateOneMax),zod.null()]).exactOptional(),
  "cfg_scale": zod.union([zod.number(),zod.null()]).exactOptional(),
  "fps": zod.union([zod.int().min(1).max(advancedSettingsFpsOneMax),zod.null()]).exactOptional(),
  "negative_prompt": zod.union([zod.string().min(1).max(advancedSettingsNegativePromptOneMax),zod.null()]).exactOptional(),
  "prompt_enhancer": zod.union([zod.boolean(),zod.null()]).exactOptional(),
  "seed": zod.union([zod.int().min(advancedSettingsSeedOneMin).max(advancedSettingsSeedOneMax),zod.null()]).exactOptional()
}).describe('Live\'s advanced settings; each is taken only where the model\'s block has it.');

export type AdvancedSettings = zod.input<typeof AdvancedSettings>;
export type AdvancedSettingsOutput = zod.output<typeof AdvancedSettings>;

export const VoiceAge = zod.enum(['kid', 'young_adult', 'adult', 'senior']).describe('Live\'s Age filter: Kid, Young Adult, Adult, Senior.');

export type VoiceAge = zod.input<typeof VoiceAge>;
export type VoiceAgeOutput = zod.output<typeof VoiceAge>;

export const AiActorClothingTag = zod.enum(['Athletic', 'Casual', 'Formal', 'Business', 'Streetwear', 'Other']).describe('Live\'s Clothing filter, in its order.');

export type AiActorClothingTag = zod.input<typeof AiActorClothingTag>;
export type AiActorClothingTagOutput = zod.output<typeof AiActorClothingTag>;

export const AiActorGender = zod.enum(['female', 'male', 'other']).describe('Live\'s actor genders: Female, Male, Other.');

export type AiActorGender = zod.input<typeof AiActorGender>;
export type AiActorGenderOutput = zod.output<typeof AiActorGender>;

export const AiActorKind = zod.enum(['global', 'team']);

export type AiActorKind = zod.input<typeof AiActorKind>;
export type AiActorKindOutput = zod.output<typeof AiActorKind>;

export const SkinTone = zod.enum(['Fair', 'Light', 'Medium', 'Tan', 'Brown', 'Dark']).describe('Live\'s Skin Tone filter: its six swatches, in its order (`global-filters.ts`).');

export type SkinTone = zod.input<typeof SkinTone>;
export type SkinToneOutput = zod.output<typeof SkinTone>;

export const AiActor = zod.object({
  "accessories": zod.union([zod.string(),zod.null()]),
  "age": zod.union([VoiceAge,zod.null()]),
  "clothing": zod.union([AiActorClothingTag,zod.null()]),
  "created_at": zod.iso.datetime({"offset":true}),
  "created_by": zod.union([zod.uuid(),zod.null()]),
  "duration_ms": zod.union([zod.int(),zod.null()]),
  "gender": AiActorGender,
  "height": zod.int(),
  "id": zod.uuid(),
  "image_url": zod.string(),
  "kind": AiActorKind,
  "name": zod.string(),
  "screen_url": zod.union([zod.string(),zod.null()]).exactOptional(),
  "situation": zod.union([zod.string(),zod.null()]),
  "skin_tone": zod.union([SkinTone,zod.null()]),
  "thumb_url": zod.union([zod.string(),zod.null()]).exactOptional(),
  "video_url": zod.union([zod.string(),zod.null()]),
  "voice_id": zod.union([zod.uuid(),zod.null()]),
  "voice_name": zod.union([zod.string(),zod.null()]),
  "width": zod.int()
}).describe('An actor of the AI Actors page: a global one (spec G8-global-actors) with its portrait\n(`image_url`), preview video (`video_url`), tags (live\'s words; a few no filter offers) and\nvoice, or a team\'s own (G8-team-actors): a portrait, a gender and its maker. URLs are signed\nlike a job\'s outputs, until the page\'s or the list\'s `urls_expire_at`.');

export type AiActor = zod.input<typeof AiActor>;
export type AiActorOutput = zod.output<typeof AiActor>;

export const AiActorAccessory = zod.enum(['Bags', 'Bathrobe', 'Book', 'Dishes', 'Drink', 'Dumbbells', 'Fan', 'Fridge', 'Food', 'Glasses', 'Hijab', 'Hat', 'Headphones', 'Jewelry', 'Knit', 'Laptop', 'Mic', 'Mirror', 'Mug', 'Pet', 'Phone', 'Plant', 'Piano', 'Scarf', 'Shoes', 'Suit', 'Tools', 'Tree']).describe('Live\'s Accessories filter, its 28 words in its order.');

export type AiActorAccessory = zod.input<typeof AiActorAccessory>;
export type AiActorAccessoryOutput = zod.output<typeof AiActorAccessory>;

export const AiActorAge = zod.enum(['child', 'teen', 'young_adult', 'middle_aged', 'senior', 'elderly']).describe('The Builder\'s Age slider, in its order.');

export type AiActorAge = zod.input<typeof AiActorAge>;
export type AiActorAgeOutput = zod.output<typeof AiActorAge>;

export const AiActorBody = zod.enum(['petite', 'slim', 'average', 'athletic', 'curvy', 'plus_size', 'muscular', 'tall']).describe('The Builder\'s Body Type tiles, in their order.');

export type AiActorBody = zod.input<typeof AiActorBody>;
export type AiActorBodyOutput = zod.output<typeof AiActorBody>;

export const AiActorEthnicity = zod.enum(['african_american', 'asian_american', 'caucasian_american', 'east_asian', 'european_caucasian', 'indigenous_american', 'middle_eastern_north_african', 'mixed_multiracial', 'south_asian', 'southeast_asian', 'sub_saharan_african', 'other']).describe('The Builder\'s Ethnicity list, in its order; Other takes the user\'s words.');

export type AiActorEthnicity = zod.input<typeof AiActorEthnicity>;
export type AiActorEthnicityOutput = zod.output<typeof AiActorEthnicity>;

export const BuilderWordsMax = 100;



export const BuilderWords = zod.string().max(BuilderWordsMax);

export type BuilderWords = zod.input<typeof BuilderWords>;
export type BuilderWordsOutput = zod.output<typeof BuilderWords>;

export const AiActorEyes = zod.enum(['brown', 'blue', 'green', 'hazel', 'gray', 'custom']).describe('The Builder\'s Eyes dots, in their order; Custom takes a colour.');

export type AiActorEyes = zod.input<typeof AiActorEyes>;
export type AiActorEyesOutput = zod.output<typeof AiActorEyes>;

export const HexColorRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');


export const HexColor = zod.string().regex(HexColorRegExp);

export type HexColor = zod.input<typeof HexColor>;
export type HexColorOutput = zod.output<typeof HexColor>;

export const AiActorFace = zod.enum(['oval', 'round', 'square', 'heart']).describe('The Builder\'s Face tiles, in their order. Live labels the third "Heart" and the fourth\n"Square" while sending `square` and `heart`: the values are what reaches the model.');

export type AiActorFace = zod.input<typeof AiActorFace>;
export type AiActorFaceOutput = zod.output<typeof AiActorFace>;

export const AiActorHairColor = zod.enum(['black', 'brown', 'blonde', 'red', 'custom']).describe('The Builder\'s hair colour dots, in their order; Custom takes a colour.');

export type AiActorHairColor = zod.input<typeof AiActorHairColor>;
export type AiActorHairColorOutput = zod.output<typeof AiActorHairColor>;

export const AiActorHairLength = zod.enum(['short', 'long']);

export type AiActorHairLength = zod.input<typeof AiActorHairLength>;
export type AiActorHairLengthOutput = zod.output<typeof AiActorHairLength>;

export const AiActorHair = zod.object({
  "color": zod.union([AiActorHairColor,zod.null()]).exactOptional(),
  "color_custom": zod.union([HexColor,zod.null()]).exactOptional(),
  "length": zod.union([AiActorHairLength,zod.null()]).exactOptional()
});

export type AiActorHair = zod.input<typeof AiActorHair>;
export type AiActorHairOutput = zod.output<typeof AiActorHair>;

export const AiActorAppearance = zod.object({
  "age": zod.union([AiActorAge,zod.null()]).exactOptional(),
  "body": zod.union([AiActorBody,zod.null()]).exactOptional(),
  "ethnicity": zod.union([AiActorEthnicity,zod.null()]).exactOptional(),
  "ethnicity_other": zod.union([BuilderWords,zod.null()]).exactOptional(),
  "eyes": zod.union([AiActorEyes,zod.null()]).exactOptional(),
  "eyes_custom": zod.union([HexColor,zod.null()]).exactOptional(),
  "face": zod.union([AiActorFace,zod.null()]).exactOptional(),
  "hair": AiActorHair.exactOptional()
});

export type AiActorAppearance = zod.input<typeof AiActorAppearance>;
export type AiActorAppearanceOutput = zod.output<typeof AiActorAppearance>;

export const AiActorBackground = zod.enum(['studio_white_backdrop', 'office_workspace', 'home_kitchen', 'home_living_room', 'outdoor_park', 'city_street', 'beach', 'cafe_restaurant', 'gym_fitness', 'shopping_mall', 'car_interior', 'rooftop_urban', 'forest_nature', 'warehouse_industrial', 'hotel_lobby', 'airplane_interior', 'hospital_medical', 'school_classroom', 'luxury_bedroom', 'corporate_boardroom']).describe('The Builder\'s Background tiles, in their order.');

export type AiActorBackground = zod.input<typeof AiActorBackground>;
export type AiActorBackgroundOutput = zod.output<typeof AiActorBackground>;

export const AiActorClothingStyle = zod.enum(['casual', 'formal', 'business', 'athletic', 'streetwear', 'other']).describe('The Builder\'s Clothing tiles, in their order. Other has no words on live, so it sends\nnone.');

export type AiActorClothingStyle = zod.input<typeof AiActorClothingStyle>;
export type AiActorClothingStyleOutput = zod.output<typeof AiActorClothingStyle>;

export const AiActorClothing = zod.object({
  "style": zod.union([AiActorClothingStyle,zod.null()]).exactOptional()
});

export type AiActorClothing = zod.input<typeof AiActorClothing>;
export type AiActorClothingOutput = zod.output<typeof AiActorClothing>;

export const AiActorFraming = zod.enum(['headshot', 'half_body', 'full_body']);

export type AiActorFraming = zod.input<typeof AiActorFraming>;
export type AiActorFramingOutput = zod.output<typeof AiActorFraming>;

export const AiActorLighting = zod.enum(['natural', 'studio', 'soft', 'hard', 'dramatic', 'backlighting', 'golden_hour', 'low_light', 'other']).describe('The Builder\'s Lighting list, in its order; Other takes the user\'s words.');

export type AiActorLighting = zod.input<typeof AiActorLighting>;
export type AiActorLightingOutput = zod.output<typeof AiActorLighting>;

export const AiActorShotAngle = zod.enum(['front', 'side', 'back']);

export type AiActorShotAngle = zod.input<typeof AiActorShotAngle>;
export type AiActorShotAngleOutput = zod.output<typeof AiActorShotAngle>;

export const aiActorSetupBackgroundDescriptionOneMax = 2000;



export const AiActorSetup = zod.object({
  "background": zod.union([AiActorBackground,zod.null()]).exactOptional(),
  "background_description": zod.union([zod.string().max(aiActorSetupBackgroundDescriptionOneMax),zod.null()]).exactOptional(),
  "framing": zod.union([AiActorFraming,zod.null()]).exactOptional(),
  "is_seated": zod.union([zod.boolean(),zod.null()]).exactOptional(),
  "lighting": zod.union([AiActorLighting,zod.null()]).exactOptional(),
  "lighting_other": zod.union([BuilderWords,zod.null()]).exactOptional(),
  "shot_angle": zod.union([AiActorShotAngle,zod.null()]).exactOptional()
});

export type AiActorSetup = zod.input<typeof AiActorSetup>;
export type AiActorSetupOutput = zod.output<typeof AiActorSetup>;

export const AiActorBuilder = zod.object({
  "appearance": AiActorAppearance.exactOptional(),
  "clothing": AiActorClothing.exactOptional(),
  "setup": AiActorSetup.exactOptional()
}).describe('Live\'s AI Actor Builder: every choice optional (an untouched Builder may be sent).');

export type AiActorBuilder = zod.input<typeof AiActorBuilder>;
export type AiActorBuilderOutput = zod.output<typeof AiActorBuilder>;

export const AiActorMime = zod.enum(['image/png', 'image/jpeg', 'image/webp']).describe('A portrait\'s type, as live\'s Upload Actor takes them.');

export type AiActorMime = zod.input<typeof AiActorMime>;
export type AiActorMimeOutput = zod.output<typeof AiActorMime>;

export const AiActorCompleteRequest = zod.object({
  "mime": AiActorMime
}).describe('The uploaded portrait becomes the team\'s actor once it is read, with gender other and a\nrandom name, as live\'s.');

export type AiActorCompleteRequest = zod.input<typeof AiActorCompleteRequest>;
export type AiActorCompleteRequestOutput = zod.output<typeof AiActorCompleteRequest>;

export const OutputIndexMin = 0;
export const OutputIndexExclusiveMax = 4;



export const OutputIndex = zod.int().min(OutputIndexMin).lt(OutputIndexExclusiveMax);

export type OutputIndex = zod.input<typeof OutputIndex>;
export type OutputIndexOutput = zod.output<typeof OutputIndex>;

export const aiActorFromGenerationRequestOutputIndexesMax = 4;



export const AiActorFromGenerationRequest = zod.object({
  "job_id": zod.uuid(),
  "output_indexes": zod.array(OutputIndex).min(1).max(aiActorFromGenerationRequestOutputIndexesMax)
}).describe('`POST .../actors/from-generation`: portraits of one of the caller\'s actor generations,\neach kept as an actor once (live\'s Save on one image, or on all of them).');

export type AiActorFromGenerationRequest = zod.input<typeof AiActorFromGenerationRequest>;
export type AiActorFromGenerationRequestOutput = zod.output<typeof AiActorFromGenerationRequest>;

export const AiActorFromLibraryRequest = zod.object({
  "asset_id": zod.uuid()
}).describe('`POST .../actors/from-library`: one of the library\'s images moved into a team actor\n(live\'s Add From Library, one image per call): the actor takes its name, and the image goes\nto the library\'s trash.');

export type AiActorFromLibraryRequest = zod.input<typeof AiActorFromLibraryRequest>;
export type AiActorFromLibraryRequestOutput = zod.output<typeof AiActorFromLibraryRequest>;

export const AiActorList = zod.object({
  "items": zod.array(AiActor),
  "urls_expire_at": zod.union([zod.iso.datetime({"offset":true}),zod.null()])
}).describe('The actors a save made or found, in the order asked.');

export type AiActorList = zod.input<typeof AiActorList>;
export type AiActorListOutput = zod.output<typeof AiActorList>;

export const AiActorPage = zod.object({
  "items": zod.array(AiActor),
  "next": zod.union([zod.string(),zod.null()]),
  "urls_expire_at": zod.union([zod.iso.datetime({"offset":true}),zod.null()])
}).describe('A page of actors, newest first (live\'s Global Actors: Genevieve first).');

export type AiActorPage = zod.input<typeof AiActorPage>;
export type AiActorPageOutput = zod.output<typeof AiActorPage>;

export const AiActorParams = zod.object({
  "gender": AiActorGender,
  "mode": zod.enum(['prompt', 'builder'])
}).describe('An actor generation\'s gender and how it was asked for: live\'s My Generations badge,\n"Prompt" or "Builder".');

export type AiActorParams = zod.input<typeof AiActorParams>;
export type AiActorParamsOutput = zod.output<typeof AiActorParams>;

export const AiActorSituation = zod.enum(['Airport', 'ASMR', 'Bathroom', 'Balcony', 'Beach', 'Car', 'Coffee Shop', 'Cooking', 'Christmas', 'Family', 'Firefighter', 'GRWM', 'Gaming', 'Green Screen', 'Gym', 'Hannukah', 'Home', 'Interview', 'Kitchen', 'Mall', 'Medical', 'Nature', 'Office', 'Outside', 'Podcast', 'Pool', 'Pregnant', 'Sitting', 'Snow', 'Studio', 'Street', 'Talk', 'Walking', 'Yoga']).describe('Live\'s Situation filter, its 34 words in its order.');

export type AiActorSituation = zod.input<typeof AiActorSituation>;
export type AiActorSituationOutput = zod.output<typeof AiActorSituation>;

export const aiActorUploadRequestBytesMax = 20971520;



export const AiActorUploadRequest = zod.object({
  "bytes": zod.int().min(1).max(aiActorUploadRequestBytesMax),
  "mime": AiActorMime
}).describe('`POST .../actors/uploads`: the portrait the browser is about to send.');

export type AiActorUploadRequest = zod.input<typeof AiActorUploadRequest>;
export type AiActorUploadRequestOutput = zod.output<typeof AiActorUploadRequest>;

export const UploadForm = zod.object({
  "expires_at": zod.iso.datetime({"offset":true}),
  "fields": zod.record(zod.string(), zod.string()),
  "url": zod.string()
}).describe('Post every field, then the file as the last field `file`, to `url`, with no\ncredentials. The bucket refuses another size, type or key (proposal 6.6).');

export type UploadForm = zod.input<typeof UploadForm>;
export type UploadFormOutput = zod.output<typeof UploadForm>;

export const AiActorUploadTicket = zod.object({
  "actor_id": zod.uuid(),
  "form": UploadForm
}).describe('Post the form, then `POST .../actors/{actor_id}/complete` with the same type.');

export type AiActorUploadTicket = zod.input<typeof AiActorUploadTicket>;
export type AiActorUploadTicketOutput = zod.output<typeof AiActorUploadTicket>;

export const GenerationType = zod.enum(['audio.extract', 'audio.music', 'audio.sfx', 'audio.tts', 'audio.voiceover', 'caption.transcribe', 'extract.brand', 'extract.product', 'image.actor', 'image.advanced', 'image.analysis', 'image.layer_edit', 'image.layerize', 'image.simple', 'image.template', 'image.tweak', 'text.actor_description', 'text.ad_copy', 'text.enhance', 'text.generate', 'text.script', 'text.shot_list', 'video.audio', 'video.background', 'video.caption', 'video.dub', 'video.edit', 'video.extend', 'video.frames', 'video.image', 'video.lipsync', 'video.merge', 'video.motion', 'video.overlay', 'video.pixel_snap', 'video.reference', 'video.reframe', 'video.shots', 'video.splice', 'video.talking_head', 'video.talking_head_advanced', 'video.template', 'video.text', 'video.upscale', 'video.voice_swap', 'voice.clone', 'voice.design', 'voice.profile']).describe('The M1 job types (D3). Each has one file in `generation/types/`.');

export type GenerationType = zod.input<typeof GenerationType>;
export type GenerationTypeOutput = zod.output<typeof GenerationType>;

export type PriceLine = {
  block_size?: string | null;
  credits_per_unit: string;
  free_hourly_cap?: number | null;
  input?: PriceLine | null;
  unit: string;
};

export const PriceLine: zod.ZodType<PriceLine> = zod.object({
  "block_size": zod.union([zod.string(),zod.null()]).exactOptional(),
  "credits_per_unit": zod.string(),
  "free_hourly_cap": zod.union([zod.int(),zod.null()]).exactOptional(),
  "input": zod.union([zod.lazy(() => PriceLine),zod.null()]).exactOptional(),
  "unit": zod.string()
}).describe('A SKU\'s active price, as staff see it beside a model (spec G9-ai-tasks, section 5):\n`credits_per_unit` credits a `unit` (the price file\'s word: image, second, token, request,\n...), a started block of `block_size` units where it has one, and free up to\n`free_hourly_cap` calls an hour where it is 0. `input` is the second line a model metered per\ntoken is billed with, its tokens read; billing leaves it empty, the caller fills it.');

export type PriceLineOutput = zod.output<typeof PriceLine>;

export const VendorName = zod.enum(['gemini_image', 'gemini_studio_image', 'elevenlabs', 'elevenlabs_dubbing', 'openai_image', 'fal_image', 'fal_video', 'veo_video', 'runway_video', 'omni_video', 'gemini_studio_text', 'gemini_studio_music', 'anthropic_text', 'page_extract', 'media']).describe('One adapter per vendor (proposal 6.4); `CREATEDAI_VENDORS__<NAME>` picks fake or real.');

export type VendorName = zod.input<typeof VendorName>;
export type VendorNameOutput = zod.output<typeof VendorName>;

export const AiTaskModelView = zod.object({
  "maker": zod.string(),
  "model": zod.string(),
  "name": zod.string(),
  "price": zod.union([PriceLine,zod.null()]),
  "reason": zod.union([zod.string(),zod.null()]),
  "selectable": zod.boolean(),
  "vendor": VendorName,
  "vendor_model": zod.string()
}).describe('A row a task may run on, with its price (the row\'s SKU at the active price version) and\nwhether staff may switch to it here; `reason` says why not, or, for an internal-only row\noutside prod, that only internal teams run it (section 6).');

export type AiTaskModelView = zod.input<typeof AiTaskModelView>;
export type AiTaskModelViewOutput = zod.output<typeof AiTaskModelView>;

export const AiTaskSetBy = zod.object({
  "email": zod.union([zod.string(),zod.null()]),
  "user_id": zod.uuid()
}).describe('The staff user behind a switch; `email` is None once the user is deleted.');

export type AiTaskSetBy = zod.input<typeof AiTaskSetBy>;
export type AiTaskSetByOutput = zod.output<typeof AiTaskSetBy>;

export const AiTaskOverride = zod.object({
  "model": zod.string(),
  "reason": zod.string(),
  "set_at": zod.iso.datetime({"offset":true}),
  "set_by": AiTaskSetBy
}).describe('A task\'s newest switch, stale or not: the row staff chose, why, who and when.');

export type AiTaskOverride = zod.input<typeof AiTaskOverride>;
export type AiTaskOverrideOutput = zod.output<typeof AiTaskOverride>;

export const Picks = zod.enum(['type', 'step', 'catalog', 'call', 'port']).describe('Who names the row an AI task runs on (spec G9-ai-tasks, section 2).');

export type Picks = zod.input<typeof Picks>;
export type PicksOutput = zod.output<typeof Picks>;

export const AiTaskView = zod.object({
  "caller": zod.union([zod.string(),zod.null()]),
  "current_model": zod.string(),
  "description": zod.string(),
  "id": zod.string(),
  "job_type": zod.union([GenerationType,zod.null()]),
  "live_model": zod.string(),
  "models": zod.array(AiTaskModelView),
  "name": zod.string(),
  "override": zod.union([AiTaskOverride,zod.null()]),
  "picks": Picks,
  "prompts": zod.array(zod.string()),
  "stale": zod.boolean()
}).describe('One AI task as staff see it: what it is, live\'s model, the model it runs on now and the\nswitch behind it, and every row it may run on, in the file\'s order.');

export type AiTaskView = zod.input<typeof AiTaskView>;
export type AiTaskViewOutput = zod.output<typeof AiTaskView>;

export const AiTaskList = zod.object({
  "items": zod.array(AiTaskView)
}).describe('`GET /v1/staff/ai-tasks`: every task, in the files\' order.');

export type AiTaskList = zod.input<typeof AiTaskList>;
export type AiTaskListOutput = zod.output<typeof AiTaskList>;

export const aiTaskModelSetModelMax = 64;


export const aiTaskModelSetModelRegExp = new RegExp('^[a-z0-9][a-z0-9.-]*$');
export const aiTaskModelSetReasonMax = 500;


export const aiTaskModelSetReasonRegExp = new RegExp('[^\\t\\n\\v\\f\\r \\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000\\ufeff]');


export const AiTaskModelSet = zod.object({
  "model": zod.string().max(aiTaskModelSetModelMax).regex(aiTaskModelSetModelRegExp).describe('A catalog model id.'),
  "reason": zod.string().min(1).max(aiTaskModelSetReasonMax).regex(aiTaskModelSetReasonRegExp)
}).describe('`PUT /v1/staff/ai-tasks/{task_id}/model`: one of the task\'s rows, and why (decision 12).');

export type AiTaskModelSet = zod.input<typeof AiTaskModelSet>;
export type AiTaskModelSetOutput = zod.output<typeof AiTaskModelSet>;

export const animateStaticAdInputsDurationOneMax = 600;

export const animateStaticAdInputsPromptDefault = ``;
export const animateStaticAdInputsPromptMax = 32000;



export const AnimateStaticAdInputs = zod.object({
  "duration": zod.union([zod.int().min(1).max(animateStaticAdInputsDurationOneMax),zod.null()]).exactOptional(),
  "image": TemplateSource,
  "prompt": zod.string().max(animateStaticAdInputsPromptMax).default(animateStaticAdInputsPromptDefault),
  "template": zod.enum(['animate-static-ad'])
}).describe('Animate Static Ad\'s form (live\'s `AnimateStaticAdForm`): the static ad to animate ("Pick\nthe static ad to animate"), the animation direction, optional (left empty, the motion step\nis asked live\'s "Animate this static ad following the directives."), and the clip\'s length\nin seconds, one of the animation model\'s (its default where none is sent). One tile.');

export type AnimateStaticAdInputs = zod.input<typeof AnimateStaticAdInputs>;
export type AnimateStaticAdInputsOutput = zod.output<typeof AnimateStaticAdInputs>;

export const AnimationAxis = zod.enum(['vertical', 'horizontal', 'both']).describe('Center Expand\'s bands: live\'s "Vertical (top + bottom)", "Horizontal (left + right)",\n"Both".');

export type AnimationAxis = zod.input<typeof AnimationAxis>;
export type AnimationAxisOutput = zod.output<typeof AnimationAxis>;

export const AnimationDirection = zod.enum(['left', 'right', 'top', 'bottom']).describe('Where a Slide comes from (or goes to), or the edge a Wipe starts at.');

export type AnimationDirection = zod.input<typeof AnimationDirection>;
export type AnimationDirectionOutput = zod.output<typeof AnimationDirection>;

export const AnimationEasing = zod.enum(['linear', 'slow', 'ease-in-quad', 'ease-out-quad', 'ease-in-out-quad', 'ease-in-cubic', 'ease-out-cubic', 'ease-in-out-cubic', 'ease-in-back', 'ease-out-back']).describe('Live\'s Easing list, in its order.');

export type AnimationEasing = zod.input<typeof AnimationEasing>;
export type AnimationEasingOutput = zod.output<typeof AnimationEasing>;

export const AnimationMode = zod.enum(['in', 'out']).describe('An In plays from the clip\'s start (after its delay); an Out ends at the clip\'s end.');

export type AnimationMode = zod.input<typeof AnimationMode>;
export type AnimationModeOutput = zod.output<typeof AnimationMode>;

export const AnimationOrigin = zod.enum(['center', 'top-left', 'top-right', 'bottom-left', 'bottom-right']).describe('Where Circle Reveal, Rect Expand and Edge Crop grow from or hold.');

export type AnimationOrigin = zod.input<typeof AnimationOrigin>;
export type AnimationOriginOutput = zod.output<typeof AnimationOrigin>;

export const AnimationPreset = zod.enum(['fade', 'zoom', 'slide', 'blur', 'wipe', 'circle-reveal', 'rect-expand', 'angle-wipe', 'center-expand', 'edge-crop', 'pulse', 'appear-by-word', 'fade-by-word', 'pop-caption', 'bounce-caption', 'scale-caption', 'slide-caption', 'slide-by-word', 'slide-mask-word', 'block-reveal', 'char-fade', 'char-slide-up', 'char-typewriter', 'char-fade-in', 'char-scramble', 'pop-by-word', 'scale-fade-by-word', 'bounce-by-word', 'rotate-by-word', 'fade-rotate-by-word', 'skew-by-word', 'wave-by-word', 'blur-by-word', 'drop-soft-by-word', 'elastic-pop-by-word', 'flip-up-by-word', 'spin-by-word', 'stretch-by-word', 'reveal-zoom-by-word', 'float-wave-by-word', 'combo-zoom-1', 'combo-zoom-2', 'combo-pendulum-1', 'combo-pendulum-2', 'combo-right-distort', 'combo-left-distort', 'combo-wobble', 'combo-spinning-top-1', 'combo-spinning-top-2', 'combo-sway-out', 'combo-bounce-1', 'combo-sway-in', 'custom']).describe('Live\'s animation presets (#266), by the slugs of live\'s preset ids, in its popover\'s order:\nits In/Out presets for every clip, its text presets for a text, then its combos for a video or\na still. Each part of #266 adds its own.');

export type AnimationPreset = zod.input<typeof AnimationPreset>;
export type AnimationPresetOutput = zod.output<typeof AnimationPreset>;

export const Prize = zod.enum(['common', 'rare', 'epic', 'legendary', 'mythic', 'jackpot']).describe('What a daily case gives: a theme of one of the five rarities past `free`, or the jackpot,\ncredits for the team (spec PR 3).');

export type Prize = zod.input<typeof Prize>;
export type PrizeOutput = zod.output<typeof Prize>;

export const PrizeOdds = zod.object({
  "basis_points": zod.int(),
  "credits": zod.union([zod.int(),zod.null()]),
  "prize": Prize
}).describe('One prize\'s share of the reader\'s next draw, in basis points of 10,000. `credits` is set\nexactly on the jackpot, what it pays (the catalogue\'s), so the odds and the reel say it\nwithout a number in the web; null on every theme\'s tier.');

export type PrizeOdds = zod.input<typeof PrizeOdds>;
export type PrizeOddsOutput = zod.output<typeof PrizeOdds>;

export const ThemeId = zod.enum(['created', 'high-contrast', 'tokyo-night', 'catppuccin', 'rose-pine', 'dracula', 'solarized', 'night-owl', 'ayu', 'cyberdream', 'horizon', 'flexoki', 'one', 'everforest', 'gruvbox']).describe('Every theme family, each with a light and a dark variant: today\'s look and the 14.');

export type ThemeId = zod.input<typeof ThemeId>;
export type ThemeIdOutput = zod.output<typeof ThemeId>;

export const CaseResult = zod.object({
  "credits": zod.union([zod.int(),zod.null()]),
  "day": zod.iso.date(),
  "id": zod.uuid(),
  "opened_at": zod.iso.datetime({"offset":true}),
  "prize": Prize,
  "team_id": zod.uuid(),
  "theme": zod.union([ThemeId,zod.null()])
}).describe('A daily case once opened: the same answer for every open that day, in any team.\n`theme` is null exactly for the jackpot, `credits` set exactly for it; `team_id` is the team\nit was opened in, the jackpot\'s payee.');

export type CaseResult = zod.input<typeof CaseResult>;
export type CaseResultOutput = zod.output<typeof CaseResult>;

export const CaseStatus = zod.enum(['waiting', 'opened', 'hidden', 'none']).describe('Today\'s case for the reader: `waiting` to be opened, `opened` today, `hidden` by the\nperson or the team, or `none` because every theme is already theirs.');

export type CaseStatus = zod.input<typeof CaseStatus>;
export type CaseStatusOutput = zod.output<typeof CaseStatus>;

export const DailyCase = zod.object({
  "day": zod.iso.date(),
  "next_at": zod.iso.datetime({"offset":true}),
  "odds": zod.array(PrizeOdds),
  "result": zod.union([CaseResult,zod.null()]),
  "status": CaseStatus
}).describe('Today\'s case for the reader. `day` is the UTC date and `next_at` the next UTC midnight.\n`odds` are the shares the reader\'s next draw uses, every theme they own left out, so what is\nshown is what is drawn: empty when nothing is left to win. `result` is today\'s case once\nopened, whatever the status says, but a token\'s reader sees it only for a case opened in the\ntoken\'s own team (null otherwise).');

export type DailyCase = zod.input<typeof DailyCase>;
export type DailyCaseOutput = zod.output<typeof DailyCase>;

export const Rarity = zod.enum(['free', 'common', 'rare', 'epic', 'legendary', 'mythic']).describe('A theme\'s tier (`backend/data/appearance/themes.yaml`). A `free` theme is everyone\'s; the\nothers are won in the free daily case.');

export type Rarity = zod.input<typeof Rarity>;
export type RarityOutput = zod.output<typeof Rarity>;

export const ThemeView = zod.object({
  "id": ThemeId,
  "owned": zod.boolean(),
  "rarity": Rarity
}).describe('One theme of the catalogue for the reader: its tier, and whether it is theirs.');

export type ThemeView = zod.input<typeof ThemeView>;
export type ThemeViewOutput = zod.output<typeof ThemeView>;

export const AppearanceView = zod.object({
  "case": DailyCase,
  "cases_hidden": zod.boolean(),
  "team_cases_hidden": zod.boolean(),
  "theme": ThemeId,
  "themes": zod.array(ThemeView)
}).describe('`GET /v1/teams/{team_id}/appearance`, the one read a page load needs: the person\'s saved\ntheme and own switch, the team\'s switch, every theme in `ThemeId` order, and today\'s case.');

export type AppearanceView = zod.input<typeof AppearanceView>;
export type AppearanceViewOutput = zod.output<typeof AppearanceView>;

export const IndexStatus = zod.enum(['pending', 'ready', 'failed', 'skipped']).describe('Where an asset stands in the search index (spec S3): `pending` until the embedder\nanswers, `ready`, `failed`, or `skipped` for a kind that is not indexed (audio).');

export type IndexStatus = zod.input<typeof IndexStatus>;
export type IndexStatusOutput = zod.output<typeof IndexStatus>;

export const AssetKind = zod.enum(['image', 'video', 'audio']);

export type AssetKind = zod.input<typeof AssetKind>;
export type AssetKindOutput = zod.output<typeof AssetKind>;

export const MediaMime = zod.enum(['image/jpeg', 'image/png', 'image/webp', 'video/mp4', 'video/quicktime', 'video/webm', 'audio/mpeg', 'audio/wav']).describe('Every type the library stores (D9). GIF, HEIC and SVG are not here, so they fail\nvalidation, and the generated client knows the list.');

export type MediaMime = zod.input<typeof MediaMime>;
export type MediaMimeOutput = zod.output<typeof MediaMime>;

export const AssetJobOrigin = zod.object({
  "job_id": zod.uuid(),
  "job_type": zod.union([zod.string(),zod.null()]),
  "output_index": zod.int()
}).describe('A saved file\'s origin as the library shows it, with its job\'s type while the team can read\nthe job (`image.simple`; `editor.render` for an editor\'s render, which is no generation job),\nNone once the job was deleted (live\'s "Delete generation" keeps the saved copies). A client\nreads the job (its prompt, Clone, "How it was made") only when this is a generation type.');

export type AssetJobOrigin = zod.input<typeof AssetJobOrigin>;
export type AssetJobOriginOutput = zod.output<typeof AssetJobOrigin>;

export const ProxyStatus = zod.enum(['ready', 'pending', 'none']).describe('Where a video\'s 540p copy stands (spec assets/proxy-copies): `ready` with `urls.proxy`,\n`pending` while it waits to be made (its original plays meanwhile), `none` where none will\ncome (light already, past the copies\' caps, or unreadable: its original plays).');

export type ProxyStatus = zod.input<typeof ProxyStatus>;
export type ProxyStatusOutput = zod.output<typeof ProxyStatus>;

export const AssetSource = zod.enum(['upload', 'generation', 'url_import', 'product_image', 'brand_logo']);

export type AssetSource = zod.input<typeof AssetSource>;
export type AssetSourceOutput = zod.output<typeof AssetSource>;

export const AssetStatus = zod.enum(['pending', 'ready', 'failed']).describe('`pending` until the bytes are in place, then `ready`; `failed` rows are purged.');

export type AssetStatus = zod.input<typeof AssetStatus>;
export type AssetStatusOutput = zod.output<typeof AssetStatus>;

export const AssetUrls = zod.object({
  "original": zod.union([zod.string(),zod.null()]),
  "poster": zod.union([zod.string(),zod.null()]),
  "preview": zod.union([zod.string(),zod.null()]).exactOptional(),
  "proxy": zod.union([zod.string(),zod.null()]).exactOptional(),
  "thumb": zod.union([zod.string(),zod.null()])
}).describe('Cloud CDN signed URLs, valid about an hour (D9), or each file\'s own URL for a browser\nthat holds the team\'s media cookie and says so (`Prefer: media=cookie`, spec\nassets/media-cookies). Null until the file exists: `original`\nwhen the asset is ready and not in the trash, `thumb` and `poster` once derivatives do, and\nan image\'s `preview` (at most 2,560 px on its longest side, AVIF, for the full-size view,\n#794) once it does; until then the view shows `original`. A video\'s `proxy`, its 540p copy\nfor the editor\'s preview (spec assets/proxy-copies), once it is made (`proxy_status`).');

export type AssetUrls = zod.input<typeof AssetUrls>;
export type AssetUrlsOutput = zod.output<typeof AssetUrls>;

export const Asset = zod.object({
  "brand_id": zod.uuid(),
  "bytes": zod.int(),
  "created_at": zod.iso.datetime({"offset":true}),
  "created_by": zod.union([zod.uuid(),zod.null()]),
  "deleted_at": zod.union([zod.iso.datetime({"offset":true}),zod.null()]),
  "duration_ms": zod.union([zod.int(),zod.null()]),
  "folder_id": zod.union([zod.uuid(),zod.null()]),
  "height": zod.union([zod.int(),zod.null()]),
  "id": zod.uuid(),
  "index_status": zod.union([IndexStatus,zod.null()]),
  "kind": AssetKind,
  "mime": MediaMime,
  "name": zod.string(),
  "origin": zod.union([AssetJobOrigin,zod.null()]),
  "proxy_status": zod.union([ProxyStatus,zod.null()]),
  "source": AssetSource,
  "status": AssetStatus,
  "updated_at": zod.iso.datetime({"offset":true}),
  "urls": AssetUrls,
  "width": zod.union([zod.int(),zod.null()])
});

export type Asset = zod.input<typeof Asset>;
export type AssetOutput = zod.output<typeof Asset>;

export const SceneMatch = zod.object({
  "end_ms": zod.int(),
  "end_time": zod.int(),
  "start_ms": zod.int(),
  "start_time": zod.int(),
  "thumbnail_seconds": zod.number(),
  "thumbnail_url": zod.string()
}).describe('The video scene a hit matched (spec S3, live\'s fields): its start and end in milliseconds,\n`start_time` floored and `end_time` ceiled to whole seconds, `thumbnail_seconds` the time of\nits kept frame, and that frame\'s thumbnail, signed as the asset\'s URLs.');

export type SceneMatch = zod.input<typeof SceneMatch>;
export type SceneMatchOutput = zod.output<typeof SceneMatch>;

export const AssetHit = zod.object({
  "asset": Asset,
  "distance": zod.number(),
  "scene": zod.union([SceneMatch,zod.null()])
}).describe('One point the query matched: its asset, the cosine distance (0 the same, 2 opposite), and\nfor a video the scene. A video matches once per matching scene, as live\'s search answers.');

export type AssetHit = zod.input<typeof AssetHit>;
export type AssetHitOutput = zod.output<typeof AssetHit>;

export const assetMoveAssetIdsMax = 100;



export const AssetMove = zod.object({
  "asset_ids": zod.array(zod.uuid()).min(1).max(assetMoveAssetIdsMax),
  "folder_id": zod.union([zod.uuid(),zod.null()])
}).describe('`POST .../brands/{brand_id}/assets/move` (#668, spec S1c): live\'s Move to project, from a\ncard\'s menu or the bulk bar. Every named file goes into `folder_id`, a folder of the path\'s\nbrand, or with null to the brand\'s top level ("All assets & files"); all or nothing.');

export type AssetMove = zod.input<typeof AssetMove>;
export type AssetMoveOutput = zod.output<typeof AssetMove>;

export const SaveRefusal = zod.enum(['not_delivered', 'unsupported_type', 'expired', 'generation_input']);

export type SaveRefusal = zod.input<typeof SaveRefusal>;
export type SaveRefusalOutput = zod.output<typeof SaveRefusal>;

export const AssetNotSavableDetails = zod.object({
  "reason": SaveRefusal
}).describe('Why a job output cannot become a library asset.');

export type AssetNotSavableDetails = zod.input<typeof AssetNotSavableDetails>;
export type AssetNotSavableDetailsOutput = zod.output<typeof AssetNotSavableDetails>;

export const AssetOrder = zod.enum(['newest', 'oldest']).describe('The library\'s order, as live\'s Sounds page sorts it: "Recently Added" or "Oldest First".');

export type AssetOrder = zod.input<typeof AssetOrder>;
export type AssetOrderOutput = zod.output<typeof AssetOrder>;

export const AssetPage = zod.object({
  "items": zod.array(Asset),
  "next": zod.union([zod.string(),zod.null()])
}).describe('One page of the library, newest first. Pass `next` as `after` for the following page;\nit is null on the last one.');

export type AssetPage = zod.input<typeof AssetPage>;
export type AssetPageOutput = zod.output<typeof AssetPage>;

export const AssetReindex = zod.object({
  "asset_id": zod.uuid(),
  "status": IndexStatus
}).describe('`POST .../assets/{asset_id}/reindex` (spec S3, live\'s Re-index): the asset is indexed again\nby the worker; `pending` until it is.');

export type AssetReindex = zod.input<typeof AssetReindex>;
export type AssetReindexOutput = zod.output<typeof AssetReindex>;

export const AssetReindexAll = zod.object({
  "requested": zod.int()
}).describe('`POST .../assets/reindex` (spec S3, "At scale"): every ready image and video of the brand\nthe library lists is indexed again, in the bulk lane, fairly with other teams\' requests;\n`requested` counts those asked (one already pending is not asked again).');

export type AssetReindexAll = zod.input<typeof AssetReindexAll>;
export type AssetReindexAllOutput = zod.output<typeof AssetReindexAll>;

export const AssetSearchPage = zod.object({
  "items": zod.array(AssetHit),
  "next": zod.union([zod.string(),zod.null()]),
  "total": zod.int(),
  "urls_expire_at": zod.union([zod.iso.datetime({"offset":true}),zod.null()])
}).describe('`GET .../assets/search` (spec S3): the brand\'s nearest points to the query, best first, at\nmost 256 in all (live\'s), `limit` a page; `total` is how many matched, `next` the page after\nthis one\'s cursor (`after`), null on the last.');

export type AssetSearchPage = zod.input<typeof AssetSearchPage>;
export type AssetSearchPageOutput = zod.output<typeof AssetSearchPage>;

export const JobStatus = zod.enum(['queued', 'submitting', 'running', 'finalizing', 'succeeded', 'failed', 'expired', 'canceled']);

export type JobStatus = zod.input<typeof JobStatus>;
export type JobStatusOutput = zod.output<typeof JobStatus>;

export const AssetZip = zod.object({
  "bytes": zod.int(),
  "created_at": zod.iso.datetime({"offset":true}),
  "error": zod.union([zod.string(),zod.null()]),
  "files": zod.int(),
  "finished_at": zod.union([zod.iso.datetime({"offset":true}),zod.null()]),
  "job_id": zod.uuid(),
  "skipped": zod.int(),
  "status": JobStatus,
  "url": zod.union([zod.string(),zod.null()]),
  "urls_expire_at": zod.union([zod.iso.datetime({"offset":true}),zod.null()])
}).describe('One ZIP\'s job: what it holds and, once made, its signed URL.');

export type AssetZip = zod.input<typeof AssetZip>;
export type AssetZipOutput = zod.output<typeof AssetZip>;

export const assetZipRequestAssetIdsMin = 2;
export const assetZipRequestAssetIdsMax = 1000;



export const AssetZipRequest = zod.object({
  "asset_ids": zod.array(zod.uuid()).min(assetZipRequestAssetIdsMin).max(assetZipRequestAssetIdsMax)
}).describe('`POST .../assets/zip`: the files of one ZIP, each once, as live\'s bulk Download.');

export type AssetZipRequest = zod.input<typeof AssetZipRequest>;
export type AssetZipRequestOutput = zod.output<typeof AssetZipRequest>;

export const assistMoveClipClipIdOneRegExp = new RegExp('^[A-Za-z0-9_-]{1,64}$');
export const assistMoveClipClipIdTwoRegExp = new RegExp('^@[A-Za-z0-9_-]{1,32}$');
export const assistMoveClipStartMsMin = 0;
export const assistMoveClipStartMsMax = 300000;

export const assistMoveClipTrackIdOneRegExp = new RegExp('^[A-Za-z0-9_-]{1,64}$');


export const AssistMoveClip = zod.object({
  "clip_id": zod.union([zod.string().regex(assistMoveClipClipIdOneRegExp),zod.string().regex(assistMoveClipClipIdTwoRegExp)]),
  "start_ms": zod.int().min(assistMoveClipStartMsMin).max(assistMoveClipStartMsMax),
  "track_id": zod.union([zod.string().regex(assistMoveClipTrackIdOneRegExp),zod.null()]).exactOptional(),
  "type": zod.enum(['move_clip'])
}).describe('Moves a clip to start at `start_ms`, on `track_id` if it names a track of its kind\n(the editor\'s `moveClip`).');

export type AssistMoveClip = zod.input<typeof AssistMoveClip>;
export type AssistMoveClipOutput = zod.output<typeof AssistMoveClip>;

export const assistTrimStartClipIdOneRegExp = new RegExp('^[A-Za-z0-9_-]{1,64}$');
export const assistTrimStartClipIdTwoRegExp = new RegExp('^@[A-Za-z0-9_-]{1,32}$');
export const assistTrimStartStartMsMin = 0;
export const assistTrimStartStartMsMax = 300000;



export const AssistTrimStart = zod.object({
  "clip_id": zod.union([zod.string().regex(assistTrimStartClipIdOneRegExp),zod.string().regex(assistTrimStartClipIdTwoRegExp)]),
  "start_ms": zod.int().min(assistTrimStartStartMsMin).max(assistTrimStartStartMsMax),
  "type": zod.enum(['trim_start'])
}).describe('Moves a clip\'s start, its end kept; a video or a sound reads from a later point\n(`trimStart`).');

export type AssistTrimStart = zod.input<typeof AssistTrimStart>;
export type AssistTrimStartOutput = zod.output<typeof AssistTrimStart>;

export const assistTrimEndClipIdOneRegExp = new RegExp('^[A-Za-z0-9_-]{1,64}$');
export const assistTrimEndClipIdTwoRegExp = new RegExp('^@[A-Za-z0-9_-]{1,32}$');
export const assistTrimEndEndMsMin = 0;
export const assistTrimEndEndMsMax = 300000;



export const AssistTrimEnd = zod.object({
  "clip_id": zod.union([zod.string().regex(assistTrimEndClipIdOneRegExp),zod.string().regex(assistTrimEndClipIdTwoRegExp)]),
  "end_ms": zod.int().min(assistTrimEndEndMsMin).max(assistTrimEndEndMsMax),
  "type": zod.enum(['trim_end'])
}).describe('Moves a clip\'s end, its start kept (`trimEnd`).');

export type AssistTrimEnd = zod.input<typeof AssistTrimEnd>;
export type AssistTrimEndOutput = zod.output<typeof AssistTrimEnd>;

export const assistSetRangeClipIdOneRegExp = new RegExp('^[A-Za-z0-9_-]{1,64}$');
export const assistSetRangeClipIdTwoRegExp = new RegExp('^@[A-Za-z0-9_-]{1,32}$');
export const assistSetRangeInMsMin = 0;
export const assistSetRangeInMsMax = 300000;

export const assistSetRangeOutMsMin = 0;
export const assistSetRangeOutMsMax = 300000;



export const AssistSetRange = zod.object({
  "clip_id": zod.union([zod.string().regex(assistSetRangeClipIdOneRegExp),zod.string().regex(assistSetRangeClipIdTwoRegExp)]),
  "in_ms": zod.int().min(assistSetRangeInMsMin).max(assistSetRangeInMsMax),
  "out_ms": zod.int().min(assistSetRangeOutMsMin).max(assistSetRangeOutMsMax),
  "type": zod.enum(['set_range'])
}).describe('A video\'s or a sound\'s in and out points in its own time; its start stays (`setRange`).');

export type AssistSetRange = zod.input<typeof AssistSetRange>;
export type AssistSetRangeOutput = zod.output<typeof AssistSetRange>;

export const assistSetClipClipIdOneRegExp = new RegExp('^[A-Za-z0-9_-]{1,64}$');
export const assistSetClipClipIdTwoRegExp = new RegExp('^@[A-Za-z0-9_-]{1,32}$');
export const assistSetClipFadeInMsOneMin = 0;
export const assistSetClipFadeInMsOneMax = 5000;

export const assistSetClipFadeOutMsOneMin = 0;
export const assistSetClipFadeOutMsOneMax = 5000;

export const assistSetClipTextOneMax = 200;


export const assistSetClipTextOneRegExp = new RegExp('[^\\t\\n\\v\\f\\r \\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000\\ufeff]');
export const assistSetClipVolumeOneMin = 0;
export const assistSetClipVolumeOneMax = 2;



export const AssistSetClip = zod.object({
  "clip_id": zod.union([zod.string().regex(assistSetClipClipIdOneRegExp),zod.string().regex(assistSetClipClipIdTwoRegExp)]),
  "fade_in_ms": zod.union([zod.int().min(assistSetClipFadeInMsOneMin).max(assistSetClipFadeInMsOneMax),zod.null()]).exactOptional(),
  "fade_out_ms": zod.union([zod.int().min(assistSetClipFadeOutMsOneMin).max(assistSetClipFadeOutMsOneMax),zod.null()]).exactOptional(),
  "hidden": zod.union([zod.boolean(),zod.null()]).exactOptional(),
  "muted": zod.union([zod.boolean(),zod.null()]).exactOptional(),
  "text": zod.union([zod.string().min(1).max(assistSetClipTextOneMax).regex(assistSetClipTextOneRegExp),zod.null()]).exactOptional(),
  "type": zod.enum(['set_clip']),
  "volume": zod.union([zod.number().min(assistSetClipVolumeOneMin).max(assistSetClipVolumeOneMax),zod.null()]).exactOptional()
}).describe('A clip\'s own fields: its sound, fades, a title\'s text, or Hide (`setClip`).');

export type AssistSetClip = zod.input<typeof AssistSetClip>;
export type AssistSetClipOutput = zod.output<typeof AssistSetClip>;

export const boxHeightExclusiveMin = 0;
export const boxHeightMax = 10000;

export const boxWidthExclusiveMin = 0;
export const boxWidthMax = 10000;

export const boxXMin = -10000;
export const boxXMax = 10000;

export const boxYMin = -10000;
export const boxYMax = 10000;



export const Box = zod.object({
  "height": zod.number().gt(boxHeightExclusiveMin).max(boxHeightMax),
  "width": zod.number().gt(boxWidthExclusiveMin).max(boxWidthMax),
  "x": zod.number().min(boxXMin).max(boxXMax),
  "y": zod.number().min(boxYMin).max(boxYMax)
}).describe('Where a picture sits on the frame and its size, in live\'s pixels on live\'s frame of the\nproject\'s ratio (1920x1080, 1080x1920, 1080x1080, 1080x1350, 1440x1080, 1920x823), whatever\nthe file\'s size. `x` and `y` are its top left corner before it turns.');

export type Box = zod.input<typeof Box>;
export type BoxOutput = zod.output<typeof Box>;

export const chromaKeyColorRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const chromaKeySimilarityMin = 0;
export const chromaKeySimilarityMax = 1;

export const chromaKeySpillMin = 0;
export const chromaKeySpillMax = 1;



export const ChromaKey = zod.object({
  "color": zod.string().regex(chromaKeyColorRegExp),
  "similarity": zod.number().min(chromaKeySimilarityMin).max(chromaKeySimilarityMax),
  "spill": zod.number().min(chromaKeySpillMin).max(chromaKeySpillMax)
}).describe('Live\'s Chroma Key: what is near `color` turns clear; `similarity` is how near (0 to 1),\n`spill` how much of the colour\'s cast is taken from what stays.');

export type ChromaKey = zod.input<typeof ChromaKey>;
export type ChromaKeyOutput = zod.output<typeof ChromaKey>;

export const AssistLookPart = zod.enum(['box', 'stroke', 'shadow', 'chroma_key']).describe('What `set_look` may take off a picture: its Transform\'s box (back to fitted and centred),\nor its Stroke, Shadow or Chroma Key.');

export type AssistLookPart = zod.input<typeof AssistLookPart>;
export type AssistLookPartOutput = zod.output<typeof AssistLookPart>;

export const shadowBlurMin = 0;
export const shadowBlurMax = 100;

export const shadowColorRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const shadowOffsetXMin = -500;
export const shadowOffsetXMax = 500;

export const shadowOffsetYMin = -500;
export const shadowOffsetYMax = 500;



export const Shadow = zod.object({
  "blur": zod.number().min(shadowBlurMin).max(shadowBlurMax),
  "color": zod.string().regex(shadowColorRegExp),
  "offset_x": zod.number().min(shadowOffsetXMin).max(shadowOffsetXMax),
  "offset_y": zod.number().min(shadowOffsetYMin).max(shadowOffsetYMax)
}).describe('Live\'s Shadow: the picture\'s shape, or the letters\', in `color`, moved by the offsets and\nblurred by `blur` live\'s pixels, behind it.');

export type Shadow = zod.input<typeof Shadow>;
export type ShadowOutput = zod.output<typeof Shadow>;

export const strokeColorRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const strokeWidthMin = 0;
export const strokeWidthMax = 100;



export const Stroke = zod.object({
  "color": zod.string().regex(strokeColorRegExp),
  "width": zod.number().min(strokeWidthMin).max(strokeWidthMax)
}).describe('Live\'s Stroke: a line of `width` live\'s pixels around the picture or the letters, in\n`color`.');

export type Stroke = zod.input<typeof Stroke>;
export type StrokeOutput = zod.output<typeof Stroke>;

export const assistSetLookClearDefault = [];
export const assistSetLookClearMax = 4;

export const assistSetLookClipIdOneRegExp = new RegExp('^[A-Za-z0-9_-]{1,64}$');
export const assistSetLookClipIdTwoRegExp = new RegExp('^@[A-Za-z0-9_-]{1,32}$');
export const assistSetLookOpacityOneMin = 0;
export const assistSetLookOpacityOneMax = 1;

export const assistSetLookRadiusOneMin = 0;
export const assistSetLookRadiusOneMax = 500;

export const assistSetLookRotationOneMin = -360;
export const assistSetLookRotationOneMax = 360;



export const AssistSetLook = zod.object({
  "box": zod.union([Box,zod.null()]).exactOptional(),
  "chroma_key": zod.union([ChromaKey,zod.null()]).exactOptional(),
  "clear": zod.array(AssistLookPart).max(assistSetLookClearMax).default(assistSetLookClearDefault),
  "clip_id": zod.union([zod.string().regex(assistSetLookClipIdOneRegExp),zod.string().regex(assistSetLookClipIdTwoRegExp)]),
  "flip_x": zod.union([zod.boolean(),zod.null()]).exactOptional(),
  "flip_y": zod.union([zod.boolean(),zod.null()]).exactOptional(),
  "opacity": zod.union([zod.number().min(assistSetLookOpacityOneMin).max(assistSetLookOpacityOneMax),zod.null()]).exactOptional(),
  "radius": zod.union([zod.int().min(assistSetLookRadiusOneMin).max(assistSetLookRadiusOneMax),zod.null()]).exactOptional(),
  "rotation": zod.union([zod.number().min(assistSetLookRotationOneMin).max(assistSetLookRotationOneMax),zod.null()]).exactOptional(),
  "shadow": zod.union([Shadow,zod.null()]).exactOptional(),
  "stroke": zod.union([Stroke,zod.null()]).exactOptional(),
  "type": zod.enum(['set_look'])
}).describe('A picture\'s look, as live\'s Parameters set it (#241; G11 PR 2b): what is given changes,\nwhat is left out stays, and `clear` takes a part off (`setClip`).');

export type AssistSetLook = zod.input<typeof AssistSetLook>;
export type AssistSetLookOutput = zod.output<typeof AssistSetLook>;

export const TextAlign = zod.enum(['left', 'center', 'right']).describe('Each line\'s place across the text\'s box: live\'s Align.');

export type TextAlign = zod.input<typeof TextAlign>;
export type TextAlignOutput = zod.output<typeof TextAlign>;

export const textBackgroundColorRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const textBackgroundOpacityDefault = 1;
export const textBackgroundOpacityMin = 0;
export const textBackgroundOpacityMax = 1;

export const textBackgroundPadXDefault = 8;
export const textBackgroundPadXMin = 0;
export const textBackgroundPadXMax = 500;

export const textBackgroundPadYDefault = 4;
export const textBackgroundPadYMin = 0;
export const textBackgroundPadYMax = 500;

export const textBackgroundRadiusDefault = 4;
export const textBackgroundRadiusMin = 0;
export const textBackgroundRadiusMax = 500;



export const TextBackground = zod.object({
  "color": zod.string().regex(textBackgroundColorRegExp),
  "opacity": zod.number().min(textBackgroundOpacityMin).max(textBackgroundOpacityMax).default(textBackgroundOpacityDefault),
  "pad_x": zod.number().min(textBackgroundPadXMin).max(textBackgroundPadXMax).default(textBackgroundPadXDefault),
  "pad_y": zod.number().min(textBackgroundPadYMin).max(textBackgroundPadYMax).default(textBackgroundPadYDefault),
  "radius": zod.number().min(textBackgroundRadiusMin).max(textBackgroundRadiusMax).default(textBackgroundRadiusDefault)
}).describe('Live\'s Text Background: a box behind each line of the text, `pad_x` and `pad_y` live\'s\npixels around it, its corners rounded by `radius`, in `color` at `opacity`.');

export type TextBackground = zod.input<typeof TextBackground>;
export type TextBackgroundOutput = zod.output<typeof TextBackground>;

export const TextCase = zod.enum(['as_typed', 'upper', 'lower']).describe('Live\'s case: the text as typed, or drawn in capitals or in small letters (the stored text\nkeeps what was typed).');

export type TextCase = zod.input<typeof TextCase>;
export type TextCaseOutput = zod.output<typeof TextCase>;

export const AssistTextPart = zod.enum(['background', 'stroke', 'shadow']).describe('What `set_text_style` may take off a text: its Background, Stroke or Shadow.');

export type AssistTextPart = zod.input<typeof AssistTextPart>;
export type AssistTextPartOutput = zod.output<typeof AssistTextPart>;

export const FontFamily = zod.enum(['Abril Fatface', 'Alegreya', 'Alegreya Sans', 'Aleo', 'Arapey', 'Archivo Narrow', 'Asap Condensed', 'Assistant', 'Bangers', 'Barlow', 'Big Shoulders Display', 'BioRhyme', 'Bitter', 'Brawler', 'Cabin', 'Caladea', 'Cardo', 'Carme', 'Chivo', 'Cormorant', 'DM Sans', 'Domine', 'Eczar', 'Encode Sans Semi Condensed', 'Enriqueta', 'Fira Sans', 'Frank Ruhl Libre', 'Fraunces', 'Gelasio', 'Headland One', 'IBM Plex Sans', 'Inconsolata', 'Inknut Antiqua', 'Inter', 'Josefin Sans', 'Karla', 'Lato', 'Libre Baskerville', 'Libre Franklin', 'Lora', 'Maitree', 'Manrope', 'Merriweather', 'Montserrat', 'Nanum Gothic', 'Neuton', 'Nunito', 'Open Sans', 'Oswald', 'Playfair Display', 'Poppins', 'Proza Libre', 'PT Sans', 'PT Serif', 'Quattrocento', 'Raleway', 'Roboto', 'Roboto Condensed', 'Rokkitt', 'Rubik', 'Sora', 'Source Code Pro', 'Source Sans 3', 'Source Sans Pro', 'Source Serif Pro', 'Space Grotesk', 'Space Mono', 'Spectral', 'Syne', 'Teko', 'Ubuntu', 'Work Sans', 'Zilla Slab']).describe('A text\'s face (#241): a family of live\'s font picker (its 70) or of its presets (Abril\nFatface, Big Shoulders Display, Sora), by Google Fonts\' name. The web loads each from Google\nFonts as live does; the server\'s fallback render draws every text in its one font.');

export type FontFamily = zod.input<typeof FontFamily>;
export type FontFamilyOutput = zod.output<typeof FontFamily>;

export const assistSetTextStyleClearDefault = [];
export const assistSetTextStyleClearMax = 3;

export const assistSetTextStyleClipIdOneRegExp = new RegExp('^[A-Za-z0-9_-]{1,64}$');
export const assistSetTextStyleClipIdTwoRegExp = new RegExp('^@[A-Za-z0-9_-]{1,32}$');
export const assistSetTextStyleColorOneRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const assistSetTextStyleOpacityOneMin = 0;
export const assistSetTextStyleOpacityOneMax = 1;

export const assistSetTextStyleRotationOneMin = -360;
export const assistSetTextStyleRotationOneMax = 360;

export const assistSetTextStyleSizeOneMin = 8;
export const assistSetTextStyleSizeOneMax = 1000;

export const assistSetTextStyleWeightOneMin = 100;
export const assistSetTextStyleWeightOneMax = 900;
export const assistSetTextStyleWeightOneMultipleOf = 100;

export const assistSetTextStyleWidthOneExclusiveMin = 0;
export const assistSetTextStyleWidthOneMax = 10000;

export const assistSetTextStyleXOneMin = -10000;
export const assistSetTextStyleXOneMax = 10000;

export const assistSetTextStyleYOneMin = -10000;
export const assistSetTextStyleYOneMax = 10000;



export const AssistSetTextStyle = zod.object({
  "align": zod.union([TextAlign,zod.null()]).exactOptional(),
  "background": zod.union([TextBackground,zod.null()]).exactOptional(),
  "case": zod.union([TextCase,zod.null()]).exactOptional(),
  "clear": zod.array(AssistTextPart).max(assistSetTextStyleClearMax).default(assistSetTextStyleClearDefault),
  "clip_id": zod.union([zod.string().regex(assistSetTextStyleClipIdOneRegExp),zod.string().regex(assistSetTextStyleClipIdTwoRegExp)]),
  "color": zod.union([zod.string().regex(assistSetTextStyleColorOneRegExp),zod.null()]).exactOptional(),
  "font": zod.union([FontFamily,zod.null()]).exactOptional(),
  "italic": zod.union([zod.boolean(),zod.null()]).exactOptional(),
  "opacity": zod.union([zod.number().min(assistSetTextStyleOpacityOneMin).max(assistSetTextStyleOpacityOneMax),zod.null()]).exactOptional(),
  "overline": zod.union([zod.boolean(),zod.null()]).exactOptional(),
  "rotation": zod.union([zod.number().min(assistSetTextStyleRotationOneMin).max(assistSetTextStyleRotationOneMax),zod.null()]).exactOptional(),
  "shadow": zod.union([Shadow,zod.null()]).exactOptional(),
  "size": zod.union([zod.int().min(assistSetTextStyleSizeOneMin).max(assistSetTextStyleSizeOneMax),zod.null()]).exactOptional(),
  "strikethrough": zod.union([zod.boolean(),zod.null()]).exactOptional(),
  "stroke": zod.union([Stroke,zod.null()]).exactOptional(),
  "type": zod.enum(['set_text_style']),
  "underline": zod.union([zod.boolean(),zod.null()]).exactOptional(),
  "weight": zod.union([zod.int().min(assistSetTextStyleWeightOneMin).max(assistSetTextStyleWeightOneMax).multipleOf(assistSetTextStyleWeightOneMultipleOf),zod.null()]).exactOptional(),
  "width": zod.union([zod.number().gt(assistSetTextStyleWidthOneExclusiveMin).max(assistSetTextStyleWidthOneMax),zod.null()]).exactOptional(),
  "x": zod.union([zod.number().min(assistSetTextStyleXOneMin).max(assistSetTextStyleXOneMax),zod.null()]).exactOptional(),
  "y": zod.union([zod.number().min(assistSetTextStyleYOneMin).max(assistSetTextStyleYOneMax),zod.null()]).exactOptional()
}).describe('A text\'s style, as live\'s Parameters set it (#241 part 2; G11 PR 2b): what is given\nchanges, what is left out stays, and `clear` takes a part off (`setClip`\'s `style`).');

export type AssistSetTextStyle = zod.input<typeof AssistSetTextStyle>;
export type AssistSetTextStyleOutput = zod.output<typeof AssistSetTextStyle>;

export const KeyframeProperty = zod.enum(['x', 'y', 'width', 'height', 'scale', 'scaleX', 'scaleY', 'angle', 'opacity', 'blur', 'brightness', 'saturation', 'motionBlur', 'maskWidth', 'maskHeight', 'maskRadius', 'maskProgress', 'maskBorderRadius', 'tracking', 'lineHeight', 'fontSize', 'cropX', 'cropY', 'cropWidth', 'cropHeight']).describe('Live\'s Custom properties, in its "Add Property" list\'s order, by live\'s own names.');

export type KeyframeProperty = zod.input<typeof KeyframeProperty>;
export type KeyframePropertyOutput = zod.output<typeof KeyframeProperty>;

export const assistKeyframeValueValueMin = -10000;
export const assistKeyframeValueValueMax = 10000;



export const AssistKeyframeValue = zod.object({
  "property": KeyframeProperty,
  "value": zod.number().min(assistKeyframeValueValueMin).max(assistKeyframeValueValueMax)
}).describe('One property a Custom stop sets: `Keyframe.values` as a list, since the model\'s schema\nkeeps no map.');

export type AssistKeyframeValue = zod.input<typeof AssistKeyframeValue>;
export type AssistKeyframeValueOutput = zod.output<typeof AssistKeyframeValue>;

export const assistKeyframeAtMin = 0;
export const assistKeyframeAtMax = 100;

export const assistKeyframeValuesDefault = [];
export const assistKeyframeValuesMax = 25;



export const AssistKeyframe = zod.object({
  "at": zod.int().min(assistKeyframeAtMin).max(assistKeyframeAtMax),
  "values": zod.array(AssistKeyframeValue).max(assistKeyframeValuesMax).default(assistKeyframeValuesDefault)
}).describe('One stop of a Custom animation the assistant adds: `at` percent, and what it sets.');

export type AssistKeyframe = zod.input<typeof AssistKeyframe>;
export type AssistKeyframeOutput = zod.output<typeof AssistKeyframe>;

export const assistAddAnimationClipIdOneRegExp = new RegExp('^[A-Za-z0-9_-]{1,64}$');
export const assistAddAnimationClipIdTwoRegExp = new RegExp('^@[A-Za-z0-9_-]{1,32}$');
export const assistAddAnimationDelayMsOneMin = 0;
export const assistAddAnimationDelayMsOneMax = 300000;

export const assistAddAnimationDistanceOneMin = -10000;
export const assistAddAnimationDistanceOneMax = 10000;

export const assistAddAnimationDurationMsOneMin = 0;
export const assistAddAnimationDurationMsOneMax = 300000;

export const assistAddAnimationIterationsOneMax = 100;

export const assistAddAnimationKeyframesDefault = [];
export const assistAddAnimationKeyframesMax = 20;

export const assistAddAnimationStaggerOneMin = 0;
export const assistAddAnimationStaggerOneMax = 1.5;



export const AssistAddAnimation = zod.object({
  "clip_id": zod.union([zod.string().regex(assistAddAnimationClipIdOneRegExp),zod.string().regex(assistAddAnimationClipIdTwoRegExp)]),
  "delay_ms": zod.union([zod.int().min(assistAddAnimationDelayMsOneMin).max(assistAddAnimationDelayMsOneMax),zod.null()]).exactOptional(),
  "direction": zod.union([AnimationDirection,zod.null()]).exactOptional(),
  "distance": zod.union([zod.number().min(assistAddAnimationDistanceOneMin).max(assistAddAnimationDistanceOneMax),zod.null()]).exactOptional(),
  "duration_ms": zod.union([zod.int().min(assistAddAnimationDurationMsOneMin).max(assistAddAnimationDurationMsOneMax),zod.null()]).exactOptional(),
  "easing": zod.union([AnimationEasing,zod.null()]).exactOptional(),
  "iterations": zod.union([zod.int().min(1).max(assistAddAnimationIterationsOneMax),zod.null()]).exactOptional(),
  "keyframes": zod.array(AssistKeyframe).max(assistAddAnimationKeyframesMax).default(assistAddAnimationKeyframesDefault),
  "mirror": zod.union([zod.boolean(),zod.null()]).exactOptional(),
  "mode": zod.union([AnimationMode,zod.null()]).exactOptional(),
  "preset": AnimationPreset,
  "stagger": zod.union([zod.number().min(assistAddAnimationStaggerOneMin).max(assistAddAnimationStaggerOneMax),zod.null()]).exactOptional(),
  "type": zod.enum(['add_animation'])
}).describe('One of live\'s animations added to a picture\'s or a text\'s list (G11 PR 2d; live\'s\n`clip.update` of `animations`): `preset` as live\'s popover starts it (In; a combo the whole\nclip), with what is given over it. A combo and Custom take no `mode`; Custom takes its\n`keyframes`. A preset\'s other settings (a mask\'s, Block Reveal\'s) are its popover\'s start.');

export type AssistAddAnimation = zod.input<typeof AssistAddAnimation>;
export type AssistAddAnimationOutput = zod.output<typeof AssistAddAnimation>;

export const assistRemoveAnimationsClipIdOneRegExp = new RegExp('^[A-Za-z0-9_-]{1,64}$');
export const assistRemoveAnimationsClipIdTwoRegExp = new RegExp('^@[A-Za-z0-9_-]{1,32}$');


export const AssistRemoveAnimations = zod.object({
  "clip_id": zod.union([zod.string().regex(assistRemoveAnimationsClipIdOneRegExp),zod.string().regex(assistRemoveAnimationsClipIdTwoRegExp)]),
  "mode": zod.union([AnimationMode,zod.null()]).exactOptional(),
  "preset": zod.union([AnimationPreset,zod.null()]).exactOptional(),
  "type": zod.enum(['remove_animations'])
}).describe('Takes a clip\'s animations off (G11 PR 2d; live\'s `animations: []`): every one, or those\nof `preset`, of `mode`, or of both.');

export type AssistRemoveAnimations = zod.input<typeof AssistRemoveAnimations>;
export type AssistRemoveAnimationsOutput = zod.output<typeof AssistRemoveAnimations>;

export const effectPointXMin = -10000;
export const effectPointXMax = 10000;

export const effectPointYMin = -10000;
export const effectPointYMax = 10000;



export const EffectPoint = zod.object({
  "x": zod.number().min(effectPointXMin).max(effectPointXMax),
  "y": zod.number().min(effectPointYMin).max(effectPointYMax)
}).describe('An X/Y pair of live\'s Configuration: a filter\'s offset, centre or strength.');

export type EffectPoint = zod.input<typeof EffectPoint>;
export type EffectPointOutput = zod.output<typeof EffectPoint>;

export const effectValueOneMin = -10000;
export const effectValueOneMax = 10000;

export const effectValueThreeRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');


export const EffectValue = zod.union([zod.number().min(effectValueOneMin).max(effectValueOneMax),zod.boolean(),zod.string().regex(effectValueThreeRegExp),EffectPoint]);

export type EffectValue = zod.input<typeof EffectValue>;
export type EffectValueOutput = zod.output<typeof EffectValue>;

export const assistEffectValueNameRegExp = new RegExp('^[a-z][A-Za-z]{0,31}$');


export const AssistEffectValue = zod.object({
  "name": zod.string().regex(assistEffectValueNameRegExp),
  "value": EffectValue
}).describe('One of an effect\'s settings: `EffectClip.values` as a list, since the model\'s schema keeps\nno map.');

export type AssistEffectValue = zod.input<typeof AssistEffectValue>;
export type AssistEffectValueOutput = zod.output<typeof AssistEffectValue>;

export const assistSetEffectValuesClipIdOneRegExp = new RegExp('^[A-Za-z0-9_-]{1,64}$');
export const assistSetEffectValuesClipIdTwoRegExp = new RegExp('^@[A-Za-z0-9_-]{1,32}$');
export const assistSetEffectValuesValuesMax = 24;



export const AssistSetEffectValues = zod.object({
  "clip_id": zod.union([zod.string().regex(assistSetEffectValuesClipIdOneRegExp),zod.string().regex(assistSetEffectValuesClipIdTwoRegExp)]),
  "type": zod.enum(['set_effect_values']),
  "values": zod.array(AssistEffectValue).min(1).max(assistSetEffectValuesValuesMax)
}).describe('An effect\'s settings, as live\'s Configuration sets them (G11 PR 2e; live\'s `clip.update`\nof an effect clip\'s `values`): each given one changes, the others stay. The editor knows each\nfilter\'s settings and holds a value to its control\'s range.');

export type AssistSetEffectValues = zod.input<typeof AssistSetEffectValues>;
export type AssistSetEffectValuesOutput = zod.output<typeof AssistSetEffectValues>;

export const assistRemoveClipClipIdOneRegExp = new RegExp('^[A-Za-z0-9_-]{1,64}$');
export const assistRemoveClipClipIdTwoRegExp = new RegExp('^@[A-Za-z0-9_-]{1,32}$');


export const AssistRemoveClip = zod.object({
  "clip_id": zod.union([zod.string().regex(assistRemoveClipClipIdOneRegExp),zod.string().regex(assistRemoveClipClipIdTwoRegExp)]),
  "type": zod.enum(['remove_clip'])
});

export type AssistRemoveClip = zod.input<typeof AssistRemoveClip>;
export type AssistRemoveClipOutput = zod.output<typeof AssistRemoveClip>;

export const assistSplitAtMsMin = 0;
export const assistSplitAtMsMax = 300000;

export const assistSplitClipIdOneRegExp = new RegExp('^[A-Za-z0-9_-]{1,64}$');
export const assistSplitClipIdTwoRegExp = new RegExp('^@[A-Za-z0-9_-]{1,32}$');
export const assistSplitRefRegExp = new RegExp('^@[A-Za-z0-9_-]{1,32}$');


export const AssistSplit = zod.object({
  "at_ms": zod.int().min(assistSplitAtMsMin).max(assistSplitAtMsMax),
  "clip_id": zod.union([zod.string().regex(assistSplitClipIdOneRegExp),zod.string().regex(assistSplitClipIdTwoRegExp)]),
  "ref": zod.string().regex(assistSplitRefRegExp),
  "type": zod.enum(['split'])
}).describe('Cuts a clip in two at `at_ms`, a time of the video inside it; the second half is `ref`\n(live\'s Split).');

export type AssistSplit = zod.input<typeof AssistSplit>;
export type AssistSplitOutput = zod.output<typeof AssistSplit>;

export const assistDuplicateClipIdOneRegExp = new RegExp('^[A-Za-z0-9_-]{1,64}$');
export const assistDuplicateClipIdTwoRegExp = new RegExp('^@[A-Za-z0-9_-]{1,32}$');
export const assistDuplicateRefRegExp = new RegExp('^@[A-Za-z0-9_-]{1,32}$');


export const AssistDuplicate = zod.object({
  "clip_id": zod.union([zod.string().regex(assistDuplicateClipIdOneRegExp),zod.string().regex(assistDuplicateClipIdTwoRegExp)]),
  "ref": zod.string().regex(assistDuplicateRefRegExp),
  "type": zod.enum(['duplicate'])
}).describe('A copy of a clip at the same time on a new track above its own (live\'s Duplicate).');

export type AssistDuplicate = zod.input<typeof AssistDuplicate>;
export type AssistDuplicateOutput = zod.output<typeof AssistDuplicate>;

export const assistSeparateAudioClipIdOneRegExp = new RegExp('^[A-Za-z0-9_-]{1,64}$');
export const assistSeparateAudioClipIdTwoRegExp = new RegExp('^@[A-Za-z0-9_-]{1,32}$');
export const assistSeparateAudioRefRegExp = new RegExp('^@[A-Za-z0-9_-]{1,32}$');


export const AssistSeparateAudio = zod.object({
  "clip_id": zod.union([zod.string().regex(assistSeparateAudioClipIdOneRegExp),zod.string().regex(assistSeparateAudioClipIdTwoRegExp)]),
  "ref": zod.string().regex(assistSeparateAudioRefRegExp),
  "type": zod.enum(['separate_audio'])
}).describe('A video\'s sound as a clip of its own, `ref`; the video is muted (live\'s Separate Audio).');

export type AssistSeparateAudio = zod.input<typeof AssistSeparateAudio>;
export type AssistSeparateAudioOutput = zod.output<typeof AssistSeparateAudio>;

export const assistSetLockClipIdOneRegExp = new RegExp('^[A-Za-z0-9_-]{1,64}$');
export const assistSetLockClipIdTwoRegExp = new RegExp('^@[A-Za-z0-9_-]{1,32}$');


export const AssistSetLock = zod.object({
  "clip_id": zod.union([zod.string().regex(assistSetLockClipIdOneRegExp),zod.string().regex(assistSetLockClipIdTwoRegExp)]),
  "locked": zod.boolean(),
  "type": zod.enum(['set_lock'])
});

export type AssistSetLock = zod.input<typeof AssistSetLock>;
export type AssistSetLockOutput = zod.output<typeof AssistSetLock>;

export const assistAddTitleEndMsMin = 0;
export const assistAddTitleEndMsMax = 300000;

export const assistAddTitleRefRegExp = new RegExp('^@[A-Za-z0-9_-]{1,32}$');
export const assistAddTitleStartMsMin = 0;
export const assistAddTitleStartMsMax = 300000;

export const assistAddTitleTextMax = 200;


export const assistAddTitleTextRegExp = new RegExp('[^\\t\\n\\v\\f\\r \\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000\\ufeff]');


export const AssistAddTitle = zod.object({
  "end_ms": zod.int().min(assistAddTitleEndMsMin).max(assistAddTitleEndMsMax),
  "ref": zod.string().regex(assistAddTitleRefRegExp),
  "start_ms": zod.int().min(assistAddTitleStartMsMin).max(assistAddTitleStartMsMax),
  "text": zod.string().min(1).max(assistAddTitleTextMax).regex(assistAddTitleTextRegExp),
  "type": zod.enum(['add_title'])
}).describe('A title on the first text track, in the editor\'s default style (`addTitle`).');

export type AssistAddTitle = zod.input<typeof AssistAddTitle>;
export type AssistAddTitleOutput = zod.output<typeof AssistAddTitle>;

export const assistAddClipRefRegExp = new RegExp('^@[A-Za-z0-9_-]{1,32}$');
export const assistAddClipStartMsOneMin = 0;
export const assistAddClipStartMsOneMax = 300000;



export const AssistAddClip = zod.object({
  "ref": zod.string().regex(assistAddClipRefRegExp),
  "source": SourceRef,
  "start_ms": zod.union([zod.int().min(assistAddClipStartMsOneMin).max(assistAddClipStartMsOneMax),zod.null()]).exactOptional(),
  "type": zod.enum(['add_clip'])
}).describe('One of the files the panel offered (`AssistRequest.media`), added whole and named by\n`ref`, as live\'s `clip.add` places it: from `start_ms` (0 without), on the first track of\nits kind free over its span, else on a new one of that kind on top (`addClip`).');

export type AssistAddClip = zod.input<typeof AssistAddClip>;
export type AssistAddClipOutput = zod.output<typeof AssistAddClip>;

export const EffectKind = zod.enum(['grayscale', 'sepia', 'invert', 'vignette', 'hue-shift', 'fade-in', 'fade-out', 'adjustment-filter', 'advanced-bloom-filter', 'backdrop-blur-filter', 'bloom-filter', 'color-map-filter', 'convolution-filter', 'dot-filter', 'glitch-filter', 'glow-filter', 'godray-filter', 'grayscale-filter', 'hsl-adjustment-filter', 'kawase-blur-filter', 'motion-blur-filter', 'old-film-filter', 'radial-blur-filter', 'reflection-filter', 'rgb-split-filter', 'tilt-shift-filter', 'rotation-movement', 'spring', 'warp-transition', 'pixelate-transition', 'focus-transition', 'scale-move-blur', 'camera-move', 'fast-zoom', 'camera-shake', 'radial-zoom-rush', 'zoom-rotate', 'dutch-tilt-recoil', 'whip-snap-punch', 'earthquake-tremor', 'shine', 'blink', 'flash-loop', 'neon-flash', 'laser', 'sparks', 'black-flash', 'bright-pulse', 'strobe', 'edge-glow', 'anamorphic-streak', 'lens-glint-rainbow', 'solarize-flare', 'glitch', 'rgb-glitch', 'rgb-shift', 'slit-scan', 'slit-scan-glitch', 'tv-scanlines', 'rgb-split-pulse', 'vhs-tape-fx', 'datamosh-melt', 'bad-antenna-static', 'pixel-sorting', 'halftone', 'film-strip-pro', 'paper-break-reveal', 'film-grain', 'kodachrome8mm', 'technicolor-two-strip', 'aged-newspaper', 'sinewave', 'swirl-movement', 'distort', 'perspective-single', 'distort-spin', 'distort-grid', 'mirror-tile', 'curtain-open', 'curtain-blur', 'distort-v2', 'wave-distort', 'wave', 'heatwave', 'fisheye-barrel', 'underwater-refraction', 'black-hole-vortex', 'heart-sparkles', 'golden-glitter', 'bubble-sparkles', 'fairy-dust', 'pixelate', 'duotone', 'tritone', 'chromatic', 'inverse-aperture', 'hdr', 'hdr-v2', 'chromatic-aura', 'cyberpunk-neon', 'thermal-infrared', 'cinematic-teal-orange']).describe('The effects of live\'s Effects tab (#265), all 102, in its order within each kind, by the\nslugs of live\'s keys (`fadeIn` is `fade-in`; spec docs/specs/editor/effects.md).');

export type EffectKind = zod.input<typeof EffectKind>;
export type EffectKindOutput = zod.output<typeof EffectKind>;

export const assistAddEffectRefRegExp = new RegExp('^@[A-Za-z0-9_-]{1,32}$');


export const AssistAddEffect = zod.object({
  "effect": EffectKind,
  "ref": zod.string().regex(assistAddEffectRefRegExp),
  "type": zod.enum(['add_effect'])
}).describe('Live\'s effect, from 0 to 5 s on a new effect track above the others (`addEffect`).');

export type AssistAddEffect = zod.input<typeof AssistAddEffect>;
export type AssistAddEffectOutput = zod.output<typeof AssistAddEffect>;

export const TransitionKind = zod.enum(['bounce', 'cross-zoom', 'directional-slide', 'dreamy-zoom', 'mosaic-slide', 'simple-zoom', 'zoom-in-circles', 'directional-warp', 'rotate-scale-fade', 'dynamic-zoom-in', 'dynamic-zoom-out', 'spin-360', 'spin-reverse', 'whip-pan-right', 'whip-pan-left', 'whip-pan-up', 'whip-pan-down', 'crash-zoom-spin', 'pendulum-swing', 'snap-push-in', 'film-burn', 'burn', 'color-phase', 'fade-through-color', 'undulating-burn-out', 'flash-white', 'flash-black', 'exposure-spike', 'prismatic-light-leak', 'neon-strobe-burn', 'supernova-burst', 'dreamy', 'linear-blur', 'morph', 'radial-zoom-blur', 'lens-defocus', 'directional-motion-blur', 'hexagonal-bokeh-blur', 'tilt-shift-morph', 'inverted-page-curl', 'stereo-viewer', '3d-cube', 'doorway', 'swap', '3d-card-flip', '3d-page-turn', '3d-origami-fold', '3d-flip-up', '3d-cube-spin', 'glitch-displace', 'glitch-memories', 'pixelize', 'random-squares', 'rgb-split', 'vhs-tracking', 'digital-block-tear', 'vhs-rewind', 'matrix-pixel-rain', 'butterfly-wave', 'crazy-parametric', 'swirl', 'water-drop', 'cross-warp', 'displacement-map', 'fly-eye', 'kaleidoscope', 'perlin-noise', 'ripple', 'water-ripple', 'black-hole-vortex', 'refractive-shockwave', 'liquid-slime-melt', 'advanced-mosaic', 'block-dissolve', 'book-flip', 'box', 'defocus-blur', 'directional-scaled', 'edge-transition', 'fold', 'hsvfade', 'horizontal-close', 'horizontal-open', 'left-right', 'overexposure', 'rectangle', 'rectangle-crop', 'simple-flip', 'star-wipe', 'static-fade', 'tvstatic', 'top-bottom', 'vertical-close', 'vertical-open', 'zoom-left-wipe', 'zoom-rigth-wipe', 'chessboard', 'coord-from-in', 'directional-easing', 'fade', 'fade-to-grayscale', 'fragment', 'luma-matte', 'luminance-melt', 'mosaic-transition', 'multiply-blend', 'parametric-glitch', 'power-kaleido', 'random-noisex', 'tangent-motion-blur', 'x-axis-translation', 'zoom-in-out', 'smooth-film-dissolve', 'luma-glow-reveal', 'additive-light-dissolve', 'bow-tie-horizontal', 'bow-tie-vertical', 'directional-wipe', 'squares-wire', 'window-blinds', 'window-slice', 'wipe-down', 'wipe-left', 'wipe-right', 'wipe-up', 'diagonal-slice', 'curtain-split', 'cross-split', 'multi-stripe-slice', 'radial-clock-wipe', 'venetian-blinds', 'circle-crop', 'grid-flip', 'polka-dots-curtain', 'radial-wipe', 'angular', 'circle', 'circle-open', 'crosshatch', 'heart', 'hexagonalize', 'pinwheel', 'polar-function', 'iris-circle', 'diamond-iris', 'star-reveal', 'heart-iris-mask', 'concentric-rings', 'hexagon-iris', 'radial-swipe', 'colour-distance', 'doom', 'cannabis-leaf', 'squeeze', 'pop-art-halftone', 'painterly-brush-stroke', 'sci-fi-laser-scan']).describe('The transitions of live\'s Transitions tab (#240), all 157, in its order, by the slugs of\nlive\'s names: the `gl-transitions` shaders live draws, and live\'s own as the editor writes\nthem.');

export type TransitionKind = zod.input<typeof TransitionKind>;
export type TransitionKindOutput = zod.output<typeof TransitionKind>;

export const assistSetTransitionDurationMsOneMin = 100;
export const assistSetTransitionDurationMsOneMax = 300000;

export const assistSetTransitionFromClipIdOneRegExp = new RegExp('^[A-Za-z0-9_-]{1,64}$');
export const assistSetTransitionFromClipIdTwoRegExp = new RegExp('^@[A-Za-z0-9_-]{1,32}$');
export const assistSetTransitionToClipIdOneRegExp = new RegExp('^[A-Za-z0-9_-]{1,64}$');
export const assistSetTransitionToClipIdTwoRegExp = new RegExp('^@[A-Za-z0-9_-]{1,32}$');


export const AssistSetTransition = zod.object({
  "duration_ms": zod.union([zod.int().min(assistSetTransitionDurationMsOneMin).max(assistSetTransitionDurationMsOneMax),zod.null()]).exactOptional(),
  "from_clip_id": zod.union([zod.string().regex(assistSetTransitionFromClipIdOneRegExp),zod.string().regex(assistSetTransitionFromClipIdTwoRegExp)]),
  "kind": TransitionKind,
  "to_clip_id": zod.union([zod.string().regex(assistSetTransitionToClipIdOneRegExp),zod.string().regex(assistSetTransitionToClipIdTwoRegExp)]),
  "type": zod.enum(['set_transition'])
}).describe('A transition on the cut from `from_clip_id` to `to_clip_id`, the next picture of its\ntrack: its kind, and its length where given (`setTransition`).');

export type AssistSetTransition = zod.input<typeof AssistSetTransition>;
export type AssistSetTransitionOutput = zod.output<typeof AssistSetTransition>;

export const assistRemoveTransitionTransitionIdRegExp = new RegExp('^[A-Za-z0-9_-]{1,64}$');


export const AssistRemoveTransition = zod.object({
  "transition_id": zod.string().regex(assistRemoveTransitionTransitionIdRegExp),
  "type": zod.enum(['remove_transition'])
});

export type AssistRemoveTransition = zod.input<typeof AssistRemoveTransition>;
export type AssistRemoveTransitionOutput = zod.output<typeof AssistRemoveTransition>;

export const AssistAutoCaptions = zod.object({
  "type": zod.enum(['auto_captions'])
}).describe('Live\'s Auto Captions skill (`auto-caption`): the spoken words of the timeline\'s videos and\nsounds transcribed and put on as captions, replacing every caption, as the editor\'s own\nGenerate captions makes them (free, `caption.transcribe`); the editor runs it once the plan\'s\nother edits are made. It takes nothing else, as live\'s skill takes nothing.');

export type AssistAutoCaptions = zod.input<typeof AssistAutoCaptions>;
export type AssistAutoCaptionsOutput = zod.output<typeof AssistAutoCaptions>;

export const assistRemoveCaptionsFromMsOneMin = 0;
export const assistRemoveCaptionsFromMsOneMax = 300000;

export const assistRemoveCaptionsToMsOneMin = 0;
export const assistRemoveCaptionsToMsOneMax = 300000;



export const AssistRemoveCaptions = zod.object({
  "from_ms": zod.union([zod.int().min(assistRemoveCaptionsFromMsOneMin).max(assistRemoveCaptionsFromMsOneMax),zod.null()]).exactOptional(),
  "to_ms": zod.union([zod.int().min(assistRemoveCaptionsToMsOneMin).max(assistRemoveCaptionsToMsOneMax),zod.null()]).exactOptional(),
  "type": zod.enum(['remove_captions'])
}).describe('Removes captions, live\'s Delete captions and its `clip.remove` on caption clips: every\nunlocked caption, or, with `from_ms` and `to_ms`, each unlocked one shown between them (it\nends after `from_ms` and starts before `to_ms`). The caption track stays.');

export type AssistRemoveCaptions = zod.input<typeof AssistRemoveCaptions>;
export type AssistRemoveCaptionsOutput = zod.output<typeof AssistRemoveCaptions>;

export const assistRoughCutFillersDefault = true;
export const assistRoughCutMinSilenceMsDefault = 500;
export const assistRoughCutMinSilenceMsMin = 200;
export const assistRoughCutMinSilenceMsMax = 5000;

export const assistRoughCutPaddingMsDefault = 200;
export const assistRoughCutPaddingMsMin = 0;
export const assistRoughCutPaddingMsMax = 1000;



export const AssistRoughCut = zod.object({
  "fillers": zod.boolean().default(assistRoughCutFillersDefault),
  "min_silence_ms": zod.int().min(assistRoughCutMinSilenceMsMin).max(assistRoughCutMinSilenceMsMax).default(assistRoughCutMinSilenceMsDefault),
  "padding_ms": zod.int().min(assistRoughCutPaddingMsMin).max(assistRoughCutPaddingMsMax).default(assistRoughCutPaddingMsDefault),
  "type": zod.enum(['rough_cut'])
}).describe('Live\'s Rough Cut (its prompt shortcut, "Create a rough cut from all the uploaded media clips,\nremoving silences"; video-editor-utils\' silence trim and filler cut read for behaviour, spec\nassistant-rough-cut): the pauses in the speech, and with `fillers` its filler words, taken out\nof every track by the captions\' word times, the rest closed up. A pause is a gap of at least\n`min_silence_ms` between two words, cut `padding_ms` short of each; live\'s are 500 and 200. The\neditor makes it after the plan\'s other edits and its Auto Captions, once a plan.');

export type AssistRoughCut = zod.input<typeof AssistRoughCut>;
export type AssistRoughCutOutput = zod.output<typeof AssistRoughCut>;

export const assistSearchLibraryLimitDefault = 1;
export const assistSearchLibraryLimitMax = 10;

export const assistSearchLibraryQueryMax = 100;


export const assistSearchLibraryQueryRegExp = new RegExp('[^\\t\\n\\v\\f\\r \\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000\\ufeff]');


export const AssistSearchLibrary = zod.object({
  "kind": zod.union([zod.enum(['image', 'video']),zod.null()]).exactOptional(),
  "limit": zod.int().min(1).max(assistSearchLibraryLimitMax).default(assistSearchLibraryLimitDefault),
  "query": zod.string().min(1).max(assistSearchLibraryQueryMax).regex(assistSearchLibraryQueryRegExp),
  "type": zod.enum(['search_library'])
}).describe('Live\'s `search_gallery_assets` (its Director\'s tool; spec assistant-search): the brand\'s\nlibrary searched by what its files show (S3\'s index), for `limit` files, 1 by default as\nlive\'s, of `kind` or of both. The editor runs it as the user and asks again with the files\nfound first in `media`; a plan that searches holds its searches alone, at most five.');

export type AssistSearchLibrary = zod.input<typeof AssistSearchLibrary>;
export type AssistSearchLibraryOutput = zod.output<typeof AssistSearchLibrary>;

export const EditAspect = zod.enum(['16:9', '9:16', '1:1', '4:5', '4:3', '21:9']).describe('The frame of the video: live\'s ratio menu\'s six (`canvas-panel.tsx`, E1 decision 21).');

export type EditAspect = zod.input<typeof EditAspect>;
export type EditAspectOutput = zod.output<typeof EditAspect>;

export const AssistSetAspect = zod.object({
  "aspect": EditAspect,
  "type": zod.enum(['set_aspect'])
}).describe('The project\'s frame shape (live\'s ratio menu, `setAspect`; G11 PR 2c): one undo step,\nevery item keeping its place and size in pixels.');

export type AssistSetAspect = zod.input<typeof AssistSetAspect>;
export type AssistSetAspectOutput = zod.output<typeof AssistSetAspect>;

export const AssistAction = zod.union([AssistMoveClip,AssistTrimStart,AssistTrimEnd,AssistSetRange,AssistSetClip,AssistSetLook,AssistSetTextStyle,AssistAddAnimation,AssistRemoveAnimations,AssistSetEffectValues,AssistRemoveClip,AssistSplit,AssistDuplicate,AssistSeparateAudio,AssistSetLock,AssistAddTitle,AssistAddClip,AssistAddEffect,AssistSetTransition,AssistRemoveTransition,AssistAutoCaptions,AssistRemoveCaptions,AssistRoughCut,AssistSearchLibrary,AssistSetAspect]);

export type AssistAction = zod.input<typeof AssistAction>;
export type AssistActionOutput = zod.output<typeof AssistAction>;

export const JobErrorCode = zod.enum(['vendor_ambiguous', 'vendor_failed', 'vendor_rejected', 'vendor_unavailable', 'insufficient_credits', 'deadline_exceeded', 'no_output', 'canceled', 'unfit_answer', 'shot_concepts_failed', 'image_analysis_failed', 'analysis_no_structure', 'ad_copy_failed', 'motion_prompt_failed', 'motion_prompt_empty', 'person_swap_failed', 'revoice_failed', 'transcript_failed', 'no_speech', 'markup_failed', 'speech_failed', 'clip_failed', 'word_check_failed', 'stitch_failed', 'captions_failed', 'audio_extraction_failed', 'talking_head_failed', 'background_removal_failed', 'hourly_limit', 'step_refused', 'dubbing_failed', 'lip_sync_failed', 'spec_failed', 'keyframe_failed', 'title_failed', 'clip_blocked', 'frame_refused', 'end_card_refused', 'source_too_large', 'source_unreadable', 'render_failed', 'clip_refused', 'join_failed', 'music_failed', 'voice_under_failed', 'backdrop_key_failed', 'composite_failed', 'clips_stopped', 'no_heard_words', 'bubble_failed', 'unused']).describe('Why a job or an output failed. Each has one sentence a user may read (`JOB_ERRORS`).');

export type JobErrorCode = zod.input<typeof JobErrorCode>;
export type JobErrorCodeOutput = zod.output<typeof JobErrorCode>;

export const JobError = zod.object({
  "code": JobErrorCode,
  "message": zod.string()
}).describe('Why a job or an output failed, in a sentence a user may read.');

export type JobError = zod.input<typeof JobError>;
export type JobErrorOutput = zod.output<typeof JobError>;

export const assistStepActionsMax = 20;

export const assistStepDescriptionMax = 500;

export const assistStepIdMax = 64;



export const AssistStep = zod.object({
  "actions": zod.array(AssistAction).min(1).max(assistStepActionsMax),
  "description": zod.string().min(1).max(assistStepDescriptionMax),
  "id": zod.string().min(1).max(assistStepIdMax)
}).describe('One step of a plan: what it does, as the panel shows it, and its edits, applied in order\nas one undoable step of the editor.');

export type AssistStep = zod.input<typeof AssistStep>;
export type AssistStepOutput = zod.output<typeof AssistStep>;

export const assistPlanGoalMax = 500;

export const assistPlanStepsDefault = [];
export const assistPlanStepsMax = 30;

export const assistPlanSummaryMax = 16000;



export const AssistPlan = zod.object({
  "goal": zod.string().max(assistPlanGoalMax),
  "steps": zod.array(AssistStep).max(assistPlanStepsMax).default(assistPlanStepsDefault),
  "summary": zod.string().min(1).max(assistPlanSummaryMax)
}).describe('An `editor.assist` job\'s answer (live\'s Director plan): its goal, the answer the panel\nshows first (markdown), and its steps; no steps is a chat answer. Each `ref` is made once.');

export type AssistPlan = zod.input<typeof AssistPlan>;
export type AssistPlanOutput = zod.output<typeof AssistPlan>;

export const AssistAnswer = zod.object({
  "created_at": zod.iso.datetime({"offset":true}),
  "error": zod.union([JobError,zod.null()]),
  "finished_at": zod.union([zod.iso.datetime({"offset":true}),zod.null()]),
  "job_id": zod.uuid(),
  "plan": zod.union([AssistPlan,zod.null()]),
  "project_id": zod.uuid(),
  "project_version": zod.int(),
  "status": JobStatus
}).describe('One answer of the assistant: its job, the saved version it is about, and, once the job\nsucceeded, its plan. Its status arrives as the job\'s events; refetch this then.');

export type AssistAnswer = zod.input<typeof AssistAnswer>;
export type AssistAnswerOutput = zod.output<typeof AssistAnswer>;

export const AssistMediaKind = zod.enum(['video', 'image', 'audio']);

export type AssistMediaKind = zod.input<typeof AssistMediaKind>;
export type AssistMediaKindOutput = zod.output<typeof AssistMediaKind>;

export const assistMediaDurationMsOneMin = 0;
export const assistMediaDurationMsOneMax = 300000;

export const assistMediaNameMax = 200;



export const AssistMedia = zod.object({
  "duration_ms": zod.union([zod.int().min(assistMediaDurationMsOneMin).max(assistMediaDurationMsOneMax),zod.null()]).exactOptional(),
  "kind": AssistMediaKind,
  "name": zod.string().min(1).max(assistMediaNameMax),
  "source": SourceRef
}).describe('A file the panel offers the assistant to add (live\'s `availableAssets`): its source, as a\nclip names it, what the editor shows it as, its kind, and a video\'s or a sound\'s length. Prompt\ntext only: the server neither reads nor checks the file, and the editor adds only a file it\noffered.');

export type AssistMedia = zod.input<typeof AssistMedia>;
export type AssistMediaOutput = zod.output<typeof AssistMedia>;

export const AssistRole = zod.enum(['user', 'assistant']);

export type AssistRole = zod.input<typeof AssistRole>;
export type AssistRoleOutput = zod.output<typeof AssistRole>;

export const AssistStepStatus = zod.enum(['done', 'failed']).describe('How a plan\'s step ended in the editor: applied, or refused (and the plan stopped there).');

export type AssistStepStatus = zod.input<typeof AssistStepStatus>;
export type AssistStepStatusOutput = zod.output<typeof AssistStepStatus>;

export const assistStepRecordDescriptionMax = 2000;


export const assistStepRecordDescriptionRegExp = new RegExp('[^\\t\\n\\v\\f\\r \\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000\\ufeff]');
export const assistStepRecordStepIdMax = 64;



export const AssistStepRecord = zod.object({
  "description": zod.string().min(1).max(assistStepRecordDescriptionMax).regex(assistStepRecordDescriptionRegExp),
  "status": AssistStepStatus,
  "step_id": zod.string().min(1).max(assistStepRecordStepIdMax)
}).describe('A plan step\'s row, as live saves it (`tools`): which step of the plan, what it did, and how\nit ended.');

export type AssistStepRecord = zod.input<typeof AssistStepRecord>;
export type AssistStepRecordOutput = zod.output<typeof AssistStepRecord>;

export const AssistMessage = zod.object({
  "content": zod.string(),
  "created_at": zod.iso.datetime({"offset":true}),
  "created_by": zod.uuid(),
  "id": zod.uuid(),
  "role": AssistRole,
  "step": zod.union([AssistStepRecord,zod.null()])
});

export type AssistMessage = zod.input<typeof AssistMessage>;
export type AssistMessageOutput = zod.output<typeof AssistMessage>;

export const assistMessageCreateContentMax = 32000;


export const assistMessageCreateContentRegExp = new RegExp('[^\\t\\n\\v\\f\\r \\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000\\ufeff]');


export const AssistMessageCreate = zod.object({
  "content": zod.string().min(1).max(assistMessageCreateContentMax).regex(assistMessageCreateContentRegExp),
  "role": AssistRole,
  "step": zod.union([AssistStepRecord,zod.null()]).exactOptional()
}).describe('`POST .../assistant/messages`: one message of the chat, appended. `content` is the\nuser\'s message or the assistant\'s markdown; a step\'s row is the assistant\'s.');

export type AssistMessageCreate = zod.input<typeof AssistMessageCreate>;
export type AssistMessageCreateOutput = zod.output<typeof AssistMessageCreate>;

export const AssistMessagePage = zod.object({
  "items": zod.array(AssistMessage),
  "next": zod.union([zod.string(),zod.null()])
}).describe('The chat, newest first; `next` is the cursor of older messages.');

export type AssistMessagePage = zod.input<typeof AssistMessagePage>;
export type AssistMessagePageOutput = zod.output<typeof AssistMessagePage>;

export const assistTurnTextMax = 3000;



export const AssistTurn = zod.object({
  "role": AssistRole,
  "text": zod.string().min(1).max(assistTurnTextMax)
}).describe('An earlier turn of the chat: the user\'s message or the assistant\'s answer summary.');

export type AssistTurn = zod.input<typeof AssistTurn>;
export type AssistTurnOutput = zod.output<typeof AssistTurn>;

export const assistRequestHistoryDefault = [];
export const assistRequestHistoryMax = 20;

export const assistRequestLabelsMaxOne = 200;

export const assistRequestLabelsDefault = {};
export const assistRequestMediaDefault = [];
export const assistRequestMediaMax = 50;

export const assistRequestMessageMax = 4000;


export const assistRequestMessageRegExp = new RegExp('[^\\t\\n\\v\\f\\r \\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000\\ufeff]');
export const assistRequestVersionMax = 9007199254740991;



export const AssistRequest = zod.object({
  "history": zod.array(AssistTurn).max(assistRequestHistoryMax).default(assistRequestHistoryDefault),
  "labels": zod.record(zod.string(), zod.string().max(assistRequestLabelsMaxOne)).default(assistRequestLabelsDefault),
  "media": zod.array(AssistMedia).max(assistRequestMediaMax).default(assistRequestMediaDefault),
  "message": zod.string().min(1).max(assistRequestMessageMax).regex(assistRequestMessageRegExp),
  "version": zod.int().min(1).max(assistRequestVersionMax)
}).describe('`POST .../assistant/answers`: a message about the saved `version` of the project, what the\neditor shows each picture or sound as (`labels`, by clip id), the files it may add (`media`,\nG11 PR 2), and the chat\'s last turns, oldest first. Another version is 409\n`VERSION_CONFLICT`.');

export type AssistRequest = zod.input<typeof AssistRequest>;
export type AssistRequestOutput = zod.output<typeof AssistRequest>;

export const SpeedCurveName = zod.enum(['montage', 'hero', 'bullet', 'jump_cut', 'flash_in', 'flash_out', 'custom']).describe('Which curve a clip plays: one of our six presets, drawn to CapCut\'s names, or its own\n(spec clip-speed-curves, decision 1). It names the Curve tab\'s pressed tile and the badge.');

export type SpeedCurveName = zod.input<typeof SpeedCurveName>;
export type SpeedCurveNameOutput = zod.output<typeof SpeedCurveName>;

export const speedPointAtSMin = 0;
export const speedPointAtSMax = 86400;

export const speedPointSpeedMin = 0.25;
export const speedPointSpeedMax = 4;



export const SpeedPoint = zod.object({
  "at_s": zod.number().min(speedPointAtSMin).max(speedPointAtSMax),
  "speed": zod.number().min(speedPointSpeedMin).max(speedPointSpeedMax)
}).describe('A clip\'s speed at a time of its own file (spec clip-speed-curves). Between two points the\nspeed is a straight line in log speed; it is held flat before the first and after the last.');

export type SpeedPoint = zod.input<typeof SpeedPoint>;
export type SpeedPointOutput = zod.output<typeof SpeedPoint>;

export const volumePointAtSMin = 0;
export const volumePointAtSMax = 86400;

export const volumePointVolumeMin = 0;
export const volumePointVolumeMax = 2;



export const VolumePoint = zod.object({
  "at_s": zod.number().min(volumePointAtSMin).max(volumePointAtSMax),
  "volume": zod.number().min(volumePointVolumeMin).max(volumePointVolumeMax)
}).describe('A clip\'s level at a time of its own file (spec volume-keyframes). The straight line through\na clip\'s points is its level, held flat before the first and after the last.');

export type VolumePoint = zod.input<typeof VolumePoint>;
export type VolumePointOutput = zod.output<typeof VolumePoint>;

export const audioClipBeatsMsItemMin = 0;
export const audioClipBeatsMsItemMax = 86400000;

export const audioClipBeatsMsDefault = [];
export const audioClipBeatsMsMax = 2000;

export const audioClipEndSMin = 0;
export const audioClipEndSMax = 300;

export const audioClipFadeInMsDefault = 0;
export const audioClipFadeInMsMin = 0;
export const audioClipFadeInMsMax = 5000;

export const audioClipFadeOutMsDefault = 0;
export const audioClipFadeOutMsMin = 0;
export const audioClipFadeOutMsMax = 5000;

export const audioClipHiddenDefault = false;
export const audioClipIdRegExp = new RegExp('^[A-Za-z0-9_-]{1,64}$');
export const audioClipInSDefault = 0;
export const audioClipInSMin = 0;
export const audioClipInSMax = 86400;

export const audioClipLockedDefault = false;
export const audioClipMutedDefault = false;
export const audioClipSpeedDefault = 1;
export const audioClipSpeedMin = 0.25;
export const audioClipSpeedMax = 4;

export const audioClipSpeedPointsDefault = [];
export const audioClipSpeedPointsMax = 16;

export const audioClipStartSMin = 0;
export const audioClipStartSMax = 300;

export const audioClipTrackIdRegExp = new RegExp('^[A-Za-z0-9_-]{1,64}$');
export const audioClipVolumeDefault = 1;
export const audioClipVolumeMin = 0;
export const audioClipVolumeMax = 2;

export const audioClipVolumePointsDefault = [];
export const audioClipVolumePointsMax = 100;



export const AudioClip = zod.object({
  "beats_ms": zod.array(zod.int().min(audioClipBeatsMsItemMin).max(audioClipBeatsMsItemMax)).max(audioClipBeatsMsMax).default(audioClipBeatsMsDefault),
  "end_s": zod.number().min(audioClipEndSMin).max(audioClipEndSMax),
  "fade_in_ms": zod.int().min(audioClipFadeInMsMin).max(audioClipFadeInMsMax).default(audioClipFadeInMsDefault),
  "fade_out_ms": zod.int().min(audioClipFadeOutMsMin).max(audioClipFadeOutMsMax).default(audioClipFadeOutMsDefault),
  "hidden": zod.boolean().default(audioClipHiddenDefault),
  "id": zod.string().regex(audioClipIdRegExp),
  "in_s": zod.number().min(audioClipInSMin).max(audioClipInSMax).default(audioClipInSDefault),
  "kind": zod.enum(['audio']),
  "locked": zod.boolean().default(audioClipLockedDefault),
  "muted": zod.boolean().default(audioClipMutedDefault),
  "source": SourceRef,
  "speed": zod.number().min(audioClipSpeedMin).max(audioClipSpeedMax).default(audioClipSpeedDefault),
  "speed_curve": zod.union([SpeedCurveName,zod.null()]).exactOptional(),
  "speed_points": zod.array(SpeedPoint).max(audioClipSpeedPointsMax).default(audioClipSpeedPointsDefault),
  "start_s": zod.number().min(audioClipStartSMin).max(audioClipStartSMax),
  "track_id": zod.string().regex(audioClipTrackIdRegExp),
  "volume": zod.number().min(audioClipVolumeMin).max(audioClipVolumeMax).default(audioClipVolumeDefault),
  "volume_points": zod.array(VolumePoint).max(audioClipVolumePointsMax).default(audioClipVolumePointsDefault)
}).describe('A sound read from `in_s` of its own time at `speed`, heard unless `muted` (live\'s Mute). Its\nbeats (spec beats.md) are times in its own file, kept whatever span it reads: one outside it is\nnot shown, and a trim back shows it again.');

export type AudioClip = zod.input<typeof AudioClip>;
export type AudioClipOutput = zod.output<typeof AudioClip>;

export const audioExtractQuoteExpectedQuoteMaxOneMin = 0;

export const audioExtractQuoteModelMax = 64;


export const audioExtractQuoteModelRegExp = new RegExp('^[a-z0-9][a-z0-9.-]*$');
export const audioExtractQuoteOutputsDefault = 1;
export const audioExtractQuoteOutputsMax = 1;



export const AudioExtractQuote = zod.object({
  "expected_quote_max": zod.union([zod.int().min(audioExtractQuoteExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "model": zod.string().max(audioExtractQuoteModelMax).regex(audioExtractQuoteModelRegExp).describe('A catalog model id.'),
  "outputs": zod.int().min(1).max(audioExtractQuoteOutputsMax).default(audioExtractQuoteOutputsDefault),
  "source_video": SourceRef,
  "type": zod.enum(['audio.extract'])
}).describe('An `AudioExtractRequest` to price: the same body, since it has no prompt.');

export type AudioExtractQuote = zod.input<typeof AudioExtractQuote>;
export type AudioExtractQuoteOutput = zod.output<typeof AudioExtractQuote>;

export const audioExtractRequestExpectedQuoteMaxOneMin = 0;

export const audioExtractRequestModelMax = 64;


export const audioExtractRequestModelRegExp = new RegExp('^[a-z0-9][a-z0-9.-]*$');
export const audioExtractRequestOutputsDefault = 1;
export const audioExtractRequestOutputsMax = 1;



export const AudioExtractRequest = zod.object({
  "expected_quote_max": zod.union([zod.int().min(audioExtractRequestExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "model": zod.string().max(audioExtractRequestModelMax).regex(audioExtractRequestModelRegExp).describe('A catalog model id.'),
  "outputs": zod.int().min(1).max(audioExtractRequestOutputsMax).default(audioExtractRequestOutputsDefault),
  "source_video": SourceRef,
  "type": zod.enum(['audio.extract'])
}).describe('A video\'s sound as an MP3 (live\'s `EXTRACT_AUDIO`): the catalog row (`model`) and the\nvideo, an earlier output or a library video. One output.');

export type AudioExtractRequest = zod.input<typeof AudioExtractRequest>;
export type AudioExtractRequestOutput = zod.output<typeof AudioExtractRequest>;

export const audioLimitsCombinedMaxDurationSecOneExclusiveMin = 0;

export const audioLimitsMaxDurationSecOneExclusiveMin = 0;

export const audioLimitsMaxSizeMbOneExclusiveMin = 0;

export const audioLimitsMinDurationSecOneMin = 0;



export const AudioLimits = zod.object({
  "accepted_formats": zod.union([zod.array(zod.string()),zod.null()]).exactOptional(),
  "combined_max_duration_sec": zod.union([zod.number().gt(audioLimitsCombinedMaxDurationSecOneExclusiveMin),zod.null()]).exactOptional(),
  "max_duration_sec": zod.union([zod.number().gt(audioLimitsMaxDurationSecOneExclusiveMin),zod.null()]).exactOptional(),
  "max_size_mb": zod.union([zod.number().gt(audioLimitsMaxSizeMbOneExclusiveMin),zod.null()]).exactOptional(),
  "min_duration_sec": zod.union([zod.number().min(audioLimitsMinDurationSecOneMin),zod.null()]).exactOptional()
}).describe('Live\'s `audio_input`: what an audio in a slot must be, and all of a job\'s together\n(#258).');

export type AudioLimits = zod.input<typeof AudioLimits>;
export type AudioLimitsOutput = zod.output<typeof AudioLimits>;

export const AudioMode = zod.enum(['toggle', 'always', 'none']).describe('Live\'s sound switch: a toggle (sound or silence), always on (the switch locked on), or no\nsound (the switch hidden).');

export type AudioMode = zod.input<typeof AudioMode>;
export type AudioModeOutput = zod.output<typeof AudioMode>;

export const audioMusicQuoteDurationSecondsOneMax = 600;

export const audioMusicQuoteExpectedQuoteMaxOneMin = 0;

export const audioMusicQuoteModelMax = 64;


export const audioMusicQuoteModelRegExp = new RegExp('^[a-z0-9][a-z0-9.-]*$');
export const audioMusicQuoteOutputsDefault = 1;
export const audioMusicQuoteOutputsMax = 1;

export const audioMusicQuotePromptDefault = ``;
export const audioMusicQuotePromptMax = 32000;

export const audioMusicQuoteReferenceImagesMax = 10;

export const audioMusicQuoteSeedOneMin = 0;
export const audioMusicQuoteSeedOneMax = 4294967295;



export const AudioMusicQuote = zod.object({
  "duration_seconds": zod.union([zod.int().min(1).max(audioMusicQuoteDurationSecondsOneMax),zod.null()]).exactOptional(),
  "expected_quote_max": zod.union([zod.int().min(audioMusicQuoteExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "force_instrumental": zod.union([zod.boolean(),zod.null()]).exactOptional(),
  "model": zod.string().max(audioMusicQuoteModelMax).regex(audioMusicQuoteModelRegExp).describe('A catalog model id.'),
  "outputs": zod.int().min(1).max(audioMusicQuoteOutputsMax).default(audioMusicQuoteOutputsDefault),
  "prompt": zod.string().max(audioMusicQuotePromptMax).default(audioMusicQuotePromptDefault),
  "reference_images": zod.array(SourceRef).max(audioMusicQuoteReferenceImagesMax).exactOptional(),
  "seed": zod.union([zod.int().min(audioMusicQuoteSeedOneMin).max(audioMusicQuoteSeedOneMax),zod.null()]).exactOptional(),
  "type": zod.enum(['audio.music'])
}).describe('An `AudioMusicRequest` to price; its prompt may be empty.');

export type AudioMusicQuote = zod.input<typeof AudioMusicQuote>;
export type AudioMusicQuoteOutput = zod.output<typeof AudioMusicQuote>;

export const audioMusicRequestDurationSecondsOneMax = 600;

export const audioMusicRequestExpectedQuoteMaxOneMin = 0;

export const audioMusicRequestModelMax = 64;


export const audioMusicRequestModelRegExp = new RegExp('^[a-z0-9][a-z0-9.-]*$');
export const audioMusicRequestOutputsDefault = 1;
export const audioMusicRequestOutputsMax = 1;

export const audioMusicRequestPromptMax = 32000;


export const audioMusicRequestPromptRegExp = new RegExp('[^\\t\\n\\v\\f\\r \\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000\\ufeff]');
export const audioMusicRequestReferenceImagesMax = 10;

export const audioMusicRequestSeedOneMin = 0;
export const audioMusicRequestSeedOneMax = 4294967295;



export const AudioMusicRequest = zod.object({
  "duration_seconds": zod.union([zod.int().min(1).max(audioMusicRequestDurationSecondsOneMax),zod.null()]).exactOptional(),
  "expected_quote_max": zod.union([zod.int().min(audioMusicRequestExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "force_instrumental": zod.union([zod.boolean(),zod.null()]).exactOptional(),
  "model": zod.string().max(audioMusicRequestModelMax).regex(audioMusicRequestModelRegExp).describe('A catalog model id.'),
  "outputs": zod.int().min(1).max(audioMusicRequestOutputsMax).default(audioMusicRequestOutputsDefault),
  "prompt": zod.string().min(1).max(audioMusicRequestPromptMax).regex(audioMusicRequestPromptRegExp),
  "reference_images": zod.array(SourceRef).max(audioMusicRequestReferenceImagesMax).exactOptional(),
  "seed": zod.union([zod.int().min(audioMusicRequestSeedOneMin).max(audioMusicRequestSeedOneMax),zod.null()]).exactOptional(),
  "type": zod.enum(['audio.music'])
}).describe('Music from a prompt; a length only where the model takes one (`exact_seconds`), and a\nseed and up to 10 images to match (earlier outputs or library images, in order) only where\nit takes them (Lyria).');

export type AudioMusicRequest = zod.input<typeof AudioMusicRequest>;
export type AudioMusicRequestOutput = zod.output<typeof AudioMusicRequest>;

export const AudioParams = zod.object({
  "duration_seconds": zod.union([zod.number(),zod.null()]).exactOptional(),
  "force_instrumental": zod.union([zod.boolean(),zod.null()]).exactOptional(),
  "language_code": zod.union([zod.string(),zod.null()]).exactOptional(),
  "loop": zod.union([zod.boolean(),zod.null()]).exactOptional(),
  "prompt_influence": zod.union([zod.number(),zod.null()]).exactOptional(),
  "seed": zod.union([zod.int(),zod.null()]).exactOptional(),
  "stability": zod.union([zod.number(),zod.null()]).exactOptional(),
  "voice_id": zod.union([zod.uuid(),zod.null()]).exactOptional()
}).describe('A sound job\'s options, with the model\'s defaults applied; each None where its type has\nnone.');

export type AudioParams = zod.input<typeof AudioParams>;
export type AudioParamsOutput = zod.output<typeof AudioParams>;

export const audioSfxQuoteDurationSecondsOneExclusiveMin = 0;
export const audioSfxQuoteDurationSecondsOneMax = 600;

export const audioSfxQuoteExpectedQuoteMaxOneMin = 0;

export const audioSfxQuoteModelMax = 64;


export const audioSfxQuoteModelRegExp = new RegExp('^[a-z0-9][a-z0-9.-]*$');
export const audioSfxQuoteOutputsDefault = 1;
export const audioSfxQuoteOutputsMax = 1;

export const audioSfxQuotePromptDefault = ``;
export const audioSfxQuotePromptMax = 32000;

export const audioSfxQuotePromptInfluenceOneMin = 0;
export const audioSfxQuotePromptInfluenceOneMax = 1;



export const AudioSfxQuote = zod.object({
  "duration_seconds": zod.union([zod.number().gt(audioSfxQuoteDurationSecondsOneExclusiveMin).max(audioSfxQuoteDurationSecondsOneMax),zod.null()]).exactOptional(),
  "expected_quote_max": zod.union([zod.int().min(audioSfxQuoteExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "loop": zod.union([zod.boolean(),zod.null()]).exactOptional(),
  "model": zod.string().max(audioSfxQuoteModelMax).regex(audioSfxQuoteModelRegExp).describe('A catalog model id.'),
  "outputs": zod.int().min(1).max(audioSfxQuoteOutputsMax).default(audioSfxQuoteOutputsDefault),
  "prompt": zod.string().max(audioSfxQuotePromptMax).default(audioSfxQuotePromptDefault),
  "prompt_influence": zod.union([zod.number().min(audioSfxQuotePromptInfluenceOneMin).max(audioSfxQuotePromptInfluenceOneMax),zod.null()]).exactOptional(),
  "type": zod.enum(['audio.sfx'])
}).describe('An `AudioSfxRequest` to price; its prompt may be empty.');

export type AudioSfxQuote = zod.input<typeof AudioSfxQuote>;
export type AudioSfxQuoteOutput = zod.output<typeof AudioSfxQuote>;

export const audioSfxRequestDurationSecondsOneExclusiveMin = 0;
export const audioSfxRequestDurationSecondsOneMax = 600;

export const audioSfxRequestExpectedQuoteMaxOneMin = 0;

export const audioSfxRequestModelMax = 64;


export const audioSfxRequestModelRegExp = new RegExp('^[a-z0-9][a-z0-9.-]*$');
export const audioSfxRequestOutputsDefault = 1;
export const audioSfxRequestOutputsMax = 1;

export const audioSfxRequestPromptMax = 32000;


export const audioSfxRequestPromptRegExp = new RegExp('[^\\t\\n\\v\\f\\r \\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000\\ufeff]');
export const audioSfxRequestPromptInfluenceOneMin = 0;
export const audioSfxRequestPromptInfluenceOneMax = 1;



export const AudioSfxRequest = zod.object({
  "duration_seconds": zod.union([zod.number().gt(audioSfxRequestDurationSecondsOneExclusiveMin).max(audioSfxRequestDurationSecondsOneMax),zod.null()]).exactOptional(),
  "expected_quote_max": zod.union([zod.int().min(audioSfxRequestExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "loop": zod.union([zod.boolean(),zod.null()]).exactOptional(),
  "model": zod.string().max(audioSfxRequestModelMax).regex(audioSfxRequestModelRegExp).describe('A catalog model id.'),
  "outputs": zod.int().min(1).max(audioSfxRequestOutputsMax).default(audioSfxRequestOutputsDefault),
  "prompt": zod.string().min(1).max(audioSfxRequestPromptMax).regex(audioSfxRequestPromptRegExp),
  "prompt_influence": zod.union([zod.number().min(audioSfxRequestPromptInfluenceOneMin).max(audioSfxRequestPromptInfluenceOneMax),zod.null()]).exactOptional(),
  "type": zod.enum(['audio.sfx'])
}).describe('A sound effect from a description. Each option left out takes the model\'s default.');

export type AudioSfxRequest = zod.input<typeof AudioSfxRequest>;
export type AudioSfxRequestOutput = zod.output<typeof AudioSfxRequest>;

export const audioTtsQuoteExpectedQuoteMaxOneMin = 0;

export const audioTtsQuoteLanguageCodeOneRegExp = new RegExp('^[a-z]{2}$');
export const audioTtsQuoteModelMax = 64;


export const audioTtsQuoteModelRegExp = new RegExp('^[a-z0-9][a-z0-9.-]*$');
export const audioTtsQuoteOutputsDefault = 1;
export const audioTtsQuoteOutputsMax = 1;

export const audioTtsQuotePromptDefault = ``;
export const audioTtsQuotePromptMax = 32000;

export const audioTtsQuoteStabilityOneMin = 0;
export const audioTtsQuoteStabilityOneMax = 1;



export const AudioTtsQuote = zod.object({
  "expected_quote_max": zod.union([zod.int().min(audioTtsQuoteExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "input_of": zod.union([zod.literal("video.lipsync"),zod.null()]).exactOptional().describe('The generation this speech is made for (`video.lipsync`): hidden from the lists, not saveable, and deleted with the last generation that uses it.'),
  "language_code": zod.union([zod.string().regex(audioTtsQuoteLanguageCodeOneRegExp),zod.null()]).exactOptional(),
  "model": zod.string().max(audioTtsQuoteModelMax).regex(audioTtsQuoteModelRegExp).describe('A catalog model id.'),
  "outputs": zod.int().min(1).max(audioTtsQuoteOutputsMax).default(audioTtsQuoteOutputsDefault),
  "prompt": zod.string().max(audioTtsQuotePromptMax).default(audioTtsQuotePromptDefault),
  "stability": zod.union([zod.number().min(audioTtsQuoteStabilityOneMin).max(audioTtsQuoteStabilityOneMax),zod.null()]).exactOptional(),
  "type": zod.enum(['audio.tts']),
  "voice_id": zod.union([zod.uuid(),zod.null()]).exactOptional()
}).describe('An `AudioTtsRequest` to price: speech is priced by its script\'s length, so the prompt\ncounts; the voice may be left out until one is chosen.');

export type AudioTtsQuote = zod.input<typeof AudioTtsQuote>;
export type AudioTtsQuoteOutput = zod.output<typeof AudioTtsQuote>;

export const audioTtsRequestExpectedQuoteMaxOneMin = 0;

export const audioTtsRequestLanguageCodeOneRegExp = new RegExp('^[a-z]{2}$');
export const audioTtsRequestModelMax = 64;


export const audioTtsRequestModelRegExp = new RegExp('^[a-z0-9][a-z0-9.-]*$');
export const audioTtsRequestOutputsDefault = 1;
export const audioTtsRequestOutputsMax = 1;

export const audioTtsRequestPromptMax = 32000;


export const audioTtsRequestPromptRegExp = new RegExp('[^\\t\\n\\v\\f\\r \\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000\\ufeff]');
export const audioTtsRequestStabilityOneMin = 0;
export const audioTtsRequestStabilityOneMax = 1;



export const AudioTtsRequest = zod.object({
  "expected_quote_max": zod.union([zod.int().min(audioTtsRequestExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "input_of": zod.union([zod.literal("video.lipsync"),zod.null()]).exactOptional().describe('The generation this speech is made for (`video.lipsync`): hidden from the lists, not saveable, and deleted with the last generation that uses it.'),
  "language_code": zod.union([zod.string().regex(audioTtsRequestLanguageCodeOneRegExp),zod.null()]).exactOptional(),
  "model": zod.string().max(audioTtsRequestModelMax).regex(audioTtsRequestModelRegExp).describe('A catalog model id.'),
  "outputs": zod.int().min(1).max(audioTtsRequestOutputsMax).default(audioTtsRequestOutputsDefault),
  "prompt": zod.string().min(1).max(audioTtsRequestPromptMax).regex(audioTtsRequestPromptRegExp),
  "stability": zod.union([zod.number().min(audioTtsRequestStabilityOneMin).max(audioTtsRequestStabilityOneMax),zod.null()]).exactOptional(),
  "type": zod.enum(['audio.tts']),
  "voice_id": zod.uuid()
}).describe('Speech: `voice_id` (a team or global voice, #220) reads the prompt.');

export type AudioTtsRequest = zod.input<typeof AudioTtsRequest>;
export type AudioTtsRequestOutput = zod.output<typeof AudioTtsRequest>;

export const audioVoiceoverQuoteExpectedQuoteMaxOneMin = 0;

export const audioVoiceoverQuoteModelMax = 64;


export const audioVoiceoverQuoteModelRegExp = new RegExp('^[a-z0-9][a-z0-9.-]*$');
export const audioVoiceoverQuoteOutputsDefault = 1;
export const audioVoiceoverQuoteOutputsMax = 1;

export const audioVoiceoverQuotePromptDefault = ``;
export const audioVoiceoverQuotePromptMax = 32000;

export const audioVoiceoverQuoteStabilityOneMin = 0;
export const audioVoiceoverQuoteStabilityOneMax = 1;



export const AudioVoiceoverQuote = zod.object({
  "expected_quote_max": zod.union([zod.int().min(audioVoiceoverQuoteExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "model": zod.string().max(audioVoiceoverQuoteModelMax).regex(audioVoiceoverQuoteModelRegExp).describe('A catalog model id.'),
  "outputs": zod.int().min(1).max(audioVoiceoverQuoteOutputsMax).default(audioVoiceoverQuoteOutputsDefault),
  "prompt": zod.string().max(audioVoiceoverQuotePromptMax).default(audioVoiceoverQuotePromptDefault),
  "stability": zod.union([zod.number().min(audioVoiceoverQuoteStabilityOneMin).max(audioVoiceoverQuoteStabilityOneMax),zod.null()]).exactOptional(),
  "type": zod.enum(['audio.voiceover']),
  "voice_id": zod.union([zod.uuid(),zod.null()]).exactOptional()
}).describe('An `AudioVoiceoverRequest` to price (free, as live\'s); the script and the voice may be\nleft out until they are written and chosen.');

export type AudioVoiceoverQuote = zod.input<typeof AudioVoiceoverQuote>;
export type AudioVoiceoverQuoteOutput = zod.output<typeof AudioVoiceoverQuote>;

export const audioVoiceoverRequestExpectedQuoteMaxOneMin = 0;

export const audioVoiceoverRequestModelMax = 64;


export const audioVoiceoverRequestModelRegExp = new RegExp('^[a-z0-9][a-z0-9.-]*$');
export const audioVoiceoverRequestOutputsDefault = 1;
export const audioVoiceoverRequestOutputsMax = 1;

export const audioVoiceoverRequestPromptMax = 32000;


export const audioVoiceoverRequestPromptRegExp = new RegExp('[^\\t\\n\\v\\f\\r \\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000\\ufeff]');
export const audioVoiceoverRequestStabilityOneMin = 0;
export const audioVoiceoverRequestStabilityOneMax = 1;



export const AudioVoiceoverRequest = zod.object({
  "expected_quote_max": zod.union([zod.int().min(audioVoiceoverRequestExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "model": zod.string().max(audioVoiceoverRequestModelMax).regex(audioVoiceoverRequestModelRegExp).describe('A catalog model id.'),
  "outputs": zod.int().min(1).max(audioVoiceoverRequestOutputsMax).default(audioVoiceoverRequestOutputsDefault),
  "prompt": zod.string().min(1).max(audioVoiceoverRequestPromptMax).regex(audioVoiceoverRequestPromptRegExp),
  "stability": zod.union([zod.number().min(audioVoiceoverRequestStabilityOneMin).max(audioVoiceoverRequestStabilityOneMax),zod.null()]).exactOptional(),
  "type": zod.enum(['audio.voiceover']),
  "voice_id": zod.uuid()
}).describe('A talking head\'s voiceover (#222, live\'s "Generate Audios"): `voice_id` (a team or\nglobal voice) reads the script, the prompt, for one actor. Free: the talking head\'s video\nis what is priced. Left out, the stability is the model\'s default (live\'s 0.7).');

export type AudioVoiceoverRequest = zod.input<typeof AudioVoiceoverRequest>;
export type AudioVoiceoverRequestOutput = zod.output<typeof AudioVoiceoverRequest>;

export const AuditAction = zod.enum(['team.create', 'credits.grant', 'credits.adjust', 'job.cancel', 'user.delete', 'ai_task.model_set', 'usage.trace_read']).describe('Every audited staff action (proposal 6.3, D7): each mutation, and each read of a team\'s\ncontent. A new one is a decision, not a route.');

export type AuditAction = zod.input<typeof AuditAction>;
export type AuditActionOutput = zod.output<typeof AuditAction>;

export const JsonValue = zod.unknown();

export type JsonValue = zod.input<typeof JsonValue>;
export type JsonValueOutput = zod.output<typeof JsonValue>;

export const JsonObject = zod.record(zod.string(), JsonValue);

export type JsonObject = zod.input<typeof JsonObject>;
export type JsonObjectOutput = zod.output<typeof JsonObject>;

export const AuditEntry = zod.object({
  "action": AuditAction,
  "actor_user_id": zod.uuid(),
  "created_at": zod.iso.datetime({"offset":true}),
  "id": zod.int(),
  "idempotency_key": zod.string(),
  "payload": JsonObject,
  "result": JsonObject,
  "target": JsonObject
}).describe('One audited staff action: who, what, on which target, and when. A mutation keeps the\nrequest as sent and the answer it got, under the staff client\'s `idempotency_key`, and a\nrepeat of the request replays `result`. A read of a team\'s content keeps an empty `payload`\nand the counts it showed, under `read:<request id>`, never the content.');

export type AuditEntry = zod.input<typeof AuditEntry>;
export type AuditEntryOutput = zod.output<typeof AuditEntry>;

export const AuditPage = zod.object({
  "items": zod.array(AuditEntry),
  "next": zod.union([zod.string(),zod.null()])
}).describe('`GET /v1/staff/audit`: newest first.');

export type AuditPage = zod.input<typeof AuditPage>;
export type AuditPageOutput = zod.output<typeof AuditPage>;

export const backgroundCapsPreserveAudioDefault = false;
export const backgroundCapsSubjectIsPersonDefault = false;

export const BackgroundCaps = zod.object({
  "background_colors": zod.union([TextOptions,zod.null()]).exactOptional(),
  "preserve_audio": zod.boolean().default(backgroundCapsPreserveAudioDefault),
  "subject_is_person": zod.boolean().default(backgroundCapsSubjectIsPersonDefault)
}).describe('Edit Background\'s settings (live\'s `videoBackgroundRemoval`): Veed asks whether the\nsubject is a person; Bria takes a background color and whether to keep the sound.');

export type BackgroundCaps = zod.input<typeof BackgroundCaps>;
export type BackgroundCapsOutput = zod.output<typeof BackgroundCaps>;

export const BackgroundSettings = zod.object({
  "background_color": zod.union([zod.string(),zod.null()]).exactOptional(),
  "preserve_audio": zod.union([zod.boolean(),zod.null()]).exactOptional(),
  "subject_is_person": zod.union([zod.boolean(),zod.null()]).exactOptional()
}).describe('Edit Background\'s settings, each only where the model takes it (live\'s\n`subjectIsPerson`, Veed; `backgroundColor` and `preserveAudio`, Bria).');

export type BackgroundSettings = zod.input<typeof BackgroundSettings>;
export type BackgroundSettingsOutput = zod.output<typeof BackgroundSettings>;

export const backgroundSwapInputsPromptMax = 3000;


export const backgroundSwapInputsPromptRegExp = new RegExp('[^\\t\\n\\v\\f\\r \\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000\\ufeff]');


export const BackgroundSwapInputs = zod.object({
  "image": TemplateSource,
  "prompt": zod.string().min(1).max(backgroundSwapInputsPromptMax).regex(backgroundSwapInputsPromptRegExp),
  "template": zod.enum(['image-background-swap'])
}).describe('Static Image Background Swap\'s form (live\'s `ImageBackgroundSwapForm`): the picture whose\nsubject stays ("Pick a source image") and the new background ("Describe the new\nbackground"). One tile.');

export type BackgroundSwapInputs = zod.input<typeof BackgroundSwapInputs>;
export type BackgroundSwapInputsOutput = zod.output<typeof BackgroundSwapInputs>;

export const balanceHeldMin = 0;



export const Balance = zod.object({
  "available": zod.int(),
  "held": zod.int().min(balanceHeldMin)
}).describe('A team\'s credits: `available` to spend, `held` by running jobs. `available` is its credits\nless its open debt, negative while a capture past its credits, or a disputed payment past what\nwas left of it, is owed (as live\'s balance; its next credits pay it first), when nothing paid\ncan start.');

export type Balance = zod.input<typeof Balance>;
export type BalanceOutput = zod.output<typeof Balance>;

export const balloonAdInputsAudioModeDefault = `voiceover`;
export const balloonAdInputsBrandColorsDefault = [];
export const balloonAdInputsBrandColorsMax = 12;

export const balloonAdInputsCaptionPositionDefault = `bottom`;
export const balloonAdInputsCaptionStyleIdDefault = ``;
export const balloonAdInputsCaptionStyleIdMax = 64;

export const balloonAdInputsCtaDefault = ``;
export const balloonAdInputsCtaMax = 2000;

export const balloonAdInputsPaletteColorDefault = false;
export const balloonAdInputsProblemDefault = ``;
export const balloonAdInputsProblemMax = 500;

export const balloonAdInputsProductCategoryDefault = ``;
export const balloonAdInputsProductCategoryMax = 200;

export const balloonAdInputsProductNameDefault = ``;
export const balloonAdInputsProductNameMax = 200;

export const balloonAdInputsProductTextDefault = ``;
export const balloonAdInputsProductTextMax = 20000;

export const balloonAdInputsPronunciationDefault = ``;
export const balloonAdInputsPronunciationMax = 500;

export const balloonAdInputsResolutionDefault = `720p`;
export const balloonAdInputsSubtitlesDefault = true;

export const BalloonAdInputs = zod.object({
  "audio_mode": zod.enum(['voiceover', 'native']).default(balloonAdInputsAudioModeDefault),
  "brand_colors": zod.array(HexColor).max(balloonAdInputsBrandColorsMax).default(balloonAdInputsBrandColorsDefault),
  "caption_position": zod.enum(['top', 'center', 'bottom']).default(balloonAdInputsCaptionPositionDefault),
  "caption_style_id": zod.string().max(balloonAdInputsCaptionStyleIdMax).default(balloonAdInputsCaptionStyleIdDefault),
  "cta": zod.string().max(balloonAdInputsCtaMax).default(balloonAdInputsCtaDefault),
  "palette_color": zod.boolean().default(balloonAdInputsPaletteColorDefault),
  "problem": zod.string().max(balloonAdInputsProblemMax).default(balloonAdInputsProblemDefault),
  "product": zod.union([PackshotProduct,zod.null()]).exactOptional(),
  "product_category": zod.string().max(balloonAdInputsProductCategoryMax).default(balloonAdInputsProductCategoryDefault),
  "product_name": zod.string().max(balloonAdInputsProductNameMax).default(balloonAdInputsProductNameDefault),
  "product_text": zod.string().max(balloonAdInputsProductTextMax).default(balloonAdInputsProductTextDefault),
  "pronunciation": zod.string().max(balloonAdInputsPronunciationMax).default(balloonAdInputsPronunciationDefault),
  "resolution": zod.enum(['720p', '1080p']).default(balloonAdInputsResolutionDefault),
  "subtitles": zod.boolean().default(balloonAdInputsSubtitlesDefault),
  "voice": zod.union([zod.uuid(),zod.null()]).exactOptional()
}).describe('Balloon Ad\'s form so far: the product (none until picked), and the rest.');

export type BalloonAdInputs = zod.input<typeof BalloonAdInputs>;
export type BalloonAdInputsOutput = zod.output<typeof BalloonAdInputs>;

export const BalloonAdBlankScript = zod.object({
  "inputs": BalloonAdInputs
}).describe('`POST .../draft/blank`: live\'s "Write it myself", on the form as it stands.');

export type BalloonAdBlankScript = zod.input<typeof BalloonAdBlankScript>;
export type BalloonAdBlankScriptOutput = zod.output<typeof BalloonAdBlankScript>;

export const VoiceKind = zod.enum(['global', 'team']);

export type VoiceKind = zod.input<typeof VoiceKind>;
export type VoiceKindOutput = zod.output<typeof VoiceKind>;

export const ClaymationNarrator = zod.object({
  "id": zod.uuid(),
  "kind": VoiceKind,
  "name": zod.string()
}).describe('The narrator a Claymation Ad draft names, as the narrator\'s tile shows it and the voice\npanel marks it: a global voice or one of the team\'s own.');

export type ClaymationNarrator = zod.input<typeof ClaymationNarrator>;
export type ClaymationNarratorOutput = zod.output<typeof ClaymationNarrator>;

export const balloonBenefitBannerClaimIdsItemMax = 40;

export const balloonBenefitBannerClaimIdsMax = 60;

export const balloonBenefitBannerTextMax = 2000;



export const BalloonBenefitBanner = zod.object({
  "claim_ids": zod.array(zod.string().max(balloonBenefitBannerClaimIdsItemMax)).max(balloonBenefitBannerClaimIdsMax),
  "text": zod.string().max(balloonBenefitBannerTextMax)
});

export type BalloonBenefitBanner = zod.input<typeof BalloonBenefitBanner>;
export type BalloonBenefitBannerOutput = zod.output<typeof BalloonBenefitBanner>;

export const balloonBannersBenefitsMax = 60;

export const balloonBannersCtaMax = 2000;



export const BalloonBanners = zod.object({
  "benefits": zod.array(BalloonBenefitBanner).max(balloonBannersBenefitsMax),
  "cta": zod.string().max(balloonBannersCtaMax)
});

export type BalloonBanners = zod.input<typeof BalloonBanners>;
export type BalloonBannersOutput = zod.output<typeof BalloonBanners>;

export const balloonClaimClaimMax = 2000;

export const balloonClaimIdMax = 40;

export const balloonClaimSourceQuoteMax = 2000;



export const BalloonClaim = zod.object({
  "claim": zod.string().max(balloonClaimClaimMax),
  "id": zod.string().max(balloonClaimIdMax),
  "source_quote": zod.string().max(balloonClaimSourceQuoteMax)
});

export type BalloonClaim = zod.input<typeof BalloonClaim>;
export type BalloonClaimOutput = zod.output<typeof BalloonClaim>;

export const balloonEndCardCtaButtonMax = 2000;

export const balloonEndCardHeadlineMax = 2000;

export const balloonEndCardSupportLineMax = 2000;



export const BalloonEndCard = zod.object({
  "cta_button": zod.string().max(balloonEndCardCtaButtonMax),
  "headline": zod.string().max(balloonEndCardHeadlineMax),
  "support_line": zod.string().max(balloonEndCardSupportLineMax)
});

export type BalloonEndCard = zod.input<typeof BalloonEndCard>;
export type BalloonEndCardOutput = zod.output<typeof BalloonEndCard>;

export const BalloonBeat = zod.enum(['problem', 'switch', 'result', 'cta']).describe('A sentence\'s beat (`W/ids.ts:45-54`).');

export type BalloonBeat = zod.input<typeof BalloonBeat>;
export type BalloonBeatOutput = zod.output<typeof BalloonBeat>;

export const balloonScriptLineClaimIdsItemMax = 40;

export const balloonScriptLineClaimIdsMax = 60;

export const balloonScriptLineTextMax = 2000;



export const BalloonScriptLine = zod.object({
  "beat": BalloonBeat,
  "claim_ids": zod.array(zod.string().max(balloonScriptLineClaimIdsItemMax)).max(balloonScriptLineClaimIdsMax),
  "id": zod.int(),
  "text": zod.string().max(balloonScriptLineTextMax)
});

export type BalloonScriptLine = zod.input<typeof BalloonScriptLine>;
export type BalloonScriptLineOutput = zod.output<typeof BalloonScriptLine>;

export const balloonScriptProblemAfterStateMax = 2000;

export const balloonScriptProblemBannerMax = 2000;

export const balloonScriptProblemBeforeStateMax = 2000;

export const balloonScriptProblemKnotMeaningMax = 2000;

export const balloonScriptProblemSourceQuoteMax = 2000;



export const BalloonScriptProblem = zod.object({
  "after_state": zod.string().max(balloonScriptProblemAfterStateMax),
  "banner": zod.string().max(balloonScriptProblemBannerMax),
  "before_state": zod.string().max(balloonScriptProblemBeforeStateMax),
  "knot_meaning": zod.string().max(balloonScriptProblemKnotMeaningMax),
  "sleep": zod.boolean(),
  "source_quote": zod.string().max(balloonScriptProblemSourceQuoteMax)
}).describe('The story\'s arc (`problemSchema`): her two states, the knot\'s banner and meaning, the\npage\'s words it stands on, and whether it is a night story.');

export type BalloonScriptProblem = zod.input<typeof BalloonScriptProblem>;
export type BalloonScriptProblemOutput = zod.output<typeof BalloonScriptProblem>;

export const balloonPronunciationRespellingMax = 200;

export const balloonPronunciationSaidMax = 2000;

export const balloonPronunciationWordMax = 200;



export const BalloonPronunciation = zod.object({
  "respelling": zod.string().max(balloonPronunciationRespellingMax),
  "said": zod.string().max(balloonPronunciationSaidMax),
  "word": zod.string().max(balloonPronunciationWordMax)
}).describe('How a written word is said (`word_check.Respelling`).');

export type BalloonPronunciation = zod.input<typeof BalloonPronunciation>;
export type BalloonPronunciationOutput = zod.output<typeof BalloonPronunciation>;

export const balloonScriptBrandNameMax = 2000;

export const balloonScriptClaimsMax = 60;

export const balloonScriptLinesMax = 60;

export const balloonScriptProductNameMax = 2000;

export const balloonScriptPronunciationsMax = 60;



export const BalloonScript = zod.object({
  "banners": BalloonBanners,
  "brand_name": zod.string().max(balloonScriptBrandNameMax),
  "claims": zod.array(BalloonClaim).max(balloonScriptClaimsMax),
  "end_card": BalloonEndCard,
  "lines": zod.array(BalloonScriptLine).min(1).max(balloonScriptLinesMax),
  "problem": BalloonScriptProblem,
  "product_name": zod.string().max(balloonScriptProductNameMax),
  "pronunciations": zod.array(BalloonPronunciation).max(balloonScriptPronunciationsMax),
  "word_count": zod.int()
}).describe('The script director\'s answer (`W/director/script.ts:121-133`), the fields in live\'s order\n(the JSON the look director is shown), edited before approval. `word_count` is recounted,\nnever trusted (`balloon_script.recounted`).');

export type BalloonScript = zod.input<typeof BalloonScript>;
export type BalloonScriptOutput = zod.output<typeof BalloonScript>;

export const BalloonDraftStage = zod.enum(['script', 'storyboard', 'takes']).describe('Live\'s stages (`W/types.ts:12-26`): the script, the storyboard once it is approved, the\ntakes once the clips are shot.');

export type BalloonDraftStage = zod.input<typeof BalloonDraftStage>;
export type BalloonDraftStageOutput = zod.output<typeof BalloonDraftStage>;

export const BalloonAdDraft = zod.object({
  "inputs": BalloonAdInputs,
  "narrator_voice": zod.union([ClaymationNarrator,zod.null()]),
  "pack_director": DirectorState,
  "pack_warning": zod.boolean(),
  "packshot": zod.union([TemplateSource,zod.null()]),
  "problem": zod.union([zod.string(),zod.null()]),
  "script": zod.union([BalloonScript,zod.null()]),
  "script_director": DirectorState,
  "script_issue": zod.union([zod.string(),zod.null()]),
  "script_warning": zod.union([zod.string(),zod.null()]),
  "stage": BalloonDraftStage,
  "updated_at": zod.iso.datetime({"offset":true})
}).describe('A member\'s Balloon Ad draft in the brand: the form, the stage, the script and its\ndirectors (the pack reader\'s, then the script\'s). `narrator_voice`: the voice the form\npicked, by its name now, none until one is picked or once it is no voice the team may use.\n`pack_warning`: the pack was hard to read. `script_warning`: live\'s words for a script still\noff what the editor can fix after the director\'s three tries. `script_issue`: what keeps the\nscript as it stands from approval, in live\'s words (`findScriptIssue`); none without a\nscript. `packshot`: the product tile\'s packshot, none until one is picked. `problem`: live\'s\nwords for the last director that failed.');

export type BalloonAdDraft = zod.input<typeof BalloonAdDraft>;
export type BalloonAdDraftOutput = zod.output<typeof BalloonAdDraft>;

export const BalloonAdDraftWrite = zod.object({
  "inputs": BalloonAdInputs,
  "script": zod.union([BalloonScript,zod.null()]).exactOptional()
}).describe('`PUT .../templates/balloon-ad/draft`: the form as it stands, its script as edited.');

export type BalloonAdDraftWrite = zod.input<typeof BalloonAdDraftWrite>;
export type BalloonAdDraftWriteOutput = zod.output<typeof BalloonAdDraftWrite>;

export const balloonAdPickedInputsAudioModeDefault = `voiceover`;
export const balloonAdPickedInputsBrandColorsDefault = [];
export const balloonAdPickedInputsBrandColorsMax = 12;

export const balloonAdPickedInputsCaptionPositionDefault = `bottom`;
export const balloonAdPickedInputsCaptionStyleIdDefault = ``;
export const balloonAdPickedInputsCaptionStyleIdMax = 64;

export const balloonAdPickedInputsCtaDefault = ``;
export const balloonAdPickedInputsCtaMax = 2000;

export const balloonAdPickedInputsPaletteColorDefault = false;
export const balloonAdPickedInputsProblemDefault = ``;
export const balloonAdPickedInputsProblemMax = 500;

export const balloonAdPickedInputsProductCategoryDefault = ``;
export const balloonAdPickedInputsProductCategoryMax = 200;

export const balloonAdPickedInputsProductNameDefault = ``;
export const balloonAdPickedInputsProductNameMax = 200;

export const balloonAdPickedInputsProductTextDefault = ``;
export const balloonAdPickedInputsProductTextMax = 20000;

export const balloonAdPickedInputsPronunciationDefault = ``;
export const balloonAdPickedInputsPronunciationMax = 500;

export const balloonAdPickedInputsResolutionDefault = `720p`;
export const balloonAdPickedInputsSubtitlesDefault = true;

export const BalloonAdPickedInputs = zod.object({
  "audio_mode": zod.enum(['voiceover', 'native']).default(balloonAdPickedInputsAudioModeDefault),
  "brand_colors": zod.array(HexColor).max(balloonAdPickedInputsBrandColorsMax).default(balloonAdPickedInputsBrandColorsDefault),
  "caption_position": zod.enum(['top', 'center', 'bottom']).default(balloonAdPickedInputsCaptionPositionDefault),
  "caption_style_id": zod.string().max(balloonAdPickedInputsCaptionStyleIdMax).default(balloonAdPickedInputsCaptionStyleIdDefault),
  "cta": zod.string().max(balloonAdPickedInputsCtaMax).default(balloonAdPickedInputsCtaDefault),
  "palette_color": zod.boolean().default(balloonAdPickedInputsPaletteColorDefault),
  "problem": zod.string().max(balloonAdPickedInputsProblemMax).default(balloonAdPickedInputsProblemDefault),
  "product": PackshotProduct,
  "product_category": zod.string().max(balloonAdPickedInputsProductCategoryMax).default(balloonAdPickedInputsProductCategoryDefault),
  "product_name": zod.string().max(balloonAdPickedInputsProductNameMax).default(balloonAdPickedInputsProductNameDefault),
  "product_text": zod.string().max(balloonAdPickedInputsProductTextMax).default(balloonAdPickedInputsProductTextDefault),
  "pronunciation": zod.string().max(balloonAdPickedInputsPronunciationMax).default(balloonAdPickedInputsPronunciationDefault),
  "resolution": zod.enum(['720p', '1080p']).default(balloonAdPickedInputsResolutionDefault),
  "subtitles": zod.boolean().default(balloonAdPickedInputsSubtitlesDefault),
  "voice": zod.union([zod.uuid(),zod.null()]).exactOptional()
}).describe('The form with its product picked, as Generate script and Approve script need it (live\'s\n"Pick a product and its packshot", 422 at `product`).');

export type BalloonAdPickedInputs = zod.input<typeof BalloonAdPickedInputs>;
export type BalloonAdPickedInputsOutput = zod.output<typeof BalloonAdPickedInputs>;

export const BalloonAdScriptApproval = zod.object({
  "inputs": BalloonAdPickedInputs,
  "script": zod.union([BalloonScript,zod.null()]).exactOptional()
}).describe('`POST .../draft/approve`: live\'s Approve script, the form and the script as edited; no\nscript is live\'s "Generate or write the script", 422 at `script`.');

export type BalloonAdScriptApproval = zod.input<typeof BalloonAdScriptApproval>;
export type BalloonAdScriptApprovalOutput = zod.output<typeof BalloonAdScriptApproval>;

export const BalloonAdScriptAsk = zod.object({
  "inputs": BalloonAdPickedInputs
}).describe('`POST .../draft/script`: live\'s wand, on the form as it stands.');

export type BalloonAdScriptAsk = zod.input<typeof BalloonAdScriptAsk>;
export type BalloonAdScriptAskOutput = zod.output<typeof BalloonAdScriptAsk>;

export const BillingUrl = zod.object({
  "url": zod.string()
}).describe('Where to send the browser: Stripe\'s Portal, or a Checkout for a team whose subscription\nended (spec B2-4a).');

export type BillingUrl = zod.input<typeof BillingUrl>;
export type BillingUrlOutput = zod.output<typeof BillingUrl>;

export const BlockMode = zod.enum(['reveal', 'slide']).describe('Block Reveal\'s Mode: live\'s "Reveal (Expand & Contract)" and "Slide (Fixed Width)".');

export type BlockMode = zod.input<typeof BlockMode>;
export type BlockModeOutput = zod.output<typeof BlockMode>;

export const colorHexRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const colorLabelOneMax = 50;


export const colorLabelOneRegExp = new RegExp('[^\\t\\n\\v\\f\\r \\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000\\ufeff]');


export const Color = zod.object({
  "hex": zod.string().regex(colorHexRegExp),
  "label": zod.union([zod.string().min(1).max(colorLabelOneMax).regex(colorLabelOneRegExp),zod.null()]).exactOptional()
}).describe('One brand or product color, in requests and responses alike.');

export type Color = zod.input<typeof Color>;
export type ColorOutput = zod.output<typeof Color>;

export const FontSource = zod.enum(['google', 'custom']);

export type FontSource = zod.input<typeof FontSource>;
export type FontSourceOutput = zod.output<typeof FontSource>;

export const fontNameMax = 100;


export const fontNameRegExp = new RegExp('[^\\t\\n\\v\\f\\r \\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000\\ufeff]');


export const Font = zod.object({
  "name": zod.string().min(1).max(fontNameMax).regex(fontNameRegExp),
  "source": FontSource
}).describe('A font by name. No preview image is stored or sent (audit D13): the SPA renders it.');

export type Font = zod.input<typeof Font>;
export type FontOutput = zod.output<typeof Font>;

export const Typography = zod.object({
  "case_treatment": zod.union([zod.string(),zod.null()]).exactOptional(),
  "font_style": zod.union([zod.string(),zod.null()]).exactOptional(),
  "typeface": zod.union([zod.string(),zod.null()]).exactOptional(),
  "typography_details": zod.union([zod.string(),zod.null()]).exactOptional()
}).describe('How the brand sets type, written by AI (the extraction jobs), never by a request.');

export type Typography = zod.input<typeof Typography>;
export type TypographyOutput = zod.output<typeof Typography>;

export const Brand = zod.object({
  "audience": zod.union([zod.string(),zod.null()]),
  "brand_query": zod.union([zod.string(),zod.null()]),
  "colors": zod.array(Color),
  "created_at": zod.iso.datetime({"offset":true}),
  "created_by": zod.uuid(),
  "description": zod.string(),
  "fonts": zod.array(Font),
  "guidelines": zod.union([zod.string(),zod.null()]),
  "id": zod.uuid(),
  "logo_asset_id": zod.union([zod.uuid(),zod.null()]),
  "logo_url": zod.union([zod.string(),zod.null()]),
  "name": zod.string(),
  "tone_of_voice": zod.union([zod.string(),zod.null()]),
  "typography": zod.union([Typography,zod.null()]),
  "updated_at": zod.iso.datetime({"offset":true}),
  "urls_expire_at": zod.union([zod.iso.datetime({"offset":true}),zod.null()]),
  "website": zod.union([zod.string(),zod.null()])
});

export type Brand = zod.input<typeof Brand>;
export type BrandOutput = zod.output<typeof Brand>;

export const brandColorHexRegExp = new RegExp('^#[0-9a-f]{6}$');


export const BrandColor = zod.object({
  "hex": zod.string().regex(brandColorHexRegExp),
  "label": zod.string()
}).describe('A brand color, live\'s: its hex and its place (Primary, Secondary, Accent, Highlight,\nBackground).');

export type BrandColor = zod.input<typeof BrandColor>;
export type BrandColorOutput = zod.output<typeof BrandColor>;

export const ExtractedImageMime = zod.enum(['image/jpeg', 'image/png', 'image/webp']).describe('The image types the library stores (D9): the ones an extraction offers to import.');

export type ExtractedImageMime = zod.input<typeof ExtractedImageMime>;
export type ExtractedImageMimeOutput = zod.output<typeof ExtractedImageMime>;

export const extractedImageAltDefault = null;
export const extractedImageBytesExclusiveMin = 0;

export const extractedImageHeightDefault = null;
export const extractedImageUrlMax = 2048;

export const extractedImageWidthDefault = null;

export const ExtractedImage = zod.object({
  "alt": zod.union([zod.string(),zod.null()]).default(extractedImageAltDefault),
  "bytes": zod.int().gt(extractedImageBytesExclusiveMin),
  "height": zod.union([zod.int(),zod.null()]).default(extractedImageHeightDefault),
  "mime": ExtractedImageMime,
  "url": zod.string().min(1).max(extractedImageUrlMax),
  "width": zod.union([zod.int(),zod.null()]).default(extractedImageWidthDefault)
}).describe('An image an extraction found, as it was read: where, its type and size as served, and its\npixels. The form imports it into the library on Save (`assets/from-url`), and the import\nrefuses a file that no longer matches.');

export type ExtractedImage = zod.input<typeof ExtractedImage>;
export type ExtractedImageOutput = zod.output<typeof ExtractedImage>;

export const BrandExtract = zod.object({
  "colors": zod.array(BrandColor),
  "description": zod.string(),
  "fonts": zod.array(zod.string()),
  "logo": zod.union([ExtractedImage,zod.null()]),
  "name": zod.string()
}).describe('An `extract.brand` job\'s one output, its JSON file (#249, live\'s `BrandExtract`): the\nsite\'s name, its logo, up to five colors, its first Google font and a description.');

export type BrandExtract = zod.input<typeof BrandExtract>;
export type BrandExtractOutput = zod.output<typeof BrandExtract>;

export const brandInAudienceOneMax = 1500;


export const brandInAudienceOneRegExp = new RegExp('[^\\t\\n\\v\\f\\r \\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000\\ufeff]');
export const brandInColorsMax = 5;

export const brandInDescriptionMax = 1500;


export const brandInDescriptionRegExp = new RegExp('[^\\t\\n\\v\\f\\r \\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000\\ufeff]');
export const brandInFontsMax = 5;

export const brandInGuidelinesOneMax = 5000;


export const brandInGuidelinesOneRegExp = new RegExp('[^\\t\\n\\v\\f\\r \\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000\\ufeff]');
export const brandInNameMax = 100;


export const brandInNameRegExp = new RegExp('[^\\t\\n\\v\\f\\r \\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000\\ufeff]');
export const brandInToneOfVoiceOneMax = 500;


export const brandInToneOfVoiceOneRegExp = new RegExp('[^\\t\\n\\v\\f\\r \\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000\\ufeff]');
export const brandInWebsiteOneMax = 2048;


export const brandInWebsiteOneRegExp = new RegExp('^[\\t\\n\\v\\f\\r \\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000\\ufeff]*https?://[^\\t\\n\\v\\f\\r \\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000\\ufeff]+[\\t\\n\\v\\f\\r \\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000\\ufeff]*$');


export const BrandIn = zod.object({
  "audience": zod.union([zod.string().min(1).max(brandInAudienceOneMax).regex(brandInAudienceOneRegExp),zod.null()]).exactOptional(),
  "colors": zod.array(Color).max(brandInColorsMax).exactOptional(),
  "description": zod.string().min(1).max(brandInDescriptionMax).regex(brandInDescriptionRegExp),
  "fonts": zod.array(Font).max(brandInFontsMax).exactOptional(),
  "guidelines": zod.union([zod.string().min(1).max(brandInGuidelinesOneMax).regex(brandInGuidelinesOneRegExp),zod.null()]).exactOptional(),
  "logo_asset_id": zod.union([zod.uuid(),zod.null()]).exactOptional(),
  "name": zod.string().min(1).max(brandInNameMax).regex(brandInNameRegExp),
  "tone_of_voice": zod.union([zod.string().min(1).max(brandInToneOfVoiceOneMax).regex(brandInToneOfVoiceOneRegExp),zod.null()]).exactOptional(),
  "website": zod.union([zod.string().max(brandInWebsiteOneMax).regex(brandInWebsiteOneRegExp),zod.null()]).exactOptional()
}).describe('`POST .../brands` and `PUT .../brands/{brand_id}`: the whole brand, replaced on update.');

export type BrandIn = zod.input<typeof BrandIn>;
export type BrandInOutput = zod.output<typeof BrandIn>;

export const CallOperation = zod.enum(['queue', 'call', 'upload', 'cancel']);

export type CallOperation = zod.input<typeof CallOperation>;
export type CallOperationOutput = zod.output<typeof CallOperation>;

export const CallOutcome = zod.enum(['pending', 'succeeded', 'failed', 'refused', 'unavailable', 'not_sent', 'ambiguous', 'canceled']);

export type CallOutcome = zod.input<typeof CallOutcome>;
export type CallOutcomeOutput = zod.output<typeof CallOutcome>;




export const CallUnit = zod.object({
  "quantity": zod.string(),
  "unit": zod.string().min(1)
}).describe('What the vendor meters for a request, in its own units, read from its answer: images,\nseconds, characters, input or output tokens.');

export type CallUnit = zod.input<typeof CallUnit>;
export type CallUnitOutput = zod.output<typeof CallUnit>;

export const CameraName = zod.enum(['wide', 'host_close', 'guest_close']);

export type CameraName = zod.input<typeof CameraName>;
export type CameraNameOutput = zod.output<typeof CameraName>;

export const captionActiveDynamicDefault = false;
export const captionActiveScaleDefault = 1;
export const captionActiveScaleMin = 0;
export const captionActiveScaleMax = 10;

export const captionActiveYDefault = 0;
export const captionActiveYMin = -2000;
export const captionActiveYMax = 2000;



export const CaptionActive = zod.object({
  "dynamic": zod.boolean().default(captionActiveDynamicDefault),
  "scale": zod.number().min(captionActiveScaleMin).max(captionActiveScaleMax).default(captionActiveScaleDefault),
  "y": zod.number().min(captionActiveYMin).max(captionActiveYMax).default(captionActiveYDefault)
}).describe('The word being spoken (#264): scaled and moved by `y`, held while spoken, or (`dynamic`)\nswelling to them and back over its time.');

export type CaptionActive = zod.input<typeof CaptionActive>;
export type CaptionActiveOutput = zod.output<typeof CaptionActive>;

export const CaptionEasing = zod.enum(['linear', 'ease_out_quad', 'ease_out_cubic', 'ease_out_sine', 'ease_out_back', 'ease_out_bounce']).describe('The curves live\'s caption animations run on (#264).');

export type CaptionEasing = zod.input<typeof CaptionEasing>;
export type CaptionEasingOutput = zod.output<typeof CaptionEasing>;

export const captionMotionOpacityDefault = 1;
export const captionMotionOpacityMin = 0;
export const captionMotionOpacityMax = 1;

export const captionMotionRotationDefault = 0;
export const captionMotionRotationMin = -360;
export const captionMotionRotationMax = 360;

export const captionMotionScaleDefault = 1;
export const captionMotionScaleMin = 0;
export const captionMotionScaleMax = 10;

export const captionMotionXDefault = 0;
export const captionMotionXMin = -2000;
export const captionMotionXMax = 2000;

export const captionMotionYDefault = 0;
export const captionMotionYMin = -2000;
export const captionMotionYMax = 2000;



export const CaptionMotion = zod.object({
  "opacity": zod.number().min(captionMotionOpacityMin).max(captionMotionOpacityMax).default(captionMotionOpacityDefault),
  "rotation": zod.number().min(captionMotionRotationMin).max(captionMotionRotationMax).default(captionMotionRotationDefault),
  "scale": zod.number().min(captionMotionScaleMin).max(captionMotionScaleMax).default(captionMotionScaleDefault),
  "x": zod.number().min(captionMotionXMin).max(captionMotionXMax).default(captionMotionXDefault),
  "y": zod.number().min(captionMotionYMin).max(captionMotionYMax).default(captionMotionYDefault)
}).describe('A word\'s pose (#264): its opacity, its scale about its centre, moved by `x` and `y` live\'s\npixels (down is positive) and turned `rotation` degrees.');

export type CaptionMotion = zod.input<typeof CaptionMotion>;
export type CaptionMotionOutput = zod.output<typeof CaptionMotion>;

export const CaptionAnimationPreset = zod.enum(['immediate', 'opacity', 'pop_in', 'slide_in', 'lateral_slide_left', 'lateral_slide_right', 'flip_in', 'scale_in', 'impact_scale', 'slide_up', 'pop_in_slide_up', 'transform', 'jump', 'zoom', 'soft_rise', 'staggered_pop', 'rapid_stream', 'random']).describe('Live\'s caption Animation list (#264), less None (no animation) in its order.');

export type CaptionAnimationPreset = zod.input<typeof CaptionAnimationPreset>;
export type CaptionAnimationPresetOutput = zod.output<typeof CaptionAnimationPreset>;

export const CaptionScope = zod.enum(['word', 'line', 'page']).describe('What enters together (#264): each word as it is spoken, each line, or the whole caption.');

export type CaptionScope = zod.input<typeof CaptionScope>;
export type CaptionScopeOutput = zod.output<typeof CaptionScope>;

export const captionAnimationDurationMsMin = 0;
export const captionAnimationDurationMsMax = 10000;

export const captionAnimationEasingDefault = 'linear';
export const captionAnimationScopeDefault = 'word';

export const CaptionAnimation = zod.object({
  "active": zod.union([CaptionActive,zod.null()]).exactOptional(),
  "duration_ms": zod.int().min(captionAnimationDurationMsMin).max(captionAnimationDurationMsMax),
  "easing": CaptionEasing.default(captionAnimationEasingDefault),
  "enter_from": CaptionMotion,
  "enter_to": CaptionMotion,
  "preset": zod.union([CaptionAnimationPreset,zod.null()]).exactOptional(),
  "scope": CaptionScope.default(captionAnimationScopeDefault)
}).describe('Live\'s caption animation (#264): each `scope` enters from `enter_from` to `enter_to` over\n`duration_ms` on `easing` as its first word is spoken (a word before it holds `enter_from`),\nand the word being spoken takes `active`. `preset` is the Animation list\'s entry it was made\nfrom; null is a preset\'s own (live\'s system presets carry their own).');

export type CaptionAnimation = zod.input<typeof CaptionAnimation>;
export type CaptionAnimationOutput = zod.output<typeof CaptionAnimation>;

export const CaptionEmphasis = zod.enum(['positive', 'negative']);

export type CaptionEmphasis = zod.input<typeof CaptionEmphasis>;
export type CaptionEmphasisOutput = zod.output<typeof CaptionEmphasis>;

export const captionWordEndMsMin = 0;
export const captionWordEndMsMax = 300000;

export const captionWordLineDefault = 0;
export const captionWordLineMin = 0;
export const captionWordLineExclusiveMax = 10;

export const captionWordStartMsMin = 0;
export const captionWordStartMsMax = 300000;

export const captionWordTextMax = 100;


export const captionWordTextRegExp = new RegExp('^\\S+$');


export const CaptionWord = zod.object({
  "emphasis": zod.union([CaptionEmphasis,zod.null()]).exactOptional(),
  "end_ms": zod.int().min(captionWordEndMsMin).max(captionWordEndMsMax),
  "line": zod.int().min(captionWordLineMin).lt(captionWordLineExclusiveMax).default(captionWordLineDefault),
  "start_ms": zod.int().min(captionWordStartMsMin).max(captionWordStartMsMax),
  "text": zod.string().min(1).max(captionWordTextMax).regex(captionWordTextRegExp)
}).describe('A word of a caption as shown, from `start_ms` to `end_ms` after the caption starts, on its\n`line` of the caption (0 first; a line no word is on is drawn empty).');

export type CaptionWord = zod.input<typeof CaptionWord>;
export type CaptionWordOutput = zod.output<typeof CaptionWord>;

export const captionClipEndSMin = 0;
export const captionClipEndSMax = 300;

export const captionClipHiddenDefault = false;
export const captionClipIdRegExp = new RegExp('^[A-Za-z0-9_-]{1,64}$');
export const captionClipLockedDefault = false;
export const captionClipRotationDefault = 0;
export const captionClipRotationMin = -360;
export const captionClipRotationMax = 360;

export const captionClipScaleDefault = 1;
export const captionClipScaleMin = 0.1;
export const captionClipScaleMax = 10;

export const captionClipStartSMin = 0;
export const captionClipStartSMax = 300;

export const captionClipTrackIdRegExp = new RegExp('^[A-Za-z0-9_-]{1,64}$');
export const captionClipWordsMax = 100;



export const CaptionClip = zod.object({
  "box": Box,
  "end_s": zod.number().min(captionClipEndSMin).max(captionClipEndSMax),
  "hidden": zod.boolean().default(captionClipHiddenDefault),
  "id": zod.string().regex(captionClipIdRegExp),
  "kind": zod.enum(['caption']),
  "locked": zod.boolean().default(captionClipLockedDefault),
  "rotation": zod.number().min(captionClipRotationMin).max(captionClipRotationMax).default(captionClipRotationDefault),
  "scale": zod.number().min(captionClipScaleMin).max(captionClipScaleMax).default(captionClipScaleDefault),
  "start_s": zod.number().min(captionClipStartSMin).max(captionClipStartSMax),
  "track_id": zod.string().regex(captionClipTrackIdRegExp),
  "words": zod.array(CaptionWord).max(captionClipWordsMax)
}).describe('Live\'s caption (#239): its words, timed from its start, drawn centred on `box` (live\'s\npixels) in the project\'s caption style, the word being spoken marked. It sits only on the\ncaption track. Its text is its words: a line\'s joined by spaces, lines by line breaks. It may\nhold none (live keeps a caption whose text was cleared). The canvas\'s handles scale it\nuniformly (`scale` times the style\'s size, about the centre of its drawn lines) and turn it\n(`rotation` degrees clockwise about that centre), as live\'s caption keeps its own size and\nangle (#560);\na caption saved before either reads as 1 and 0.');

export type CaptionClip = zod.input<typeof CaptionClip>;
export type CaptionClipOutput = zod.output<typeof CaptionClip>;

export const CaptionFrequency = zod.enum(['punctuation_or_pause', 'single_word', 'time', 'random']).describe('When live\'s segmenter starts a new caption (#264): at a sentence\'s end or a pause, every\n`words_per_line` words, every `split_s`, or after a random 2 to 5 words.');

export type CaptionFrequency = zod.input<typeof CaptionFrequency>;
export type CaptionFrequencyOutput = zod.output<typeof CaptionFrequency>;

export const CaptionHighlight = zod.enum(['positive', 'negative']).describe('Live\'s keyword tag on a word, for a caption preset\'s tag styles (#264): a key subject,\naspiration, action or number, or a word of tension, risk or loss.');

export type CaptionHighlight = zod.input<typeof CaptionHighlight>;
export type CaptionHighlightOutput = zod.output<typeof CaptionHighlight>;

export const captionParagraphAutofitDefault = false;
export const captionParagraphCharacterCountDefault = 16;
export const captionParagraphCharacterCountMax = 200;

export const captionParagraphFrequencyDefault = 'punctuation_or_pause';
export const captionParagraphPauseSDefault = 0.4;
export const captionParagraphPauseSMin = 0.05;
export const captionParagraphPauseSMax = 10;

export const captionParagraphQuantityDefault = 1;
export const captionParagraphQuantityMax = 6;

export const captionParagraphSplitSDefault = 2;
export const captionParagraphSplitSMin = 0.1;
export const captionParagraphSplitSMax = 60;

export const captionParagraphWordsPerLineDefault = 1;
export const captionParagraphWordsPerLineMax = 100;



export const CaptionParagraph = zod.object({
  "autofit": zod.boolean().default(captionParagraphAutofitDefault),
  "character_count": zod.int().min(1).max(captionParagraphCharacterCountMax).default(captionParagraphCharacterCountDefault),
  "frequency": CaptionFrequency.default(captionParagraphFrequencyDefault),
  "pause_s": zod.number().min(captionParagraphPauseSMin).max(captionParagraphPauseSMax).default(captionParagraphPauseSDefault),
  "quantity": zod.int().min(1).max(captionParagraphQuantityMax).default(captionParagraphQuantityDefault),
  "split_s": zod.number().min(captionParagraphSplitSMin).max(captionParagraphSplitSMax).default(captionParagraphSplitSDefault),
  "words_per_line": zod.int().min(1).max(captionParagraphWordsPerLineMax).default(captionParagraphWordsPerLineDefault)
}).describe('Live\'s Paragraph settings (#264): how words are cut into captions and lines. At most\n`quantity` lines of about `character_count` characters, a new caption at a pause of `pause_s`\nand by `frequency`; `autofit` sizes each caption\'s box to its longest line.');

export type CaptionParagraph = zod.input<typeof CaptionParagraph>;
export type CaptionParagraphOutput = zod.output<typeof CaptionParagraph>;

export const CaptionVertical = zod.enum(['top', 'center', 'bottom']);

export type CaptionVertical = zod.input<typeof CaptionVertical>;
export type CaptionVerticalOutput = zod.output<typeof CaptionVertical>;

export const captionPlacementHorizontalDefault = 'center';
export const captionPlacementVerticalDefault = 'center';

export const CaptionPlacement = zod.object({
  "horizontal": TextAlign.default(captionPlacementHorizontalDefault),
  "vertical": CaptionVertical.default(captionPlacementVerticalDefault)
}).describe('Live\'s Position (#264): where a cut places each caption\'s box on the frame.');

export type CaptionPlacement = zod.input<typeof CaptionPlacement>;
export type CaptionPlacementOutput = zod.output<typeof CaptionPlacement>;

export const captionTagColorRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const captionTagDifferenceDefault = false;
export const captionTagItalicDefault = false;
export const captionTagSizeRatioDefault = 1;
export const captionTagSizeRatioMin = 0.1;
export const captionTagSizeRatioMax = 5;

export const captionTagUnderlineDefault = false;
export const captionTagWeightDefault = 700;
export const captionTagWeightMin = 100;
export const captionTagWeightMax = 900;
export const captionTagWeightMultipleOf = 100;



export const CaptionTag = zod.object({
  "animation": zod.union([CaptionAnimation,zod.null()]).exactOptional(),
  "color": zod.string().regex(captionTagColorRegExp),
  "difference": zod.boolean().default(captionTagDifferenceDefault),
  "font": zod.union([FontFamily,zod.null()]).exactOptional(),
  "italic": zod.boolean().default(captionTagItalicDefault),
  "size_ratio": zod.number().min(captionTagSizeRatioMin).max(captionTagSizeRatioMax).default(captionTagSizeRatioDefault),
  "underline": zod.boolean().default(captionTagUnderlineDefault),
  "weight": zod.int().min(captionTagWeightMin).max(captionTagWeightMax).multipleOf(captionTagWeightMultipleOf).default(captionTagWeightDefault)
}).describe('Live\'s Emphasize (#264): a word the transcript marks positive or negative, drawn in\n`color`, in its own `font` when set, `size_ratio` times the caption\'s size, underlined, or\n(`difference`) inverting what lies under it, entering by its own `animation` when set.');

export type CaptionTag = zod.input<typeof CaptionTag>;
export type CaptionTagOutput = zod.output<typeof CaptionTag>;

export const captionShadowAlphaDefault = 1;
export const captionShadowAlphaMin = 0;
export const captionShadowAlphaMax = 1;

export const captionShadowBlurMin = 0;
export const captionShadowBlurMax = 100;

export const captionShadowColorRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const captionShadowOffsetXMin = -500;
export const captionShadowOffsetXMax = 500;

export const captionShadowOffsetYMin = -500;
export const captionShadowOffsetYMax = 500;



export const CaptionShadow = zod.object({
  "alpha": zod.number().min(captionShadowAlphaMin).max(captionShadowAlphaMax).default(captionShadowAlphaDefault),
  "blur": zod.number().min(captionShadowBlurMin).max(captionShadowBlurMax),
  "color": zod.string().regex(captionShadowColorRegExp),
  "offset_x": zod.number().min(captionShadowOffsetXMin).max(captionShadowOffsetXMax),
  "offset_y": zod.number().min(captionShadowOffsetYMin).max(captionShadowOffsetYMax)
}).describe('A caption\'s shadow (#264): live\'s Shadow, at `alpha` (live\'s presets\' 0.9, 0.4, 0.5).');

export type CaptionShadow = zod.input<typeof CaptionShadow>;
export type CaptionShadowOutput = zod.output<typeof CaptionShadow>;

export const captionStyleActiveBackgroundOneRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const captionStyleActiveColorOneRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const captionStyleAlignDefault = 'center';
export const captionStyleBackgroundDefault = { "color": "#FFFFFF" as const, "opacity": 1 as const, "pad_x": 32 as const, "pad_y": 24 as const, "radius": 16 as const };
export const captionStyleCaseDefault = 'as_typed';
export const captionStyleColorOneRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const captionStyleColorDefault = `#000000`;
export const captionStyleFontDefault = 'Poppins';
export const captionStyleItalicDefault = false;
export const captionStyleLetterSpacingDefault = 0;
export const captionStyleLetterSpacingMin = -100;
export const captionStyleLetterSpacingMax = 500;

export const captionStyleLineHeightDefault = 1;
export const captionStyleLineHeightMin = 0.5;
export const captionStyleLineHeightMax = 3;

export const captionStyleOverlineDefault = false;
export const captionStyleSizeDefault = 80;
export const captionStyleSizeMin = 8;
export const captionStyleSizeMax = 1000;

export const captionStyleStrikethroughDefault = false;
export const captionStyleUnderlineDefault = false;
export const captionStyleUpcomingColorOneRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const captionStyleUpcomingColorDefault = `#BBB9BD`;
export const captionStyleWeightDefault = 700;
export const captionStyleWeightMin = 100;
export const captionStyleWeightMax = 900;
export const captionStyleWeightMultipleOf = 100;



export const CaptionStyle = zod.object({
  "active_background": zod.union([zod.string().regex(captionStyleActiveBackgroundOneRegExp),zod.null()]).exactOptional(),
  "active_color": zod.union([zod.string().regex(captionStyleActiveColorOneRegExp),zod.null()]).exactOptional(),
  "align": TextAlign.default(captionStyleAlignDefault),
  "background": zod.union([TextBackground,zod.null()]).default(captionStyleBackgroundDefault),
  "case": TextCase.default(captionStyleCaseDefault),
  "color": zod.union([zod.string().regex(captionStyleColorOneRegExp),zod.null()]).default(captionStyleColorDefault),
  "font": FontFamily.default(captionStyleFontDefault),
  "italic": zod.boolean().default(captionStyleItalicDefault),
  "letter_spacing": zod.number().min(captionStyleLetterSpacingMin).max(captionStyleLetterSpacingMax).default(captionStyleLetterSpacingDefault),
  "line_height": zod.number().min(captionStyleLineHeightMin).max(captionStyleLineHeightMax).default(captionStyleLineHeightDefault),
  "negative": zod.union([CaptionTag,zod.null()]).exactOptional(),
  "overline": zod.boolean().default(captionStyleOverlineDefault),
  "positive": zod.union([CaptionTag,zod.null()]).exactOptional(),
  "shadow": zod.union([CaptionShadow,zod.null()]).exactOptional(),
  "size": zod.int().min(captionStyleSizeMin).max(captionStyleSizeMax).default(captionStyleSizeDefault),
  "strikethrough": zod.boolean().default(captionStyleStrikethroughDefault),
  "stroke": zod.union([Stroke,zod.null()]).exactOptional(),
  "underline": zod.boolean().default(captionStyleUnderlineDefault),
  "upcoming_color": zod.union([zod.string().regex(captionStyleUpcomingColorOneRegExp),zod.null()]).default(captionStyleUpcomingColorDefault),
  "weight": zod.int().min(captionStyleWeightMin).max(captionStyleWeightMax).multipleOf(captionStyleWeightMultipleOf).default(captionStyleWeightDefault)
}).describe('Live\'s caption look (#239): the project\'s one, on every caption (live applies each change to\nall of them), live\'s default look by default. The words in `font` at `size` live\'s pixels, a\nword spoken or being spoken in `color`, one still to come in `upcoming_color` (null: `color`),\nthe one being spoken in `active_color` (null: `color`) on an `active_background` box (null:\nnone); `background` behind each line (null: none). #264: the letters\' spacing (live\'s pixels)\nand line pitch (times live\'s 1.15), decorations, and the emphasised words\' looks.');

export type CaptionStyle = zod.input<typeof CaptionStyle>;
export type CaptionStyleOutput = zod.output<typeof CaptionStyle>;

export const captionSettingsPresetIdOneRegExp = new RegExp('^[A-Za-z0-9_-]{1,64}$');
export const captionSettingsSuperSizeNoBreakDefault = true;

export const CaptionSettings = zod.object({
  "animation": zod.union([CaptionAnimation,zod.null()]).exactOptional(),
  "paragraph": zod.union([CaptionParagraph,zod.null()]).exactOptional(),
  "placement": zod.union([CaptionPlacement,zod.null()]).exactOptional(),
  "preset_id": zod.union([zod.string().regex(captionSettingsPresetIdOneRegExp),zod.null()]).exactOptional(),
  "style": CaptionStyle,
  "super_size_no_break": zod.boolean().default(captionSettingsSuperSizeNoBreakDefault)
}).describe('A project\'s captions (#239): their look, the same on every caption. #264: live\'s Paragraph\nsettings and Position (null: live\'s defaults), its animation (null: none), and the preset the\nlook was last picked from (`preset_id`, a system preset\'s or the team\'s; null: none).');

export type CaptionSettings = zod.input<typeof CaptionSettings>;
export type CaptionSettingsOutput = zod.output<typeof CaptionSettings>;

export const captionPresetIdRegExp = new RegExp('^[A-Za-z0-9_-]{1,64}$');
export const captionPresetNameMax = 100;



export const CaptionPreset = zod.object({
  "id": zod.string().regex(captionPresetIdRegExp),
  "name": zod.string().min(1).max(captionPresetNameMax),
  "settings": CaptionSettings,
  "system": zod.boolean()
}).describe('Live\'s caption preset (#264): a look a click puts on every caption, and the cut it re-cuts\nthem with. The caller\'s own come first, oldest first, then live\'s six system presets in live\'s\norder (`system`).');

export type CaptionPreset = zod.input<typeof CaptionPreset>;
export type CaptionPresetOutput = zod.output<typeof CaptionPreset>;

export const captionPresetCreateNameMax = 100;


export const captionPresetCreateNameRegExp = new RegExp('[^\\t\\n\\v\\f\\r \\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000\\ufeff]');


export const CaptionPresetCreate = zod.object({
  "name": zod.string().min(1).max(captionPresetCreateNameMax).regex(captionPresetCreateNameRegExp),
  "settings": CaptionSettings
}).describe('Live\'s "Save style as preset" (#264 part 3): the project\'s look, named, for its maker.');

export type CaptionPresetCreate = zod.input<typeof CaptionPresetCreate>;
export type CaptionPresetCreateOutput = zod.output<typeof CaptionPresetCreate>;

export const captionTranscribeQuoteExpectedQuoteMaxOneMin = 0;

export const captionTranscribeQuoteLanguageCodeOneRegExp = new RegExp('^[a-z]{2,3}$');
export const captionTranscribeQuoteOutputsDefault = 1;
export const captionTranscribeQuoteOutputsMax = 1;



export const CaptionTranscribeQuote = zod.object({
  "expected_quote_max": zod.union([zod.int().min(captionTranscribeQuoteExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "language_code": zod.union([zod.string().regex(captionTranscribeQuoteLanguageCodeOneRegExp),zod.null()]).exactOptional(),
  "outputs": zod.int().min(1).max(captionTranscribeQuoteOutputsMax).default(captionTranscribeQuoteOutputsDefault),
  "source": SourceRef,
  "type": zod.enum(['caption.transcribe'])
}).describe('A `CaptionTranscribeRequest` to price: the same body, since it has no prompt.');

export type CaptionTranscribeQuote = zod.input<typeof CaptionTranscribeQuote>;
export type CaptionTranscribeQuoteOutput = zod.output<typeof CaptionTranscribeQuote>;

export const captionTranscribeRequestExpectedQuoteMaxOneMin = 0;

export const captionTranscribeRequestLanguageCodeOneRegExp = new RegExp('^[a-z]{2,3}$');
export const captionTranscribeRequestOutputsDefault = 1;
export const captionTranscribeRequestOutputsMax = 1;



export const CaptionTranscribeRequest = zod.object({
  "expected_quote_max": zod.union([zod.int().min(captionTranscribeRequestExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "language_code": zod.union([zod.string().regex(captionTranscribeRequestLanguageCodeOneRegExp),zod.null()]).exactOptional(),
  "outputs": zod.int().min(1).max(captionTranscribeRequestOutputsMax).default(captionTranscribeRequestOutputsDefault),
  "source": SourceRef,
  "type": zod.enum(['caption.transcribe'])
}).describe('A clip\'s speech as timed words (#239, live\'s "Generate captions", one call per video or\naudio clip): the clip\'s library video or audio, or an earlier output. No prompt and no\nlanguage, as live\'s editor sends none. No model: the AI task `caption.transcribe` picks the row\n(spec G9-ai-tasks). Free, as live charges nothing.');

export type CaptionTranscribeRequest = zod.input<typeof CaptionTranscribeRequest>;
export type CaptionTranscribeRequestOutput = zod.output<typeof CaptionTranscribeRequest>;

export const TranscriptWordKind = zod.enum(['word', 'spacing', 'audio_event']).describe('ElevenLabs\' kinds of transcript token, kept as it answers, as live keeps them: a spoken\nword, the space between two, or a sound it tagged ("(laughter)").');

export type TranscriptWordKind = zod.input<typeof TranscriptWordKind>;
export type TranscriptWordKindOutput = zod.output<typeof TranscriptWordKind>;

export const transcriptWordEndMsMin = 0;

export const transcriptWordHighlightDefault = null;
export const transcriptWordStartMsMin = 0;



export const TranscriptWord = zod.object({
  "end_ms": zod.int().min(transcriptWordEndMsMin),
  "highlight": zod.union([CaptionHighlight,zod.null()]).default(transcriptWordHighlightDefault),
  "kind": TranscriptWordKind,
  "start_ms": zod.int().min(transcriptWordStartMsMin),
  "text": zod.string()
}).describe('One token of a transcript, timed in milliseconds from the start of the source file,\nbefore any trim: the editor offsets it by its clip\'s trim and position.');

export type TranscriptWord = zod.input<typeof TranscriptWord>;
export type TranscriptWordOutput = zod.output<typeof TranscriptWord>;

export const CaptionTranscript = zod.object({
  "language": zod.union([zod.string(),zod.null()]),
  "text": zod.string(),
  "words": zod.array(TranscriptWord)
}).describe('A `caption.transcribe` job\'s one output, its JSON file (#239): the language ElevenLabs\nheard, the whole text and its timed tokens. No speech is an empty text with no words, a\nsuccess.');

export type CaptionTranscript = zod.input<typeof CaptionTranscript>;
export type CaptionTranscriptOutput = zod.output<typeof CaptionTranscript>;

export const cartoonPickedInputsBrandDefault = ``;
export const cartoonPickedInputsBrandMax = 100;

export const cartoonPickedInputsProductCategoryDefault = ``;
export const cartoonPickedInputsProductCategoryMax = 200;

export const cartoonPickedInputsProductNameDefault = ``;
export const cartoonPickedInputsProductNameMax = 200;

export const cartoonPickedInputsProductTextDefault = ``;
export const cartoonPickedInputsProductTextMax = 20000;

export const cartoonPickedInputsResolutionDefault = `720p`;
export const cartoonPickedInputsSizeDefault = ``;
export const cartoonPickedInputsSizeMax = 200;

export const cartoonPickedInputsSubtitlesDefault = true;
export const cartoonPickedInputsSurfaceDefault = ``;
export const cartoonPickedInputsSurfaceMax = 200;



export const CartoonPickedInputs = zod.object({
  "brand": zod.string().max(cartoonPickedInputsBrandMax).default(cartoonPickedInputsBrandDefault),
  "product": PackshotProduct,
  "product_category": zod.string().max(cartoonPickedInputsProductCategoryMax).default(cartoonPickedInputsProductCategoryDefault),
  "product_name": zod.string().max(cartoonPickedInputsProductNameMax).default(cartoonPickedInputsProductNameDefault),
  "product_text": zod.string().max(cartoonPickedInputsProductTextMax).default(cartoonPickedInputsProductTextDefault),
  "resolution": zod.enum(['720p', '480p']).default(cartoonPickedInputsResolutionDefault),
  "size": zod.string().max(cartoonPickedInputsSizeMax).default(cartoonPickedInputsSizeDefault),
  "subtitles": zod.boolean().default(cartoonPickedInputsSubtitlesDefault),
  "surface": zod.string().max(cartoonPickedInputsSurfaceMax).default(cartoonPickedInputsSurfaceDefault)
}).describe('The form with its product picked, as Generate script and Approve script need it (422 at\n`product`).');

export type CartoonPickedInputs = zod.input<typeof CartoonPickedInputs>;
export type CartoonPickedInputsOutput = zod.output<typeof CartoonPickedInputs>;

export const CartoonSpeaker = zod.enum(['CREATURE', 'WOMAN', 'NARRATOR']);

export type CartoonSpeaker = zod.input<typeof CartoonSpeaker>;
export type CartoonSpeakerOutput = zod.output<typeof CartoonSpeaker>;

export const cartoonLineTextMax = 2000;



export const CartoonLine = zod.object({
  "speaker": CartoonSpeaker,
  "text": zod.string().max(cartoonLineTextMax)
}).describe('One line, one shot: who says it and its words as written.');

export type CartoonLine = zod.input<typeof CartoonLine>;
export type CartoonLineOutput = zod.output<typeof CartoonLine>;

export const pronunciationRespellingMax = 200;

export const pronunciationWordMax = 200;



export const Pronunciation = zod.object({
  "respelling": zod.string().max(pronunciationRespellingMax),
  "word": zod.string().max(pronunciationWordMax)
}).describe('A word a voice model could misread, and how to say it (live\'s `pronunciations`).');

export type Pronunciation = zod.input<typeof Pronunciation>;
export type PronunciationOutput = zod.output<typeof Pronunciation>;

export const cartoonShotActionMax = 2000;

export const cartoonShotCameraMax = 200;



export const CartoonShot = zod.object({
  "action": zod.string().max(cartoonShotActionMax),
  "camera": zod.string().max(cartoonShotCameraMax)
}).describe('One storyboard shot (the playbook\'s S1 to S11, L1590-1600): what happens in it, with the\ncreature at its fixed spot, and the camera.');

export type CartoonShot = zod.input<typeof CartoonShot>;
export type CartoonShotOutput = zod.output<typeof CartoonShot>;

export const cartoonScriptCleanLockMax = 2000;

export const cartoonScriptCreatureLockMax = 2000;

export const cartoonScriptCreatureNameMax = 200;

export const cartoonScriptCreatureVoiceMax = 2000;

export const cartoonScriptLinesMax = 60;

export const cartoonScriptLocationLockMax = 2000;

export const cartoonScriptMixedMediaLockMax = 2000;

export const cartoonScriptProductLockMax = 8000;

export const cartoonScriptProductShortMax = 200;

export const cartoonScriptPronunciationsMax = 60;

export const cartoonScriptShotsMax = 60;

export const cartoonScriptSuperLineMax = 200;

export const cartoonScriptSuperNameMax = 200;

export const cartoonScriptWomanLockMax = 2000;

export const cartoonScriptWomanNameMax = 200;



export const CartoonScript = zod.object({
  "clean_lock": zod.string().max(cartoonScriptCleanLockMax),
  "creature_lock": zod.string().max(cartoonScriptCreatureLockMax),
  "creature_name": zod.string().max(cartoonScriptCreatureNameMax),
  "creature_voice": zod.string().max(cartoonScriptCreatureVoiceMax),
  "lines": zod.array(CartoonLine).min(1).max(cartoonScriptLinesMax),
  "location_lock": zod.string().max(cartoonScriptLocationLockMax),
  "mixed_media_lock": zod.string().max(cartoonScriptMixedMediaLockMax),
  "product_lock": zod.string().max(cartoonScriptProductLockMax),
  "product_short": zod.string().max(cartoonScriptProductShortMax),
  "pronunciations": zod.array(Pronunciation).max(cartoonScriptPronunciationsMax),
  "shots": zod.array(CartoonShot).min(1).max(cartoonScriptShotsMax),
  "super_line": zod.string().max(cartoonScriptSuperLineMax),
  "super_name": zod.string().max(cartoonScriptSuperNameMax),
  "woman_lock": zod.string().max(cartoonScriptWomanLockMax),
  "woman_name": zod.string().max(cartoonScriptWomanNameMax)
}).describe('Cartoon character in the real world\'s script (spec G14-cartoon-in-the-real-world; the\nplaybook\'s Fill in, L1547-1553): the director\'s answer, edited in the form before approval.\nIts eleven lines and shots, the names, the five locks pasted into every still and clip\n(L1577-1581) and the clean-surface lock (L1686), the creature\'s voice, the hero\'s super\n(L1684) and the respellings. `templates/cartoon_script.py` checks it.');

export type CartoonScript = zod.input<typeof CartoonScript>;
export type CartoonScriptOutput = zod.output<typeof CartoonScript>;

export const CartoonApproval = zod.object({
  "inputs": CartoonPickedInputs,
  "script": CartoonScript
}).describe('`POST .../draft/approve`: Approve script, the form and the script as edited.');

export type CartoonApproval = zod.input<typeof CartoonApproval>;
export type CartoonApprovalOutput = zod.output<typeof CartoonApproval>;

export const cartoonClonePickedInputsProductCategoryDefault = ``;
export const cartoonClonePickedInputsProductCategoryMax = 200;

export const cartoonClonePickedInputsProductNameDefault = ``;
export const cartoonClonePickedInputsProductNameMax = 200;

export const cartoonClonePickedInputsProductTextDefault = ``;
export const cartoonClonePickedInputsProductTextMax = 20000;

export const cartoonClonePickedInputsResolutionDefault = `720p`;
export const cartoonClonePickedInputsRightsDefault = false;

export const CartoonClonePickedInputs = zod.object({
  "product": PackshotProduct,
  "product_category": zod.string().max(cartoonClonePickedInputsProductCategoryMax).default(cartoonClonePickedInputsProductCategoryDefault),
  "product_name": zod.string().max(cartoonClonePickedInputsProductNameMax).default(cartoonClonePickedInputsProductNameDefault),
  "product_text": zod.string().max(cartoonClonePickedInputsProductTextMax).default(cartoonClonePickedInputsProductTextDefault),
  "resolution": zod.enum(['480p', '720p', '1080p']).default(cartoonClonePickedInputsResolutionDefault),
  "rights": zod.boolean().default(cartoonClonePickedInputsRightsDefault),
  "source_ad": zod.union([AssetRef,zod.null()]).exactOptional()
}).describe('The form with its product picked, as Generate Script and Approve script need it (422 at\n`product` with the drafts\' pick words).');

export type CartoonClonePickedInputs = zod.input<typeof CartoonClonePickedInputs>;
export type CartoonClonePickedInputsOutput = zod.output<typeof CartoonClonePickedInputs>;

export const cartoonCloneShotActionMax = 300;



export const CartoonCloneShot = zod.object({
  "action": zod.string().max(cartoonCloneShotActionMax),
  "face": zod.boolean()
}).describe('One of the source ad\'s shots as Cartoon clone\'s director reads it (G14-cartoon-clone): what\nhappens in it, for the clips\' shot mapping, and whether the person\'s face is in it (a hands-only\nshot is drawn from its frame and the set alone).');

export type CartoonCloneShot = zod.input<typeof CartoonCloneShot>;
export type CartoonCloneShotOutput = zod.output<typeof CartoonCloneShot>;

export const cartoonCloneScriptChangesMax = 20;

export const cartoonCloneScriptClaimsMax = 12;

export const cartoonCloneScriptEnvShotMax = 12;

export const cartoonCloneScriptFaceLockMax = 800;

export const cartoonCloneScriptFirstShotsItemMax = 12;

export const cartoonCloneScriptFirstShotsMax = 2;

export const cartoonCloneScriptLineMax = 1200;

export const cartoonCloneScriptProductDescriptionMax = 600;

export const cartoonCloneScriptSetMax = 120;

export const cartoonCloneScriptSetFixturesMax = 400;

export const cartoonCloneScriptShotsMax = 12;

export const cartoonCloneScriptSurfaceMax = 120;

export const cartoonCloneScriptVoiceMax = 600;

export const cartoonCloneScriptWardrobeLockMax = 400;

export const cartoonCloneScriptWordmarkMax = 80;



export const CartoonCloneScript = zod.object({
  "changes": zod.array(AdSwapChange).max(cartoonCloneScriptChangesMax),
  "claims": zod.array(AdSwapClaim).max(cartoonCloneScriptClaimsMax),
  "env_shot": zod.int().min(1).max(cartoonCloneScriptEnvShotMax),
  "face_lock": zod.string().max(cartoonCloneScriptFaceLockMax),
  "first_shots": zod.array(zod.int().min(1).max(cartoonCloneScriptFirstShotsItemMax)).max(cartoonCloneScriptFirstShotsMax),
  "line": zod.string().max(cartoonCloneScriptLineMax),
  "person": zod.enum(['woman', 'man']),
  "product_description": zod.string().max(cartoonCloneScriptProductDescriptionMax),
  "pronoun": zod.enum(['she', 'he']),
  "set": zod.string().max(cartoonCloneScriptSetMax),
  "set_fixtures": zod.string().max(cartoonCloneScriptSetFixturesMax),
  "shots": zod.array(CartoonCloneShot).max(cartoonCloneScriptShotsMax),
  "surface": zod.string().max(cartoonCloneScriptSurfaceMax),
  "voice": zod.string().max(cartoonCloneScriptVoiceMax),
  "wardrobe_lock": zod.string().max(cartoonCloneScriptWardrobeLockMax),
  "wordmark": zod.string().max(cartoonCloneScriptWordmarkMax)
}).describe('Cartoon clone\'s script (G14-cartoon-clone): the clone director\'s answer, as the member\nedits and approves it. The voiceover\'s line (the source\'s words, only the forced changes); the\nset and its fixtures; the character\'s face and wardrobe locks, written from the frames; the\npack written out and its wordmark as the brand writes it; the surface the hands-only shots sit\non; the designed voice\'s description; the person and pronoun; the widest shot\n(the set\'s frame) and the two face shots the first cartoon frames redraw; one entry per shot;\nthe changes made and the claims kept.');

export type CartoonCloneScript = zod.input<typeof CartoonCloneScript>;
export type CartoonCloneScriptOutput = zod.output<typeof CartoonCloneScript>;

export const CartoonCloneApproval = zod.object({
  "inputs": CartoonClonePickedInputs,
  "script": CartoonCloneScript
}).describe('`POST .../draft/approve`: Approve script, the form and the script as edited.');

export type CartoonCloneApproval = zod.input<typeof CartoonCloneApproval>;
export type CartoonCloneApprovalOutput = zod.output<typeof CartoonCloneApproval>;

export const cartoonCloneInputsProductCategoryDefault = ``;
export const cartoonCloneInputsProductCategoryMax = 200;

export const cartoonCloneInputsProductNameDefault = ``;
export const cartoonCloneInputsProductNameMax = 200;

export const cartoonCloneInputsProductTextDefault = ``;
export const cartoonCloneInputsProductTextMax = 20000;

export const cartoonCloneInputsResolutionDefault = `720p`;
export const cartoonCloneInputsRightsDefault = false;

export const CartoonCloneInputs = zod.object({
  "product": zod.union([PackshotProduct,zod.null()]).exactOptional(),
  "product_category": zod.string().max(cartoonCloneInputsProductCategoryMax).default(cartoonCloneInputsProductCategoryDefault),
  "product_name": zod.string().max(cartoonCloneInputsProductNameMax).default(cartoonCloneInputsProductNameDefault),
  "product_text": zod.string().max(cartoonCloneInputsProductTextMax).default(cartoonCloneInputsProductTextDefault),
  "resolution": zod.enum(['480p', '720p', '1080p']).default(cartoonCloneInputsResolutionDefault),
  "rights": zod.boolean().default(cartoonCloneInputsRightsDefault),
  "source_ad": zod.union([AssetRef,zod.null()]).exactOptional()
}).describe('Cartoon clone\'s form so far: the product (none until picked), and the rest.');

export type CartoonCloneInputs = zod.input<typeof CartoonCloneInputs>;
export type CartoonCloneInputsOutput = zod.output<typeof CartoonCloneInputs>;

export const CartoonCloneStillName = zod.enum(['first_a', 'first_b', 'sheet', 'env', 'shot_a', 'shot_b', 'shot_c', 'shot_d', 'shot_e', 'shot_f', 'shot_g', 'shot_h', 'shot_i', 'shot_j', 'shot_k', 'shot_l']);

export type CartoonCloneStillName = zod.input<typeof CartoonCloneStillName>;
export type CartoonCloneStillNameOutput = zod.output<typeof CartoonCloneStillName>;

export const CartoonCloneDraftStill = zod.object({
  "name": CartoonCloneStillName,
  "output": zod.union([OutputRef,zod.null()]).exactOptional(),
  "problem": zod.union([zod.string(),zod.null()]),
  "status": StillStatus,
  "url": zod.union([zod.string(),zod.null()])
}).describe('A still of Cartoon clone\'s cast, as `DraftStill`.');

export type CartoonCloneDraftStill = zod.input<typeof CartoonCloneDraftStill>;
export type CartoonCloneDraftStillOutput = zod.output<typeof CartoonCloneDraftStill>;

export const CartoonCloneVoice = zod.object({
  "job_id": zod.union([zod.uuid(),zod.null()]).exactOptional(),
  "problem": zod.union([zod.string(),zod.null()]),
  "status": StillStatus,
  "url": zod.union([zod.string(),zod.null()])
}).describe('Cartoon clone\'s designed voice (G14-cartoon-clone, CartoonClone-12): its state, its preview\nonce designed, and the design\'s job, which "Generate video" saves as the brand\'s voice.');

export type CartoonCloneVoice = zod.input<typeof CartoonCloneVoice>;
export type CartoonCloneVoiceOutput = zod.output<typeof CartoonCloneVoice>;

export const CartoonCloneDraft = zod.object({
  "inputs": CartoonCloneInputs,
  "pack_director": DirectorState,
  "pack_warning": zod.boolean(),
  "problem": zod.union([zod.string(),zod.null()]),
  "reading": zod.union([AdSwapSourceRead,zod.null()]),
  "reading_director": DirectorState,
  "script": zod.union([CartoonCloneScript,zod.null()]),
  "script_director": DirectorState,
  "script_problems": zod.array(zod.string()),
  "stage": DraftStage,
  "stills": zod.array(CartoonCloneDraftStill),
  "updated_at": zod.iso.datetime({"offset":true}),
  "urls_expire_at": zod.union([zod.iso.datetime({"offset":true}),zod.null()]),
  "voice": zod.union([CartoonCloneVoice,zod.null()])
}).describe('A member\'s Cartoon clone draft in the brand (G14-cartoon-clone): the form, the stage, the\nscript and the steps that make it (the pack reader\'s, the source ad\'s reading, the clone\ndirector\'s), the reading and its parts, what is still off in the script after the director\'s\nredo, the last step that failed for good (`problem`), and once the script is approved the\ncast\'s stills and the designed voice.');

export type CartoonCloneDraft = zod.input<typeof CartoonCloneDraft>;
export type CartoonCloneDraftOutput = zod.output<typeof CartoonCloneDraft>;

export const CartoonCloneDraftWrite = zod.object({
  "inputs": CartoonCloneInputs,
  "script": zod.union([CartoonCloneScript,zod.null()]).exactOptional()
}).describe('`PUT .../templates/cartoon-clone/draft`: the form as it stands, its script as edited.');

export type CartoonCloneDraftWrite = zod.input<typeof CartoonCloneDraftWrite>;
export type CartoonCloneDraftWriteOutput = zod.output<typeof CartoonCloneDraftWrite>;

export const CartoonCloneScriptAsk = zod.object({
  "inputs": CartoonClonePickedInputs
}).describe('`POST .../draft/script`: Generate Script, on the form as it stands.');

export type CartoonCloneScriptAsk = zod.input<typeof CartoonCloneScriptAsk>;
export type CartoonCloneScriptAskOutput = zod.output<typeof CartoonCloneScriptAsk>;

export const cartoonInputsBrandDefault = ``;
export const cartoonInputsBrandMax = 100;

export const cartoonInputsProductCategoryDefault = ``;
export const cartoonInputsProductCategoryMax = 200;

export const cartoonInputsProductNameDefault = ``;
export const cartoonInputsProductNameMax = 200;

export const cartoonInputsProductTextDefault = ``;
export const cartoonInputsProductTextMax = 20000;

export const cartoonInputsResolutionDefault = `720p`;
export const cartoonInputsSizeDefault = ``;
export const cartoonInputsSizeMax = 200;

export const cartoonInputsSubtitlesDefault = true;
export const cartoonInputsSurfaceDefault = ``;
export const cartoonInputsSurfaceMax = 200;



export const CartoonInputs = zod.object({
  "brand": zod.string().max(cartoonInputsBrandMax).default(cartoonInputsBrandDefault),
  "product": zod.union([PackshotProduct,zod.null()]).exactOptional(),
  "product_category": zod.string().max(cartoonInputsProductCategoryMax).default(cartoonInputsProductCategoryDefault),
  "product_name": zod.string().max(cartoonInputsProductNameMax).default(cartoonInputsProductNameDefault),
  "product_text": zod.string().max(cartoonInputsProductTextMax).default(cartoonInputsProductTextDefault),
  "resolution": zod.enum(['720p', '480p']).default(cartoonInputsResolutionDefault),
  "size": zod.string().max(cartoonInputsSizeMax).default(cartoonInputsSizeDefault),
  "subtitles": zod.boolean().default(cartoonInputsSubtitlesDefault),
  "surface": zod.string().max(cartoonInputsSurfaceMax).default(cartoonInputsSurfaceDefault)
}).describe('The form so far: the product (none until picked), and the rest.');

export type CartoonInputs = zod.input<typeof CartoonInputs>;
export type CartoonInputsOutput = zod.output<typeof CartoonInputs>;

export const CartoonStillName = zod.enum(['creature_sheet', 'scale_plate', 'woman_sheet', 'room_master', 'product_sheet', 's1', 's2', 's3', 's4', 's5', 's6', 's7', 's8', 's9', 's10', 's11']);

export type CartoonStillName = zod.input<typeof CartoonStillName>;
export type CartoonStillNameOutput = zod.output<typeof CartoonStillName>;

export const CartoonDraftStill = zod.object({
  "name": CartoonStillName,
  "output": zod.union([OutputRef,zod.null()]).exactOptional(),
  "problem": zod.union([zod.string(),zod.null()]),
  "status": StillStatus,
  "url": zod.union([zod.string(),zod.null()])
}).describe('One of the sixteen stills, as `DraftStill`.');

export type CartoonDraftStill = zod.input<typeof CartoonDraftStill>;
export type CartoonDraftStillOutput = zod.output<typeof CartoonDraftStill>;

export const CartoonDraft = zod.object({
  "inputs": CartoonInputs,
  "pack_director": DirectorState,
  "pack_warning": zod.boolean(),
  "problem": zod.union([zod.string(),zod.null()]),
  "script": zod.union([CartoonScript,zod.null()]),
  "script_director": DirectorState,
  "script_problems": zod.array(zod.string()),
  "stage": DraftStage,
  "stills": zod.array(CartoonDraftStill),
  "updated_at": zod.iso.datetime({"offset":true}),
  "urls_expire_at": zod.union([zod.iso.datetime({"offset":true}),zod.null()])
}).describe('A member\'s draft in the brand: the form, the stage, the script and its directors (the pack\nreader\'s, then the script\'s), and the stills. `pack_warning`: the pack was hard to read.\n`script_problems`: what Approve would still refuse after the director\'s redo, in its words;\nempty for a script that passes. `problem`: the words of the last director that failed.\n`stills` is empty until the script is approved.');

export type CartoonDraft = zod.input<typeof CartoonDraft>;
export type CartoonDraftOutput = zod.output<typeof CartoonDraft>;

export const CartoonDraftWrite = zod.object({
  "inputs": CartoonInputs,
  "script": zod.union([CartoonScript,zod.null()]).exactOptional()
}).describe('`PUT .../templates/cartoon-character-in-the-real-world/draft`: the form as it stands, its\nscript as edited.');

export type CartoonDraftWrite = zod.input<typeof CartoonDraftWrite>;
export type CartoonDraftWriteOutput = zod.output<typeof CartoonDraftWrite>;

export const CartoonScriptAsk = zod.object({
  "inputs": CartoonPickedInputs
}).describe('`POST .../draft/script`: Generate script, on the form as it stands.');

export type CartoonScriptAsk = zod.input<typeof CartoonScriptAsk>;
export type CartoonScriptAskOutput = zod.output<typeof CartoonScriptAsk>;

export const CartoonStills = zod.object({
  "creature_sheet": OutputRef,
  "product_sheet": OutputRef,
  "room_master": OutputRef,
  "s1": OutputRef,
  "s10": OutputRef,
  "s11": OutputRef,
  "s2": OutputRef,
  "s3": OutputRef,
  "s4": OutputRef,
  "s5": OutputRef,
  "s6": OutputRef,
  "s7": OutputRef,
  "s8": OutputRef,
  "s9": OutputRef,
  "woman_sheet": OutputRef
}).describe('The stills the generations are drawn from (L1606), each the draft\'s still\'s picture, an\nearlier output: a storyboard still a shot, the three sheets and the room master. The scale\nplate is no generation\'s.');

export type CartoonStills = zod.input<typeof CartoonStills>;
export type CartoonStillsOutput = zod.output<typeof CartoonStills>;

export const cartoonVideoInputsResolutionDefault = `720p`;
export const cartoonVideoInputsSubtitlesDefault = true;

export const CartoonVideoInputs = zod.object({
  "narrator_voice_id": zod.uuid(),
  "resolution": zod.enum(['720p', '480p']).default(cartoonVideoInputsResolutionDefault),
  "script": CartoonScript,
  "stills": CartoonStills,
  "subtitles": zod.boolean().default(cartoonVideoInputsSubtitlesDefault),
  "template": zod.enum(['cartoon-character-in-the-real-world'])
}).describe('Cartoon character in the real world\'s "Generate video" (spec\nG14-cartoon-in-the-real-world, "The run", PR c): the approved script, the stills, the\nnarrator\'s voice (the member\'s pick, Cartoon-10), the subtitles and the clips\' resolution. One\n`video.template` tile (`templates/cartoon_real_world.py`).');

export type CartoonVideoInputs = zod.input<typeof CartoonVideoInputs>;
export type CartoonVideoInputsOutput = zod.output<typeof CartoonVideoInputs>;

export const cartoonVillainPickedInputsAilmentDefault = ``;
export const cartoonVillainPickedInputsAilmentMax = 200;

export const cartoonVillainPickedInputsBrandAsSaidDefault = ``;
export const cartoonVillainPickedInputsBrandAsSaidMax = 100;

export const cartoonVillainPickedInputsProductCategoryDefault = ``;
export const cartoonVillainPickedInputsProductCategoryMax = 200;

export const cartoonVillainPickedInputsProductNameDefault = ``;
export const cartoonVillainPickedInputsProductNameMax = 200;

export const cartoonVillainPickedInputsProductTextDefault = ``;
export const cartoonVillainPickedInputsProductTextMax = 20000;

export const cartoonVillainPickedInputsResolutionDefault = `720p`;
export const cartoonVillainPickedInputsTakesDefault = 1;
export const cartoonVillainPickedInputsTakesMax = 3;



export const CartoonVillainPickedInputs = zod.object({
  "ailment": zod.string().max(cartoonVillainPickedInputsAilmentMax).default(cartoonVillainPickedInputsAilmentDefault),
  "brand_as_said": zod.string().max(cartoonVillainPickedInputsBrandAsSaidMax).default(cartoonVillainPickedInputsBrandAsSaidDefault),
  "product": PackshotProduct,
  "product_category": zod.string().max(cartoonVillainPickedInputsProductCategoryMax).default(cartoonVillainPickedInputsProductCategoryDefault),
  "product_name": zod.string().max(cartoonVillainPickedInputsProductNameMax).default(cartoonVillainPickedInputsProductNameDefault),
  "product_text": zod.string().max(cartoonVillainPickedInputsProductTextMax).default(cartoonVillainPickedInputsProductTextDefault),
  "resolution": zod.literal("720p").default(cartoonVillainPickedInputsResolutionDefault).meta({ title: 'Resolution' }),
  "takes": zod.int().min(1).max(cartoonVillainPickedInputsTakesMax).default(cartoonVillainPickedInputsTakesDefault)
}).describe('The form with its product picked, as Generate script and Approve script need it (422 at\n`product`, `PICK_PRODUCT`).');

export type CartoonVillainPickedInputs = zod.input<typeof CartoonVillainPickedInputs>;
export type CartoonVillainPickedInputsOutput = zod.output<typeof CartoonVillainPickedInputs>;

export const cartoonVillainScriptAilmentMax = 2000;

export const cartoonVillainScriptAnatomyMax = 2000;

export const cartoonVillainScriptAnatomySurfaceMax = 2000;

export const cartoonVillainScriptBodyPartMax = 2000;

export const cartoonVillainScriptBodyTextureAndColorsMax = 2000;

export const cartoonVillainScriptBragMax = 2000;

export const cartoonVillainScriptBrandMax = 2000;

export const cartoonVillainScriptBrandAsSaidMax = 2000;

export const cartoonVillainScriptBrandColorsItemMax = 7;

export const cartoonVillainScriptBrandColorsMax = 4;

export const cartoonVillainScriptBrandWordmarkMax = 2000;

export const cartoonVillainScriptBusinessEndMax = 2000;

export const cartoonVillainScriptCreatureMax = 2000;

export const cartoonVillainScriptCreatureShortMax = 2000;

export const cartoonVillainScriptCtaButtonMax = 2000;

export const cartoonVillainScriptEdgeMax = 2000;

export const cartoonVillainScriptHeadFeatureMax = 2000;

export const cartoonVillainScriptHeadlineMax = 2000;

export const cartoonVillainScriptHideBeneathMax = 2000;

export const cartoonVillainScriptHideCoverMax = 2000;

export const cartoonVillainScriptHideGapMax = 2000;

export const cartoonVillainScriptHideWhereMax = 2000;

export const cartoonVillainScriptLabelColorMax = 2000;

export const cartoonVillainScriptLabelPlacementMax = 2000;

export const cartoonVillainScriptProductShapeMax = 2000;

export const cartoonVillainScriptProductTypeMax = 2000;

export const cartoonVillainScriptPronunciationGuideMax = 2000;

export const cartoonVillainScriptScaleObjectMax = 2000;

export const cartoonVillainScriptShotGapMax = 2000;

export const cartoonVillainScriptShotWhereMax = 2000;

export const cartoonVillainScriptSupportLineMax = 2000;

export const cartoonVillainScriptSurfaceMax = 2000;

export const cartoonVillainScriptTargetMax = 2000;

export const cartoonVillainScriptTextColorAndCaseMax = 2000;

export const cartoonVillainScriptTextDirectionMax = 2000;



export const CartoonVillainScript = zod.object({
  "ailment": zod.string().max(cartoonVillainScriptAilmentMax),
  "anatomy": zod.string().max(cartoonVillainScriptAnatomyMax),
  "anatomy_surface": zod.string().max(cartoonVillainScriptAnatomySurfaceMax),
  "body_part": zod.string().max(cartoonVillainScriptBodyPartMax),
  "body_texture_and_colors": zod.string().max(cartoonVillainScriptBodyTextureAndColorsMax),
  "brag": zod.string().max(cartoonVillainScriptBragMax),
  "brand": zod.string().max(cartoonVillainScriptBrandMax),
  "brand_as_said": zod.string().max(cartoonVillainScriptBrandAsSaidMax),
  "brand_colors": zod.array(zod.string().max(cartoonVillainScriptBrandColorsItemMax)).max(cartoonVillainScriptBrandColorsMax),
  "brand_wordmark": zod.string().max(cartoonVillainScriptBrandWordmarkMax),
  "business_end": zod.string().max(cartoonVillainScriptBusinessEndMax),
  "creature": zod.string().max(cartoonVillainScriptCreatureMax),
  "creature_short": zod.string().max(cartoonVillainScriptCreatureShortMax),
  "cta_button": zod.string().max(cartoonVillainScriptCtaButtonMax),
  "edge": zod.string().max(cartoonVillainScriptEdgeMax),
  "head_feature": zod.string().max(cartoonVillainScriptHeadFeatureMax),
  "headline": zod.string().max(cartoonVillainScriptHeadlineMax),
  "hide_beneath": zod.string().max(cartoonVillainScriptHideBeneathMax),
  "hide_cover": zod.string().max(cartoonVillainScriptHideCoverMax),
  "hide_gap": zod.string().max(cartoonVillainScriptHideGapMax),
  "hide_where": zod.string().max(cartoonVillainScriptHideWhereMax),
  "label_color": zod.string().max(cartoonVillainScriptLabelColorMax),
  "label_placement": zod.string().max(cartoonVillainScriptLabelPlacementMax),
  "product_shape": zod.string().max(cartoonVillainScriptProductShapeMax),
  "product_type": zod.string().max(cartoonVillainScriptProductTypeMax),
  "pronunciation_guide": zod.string().max(cartoonVillainScriptPronunciationGuideMax),
  "scale_object": zod.string().max(cartoonVillainScriptScaleObjectMax),
  "shot_gap": zod.string().max(cartoonVillainScriptShotGapMax),
  "shot_where": zod.string().max(cartoonVillainScriptShotWhereMax),
  "support_line": zod.string().max(cartoonVillainScriptSupportLineMax),
  "surface": zod.string().max(cartoonVillainScriptSurfaceMax),
  "target": zod.string().max(cartoonVillainScriptTargetMax),
  "text_color_and_case": zod.string().max(cartoonVillainScriptTextColorAndCaseMax),
  "text_direction": zod.string().max(cartoonVillainScriptTextDirectionMax)
}).describe('The brand as written, as said and as printed; the villain\'s brag; the villain, the body\npart and the product as the locks describe them; where the villain hides and where the\nproduct points; the end card\'s words and the brand\'s colours (hex).');

export type CartoonVillainScript = zod.input<typeof CartoonVillainScript>;
export type CartoonVillainScriptOutput = zod.output<typeof CartoonVillainScript>;

export const CartoonVillainApproval = zod.object({
  "inputs": CartoonVillainPickedInputs,
  "script": CartoonVillainScript
}).describe('`POST .../draft/approve`: Approve script, the form and the script as edited.');

export type CartoonVillainApproval = zod.input<typeof CartoonVillainApproval>;
export type CartoonVillainApprovalOutput = zod.output<typeof CartoonVillainApproval>;

export const cartoonVillainInputsAilmentDefault = ``;
export const cartoonVillainInputsAilmentMax = 200;

export const cartoonVillainInputsBrandAsSaidDefault = ``;
export const cartoonVillainInputsBrandAsSaidMax = 100;

export const cartoonVillainInputsProductCategoryDefault = ``;
export const cartoonVillainInputsProductCategoryMax = 200;

export const cartoonVillainInputsProductNameDefault = ``;
export const cartoonVillainInputsProductNameMax = 200;

export const cartoonVillainInputsProductTextDefault = ``;
export const cartoonVillainInputsProductTextMax = 20000;

export const cartoonVillainInputsResolutionDefault = `720p`;
export const cartoonVillainInputsTakesDefault = 1;
export const cartoonVillainInputsTakesMax = 3;



export const CartoonVillainInputs = zod.object({
  "ailment": zod.string().max(cartoonVillainInputsAilmentMax).default(cartoonVillainInputsAilmentDefault),
  "brand_as_said": zod.string().max(cartoonVillainInputsBrandAsSaidMax).default(cartoonVillainInputsBrandAsSaidDefault),
  "product": zod.union([PackshotProduct,zod.null()]).exactOptional(),
  "product_category": zod.string().max(cartoonVillainInputsProductCategoryMax).default(cartoonVillainInputsProductCategoryDefault),
  "product_name": zod.string().max(cartoonVillainInputsProductNameMax).default(cartoonVillainInputsProductNameDefault),
  "product_text": zod.string().max(cartoonVillainInputsProductTextMax).default(cartoonVillainInputsProductTextDefault),
  "resolution": zod.literal("720p").default(cartoonVillainInputsResolutionDefault).meta({ title: 'Resolution' }),
  "takes": zod.int().min(1).max(cartoonVillainInputsTakesMax).default(cartoonVillainInputsTakesDefault)
}).describe('Cartoon villain\'s form so far: the product (none until picked), and the rest.');

export type CartoonVillainInputs = zod.input<typeof CartoonVillainInputs>;
export type CartoonVillainInputsOutput = zod.output<typeof CartoonVillainInputs>;

export const CartoonVillainStillName = zod.enum(['sheet', 'home', 's1', 's2', 'end_card']);

export type CartoonVillainStillName = zod.input<typeof CartoonVillainStillName>;
export type CartoonVillainStillNameOutput = zod.output<typeof CartoonVillainStillName>;

export const CartoonVillainDraftStill = zod.object({
  "name": CartoonVillainStillName,
  "output": zod.union([OutputRef,zod.null()]).exactOptional(),
  "problem": zod.union([zod.string(),zod.null()]),
  "status": StillStatus,
  "url": zod.union([zod.string(),zod.null()])
}).describe('One of the five stills, as `DraftStill`.');

export type CartoonVillainDraftStill = zod.input<typeof CartoonVillainDraftStill>;
export type CartoonVillainDraftStillOutput = zod.output<typeof CartoonVillainDraftStill>;

export const CartoonVillainDraft = zod.object({
  "inputs": CartoonVillainInputs,
  "pack_director": DirectorState,
  "pack_warning": zod.boolean(),
  "problem": zod.union([zod.string(),zod.null()]),
  "script": zod.union([CartoonVillainScript,zod.null()]),
  "script_director": DirectorState,
  "stage": DraftStage,
  "stills": zod.array(CartoonVillainDraftStill),
  "updated_at": zod.iso.datetime({"offset":true}),
  "urls_expire_at": zod.union([zod.iso.datetime({"offset":true}),zod.null()])
}).describe('A member\'s Cartoon villain draft in the brand: the form, the stage, the script and its\ndirectors (the pack reader\'s, then the script\'s), and the stills. `pack_warning`: the pack\nwas hard to read. `problem`: the words for the last step that failed. `stills` is empty until\nthe script is approved.');

export type CartoonVillainDraft = zod.input<typeof CartoonVillainDraft>;
export type CartoonVillainDraftOutput = zod.output<typeof CartoonVillainDraft>;

export const CartoonVillainDraftWrite = zod.object({
  "inputs": CartoonVillainInputs,
  "script": zod.union([CartoonVillainScript,zod.null()]).exactOptional()
}).describe('`PUT .../templates/cartoon-villain/draft`: the form as it stands, its script as edited.');

export type CartoonVillainDraftWrite = zod.input<typeof CartoonVillainDraftWrite>;
export type CartoonVillainDraftWriteOutput = zod.output<typeof CartoonVillainDraftWrite>;

export const CartoonVillainScriptAsk = zod.object({
  "inputs": CartoonVillainPickedInputs
}).describe('`POST .../draft/script`: Generate script, on the form as it stands.');

export type CartoonVillainScriptAsk = zod.input<typeof CartoonVillainScriptAsk>;
export type CartoonVillainScriptAskOutput = zod.output<typeof CartoonVillainScriptAsk>;

export const CastPronoun = zod.enum(['she', 'he']);

export type CastPronoun = zod.input<typeof CastPronoun>;
export type CastPronounOutput = zod.output<typeof CastPronoun>;

export const castPersonIdentityMax = 2000;

export const castPersonOutfitMax = 2000;

export const castPersonPoseNoteMax = 2000;

export const castPersonVoiceMax = 2000;



export const CastPerson = zod.object({
  "identity": zod.string().min(1).max(castPersonIdentityMax),
  "outfit": zod.string().min(1).max(castPersonOutfitMax),
  "pose_note": zod.string().min(1).max(castPersonPoseNoteMax),
  "pronoun": CastPronoun,
  "voice": zod.string().min(1).max(castPersonVoiceMax)
}).describe('The host or the guest as the director casts them (live\'s `personSchema`).');

export type CastPerson = zod.input<typeof CastPerson>;
export type CastPersonOutput = zod.output<typeof CastPerson>;

export const videoTariffByInputOneRegExpOne = new RegExp('^[a-z][a-z0-9_-]*(\\.[a-z0-9][a-z0-9_-]*)+$');
export const videoTariffSkuRegExp = new RegExp('^[a-z][a-z0-9_-]*(\\.[a-z0-9][a-z0-9_-]*)+$');


export const VideoTariff = zod.object({
  "by_input": zod.union([zod.record(zod.string(), zod.string().regex(videoTariffByInputOneRegExpOne)),zod.null()]).exactOptional(),
  "sku": zod.string().regex(videoTariffSkuRegExp)
}).describe('FAL\'s video tariff (Kling 4.0: "with video references or video elements"; live\'s `_video`\nunits and floored input side, ai-backend #518, G2-kling-v4-video-elements): the SKU a job\nthat sends a video is priced under, by the row\'s inputs as its own, on the output\'s seconds\nplus the input videos\' exact seconds, those never fewer than the output\'s ("minimum 2x the\noutput").');

export type VideoTariff = zod.input<typeof VideoTariff>;
export type VideoTariffOutput = zod.output<typeof VideoTariff>;

export const MeteringPer = zod.enum(['output', 'second', 'character', 'token']).describe('What one unit of a model\'s SKU is: one delivered output, one second of video or audio (the\nseconds asked for, for audio, as live bills them), one character of a text (speech), or one\ntoken an LLM wrote (a shot list, #223; the tokens it read go on the row\'s `input_sku`).');

export type MeteringPer = zod.input<typeof MeteringPer>;
export type MeteringPerOutput = zod.output<typeof MeteringPer>;

export const meteringByInputOneRegExpOne = new RegExp('^[a-z][a-z0-9_-]*(\\.[a-z0-9][a-z0-9_-]*)+$');
export const meteringInputSkuOneRegExp = new RegExp('^[a-z][a-z0-9_-]*(\\.[a-z0-9][a-z0-9_-]*)+$');
export const meteringSkuRegExp = new RegExp('^[a-z][a-z0-9_-]*(\\.[a-z0-9][a-z0-9_-]*)+$');
export const meteringSourceSecondsDefault = false;

export const Metering = zod.object({
  "by_input": zod.union([zod.record(zod.string(), zod.string().regex(meteringByInputOneRegExpOne)),zod.null()]).exactOptional(),
  "input_seconds": zod.union([VideoTariff,zod.null()]).exactOptional(),
  "input_sku": zod.union([zod.string().regex(meteringInputSkuOneRegExp),zod.null()]).exactOptional(),
  "per": MeteringPer,
  "sku": zod.string().regex(meteringSkuRegExp),
  "source_seconds": zod.boolean().default(meteringSourceSecondsDefault),
  "with_videos": zod.union([VideoTariff,zod.null()]).exactOptional()
}).describe('The SKU a model\'s usage is billed under (`backend/data/prices`) and what a unit is.');

export type Metering = zod.input<typeof Metering>;
export type MeteringOutput = zod.output<typeof Metering>;

export const MusicDurationControl = zod.enum(['exact_seconds', 'fixed', 'model_chosen']).describe('How a music model\'s length is set: asked for to the second (ElevenLabs), fixed (Lyria\nClip), or chosen by the model (Lyria Pro), as live\'s `MusicDurationControl`.');

export type MusicDurationControl = zod.input<typeof MusicDurationControl>;
export type MusicDurationControlOutput = zod.output<typeof MusicDurationControl>;

export const musicDurationDefaultSecondsOneMax = 600;

export const musicDurationFixedSecondsOneMax = 600;

export const musicDurationMaxSecondsOneMax = 600;

export const musicDurationMinSecondsOneMax = 600;






export const MusicDuration = zod.object({
  "control": MusicDurationControl,
  "default_seconds": zod.union([zod.int().min(1).max(musicDurationDefaultSecondsOneMax),zod.null()]).exactOptional(),
  "fixed_seconds": zod.union([zod.int().min(1).max(musicDurationFixedSecondsOneMax),zod.null()]).exactOptional(),
  "max_seconds": zod.union([zod.int().min(1).max(musicDurationMaxSecondsOneMax),zod.null()]).exactOptional(),
  "min_seconds": zod.union([zod.int().min(1).max(musicDurationMinSecondsOneMax),zod.null()]).exactOptional(),
  "presets": zod.union([zod.array(zod.int()).min(1),zod.null()]).exactOptional(),
  "typical_max_seconds": zod.union([zod.int().min(1),zod.null()]).exactOptional(),
  "typical_min_seconds": zod.union([zod.int().min(1),zod.null()]).exactOptional()
}).describe('A music model\'s length: for `exact_seconds`, the composer\'s presets and the range they\nare clipped to; for `fixed`, the one length; for `model_chosen`, what is typical (shown,\nnever promised).');

export type MusicDuration = zod.input<typeof MusicDuration>;
export type MusicDurationOutput = zod.output<typeof MusicDuration>;

export const inputCountMaxMin = 0;
export const inputCountMaxMax = 64;

export const inputCountMinDefault = 0;
export const inputCountMinMin = 0;



export const InputCount = zod.object({
  "max": zod.int().min(inputCountMaxMin).max(inputCountMaxMax),
  "min": zod.int().min(inputCountMinMin).default(inputCountMinDefault)
}).describe('How many of one input a job takes.');

export type InputCount = zod.input<typeof InputCount>;
export type InputCountOutput = zod.output<typeof InputCount>;





export const MusicMode = zod.object({
  "duration": MusicDuration,
  "force_instrumental": zod.boolean(),
  "image_mimes": zod.union([zod.array(zod.string()).min(1),zod.null()]),
  "notes": zod.array(zod.string()),
  "prompt_min_chars": zod.int().min(1),
  "reference_images": zod.union([InputCount,zod.null()]),
  "returns_lyrics": zod.boolean(),
  "seed": zod.boolean()
}).describe('`audio.music`: a track from a prompt.');

export type MusicMode = zod.input<typeof MusicMode>;
export type MusicModeOutput = zod.output<typeof MusicMode>;

export const stepRangeStepExclusiveMin = 0;



export const StepRange = zod.object({
  "default": zod.number(),
  "max": zod.number(),
  "min": zod.number(),
  "step": zod.number().gt(stepRangeStepExclusiveMin)
}).describe('A slider: live\'s `value_range` (min, max, step and the composer\'s default).');

export type StepRange = zod.input<typeof StepRange>;
export type StepRangeOutput = zod.output<typeof StepRange>;




export const SoundEffectsMode = zod.object({
  "duration_seconds": StepRange,
  "loop": zod.boolean(),
  "loop_default": zod.boolean(),
  "notes": zod.array(zod.string()),
  "prompt_influence": zod.union([StepRange,zod.null()]),
  "prompt_min_chars": zod.int().min(1)
}).describe('`audio.sfx`: a sound from a description, `duration_seconds` long.');

export type SoundEffectsMode = zod.input<typeof SoundEffectsMode>;
export type SoundEffectsModeOutput = zod.output<typeof SoundEffectsMode>;

export const SpeechMode = zod.object({
  "language_code": zod.boolean(),
  "notes": zod.array(zod.string()),
  "seed": zod.boolean(),
  "stability": StepRange
}).describe('`audio.tts`: a voice reads the prompt (the script).');

export type SpeechMode = zod.input<typeof SpeechMode>;
export type SpeechModeOutput = zod.output<typeof SpeechMode>;




export const VoiceDesignMode = zod.object({
  "notes": zod.array(zod.string()),
  "prompt_min_chars": zod.int().min(1)
}).describe('`voice.design`: a voice from a description (live: 20 to 1000 characters).');

export type VoiceDesignMode = zod.input<typeof VoiceDesignMode>;
export type VoiceDesignModeOutput = zod.output<typeof VoiceDesignMode>;

export const VoiceoverMode = zod.object({
  "notes": zod.array(zod.string()),
  "stability": StepRange
}).describe('`audio.voiceover`: an actor\'s voice reads a talking head\'s script (#222). Only the\nstability is the user\'s, as live\'s Talking Head form offers it.');

export type VoiceoverMode = zod.input<typeof VoiceoverMode>;
export type VoiceoverModeOutput = zod.output<typeof VoiceoverMode>;

export const catalogAudioModelCostTierMax = 5;

export const catalogAudioModelDescriptionMax = 160;

export const catalogAudioModelIdMax = 64;


export const catalogAudioModelIdRegExp = new RegExp('^[a-z0-9][a-z0-9.-]*$');

export const catalogAudioModelMakerMax = 40;

export const catalogAudioModelMaxOutputsMax = 16;

export const catalogAudioModelNameMax = 80;

export const catalogAudioModelPromptMaxCharsMax = 32000;



export const CatalogAudioModel = zod.object({
  "cost_tier": zod.int().min(1).max(catalogAudioModelCostTierMax),
  "description": zod.string().min(1).max(catalogAudioModelDescriptionMax),
  "id": zod.string().max(catalogAudioModelIdMax).regex(catalogAudioModelIdRegExp),
  "is_default": zod.boolean(),
  "is_new": zod.boolean(),
  "job_types": zod.array(GenerationType).min(1),
  "maker": zod.string().min(1).max(catalogAudioModelMakerMax),
  "max_outputs": zod.int().min(1).max(catalogAudioModelMaxOutputsMax),
  "medium": zod.literal("audio").meta({ title: 'Medium' }),
  "metering": Metering,
  "music": zod.union([MusicMode,zod.null()]).exactOptional(),
  "name": zod.string().min(1).max(catalogAudioModelNameMax),
  "prompt_max_chars": zod.int().min(1).max(catalogAudioModelPromptMaxCharsMax),
  "sound_effects": zod.union([SoundEffectsMode,zod.null()]).exactOptional(),
  "speech": zod.union([SpeechMode,zod.null()]).exactOptional(),
  "vendor": VendorName,
  "voice_design": zod.union([VoiceDesignMode,zod.null()]).exactOptional(),
  "voiceover": zod.union([VoiceoverMode,zod.null()]).exactOptional()
}).describe('A sound model: a block for each mode it serves (`job_types` names them), as live\'s.');

export type CatalogAudioModel = zod.input<typeof CatalogAudioModel>;
export type CatalogAudioModelOutput = zod.output<typeof CatalogAudioModel>;

export const ImageMode = zod.object({
  "references": InputCount.exactOptional()
}).describe('An image job type\'s block: how many reference images it takes (live\'s\n`max_reference_images`, a budget the brand logo and product images share once they join).');

export type ImageMode = zod.input<typeof ImageMode>;
export type ImageModeOutput = zod.output<typeof ImageMode>;

export const catalogImageModelCostTierMax = 5;

export const catalogImageModelDescriptionMax = 160;

export const catalogImageModelIdMax = 64;


export const catalogImageModelIdRegExp = new RegExp('^[a-z0-9][a-z0-9.-]*$');

export const catalogImageModelMakerMax = 40;

export const catalogImageModelMaxOutputsMax = 16;

export const catalogImageModelNameMax = 80;

export const catalogImageModelPromptMaxCharsMax = 32000;



export const CatalogImageModel = zod.object({
  "ad_copy": zod.boolean(),
  "aspect_ratios": TextOptions,
  "cost_tier": zod.int().min(1).max(catalogImageModelCostTierMax),
  "description": zod.string().min(1).max(catalogImageModelDescriptionMax),
  "id": zod.string().max(catalogImageModelIdMax).regex(catalogImageModelIdRegExp),
  "is_default": zod.boolean(),
  "is_new": zod.boolean(),
  "job_types": zod.array(GenerationType).min(1),
  "maker": zod.string().min(1).max(catalogImageModelMakerMax),
  "max_outputs": zod.int().min(1).max(catalogImageModelMaxOutputsMax),
  "medium": zod.literal("image").meta({ title: 'Medium' }),
  "metering": Metering,
  "modes": zod.record(zod.string(), ImageMode),
  "name": zod.string().min(1).max(catalogImageModelNameMax),
  "prompt_max_chars": zod.int().min(1).max(catalogImageModelPromptMaxCharsMax),
  "vendor": VendorName
});

export type CatalogImageModel = zod.input<typeof CatalogImageModel>;
export type CatalogImageModelOutput = zod.output<typeof CatalogImageModel>;

export const Medium = zod.enum(['image', 'video', 'audio', 'text']);

export type Medium = zod.input<typeof Medium>;
export type MediumOutput = zod.output<typeof Medium>;

export const CatalogJobType = zod.object({
  "id": GenerationType,
  "max_outputs": zod.int(),
  "medium": Medium,
  "needs_source": zod.boolean()
});

export type CatalogJobType = zod.input<typeof CatalogJobType>;
export type CatalogJobTypeOutput = zod.output<typeof CatalogJobType>;

export const catalogTextModelCostTierMax = 5;

export const catalogTextModelDescriptionMax = 160;

export const catalogTextModelIdMax = 64;


export const catalogTextModelIdRegExp = new RegExp('^[a-z0-9][a-z0-9.-]*$');

export const catalogTextModelMakerMax = 40;

export const catalogTextModelMaxOutputsMax = 16;

export const catalogTextModelNameMax = 80;

export const catalogTextModelPromptMaxCharsMax = 32000;



export const CatalogTextModel = zod.object({
  "cost_tier": zod.int().min(1).max(catalogTextModelCostTierMax),
  "description": zod.string().min(1).max(catalogTextModelDescriptionMax),
  "id": zod.string().max(catalogTextModelIdMax).regex(catalogTextModelIdRegExp),
  "is_default": zod.boolean(),
  "is_new": zod.boolean(),
  "job_types": zod.array(GenerationType).min(1),
  "maker": zod.string().min(1).max(catalogTextModelMakerMax),
  "max_outputs": zod.int().min(1).max(catalogTextModelMaxOutputsMax),
  "medium": zod.literal("text").meta({ title: 'Medium' }),
  "metering": Metering,
  "name": zod.string().min(1).max(catalogTextModelNameMax),
  "prompt_max_chars": zod.int().min(1).max(catalogTextModelPromptMaxCharsMax),
  "vendor": VendorName
}).describe('An LLM that writes a job\'s text (G8): a client never picks it, the server fills the\none row of the type, as live\'s forms never name the LLM.');

export type CatalogTextModel = zod.input<typeof CatalogTextModel>;
export type CatalogTextModelOutput = zod.output<typeof CatalogTextModel>;




export const IntOptions = zod.object({
  "default": zod.int(),
  "values": zod.array(zod.int()).min(1)
});

export type IntOptions = zod.input<typeof IntOptions>;
export type IntOptionsOutput = zod.output<typeof IntOptions>;

export const dubbingSourceMaxBytesExclusiveMin = 0;

export const dubbingSourceMaxSecondsExclusiveMin = 0;




export const DubbingSource = zod.object({
  "max_bytes": zod.int().gt(dubbingSourceMaxBytesExclusiveMin),
  "max_seconds": zod.int().gt(dubbingSourceMaxSecondsExclusiveMin),
  "mimes": zod.array(zod.string()).min(1)
}).describe('What a dub takes as its source (live\'s `video_input`): the types, the size and the\nlength.');

export type DubbingSource = zod.input<typeof DubbingSource>;
export type DubbingSourceOutput = zod.output<typeof DubbingSource>;

export const dubbingLanguageCodeRegExp = new RegExp('^[a-z]{2,4}$');


export const DubbingLanguage = zod.object({
  "code": zod.string().regex(dubbingLanguageCodeRegExp),
  "name": zod.string()
}).describe('A language of the Dubbing tool\'s lists: its code, as ElevenLabs takes it, and live\'s name.');

export type DubbingLanguage = zod.input<typeof DubbingLanguage>;
export type DubbingLanguageOutput = zod.output<typeof DubbingLanguage>;

export const dubbingCapsDropBackgroundAudioDefault = false;




export const DubbingCaps = zod.object({
  "default_source": zod.string(),
  "default_target": zod.string(),
  "drop_background_audio": zod.boolean().default(dubbingCapsDropBackgroundAudioDefault),
  "max_speakers": zod.union([zod.int().min(1),zod.null()]).exactOptional(),
  "source": DubbingSource,
  "source_languages": zod.array(DubbingLanguage).min(1),
  "target_languages": zod.array(DubbingLanguage).min(1)
}).describe('Video Dubbing\'s block (live\'s `videoDubbing`): its languages in live\'s order with their\ndefaults, the most speakers it takes (None: it takes no count) and whether it can drop the\nbackground audio.');

export type DubbingCaps = zod.input<typeof DubbingCaps>;
export type DubbingCapsOutput = zod.output<typeof DubbingCaps>;

export const InputRequirement = zod.enum(['required', 'optional', 'none']).describe('Whether a part of a job is needed, allowed, or not taken.');

export type InputRequirement = zod.input<typeof InputRequirement>;
export type InputRequirementOutput = zod.output<typeof InputRequirement>;

export const elementCapsImagePairDefault = false;
export const elementCapsMaxMax = 16;

export const elementCapsMaxVideosDefault = 1;
export const elementCapsMaxVideosMax = 16;

export const elementCapsMinDefault = 0;
export const elementCapsMinMin = 0;



export const ElementCaps = zod.object({
  "frontal": InputRequirement,
  "image_pair": zod.boolean().default(elementCapsImagePairDefault),
  "images": InputCount,
  "max": zod.int().min(1).max(elementCapsMaxMax),
  "max_videos": zod.int().min(1).max(elementCapsMaxVideosMax).default(elementCapsMaxVideosDefault),
  "min": zod.int().min(elementCapsMinMin).default(elementCapsMinDefault),
  "video": InputRequirement
}).describe('Live\'s elements: each a frontal image, more images of it, and a video, every part required,\noptional or not taken (`reference_element_field_requirements`).');

export type ElementCaps = zod.input<typeof ElementCaps>;
export type ElementCapsOutput = zod.output<typeof ElementCaps>;

export const syncModeOptionValueRegExp = new RegExp('^[a-z_]{1,32}$');


export const SyncModeOption = zod.object({
  "label": zod.string(),
  "value": zod.string().regex(syncModeOptionValueRegExp)
}).describe('One of Lip-Sync\'s sync modes: its value, as FAL takes it, and live\'s label.');

export type SyncModeOption = zod.input<typeof SyncModeOption>;
export type SyncModeOptionOutput = zod.output<typeof SyncModeOption>;


export const lipsyncCapsAutoDetectSpeakerDefault = false;



export const LipsyncCaps = zod.object({
  "audio_mimes": zod.array(zod.string()).min(1),
  "auto_detect_speaker": zod.boolean().default(lipsyncCapsAutoDetectSpeakerDefault),
  "default_sync_mode": zod.string(),
  "sync_modes": zod.array(SyncModeOption).min(1),
  "video_mimes": zod.array(zod.string()).min(1)
}).describe('Lip-Sync\'s block (live\'s `lipsync`): how a length mismatch is handled (its sync modes, in\nlive\'s order, and the default), whether the speaker is detected, and the source video\'s\nand audio\'s types.');

export type LipsyncCaps = zod.input<typeof LipsyncCaps>;
export type LipsyncCapsOutput = zod.output<typeof LipsyncCaps>;

export const imageLimitsMaxAspectRatioOneExclusiveMin = 0;

export const imageLimitsMaxSizeMbOneExclusiveMin = 0;

export const imageLimitsMinAspectRatioOneExclusiveMin = 0;





export const ImageLimits = zod.object({
  "accepted_formats": zod.union([zod.array(zod.string()),zod.null()]).exactOptional(),
  "max_aspect_ratio": zod.union([zod.number().gt(imageLimitsMaxAspectRatioOneExclusiveMin),zod.null()]).exactOptional(),
  "max_size_mb": zod.union([zod.number().gt(imageLimitsMaxSizeMbOneExclusiveMin),zod.null()]).exactOptional(),
  "min_aspect_ratio": zod.union([zod.number().gt(imageLimitsMinAspectRatioOneExclusiveMin),zod.null()]).exactOptional(),
  "min_height_px": zod.union([zod.int().min(1),zod.null()]).exactOptional(),
  "min_width_px": zod.union([zod.int().min(1),zod.null()]).exactOptional()
}).describe('Live\'s `image_input`: what an image in a slot must be (#258). Each limit is optional,\nas live\'s are; none set, none checked.');

export type ImageLimits = zod.input<typeof ImageLimits>;
export type ImageLimitsOutput = zod.output<typeof ImageLimits>;

export const videoLimitsCombinedMaxDurationSecOneExclusiveMin = 0;

export const videoLimitsMaxDurationSecOneExclusiveMin = 0;


export const videoLimitsMaxSizeMbOneExclusiveMin = 0;

export const videoLimitsMinDurationSecOneMin = 0;





export const VideoLimits = zod.object({
  "accepted_formats": zod.union([zod.array(zod.string()),zod.null()]).exactOptional(),
  "combined_max_duration_sec": zod.union([zod.number().gt(videoLimitsCombinedMaxDurationSecOneExclusiveMin),zod.null()]).exactOptional(),
  "max_duration_sec": zod.union([zod.number().gt(videoLimitsMaxDurationSecOneExclusiveMin),zod.null()]).exactOptional(),
  "max_resolution_px": zod.union([zod.int().min(1),zod.null()]).exactOptional(),
  "max_size_mb": zod.union([zod.number().gt(videoLimitsMaxSizeMbOneExclusiveMin),zod.null()]).exactOptional(),
  "min_duration_sec": zod.union([zod.number().min(videoLimitsMinDurationSecOneMin),zod.null()]).exactOptional(),
  "min_resolution_px": zod.union([zod.int().min(1),zod.null()]).exactOptional(),
  "min_width_px": zod.union([zod.int().min(1),zod.null()]).exactOptional()
}).describe('Live\'s `video_input`: what a video in a slot must be (#258). Its sides are the shorter\n(`min_resolution_px`) and the longer (`max_resolution_px`). `min_width_px` is not live\'s:\nFAL\'s least width for Kling O3\'s element video, met on dev (#258).');

export type VideoLimits = zod.input<typeof VideoLimits>;
export type VideoLimitsOutput = zod.output<typeof VideoLimits>;

export const MediaLimits = zod.object({
  "audio": zod.union([AudioLimits,zod.null()]).exactOptional(),
  "image": zod.union([ImageLimits,zod.null()]).exactOptional(),
  "video": zod.union([VideoLimits,zod.null()]).exactOptional()
}).describe('A mode\'s limits per medium: images (frames, reference images, an element\'s images),\nvideos (reference videos, an element\'s video) and audios (reference audios).');

export type MediaLimits = zod.input<typeof MediaLimits>;
export type MediaLimitsOutput = zod.output<typeof MediaLimits>;

export const secondsRangeMaxMax = 600;

export const secondsRangeMinMax = 600;



export const SecondsRange = zod.object({
  "max": zod.int().min(1).max(secondsRangeMaxMax),
  "min": zod.int().min(1).max(secondsRangeMinMax)
}).describe('A span of whole seconds, as a shot\'s length and a video\'s whole budget.');

export type SecondsRange = zod.input<typeof SecondsRange>;
export type SecondsRangeOutput = zod.output<typeof SecondsRange>;

export const multiShotCapsEndFrameDefault = false;
export const multiShotCapsMaxShotsMax = 30;



export const MultiShotCaps = zod.object({
  "end_frame": zod.boolean().default(multiShotCapsEndFrameDefault),
  "max_shots": zod.int().min(1).max(multiShotCapsMaxShotsMax),
  "shot_seconds": SecondsRange
}).describe('Live\'s multi-prompt: up to `max_shots` shots, each `shot_seconds.min` seconds or more, all\nof them together at most `shot_seconds.max` (the composer\'s budget, "max 15 sec").');

export type MultiShotCaps = zod.input<typeof MultiShotCaps>;
export type MultiShotCapsOutput = zod.output<typeof MultiShotCaps>;

export const ModeRuleWhen = zod.enum(['element_with_video', 'elements', 'start_frame', 'end_frame', 'reference_audios']);

export type ModeRuleWhen = zod.input<typeof ModeRuleWhen>;
export type ModeRuleWhenOutput = zod.output<typeof ModeRuleWhen>;

export const modeRuleMaxElementsOneMin = 0;

export const modeRuleMaxReferenceImagesOneMin = 0;

export const modeRuleMaxTotalOneMin = 0;



export const ModeRule = zod.object({
  "max_elements": zod.union([zod.int().min(modeRuleMaxElementsOneMin),zod.null()]).exactOptional(),
  "max_reference_images": zod.union([zod.int().min(modeRuleMaxReferenceImagesOneMin),zod.null()]).exactOptional(),
  "max_total": zod.union([zod.int().min(modeRuleMaxTotalOneMin),zod.null()]).exactOptional(),
  "require_one_of": zod.union([zod.array(zod.enum(['reference_images', 'reference_videos'])),zod.null()]).exactOptional(),
  "when": ModeRuleWhen
}).describe('One of live\'s conditional rules: when the job has `when`, one more limit applies. The\ntotal counts reference images, videos, audios and elements, never the frames.');

export type ModeRule = zod.input<typeof ModeRule>;
export type ModeRuleOutput = zod.output<typeof ModeRule>;

export const PromptTag = zod.enum(['image', 'video', 'audio', 'element']).describe('What a prompt may name by position (`@Image1`, `@Element1`): live\'s tagging flags.');

export type PromptTag = zod.input<typeof PromptTag>;
export type PromptTagOutput = zod.output<typeof PromptTag>;



export const talkingHeadCapsMaxAudioSecondsOneExclusiveMin = 0;

export const talkingHeadCapsMinAudioSecondsOneExclusiveMin = 0;



export const TalkingHeadCaps = zod.object({
  "audio_mimes": zod.array(zod.string()).min(1),
  "image_mimes": zod.array(zod.string()).min(1),
  "max_audio_seconds": zod.union([zod.number().gt(talkingHeadCapsMaxAudioSecondsOneExclusiveMin),zod.null()]).exactOptional(),
  "min_audio_seconds": zod.union([zod.number().gt(talkingHeadCapsMinAudioSecondsOneExclusiveMin),zod.null()]).exactOptional()
}).describe('A talking-head model\'s inputs (#222, live\'s `talkingHead` block): the portrait\'s and the\naudio\'s types, and the audio\'s length where the model bounds it (Swift\'s 5 to 14.8 s).');

export type TalkingHeadCaps = zod.input<typeof TalkingHeadCaps>;
export type TalkingHeadCapsOutput = zod.output<typeof TalkingHeadCaps>;

export const settingRangeStepExclusiveMin = 0;



export const SettingRange = zod.object({
  "default": zod.union([zod.number(),zod.null()]).exactOptional(),
  "max": zod.number(),
  "min": zod.number(),
  "step": zod.number().gt(settingRangeStepExclusiveMin)
}).describe('A setting\'s bounds, inclusive, as live\'s API checks them, and its default where it has\none; `step` is its control\'s (live\'s composer), a value between steps taken as live takes\nit.');

export type SettingRange = zod.input<typeof SettingRange>;
export type SettingRangeOutput = zod.output<typeof SettingRange>;

export const UpscaleCaps = zod.object({
  "compression": zod.union([SettingRange,zod.null()]).exactOptional(),
  "grain": zod.union([SettingRange,zod.null()]).exactOptional(),
  "halo": zod.union([SettingRange,zod.null()]).exactOptional(),
  "noise": zod.union([SettingRange,zod.null()]).exactOptional(),
  "recover_detail": zod.union([SettingRange,zod.null()]).exactOptional(),
  "target_fps": zod.union([SettingRange,zod.null()]).exactOptional(),
  "upscale_factor": SettingRange
}).describe('Video Upscale\'s settings (Topaz on FAL, live\'s `videoUpscale`): each one\'s range, or None\nwhere the model has no such setting.');

export type UpscaleCaps = zod.input<typeof UpscaleCaps>;
export type UpscaleCapsOutput = zod.output<typeof UpscaleCaps>;




export const VoiceSwapCaps = zod.object({
  "video_mimes": zod.array(zod.string()).min(1)
}).describe('A voice swap\'s source (#223): the video types it takes. Live\'s settings are fixed.');

export type VoiceSwapCaps = zod.input<typeof VoiceSwapCaps>;
export type VoiceSwapCapsOutput = zod.output<typeof VoiceSwapCaps>;

export const videoModeEndFrameDefault = false;
export const videoModeFollowsSourceResolutionDefault = false;
export const videoModeKeepSourceAudioDefault = false;
export const videoModeMaxTotalReferencesOneMin = 0;

export const videoModePromptMaxCharsOneMax = 50000;

export const videoModeStartFrameDefault = 'none';
export const videoModeTakesAspectRatioDefault = true;

export const VideoMode = zod.object({
  "advanced": AdvancedCaps.exactOptional(),
  "aspect_ratios": zod.union([TextOptions,zod.null()]).exactOptional(),
  "audio": AudioMode,
  "background": zod.union([BackgroundCaps,zod.null()]).exactOptional(),
  "dubbing": zod.union([DubbingCaps,zod.null()]).exactOptional(),
  "durations": zod.union([IntOptions,zod.null()]).exactOptional(),
  "elements": zod.union([ElementCaps,zod.null()]).exactOptional(),
  "end_frame": zod.boolean().default(videoModeEndFrameDefault),
  "follows_source_resolution": zod.boolean().default(videoModeFollowsSourceResolutionDefault),
  "keep_source_audio": zod.boolean().default(videoModeKeepSourceAudioDefault),
  "lipsync": zod.union([LipsyncCaps,zod.null()]).exactOptional(),
  "max_images_with_frames": zod.union([zod.int().min(1),zod.null()]).exactOptional(),
  "max_total_references": zod.union([zod.int().min(videoModeMaxTotalReferencesOneMin),zod.null()]).exactOptional(),
  "media_limits": zod.union([MediaLimits,zod.null()]).exactOptional(),
  "middle_frames": zod.union([InputCount,zod.null()]).exactOptional(),
  "multi_shot": zod.union([MultiShotCaps,zod.null()]).exactOptional(),
  "notes": zod.array(zod.string()).exactOptional(),
  "prompt_max_chars": zod.union([zod.int().min(1).max(videoModePromptMaxCharsOneMax),zod.null()]).exactOptional(),
  "reference_audios": zod.union([InputCount,zod.null()]).exactOptional(),
  "reference_images": zod.union([InputCount,zod.null()]).exactOptional(),
  "reference_videos": zod.union([InputCount,zod.null()]).exactOptional(),
  "resolutions": zod.union([TextOptions,zod.null()]).exactOptional(),
  "rules": zod.array(ModeRule).exactOptional(),
  "start_frame": InputRequirement.default(videoModeStartFrameDefault),
  "tags": zod.array(PromptTag).exactOptional(),
  "takes_aspect_ratio": zod.boolean().default(videoModeTakesAspectRatioDefault),
  "talking_head": zod.union([TalkingHeadCaps,zod.null()]).exactOptional(),
  "upscale": zod.union([UpscaleCaps,zod.null()]).exactOptional(),
  "voice_swap": zod.union([VoiceSwapCaps,zod.null()]).exactOptional()
}).describe('A video job type\'s block, as live\'s mode block for the same mode. Live keeps the options\nper mode too: where this mode\'s differ from the row\'s, the block names them (absent, the\nrow\'s), and `takes_aspect_ratio` is false where live\'s mode lists no ratio (most image to\nvideo: the video keeps the start frame\'s shape).');

export type VideoMode = zod.input<typeof VideoMode>;
export type VideoModeOutput = zod.output<typeof VideoMode>;

export const catalogVideoModelCostTierMax = 5;

export const catalogVideoModelDescriptionMax = 160;

export const catalogVideoModelIdMax = 64;


export const catalogVideoModelIdRegExp = new RegExp('^[a-z0-9][a-z0-9.-]*$');

export const catalogVideoModelMakerMax = 40;

export const catalogVideoModelMaxOutputsMax = 16;

export const catalogVideoModelNameMax = 80;

export const catalogVideoModelPromptMaxCharsMax = 32000;



export const CatalogVideoModel = zod.object({
  "aspect_ratios": TextOptions,
  "cost_tier": zod.int().min(1).max(catalogVideoModelCostTierMax),
  "description": zod.string().min(1).max(catalogVideoModelDescriptionMax),
  "durations": zod.union([IntOptions,zod.null()]).exactOptional(),
  "id": zod.string().max(catalogVideoModelIdMax).regex(catalogVideoModelIdRegExp),
  "is_default": zod.boolean(),
  "is_new": zod.boolean(),
  "job_types": zod.array(GenerationType).min(1),
  "maker": zod.string().min(1).max(catalogVideoModelMakerMax),
  "max_outputs": zod.int().min(1).max(catalogVideoModelMaxOutputsMax),
  "medium": zod.literal("video").meta({ title: 'Medium' }),
  "metering": Metering,
  "modes": zod.record(zod.string(), VideoMode),
  "name": zod.string().min(1).max(catalogVideoModelNameMax),
  "prompt_max_chars": zod.int().min(1).max(catalogVideoModelPromptMaxCharsMax),
  "resolutions": zod.union([TextOptions,zod.null()]).exactOptional(),
  "vendor": VendorName
});

export type CatalogVideoModel = zod.input<typeof CatalogVideoModel>;
export type CatalogVideoModelOutput = zod.output<typeof CatalogVideoModel>;

export const Catalog = zod.object({
  "audio_models": zod.array(CatalogAudioModel),
  "image_models": zod.array(CatalogImageModel),
  "job_types": zod.array(CatalogJobType),
  "text_models": zod.array(CatalogTextModel),
  "version": zod.string(),
  "video_models": zod.array(CatalogVideoModel)
}).describe('`GET /v1/catalog`: what can be generated here, with every option, so the SPA renders its\nforms from it (proposal 6.4). Every job records the `version` it was validated against.');

export type Catalog = zod.input<typeof Catalog>;
export type CatalogOutput = zod.output<typeof Catalog>;

export const ChalkColor = zod.enum(['white', 'coral', 'yellow']);

export type ChalkColor = zod.input<typeof ChalkColor>;
export type ChalkColorOutput = zod.output<typeof ChalkColor>;

export const chalkBoardElementCueMax = 2000;

export const chalkBoardElementElementMax = 2000;

export const chalkBoardElementIconMax = 2000;

export const chalkBoardElementTextMax = 2000;



export const ChalkBoardElement = zod.object({
  "color": ChalkColor,
  "cue": zod.string().max(chalkBoardElementCueMax),
  "element": zod.string().max(chalkBoardElementElementMax),
  "icon": zod.string().max(chalkBoardElementIconMax),
  "text": zod.string().max(chalkBoardElementTextMax)
}).describe('A board part as the board director places it: the element drawn and the cue word it is\nfinished on.');

export type ChalkBoardElement = zod.input<typeof ChalkBoardElement>;
export type ChalkBoardElementOutput = zod.output<typeof ChalkBoardElement>;

export const chalkBoardBeatActionMax = 2000;

export const chalkBoardBeatPartsMax = 60;



export const ChalkBoardBeat = zod.object({
  "action": zod.string().max(chalkBoardBeatActionMax),
  "line_id": zod.int(),
  "parts": zod.array(ChalkBoardElement).max(chalkBoardBeatPartsMax)
});

export type ChalkBoardBeat = zod.input<typeof ChalkBoardBeat>;
export type ChalkBoardBeatOutput = zod.output<typeof ChalkBoardBeat>;

export const ChalkClip = zod.enum(['A', 'B', 'C']).describe('Live\'s three board clips: A the problem, B the product, C the proof and the product.');

export type ChalkClip = zod.input<typeof ChalkClip>;
export type ChalkClipOutput = zod.output<typeof ChalkClip>;

export const chalkBoardClipBeatsMax = 60;

export const chalkBoardClipHandEndMax = 2000;



export const ChalkBoardClip = zod.object({
  "beats": zod.array(ChalkBoardBeat).max(chalkBoardClipBeatsMax),
  "clip": ChalkClip,
  "hand_end": zod.string().max(chalkBoardClipHandEndMax)
});

export type ChalkBoardClip = zod.input<typeof ChalkBoardClip>;
export type ChalkBoardClipOutput = zod.output<typeof ChalkBoardClip>;

export const chalkBoardProductDescriptionMax = 2000;

export const chalkBoardProductGripMax = 2000;

export const chalkBoardProductMaterialMax = 2000;

export const chalkBoardProductSizeLineMax = 2000;



export const ChalkBoardProduct = zod.object({
  "description": zod.string().max(chalkBoardProductDescriptionMax),
  "grip": zod.string().max(chalkBoardProductGripMax),
  "hold": zod.enum(['fingers', 'hand']),
  "material": zod.string().max(chalkBoardProductMaterialMax),
  "size_line": zod.string().max(chalkBoardProductSizeLineMax)
});

export type ChalkBoardProduct = zod.input<typeof ChalkBoardProduct>;
export type ChalkBoardProductOutput = zod.output<typeof ChalkBoardProduct>;

export const chalkBoardClipsMax = 60;



export const ChalkBoard = zod.object({
  "clips": zod.array(ChalkBoardClip).max(chalkBoardClipsMax),
  "product": ChalkBoardProduct
}).describe('The board director\'s answer (`W/board.ts:69-72`): the product as held, and each clip\'s\nbeats, a line each, with where the hand ends.');

export type ChalkBoard = zod.input<typeof ChalkBoard>;
export type ChalkBoardOutput = zod.output<typeof ChalkBoard>;

export const chalkBoardPartIconMax = 2000;

export const chalkBoardPartTextMax = 2000;



export const ChalkBoardPart = zod.object({
  "color": ChalkColor,
  "icon": zod.string().max(chalkBoardPartIconMax),
  "text": zod.string().max(chalkBoardPartTextMax)
}).describe('What the hand writes on the board as a line is said: short capitals or an icon.');

export type ChalkBoardPart = zod.input<typeof ChalkBoardPart>;
export type ChalkBoardPartOutput = zod.output<typeof ChalkBoardPart>;

export const chalkClaimClaimMax = 2000;

export const chalkClaimIdMax = 40;

export const chalkClaimSourceQuoteMax = 2000;



export const ChalkClaim = zod.object({
  "claim": zod.string().max(chalkClaimClaimMax),
  "id": zod.string().max(chalkClaimIdMax),
  "source_quote": zod.string().max(chalkClaimSourceQuoteMax)
});

export type ChalkClaim = zod.input<typeof ChalkClaim>;
export type ChalkClaimOutput = zod.output<typeof ChalkClaim>;

export const ChalkPlannedCue = zod.object({
  "color": ChalkColor,
  "label": zod.string(),
  "line_id": zod.int(),
  "planned_seconds": zod.union([zod.number(),zod.null()]),
  "warned": zod.boolean()
}).describe('A board element as the storyboard lists it (live\'s `PlannedCue`): its line, its label, its\ncolour, when its cue word is planned to be said (None: the cue is not in the line), and\nwhether a cue warning names it.');

export type ChalkPlannedCue = zod.input<typeof ChalkPlannedCue>;
export type ChalkPlannedCueOutput = zod.output<typeof ChalkPlannedCue>;

export const ChalkClipCues = zod.object({
  "clip": ChalkClip,
  "cues": zod.array(ChalkPlannedCue),
  "duration_seconds": zod.int()
});

export type ChalkClipCues = zod.input<typeof ChalkClipCues>;
export type ChalkClipCuesOutput = zod.output<typeof ChalkClipCues>;

export const ChalkLineTiming = zod.object({
  "beat_end_s": zod.number(),
  "beat_start_s": zod.number(),
  "end_s": zod.number(),
  "line_id": zod.int(),
  "start_s": zod.number(),
  "words": zod.int()
}).describe('A line\'s row of the timing plan (`W/types.ts:31-38`), in seconds from its clip\'s start.');

export type ChalkLineTiming = zod.input<typeof ChalkLineTiming>;
export type ChalkLineTimingOutput = zod.output<typeof ChalkLineTiming>;

export const ChalkClipTiming = zod.object({
  "clip": ChalkClip,
  "duration_s": zod.int(),
  "lines": zod.array(ChalkLineTiming),
  "pace_wps": zod.number(),
  "speech_start_s": zod.number(),
  "tail_s": zod.number(),
  "wipe_s": zod.number(),
  "words": zod.int()
});

export type ChalkClipTiming = zod.input<typeof ChalkClipTiming>;
export type ChalkClipTimingOutput = zod.output<typeof ChalkClipTiming>;

export const ChalkDraftStillName = zod.enum(['board0', 'end_a', 'end_b', 'end_c', 'end_card']);

export type ChalkDraftStillName = zod.input<typeof ChalkDraftStillName>;
export type ChalkDraftStillNameOutput = zod.output<typeof ChalkDraftStillName>;

export const ChalkDraftStill = zod.object({
  "name": ChalkDraftStillName,
  "output": zod.union([OutputRef,zod.null()]).exactOptional(),
  "problem": zod.union([zod.string(),zod.null()]),
  "status": StillStatus,
  "url": zod.union([zod.string(),zod.null()])
}).describe('One of the five stills (live\'s `StillState`), as `DraftStill`.');

export type ChalkDraftStill = zod.input<typeof ChalkDraftStill>;
export type ChalkDraftStillOutput = zod.output<typeof ChalkDraftStill>;

export const chalkEndCardCtaButtonMax = 2000;

export const chalkEndCardHeadlineMax = 2000;

export const chalkEndCardSupportLineMax = 2000;



export const ChalkEndCard = zod.object({
  "cta_button": zod.string().max(chalkEndCardCtaButtonMax),
  "headline": zod.string().max(chalkEndCardHeadlineMax),
  "support_line": zod.string().max(chalkEndCardSupportLineMax)
});

export type ChalkEndCard = zod.input<typeof ChalkEndCard>;
export type ChalkEndCardOutput = zod.output<typeof ChalkEndCard>;

export const chalkExplainerAdPickedInputsCaptionPositionDefault = `bottom`;
export const chalkExplainerAdPickedInputsCaptionStyleIdDefault = ``;
export const chalkExplainerAdPickedInputsCaptionStyleIdMax = 64;

export const chalkExplainerAdPickedInputsCtaDefault = ``;
export const chalkExplainerAdPickedInputsCtaMax = 100;

export const chalkExplainerAdPickedInputsProblemDefault = ``;
export const chalkExplainerAdPickedInputsProblemMax = 500;

export const chalkExplainerAdPickedInputsProductCategoryDefault = ``;
export const chalkExplainerAdPickedInputsProductCategoryMax = 200;

export const chalkExplainerAdPickedInputsProductNameDefault = ``;
export const chalkExplainerAdPickedInputsProductNameMax = 200;

export const chalkExplainerAdPickedInputsProductTextDefault = ``;
export const chalkExplainerAdPickedInputsProductTextMax = 20000;

export const chalkExplainerAdPickedInputsPronunciationDefault = ``;
export const chalkExplainerAdPickedInputsPronunciationMax = 100;

export const chalkExplainerAdPickedInputsResolutionDefault = `1080p`;
export const chalkExplainerAdPickedInputsSubtitlesDefault = true;
export const chalkExplainerAdPickedInputsTakesDefault = 1;
export const chalkExplainerAdPickedInputsTakesMax = 3;



export const ChalkExplainerAdPickedInputs = zod.object({
  "caption_position": zod.enum(['top', 'center', 'bottom']).default(chalkExplainerAdPickedInputsCaptionPositionDefault),
  "caption_style_id": zod.string().max(chalkExplainerAdPickedInputsCaptionStyleIdMax).default(chalkExplainerAdPickedInputsCaptionStyleIdDefault),
  "cta": zod.string().max(chalkExplainerAdPickedInputsCtaMax).default(chalkExplainerAdPickedInputsCtaDefault),
  "problem": zod.string().max(chalkExplainerAdPickedInputsProblemMax).default(chalkExplainerAdPickedInputsProblemDefault),
  "product": PackshotProduct,
  "product_category": zod.string().max(chalkExplainerAdPickedInputsProductCategoryMax).default(chalkExplainerAdPickedInputsProductCategoryDefault),
  "product_name": zod.string().max(chalkExplainerAdPickedInputsProductNameMax).default(chalkExplainerAdPickedInputsProductNameDefault),
  "product_text": zod.string().max(chalkExplainerAdPickedInputsProductTextMax).default(chalkExplainerAdPickedInputsProductTextDefault),
  "pronunciation": zod.string().max(chalkExplainerAdPickedInputsPronunciationMax).default(chalkExplainerAdPickedInputsPronunciationDefault),
  "resolution": zod.enum(['1080p', '720p']).default(chalkExplainerAdPickedInputsResolutionDefault),
  "subtitles": zod.boolean().default(chalkExplainerAdPickedInputsSubtitlesDefault),
  "takes": zod.int().min(1).max(chalkExplainerAdPickedInputsTakesMax).default(chalkExplainerAdPickedInputsTakesDefault)
}).describe('The form with its product picked, as Generate script and Approve script need it (live\'s\n"Pick a product and its packshot", 422 at `product`).');

export type ChalkExplainerAdPickedInputs = zod.input<typeof ChalkExplainerAdPickedInputs>;
export type ChalkExplainerAdPickedInputsOutput = zod.output<typeof ChalkExplainerAdPickedInputs>;

export const chalkLineBoardPartsMax = 60;



export const ChalkLineBoard = zod.object({
  "parts": zod.array(ChalkBoardPart).max(chalkLineBoardPartsMax)
});

export type ChalkLineBoard = zod.input<typeof ChalkLineBoard>;
export type ChalkLineBoardOutput = zod.output<typeof ChalkLineBoard>;

export const ChalkLineRole = zod.enum(['hook', 'easy_truth', 'but_turn', 'consequence', 'twist', 'product', 'mechanism', 'proof', 'loop', 'cta']).describe('The ten lines\' roles, in their order (`W/script.ts:15-39`).');

export type ChalkLineRole = zod.input<typeof ChalkLineRole>;
export type ChalkLineRoleOutput = zod.output<typeof ChalkLineRole>;

export const chalkScriptLineClaimIdsItemMax = 40;

export const chalkScriptLineClaimIdsMax = 60;

export const chalkScriptLineSpokenMax = 2000;

export const chalkScriptLineTextMax = 2000;



export const ChalkScriptLine = zod.object({
  "board": ChalkLineBoard,
  "claim_ids": zod.array(zod.string().max(chalkScriptLineClaimIdsItemMax)).max(chalkScriptLineClaimIdsMax),
  "clip": ChalkClip,
  "id": zod.int(),
  "role": ChalkLineRole,
  "spoken": zod.string().max(chalkScriptLineSpokenMax),
  "text": zod.string().max(chalkScriptLineTextMax)
}).describe('A line: what is written and what is said, its clip, its role and its board parts.');

export type ChalkScriptLine = zod.input<typeof ChalkScriptLine>;
export type ChalkScriptLineOutput = zod.output<typeof ChalkScriptLine>;

export const chalkPronunciationRespellingMax = 200;

export const chalkPronunciationWordMax = 200;



export const ChalkPronunciation = zod.object({
  "respelling": zod.string().max(chalkPronunciationRespellingMax),
  "word": zod.string().max(chalkPronunciationWordMax)
}).describe('How a written word is said (`word_check.Respelling`).');

export type ChalkPronunciation = zod.input<typeof ChalkPronunciation>;
export type ChalkPronunciationOutput = zod.output<typeof ChalkPronunciation>;

export const chalkScriptClaimsMax = 60;

export const chalkScriptLinesMax = 60;

export const chalkScriptProblemMax = 2000;

export const chalkScriptProductNameMax = 2000;

export const chalkScriptPronunciationsMax = 60;



export const ChalkScript = zod.object({
  "claims": zod.array(ChalkClaim).max(chalkScriptClaimsMax),
  "end_card": ChalkEndCard,
  "lines": zod.array(ChalkScriptLine).max(chalkScriptLinesMax),
  "problem": zod.string().max(chalkScriptProblemMax),
  "product_name": zod.string().max(chalkScriptProductNameMax),
  "pronunciations": zod.array(ChalkPronunciation).max(chalkScriptPronunciationsMax)
}).describe('The script director\'s answer (`W/script.ts:130-137`), edited in the form before approval:\nten lines in three clips, the claims they quote, the end card\'s texts, the respellings.');

export type ChalkScript = zod.input<typeof ChalkScript>;
export type ChalkScriptOutput = zod.output<typeof ChalkScript>;

export const ChalkExplainerAdApproval = zod.object({
  "inputs": ChalkExplainerAdPickedInputs,
  "script": ChalkScript
}).describe('`POST .../draft/approve`: live\'s Approve script, the form and the script as edited.');

export type ChalkExplainerAdApproval = zod.input<typeof ChalkExplainerAdApproval>;
export type ChalkExplainerAdApprovalOutput = zod.output<typeof ChalkExplainerAdApproval>;

export const chalkExplainerAdInputsCaptionPositionDefault = `bottom`;
export const chalkExplainerAdInputsCaptionStyleIdDefault = ``;
export const chalkExplainerAdInputsCaptionStyleIdMax = 64;

export const chalkExplainerAdInputsCtaDefault = ``;
export const chalkExplainerAdInputsCtaMax = 100;

export const chalkExplainerAdInputsProblemDefault = ``;
export const chalkExplainerAdInputsProblemMax = 500;

export const chalkExplainerAdInputsProductCategoryDefault = ``;
export const chalkExplainerAdInputsProductCategoryMax = 200;

export const chalkExplainerAdInputsProductNameDefault = ``;
export const chalkExplainerAdInputsProductNameMax = 200;

export const chalkExplainerAdInputsProductTextDefault = ``;
export const chalkExplainerAdInputsProductTextMax = 20000;

export const chalkExplainerAdInputsPronunciationDefault = ``;
export const chalkExplainerAdInputsPronunciationMax = 100;

export const chalkExplainerAdInputsResolutionDefault = `1080p`;
export const chalkExplainerAdInputsSubtitlesDefault = true;
export const chalkExplainerAdInputsTakesDefault = 1;
export const chalkExplainerAdInputsTakesMax = 3;



export const ChalkExplainerAdInputs = zod.object({
  "caption_position": zod.enum(['top', 'center', 'bottom']).default(chalkExplainerAdInputsCaptionPositionDefault),
  "caption_style_id": zod.string().max(chalkExplainerAdInputsCaptionStyleIdMax).default(chalkExplainerAdInputsCaptionStyleIdDefault),
  "cta": zod.string().max(chalkExplainerAdInputsCtaMax).default(chalkExplainerAdInputsCtaDefault),
  "problem": zod.string().max(chalkExplainerAdInputsProblemMax).default(chalkExplainerAdInputsProblemDefault),
  "product": zod.union([PackshotProduct,zod.null()]).exactOptional(),
  "product_category": zod.string().max(chalkExplainerAdInputsProductCategoryMax).default(chalkExplainerAdInputsProductCategoryDefault),
  "product_name": zod.string().max(chalkExplainerAdInputsProductNameMax).default(chalkExplainerAdInputsProductNameDefault),
  "product_text": zod.string().max(chalkExplainerAdInputsProductTextMax).default(chalkExplainerAdInputsProductTextDefault),
  "pronunciation": zod.string().max(chalkExplainerAdInputsPronunciationMax).default(chalkExplainerAdInputsPronunciationDefault),
  "resolution": zod.enum(['1080p', '720p']).default(chalkExplainerAdInputsResolutionDefault),
  "subtitles": zod.boolean().default(chalkExplainerAdInputsSubtitlesDefault),
  "takes": zod.int().min(1).max(chalkExplainerAdInputsTakesMax).default(chalkExplainerAdInputsTakesDefault)
}).describe('Chalk Explainer Ad\'s form so far: the product (none until picked), and the rest.');

export type ChalkExplainerAdInputs = zod.input<typeof ChalkExplainerAdInputs>;
export type ChalkExplainerAdInputsOutput = zod.output<typeof ChalkExplainerAdInputs>;

export const ChalkTimingPlan = zod.object({
  "clips": zod.array(ChalkClipTiming),
  "end_card_s": zod.int(),
  "pace_target_wps": zod.number(),
  "total_s": zod.number(),
  "warnings": zod.array(zod.string())
}).describe('A script\'s timing plan (`W/types.ts:51-57`, `templates/chalk_timing.plan_timing`): each\nclip\'s length and each line\'s span, and live\'s warnings on them.');

export type ChalkTimingPlan = zod.input<typeof ChalkTimingPlan>;
export type ChalkTimingPlanOutput = zod.output<typeof ChalkTimingPlan>;

export const ChalkExplainerAdDraft = zod.object({
  "board": zod.union([ChalkBoard,zod.null()]),
  "board_director": DirectorState,
  "cue_warnings": zod.array(zod.string()),
  "cues": zod.array(ChalkClipCues),
  "inputs": ChalkExplainerAdInputs,
  "pack_director": DirectorState,
  "pack_warning": zod.boolean(),
  "problem": zod.union([zod.string(),zod.null()]),
  "script": zod.union([ChalkScript,zod.null()]),
  "script_director": DirectorState,
  "script_problems": zod.array(zod.string()),
  "script_warning": zod.boolean(),
  "stage": DraftStage,
  "stills": zod.array(ChalkDraftStill),
  "timing": zod.union([ChalkTimingPlan,zod.null()]),
  "updated_at": zod.iso.datetime({"offset":true}),
  "urls_expire_at": zod.union([zod.iso.datetime({"offset":true}),zod.null()])
}).describe('A member\'s Chalk Explainer Ad draft in the brand: the form, the stage, the script and its\ndirectors (the pack reader\'s, then the script\'s), the script\'s timing plan, the board and its\ndirector, the storyboard\'s rows and the stills. `pack_warning`: the pack was hard to read.\n`script_warning`: the script kept is the director\'s best of its three tries and still has\nproblems (live\'s "Script check failed 3 times. Fix the lines before approving.", until the\nnext Generate Script). `script_problems`: what is off in the script as it stands, each in\nlive\'s words, from the director or the member\'s last edit. `timing`: the script\'s plan,\nits warnings live\'s. `cues` and `cue_warnings`: once the board is kept. `problem`: live\'s\nwords for the last director that failed. `stills` is empty until the script is approved.');

export type ChalkExplainerAdDraft = zod.input<typeof ChalkExplainerAdDraft>;
export type ChalkExplainerAdDraftOutput = zod.output<typeof ChalkExplainerAdDraft>;

export const ChalkExplainerAdDraftWrite = zod.object({
  "inputs": ChalkExplainerAdInputs,
  "script": zod.union([ChalkScript,zod.null()]).exactOptional()
}).describe('`PUT .../templates/chalk-explainer-ad/draft`: the form as it stands, its script as\nedited.');

export type ChalkExplainerAdDraftWrite = zod.input<typeof ChalkExplainerAdDraftWrite>;
export type ChalkExplainerAdDraftWriteOutput = zod.output<typeof ChalkExplainerAdDraftWrite>;

export const ChalkExplainerAdScriptAsk = zod.object({
  "inputs": ChalkExplainerAdPickedInputs
}).describe('`POST .../draft/script`: live\'s Generate Script, on the form as it stands.');

export type ChalkExplainerAdScriptAsk = zod.input<typeof ChalkExplainerAdScriptAsk>;
export type ChalkExplainerAdScriptAskOutput = zod.output<typeof ChalkExplainerAdScriptAsk>;

export const ChalkStills = zod.object({
  "board0": OutputRef,
  "end_a": OutputRef,
  "end_b": OutputRef,
  "end_c": OutputRef,
  "end_card": OutputRef
}).describe('The pictures a Chalk Explainer Ad video is drawn between (live\'s `stillUrls`): the blank\nboard and the board at the end of each clip, and the end card, each the draft\'s still\'s\npicture, an earlier output.');

export type ChalkStills = zod.input<typeof ChalkStills>;
export type ChalkStillsOutput = zod.output<typeof ChalkStills>;

export const chalkExplainerVideoInputsCaptionPositionDefault = `bottom`;
export const chalkExplainerVideoInputsCaptionStyleIdDefault = ``;
export const chalkExplainerVideoInputsCaptionStyleIdMax = 64;

export const chalkExplainerVideoInputsResolutionDefault = `1080p`;
export const chalkExplainerVideoInputsSubtitlesDefault = true;
export const chalkExplainerVideoInputsTakesDefault = 1;
export const chalkExplainerVideoInputsTakesMax = 3;



export const ChalkExplainerVideoInputs = zod.object({
  "board": ChalkBoard,
  "caption_position": zod.enum(['top', 'center', 'bottom']).default(chalkExplainerVideoInputsCaptionPositionDefault),
  "caption_style_id": zod.string().max(chalkExplainerVideoInputsCaptionStyleIdMax).default(chalkExplainerVideoInputsCaptionStyleIdDefault),
  "resolution": zod.enum(['1080p', '720p']).default(chalkExplainerVideoInputsResolutionDefault),
  "script": ChalkScript,
  "stills": ChalkStills,
  "subtitles": zod.boolean().default(chalkExplainerVideoInputsSubtitlesDefault),
  "takes": zod.int().min(1).max(chalkExplainerVideoInputsTakesMax).default(chalkExplainerVideoInputsTakesDefault),
  "template": zod.enum(['chalk-explainer-ad'])
}).describe('Chalk Explainer Ad\'s "Generate final video" (live\'s hand-off, G14-chalk-explainer-ad PR c):\nthe approved script and board, the stills, each board clip\'s takes, the captions and their\nlook and place, and the clips\' resolution. One tile: each board clip shot in its takes\nbetween its stills, each take heard and checked, the best kept and cut, the silent end\ncard; the story merged and captioned in two passes, then the end card\'s first 2 s joined.');

export type ChalkExplainerVideoInputs = zod.input<typeof ChalkExplainerVideoInputs>;
export type ChalkExplainerVideoInputsOutput = zod.output<typeof ChalkExplainerVideoInputs>;

export const checkoutStartPlanCodeMax = 64;



export const CheckoutStart = zod.object({
  "cycle": zod.enum(['month', 'year']),
  "plan_code": zod.string().min(1).max(checkoutStartPlanCodeMax)
}).describe('`POST /v1/teams/{team_id}/billing/checkout` (spec B2-3b): the plan and cycle to buy.');

export type CheckoutStart = zod.input<typeof CheckoutStart>;
export type CheckoutStartOutput = zod.output<typeof CheckoutStart>;

export const CheckoutUrl = zod.object({
  "url": zod.string()
}).describe('Where to send the browser: the team\'s open Stripe Checkout.');

export type CheckoutUrl = zod.input<typeof CheckoutUrl>;
export type CheckoutUrlOutput = zod.output<typeof CheckoutUrl>;

export const ClaudeOptions = zod.object({
  "effort": zod.union([zod.enum(['low', 'medium', 'high', 'xhigh', 'max']),zod.null()]).exactOptional(),
  "thinking": zod.union([zod.enum(['adaptive', 'disabled']),zod.null()]).exactOptional()
}).describe('Live\'s Claude-only options (`AnthropicTextOptions`): adaptive thinking or none, and the\neffort (`output_config.effort`); left out, the model\'s defaults.');

export type ClaudeOptions = zod.input<typeof ClaudeOptions>;
export type ClaudeOptionsOutput = zod.output<typeof ClaudeOptions>;

export const claymationAdInputsBrandUrlDefault = ``;
export const claymationAdInputsBrandUrlMax = 2000;

export const claymationAdInputsCaptionPositionDefault = `bottom`;
export const claymationAdInputsCaptionStyleIdDefault = ``;
export const claymationAdInputsCaptionStyleIdMax = 64;

export const claymationAdInputsClosingLineDefault = ``;
export const claymationAdInputsClosingLineMax = 2000;

export const claymationAdInputsCtaDefault = ``;
export const claymationAdInputsCtaMax = 2000;

export const claymationAdInputsMechanismDefault = ``;
export const claymationAdInputsMechanismMax = 500;

export const claymationAdInputsMusicBedDefault = true;
export const claymationAdInputsProductCategoryDefault = ``;
export const claymationAdInputsProductCategoryMax = 200;

export const claymationAdInputsProductCountDefault = `auto`;
export const claymationAdInputsProductNameDefault = ``;
export const claymationAdInputsProductNameMax = 200;

export const claymationAdInputsProductTextDefault = ``;
export const claymationAdInputsProductTextMax = 20000;

export const claymationAdInputsPronunciationDefault = ``;
export const claymationAdInputsPronunciationMax = 500;

export const claymationAdInputsResolutionDefault = `720p`;
export const claymationAdInputsSubtitlesDefault = true;

export const ClaymationAdInputs = zod.object({
  "brand_url": zod.string().max(claymationAdInputsBrandUrlMax).default(claymationAdInputsBrandUrlDefault),
  "caption_position": zod.enum(['top', 'center', 'bottom']).default(claymationAdInputsCaptionPositionDefault),
  "caption_style_id": zod.string().max(claymationAdInputsCaptionStyleIdMax).default(claymationAdInputsCaptionStyleIdDefault),
  "closing_line": zod.string().max(claymationAdInputsClosingLineMax).default(claymationAdInputsClosingLineDefault),
  "cta": zod.string().max(claymationAdInputsCtaMax).default(claymationAdInputsCtaDefault),
  "mechanism": zod.string().max(claymationAdInputsMechanismMax).default(claymationAdInputsMechanismDefault),
  "music_bed": zod.boolean().default(claymationAdInputsMusicBedDefault),
  "narrator": zod.union([zod.uuid(),zod.null()]).exactOptional(),
  "product": zod.union([PackshotProduct,zod.null()]).exactOptional(),
  "product_category": zod.string().max(claymationAdInputsProductCategoryMax).default(claymationAdInputsProductCategoryDefault),
  "product_count": zod.enum(['auto', '1', '2']).default(claymationAdInputsProductCountDefault),
  "product_name": zod.string().max(claymationAdInputsProductNameMax).default(claymationAdInputsProductNameDefault),
  "product_text": zod.string().max(claymationAdInputsProductTextMax).default(claymationAdInputsProductTextDefault),
  "pronunciation": zod.string().max(claymationAdInputsPronunciationMax).default(claymationAdInputsPronunciationDefault),
  "resolution": zod.enum(['720p', '1080p']).default(claymationAdInputsResolutionDefault),
  "subtitles": zod.boolean().default(claymationAdInputsSubtitlesDefault)
}).describe('Claymation Ad\'s form so far: the product (none until picked), and the rest.');

export type ClaymationAdInputs = zod.input<typeof ClaymationAdInputs>;
export type ClaymationAdInputsOutput = zod.output<typeof ClaymationAdInputs>;

export const ClaymationPlannedEndCard = zod.object({
  "length_s": zod.int(),
  "start_s": zod.int()
});

export type ClaymationPlannedEndCard = zod.input<typeof ClaymationPlannedEndCard>;
export type ClaymationPlannedEndCardOutput = zod.output<typeof ClaymationPlannedEndCard>;

export const ClaymationPlannedLine = zod.object({
  "end_s": zod.number(),
  "line_id": zod.int(),
  "start_s": zod.number(),
  "text": zod.string()
}).describe('A line\'s seconds within its shot\'s clip.');

export type ClaymationPlannedLine = zod.input<typeof ClaymationPlannedLine>;
export type ClaymationPlannedLineOutput = zod.output<typeof ClaymationPlannedLine>;

export const ClaymationPlannedShot = zod.object({
  "drift_s": zod.number(),
  "length_s": zod.int(),
  "lines": zod.array(ClaymationPlannedLine),
  "shot_id": zod.int(),
  "start_s": zod.int()
}).describe('A shot\'s clip: its whole-second start and length in the video, how far its cut sits from\nits line\'s first word, and its lines.');

export type ClaymationPlannedShot = zod.input<typeof ClaymationPlannedShot>;
export type ClaymationPlannedShotOutput = zod.output<typeof ClaymationPlannedShot>;

export const ClaymationShotPlan = zod.object({
  "end_card": ClaymationPlannedEndCard,
  "max_drift_s": zod.number(),
  "notes": zod.array(zod.string()),
  "shots": zod.array(ClaymationPlannedShot),
  "video_seconds": zod.int(),
  "vo_end": zod.number(),
  "vo_seconds": zod.union([zod.number(),zod.null()])
}).describe('The cuts of the whole ad on one take (live\'s `ShotPlan`): where the voice ends, the take\'s\nlength, the shots, the end card, the video\'s length, the largest drift and the drifts worth a\nnote.');

export type ClaymationShotPlan = zod.input<typeof ClaymationShotPlan>;
export type ClaymationShotPlanOutput = zod.output<typeof ClaymationShotPlan>;

export const claymationCharacterNameMax = 2000;

export const claymationCharacterWhoMax = 2000;



export const ClaymationCharacter = zod.object({
  "name": zod.string().max(claymationCharacterNameMax),
  "who": zod.string().max(claymationCharacterWhoMax)
});

export type ClaymationCharacter = zod.input<typeof ClaymationCharacter>;
export type ClaymationCharacterOutput = zod.output<typeof ClaymationCharacter>;

export const claymationClaimClaimMax = 2000;

export const claymationClaimIdMax = 40;

export const claymationClaimSourceQuoteMax = 2000;



export const ClaymationClaim = zod.object({
  "claim": zod.string().max(claymationClaimClaimMax),
  "id": zod.string().max(claymationClaimIdMax),
  "source_quote": zod.string().max(claymationClaimSourceQuoteMax)
});

export type ClaymationClaim = zod.input<typeof ClaymationClaim>;
export type ClaymationClaimOutput = zod.output<typeof ClaymationClaim>;

export const claymationEndCardCtaButtonMax = 2000;

export const claymationEndCardHeadlineMax = 2000;

export const claymationEndCardSupportLineMax = 2000;



export const ClaymationEndCard = zod.object({
  "cta_button": zod.string().max(claymationEndCardCtaButtonMax),
  "headline": zod.string().max(claymationEndCardHeadlineMax),
  "support_line": zod.string().max(claymationEndCardSupportLineMax)
});

export type ClaymationEndCard = zod.input<typeof ClaymationEndCard>;
export type ClaymationEndCardOutput = zod.output<typeof ClaymationEndCard>;

export const ClaymationBeat = zod.enum(['hook', 'habit', 'fact_bridge', 'contrast', 'reveal', 'product_a', 'product_b', 'proof', 'close']).describe('A line\'s beat (`W/script.ts:5-15`).');

export type ClaymationBeat = zod.input<typeof ClaymationBeat>;
export type ClaymationBeatOutput = zod.output<typeof ClaymationBeat>;

export const claymationLineClaimIdsItemMax = 40;

export const claymationLineClaimIdsMax = 60;

export const claymationLineSpokenMax = 2000;

export const claymationLineTextMax = 2000;



export const ClaymationLine = zod.object({
  "beat": ClaymationBeat,
  "claim_ids": zod.array(zod.string().max(claymationLineClaimIdsItemMax)).max(claymationLineClaimIdsMax),
  "id": zod.int(),
  "spoken": zod.string().max(claymationLineSpokenMax),
  "text": zod.string().max(claymationLineTextMax)
});

export type ClaymationLine = zod.input<typeof ClaymationLine>;
export type ClaymationLineOutput = zod.output<typeof ClaymationLine>;

export const claymationOverlayCueMax = 2000;

export const claymationOverlayTextMax = 2000;



export const ClaymationOverlay = zod.object({
  "cue": zod.string().max(claymationOverlayCueMax),
  "line_id": zod.int(),
  "text": zod.string().max(claymationOverlayTextMax)
});

export type ClaymationOverlay = zod.input<typeof ClaymationOverlay>;
export type ClaymationOverlayOutput = zod.output<typeof ClaymationOverlay>;

export const ClaymationProductId = zod.enum(['A', 'B']);

export type ClaymationProductId = zod.input<typeof ClaymationProductId>;
export type ClaymationProductIdOutput = zod.output<typeof ClaymationProductId>;

export const claymationProductJobMax = 2000;

export const claymationProductMadeFromMax = 2000;

export const claymationProductNameMax = 2000;



export const ClaymationProduct = zod.object({
  "id": ClaymationProductId,
  "job": zod.string().max(claymationProductJobMax),
  "made_from": zod.string().max(claymationProductMadeFromMax),
  "name": zod.string().max(claymationProductNameMax)
});

export type ClaymationProduct = zod.input<typeof ClaymationProduct>;
export type ClaymationProductOutput = zod.output<typeof ClaymationProduct>;

export const claymationPronunciationRespellingMax = 200;

export const claymationPronunciationSaidMax = 2000;

export const claymationPronunciationWordMax = 200;



export const ClaymationPronunciation = zod.object({
  "respelling": zod.string().max(claymationPronunciationRespellingMax),
  "said": zod.string().max(claymationPronunciationSaidMax),
  "word": zod.string().max(claymationPronunciationWordMax)
}).describe('How a written word is said (`word_check.Respelling`).');

export type ClaymationPronunciation = zod.input<typeof ClaymationPronunciation>;
export type ClaymationPronunciationOutput = zod.output<typeof ClaymationPronunciation>;

export const ClaymationSetId = zod.enum(['S1', 'S2', 'S3']);

export type ClaymationSetId = zod.input<typeof ClaymationSetId>;
export type ClaymationSetIdOutput = zod.output<typeof ClaymationSetId>;

export const claymationSetPlaceMax = 2000;

export const claymationSetWhyMax = 2000;



export const ClaymationSet = zod.object({
  "id": ClaymationSetId,
  "place": zod.string().max(claymationSetPlaceMax),
  "why": zod.string().max(claymationSetWhyMax)
});

export type ClaymationSet = zod.input<typeof ClaymationSet>;
export type ClaymationSetOutput = zod.output<typeof ClaymationSet>;

export const claymationShotLineIdsMax = 60;

export const claymationShotPictureMax = 2000;

export const claymationShotProductsInFrameMax = 60;



export const ClaymationShot = zod.object({
  "character_in_frame": zod.boolean(),
  "line_ids": zod.array(zod.int()).max(claymationShotLineIdsMax),
  "picture": zod.string().max(claymationShotPictureMax),
  "products_in_frame": zod.array(ClaymationProductId).max(claymationShotProductsInFrameMax),
  "set_id": ClaymationSetId,
  "shot_id": zod.int()
});

export type ClaymationShot = zod.input<typeof ClaymationShot>;
export type ClaymationShotOutput = zod.output<typeof ClaymationShot>;

export const claymationScriptBrandMax = 2000;

export const claymationScriptBrandUrlMax = 2000;

export const claymationScriptClaimsMax = 60;

export const claymationScriptEndLineMax = 2000;

export const claymationScriptLinesMax = 60;

export const claymationScriptMechanismMax = 2000;

export const claymationScriptOverlaysMax = 60;

export const claymationScriptProductsMax = 60;

export const claymationScriptPronunciationsMax = 60;

export const claymationScriptSetsMax = 60;

export const claymationScriptShotsMax = 60;



export const ClaymationScript = zod.object({
  "brand": zod.string().max(claymationScriptBrandMax),
  "brand_url": zod.string().max(claymationScriptBrandUrlMax),
  "character": ClaymationCharacter,
  "claims": zod.array(ClaymationClaim).max(claymationScriptClaimsMax),
  "end_card": ClaymationEndCard,
  "end_line": zod.string().max(claymationScriptEndLineMax),
  "lines": zod.array(ClaymationLine).max(claymationScriptLinesMax),
  "mechanism": zod.string().max(claymationScriptMechanismMax),
  "overlays": zod.array(ClaymationOverlay).max(claymationScriptOverlaysMax),
  "product_count": zod.union([zod.literal(1),zod.literal(2)]),
  "products": zod.array(ClaymationProduct).max(claymationScriptProductsMax),
  "pronunciations": zod.array(ClaymationPronunciation).max(claymationScriptPronunciationsMax),
  "sets": zod.array(ClaymationSet).max(claymationScriptSetsMax),
  "shots": zod.array(ClaymationShot).max(claymationScriptShotsMax),
  "word_count": zod.int()
}).describe('Live\'s script (`W/script.ts:175-194`): the script director\'s answer, edited in the form\nbefore approval; `product_count` 1 or 2, `word_count` code\'s count at approval.');

export type ClaymationScript = zod.input<typeof ClaymationScript>;
export type ClaymationScriptOutput = zod.output<typeof ClaymationScript>;

export const claymationSpecCharacterLockMax = 2000;

export const claymationSpecCharacterNameMax = 2000;



export const ClaymationSpecCharacter = zod.object({
  "lock": zod.string().max(claymationSpecCharacterLockMax),
  "name": zod.string().max(claymationSpecCharacterNameMax)
});

export type ClaymationSpecCharacter = zod.input<typeof ClaymationSpecCharacter>;
export type ClaymationSpecCharacterOutput = zod.output<typeof ClaymationSpecCharacter>;

export const claymationSpecItemLookMax = 2000;

export const claymationSpecItemNameMax = 2000;



export const ClaymationSpecItem = zod.object({
  "height_cm": zod.number(),
  "id": ClaymationProductId,
  "look": zod.string().max(claymationSpecItemLookMax),
  "name": zod.string().max(claymationSpecItemNameMax)
});

export type ClaymationSpecItem = zod.input<typeof ClaymationSpecItem>;
export type ClaymationSpecItemOutput = zod.output<typeof ClaymationSpecItem>;

export const claymationSpecProductItemsMax = 60;

export const claymationSpecProductPackTypeMax = 2000;

export const claymationSpecProductProductLockMax = 2000;

export const claymationSpecProductSheetLayoutMax = 2000;

export const claymationSpecProductSizeLineMax = 2000;



export const ClaymationSpecProduct = zod.object({
  "items": zod.array(ClaymationSpecItem).max(claymationSpecProductItemsMax),
  "pack_type": zod.string().max(claymationSpecProductPackTypeMax),
  "product_lock": zod.string().max(claymationSpecProductProductLockMax),
  "sheet_layout": zod.string().max(claymationSpecProductSheetLayoutMax),
  "size_line": zod.string().max(claymationSpecProductSizeLineMax)
});

export type ClaymationSpecProduct = zod.input<typeof ClaymationSpecProduct>;
export type ClaymationSpecProductOutput = zod.output<typeof ClaymationSpecProduct>;

export const claymationSpecSetPlaceMax = 2000;

export const claymationSpecSetPlateBackgroundMax = 2000;

export const claymationSpecSetPlateCameraMax = 2000;

export const claymationSpecSetPlateDetailMax = 2000;

export const claymationSpecSetPlateForegroundMax = 2000;

export const claymationSpecSetPlateMidgroundMax = 2000;

export const claymationSpecSetWorldLockMax = 2000;



export const ClaymationSpecSet = zod.object({
  "id": ClaymationSetId,
  "place": zod.string().max(claymationSpecSetPlaceMax),
  "plate_background": zod.string().max(claymationSpecSetPlateBackgroundMax),
  "plate_camera": zod.string().max(claymationSpecSetPlateCameraMax),
  "plate_detail": zod.string().max(claymationSpecSetPlateDetailMax),
  "plate_foreground": zod.string().max(claymationSpecSetPlateForegroundMax),
  "plate_midground": zod.string().max(claymationSpecSetPlateMidgroundMax),
  "world_lock": zod.string().max(claymationSpecSetWorldLockMax)
});

export type ClaymationSpecSet = zod.input<typeof ClaymationSpecSet>;
export type ClaymationSpecSetOutput = zod.output<typeof ClaymationSpecSet>;

export const claymationSpecShotBackgroundMax = 2000;

export const claymationSpecShotCameraAngleMax = 2000;

export const claymationSpecShotForegroundMax = 2000;

export const claymationSpecShotLocksMax = 60;

export const claymationSpecShotMidgroundMax = 2000;

export const claymationSpecShotOrientationChangeMax = 2000;

export const claymationSpecShotPosesItemMax = 2000;

export const claymationSpecShotPosesMax = 60;

export const claymationSpecShotProductActionMax = 2000;

export const claymationSpecShotProductsInFrameMax = 60;

export const claymationSpecShotSceneMax = 2000;

export const claymationSpecShotTippedProductsMax = 60;

export const claymationSpecShotWhimsicalDetailMax = 2000;



export const ClaymationSpecShot = zod.object({
  "background": zod.string().max(claymationSpecShotBackgroundMax),
  "camera_angle": zod.string().max(claymationSpecShotCameraAngleMax),
  "character_in_frame": zod.boolean(),
  "continuity_from": zod.int(),
  "foreground": zod.string().max(claymationSpecShotForegroundMax),
  "locks": zod.array(zod.literal("branch")).max(claymationSpecShotLocksMax),
  "midground": zod.string().max(claymationSpecShotMidgroundMax),
  "orientation_change": zod.string().max(claymationSpecShotOrientationChangeMax),
  "poses": zod.array(zod.string().max(claymationSpecShotPosesItemMax)).max(claymationSpecShotPosesMax),
  "product_action": zod.string().max(claymationSpecShotProductActionMax),
  "products_in_frame": zod.array(ClaymationProductId).max(claymationSpecShotProductsInFrameMax),
  "scene": zod.string().max(claymationSpecShotSceneMax),
  "set_id": ClaymationSetId,
  "shot_id": zod.int(),
  "tipped_products": zod.array(ClaymationProductId).max(claymationSpecShotTippedProductsMax),
  "whimsical_detail": zod.string().max(claymationSpecShotWhimsicalDetailMax)
});

export type ClaymationSpecShot = zod.input<typeof ClaymationSpecShot>;
export type ClaymationSpecShotOutput = zod.output<typeof ClaymationSpecShot>;

export const claymationShotSpecPaletteMax = 2000;

export const claymationShotSpecSetsMax = 60;

export const claymationShotSpecShotsMax = 60;



export const ClaymationShotSpec = zod.object({
  "character": ClaymationSpecCharacter,
  "palette": zod.string().max(claymationShotSpecPaletteMax),
  "product": ClaymationSpecProduct,
  "sets": zod.array(ClaymationSpecSet).max(claymationShotSpecSetsMax),
  "shots": zod.array(ClaymationSpecShot).max(claymationShotSpecShotsMax)
}).describe('Live\'s shot spec (`W/shot.ts:110-116`): the shot director\'s answer, what the stills and\nthe clips are drawn from.');

export type ClaymationShotSpec = zod.input<typeof ClaymationShotSpec>;
export type ClaymationShotSpecOutput = zod.output<typeof ClaymationShotSpec>;

export const ClaymationDraftStage = zod.enum(['script', 'voice', 'storyboard']).describe('Live\'s stages (`W/types.ts:12-16`): the script, the voice once it is approved, the\nstoryboard once a take is.');

export type ClaymationDraftStage = zod.input<typeof ClaymationDraftStage>;
export type ClaymationDraftStageOutput = zod.output<typeof ClaymationDraftStage>;

export const ClaymationStillName = zod.enum(['end_card', 'sheet_character', 'product_sheet', 'plate_s1', 'plate_s2', 'plate_s3', 'shot_1', 'shot_2', 'shot_3', 'shot_4', 'shot_5', 'shot_6', 'shot_7', 'shot_8', 'shot_1_turn', 'shot_2_turn', 'shot_3_turn', 'shot_4_turn', 'shot_5_turn', 'shot_6_turn', 'shot_7_turn', 'shot_8_turn']);

export type ClaymationStillName = zod.input<typeof ClaymationStillName>;
export type ClaymationStillNameOutput = zod.output<typeof ClaymationStillName>;

export const ClaymationDraftStill = zod.object({
  "name": ClaymationStillName,
  "output": zod.union([OutputRef,zod.null()]).exactOptional(),
  "problem": zod.union([zod.string(),zod.null()]),
  "status": StillStatus,
  "url": zod.union([zod.string(),zod.null()])
}).describe('One of the storyboard\'s stills (live\'s `StillState`), as `DraftStill`.');

export type ClaymationDraftStill = zod.input<typeof ClaymationDraftStill>;
export type ClaymationDraftStillOutput = zod.output<typeof ClaymationDraftStill>;

export const PixarTakeVerdict = zod.enum(['pass', 'note', 'fail']).describe('A take\'s check (live\'s `TAKE_VERDICTS`): a `fail` cannot be picked.');

export type PixarTakeVerdict = zod.input<typeof PixarTakeVerdict>;
export type PixarTakeVerdictOutput = zod.output<typeof PixarTakeVerdict>;

export const ClaymationTake = zod.object({
  "duration_s": zod.union([zod.number(),zod.null()]),
  "fails": zod.array(zod.string()),
  "notes": zod.array(zod.string()),
  "number": zod.int(),
  "output": zod.union([OutputRef,zod.null()]).exactOptional(),
  "pace_wps": zod.union([zod.number(),zod.null()]),
  "pickable": zod.boolean(),
  "planned_s": zod.union([zod.number(),zod.null()]),
  "problem": zod.union([zod.string(),zod.null()]),
  "status": StillStatus,
  "url": zod.union([zod.string(),zod.null()]),
  "verdict": zod.union([PixarTakeVerdict,zod.null()]),
  "vo_end": zod.union([zod.number(),zod.null()])
}).describe('One voiceover take (live\'s take card): `working` while it is made or heard, `done` with\nits voice at `url` and its check, or `failed` (`problem` says why). The check\'s verdict,\nfails and notes in live\'s words; `planned_s`, the script\'s planned length, `vo_end`, where\nits last word ends, and `pace_wps`, its words a second, for the card\'s line. `pickable`:\nevery line heard (live\'s `isEveryLineHeard`); `output` names the voice, as the video\'s run\ntakes it.');

export type ClaymationTake = zod.input<typeof ClaymationTake>;
export type ClaymationTakeOutput = zod.output<typeof ClaymationTake>;

export const _CheckTextMax = 2000;



export const _CheckText = zod.string().max(_CheckTextMax);

export type _CheckText = zod.input<typeof _CheckText>;
export type _CheckTextOutput = zod.output<typeof _CheckText>;

export const claymationLineTimeTextMax = 2000;



export const ClaymationLineTime = zod.object({
  "end_s": zod.union([zod.number(),zod.null()]),
  "line_id": zod.int(),
  "start_s": zod.union([zod.number(),zod.null()]),
  "text": zod.string().max(claymationLineTimeTextMax)
}).describe('Where a line is heard in a take (None when none of its words was).');

export type ClaymationLineTime = zod.input<typeof ClaymationLineTime>;
export type ClaymationLineTimeOutput = zod.output<typeof ClaymationLineTime>;

export const claymationMapWordTextMax = 2000;



export const ClaymationMapWord = zod.object({
  "brk": zod.boolean(),
  "end": zod.number(),
  "line_id": zod.int(),
  "start": zod.number(),
  "text": zod.string().max(claymationMapWordTextMax)
}).describe('A word of the timing map: its script spelling, its seconds, its line, and whether it is\nthe line\'s last (`brk`).');

export type ClaymationMapWord = zod.input<typeof ClaymationMapWord>;
export type ClaymationMapWordOutput = zod.output<typeof ClaymationMapWord>;

export const claymationTakeCheckFailsMax = 1000;

export const claymationTakeCheckIssuesMax = 2000;

export const claymationTakeCheckLinesMax = 60;

export const claymationTakeCheckNotesMax = 1000;

export const claymationTakeCheckWordsMax = 1000;



export const ClaymationTakeCheck = zod.object({
  "duration": zod.number(),
  "fails": zod.array(_CheckText).max(claymationTakeCheckFailsMax),
  "issues": zod.array(_CheckText).max(claymationTakeCheckIssuesMax),
  "lines": zod.array(ClaymationLineTime).max(claymationTakeCheckLinesMax),
  "notes": zod.array(_CheckText).max(claymationTakeCheckNotesMax),
  "pace_wps": zod.union([zod.number(),zod.null()]),
  "planned_s": zod.number(),
  "verdict": PixarTakeVerdict,
  "vo_end": zod.union([zod.number(),zod.null()]),
  "vo_start": zod.union([zod.number(),zod.null()]),
  "words": zod.array(ClaymationMapWord).max(claymationTakeCheckWordsMax)
}).describe('One voiceover take checked against the script, with its timing map (live\'s `TakeCheck`):\nthe fails and notes in live\'s words, `issues` the two joined, where the voice starts and\nends (None when no word was heard), its pace and the planned length. The draft keeps it with\nits take; "Generate final video" sends the picked one\'s, which the run\'s plan and captions\nread.');

export type ClaymationTakeCheck = zod.input<typeof ClaymationTakeCheck>;
export type ClaymationTakeCheckOutput = zod.output<typeof ClaymationTakeCheck>;

export const ClaymationVideoTake = zod.object({
  "check": ClaymationTakeCheck,
  "voice": OutputRef
}).describe('The picked take: its voice (the take\'s output) and its check, whose timing map the run\'s\nshot plan and captions read.');

export type ClaymationVideoTake = zod.input<typeof ClaymationVideoTake>;
export type ClaymationVideoTakeOutput = zod.output<typeof ClaymationVideoTake>;

export const ClaymationAdDraft = zod.object({
  "inputs": ClaymationAdInputs,
  "narrator_voice": zod.union([ClaymationNarrator,zod.null()]),
  "pack_director": DirectorState,
  "pack_warning": zod.boolean(),
  "packshot": zod.union([TemplateSource,zod.null()]),
  "picked_take": zod.union([zod.int(),zod.null()]),
  "plan": zod.union([ClaymationShotPlan,zod.null()]),
  "preferred_take": zod.union([zod.int(),zod.null()]),
  "problem": zod.union([zod.string(),zod.null()]),
  "script": zod.union([ClaymationScript,zod.null()]),
  "script_director": DirectorState,
  "script_problems": zod.array(zod.string()),
  "script_warning": zod.union([zod.string(),zod.null()]),
  "shot_director": DirectorState,
  "spec": zod.union([ClaymationShotSpec,zod.null()]),
  "spec_warning": zod.union([zod.string(),zod.null()]),
  "stage": ClaymationDraftStage,
  "stills": zod.array(ClaymationDraftStill),
  "takes": zod.array(ClaymationTake),
  "takes_note": zod.union([zod.string(),zod.null()]),
  "updated_at": zod.iso.datetime({"offset":true}),
  "urls_expire_at": zod.union([zod.iso.datetime({"offset":true}),zod.null()]),
  "video_take": zod.union([ClaymationVideoTake,zod.null()])
}).describe('A member\'s Claymation Ad draft in the brand: the form, the stage, the script and its\ndirectors (the pack reader\'s, then the script\'s). `pack_warning`: the pack was hard to read\n(live\'s words); `script_warning`: live\'s words for a script still off its checks after the\ndirector\'s three tries, and `script_problems` what is off in the script as it stands, each\nin live\'s words. `problem`: live\'s words for the last director that failed. From Approve\nscript, the voiceover\'s takes and live\'s note on them; once every take ends, the one live\npre-picks (`preferred_take`, none when every take failed its check); from Approve voice, the\npicked take, its shot plan, and the take as "Generate final video" sends it (`video_take`).\nFrom Approve script too, the shot director\'s state, its spec\nand live\'s words when it is still off after three tries (`spec_warning`), and the\nstoryboard\'s stills in render order: the end card, then the spec\'s. `urls_expire_at`: when\nthe takes\' and the stills\' URLs stop working. `narrator_voice`: the narrator the form\npicked, by its name now, for the narrator\'s tile; none until one is picked, or once it is\nno voice the team may use. `packshot`: the product tile\'s packshot as "Generate final video"\nsends it (`picked_packshot`), none until one is picked.');

export type ClaymationAdDraft = zod.input<typeof ClaymationAdDraft>;
export type ClaymationAdDraftOutput = zod.output<typeof ClaymationAdDraft>;

export const ClaymationAdDraftWrite = zod.object({
  "inputs": ClaymationAdInputs,
  "script": zod.union([ClaymationScript,zod.null()]).exactOptional()
}).describe('`PUT .../templates/claymation-ad/draft`: the form as it stands, its script as edited.');

export type ClaymationAdDraftWrite = zod.input<typeof ClaymationAdDraftWrite>;
export type ClaymationAdDraftWriteOutput = zod.output<typeof ClaymationAdDraftWrite>;

export const claymationAdPickedInputsBrandUrlDefault = ``;
export const claymationAdPickedInputsBrandUrlMax = 2000;

export const claymationAdPickedInputsCaptionPositionDefault = `bottom`;
export const claymationAdPickedInputsCaptionStyleIdDefault = ``;
export const claymationAdPickedInputsCaptionStyleIdMax = 64;

export const claymationAdPickedInputsClosingLineDefault = ``;
export const claymationAdPickedInputsClosingLineMax = 2000;

export const claymationAdPickedInputsCtaDefault = ``;
export const claymationAdPickedInputsCtaMax = 2000;

export const claymationAdPickedInputsMechanismDefault = ``;
export const claymationAdPickedInputsMechanismMax = 500;

export const claymationAdPickedInputsMusicBedDefault = true;
export const claymationAdPickedInputsProductCategoryDefault = ``;
export const claymationAdPickedInputsProductCategoryMax = 200;

export const claymationAdPickedInputsProductCountDefault = `auto`;
export const claymationAdPickedInputsProductNameDefault = ``;
export const claymationAdPickedInputsProductNameMax = 200;

export const claymationAdPickedInputsProductTextDefault = ``;
export const claymationAdPickedInputsProductTextMax = 20000;

export const claymationAdPickedInputsPronunciationDefault = ``;
export const claymationAdPickedInputsPronunciationMax = 500;

export const claymationAdPickedInputsResolutionDefault = `720p`;
export const claymationAdPickedInputsSubtitlesDefault = true;

export const ClaymationAdPickedInputs = zod.object({
  "brand_url": zod.string().max(claymationAdPickedInputsBrandUrlMax).default(claymationAdPickedInputsBrandUrlDefault),
  "caption_position": zod.enum(['top', 'center', 'bottom']).default(claymationAdPickedInputsCaptionPositionDefault),
  "caption_style_id": zod.string().max(claymationAdPickedInputsCaptionStyleIdMax).default(claymationAdPickedInputsCaptionStyleIdDefault),
  "closing_line": zod.string().max(claymationAdPickedInputsClosingLineMax).default(claymationAdPickedInputsClosingLineDefault),
  "cta": zod.string().max(claymationAdPickedInputsCtaMax).default(claymationAdPickedInputsCtaDefault),
  "mechanism": zod.string().max(claymationAdPickedInputsMechanismMax).default(claymationAdPickedInputsMechanismDefault),
  "music_bed": zod.boolean().default(claymationAdPickedInputsMusicBedDefault),
  "narrator": zod.union([zod.uuid(),zod.null()]).exactOptional(),
  "product": PackshotProduct,
  "product_category": zod.string().max(claymationAdPickedInputsProductCategoryMax).default(claymationAdPickedInputsProductCategoryDefault),
  "product_count": zod.enum(['auto', '1', '2']).default(claymationAdPickedInputsProductCountDefault),
  "product_name": zod.string().max(claymationAdPickedInputsProductNameMax).default(claymationAdPickedInputsProductNameDefault),
  "product_text": zod.string().max(claymationAdPickedInputsProductTextMax).default(claymationAdPickedInputsProductTextDefault),
  "pronunciation": zod.string().max(claymationAdPickedInputsPronunciationMax).default(claymationAdPickedInputsPronunciationDefault),
  "resolution": zod.enum(['720p', '1080p']).default(claymationAdPickedInputsResolutionDefault),
  "subtitles": zod.boolean().default(claymationAdPickedInputsSubtitlesDefault)
}).describe('The form with its product picked, as Generate Script and Approve script need it (live\'s\n"Pick a product and its packshot", 422 at `product`).');

export type ClaymationAdPickedInputs = zod.input<typeof ClaymationAdPickedInputs>;
export type ClaymationAdPickedInputsOutput = zod.output<typeof ClaymationAdPickedInputs>;

export const ClaymationAdScriptApproval = zod.object({
  "inputs": ClaymationAdPickedInputs,
  "script": ClaymationScript
}).describe('`POST .../draft/approve`: live\'s Approve script, the form and the script as edited.');

export type ClaymationAdScriptApproval = zod.input<typeof ClaymationAdScriptApproval>;
export type ClaymationAdScriptApprovalOutput = zod.output<typeof ClaymationAdScriptApproval>;

export const ClaymationAdScriptAsk = zod.object({
  "inputs": ClaymationAdPickedInputs
}).describe('`POST .../draft/script`: live\'s wand ("Generate Script"), on the form as it stands.');

export type ClaymationAdScriptAsk = zod.input<typeof ClaymationAdScriptAsk>;
export type ClaymationAdScriptAskOutput = zod.output<typeof ClaymationAdScriptAsk>;

export const claymationAdVideoInputsCaptionPositionDefault = `bottom`;
export const claymationAdVideoInputsCaptionStyleIdDefault = ``;
export const claymationAdVideoInputsCaptionStyleIdMax = 64;

export const claymationAdVideoInputsMusicBedDefault = true;
export const claymationAdVideoInputsResolutionDefault = `720p`;
export const claymationAdVideoInputsSubtitlesDefault = true;

export const ClaymationAdVideoInputs = zod.object({
  "caption_position": zod.enum(['top', 'center', 'bottom']).default(claymationAdVideoInputsCaptionPositionDefault),
  "caption_style_id": zod.string().max(claymationAdVideoInputsCaptionStyleIdMax).default(claymationAdVideoInputsCaptionStyleIdDefault),
  "music_bed": zod.boolean().default(claymationAdVideoInputsMusicBedDefault),
  "packshot": TemplateSource,
  "resolution": zod.enum(['720p', '1080p']).default(claymationAdVideoInputsResolutionDefault),
  "script": ClaymationScript,
  "spec": ClaymationShotSpec,
  "stills": zod.record(zod.string(), OutputRef),
  "subtitles": zod.boolean().default(claymationAdVideoInputsSubtitlesDefault),
  "take": ClaymationVideoTake,
  "template": zod.enum(['claymation-ad'])
}).describe('Claymation Ad\'s "Generate final video" (live\'s hand-off, G14-claymation-ad PR c): the\napproved script and shot spec, the picked take, the packshot and the storyboard\'s stills by\nname (each the draft\'s drawn picture), the music bed, the captions and the resolution. One\ntile: a silent clip per shot and the end card\'s, merged, captioned in two passes, the\nvoiceover laid under it and the bed mixed under that.');

export type ClaymationAdVideoInputs = zod.input<typeof ClaymationAdVideoInputs>;
export type ClaymationAdVideoInputsOutput = zod.output<typeof ClaymationAdVideoInputs>;

export const claymationAdVoiceApprovalTakeMax = 6;



export const ClaymationAdVoiceApproval = zod.object({
  "take": zod.int().min(1).max(claymationAdVoiceApprovalTakeMax)
}).describe('`POST .../draft/approve-voice`: live\'s Approve voice, the take picked by its number.');

export type ClaymationAdVoiceApproval = zod.input<typeof ClaymationAdVoiceApproval>;
export type ClaymationAdVoiceApprovalOutput = zod.output<typeof ClaymationAdVoiceApproval>;

export const keyframeAtMin = 0;
export const keyframeAtMax = 100;

export const keyframeValuesMinOne = -10000;
export const keyframeValuesMaxOne = 10000;

export const keyframeValuesDefault = {};

export const Keyframe = zod.object({
  "at": zod.int().min(keyframeAtMin).max(keyframeAtMax),
  "values": zod.record(zod.string(), zod.number().min(keyframeValuesMinOne).max(keyframeValuesMaxOne)).default(keyframeValuesDefault)
}).describe('One stop of a Custom animation: `at` percent of a cycle, and the properties it sets\n(one it leaves unset is at rest there, as live\'s).');

export type Keyframe = zod.input<typeof Keyframe>;
export type KeyframeOutput = zod.output<typeof Keyframe>;

export const clipAnimationAngleDefault = 45;
export const clipAnimationAngleMin = 0;
export const clipAnimationAngleMax = 360;

export const clipAnimationAxisDefault = 'vertical';
export const clipAnimationBlockColorDefault = `#FFFFFF`;
export const clipAnimationBlockColorRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const clipAnimationBlockModeDefault = 'reveal';
export const clipAnimationBlockSizeDefault = 0.3;
export const clipAnimationBlockSizeMin = 0.1;
export const clipAnimationBlockSizeMax = 1;

export const clipAnimationBorderRadiusDefault = 0;
export const clipAnimationBorderRadiusMin = 0;
export const clipAnimationBorderRadiusMax = 200;

export const clipAnimationDelayMsDefault = 0;
export const clipAnimationDelayMsMin = 0;
export const clipAnimationDelayMsMax = 300000;

export const clipAnimationDirectionDefault = 'left';
export const clipAnimationDistanceDefault = 300;
export const clipAnimationDistanceMin = -10000;
export const clipAnimationDistanceMax = 10000;

export const clipAnimationDurationMsDefault = 1000;
export const clipAnimationDurationMsMin = 0;
export const clipAnimationDurationMsMax = 300000;

export const clipAnimationEasingDefault = 'linear';
export const clipAnimationIdRegExp = new RegExp('^[A-Za-z0-9_-]{1,64}$');
export const clipAnimationInitialDefault = 0;
export const clipAnimationInitialMin = 0;
export const clipAnimationInitialMax = 0.9;

export const clipAnimationInvertedColorDefault = `#000000`;
export const clipAnimationInvertedColorRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const clipAnimationIterationsDefault = 1;
export const clipAnimationIterationsMax = 100;

export const clipAnimationKeyframesDefault = [];
export const clipAnimationKeyframesMax = 20;

export const clipAnimationMirrorDefault = false;
export const clipAnimationOriginDefault = 'center';
export const clipAnimationStaggerOneMin = 0;
export const clipAnimationStaggerOneMax = 1.5;

export const clipAnimationXMarginDefault = 100;
export const clipAnimationXMarginMin = 0;
export const clipAnimationXMarginMax = 500;

export const clipAnimationYMarginDefault = 100;
export const clipAnimationYMarginMin = 0;
export const clipAnimationYMarginMax = 500;



export const ClipAnimation = zod.object({
  "angle": zod.number().min(clipAnimationAngleMin).max(clipAnimationAngleMax).default(clipAnimationAngleDefault),
  "axis": AnimationAxis.default(clipAnimationAxisDefault),
  "block_color": zod.string().regex(clipAnimationBlockColorRegExp).default(clipAnimationBlockColorDefault),
  "block_mode": BlockMode.default(clipAnimationBlockModeDefault),
  "block_size": zod.number().min(clipAnimationBlockSizeMin).max(clipAnimationBlockSizeMax).default(clipAnimationBlockSizeDefault),
  "border_radius": zod.number().min(clipAnimationBorderRadiusMin).max(clipAnimationBorderRadiusMax).default(clipAnimationBorderRadiusDefault),
  "delay_ms": zod.int().min(clipAnimationDelayMsMin).max(clipAnimationDelayMsMax).default(clipAnimationDelayMsDefault),
  "direction": AnimationDirection.default(clipAnimationDirectionDefault),
  "distance": zod.number().min(clipAnimationDistanceMin).max(clipAnimationDistanceMax).default(clipAnimationDistanceDefault),
  "duration_ms": zod.int().min(clipAnimationDurationMsMin).max(clipAnimationDurationMsMax).default(clipAnimationDurationMsDefault),
  "easing": AnimationEasing.default(clipAnimationEasingDefault),
  "id": zod.string().regex(clipAnimationIdRegExp),
  "initial": zod.number().min(clipAnimationInitialMin).max(clipAnimationInitialMax).default(clipAnimationInitialDefault),
  "inverted_color": zod.string().regex(clipAnimationInvertedColorRegExp).default(clipAnimationInvertedColorDefault),
  "iterations": zod.int().min(1).max(clipAnimationIterationsMax).default(clipAnimationIterationsDefault),
  "keyframes": zod.array(Keyframe).max(clipAnimationKeyframesMax).default(clipAnimationKeyframesDefault),
  "mirror": zod.boolean().default(clipAnimationMirrorDefault),
  "mode": zod.union([AnimationMode,zod.null()]).exactOptional(),
  "origin": AnimationOrigin.default(clipAnimationOriginDefault),
  "preset": AnimationPreset,
  "stagger": zod.union([zod.number().min(clipAnimationStaggerOneMin).max(clipAnimationStaggerOneMax),zod.null()]).exactOptional(),
  "x_margin": zod.number().min(clipAnimationXMarginMin).max(clipAnimationXMarginMax).default(clipAnimationXMarginDefault),
  "y_margin": zod.number().min(clipAnimationYMarginMin).max(clipAnimationYMarginMax).default(clipAnimationYMarginDefault)
}).describe('One of a clip\'s animations, as live\'s popover sets it (#266): a preset, In or Out (none\nfor a combo), its Timing and Easing, and the preset\'s own settings, each with live\'s\ndefault. A preset\'s motion is not stored: it is the SPA\'s (`PRESETS` in\nweb/src/features/editor/animations.ts, read by its engine/animate.ts). An Out\'s delay is\nnot kept: it ends at the clip\'s end however the clip is trimmed (spec decision 4).');

export type ClipAnimation = zod.input<typeof ClipAnimation>;
export type ClipAnimationOutput = zod.output<typeof ClipAnimation>;

export const ClonedVoice = zod.object({
  "voice_id": zod.uuid()
}).describe('What `voice.clone`\'s one output holds (spec G14-yapper, the voice lock): the brand\'s\nvoice the step cloned from a sound of the run, by its id, which the run\'s voice swaps\nname.');

export type ClonedVoice = zod.input<typeof ClonedVoice>;
export type ClonedVoiceOutput = zod.output<typeof ClonedVoice>;

export const CodeSent = zod.object({
  "expires_in_seconds": zod.int()
}).describe('Always the answer to a code request, whether or not the email has an account.');

export type CodeSent = zod.input<typeof CodeSent>;
export type CodeSentOutput = zod.output<typeof CodeSent>;

export const Consents = zod.object({
  "ads_at": zod.union([zod.iso.datetime({"offset":true}),zod.null()]),
  "marketing_at": zod.union([zod.iso.datetime({"offset":true}),zod.null()])
}).describe('When the user agreed to marketing email and to ads audiences; None when they did not.');

export type Consents = zod.input<typeof Consents>;
export type ConsentsOutput = zod.output<typeof Consents>;

export const ConsentsUpdate = zod.object({
  "ads": zod.boolean(),
  "marketing": zod.boolean()
}).describe('`PUT /v1/me/consents`: true records the consent (its first time is kept), false clears.\nJSON booleans only: a consent is never read from a 0, a 1 or a string.');

export type ConsentsUpdate = zod.input<typeof ConsentsUpdate>;
export type ConsentsUpdateOutput = zod.output<typeof ConsentsUpdate>;

export const CostSource = zod.enum(['table', 'free', 'vendor']);

export type CostSource = zod.input<typeof CostSource>;
export type CostSourceOutput = zod.output<typeof CostSource>;

export const DeliveryState = zod.enum(['running', 'done', 'failed']).describe('Where a vendor says a request is, in a poll answer or a webhook.');

export type DeliveryState = zod.input<typeof DeliveryState>;
export type DeliveryStateOutput = zod.output<typeof DeliveryState>;

export const LayerBox = zod.object({
  "height": zod.int(),
  "width": zod.int(),
  "x": zod.int(),
  "y": zod.int()
}).describe('A layer\'s place on its base, in the base\'s pixels.');

export type LayerBox = zod.input<typeof LayerBox>;
export type LayerBoxOutput = zod.output<typeof LayerBox>;

export const DocumentLayer = zod.object({
  "box": zod.union([LayerBox,zod.null()]),
  "description": zod.union([zod.string(),zod.null()]),
  "height": zod.union([zod.int(),zod.null()]),
  "name": zod.union([zod.string(),zod.null()]),
  "output_index": zod.int(),
  "url": zod.union([zod.string(),zod.null()]),
  "width": zod.union([zod.int(),zod.null()]),
  "z_index": zod.int()
}).describe('One layer of a Layerize\'s document: its output (`url` signed as the job\'s outputs), its\n`z_index`, FAL\'s name and description (null when FAL gave none: the editor says "Layer n"),\nits `box` on the base (null on the base only), and its picture\'s own size.');

export type DocumentLayer = zod.input<typeof DocumentLayer>;
export type DocumentLayerOutput = zod.output<typeof DocumentLayer>;

export const StillName = zod.enum(['master', 'host_close', 'guest_close', 'guest_hold', 'end_card']);

export type StillName = zod.input<typeof StillName>;
export type StillNameOutput = zod.output<typeof StillName>;

export const DraftStill = zod.object({
  "name": StillName,
  "output": zod.union([OutputRef,zod.null()]).exactOptional(),
  "problem": zod.union([zod.string(),zod.null()]),
  "status": StillStatus,
  "url": zod.union([zod.string(),zod.null()])
}).describe('One of the cast\'s five stills (live\'s `StillState`): the master two-shot, the host\'s and\nthe guest\'s close-ups, the guest holding the product, the end card. `url` is signed until the\ndraft\'s `urls_expire_at`; `output` names the drawn picture, as "Generate video" sends it\n(`PodcastStills`).');

export type DraftStill = zod.input<typeof DraftStill>;
export type DraftStillOutput = zod.output<typeof DraftStill>;

export const DubLanguageRegExp = new RegExp('^[a-z]{2,3}$');


export const DubLanguage = zod.string().regex(DubLanguageRegExp);

export type DubLanguage = zod.input<typeof DubLanguage>;
export type DubLanguageOutput = zod.output<typeof DubLanguage>;

export const dubbingSettingsNumSpeakersOneMin = 0;
export const dubbingSettingsNumSpeakersOneMax = 100;

export const dubbingSettingsSourceLangOneRegExp = new RegExp('^[a-z]{2,4}$');
export const dubbingSettingsTargetLangOneRegExp = new RegExp('^[a-z]{2,4}$');


export const DubbingSettings = zod.object({
  "drop_background_audio": zod.union([zod.boolean(),zod.null()]).exactOptional(),
  "num_speakers": zod.union([zod.int().min(dubbingSettingsNumSpeakersOneMin).max(dubbingSettingsNumSpeakersOneMax),zod.null()]).exactOptional(),
  "source_lang": zod.union([zod.string().regex(dubbingSettingsSourceLangOneRegExp),zod.null()]).exactOptional(),
  "target_lang": zod.union([zod.string().regex(dubbingSettingsTargetLangOneRegExp),zod.null()]).exactOptional()
}).describe('Video Dubbing\'s choices (live\'s `sourceLang`, `targetLang`, `numSpeakers`,\n`dropBackgroundAudio`): each left out takes the model\'s default, 0 speakers meaning Auto.');

export type DubbingSettings = zod.input<typeof DubbingSettings>;
export type DubbingSettingsOutput = zod.output<typeof DubbingSettings>;

export const EditCaptionsChange = zod.object({
  "look": zod.union([CaptionSettings,zod.null()])
}).describe('The captions\' look as a save left it (spec live-sync.md); null is live\'s default look.');

export type EditCaptionsChange = zod.input<typeof EditCaptionsChange>;
export type EditCaptionsChangeOutput = zod.output<typeof EditCaptionsChange>;

export const videoClipAnimationsDefault = [];
export const videoClipAnimationsMax = 20;

export const videoClipEndSMin = 0;
export const videoClipEndSMax = 300;

export const videoClipFadeInMsDefault = 0;
export const videoClipFadeInMsMin = 0;
export const videoClipFadeInMsMax = 5000;

export const videoClipFadeOutMsDefault = 0;
export const videoClipFadeOutMsMin = 0;
export const videoClipFadeOutMsMax = 5000;

export const videoClipFlipXDefault = false;
export const videoClipFlipYDefault = false;
export const videoClipHiddenDefault = false;
export const videoClipIdRegExp = new RegExp('^[A-Za-z0-9_-]{1,64}$');
export const videoClipInSDefault = 0;
export const videoClipInSMin = 0;
export const videoClipInSMax = 86400;

export const videoClipLockedDefault = false;
export const videoClipMutedDefault = false;
export const videoClipOpacityDefault = 1;
export const videoClipOpacityMin = 0;
export const videoClipOpacityMax = 1;

export const videoClipRadiusDefault = 0;
export const videoClipRadiusMin = 0;
export const videoClipRadiusMax = 500;

export const videoClipRotationDefault = 0;
export const videoClipRotationMin = -360;
export const videoClipRotationMax = 360;

export const videoClipSpeedDefault = 1;
export const videoClipSpeedMin = 0.25;
export const videoClipSpeedMax = 4;

export const videoClipSpeedPointsDefault = [];
export const videoClipSpeedPointsMax = 16;

export const videoClipStartSMin = 0;
export const videoClipStartSMax = 300;

export const videoClipTrackIdRegExp = new RegExp('^[A-Za-z0-9_-]{1,64}$');
export const videoClipVolumeDefault = 1;
export const videoClipVolumeMin = 0;
export const videoClipVolumeMax = 2;

export const videoClipVolumePointsDefault = [];
export const videoClipVolumePointsMax = 100;



export const VideoClip = zod.object({
  "animations": zod.array(ClipAnimation).max(videoClipAnimationsMax).default(videoClipAnimationsDefault),
  "box": zod.union([Box,zod.null()]).exactOptional(),
  "chroma_key": zod.union([ChromaKey,zod.null()]).exactOptional(),
  "end_s": zod.number().min(videoClipEndSMin).max(videoClipEndSMax),
  "fade_in_ms": zod.int().min(videoClipFadeInMsMin).max(videoClipFadeInMsMax).default(videoClipFadeInMsDefault),
  "fade_out_ms": zod.int().min(videoClipFadeOutMsMin).max(videoClipFadeOutMsMax).default(videoClipFadeOutMsDefault),
  "flip_x": zod.boolean().default(videoClipFlipXDefault),
  "flip_y": zod.boolean().default(videoClipFlipYDefault),
  "hidden": zod.boolean().default(videoClipHiddenDefault),
  "id": zod.string().regex(videoClipIdRegExp),
  "in_s": zod.number().min(videoClipInSMin).max(videoClipInSMax).default(videoClipInSDefault),
  "kind": zod.enum(['video']),
  "locked": zod.boolean().default(videoClipLockedDefault),
  "muted": zod.boolean().default(videoClipMutedDefault),
  "opacity": zod.number().min(videoClipOpacityMin).max(videoClipOpacityMax).default(videoClipOpacityDefault),
  "original_source": zod.union([SourceRef,zod.null()]).exactOptional(),
  "radius": zod.int().min(videoClipRadiusMin).max(videoClipRadiusMax).default(videoClipRadiusDefault),
  "rotation": zod.number().min(videoClipRotationMin).max(videoClipRotationMax).default(videoClipRotationDefault),
  "shadow": zod.union([Shadow,zod.null()]).exactOptional(),
  "source": SourceRef,
  "speed": zod.number().min(videoClipSpeedMin).max(videoClipSpeedMax).default(videoClipSpeedDefault),
  "speed_curve": zod.union([SpeedCurveName,zod.null()]).exactOptional(),
  "speed_points": zod.array(SpeedPoint).max(videoClipSpeedPointsMax).default(videoClipSpeedPointsDefault),
  "start_s": zod.number().min(videoClipStartSMin).max(videoClipStartSMax),
  "stroke": zod.union([Stroke,zod.null()]).exactOptional(),
  "track_id": zod.string().regex(videoClipTrackIdRegExp),
  "volume": zod.number().min(videoClipVolumeMin).max(videoClipVolumeMax).default(videoClipVolumeDefault),
  "volume_points": zod.array(VolumePoint).max(videoClipVolumePointsMax).default(videoClipVolumePointsDefault)
}).describe('A video read from `in_s` of its own time at `speed`, with its own sound unless `muted`. Once\nits background is removed (spec remove-background.md), it plays the job\'s output and keeps the\nfile it played before in `original_source`, which Restore original puts back; the render never\nreads it.');

export type VideoClip = zod.input<typeof VideoClip>;
export type VideoClipOutput = zod.output<typeof VideoClip>;

export const imageClipAnimationsDefault = [];
export const imageClipAnimationsMax = 20;

export const imageClipEndSMin = 0;
export const imageClipEndSMax = 300;

export const imageClipFlipXDefault = false;
export const imageClipFlipYDefault = false;
export const imageClipHiddenDefault = false;
export const imageClipIdRegExp = new RegExp('^[A-Za-z0-9_-]{1,64}$');
export const imageClipLockedDefault = false;
export const imageClipOpacityDefault = 1;
export const imageClipOpacityMin = 0;
export const imageClipOpacityMax = 1;

export const imageClipRadiusDefault = 0;
export const imageClipRadiusMin = 0;
export const imageClipRadiusMax = 500;

export const imageClipRotationDefault = 0;
export const imageClipRotationMin = -360;
export const imageClipRotationMax = 360;

export const imageClipStartSMin = 0;
export const imageClipStartSMax = 300;

export const imageClipTrackIdRegExp = new RegExp('^[A-Za-z0-9_-]{1,64}$');


export const ImageClip = zod.object({
  "animations": zod.array(ClipAnimation).max(imageClipAnimationsMax).default(imageClipAnimationsDefault),
  "box": zod.union([Box,zod.null()]).exactOptional(),
  "chroma_key": zod.union([ChromaKey,zod.null()]).exactOptional(),
  "end_s": zod.number().min(imageClipEndSMin).max(imageClipEndSMax),
  "flip_x": zod.boolean().default(imageClipFlipXDefault),
  "flip_y": zod.boolean().default(imageClipFlipYDefault),
  "hidden": zod.boolean().default(imageClipHiddenDefault),
  "id": zod.string().regex(imageClipIdRegExp),
  "kind": zod.enum(['image']),
  "locked": zod.boolean().default(imageClipLockedDefault),
  "opacity": zod.number().min(imageClipOpacityMin).max(imageClipOpacityMax).default(imageClipOpacityDefault),
  "radius": zod.int().min(imageClipRadiusMin).max(imageClipRadiusMax).default(imageClipRadiusDefault),
  "rotation": zod.number().min(imageClipRotationMin).max(imageClipRotationMax).default(imageClipRotationDefault),
  "shadow": zod.union([Shadow,zod.null()]).exactOptional(),
  "source": ActorSource,
  "start_s": zod.number().min(imageClipStartSMin).max(imageClipStartSMax),
  "stroke": zod.union([Stroke,zod.null()]).exactOptional(),
  "track_id": zod.string().regex(imageClipTrackIdRegExp)
}).describe('A still, shown for the clip\'s length: a file, or one of the team\'s actors\' portraits\n(live\'s media panel\'s Avatar, #244 part 3).');

export type ImageClip = zod.input<typeof ImageClip>;
export type ImageClipOutput = zod.output<typeof ImageClip>;

export const TextPosition = zod.enum(['top', 'center', 'bottom']);

export type TextPosition = zod.input<typeof TextPosition>;
export type TextPositionOutput = zod.output<typeof TextPosition>;

export const textStyleAlignDefault = 'center';
export const textStyleCaseDefault = 'as_typed';
export const textStyleColorOneRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const textStyleColorDefault = `#FFFFFF`;
export const textStyleFontDefault = 'Roboto';
export const textStyleItalicDefault = false;
export const textStyleOpacityDefault = 1;
export const textStyleOpacityMin = 0;
export const textStyleOpacityMax = 1;

export const textStyleOverlineDefault = false;
export const textStyleRotationDefault = 0;
export const textStyleRotationMin = -360;
export const textStyleRotationMax = 360;

export const textStyleSizeDefault = 48;
export const textStyleSizeMin = 8;
export const textStyleSizeMax = 1000;

export const textStyleStrikethroughDefault = false;
export const textStyleUnderlineDefault = false;
export const textStyleWeightDefault = 700;
export const textStyleWeightMin = 100;
export const textStyleWeightMax = 900;
export const textStyleWeightMultipleOf = 100;

export const textStyleWidthExclusiveMin = 0;
export const textStyleWidthMax = 10000;

export const textStyleXMin = -10000;
export const textStyleXMax = 10000;

export const textStyleYMin = -10000;
export const textStyleYMax = 10000;



export const TextStyle = zod.object({
  "align": TextAlign.default(textStyleAlignDefault),
  "background": zod.union([TextBackground,zod.null()]).exactOptional(),
  "case": TextCase.default(textStyleCaseDefault),
  "color": zod.union([zod.string().regex(textStyleColorOneRegExp),zod.null()]).default(textStyleColorDefault),
  "font": FontFamily.default(textStyleFontDefault),
  "italic": zod.boolean().default(textStyleItalicDefault),
  "opacity": zod.number().min(textStyleOpacityMin).max(textStyleOpacityMax).default(textStyleOpacityDefault),
  "overline": zod.boolean().default(textStyleOverlineDefault),
  "rotation": zod.number().min(textStyleRotationMin).max(textStyleRotationMax).default(textStyleRotationDefault),
  "shadow": zod.union([Shadow,zod.null()]).exactOptional(),
  "size": zod.int().min(textStyleSizeMin).max(textStyleSizeMax).default(textStyleSizeDefault),
  "strikethrough": zod.boolean().default(textStyleStrikethroughDefault),
  "stroke": zod.union([Stroke,zod.null()]).exactOptional(),
  "underline": zod.boolean().default(textStyleUnderlineDefault),
  "weight": zod.int().min(textStyleWeightMin).max(textStyleWeightMax).multipleOf(textStyleWeightMultipleOf).default(textStyleWeightDefault),
  "width": zod.number().gt(textStyleWidthExclusiveMin).max(textStyleWidthMax),
  "x": zod.number().min(textStyleXMin).max(textStyleXMax),
  "y": zod.number().min(textStyleYMin).max(textStyleYMax)
}).describe('A text as live\'s Parameters set it (#241 part 2). Its box\'s top left (`x`, `y`) and\n`width` are live\'s pixels on live\'s frame (as `Box`\'s); its height is the text\'s own,\nlaid out in its face at `size`, wrapped within the width less the background\'s padding (live\'s\n8 and 4 when it has none). It turns about its box\'s centre; its opacity fades all of it. A\nnull `color` is live\'s "minus": the letters clear, their stroke and shadow still drawn.');

export type TextStyle = zod.input<typeof TextStyle>;
export type TextStyleOutput = zod.output<typeof TextStyle>;

export const textClipAnimationsDefault = [];
export const textClipAnimationsMax = 20;

export const textClipEndSMin = 0;
export const textClipEndSMax = 300;

export const textClipHiddenDefault = false;
export const textClipIdRegExp = new RegExp('^[A-Za-z0-9_-]{1,64}$');
export const textClipLockedDefault = false;
export const textClipPositionDefault = 'bottom';
export const textClipStartSMin = 0;
export const textClipStartSMax = 300;

export const textClipTextMax = 200;


export const textClipTextRegExp = new RegExp('[^\\t\\n\\v\\f\\r \\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000\\ufeff]');
export const textClipTrackIdRegExp = new RegExp('^[A-Za-z0-9_-]{1,64}$');


export const TextClip = zod.object({
  "animations": zod.array(ClipAnimation).max(textClipAnimationsMax).default(textClipAnimationsDefault),
  "end_s": zod.number().min(textClipEndSMin).max(textClipEndSMax),
  "hidden": zod.boolean().default(textClipHiddenDefault),
  "id": zod.string().regex(textClipIdRegExp),
  "kind": zod.enum(['text']),
  "locked": zod.boolean().default(textClipLockedDefault),
  "position": TextPosition.default(textClipPositionDefault),
  "start_s": zod.number().min(textClipStartSMin).max(textClipStartSMax),
  "style": zod.union([TextStyle,zod.null()]).exactOptional(),
  "text": zod.string().min(1).max(textClipTextMax).regex(textClipTextRegExp),
  "track_id": zod.string().regex(textClipTrackIdRegExp)
}).describe('A text over the video: live\'s, as its `style` sets it, or, with none (a title made before\n#241 part 2), E1\'s caption at `position`, bold white on a dark box across the frame.');

export type TextClip = zod.input<typeof TextClip>;
export type TextClipOutput = zod.output<typeof TextClip>;

export const effectClipEndSMin = 0;
export const effectClipEndSMax = 300;

export const effectClipHiddenDefault = false;
export const effectClipIdRegExp = new RegExp('^[A-Za-z0-9_-]{1,64}$');
export const effectClipLockedDefault = false;
export const effectClipStartSMin = 0;
export const effectClipStartSMax = 300;

export const effectClipTrackIdRegExp = new RegExp('^[A-Za-z0-9_-]{1,64}$');
export const effectClipValuesDefault = {};

export const EffectClip = zod.object({
  "effect": EffectKind,
  "end_s": zod.number().min(effectClipEndSMin).max(effectClipEndSMax),
  "hidden": zod.boolean().default(effectClipHiddenDefault),
  "id": zod.string().regex(effectClipIdRegExp),
  "kind": zod.enum(['effect']),
  "locked": zod.boolean().default(effectClipLockedDefault),
  "start_s": zod.number().min(effectClipStartSMin).max(effectClipStartSMax),
  "track_id": zod.string().regex(effectClipTrackIdRegExp),
  "values": zod.looseObject({

}).default(effectClipValuesDefault)
}).describe('Live\'s effect (#265): `effect` over every picture and text of the tracks below its own,\nfrom `start_s` to `end_s`, as an adjustment layer; its shader\'s time runs 0 to 1 over the\nclip. Hidden, it is not applied. The server\'s ffmpeg render draws no effect. `values` are\nlive\'s Configuration edits of a Pixi filter (part 2), by its parameter\'s name, over the\nfilter\'s defaults; the editor keeps each to its control\'s range.');

export type EffectClip = zod.input<typeof EffectClip>;
export type EffectClipOutput = zod.output<typeof EffectClip>;

export const TimelineClip = zod.union([VideoClip,ImageClip,AudioClip,TextClip,EffectClip,CaptionClip]);

export type TimelineClip = zod.input<typeof TimelineClip>;
export type TimelineClipOutput = zod.output<typeof TimelineClip>;

export const markerAtSMin = 0;
export const markerAtSMax = 300;

export const markerColorRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const markerIdRegExp = new RegExp('^[A-Za-z0-9_-]{1,64}$');
export const markerLabelMax = 100;


export const markerLabelRegExp = new RegExp('[^\\t\\n\\v\\f\\r \\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000\\ufeff]');


export const Marker = zod.object({
  "at_s": zod.number().min(markerAtSMin).max(markerAtSMax),
  "color": zod.string().regex(markerColorRegExp),
  "id": zod.string().regex(markerIdRegExp),
  "label": zod.string().min(1).max(markerLabelMax).regex(markerLabelRegExp)
}).describe('A note pinned to a moment of the video (spec markers): live\'s MCP marker, a time, a label\nand a colour, saved with the project.');

export type Marker = zod.input<typeof Marker>;
export type MarkerOutput = zod.output<typeof Marker>;

export const TrackKind = zod.enum(['video', 'audio', 'text', 'effect', 'caption']);

export type TrackKind = zod.input<typeof TrackKind>;
export type TrackKindOutput = zod.output<typeof TrackKind>;

export const trackIdRegExp = new RegExp('^[A-Za-z0-9_-]{1,64}$');
export const trackMagnetDefault = false;
export const trackMutedDefault = false;

export const Track = zod.object({
  "id": zod.string().regex(trackIdRegExp),
  "kind": TrackKind,
  "magnet": zod.boolean().default(trackMagnetDefault),
  "muted": zod.boolean().default(trackMutedDefault)
});

export type Track = zod.input<typeof Track>;
export type TrackOutput = zod.output<typeof Track>;

export const transitionDurationSMin = 0.1;
export const transitionDurationSMax = 300;

export const transitionFromClipIdRegExp = new RegExp('^[A-Za-z0-9_-]{1,64}$');
export const transitionIdRegExp = new RegExp('^[A-Za-z0-9_-]{1,64}$');
export const transitionToClipIdRegExp = new RegExp('^[A-Za-z0-9_-]{1,64}$');


export const Transition = zod.object({
  "duration_s": zod.number().min(transitionDurationSMin).max(transitionDurationSMax),
  "from_clip_id": zod.string().regex(transitionFromClipIdRegExp),
  "id": zod.string().regex(transitionIdRegExp),
  "kind": TransitionKind,
  "to_clip_id": zod.string().regex(transitionToClipIdRegExp)
}).describe('Live\'s transition (#240): `kind` over the cut where the picture `from_clip_id` ends and\n`to_clip_id`, the next clip of its video track, starts (at most 0.1 s later), lasting\n`duration_s` centred on the cut, never longer than either picture. Inside it, the first\npicture holds its last frame past its end and the second its first frame before its start.');

export type Transition = zod.input<typeof Transition>;
export type TransitionOutput = zod.output<typeof Transition>;

export const editChangeRemovedClipsItemRegExp = new RegExp('^[A-Za-z0-9_-]{1,64}$');
export const editChangeRemovedMarkersItemRegExp = new RegExp('^[A-Za-z0-9_-]{1,64}$');
export const editChangeRemovedTransitionsItemRegExp = new RegExp('^[A-Za-z0-9_-]{1,64}$');


export const EditChange = zod.object({
  "aspect": zod.union([EditAspect,zod.null()]),
  "captions": zod.union([EditCaptionsChange,zod.null()]),
  "clips": zod.array(TimelineClip),
  "markers": zod.array(Marker),
  "name": zod.union([zod.string(),zod.null()]),
  "removed_clips": zod.array(zod.string().regex(editChangeRemovedClipsItemRegExp)),
  "removed_markers": zod.array(zod.string().regex(editChangeRemovedMarkersItemRegExp)),
  "removed_transitions": zod.array(zod.string().regex(editChangeRemovedTransitionsItemRegExp)),
  "tracks": zod.union([zod.array(Track),zod.null()]),
  "transitions": zod.array(Transition),
  "version": zod.int()
}).describe('What one save of a project changed against the version before it (spec live-sync.md), in\nthe timeline\'s own words: clips, transitions and markers by id, each added or changed one\nwhole and the ids of those removed; the tracks, the captions\' look, the name and the frame\nwhole, each null when the save left it as it was. A save that changed nothing has an empty\nchange, so every version has one.');

export type EditChange = zod.input<typeof EditChange>;
export type EditChangeOutput = zod.output<typeof EditChange>;

export const timelineClipsMax = 1140;

export const timelineMarkersDefault = [];
export const timelineMarkersMax = 100;

export const timelineTracksMax = 20;

export const timelineTransitionsDefault = [];
export const timelineTransitionsMax = 50;



export const Timeline = zod.object({
  "captions": zod.union([CaptionSettings,zod.null()]).exactOptional(),
  "clips": zod.array(TimelineClip).max(timelineClipsMax),
  "markers": zod.array(Marker).max(timelineMarkersMax).default(timelineMarkersDefault),
  "tracks": zod.array(Track).max(timelineTracksMax),
  "transitions": zod.array(Transition).max(timelineTransitionsMax).default(timelineTransitionsDefault),
  "version": zod.literal(2).meta({ title: 'Version' })
}).describe('Version 2: tracks, top to bottom, the clips placed on them, and the transitions on their\ncuts (none in a timeline saved before #240).');

export type Timeline = zod.input<typeof Timeline>;
export type TimelineOutput = zod.output<typeof Timeline>;

export const EditProject = zod.object({
  "aspect": EditAspect,
  "brand_id": zod.uuid(),
  "created_at": zod.iso.datetime({"offset":true}),
  "created_by": zod.uuid(),
  "duration_s": zod.number(),
  "id": zod.uuid(),
  "name": zod.string(),
  "timeline": Timeline,
  "updated_at": zod.iso.datetime({"offset":true}),
  "version": zod.int()
});

export type EditProject = zod.input<typeof EditProject>;
export type EditProjectOutput = zod.output<typeof EditProject>;

export const EditProjectChanges = zod.object({
  "changes": zod.array(EditChange),
  "complete": zod.boolean(),
  "version": zod.int()
}).describe('`GET .../edit-projects/{project_id}/changes?after=`: what the saves after `after` changed,\noldest first, up to `version`, the project\'s version now (spec live-sync.md). `complete` is\nfalse, with no changes, when the log cannot give them all: read the project whole instead.');

export type EditProjectChanges = zod.input<typeof EditProjectChanges>;
export type EditProjectChangesOutput = zod.output<typeof EditProjectChanges>;

export const editProjectCreateNameMax = 100;


export const editProjectCreateNameRegExp = new RegExp('[^\\t\\n\\v\\f\\r \\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000\\ufeff]');


export const EditProjectCreate = zod.object({
  "aspect": EditAspect,
  "name": zod.string().min(1).max(editProjectCreateNameMax).regex(editProjectCreateNameRegExp),
  "timeline": Timeline.exactOptional()
}).describe('`POST .../edit-projects`: a new project, its main track empty unless a timeline is\ngiven.');

export type EditProjectCreate = zod.input<typeof EditProjectCreate>;
export type EditProjectCreateOutput = zod.output<typeof EditProjectCreate>;

export const editProjectFromAssetNameMax = 100;


export const editProjectFromAssetNameRegExp = new RegExp('[^\\t\\n\\v\\f\\r \\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000\\ufeff]');


export const EditProjectFromAsset = zod.object({
  "aspect": EditAspect,
  "asset_id": zod.uuid(),
  "name": zod.string().min(1).max(editProjectFromAssetNameMax).regex(editProjectFromAssetNameRegExp),
  "timeline": Timeline
}).describe('`POST .../edit-projects/from-asset` (#668, spec S1c): live\'s Open in the editor of a\nlibrary video. The brand\'s project made from the file when there is one (200, the body\nunused), else a new one from this body (201): the file always reopens its own project, as\nlive keeps one space per file.');

export type EditProjectFromAsset = zod.input<typeof EditProjectFromAsset>;
export type EditProjectFromAssetOutput = zod.output<typeof EditProjectFromAsset>;

export const EditSourceKind = zod.enum(['video', 'image', 'audio']);

export type EditSourceKind = zod.input<typeof EditSourceKind>;
export type EditSourceKindOutput = zod.output<typeof EditSourceKind>;

export const EditSourceReady = zod.object({
  "duration_ms": zod.union([zod.int(),zod.null()]),
  "height": zod.union([zod.int(),zod.null()]),
  "kind": EditSourceKind,
  "name": zod.string(),
  "poster": zod.union([zod.string(),zod.null()]),
  "proxy": zod.union([zod.string(),zod.null()]),
  "proxy_status": zod.union([ProxyStatus,zod.null()]),
  "source": ActorSource,
  "status": zod.enum(['ready']),
  "url": zod.string(),
  "width": zod.union([zod.int(),zod.null()])
}).describe('A project\'s source that plays (spec docs/specs/editor/project-media.md), as the editor\nplays and shows it: what its own read gives (the library file, the job\'s output, the actor),\nresolved under the reader\'s scope by a render\'s rules.');

export type EditSourceReady = zod.input<typeof EditSourceReady>;
export type EditSourceReadyOutput = zod.output<typeof EditSourceReady>;

export const EditSourceGone = zod.object({
  "source": ActorSource,
  "status": zod.enum(['gone'])
}).describe('A project\'s source that no longer plays, as a render refuses it: a file in the trash, not\nready, purged or of another team; a job deleted, failed, of another brand or not a\ngeneration; an output not delivered; an actor deleted or not the team\'s.');

export type EditSourceGone = zod.input<typeof EditSourceGone>;
export type EditSourceGoneOutput = zod.output<typeof EditSourceGone>;

export const EditSourceMedia = zod.union([EditSourceReady,EditSourceGone]);

export type EditSourceMedia = zod.input<typeof EditSourceMedia>;
export type EditSourceMediaOutput = zod.output<typeof EditSourceMedia>;

export const EditProjectMedia = zod.object({
  "sources": zod.array(EditSourceMedia),
  "urls_expire_at": zod.union([zod.iso.datetime({"offset":true}),zod.null()])
}).describe('`GET .../edit-projects/{project_id}/media`: every distinct source of the saved timeline\nonce, in the order its clips first name it, so the editor opens with one read.');

export type EditProjectMedia = zod.input<typeof EditProjectMedia>;
export type EditProjectMediaOutput = zod.output<typeof EditProjectMedia>;

export const EditProjectSummary = zod.object({
  "aspect": EditAspect,
  "clip_count": zod.int(),
  "created_by": zod.uuid(),
  "duration_s": zod.number(),
  "id": zod.uuid(),
  "name": zod.string(),
  "poster": zod.union([zod.string(),zod.null()]),
  "updated_at": zod.iso.datetime({"offset":true}),
  "video": zod.union([zod.string(),zod.null()])
}).describe('A project as the Video Editor\'s list shows it (spec docs/specs/editor/project-list-pages.md):\nno timeline, so a page does not grow with the projects in it.');

export type EditProjectSummary = zod.input<typeof EditProjectSummary>;
export type EditProjectSummaryOutput = zod.output<typeof EditProjectSummary>;

export const EditProjectPage = zod.object({
  "items": zod.array(EditProjectSummary),
  "next": zod.union([zod.string(),zod.null()]),
  "urls_expire_at": zod.union([zod.iso.datetime({"offset":true}),zod.null()])
}).describe('`GET .../edit-projects`: the brand\'s projects, newest change first; `next` is the cursor of\nthe following page.');

export type EditProjectPage = zod.input<typeof EditProjectPage>;
export type EditProjectPageOutput = zod.output<typeof EditProjectPage>;

export const editProjectSavedFrameVersionMin = 2;



export const EditProjectSavedFrame = zod.object({
  "brand_id": zod.uuid(),
  "project_id": zod.uuid(),
  "version": zod.int().min(editProjectSavedFrameVersionMin)
}).describe('The `data:` of an `edit_project.saved` frame (spec editor/live-sync-stream.md): a\n`platform.stream_event` row, whose id is the frame\'s `id:`. The project, its brand and the\nversion the save made; what it changed comes from the editor\'s own route, which checks its\nreader, so no clip\'s text or file reaches the channel.');

export type EditProjectSavedFrame = zod.input<typeof EditProjectSavedFrame>;
export type EditProjectSavedFrameOutput = zod.output<typeof EditProjectSavedFrame>;

export const editProjectUpdateNameMax = 100;


export const editProjectUpdateNameRegExp = new RegExp('[^\\t\\n\\v\\f\\r \\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000\\ufeff]');
export const editProjectUpdateVersionMax = 9007199254740991;



export const EditProjectUpdate = zod.object({
  "aspect": EditAspect,
  "name": zod.string().min(1).max(editProjectUpdateNameMax).regex(editProjectUpdateNameRegExp),
  "timeline": Timeline,
  "version": zod.int().min(1).max(editProjectUpdateVersionMax)
}).describe('`PUT .../edit-projects/{project_id}`: the whole project, replaced. `version` is the one\nthe client loaded; another is 409 `VERSION_CONFLICT`.');

export type EditProjectUpdate = zod.input<typeof EditProjectUpdate>;
export type EditProjectUpdateOutput = zod.output<typeof EditProjectUpdate>;

export const EditRenderMaker = zod.enum(['browser', 'server']).describe('Where a render\'s file is made (spec editor/fast-save): in the browser that pressed Save,\nwhich posts it, or on the server (the Save worker, or ffmpeg locally).');

export type EditRenderMaker = zod.input<typeof EditRenderMaker>;
export type EditRenderMakerOutput = zod.output<typeof EditRenderMaker>;

export const editRenderProgressOneMin = 0;
export const editRenderProgressOneMax = 1;



export const EditRender = zod.object({
  "asset_id": zod.union([zod.uuid(),zod.null()]),
  "created_at": zod.iso.datetime({"offset":true}),
  "error": zod.union([JobError,zod.null()]),
  "finished_at": zod.union([zod.iso.datetime({"offset":true}),zod.null()]),
  "job_id": zod.uuid(),
  "made_in": EditRenderMaker,
  "progress": zod.union([zod.number().min(editRenderProgressOneMin).max(editRenderProgressOneMax),zod.null()]),
  "project_id": zod.uuid(),
  "project_version": zod.int(),
  "status": JobStatus,
  "url": zod.union([zod.string(),zod.null()]),
  "urls_expire_at": zod.union([zod.iso.datetime({"offset":true}),zod.null()])
}).describe('One render of a project. Its status arrives as the job\'s events (`job_id`); refetch\nthis then.');

export type EditRender = zod.input<typeof EditRender>;
export type EditRenderOutput = zod.output<typeof EditRender>;

export const EditRenderFile = zod.object({
  "form": UploadForm
}).describe('Where the browser posts the render\'s file: assets\' upload form, a policy for the\nrender\'s own object, of `video/mp4` and exactly the size named, for 15 minutes.');

export type EditRenderFile = zod.input<typeof EditRenderFile>;
export type EditRenderFileOutput = zod.output<typeof EditRenderFile>;

export const editRenderFileRequestBytesMax = 4294967296;



export const EditRenderFileRequest = zod.object({
  "bytes": zod.int().min(1).max(editRenderFileRequestBytesMax)
}).describe('`POST .../renders/{job_id}/file`: the file the browser made for a render made in it, by\nits exact size (spec editor/fast-save).');

export type EditRenderFileRequest = zod.input<typeof EditRenderFileRequest>;
export type EditRenderFileRequestOutput = zod.output<typeof EditRenderFileRequest>;

export const EditRenderPurpose = zod.enum(['save', 'download']).describe('What a render was started for: Save, or Download when the browser could not make the file\nitself. It changes nothing of the render; `video_exported` keeps it (spec\nplatform/journey.md, 2.7).');

export type EditRenderPurpose = zod.input<typeof EditRenderPurpose>;
export type EditRenderPurposeOutput = zod.output<typeof EditRenderPurpose>;

export const editRenderRequestMadeInDefault = 'server';
export const editRenderRequestPurposeDefault = 'save';
export const editRenderRequestVersionMax = 9007199254740991;



export const EditRenderRequest = zod.object({
  "folder_id": zod.union([zod.uuid(),zod.null()]).exactOptional(),
  "made_in": EditRenderMaker.default(editRenderRequestMadeInDefault),
  "purpose": EditRenderPurpose.default(editRenderRequestPurposeDefault),
  "version": zod.int().min(1).max(editRenderRequestVersionMax)
}).describe('`POST .../edit-projects/{project_id}/renders`: render this saved version, and keep the\nvideo in the brand\'s library, in `folder_id` when one is named (live\'s Save to project; a\nfolder of the brand, else 422). `made_in` asks for the file to be made in the browser that\nsends this; the answer\'s `made_in` says where it is made (spec editor/fast-save). `purpose`\nsays which button started it.');

export type EditRenderRequest = zod.input<typeof EditRenderRequest>;
export type EditRenderRequestOutput = zod.output<typeof EditRenderRequest>;

export const elementImagesOneMax = 16;



export const Element = zod.object({
  "frontal": zod.union([SourceRef,zod.null()]).exactOptional(),
  "images": zod.union([zod.array(TemplateSource).max(elementImagesOneMax),zod.null()]).exactOptional(),
  "video": zod.union([SourceRef,zod.null()]).exactOptional()
}).describe('Live\'s element: a frontal image, more images of it from other angles, and a video; which\nparts a model needs is its block\'s `elements` (spec G6-studio-api, section 4).');

export type Element = zod.input<typeof Element>;
export type ElementOutput = zod.output<typeof Element>;

export const emailCodeRequestEmailMin = 3;
export const emailCodeRequestEmailMax = 320;


export const emailCodeRequestEmailRegExp = new RegExp('^[a-zA-Z0-9.!#$%&\'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?)+$');


export const EmailCodeRequest = zod.object({
  "email": zod.string().min(emailCodeRequestEmailMin).max(emailCodeRequestEmailMax).regex(emailCodeRequestEmailRegExp)
});

export type EmailCodeRequest = zod.input<typeof EmailCodeRequest>;
export type EmailCodeRequestOutput = zod.output<typeof EmailCodeRequest>;

export const emailCodeVerifyCodeRegExp = new RegExp('^[0-9]{6}$');
export const emailCodeVerifyEmailMin = 3;
export const emailCodeVerifyEmailMax = 320;


export const emailCodeVerifyEmailRegExp = new RegExp('^[a-zA-Z0-9.!#$%&\'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?)+$');


export const EmailCodeVerify = zod.object({
  "code": zod.string().regex(emailCodeVerifyCodeRegExp),
  "email": zod.string().min(emailCodeVerifyEmailMin).max(emailCodeVerifyEmailMax).regex(emailCodeVerifyEmailRegExp),
  "time_zone": zod.union([zod.string(),zod.null()]).exactOptional()
}).describe('The code from the email. `time_zone`: the browser\'s IANA time zone, kept on the user when\nit names one and otherwise dropped, never refused.');

export type EmailCodeVerify = zod.input<typeof EmailCodeVerify>;
export type EmailCodeVerifyOutput = zod.output<typeof EmailCodeVerify>;

export const endCardCtaButtonMax = 200;

export const endCardHeadlineMax = 2000;



export const EndCard = zod.object({
  "cta_button": zod.string().max(endCardCtaButtonMax),
  "headline": zod.string().max(endCardHeadlineMax)
}).describe('The designed card the ad ends on: its headline and its button.');

export type EndCard = zod.input<typeof EndCard>;
export type EndCardOutput = zod.output<typeof EndCard>;

export const EntryKind = zod.enum(['grant', 'purchase', 'hold', 'capture', 'release', 'expire', 'adjust', 'refund', 'revoke', 'dispute']).describe('What a ledger entry did to `available` (proposal 6.7, "a ledger of available").');

export type EntryKind = zod.input<typeof EntryKind>;
export type EntryKindOutput = zod.output<typeof EntryKind>;

export const ErrorCode = zod.enum(['VALIDATION_FAILED', 'UNAUTHENTICATED', 'FORBIDDEN', 'NOT_FOUND', 'METHOD_NOT_ALLOWED', 'RATE_LIMITED', 'INTERNAL', 'NOT_INVITED', 'CODE_INVALID', 'EMAIL_NOT_VERIFIED', 'GOOGLE_SIGN_IN_FAILED', 'SIGN_IN_UNAVAILABLE', 'UNPRICED', 'INSUFFICIENT_CREDITS', 'IDEMPOTENCY_CONFLICT', 'TASK_NOT_READY', 'TASK_REJECTED', 'PERMISSION_DENIED', 'OWNERSHIP_LOCKED', 'TEAM_CREATION_CLOSED', 'TEAM_LIMIT_REACHED', 'ALREADY_MEMBER', 'INVITATION_PENDING', 'BRAND_NAME_TAKEN', 'BRAND_LIMIT_REACHED', 'PRODUCT_NAME_TAKEN', 'PRODUCT_LIMIT_REACHED', 'FOLDER_NAME_TAKEN', 'FOLDER_LIMIT_REACHED', 'STORAGE_LIMIT', 'ASSET_NAME_TAKEN', 'UPLOAD_NOT_RECEIVED', 'UPLOAD_MISMATCH', 'ASSET_NOT_SAVABLE', 'ASSET_IN_USE', 'QUOTE_CHANGED', 'JOB_ACTIVE', 'PROMPT_TEMPLATE_EXISTS', 'TEMPLATE_DRAFT_LOCKED', 'STREAM_UNAVAILABLE', 'SEARCH_UNAVAILABLE', 'STRIPE_UNAVAILABLE', 'SUBSCRIPTION_EXISTS', 'CHECKOUT_PROCESSING', 'SUBSCRIPTION_MISSING', 'SUBSCRIPTION_REQUIRED', 'EMAIL_UNAVAILABLE', 'TEAM_DELETED', 'JOB_FINALIZING', 'JOB_TERMINAL', 'USER_OWNS_TEAMS', 'USER_IS_STAFF', 'TERMS_VERSION_STALE', 'VERSION_CONFLICT', 'CAPTION_PRESET_LIMIT_REACHED', 'THEME_LOCKED', 'CASES_HIDDEN', 'ALL_THEMES_OWNED']);

export type ErrorCode = zod.input<typeof ErrorCode>;
export type ErrorCodeOutput = zod.output<typeof ErrorCode>;

export const ErrorBody = zod.object({
  "code": ErrorCode,
  "details": zod.record(zod.string(), zod.unknown()),
  "message": zod.string(),
  "request_id": zod.string()
});

export type ErrorBody = zod.input<typeof ErrorBody>;
export type ErrorBodyOutput = zod.output<typeof ErrorBody>;

export const ErrorEnvelope = zod.object({
  "error": ErrorBody
}).describe('Every error response of every route (proposal 3.2).');

export type ErrorEnvelope = zod.input<typeof ErrorEnvelope>;
export type ErrorEnvelopeOutput = zod.output<typeof ErrorEnvelope>;

export const extractBrandQuoteExpectedQuoteMaxOneMin = 0;

export const extractBrandQuoteOutputsDefault = 1;
export const extractBrandQuoteOutputsMax = 1;

export const extractBrandQuoteUrlMax = 2048;



export const ExtractBrandQuote = zod.object({
  "expected_quote_max": zod.union([zod.int().min(extractBrandQuoteExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "outputs": zod.int().min(1).max(extractBrandQuoteOutputsMax).default(extractBrandQuoteOutputsDefault),
  "type": zod.enum(['extract.brand']),
  "url": zod.string().min(1).max(extractBrandQuoteUrlMax)
}).describe('An `ExtractBrandRequest` to price: the same body, since it has no prompt.');

export type ExtractBrandQuote = zod.input<typeof ExtractBrandQuote>;
export type ExtractBrandQuoteOutput = zod.output<typeof ExtractBrandQuote>;

export const extractBrandRequestExpectedQuoteMaxOneMin = 0;

export const extractBrandRequestOutputsDefault = 1;
export const extractBrandRequestOutputsMax = 1;

export const extractBrandRequestUrlMax = 2048;



export const ExtractBrandRequest = zod.object({
  "expected_quote_max": zod.union([zod.int().min(extractBrandRequestExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "outputs": zod.int().min(1).max(extractBrandRequestOutputsMax).default(extractBrandRequestOutputsDefault),
  "type": zod.enum(['extract.brand']),
  "url": zod.string().min(1).max(extractBrandRequestUrlMax)
}).describe('A brand read from its website (#249, live\'s `POST /brand/extract`): the URL as the user typed\nit (live adds `https://` where it has no scheme). No model: the AI task `extract.brand` picks\nthe row (spec G9-ai-tasks).');

export type ExtractBrandRequest = zod.input<typeof ExtractBrandRequest>;
export type ExtractBrandRequestOutput = zod.output<typeof ExtractBrandRequest>;

export const extractProductQuoteExpectedQuoteMaxOneMin = 0;

export const extractProductQuoteOutputsDefault = 1;
export const extractProductQuoteOutputsMax = 1;

export const extractProductQuoteUrlMax = 2048;



export const ExtractProductQuote = zod.object({
  "expected_quote_max": zod.union([zod.int().min(extractProductQuoteExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "outputs": zod.int().min(1).max(extractProductQuoteOutputsMax).default(extractProductQuoteOutputsDefault),
  "type": zod.enum(['extract.product']),
  "url": zod.string().min(1).max(extractProductQuoteUrlMax)
}).describe('An `ExtractProductRequest` to price: the same body, since it has no prompt.');

export type ExtractProductQuote = zod.input<typeof ExtractProductQuote>;
export type ExtractProductQuoteOutput = zod.output<typeof ExtractProductQuote>;

export const extractProductRequestExpectedQuoteMaxOneMin = 0;

export const extractProductRequestOutputsDefault = 1;
export const extractProductRequestOutputsMax = 1;

export const extractProductRequestUrlMax = 2048;



export const ExtractProductRequest = zod.object({
  "expected_quote_max": zod.union([zod.int().min(extractProductRequestExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "outputs": zod.int().min(1).max(extractProductRequestOutputsMax).default(extractProductRequestOutputsDefault),
  "type": zod.enum(['extract.product']),
  "url": zod.string().min(1).max(extractProductRequestUrlMax)
}).describe('A product read from its Shopify page (#249, live\'s `POST /product/extract`): the URL as the\nuser typed it (live adds `https://` where it has no scheme). No model: the AI task\n`extract.product` picks the row (spec G9-ai-tasks).');

export type ExtractProductRequest = zod.input<typeof ExtractProductRequest>;
export type ExtractProductRequestOutput = zod.output<typeof ExtractProductRequest>;

export const Features = zod.object({
  "semantic_search": zod.boolean()
}).describe('`GET /v1/features`: which of the deployment\'s optional features are on, so the web shows\nonly those (`settings.flags`, set per environment). One named field per flag the web may see;\nnothing lists the flags wholesale, so a new flag stays private until a field names it.');

export type Features = zod.input<typeof Features>;
export type FeaturesOutput = zod.output<typeof Features>;

export const FieldError = zod.object({
  "loc": zod.array(zod.union([zod.string(),zod.int()])),
  "message": zod.string(),
  "type": zod.string()
});

export type FieldError = zod.input<typeof FieldError>;
export type FieldErrorOutput = zod.output<typeof FieldError>;

export const flatCartoonPickedInputsBrandDefault = ``;
export const flatCartoonPickedInputsBrandMax = 100;

export const flatCartoonPickedInputsProblemDefault = ``;
export const flatCartoonPickedInputsProblemMax = 200;

export const flatCartoonPickedInputsProductCategoryDefault = ``;
export const flatCartoonPickedInputsProductCategoryMax = 200;

export const flatCartoonPickedInputsProductNameDefault = ``;
export const flatCartoonPickedInputsProductNameMax = 200;

export const flatCartoonPickedInputsProductTextDefault = ``;
export const flatCartoonPickedInputsProductTextMax = 20000;

export const flatCartoonPickedInputsResolutionDefault = `1080p`;
export const flatCartoonPickedInputsSubtitlesDefault = true;
export const flatCartoonPickedInputsUrlDefault = ``;
export const flatCartoonPickedInputsUrlMax = 100;



export const FlatCartoonPickedInputs = zod.object({
  "brand": zod.string().max(flatCartoonPickedInputsBrandMax).default(flatCartoonPickedInputsBrandDefault),
  "problem": zod.string().max(flatCartoonPickedInputsProblemMax).default(flatCartoonPickedInputsProblemDefault),
  "product": PackshotProduct,
  "product_category": zod.string().max(flatCartoonPickedInputsProductCategoryMax).default(flatCartoonPickedInputsProductCategoryDefault),
  "product_name": zod.string().max(flatCartoonPickedInputsProductNameMax).default(flatCartoonPickedInputsProductNameDefault),
  "product_text": zod.string().max(flatCartoonPickedInputsProductTextMax).default(flatCartoonPickedInputsProductTextDefault),
  "resolution": zod.enum(['1080p', '720p']).default(flatCartoonPickedInputsResolutionDefault),
  "subtitles": zod.boolean().default(flatCartoonPickedInputsSubtitlesDefault),
  "url": zod.string().max(flatCartoonPickedInputsUrlMax).default(flatCartoonPickedInputsUrlDefault)
}).describe('The form with its product picked, as Generate script and Approve script need it (422 at\n`product`).');

export type FlatCartoonPickedInputs = zod.input<typeof FlatCartoonPickedInputs>;
export type FlatCartoonPickedInputsOutput = zod.output<typeof FlatCartoonPickedInputs>;

export const FlatCartoonSpeaker = zod.enum(['HOST', 'CALLER', 'NARRATOR']);

export type FlatCartoonSpeaker = zod.input<typeof FlatCartoonSpeaker>;
export type FlatCartoonSpeakerOutput = zod.output<typeof FlatCartoonSpeaker>;

export const flatCartoonLineTextMax = 2000;



export const FlatCartoonLine = zod.object({
  "speaker": FlatCartoonSpeaker,
  "text": zod.string().max(flatCartoonLineTextMax)
}).describe('One line, one clip: who says it and its words as written.');

export type FlatCartoonLine = zod.input<typeof FlatCartoonLine>;
export type FlatCartoonLineOutput = zod.output<typeof FlatCartoonLine>;

export const flatCartoonScriptAccentColorsMax = 200;

export const flatCartoonScriptBenefitNumberMax = 200;

export const flatCartoonScriptCallerFeaturesMax = 200;

export const flatCartoonScriptCallerLockMax = 2000;

export const flatCartoonScriptCallerNameMax = 200;

export const flatCartoonScriptCallerRecapMax = 2000;

export const flatCartoonScriptCarPropsMax = 2000;

export const flatCartoonScriptHostFeaturesMax = 200;

export const flatCartoonScriptHostLockMax = 2000;

export const flatCartoonScriptHostRecapMax = 2000;

export const flatCartoonScriptLinesMax = 60;

export const flatCartoonScriptMetaphorActionMax = 2000;

export const flatCartoonScriptPackWordMax = 200;

export const flatCartoonScriptProblemMetaphorMax = 2000;

export const flatCartoonScriptProductDescriptionMax = 8000;

export const flatCartoonScriptProductShortMax = 200;

export const flatCartoonScriptPronunciationsMax = 60;

export const flatCartoonScriptRunnerFeaturesMax = 200;

export const flatCartoonScriptRunnerLockMax = 2000;

export const flatCartoonScriptRunnerRecapMax = 2000;

export const flatCartoonScriptTaglineMax = 200;



export const FlatCartoonScript = zod.object({
  "accent_colors": zod.string().max(flatCartoonScriptAccentColorsMax),
  "benefit_number": zod.string().max(flatCartoonScriptBenefitNumberMax),
  "caller_features": zod.string().max(flatCartoonScriptCallerFeaturesMax),
  "caller_lock": zod.string().max(flatCartoonScriptCallerLockMax),
  "caller_name": zod.string().max(flatCartoonScriptCallerNameMax),
  "caller_recap": zod.string().max(flatCartoonScriptCallerRecapMax),
  "car_props": zod.string().max(flatCartoonScriptCarPropsMax),
  "host_features": zod.string().max(flatCartoonScriptHostFeaturesMax),
  "host_lock": zod.string().max(flatCartoonScriptHostLockMax),
  "host_recap": zod.string().max(flatCartoonScriptHostRecapMax),
  "lines": zod.array(FlatCartoonLine).min(1).max(flatCartoonScriptLinesMax),
  "metaphor_action": zod.string().max(flatCartoonScriptMetaphorActionMax),
  "pack_word": zod.string().max(flatCartoonScriptPackWordMax),
  "problem_metaphor": zod.string().max(flatCartoonScriptProblemMetaphorMax),
  "product_description": zod.string().max(flatCartoonScriptProductDescriptionMax),
  "product_short": zod.string().max(flatCartoonScriptProductShortMax),
  "pronunciations": zod.array(Pronunciation).max(flatCartoonScriptPronunciationsMax),
  "runner_features": zod.string().max(flatCartoonScriptRunnerFeaturesMax),
  "runner_lock": zod.string().max(flatCartoonScriptRunnerLockMax),
  "runner_recap": zod.string().max(flatCartoonScriptRunnerRecapMax),
  "tagline": zod.string().max(flatCartoonScriptTaglineMax)
}).describe('Flat cartoon\'s script (spec G14-flat-cartoon; the playbook\'s Fill in, L3625-3637): the\ndirector\'s answer, edited in the form before approval. Its six lines, the invented cast\'s\nlocks with their hex colors, the metaphor, the product as the stills draw it, the tagline\nand the respellings. `templates/flat_cartoon_script.py` checks it.');

export type FlatCartoonScript = zod.input<typeof FlatCartoonScript>;
export type FlatCartoonScriptOutput = zod.output<typeof FlatCartoonScript>;

export const FlatCartoonApproval = zod.object({
  "inputs": FlatCartoonPickedInputs,
  "script": FlatCartoonScript
}).describe('`POST .../draft/approve`: Approve script, the form and the script as edited.');

export type FlatCartoonApproval = zod.input<typeof FlatCartoonApproval>;
export type FlatCartoonApprovalOutput = zod.output<typeof FlatCartoonApproval>;

export const flatCartoonInputsBrandDefault = ``;
export const flatCartoonInputsBrandMax = 100;

export const flatCartoonInputsProblemDefault = ``;
export const flatCartoonInputsProblemMax = 200;

export const flatCartoonInputsProductCategoryDefault = ``;
export const flatCartoonInputsProductCategoryMax = 200;

export const flatCartoonInputsProductNameDefault = ``;
export const flatCartoonInputsProductNameMax = 200;

export const flatCartoonInputsProductTextDefault = ``;
export const flatCartoonInputsProductTextMax = 20000;

export const flatCartoonInputsResolutionDefault = `1080p`;
export const flatCartoonInputsSubtitlesDefault = true;
export const flatCartoonInputsUrlDefault = ``;
export const flatCartoonInputsUrlMax = 100;



export const FlatCartoonInputs = zod.object({
  "brand": zod.string().max(flatCartoonInputsBrandMax).default(flatCartoonInputsBrandDefault),
  "problem": zod.string().max(flatCartoonInputsProblemMax).default(flatCartoonInputsProblemDefault),
  "product": zod.union([PackshotProduct,zod.null()]).exactOptional(),
  "product_category": zod.string().max(flatCartoonInputsProductCategoryMax).default(flatCartoonInputsProductCategoryDefault),
  "product_name": zod.string().max(flatCartoonInputsProductNameMax).default(flatCartoonInputsProductNameDefault),
  "product_text": zod.string().max(flatCartoonInputsProductTextMax).default(flatCartoonInputsProductTextDefault),
  "resolution": zod.enum(['1080p', '720p']).default(flatCartoonInputsResolutionDefault),
  "subtitles": zod.boolean().default(flatCartoonInputsSubtitlesDefault),
  "url": zod.string().max(flatCartoonInputsUrlMax).default(flatCartoonInputsUrlDefault)
}).describe('Flat cartoon\'s form so far: the product (none until picked), and the rest.');

export type FlatCartoonInputs = zod.input<typeof FlatCartoonInputs>;
export type FlatCartoonInputsOutput = zod.output<typeof FlatCartoonInputs>;

export const FlatCartoonStillName = zod.enum(['host_sheet', 'caller_sheet', 'studio', 'car', 'metaphor', 'prescribe', 'closeup', 'hero']);

export type FlatCartoonStillName = zod.input<typeof FlatCartoonStillName>;
export type FlatCartoonStillNameOutput = zod.output<typeof FlatCartoonStillName>;

export const FlatCartoonDraftStill = zod.object({
  "name": FlatCartoonStillName,
  "output": zod.union([OutputRef,zod.null()]).exactOptional(),
  "problem": zod.union([zod.string(),zod.null()]),
  "status": StillStatus,
  "url": zod.union([zod.string(),zod.null()])
}).describe('One of the eight stills, as `DraftStill`.');

export type FlatCartoonDraftStill = zod.input<typeof FlatCartoonDraftStill>;
export type FlatCartoonDraftStillOutput = zod.output<typeof FlatCartoonDraftStill>;

export const FlatCartoonDraft = zod.object({
  "inputs": FlatCartoonInputs,
  "pack_director": DirectorState,
  "pack_warning": zod.boolean(),
  "problem": zod.union([zod.string(),zod.null()]),
  "script": zod.union([FlatCartoonScript,zod.null()]),
  "script_director": DirectorState,
  "script_problems": zod.array(zod.string()),
  "stage": DraftStage,
  "stills": zod.array(FlatCartoonDraftStill),
  "updated_at": zod.iso.datetime({"offset":true}),
  "urls_expire_at": zod.union([zod.iso.datetime({"offset":true}),zod.null()])
}).describe('A member\'s Flat cartoon draft in the brand: the form, the stage, the script and its\ndirectors (the pack reader\'s, then the script\'s), and the stills. `pack_warning`: the pack was\nhard to read. `script_problems`: what Approve would still refuse after the director\'s redo,\nin its words; empty for a script that passes. `problem`: the words of the last director that\nfailed. `stills` is empty until the script is approved.');

export type FlatCartoonDraft = zod.input<typeof FlatCartoonDraft>;
export type FlatCartoonDraftOutput = zod.output<typeof FlatCartoonDraft>;

export const FlatCartoonDraftWrite = zod.object({
  "inputs": FlatCartoonInputs,
  "script": zod.union([FlatCartoonScript,zod.null()]).exactOptional()
}).describe('`PUT .../templates/flat-cartoon/draft`: the form as it stands, its script as edited.');

export type FlatCartoonDraftWrite = zod.input<typeof FlatCartoonDraftWrite>;
export type FlatCartoonDraftWriteOutput = zod.output<typeof FlatCartoonDraftWrite>;

export const FlatCartoonScriptAsk = zod.object({
  "inputs": FlatCartoonPickedInputs
}).describe('`POST .../draft/script`: Generate script, on the form as it stands.');

export type FlatCartoonScriptAsk = zod.input<typeof FlatCartoonScriptAsk>;
export type FlatCartoonScriptAskOutput = zod.output<typeof FlatCartoonScriptAsk>;

export const FlatCartoonStills = zod.object({
  "car": OutputRef,
  "closeup": OutputRef,
  "hero": OutputRef,
  "metaphor": OutputRef,
  "prescribe": OutputRef,
  "studio": OutputRef
}).describe('The six start stills the clips start from (A2 to F2), each the draft\'s still\'s picture,\nan earlier output. The character sheets are no clip\'s.');

export type FlatCartoonStills = zod.input<typeof FlatCartoonStills>;
export type FlatCartoonStillsOutput = zod.output<typeof FlatCartoonStills>;

export const flatCartoonVideoInputsBrandMax = 100;

export const flatCartoonVideoInputsResolutionDefault = `1080p`;
export const flatCartoonVideoInputsSubtitlesDefault = true;
export const flatCartoonVideoInputsUrlDefault = ``;
export const flatCartoonVideoInputsUrlMax = 100;



export const FlatCartoonVideoInputs = zod.object({
  "brand": zod.string().min(1).max(flatCartoonVideoInputsBrandMax),
  "resolution": zod.enum(['1080p', '720p']).default(flatCartoonVideoInputsResolutionDefault),
  "script": FlatCartoonScript,
  "stills": FlatCartoonStills,
  "subtitles": zod.boolean().default(flatCartoonVideoInputsSubtitlesDefault),
  "template": zod.enum(['flat-cartoon']),
  "url": zod.string().max(flatCartoonVideoInputsUrlMax).default(flatCartoonVideoInputsUrlDefault)
}).describe('Flat cartoon\'s "Generate video" (spec G14-flat-cartoon, "The run", PR c): the approved\nscript, the brand as said and the web address, the six start stills, the subtitles and the\nclips\' resolution. One `video.template` tile (`templates/flat_cartoon.py`).');

export type FlatCartoonVideoInputs = zod.input<typeof FlatCartoonVideoInputs>;
export type FlatCartoonVideoInputsOutput = zod.output<typeof FlatCartoonVideoInputs>;

export const Folder = zod.object({
  "created_at": zod.iso.datetime({"offset":true}),
  "created_by": zod.uuid(),
  "id": zod.uuid(),
  "is_favorite": zod.boolean(),
  "name": zod.string(),
  "parent_id": zod.union([zod.uuid(),zod.null()]),
  "updated_at": zod.iso.datetime({"offset":true})
});

export type Folder = zod.input<typeof Folder>;
export type FolderOutput = zod.output<typeof Folder>;

export const FolderContents = zod.enum(['delete', 'keep']).describe('What deleting a folder does with what it holds (A3b): live\'s "Delete the project and all\ncontents" (the subtree\'s assets into the trash, its folders gone) or "Delete project but\nkeep assets" (its assets and child folders to a target, the top level when none).');

export type FolderContents = zod.input<typeof FolderContents>;
export type FolderContentsOutput = zod.output<typeof FolderContents>;

export const folderCreateNameMax = 100;


export const folderCreateNameRegExp = new RegExp('[^\\t\\n\\v\\f\\r \\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000\\ufeff]');


export const FolderCreate = zod.object({
  "name": zod.string().min(1).max(folderCreateNameMax).regex(folderCreateNameRegExp),
  "parent_id": zod.union([zod.uuid(),zod.null()]).exactOptional()
}).describe('`POST .../folders`: the name, and the folder it goes in (none: the brand\'s top level).');

export type FolderCreate = zod.input<typeof FolderCreate>;
export type FolderCreateOutput = zod.output<typeof FolderCreate>;

export const folderInNameMax = 100;


export const folderInNameRegExp = new RegExp('[^\\t\\n\\v\\f\\r \\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000\\ufeff]');


export const FolderIn = zod.object({
  "name": zod.string().min(1).max(folderInNameMax).regex(folderInNameRegExp)
}).describe('`PUT .../folders/{folder_id}`: the folder\'s new name; a rename keeps its parent.');

export type FolderIn = zod.input<typeof FolderIn>;
export type FolderInOutput = zod.output<typeof FolderIn>;

export const FolderMove = zod.object({
  "parent_id": zod.union([zod.uuid(),zod.null()])
}).describe('`POST .../folders/{folder_id}/move`: the new parent, or null for the top level.');

export type FolderMove = zod.input<typeof FolderMove>;
export type FolderMoveOutput = zod.output<typeof FolderMove>;

export const GeminiOptions = zod.object({
  "thinking": zod.union([zod.enum(['minimal', 'low', 'medium', 'high']),zod.null()]).exactOptional()
}).describe('Live\'s Gemini-only option (`thinking`, its `GeminiThinkingLevel`): the thinking level;\nleft out, the model\'s default.');

export type GeminiOptions = zod.input<typeof GeminiOptions>;
export type GeminiOptionsOutput = zod.output<typeof GeminiOptions>;

export const OutputStatus = zod.enum(['pending', 'delivered', 'failed']);

export type OutputStatus = zod.input<typeof OutputStatus>;
export type OutputStatusOutput = zod.output<typeof OutputStatus>;

export const GenerationOutput = zod.object({
  "ad_specification": zod.union([AdSpecification,zod.null()]).exactOptional(),
  "duration_ms": zod.union([zod.int(),zod.null()]),
  "error": zod.union([JobError,zod.null()]),
  "height": zod.union([zod.int(),zod.null()]),
  "index": zod.int(),
  "mime": zod.union([zod.string(),zod.null()]),
  "poster_url": zod.union([zod.string(),zod.null()]).exactOptional(),
  "saved_actor_id": zod.union([zod.uuid(),zod.null()]).exactOptional(),
  "saved_asset_id": zod.union([zod.uuid(),zod.null()]).exactOptional(),
  "status": OutputStatus,
  "thumb_url": zod.union([zod.string(),zod.null()]).exactOptional(),
  "url": zod.union([zod.string(),zod.null()]),
  "width": zod.union([zod.int(),zod.null()])
}).describe('One requested output of a job: delivered, failed, or still pending.');

export type GenerationOutput = zod.input<typeof GenerationOutput>;
export type GenerationOutputOutput = zod.output<typeof GenerationOutput>;

export const GoogleAuthorization = zod.object({
  "authorization_url": zod.string()
}).describe('Where the SPA sends the browser; Google returns it to `/sign-in/google`.');

export type GoogleAuthorization = zod.input<typeof GoogleAuthorization>;
export type GoogleAuthorizationOutput = zod.output<typeof GoogleAuthorization>;

export const googleCompleteCodeMax = 2048;

export const googleCompleteStateMax = 256;



export const GoogleComplete = zod.object({
  "code": zod.string().min(1).max(googleCompleteCodeMax),
  "state": zod.string().min(1).max(googleCompleteStateMax),
  "time_zone": zod.union([zod.string(),zod.null()]).exactOptional()
}).describe('What Google appended to `/sign-in/google`, posted by that page, and the browser\'s IANA\ntime zone, kept as `EmailCodeVerify` keeps it.');

export type GoogleComplete = zod.input<typeof GoogleComplete>;
export type GoogleCompleteOutput = zod.output<typeof GoogleComplete>;

export const googleStartRedirectDefault = `/`;
export const googleStartRedirectMax = 2048;


export const googleStartRedirectRegExp = new RegExp('^/([^/\\\\\\t\\n\\v\\f\\r \\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000\\ufeff][^\\\\\\t\\n\\v\\f\\r \\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000\\ufeff]*)?$');


export const GoogleStart = zod.object({
  "redirect": zod.string().max(googleStartRedirectMax).regex(googleStartRedirectRegExp).default(googleStartRedirectDefault)
});

export type GoogleStart = zod.input<typeof GoogleStart>;
export type GoogleStartOutput = zod.output<typeof GoogleStart>;

export const GreenScreenRoute = zod.enum(['key', 'inset']);

export type GreenScreenRoute = zod.input<typeof GreenScreenRoute>;
export type GreenScreenRouteOutput = zod.output<typeof GreenScreenRoute>;

export const GreenScreenVideoModel = zod.enum(['gemini-omni-flash-1.1', 'seedance-2-standard']);

export type GreenScreenVideoModel = zod.input<typeof GreenScreenVideoModel>;
export type GreenScreenVideoModelOutput = zod.output<typeof GreenScreenVideoModel>;

export const greenScreenPickedInputsCaptionPositionDefault = `bottom`;
export const greenScreenPickedInputsCaptionStyleIdDefault = ``;
export const greenScreenPickedInputsCaptionStyleIdMax = 64;

export const greenScreenPickedInputsCategoryDefault = ``;
export const greenScreenPickedInputsCategoryMax = 2000;

export const greenScreenPickedInputsCompositeRouteDefault = 'key';
export const greenScreenPickedInputsCreatorLookDefault = ``;
export const greenScreenPickedInputsCreatorLookMax = 500;

export const greenScreenPickedInputsProductNameDefault = ``;
export const greenScreenPickedInputsProductNameMax = 200;

export const greenScreenPickedInputsProductTextDefault = ``;
export const greenScreenPickedInputsProductTextMax = 20000;

export const greenScreenPickedInputsPronunciationDefault = ``;
export const greenScreenPickedInputsPronunciationMax = 500;

export const greenScreenPickedInputsResolutionDefault = `1080p`;
export const greenScreenPickedInputsSloganDefault = ``;
export const greenScreenPickedInputsSloganMax = 2000;

export const greenScreenPickedInputsSubtitlesDefault = true;
export const greenScreenPickedInputsTakeCountDefault = 1;
export const greenScreenPickedInputsTakeCountMax = 3;

export const greenScreenPickedInputsVideoModelDefault = 'gemini-omni-flash-1.1';

export const GreenScreenPickedInputs = zod.object({
  "caption_position": zod.enum(['top', 'center', 'bottom']).default(greenScreenPickedInputsCaptionPositionDefault),
  "caption_style_id": zod.string().max(greenScreenPickedInputsCaptionStyleIdMax).default(greenScreenPickedInputsCaptionStyleIdDefault),
  "category": zod.string().max(greenScreenPickedInputsCategoryMax).default(greenScreenPickedInputsCategoryDefault),
  "composite_route": GreenScreenRoute.default(greenScreenPickedInputsCompositeRouteDefault),
  "creator": zod.union([ActorSource,zod.null()]).exactOptional(),
  "creator_look": zod.string().max(greenScreenPickedInputsCreatorLookMax).default(greenScreenPickedInputsCreatorLookDefault),
  "product": PackshotProduct,
  "product_name": zod.string().max(greenScreenPickedInputsProductNameMax).default(greenScreenPickedInputsProductNameDefault),
  "product_text": zod.string().max(greenScreenPickedInputsProductTextMax).default(greenScreenPickedInputsProductTextDefault),
  "pronunciation": zod.string().max(greenScreenPickedInputsPronunciationMax).default(greenScreenPickedInputsPronunciationDefault),
  "resolution": zod.enum(['1080p', '720p']).default(greenScreenPickedInputsResolutionDefault),
  "slogan": zod.string().max(greenScreenPickedInputsSloganMax).default(greenScreenPickedInputsSloganDefault),
  "subtitles": zod.boolean().default(greenScreenPickedInputsSubtitlesDefault),
  "take_count": zod.int().min(1).max(greenScreenPickedInputsTakeCountMax).default(greenScreenPickedInputsTakeCountDefault),
  "video_model": GreenScreenVideoModel.default(greenScreenPickedInputsVideoModelDefault)
}).describe('The form with its product picked, as Generate Script needs it (live\'s "Pick a product\nand its packshot", 422 at `product`).');

export type GreenScreenPickedInputs = zod.input<typeof GreenScreenPickedInputs>;
export type GreenScreenPickedInputsOutput = zod.output<typeof GreenScreenPickedInputs>;

export const greenScreenBeatActionMax = 2000;



export const GreenScreenBeat = zod.object({
  "action": zod.string().max(greenScreenBeatActionMax),
  "clip": zod.int()
}).describe('A clip\'s hand and face action, tied to its words.');

export type GreenScreenBeat = zod.input<typeof GreenScreenBeat>;
export type GreenScreenBeatOutput = zod.output<typeof GreenScreenBeat>;

export const scriptClaimClaimMax = 2000;

export const scriptClaimIdMax = 16;

export const scriptClaimSourceQuoteMax = 2000;



export const ScriptClaim = zod.object({
  "claim": zod.string().max(scriptClaimClaimMax),
  "id": zod.string().max(scriptClaimIdMax),
  "source_quote": zod.string().max(scriptClaimSourceQuoteMax)
}).describe('A product fact the script states, with its quote from the product page (live\'s\n`claims`).');

export type ScriptClaim = zod.input<typeof ScriptClaim>;
export type ScriptClaimOutput = zod.output<typeof ScriptClaim>;

export const GreenScreenGender = zod.enum(['female', 'male']);

export type GreenScreenGender = zod.input<typeof GreenScreenGender>;
export type GreenScreenGenderOutput = zod.output<typeof GreenScreenGender>;

export const greenScreenCreatorLookMax = 2000;

export const greenScreenCreatorWhyMax = 2000;



export const GreenScreenCreator = zod.object({
  "age": zod.int(),
  "gender": GreenScreenGender,
  "look": zod.string().max(greenScreenCreatorLookMax),
  "why": zod.string().max(greenScreenCreatorWhyMax)
}).describe('The creator: a designed one\'s look (a woman of 20 to 25, no clothing), or a picked\nperson\'s as seen, why they fit the buyer, and the gender and age the voice follows.');

export type GreenScreenCreator = zod.input<typeof GreenScreenCreator>;
export type GreenScreenCreatorOutput = zod.output<typeof GreenScreenCreator>;

export const GreenScreenRole = zod.enum(['hook', 'point', 'bad_habit', 'product', 'usage', 'slogan']);

export type GreenScreenRole = zod.input<typeof GreenScreenRole>;
export type GreenScreenRoleOutput = zod.output<typeof GreenScreenRole>;

export const greenScreenLineCardLineMax = 2000;

export const greenScreenLineClaimIdsMax = 60;

export const greenScreenLineSpokenMax = 2000;

export const greenScreenLineTextMax = 2000;



export const GreenScreenLine = zod.object({
  "card_line": zod.string().max(greenScreenLineCardLineMax),
  "claim_ids": zod.array(zod.string()).max(greenScreenLineClaimIdsMax),
  "clip": zod.int(),
  "id": zod.int(),
  "role": GreenScreenRole,
  "spoken": zod.string().max(greenScreenLineSpokenMax),
  "text": zod.string().max(greenScreenLineTextMax)
}).describe('One of the ten lines: its number, its clip, its role, its words as written and as said,\nthe claims it states, and a point\'s card line ("" for the others).');

export type GreenScreenLine = zod.input<typeof GreenScreenLine>;
export type GreenScreenLineOutput = zod.output<typeof GreenScreenLine>;

export const GreenScreenSloganSource = zod.enum(['input', 'page', 'written']);

export type GreenScreenSloganSource = zod.input<typeof GreenScreenSloganSource>;
export type GreenScreenSloganSourceOutput = zod.output<typeof GreenScreenSloganSource>;

export const greenScreenScriptBeatsMax = 60;

export const greenScreenScriptBrandSpokenMax = 2000;

export const greenScreenScriptCardTitleMax = 2000;

export const greenScreenScriptCategoryMax = 2000;

export const greenScreenScriptClaimsMax = 60;

export const greenScreenScriptLinesMax = 60;

export const greenScreenScriptProductNameMax = 2000;

export const greenScreenScriptProductSpokenMax = 2000;

export const greenScreenScriptPronunciationsMax = 60;

export const greenScreenScriptSloganMax = 2000;



export const GreenScreenScript = zod.object({
  "beats": zod.array(GreenScreenBeat).max(greenScreenScriptBeatsMax),
  "brand_spoken": zod.string().max(greenScreenScriptBrandSpokenMax),
  "card_title": zod.string().max(greenScreenScriptCardTitleMax),
  "category": zod.string().max(greenScreenScriptCategoryMax),
  "claims": zod.array(ScriptClaim).max(greenScreenScriptClaimsMax),
  "creator": GreenScreenCreator,
  "lines": zod.array(GreenScreenLine).max(greenScreenScriptLinesMax),
  "product_name": zod.string().max(greenScreenScriptProductNameMax),
  "product_spoken": zod.string().max(greenScreenScriptProductSpokenMax),
  "pronunciations": zod.array(Pronunciation).max(greenScreenScriptPronunciationsMax),
  "slogan": zod.string().max(greenScreenScriptSloganMax),
  "slogan_source": GreenScreenSloganSource
}).describe('The script director\'s answer, as approval 1 holds it (live\'s `greenScreenScriptSchema`):\nthe names, category, card title and slogan, the creator, the claims, the ten lines, the four\nbeats and the pronunciations.');

export type GreenScreenScript = zod.input<typeof GreenScreenScript>;
export type GreenScreenScriptOutput = zod.output<typeof GreenScreenScript>;

export const GreenScreenApproval = zod.object({
  "inputs": GreenScreenPickedInputs,
  "script": GreenScreenScript
}).describe('`POST .../draft/approve`: live\'s "Approve script", the form and the script as they stand\n(approval 1\'s issues, `green_screen_script.script_issue`, refuse it at `script`).');

export type GreenScreenApproval = zod.input<typeof GreenScreenApproval>;
export type GreenScreenApprovalOutput = zod.output<typeof GreenScreenApproval>;

export const greenScreenCardCheckCardCountMax = 3;



export const GreenScreenCardCheck = zod.object({
  "card_count": zod.int().min(1).max(greenScreenCardCheckCardCountMax),
  "problems": zod.array(zod.string())
}).describe('The kept card read back (live\'s `CardCheck`): what is off in it, in live\'s words (none:\nit reads exactly as approved), and how many cards it took, 1 to 3.');

export type GreenScreenCardCheck = zod.input<typeof GreenScreenCardCheck>;
export type GreenScreenCardCheckOutput = zod.output<typeof GreenScreenCardCheck>;

export const greenScreenInputsCaptionPositionDefault = `bottom`;
export const greenScreenInputsCaptionStyleIdDefault = ``;
export const greenScreenInputsCaptionStyleIdMax = 64;

export const greenScreenInputsCategoryDefault = ``;
export const greenScreenInputsCategoryMax = 2000;

export const greenScreenInputsCompositeRouteDefault = 'key';
export const greenScreenInputsCreatorLookDefault = ``;
export const greenScreenInputsCreatorLookMax = 500;

export const greenScreenInputsProductNameDefault = ``;
export const greenScreenInputsProductNameMax = 200;

export const greenScreenInputsProductTextDefault = ``;
export const greenScreenInputsProductTextMax = 20000;

export const greenScreenInputsPronunciationDefault = ``;
export const greenScreenInputsPronunciationMax = 500;

export const greenScreenInputsResolutionDefault = `1080p`;
export const greenScreenInputsSloganDefault = ``;
export const greenScreenInputsSloganMax = 2000;

export const greenScreenInputsSubtitlesDefault = true;
export const greenScreenInputsTakeCountDefault = 1;
export const greenScreenInputsTakeCountMax = 3;

export const greenScreenInputsVideoModelDefault = 'gemini-omni-flash-1.1';

export const GreenScreenInputs = zod.object({
  "caption_position": zod.enum(['top', 'center', 'bottom']).default(greenScreenInputsCaptionPositionDefault),
  "caption_style_id": zod.string().max(greenScreenInputsCaptionStyleIdMax).default(greenScreenInputsCaptionStyleIdDefault),
  "category": zod.string().max(greenScreenInputsCategoryMax).default(greenScreenInputsCategoryDefault),
  "composite_route": GreenScreenRoute.default(greenScreenInputsCompositeRouteDefault),
  "creator": zod.union([ActorSource,zod.null()]).exactOptional(),
  "creator_look": zod.string().max(greenScreenInputsCreatorLookMax).default(greenScreenInputsCreatorLookDefault),
  "product": zod.union([PackshotProduct,zod.null()]).exactOptional(),
  "product_name": zod.string().max(greenScreenInputsProductNameMax).default(greenScreenInputsProductNameDefault),
  "product_text": zod.string().max(greenScreenInputsProductTextMax).default(greenScreenInputsProductTextDefault),
  "pronunciation": zod.string().max(greenScreenInputsPronunciationMax).default(greenScreenInputsPronunciationDefault),
  "resolution": zod.enum(['1080p', '720p']).default(greenScreenInputsResolutionDefault),
  "slogan": zod.string().max(greenScreenInputsSloganMax).default(greenScreenInputsSloganDefault),
  "subtitles": zod.boolean().default(greenScreenInputsSubtitlesDefault),
  "take_count": zod.int().min(1).max(greenScreenInputsTakeCountMax).default(greenScreenInputsTakeCountDefault),
  "video_model": GreenScreenVideoModel.default(greenScreenInputsVideoModelDefault)
}).describe('Green Screen Yapper Ad\'s form so far: the product (none until picked), and the rest.');

export type GreenScreenInputs = zod.input<typeof GreenScreenInputs>;
export type GreenScreenInputsOutput = zod.output<typeof GreenScreenInputs>;

export const greenScreenPlannedClipClipMax = 4;

export const greenScreenPlannedClipDurationSMin = 0;

export const greenScreenPlannedClipWordsMin = 0;



export const GreenScreenPlannedClip = zod.object({
  "clip": zod.int().min(1).max(greenScreenPlannedClipClipMax),
  "duration_s": zod.int().min(greenScreenPlannedClipDurationSMin),
  "words": zod.int().min(greenScreenPlannedClipWordsMin)
}).describe('One talking clip of the script\'s timing plan (live\'s `PlannedClip`): its words and its\nwhole seconds on the picked clip model.');

export type GreenScreenPlannedClip = zod.input<typeof GreenScreenPlannedClip>;
export type GreenScreenPlannedClipOutput = zod.output<typeof GreenScreenPlannedClip>;

export const greenScreenPlannedLineWordsMin = 0;



export const GreenScreenPlannedLine = zod.object({
  "id": zod.int(),
  "words": zod.int().min(greenScreenPlannedLineWordsMin)
}).describe('One line\'s spoken words as the plan counts them (live\'s `countSpokenWords`: a respelling\nis one word), the "Says:" row\'s count.');

export type GreenScreenPlannedLine = zod.input<typeof GreenScreenPlannedLine>;
export type GreenScreenPlannedLineOutput = zod.output<typeof GreenScreenPlannedLine>;

export const greenScreenPlanCardClipSMin = 0;

export const greenScreenPlanTotalSMin = 0;

export const greenScreenPlanWordsMin = 0;



export const GreenScreenPlan = zod.object({
  "card_clip_s": zod.int().min(greenScreenPlanCardClipSMin),
  "clips": zod.array(GreenScreenPlannedClip),
  "lines": zod.array(GreenScreenPlannedLine),
  "total_s": zod.int().min(greenScreenPlanTotalSMin),
  "words": zod.int().min(greenScreenPlanWordsMin)
}).describe('The script\'s timing plan as the editor shows it (live\'s `toScriptMetaLabel`, clip headers\nand word counts): the four talking clips, each line\'s words, the card clip\'s seconds, the\nwords and the seconds in all.');

export type GreenScreenPlan = zod.input<typeof GreenScreenPlan>;
export type GreenScreenPlanOutput = zod.output<typeof GreenScreenPlan>;

export const GreenScreenTakeWord = zod.enum(['first', 'second', 'third']);

export type GreenScreenTakeWord = zod.input<typeof GreenScreenTakeWord>;
export type GreenScreenTakeWordOutput = zod.output<typeof GreenScreenTakeWord>;

export const GreenScreenTake = zod.object({
  "frames": zod.union([OutputRef,zod.null()]).exactOptional(),
  "picture": zod.union([OutputRef,zod.null()]).exactOptional(),
  "take": GreenScreenTakeWord,
  "video": OutputRef,
  "words": zod.union([OutputRef,zod.null()]).exactOptional()
}).describe('One take an earlier run from this draft delivered, kept as it is with its checks (live\'s\n`ClipTake`, G14-engine Engine-8): which take of its clip it was, its video, and the outputs of\nits word check, frames and picture check where they came back.');

export type GreenScreenTake = zod.input<typeof GreenScreenTake>;
export type GreenScreenTakeOutput = zod.output<typeof GreenScreenTake>;

export const greenScreenTakesADefault = [];
export const greenScreenTakesAMax = 3;

export const greenScreenTakesBDefault = [];
export const greenScreenTakesBMax = 3;

export const greenScreenTakesCDefault = [];
export const greenScreenTakesCMax = 3;

export const greenScreenTakesDDefault = [];
export const greenScreenTakesDMax = 3;



export const GreenScreenTakes = zod.object({
  "a": zod.array(GreenScreenTake).max(greenScreenTakesAMax).default(greenScreenTakesADefault),
  "b": zod.array(GreenScreenTake).max(greenScreenTakesBMax).default(greenScreenTakesBDefault),
  "c": zod.array(GreenScreenTake).max(greenScreenTakesCMax).default(greenScreenTakesCDefault),
  "card": zod.union([OutputRef,zod.null()]).exactOptional(),
  "d": zod.array(GreenScreenTake).max(greenScreenTakesDMax).default(greenScreenTakesDDefault)
}).describe('The clips an earlier run delivered that the next run keeps (live\'s `toCurrentTake`: a clip\nwhose request is unchanged is not made again): each talking clip\'s delivered takes, by its\nletter, and the card clip. A clip named here runs none of its other takes; the form names a\nclip only while its still, words, model and resolution are unchanged.');

export type GreenScreenTakes = zod.input<typeof GreenScreenTakes>;
export type GreenScreenTakesOutput = zod.output<typeof GreenScreenTakes>;

export const GreenScreenStills = zod.object({
  "card": OutputRef,
  "creator": OutputRef,
  "pose_2": OutputRef,
  "pose_3": OutputRef,
  "pose_4": OutputRef
}).describe('The pictures the clips start on (live\'s `stillUrls`): the creator (clip 1), the three\nposes (clips 2 to 4) and the card (its clip, start and end), each the draft\'s still\'s\npicture, an earlier output.');

export type GreenScreenStills = zod.input<typeof GreenScreenStills>;
export type GreenScreenStillsOutput = zod.output<typeof GreenScreenStills>;

export const greenScreenVideoInputsCaptionPositionDefault = `bottom`;
export const greenScreenVideoInputsCaptionStyleIdDefault = ``;
export const greenScreenVideoInputsCaptionStyleIdMax = 64;

export const greenScreenVideoInputsCompositeRouteDefault = 'key';
export const greenScreenVideoInputsPhotoCreatorDefault = false;
export const greenScreenVideoInputsResolutionDefault = `1080p`;
export const greenScreenVideoInputsSubtitlesDefault = true;
export const greenScreenVideoInputsTakeCountDefault = 1;
export const greenScreenVideoInputsTakeCountMax = 3;

export const greenScreenVideoInputsTakesDefault = { a: [], b: [], c: [], d: [], };
export const greenScreenVideoInputsVideoModelDefault = 'gemini-omni-flash-1.1';

export const GreenScreenVideoInputs = zod.object({
  "caption_position": zod.enum(['top', 'center', 'bottom']).default(greenScreenVideoInputsCaptionPositionDefault),
  "caption_style_id": zod.string().max(greenScreenVideoInputsCaptionStyleIdMax).default(greenScreenVideoInputsCaptionStyleIdDefault),
  "composite_route": GreenScreenRoute.default(greenScreenVideoInputsCompositeRouteDefault),
  "photo_creator": zod.boolean().default(greenScreenVideoInputsPhotoCreatorDefault),
  "resolution": zod.enum(['1080p', '720p']).default(greenScreenVideoInputsResolutionDefault),
  "script": GreenScreenScript,
  "stills": GreenScreenStills,
  "subtitles": zod.boolean().default(greenScreenVideoInputsSubtitlesDefault),
  "take_count": zod.int().min(1).max(greenScreenVideoInputsTakeCountMax).default(greenScreenVideoInputsTakeCountDefault),
  "takes": GreenScreenTakes.default(greenScreenVideoInputsTakesDefault),
  "template": zod.enum(['green-screen-yapper-ad']),
  "video_model": GreenScreenVideoModel.default(greenScreenVideoInputsVideoModelDefault)
}).describe('Green Screen Yapper Ad\'s "Generate video" (live\'s hand-off): the approved script, the\nstills, whether the creator is a person\'s photo (live\'s `!!personUrl`, which words the clips\nand the picture check; the photo itself is no clip\'s), the captions\' choice, the clip model,\nthe resolution, the takes of each clip (1 to 3) and the composite route (`key`: keyed off a\ngreen backdrop; `inset`: laid in on a white one). One tile: the takes and their checks, the\ncard clip, the join, the key, the composite, the captions in two passes.');

export type GreenScreenVideoInputs = zod.input<typeof GreenScreenVideoInputs>;
export type GreenScreenVideoInputsOutput = zod.output<typeof GreenScreenVideoInputs>;

export const GreenScreenRunClip = zod.enum(['a', 'b', 'c', 'd', 'card']);

export type GreenScreenRunClip = zod.input<typeof GreenScreenRunClip>;
export type GreenScreenRunClipOutput = zod.output<typeof GreenScreenRunClip>;

export const GreenScreenDraftRun = zod.object({
  "delivered": GreenScreenTakes,
  "ended": zod.boolean(),
  "error_code": zod.union([JobErrorCode,zod.null()]),
  "inputs": GreenScreenVideoInputs,
  "job_id": zod.uuid(),
  "refused": zod.array(GreenScreenRunClip)
}).describe('The member\'s last "Generate final video" from this draft (live keeps a run\'s takes in its\nwidget; ours reads them from the run): its job, whether it has ended and how its tile failed\n(`clip_refused`, or another code), the inputs it was made with, the takes it delivered (each\nclip\'s, with their checks, and the card clip: the next run\'s `takes` where the clip is\nunchanged), and the clips the video model refused with no take back (the card clip as\n`card`), which Revise opens.');

export type GreenScreenDraftRun = zod.input<typeof GreenScreenDraftRun>;
export type GreenScreenDraftRunOutput = zod.output<typeof GreenScreenDraftRun>;

export const GreenScreenStillName = zod.enum(['creator', 'pose_2', 'pose_3', 'pose_4', 'card']);

export type GreenScreenStillName = zod.input<typeof GreenScreenStillName>;
export type GreenScreenStillNameOutput = zod.output<typeof GreenScreenStillName>;

export const GreenScreenDraftStill = zod.object({
  "name": GreenScreenStillName,
  "output": zod.union([OutputRef,zod.null()]).exactOptional(),
  "problem": zod.union([zod.string(),zod.null()]),
  "status": StillStatus,
  "url": zod.union([zod.string(),zod.null()])
}).describe('One of approval 2\'s stills (live\'s `StillState`), as `DraftStill`: the creator, the three\nposes, the card (its kept card once every card it draws is read back). `url` is signed until\nthe draft\'s `urls_expire_at`; `output` names the picture, as "Generate video" sends it\n(`GreenScreenStills`).');

export type GreenScreenDraftStill = zod.input<typeof GreenScreenDraftStill>;
export type GreenScreenDraftStillOutput = zod.output<typeof GreenScreenDraftStill>;

export const GreenScreenDraft = zod.object({
  "card_check": zod.union([GreenScreenCardCheck,zod.null()]),
  "card_checking": zod.boolean(),
  "inputs": GreenScreenInputs,
  "plan": zod.union([GreenScreenPlan,zod.null()]),
  "problem": zod.union([zod.string(),zod.null()]),
  "run": zod.union([GreenScreenDraftRun,zod.null()]),
  "script": zod.union([GreenScreenScript,zod.null()]),
  "script_director": DirectorState,
  "script_issue": zod.union([zod.string(),zod.null()]),
  "script_problems": zod.array(zod.string()),
  "script_warnings": zod.array(zod.string()),
  "stage": DraftStage,
  "stills": zod.array(GreenScreenDraftStill),
  "updated_at": zod.iso.datetime({"offset":true}),
  "urls_expire_at": zod.union([zod.iso.datetime({"offset":true}),zod.null()])
}).describe('A member\'s Green Screen Yapper Ad draft in the brand: the form, the stage, the script and\nits director. `script_warnings`: live\'s words on the director\'s kept script (still off after\nits three tries; a slogan written from the page); `script_problems`: what is off in the\nscript as it stands, in live\'s words, on the picked clip model. `problem`: live\'s words for\nthe director\'s last failure. Once the script is approved (`cast`): the five `stills`, the\nkept card\'s check (`card_check`, none until the card is kept) and whether a card is being\nread back (`card_checking`).');

export type GreenScreenDraft = zod.input<typeof GreenScreenDraft>;
export type GreenScreenDraftOutput = zod.output<typeof GreenScreenDraft>;

export const GreenScreenDraftWrite = zod.object({
  "inputs": GreenScreenInputs,
  "script": zod.union([GreenScreenScript,zod.null()]).exactOptional()
}).describe('`PUT .../templates/green-screen-yapper-ad/draft`: the form as it stands, its script as\nedited.');

export type GreenScreenDraftWrite = zod.input<typeof GreenScreenDraftWrite>;
export type GreenScreenDraftWriteOutput = zod.output<typeof GreenScreenDraftWrite>;

export const GreenScreenScriptAsk = zod.object({
  "inputs": GreenScreenPickedInputs
}).describe('`POST .../draft/script`: live\'s "Generate script", on the form as it stands.');

export type GreenScreenScriptAsk = zod.input<typeof GreenScreenScriptAsk>;
export type GreenScreenScriptAskOutput = zod.output<typeof GreenScreenScriptAsk>;

export const grwmPickedInputsDressDefault = ``;
export const grwmPickedInputsDressMax = 1000;

export const grwmPickedInputsDressShortDefault = ``;
export const grwmPickedInputsDressShortMax = 100;

export const grwmPickedInputsFaceLockDefault = ``;
export const grwmPickedInputsFaceLockMax = 1000;

export const grwmPickedInputsHairStyledDefault = ``;
export const grwmPickedInputsHairStyledMax = 200;

export const grwmPickedInputsProductNameDefault = ``;
export const grwmPickedInputsProductNameMax = 200;

export const grwmPickedInputsProductTextDefault = ``;
export const grwmPickedInputsProductTextMax = 20000;

export const grwmPickedInputsResolutionDefault = `1080p`;
export const grwmPickedInputsStairsDefault = true;
export const grwmPickedInputsWomanDefault = ``;
export const grwmPickedInputsWomanMax = 1000;



export const GrwmPickedInputs = zod.object({
  "dress": zod.string().max(grwmPickedInputsDressMax).default(grwmPickedInputsDressDefault),
  "dress_short": zod.string().max(grwmPickedInputsDressShortMax).default(grwmPickedInputsDressShortDefault),
  "face_lock": zod.string().max(grwmPickedInputsFaceLockMax).default(grwmPickedInputsFaceLockDefault),
  "hair_styled": zod.string().max(grwmPickedInputsHairStyledMax).default(grwmPickedInputsHairStyledDefault),
  "product": PackshotProduct,
  "product_name": zod.string().max(grwmPickedInputsProductNameMax).default(grwmPickedInputsProductNameDefault),
  "product_text": zod.string().max(grwmPickedInputsProductTextMax).default(grwmPickedInputsProductTextDefault),
  "resolution": zod.enum(['1080p', '720p']).default(grwmPickedInputsResolutionDefault),
  "stairs": zod.boolean().default(grwmPickedInputsStairsDefault),
  "woman": zod.string().max(grwmPickedInputsWomanMax).default(grwmPickedInputsWomanDefault)
}).describe('The form with its product picked, as Generate script and Approve script need it (422 at\n`product`, "Pick a product and its packshot").');

export type GrwmPickedInputs = zod.input<typeof GrwmPickedInputs>;
export type GrwmPickedInputsOutput = zod.output<typeof GrwmPickedInputs>;

export const GrwmBeat = zod.enum(['shower', 'skin_prep', 'blush_lipstick', 'curls', 'dress_reveal', 'entryway', 'leaving', 'nerves', 'arrival', 'toast']).describe('GRWM\'s ten beats in their order (spec G14-grwm; the playbook\'s Script, L9400): one line a\nbeat, the first five clip one\'s, the last five clip two\'s.');

export type GrwmBeat = zod.input<typeof GrwmBeat>;
export type GrwmBeatOutput = zod.output<typeof GrwmBeat>;

export const grwmLineTextMax = 300;



export const GrwmLine = zod.object({
  "beat": GrwmBeat,
  "text": zod.string().max(grwmLineTextMax)
}).describe('One beat\'s voiceover line.');

export type GrwmLine = zod.input<typeof GrwmLine>;
export type GrwmLineOutput = zod.output<typeof GrwmLine>;

export const grwmScriptLinesMax = 10;

export const grwmScriptProductActionMax = 500;



export const GrwmScript = zod.object({
  "lines": zod.array(GrwmLine).min(1).max(grwmScriptLinesMax),
  "product_action": zod.string().max(grwmScriptProductActionMax)
}).describe('GRWM\'s script: the ten lines on their beats (the director\'s answer, edited in the form\nbefore approval, or the playbook\'s approved example), and what she does with the product in\nthe entryway beat (the playbook\'s {PRODUCT_ACTION}, L9388).');

export type GrwmScript = zod.input<typeof GrwmScript>;
export type GrwmScriptOutput = zod.output<typeof GrwmScript>;

export const GrwmApproval = zod.object({
  "inputs": GrwmPickedInputs,
  "script": GrwmScript
}).describe('`POST .../draft/approve`: Approve script, the form and the script as edited.');

export type GrwmApproval = zod.input<typeof GrwmApproval>;
export type GrwmApprovalOutput = zod.output<typeof GrwmApproval>;

export const grwmInputsDressDefault = ``;
export const grwmInputsDressMax = 1000;

export const grwmInputsDressShortDefault = ``;
export const grwmInputsDressShortMax = 100;

export const grwmInputsFaceLockDefault = ``;
export const grwmInputsFaceLockMax = 1000;

export const grwmInputsHairStyledDefault = ``;
export const grwmInputsHairStyledMax = 200;

export const grwmInputsProductNameDefault = ``;
export const grwmInputsProductNameMax = 200;

export const grwmInputsProductTextDefault = ``;
export const grwmInputsProductTextMax = 20000;

export const grwmInputsResolutionDefault = `1080p`;
export const grwmInputsStairsDefault = true;
export const grwmInputsWomanDefault = ``;
export const grwmInputsWomanMax = 1000;



export const GrwmInputs = zod.object({
  "dress": zod.string().max(grwmInputsDressMax).default(grwmInputsDressDefault),
  "dress_short": zod.string().max(grwmInputsDressShortMax).default(grwmInputsDressShortDefault),
  "face_lock": zod.string().max(grwmInputsFaceLockMax).default(grwmInputsFaceLockDefault),
  "hair_styled": zod.string().max(grwmInputsHairStyledMax).default(grwmInputsHairStyledDefault),
  "product": zod.union([PackshotProduct,zod.null()]).exactOptional(),
  "product_name": zod.string().max(grwmInputsProductNameMax).default(grwmInputsProductNameDefault),
  "product_text": zod.string().max(grwmInputsProductTextMax).default(grwmInputsProductTextDefault),
  "resolution": zod.enum(['1080p', '720p']).default(grwmInputsResolutionDefault),
  "stairs": zod.boolean().default(grwmInputsStairsDefault),
  "woman": zod.string().max(grwmInputsWomanMax).default(grwmInputsWomanDefault)
}).describe('GRWM\'s form so far: the product (none until picked), and the rest.');

export type GrwmInputs = zod.input<typeof GrwmInputs>;
export type GrwmInputsOutput = zod.output<typeof GrwmInputs>;

export const GrwmStillName = zod.enum(['img1', 'img2c', 'img3c', 'img2', 'img3', 'dress', 'body', 'wear_front', 'wear_side', 'img4', 'img5', 'door', 'img6s', 'rest_plate', 'img7r', 'img8r']);

export type GrwmStillName = zod.input<typeof GrwmStillName>;
export type GrwmStillNameOutput = zod.output<typeof GrwmStillName>;

export const GrwmDraftStill = zod.object({
  "name": GrwmStillName,
  "output": zod.union([OutputRef,zod.null()]).exactOptional(),
  "problem": zod.union([zod.string(),zod.null()]),
  "status": StillStatus,
  "url": zod.union([zod.string(),zod.null()])
}).describe('One of the sixteen stills, as `DraftStill`.');

export type GrwmDraftStill = zod.input<typeof GrwmDraftStill>;
export type GrwmDraftStillOutput = zod.output<typeof GrwmDraftStill>;

export const GrwmStills = zod.object({
  "body": OutputRef,
  "door": OutputRef,
  "dress": OutputRef,
  "img1": OutputRef,
  "img2": OutputRef,
  "img2c": OutputRef,
  "img3": OutputRef,
  "img3c": OutputRef,
  "img4": OutputRef,
  "img5": OutputRef,
  "img6s": OutputRef,
  "img7r": OutputRef,
  "img8r": OutputRef,
  "rest_plate": OutputRef,
  "wear_front": OutputRef,
  "wear_side": OutputRef
}).describe('The sixteen stills a GRWM video is drawn from, each the draft\'s still\'s picture, an\nearlier output, by the playbook\'s names (L9411-9415).');

export type GrwmStills = zod.input<typeof GrwmStills>;
export type GrwmStillsOutput = zod.output<typeof GrwmStills>;

export const grwmVideoInputsDressMax = 1000;

export const grwmVideoInputsDressShortMax = 100;

export const grwmVideoInputsHairStyledMax = 200;

export const grwmVideoInputsProductNameMax = 200;

export const grwmVideoInputsResolutionDefault = `1080p`;
export const grwmVideoInputsStairsDefault = true;

export const GrwmVideoInputs = zod.object({
  "dress": zod.string().min(1).max(grwmVideoInputsDressMax),
  "dress_short": zod.string().min(1).max(grwmVideoInputsDressShortMax),
  "hair_styled": zod.string().min(1).max(grwmVideoInputsHairStyledMax),
  "packshot": TemplateSource,
  "product_id": zod.union([zod.uuid(),zod.null()]).exactOptional(),
  "product_name": zod.string().min(1).max(grwmVideoInputsProductNameMax),
  "resolution": zod.enum(['1080p', '720p']).default(grwmVideoInputsResolutionDefault),
  "script": GrwmScript,
  "stairs": zod.boolean().default(grwmVideoInputsStairsDefault),
  "stills": GrwmStills,
  "template": zod.enum(['grwm'])
}).describe('GRWM\'s "Generate video" (spec G14-grwm, PR C): the approved script, the stills, the\nproduct\'s picture (`packshot`: the brand product\'s picture or an upload, checked at the\nstart as any source) and name, the brand\'s product where it is one (the library\'s Product\nfilter), the locks the stills were drawn with, the clips\' resolution and whether the stairs\nbeat is re-shot. One tile.');

export type GrwmVideoInputs = zod.input<typeof GrwmVideoInputs>;
export type GrwmVideoInputsOutput = zod.output<typeof GrwmVideoInputs>;

export const GrwmDraft = zod.object({
  "example": GrwmScript,
  "inputs": GrwmInputs,
  "problem": zod.union([zod.string(),zod.null()]),
  "script": zod.union([GrwmScript,zod.null()]),
  "script_director": DirectorState,
  "script_problems": zod.array(zod.string()),
  "stage": DraftStage,
  "stills": zod.array(GrwmDraftStill),
  "updated_at": zod.iso.datetime({"offset":true}),
  "urls_expire_at": zod.union([zod.iso.datetime({"offset":true}),zod.null()]),
  "video": zod.union([GrwmVideoInputs,zod.null()]).exactOptional()
}).describe('A member\'s GRWM draft in the brand: the form, the stage, the script and its director, and\nthe stills. `script_problems`: what the kept script still has off, in our words (beyond the\nlimits Approve refuses, the entryway line naming none of the product\'s words); `problem`:\nwhy the director failed for good. `stills` is empty until the script is approved.');

export type GrwmDraft = zod.input<typeof GrwmDraft>;
export type GrwmDraftOutput = zod.output<typeof GrwmDraft>;

export const GrwmDraftWrite = zod.object({
  "inputs": GrwmInputs,
  "script": zod.union([GrwmScript,zod.null()]).exactOptional()
}).describe('`PUT .../templates/grwm/draft`: the form as it stands, its script as edited.');

export type GrwmDraftWrite = zod.input<typeof GrwmDraftWrite>;
export type GrwmDraftWriteOutput = zod.output<typeof GrwmDraftWrite>;

export const GrwmScriptAsk = zod.object({
  "inputs": GrwmPickedInputs
}).describe('`POST .../draft/script`: Generate script, on the form as it stands.');

export type GrwmScriptAsk = zod.input<typeof GrwmScriptAsk>;
export type GrwmScriptAskOutput = zod.output<typeof GrwmScriptAsk>;

export const HealthResponse = zod.object({
  "git_sha": zod.string(),
  "revision": zod.union([zod.string(),zod.null()]),
  "service": zod.string(),
  "status": zod.literal("ok").meta({ title: 'Status' })
}).describe('`GET /api/healthz`: which code is running (proposal 6.8). Touches no dependency.');

export type HealthResponse = zod.input<typeof HealthResponse>;
export type HealthResponseOutput = zod.output<typeof HealthResponse>;

export const HeroShotRatio = zod.enum(['9:16', '16:9', '1:1', '3:4', '4:3']);

export type HeroShotRatio = zod.input<typeof HeroShotRatio>;
export type HeroShotRatioOutput = zod.output<typeof HeroShotRatio>;

export const heroShotInputsAspectRatioDefault = '9:16';
export const heroShotInputsBriefMax = 60000;


export const heroShotInputsBriefRegExp = new RegExp('[^\\t\\n\\v\\f\\r \\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000\\ufeff]');
export const heroShotInputsCustomStyleDefault = ``;
export const heroShotInputsCustomStyleMax = 2000;

export const heroShotInputsStyleDefault = `director`;
export const heroShotInputsStyleMax = 40;


export const heroShotInputsStyleRegExp = new RegExp('^[a-z0-9]+(?:_[a-z0-9]+)*$');


export const HeroShotInputs = zod.object({
  "aspect_ratio": HeroShotRatio.default(heroShotInputsAspectRatioDefault),
  "brand_logo": zod.union([AssetRef,zod.null()]).exactOptional(),
  "brief": zod.string().min(1).max(heroShotInputsBriefMax).regex(heroShotInputsBriefRegExp),
  "custom_style": zod.string().max(heroShotInputsCustomStyleMax).default(heroShotInputsCustomStyleDefault),
  "packshot": TemplateSource,
  "product_id": zod.union([zod.uuid(),zod.null()]).exactOptional(),
  "style": zod.string().max(heroShotInputsStyleMax).regex(heroShotInputsStyleRegExp).default(heroShotInputsStyleDefault),
  "template": zod.enum(['product-hero-shot'])
}).describe('12 sec Product Hero Shot\'s form (live\'s `ProductHeroShotForm`): the product (the brand\'s,\nfor the library\'s filter; none for live\'s example), its packshot (the one picture picked of\nit), its brief (live\'s form sends the product\'s description), the brand\'s logo for the end\ncard where the member turns it on, the style (live\'s "Let the director decide", "Custom" with\nits text, or one of its presets, by key) and the ratio. One tile.');

export type HeroShotInputs = zod.input<typeof HeroShotInputs>;
export type HeroShotInputsOutput = zod.output<typeof HeroShotInputs>;

export const Hidden = zod.object({
  "hidden": zod.boolean()
}).describe('Whether the user hides their achievements: from themselves and from every team.');

export type Hidden = zod.input<typeof Hidden>;
export type HiddenOutput = zod.output<typeof Hidden>;

export const HiddenUpdate = zod.object({
  "hidden": zod.boolean()
}).describe('`PUT /v1/me/achievements/hidden`: Hide achievements, on or off.');

export type HiddenUpdate = zod.input<typeof HiddenUpdate>;
export type HiddenUpdateOutput = zod.output<typeof HiddenUpdate>;

export const HookId = zod.enum(['01', '02', '03', '04', '05', '06', '07', '08', '09']);

export type HookId = zod.input<typeof HookId>;
export type HookIdOutput = zod.output<typeof HookId>;

export const hooksInputsAspectRatioDefault = `9:16`;
export const hooksInputsAspectRatioMin = 3;
export const hooksInputsAspectRatioMax = 8;

export const hooksInputsDurationOneMax = 600;

export const hooksInputsHeldObjectDefault = `banana`;
export const hooksInputsHeldObjectMax = 40;

export const hooksInputsResolutionDefault = `720p`;
export const hooksInputsResolutionMax = 16;

export const hooksInputsScriptDefault = ``;
export const hooksInputsScriptMax = 80;



export const HooksInputs = zod.object({
  "actor": ReferenceSource,
  "aspect_ratio": zod.string().min(hooksInputsAspectRatioMin).max(hooksInputsAspectRatioMax).default(hooksInputsAspectRatioDefault),
  "duration": zod.union([zod.int().min(1).max(hooksInputsDurationOneMax),zod.null()]).exactOptional(),
  "held_object": zod.string().max(hooksInputsHeldObjectMax).default(hooksInputsHeldObjectDefault),
  "hooks": zod.array(HookId),
  "product": TemplateSource,
  "resolution": zod.string().min(1).max(hooksInputsResolutionMax).default(hooksInputsResolutionDefault),
  "script": zod.string().max(hooksInputsScriptMax).default(hooksInputsScriptDefault),
  "template": zod.enum(['hooks'])
}).describe('Hooks\' form (live\'s `HooksForm`): the AI Actor (`#Image1`: an actor, a global actor or a\nlibrary picture, as live\'s Add Actors offers them), the product\'s picture (`#Image2`, the one\npicked of the product), the hooks (1 to 9, one tile each, in live\'s order whatever the order\npicked), The Absurd Prop\'s object (live\'s "banana" by default), the line the actor says (empty:\neach hook\'s own), and the clip\'s length (none: each hook\'s own, live\'s Auto), resolution and\nratio, live\'s 720p and 9:16 by default.');

export type HooksInputs = zod.input<typeof HooksInputs>;
export type HooksInputsOutput = zod.output<typeof HooksInputs>;

export const IdempotencyConflictDetails = zod.object({
  "idempotency_key": zod.string()
}).describe('The key that was used before for a different request.');

export type IdempotencyConflictDetails = zod.input<typeof IdempotencyConflictDetails>;
export type IdempotencyConflictDetailsOutput = zod.output<typeof IdempotencyConflictDetails>;

export const imageActorQuoteExpectedQuoteMaxOneMin = 0;

export const imageActorQuoteModelMax = 64;


export const imageActorQuoteModelRegExp = new RegExp('^[a-z0-9][a-z0-9.-]*$');
export const imageActorQuoteOutputsDefault = 4;
export const imageActorQuoteOutputsMax = 4;

export const imageActorQuoteProductIdsMax = 4;

export const imageActorQuotePromptOneMax = 32000;

export const imageActorQuotePromptDefault = ``;
export const imageActorQuoteReferencesMax = 16;



export const ImageActorQuote = zod.object({
  "builder": zod.union([AiActorBuilder,zod.null()]).exactOptional(),
  "expected_quote_max": zod.union([zod.int().min(imageActorQuoteExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "gender": AiActorGender,
  "model": zod.string().max(imageActorQuoteModelMax).regex(imageActorQuoteModelRegExp).describe('A catalog model id.'),
  "outputs": zod.int().min(1).max(imageActorQuoteOutputsMax).default(imageActorQuoteOutputsDefault),
  "product_ids": zod.array(zod.uuid()).max(imageActorQuoteProductIdsMax).exactOptional(),
  "prompt": zod.union([zod.string().max(imageActorQuotePromptOneMax),zod.null()]).default(imageActorQuotePromptDefault),
  "references": zod.array(SourceRef).max(imageActorQuoteReferencesMax).exactOptional(),
  "type": zod.enum(['image.actor'])
}).describe('An `ImageActorRequest` to price, as live\'s estimate prices one before its prompt: the\nprompt may be empty, and with neither a prompt nor a builder it is priced as one.');

export type ImageActorQuote = zod.input<typeof ImageActorQuote>;
export type ImageActorQuoteOutput = zod.output<typeof ImageActorQuote>;

export const imageActorRequestExpectedQuoteMaxOneMin = 0;

export const imageActorRequestModelMax = 64;


export const imageActorRequestModelRegExp = new RegExp('^[a-z0-9][a-z0-9.-]*$');
export const imageActorRequestOutputsDefault = 4;
export const imageActorRequestOutputsMax = 4;

export const imageActorRequestProductIdsMax = 4;

export const imageActorRequestPromptOneMin = 10;
export const imageActorRequestPromptOneMax = 32000;


export const imageActorRequestPromptOneRegExp = new RegExp('[^\\t\\n\\v\\f\\r \\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000\\ufeff]');
export const imageActorRequestReferencesMax = 16;



export const ImageActorRequest = zod.object({
  "builder": zod.union([AiActorBuilder,zod.null()]).exactOptional(),
  "expected_quote_max": zod.union([zod.int().min(imageActorRequestExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "gender": AiActorGender,
  "model": zod.string().max(imageActorRequestModelMax).regex(imageActorRequestModelRegExp).describe('A catalog model id.'),
  "outputs": zod.int().min(1).max(imageActorRequestOutputsMax).default(imageActorRequestOutputsDefault),
  "product_ids": zod.array(zod.uuid()).max(imageActorRequestProductIdsMax).exactOptional(),
  "prompt": zod.union([zod.string().min(imageActorRequestPromptOneMin).max(imageActorRequestPromptOneMax).regex(imageActorRequestPromptOneRegExp),zod.null()]).exactOptional(),
  "references": zod.array(SourceRef).max(imageActorRequestReferencesMax).exactOptional(),
  "type": zod.enum(['image.actor'])
}).describe('Live\'s Generate With Text (`prompt`) or AI Actor Builder (`builder`): a portrait at 2:3,\none to four of them (four unless asked), with reference images as Generate With Text takes\nthem. Exactly one of `prompt` and `builder`.');

export type ImageActorRequest = zod.input<typeof ImageActorRequest>;
export type ImageActorRequestOutput = zod.output<typeof ImageActorRequest>;

export const imageAdvancedQuoteBrandLogoDefault = false;
export const imageAdvancedQuoteExpectedQuoteMaxOneMin = 0;

export const imageAdvancedQuoteFontsDefault = false;
export const imageAdvancedQuoteModelMax = 64;


export const imageAdvancedQuoteModelRegExp = new RegExp('^[a-z0-9][a-z0-9.-]*$');
export const imageAdvancedQuoteProductPicturesOneMax = 5;

export const imageAdvancedQuoteReferencesMax = 5;

export const imageAdvancedQuoteStyleOneMax = 5000;


export const imageAdvancedQuoteStyleOneRegExp = new RegExp('[^\\t\\n\\v\\f\\r \\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000\\ufeff]');


export const ImageAdvancedQuote = zod.object({
  "aspect_ratio": zod.union([zod.string(),zod.null()]).exactOptional(),
  "brand_logo": zod.boolean().default(imageAdvancedQuoteBrandLogoDefault),
  "expected_quote_max": zod.union([zod.int().min(imageAdvancedQuoteExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "fonts": zod.boolean().default(imageAdvancedQuoteFontsDefault),
  "model": zod.string().max(imageAdvancedQuoteModelMax).regex(imageAdvancedQuoteModelRegExp).describe('A catalog model id.'),
  "product": zod.union([AdProduct,zod.null()]).exactOptional(),
  "product_pictures": zod.union([zod.array(ExampleRef).min(1).max(imageAdvancedQuoteProductPicturesOneMax),zod.null()]).exactOptional(),
  "references": zod.array(AdReference).min(1).max(imageAdvancedQuoteReferencesMax),
  "style": zod.union([zod.string().min(1).max(imageAdvancedQuoteStyleOneMax).regex(imageAdvancedQuoteStyleOneRegExp),zod.null()]).exactOptional(),
  "type": zod.enum(['image.advanced'])
}).describe('An `ImageAdvancedRequest` to price: the same body, since it has no prompt.');

export type ImageAdvancedQuote = zod.input<typeof ImageAdvancedQuote>;
export type ImageAdvancedQuoteOutput = zod.output<typeof ImageAdvancedQuote>;

export const imageAdvancedRequestBrandLogoDefault = false;
export const imageAdvancedRequestExpectedQuoteMaxOneMin = 0;

export const imageAdvancedRequestFontsDefault = false;
export const imageAdvancedRequestModelMax = 64;


export const imageAdvancedRequestModelRegExp = new RegExp('^[a-z0-9][a-z0-9.-]*$');
export const imageAdvancedRequestProductPicturesOneMax = 5;

export const imageAdvancedRequestReferencesMax = 5;

export const imageAdvancedRequestStyleOneMax = 5000;


export const imageAdvancedRequestStyleOneRegExp = new RegExp('[^\\t\\n\\v\\f\\r \\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000\\ufeff]');


export const ImageAdvancedRequest = zod.object({
  "aspect_ratio": zod.union([zod.string(),zod.null()]).exactOptional(),
  "brand_logo": zod.boolean().default(imageAdvancedRequestBrandLogoDefault),
  "expected_quote_max": zod.union([zod.int().min(imageAdvancedRequestExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "fonts": zod.boolean().default(imageAdvancedRequestFontsDefault),
  "model": zod.string().max(imageAdvancedRequestModelMax).regex(imageAdvancedRequestModelRegExp).describe('A catalog model id.'),
  "product": zod.union([AdProduct,zod.null()]).exactOptional(),
  "product_pictures": zod.union([zod.array(ExampleRef).min(1).max(imageAdvancedRequestProductPicturesOneMax),zod.null()]).exactOptional(),
  "references": zod.array(AdReference).min(1).max(imageAdvancedRequestReferencesMax),
  "style": zod.union([zod.string().min(1).max(imageAdvancedRequestStyleOneMax).regex(imageAdvancedRequestStyleOneRegExp),zod.null()]).exactOptional(),
  "type": zod.enum(['image.advanced'])
}).describe('Ad creatives, live\'s image Advanced mode (G8, #217): for each reference image, or for the\nStyle alone, one image per combination of the chosen ad-copy values, at most 100 in all.\nNo prompt (the design comes from the inspiration or the Style) and no `outputs`: the\ncombinations are the outputs.');

export type ImageAdvancedRequest = zod.input<typeof ImageAdvancedRequest>;
export type ImageAdvancedRequestOutput = zod.output<typeof ImageAdvancedRequest>;

export const imageAnalysisQuoteExpectedQuoteMaxOneMin = 0;

export const imageAnalysisQuoteOutputsDefault = 1;
export const imageAnalysisQuoteOutputsMax = 1;



export const ImageAnalysisQuote = zod.object({
  "expected_quote_max": zod.union([zod.int().min(imageAnalysisQuoteExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "outputs": zod.int().min(1).max(imageAnalysisQuoteOutputsMax).default(imageAnalysisQuoteOutputsDefault),
  "source": TemplateSource,
  "type": zod.enum(['image.analysis'])
}).describe('An `ImageAnalysisRequest` to price: the same body, since it has no prompt.');

export type ImageAnalysisQuote = zod.input<typeof ImageAnalysisQuote>;
export type ImageAnalysisQuoteOutput = zod.output<typeof ImageAnalysisQuote>;

export const imageAnalysisRequestExpectedQuoteMaxOneMin = 0;

export const imageAnalysisRequestOutputsDefault = 1;
export const imageAnalysisRequestOutputsMax = 1;



export const ImageAnalysisRequest = zod.object({
  "expected_quote_max": zod.union([zod.int().min(imageAnalysisRequestExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "outputs": zod.int().min(1).max(imageAnalysisRequestOutputsMax).default(imageAnalysisRequestOutputsDefault),
  "source": TemplateSource,
  "type": zod.enum(['image.analysis'])
}).describe('An image\'s analysis (G8 PR 3a, live\'s inspiration extraction): the reference, a library\nimage or an earlier output, read into its ad structure, one JSON output. No prompt: live\'s\ninstructions are the type\'s. No model: the AI task `ad_copy.analysis` picks the row (spec\nG9-ai-tasks). The SPA starts it for a reference with no structure yet; another start reads it\nagain.');

export type ImageAnalysisRequest = zod.input<typeof ImageAnalysisRequest>;
export type ImageAnalysisRequestOutput = zod.output<typeof ImageAnalysisRequest>;

export const imageLayerEditQuoteExpectedQuoteMaxOneMin = 0;

export const imageLayerEditQuotePromptDefault = ``;
export const imageLayerEditQuotePromptMax = 4000;

export const imageLayerEditQuoteRemoveBackgroundDefault = false;

export const ImageLayerEditQuote = zod.object({
  "expected_quote_max": zod.union([zod.int().min(imageLayerEditQuoteExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "layerize_job_id": zod.uuid(),
  "prompt": zod.string().max(imageLayerEditQuotePromptMax).default(imageLayerEditQuotePromptDefault),
  "remove_background": zod.boolean().default(imageLayerEditQuoteRemoveBackgroundDefault),
  "source": SourceRef,
  "type": zod.enum(['image.layer_edit'])
}).describe('An `ImageLayerEditRequest` to price; its prompt may be empty (live prices the modal before\none is written).');

export type ImageLayerEditQuote = zod.input<typeof ImageLayerEditQuote>;
export type ImageLayerEditQuoteOutput = zod.output<typeof ImageLayerEditQuote>;

export const imageLayerEditRequestExpectedQuoteMaxOneMin = 0;

export const imageLayerEditRequestPromptMax = 4000;


export const imageLayerEditRequestPromptRegExp = new RegExp('[^\\t\\n\\v\\f\\r \\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000\\ufeff]');
export const imageLayerEditRequestRemoveBackgroundDefault = false;

export const ImageLayerEditRequest = zod.object({
  "expected_quote_max": zod.union([zod.int().min(imageLayerEditRequestExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "layerize_job_id": zod.uuid(),
  "prompt": zod.string().min(1).max(imageLayerEditRequestPromptMax).regex(imageLayerEditRequestPromptRegExp),
  "remove_background": zod.boolean().default(imageLayerEditRequestRemoveBackgroundDefault),
  "source": SourceRef,
  "type": zod.enum(['image.layer_edit'])
}).describe('Edit one layer of a Layerize with AI, live\'s layer editor\'s "Edit with AI" (G13b, #251):\n`source` the layer\'s picture (a layer of the Layerize, an earlier edit, a library picture, a\nproduct\'s photo or a delivered image of the brand), `layerize_job_id` the finished Layerize\nof the brand it is edited in, `prompt` what to change. No model: the AI task\n`layer_edit.image` picks the row (spec G9-ai-tasks). One image back, at the ratio nearest the\nsource\'s; `remove_background` cuts it out after the edit (live\'s, for a layer with\ntransparency).');

export type ImageLayerEditRequest = zod.input<typeof ImageLayerEditRequest>;
export type ImageLayerEditRequestOutput = zod.output<typeof ImageLayerEditRequest>;

export const imageLayerizeQuoteExpectedQuoteMaxOneMin = 0;

export const imageLayerizeQuoteModelMax = 64;


export const imageLayerizeQuoteModelRegExp = new RegExp('^[a-z0-9][a-z0-9.-]*$');
export const imageLayerizeQuoteProductIdsMax = 1;

export const imageLayerizeQuotePromptOneMax = 4000;



export const ImageLayerizeQuote = zod.object({
  "expected_quote_max": zod.union([zod.int().min(imageLayerizeQuoteExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "model": zod.string().max(imageLayerizeQuoteModelMax).regex(imageLayerizeQuoteModelRegExp).describe('A catalog model id.'),
  "product_ids": zod.array(zod.uuid()).max(imageLayerizeQuoteProductIdsMax).exactOptional(),
  "prompt": zod.union([zod.string().max(imageLayerizeQuotePromptOneMax),zod.null()]).exactOptional(),
  "source": SourceRef,
  "type": zod.enum(['image.layerize'])
}).describe('An `ImageLayerizeRequest` to price: the same body, its prompt optional already.');

export type ImageLayerizeQuote = zod.input<typeof ImageLayerizeQuote>;
export type ImageLayerizeQuoteOutput = zod.output<typeof ImageLayerizeQuote>;

export const imageLayerizeRequestExpectedQuoteMaxOneMin = 0;

export const imageLayerizeRequestModelMax = 64;


export const imageLayerizeRequestModelRegExp = new RegExp('^[a-z0-9][a-z0-9.-]*$');
export const imageLayerizeRequestProductIdsMax = 1;

export const imageLayerizeRequestPromptOneMax = 4000;



export const ImageLayerizeRequest = zod.object({
  "expected_quote_max": zod.union([zod.int().min(imageLayerizeRequestExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "model": zod.string().max(imageLayerizeRequestModelMax).regex(imageLayerizeRequestModelRegExp).describe('A catalog model id.'),
  "product_ids": zod.array(zod.uuid()).max(imageLayerizeRequestProductIdsMax).exactOptional(),
  "prompt": zod.union([zod.string().max(imageLayerizeRequestPromptOneMax),zod.null()]).exactOptional(),
  "source": SourceRef,
  "type": zod.enum(['image.layerize'])
}).describe('Split one picture into its layers, live\'s Layerize (G13, #251): the picture (an earlier\noutput, a library picture or a product\'s photo) and an optional prompt of what to\nseparate; 2 to 17 layers, each an output by its stacking order.');

export type ImageLayerizeRequest = zod.input<typeof ImageLayerizeRequest>;
export type ImageLayerizeRequestOutput = zod.output<typeof ImageLayerizeRequest>;

export const imageSimpleQuoteExpectedQuoteMaxOneMin = 0;

export const imageSimpleQuoteModelMax = 64;


export const imageSimpleQuoteModelRegExp = new RegExp('^[a-z0-9][a-z0-9.-]*$');
export const imageSimpleQuoteOutputsDefault = 1;
export const imageSimpleQuoteOutputsMax = 16;

export const imageSimpleQuotePromptDefault = ``;
export const imageSimpleQuotePromptMax = 32000;



export const ImageSimpleQuote = zod.object({
  "aspect_ratio": zod.union([zod.string(),zod.null()]).exactOptional(),
  "expected_quote_max": zod.union([zod.int().min(imageSimpleQuoteExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "model": zod.string().max(imageSimpleQuoteModelMax).regex(imageSimpleQuoteModelRegExp).describe('A catalog model id.'),
  "outputs": zod.int().min(1).max(imageSimpleQuoteOutputsMax).default(imageSimpleQuoteOutputsDefault),
  "prompt": zod.string().max(imageSimpleQuotePromptMax).default(imageSimpleQuotePromptDefault),
  "prompt_template_id": zod.union([zod.uuid(),zod.null()]).exactOptional(),
  "type": zod.enum(['image.simple'])
}).describe('An `ImageSimpleRequest` to price; its prompt may be empty.');

export type ImageSimpleQuote = zod.input<typeof ImageSimpleQuote>;
export type ImageSimpleQuoteOutput = zod.output<typeof ImageSimpleQuote>;

export const imageSimpleRequestExpectedQuoteMaxOneMin = 0;

export const imageSimpleRequestModelMax = 64;


export const imageSimpleRequestModelRegExp = new RegExp('^[a-z0-9][a-z0-9.-]*$');
export const imageSimpleRequestOutputsDefault = 1;
export const imageSimpleRequestOutputsMax = 16;

export const imageSimpleRequestPromptMax = 32000;


export const imageSimpleRequestPromptRegExp = new RegExp('[^\\t\\n\\v\\f\\r \\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000\\ufeff]');


export const ImageSimpleRequest = zod.object({
  "aspect_ratio": zod.union([zod.string(),zod.null()]).exactOptional(),
  "expected_quote_max": zod.union([zod.int().min(imageSimpleRequestExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "model": zod.string().max(imageSimpleRequestModelMax).regex(imageSimpleRequestModelRegExp).describe('A catalog model id.'),
  "outputs": zod.int().min(1).max(imageSimpleRequestOutputsMax).default(imageSimpleRequestOutputsDefault),
  "prompt": zod.string().min(1).max(imageSimpleRequestPromptMax).regex(imageSimpleRequestPromptRegExp),
  "prompt_template_id": zod.union([zod.uuid(),zod.null()]).exactOptional(),
  "type": zod.enum(['image.simple'])
}).describe('Text to image.');

export type ImageSimpleRequest = zod.input<typeof ImageSimpleRequest>;
export type ImageSimpleRequestOutput = zod.output<typeof ImageSimpleRequest>;

export const ResizePlatform = zod.enum(['meta', 'tiktok', 'google', 'youtube', 'x', 'pinterest', 'snapchat', 'linkedin']);

export type ResizePlatform = zod.input<typeof ResizePlatform>;
export type ResizePlatformOutput = zod.output<typeof ResizePlatform>;

export const resizeFormatsPlatformsMax = 8;

export const resizeFormatsRatiosItemRegExp = new RegExp('^[1-9][0-9]?:[1-9][0-9]?$');
export const resizeFormatsRatiosMax = 14;



export const ResizeFormats = zod.object({
  "platforms": zod.array(ResizePlatform).max(resizeFormatsPlatformsMax),
  "ratios": zod.array(zod.string().regex(resizeFormatsRatiosItemRegExp)).max(resizeFormatsRatiosMax)
}).describe('Live\'s format picker (`FormatSelection`): platform presets, or ratios picked by hand from\nthe model\'s own list ("Other", its 14), never both, as live\'s picker clears one for the\nother.');

export type ResizeFormats = zod.input<typeof ResizeFormats>;
export type ResizeFormatsOutput = zod.output<typeof ResizeFormats>;

export const InstantResizeInputs = zod.object({
  "formats": ResizeFormats,
  "image": TemplateSource,
  "template": zod.enum(['static-ad-instant-resize'])
}).describe('Static Ad Instant Resize\'s form (live\'s `StaticAdInstantResizeForm`): the finished ad\n("Pick the ad to resize") and its target formats. One tile a distinct ratio.');

export type InstantResizeInputs = zod.input<typeof InstantResizeInputs>;
export type InstantResizeInputsOutput = zod.output<typeof InstantResizeInputs>;

export const TranslationLanguage = zod.enum(['English', 'Spanish', 'French', 'German', 'Italian', 'Portuguese', 'Hindi', 'Japanese', 'Chinese', 'Korean']);

export type TranslationLanguage = zod.input<typeof TranslationLanguage>;
export type TranslationLanguageOutput = zod.output<typeof TranslationLanguage>;

export const translateLanguagesCustomMax = 50;

export const translateLanguagesSelectedMax = 10;



export const TranslateLanguages = zod.object({
  "custom": zod.string().max(translateLanguagesCustomMax),
  "selected": zod.array(TranslationLanguage).max(translateLanguagesSelectedMax)
}).describe('Live\'s language picker (`LanguageSelection`): the languages ticked from live\'s list, and\none typed under "Other" (empty for none): up to 11, as live\'s.');

export type TranslateLanguages = zod.input<typeof TranslateLanguages>;
export type TranslateLanguagesOutput = zod.output<typeof TranslateLanguages>;

export const TranslateImageInputs = zod.object({
  "image": TemplateSource,
  "languages": TranslateLanguages,
  "template": zod.enum(['translate-static-image'])
}).describe('Translate Static Image\'s form (live\'s `TranslateStaticImageForm`): the creative ("Pick\nthe creative to translate") and its target languages. One tile a language.');

export type TranslateImageInputs = zod.input<typeof TranslateImageInputs>;
export type TranslateImageInputsOutput = zod.output<typeof TranslateImageInputs>;

export const sceneVariationsInputsCountDefault = 5;
export const sceneVariationsInputsCountMax = 10;



export const SceneVariationsInputs = zod.object({
  "count": zod.int().min(1).max(sceneVariationsInputsCountMax).default(sceneVariationsInputsCountDefault),
  "image": TemplateSource,
  "template": zod.enum(['product-scene-variations'])
}).describe('Product Scene Variations\' form (live\'s `ProductSceneVariationsForm`): the product picture\n("Pick the product image to re-stage") and how many variations (live\'s 1 to 10, 5 by\ndefault). One tile a variation.');

export type SceneVariationsInputs = zod.input<typeof SceneVariationsInputs>;
export type SceneVariationsInputsOutput = zod.output<typeof SceneVariationsInputs>;

export const staticAdProductImageIdsMax = 5;



export const StaticAdProduct = zod.object({
  "image_ids": zod.array(zod.uuid()).min(1).max(staticAdProductImageIdsMax),
  "product_id": zod.uuid()
}).describe('The product the ads are for (live\'s product select) and its pictures the ads show (live\nsends the main one, `getMainProductImage`): the team\'s product and its own images.');

export type StaticAdProduct = zod.input<typeof StaticAdProduct>;
export type StaticAdProductOutput = zod.output<typeof StaticAdProduct>;

export const productPricingCurrentOfferOneMax = 500;

export const productPricingPriceOneMax = 50;



export const ProductPricing = zod.object({
  "current_offer": zod.union([zod.string().max(productPricingCurrentOfferOneMax),zod.null()]).exactOptional(),
  "price": zod.union([zod.string().max(productPricingPriceOneMax),zod.null()]).exactOptional()
}).describe('A product\'s price and offer as live\'s `ProductData` gives them (`pricing_and_offers`).');

export type ProductPricing = zod.input<typeof ProductPricing>;
export type ProductPricingOutput = zod.output<typeof ProductPricing>;

export const productDataBrandNameMax = 200;

export const productDataDescriptionMax = 5000;

export const productDataKeyBenefitsOneMax = 20;

export const productDataProductNameMax = 200;

export const productDataTaglineOneMax = 500;

export const productDataUseCasesOneMax = 20;



export const ProductData = zod.object({
  "brand_name": zod.string().min(1).max(productDataBrandNameMax),
  "description": zod.string().min(1).max(productDataDescriptionMax),
  "key_benefits": zod.union([zod.array(zod.string()).max(productDataKeyBenefitsOneMax),zod.null()]).exactOptional(),
  "pricing_and_offers": zod.union([ProductPricing,zod.null()]).exactOptional(),
  "product_name": zod.string().min(1).max(productDataProductNameMax),
  "tagline": zod.union([zod.string().max(productDataTaglineOneMax),zod.null()]).exactOptional(),
  "use_cases": zod.union([zod.array(zod.string()).max(productDataUseCasesOneMax),zod.null()]).exactOptional()
}).describe('A product spelled out as data, with no row anywhere: live\'s `ProductData`, field for\nfield, as its Static Ad Generation example gives its product (`PRODUCT_SOURCES.EXAMPLE`, the\nad copy step\'s `product_data`, #749). A run takes only its card\'s own example product: its\nstart refuses any other (the recipe\'s `prepare`), and a step\'s field is refused publicly.');

export type ProductData = zod.input<typeof ProductData>;
export type ProductDataOutput = zod.output<typeof ProductData>;

export const StaticAdExampleProduct = zod.object({
  "data": ProductData,
  "image": ExampleRef
}).describe('Live\'s example product (its `exampleProductSchema`): the product as data, which the ad\ncopy reads, and its one picture, which the ad shows (live\'s `product_image_urls`), the\ncard\'s own example input. A run\'s start takes the card\'s own example product alone, equal\nto the catalog\'s (#749): a client cannot spell out a product of its own.');

export type StaticAdExampleProduct = zod.input<typeof StaticAdExampleProduct>;
export type StaticAdExampleProductOutput = zod.output<typeof StaticAdExampleProduct>;

export const staticAdInputsAspectRatioMin = 3;
export const staticAdInputsAspectRatioMax = 8;

export const staticAdInputsInspirationsMax = 5;

export const staticAdInputsModelMax = 64;


export const staticAdInputsModelRegExp = new RegExp('^[a-z0-9][a-z0-9.-]*$');


export const StaticAdInputs = zod.object({
  "aspect_ratio": zod.string().min(staticAdInputsAspectRatioMin).max(staticAdInputsAspectRatioMax),
  "inspirations": zod.array(TemplateSource).min(1).max(staticAdInputsInspirationsMax),
  "model": zod.string().max(staticAdInputsModelMax).regex(staticAdInputsModelRegExp).describe('A catalog model id.'),
  "product": zod.union([StaticAdProduct,StaticAdExampleProduct]),
  "template": zod.enum(['static-ad-generation'])
}).describe('Static Ad Generation\'s form (live\'s `StaticAdGenerationForm`): the inspirations (live\'s\nMeta Ad Library picks; ours the brand\'s library images until the ads area, decision 10), the\nproduct, and the image model and ratio the ads are rendered with. One tile an inspiration.');

export type StaticAdInputs = zod.input<typeof StaticAdInputs>;
export type StaticAdInputsOutput = zod.output<typeof StaticAdInputs>;

export const ImageTemplateInputs = zod.union([BackgroundSwapInputs,InstantResizeInputs,TranslateImageInputs,SceneVariationsInputs,StaticAdInputs]);

export type ImageTemplateInputs = zod.input<typeof ImageTemplateInputs>;
export type ImageTemplateInputsOutput = zod.output<typeof ImageTemplateInputs>;

export const imageTemplateQuoteExpectedQuoteMaxOneMin = 0;

export const imageTemplateQuoteModelOneMax = 64;


export const imageTemplateQuoteModelOneRegExp = new RegExp('^[a-z0-9][a-z0-9.-]*$');


export const ImageTemplateQuote = zod.object({
  "expected_quote_max": zod.union([zod.int().min(imageTemplateQuoteExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "inputs": ImageTemplateInputs,
  "model": zod.union([zod.string().max(imageTemplateQuoteModelOneMax).regex(imageTemplateQuoteModelOneRegExp),zod.null()]).exactOptional().describe('A catalog model id.'),
  "type": zod.enum(['image.template'])
}).describe('An `ImageTemplateRequest` to price: nothing, as each step holds its own price at its\nstart, as live charges each step.');

export type ImageTemplateQuote = zod.input<typeof ImageTemplateQuote>;
export type ImageTemplateQuoteOutput = zod.output<typeof ImageTemplateQuote>;

export const imageTemplateRequestExpectedQuoteMaxOneMin = 0;

export const imageTemplateRequestModelOneMax = 64;


export const imageTemplateRequestModelOneRegExp = new RegExp('^[a-z0-9][a-z0-9.-]*$');


export const ImageTemplateRequest = zod.object({
  "expected_quote_max": zod.union([zod.int().min(imageTemplateRequestExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "inputs": ImageTemplateInputs,
  "model": zod.union([zod.string().max(imageTemplateRequestModelOneMax).regex(imageTemplateRequestModelOneRegExp),zod.null()]).exactOptional().describe('A catalog model id.'),
  "type": zod.enum(['image.template'])
}).describe('One Generate of a picture template\'s form: its inputs, by their `template` (the catalog\'s\nid). As many pictures as the inputs make tiles (`slots()`), at most 14. No prompt and no\nmodel: each step\'s model is the recipe\'s, as live\'s forms fix theirs.');

export type ImageTemplateRequest = zod.input<typeof ImageTemplateRequest>;
export type ImageTemplateRequestOutput = zod.output<typeof ImageTemplateRequest>;

export const imageTweakQuoteExpectedQuoteMaxOneMin = 0;

export const imageTweakQuoteModelMax = 64;


export const imageTweakQuoteModelRegExp = new RegExp('^[a-z0-9][a-z0-9.-]*$');
export const imageTweakQuoteOutputsDefault = 1;
export const imageTweakQuoteOutputsMax = 16;

export const imageTweakQuoteProductIdsMax = 16;

export const imageTweakQuotePromptDefault = ``;
export const imageTweakQuotePromptMax = 32000;

export const imageTweakQuoteReferencesMax = 16;



export const ImageTweakQuote = zod.object({
  "aspect_ratio": zod.union([zod.string(),zod.null()]).exactOptional(),
  "edit": zod.union([zod.literal("tweak"),zod.null()]).exactOptional(),
  "expected_quote_max": zod.union([zod.int().min(imageTweakQuoteExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "model": zod.string().max(imageTweakQuoteModelMax).regex(imageTweakQuoteModelRegExp).describe('A catalog model id.'),
  "outputs": zod.int().min(1).max(imageTweakQuoteOutputsMax).default(imageTweakQuoteOutputsDefault),
  "product_ids": zod.array(zod.uuid()).max(imageTweakQuoteProductIdsMax).exactOptional(),
  "prompt": zod.string().max(imageTweakQuotePromptMax).default(imageTweakQuotePromptDefault),
  "prompt_template_id": zod.union([zod.uuid(),zod.null()]).exactOptional(),
  "references": zod.array(ReferenceSource).min(1).max(imageTweakQuoteReferencesMax),
  "type": zod.enum(['image.tweak'])
}).describe('An `ImageTweakRequest` to price; its prompt may be empty.');

export type ImageTweakQuote = zod.input<typeof ImageTweakQuote>;
export type ImageTweakQuoteOutput = zod.output<typeof ImageTweakQuote>;

export const imageTweakRequestExpectedQuoteMaxOneMin = 0;

export const imageTweakRequestModelMax = 64;


export const imageTweakRequestModelRegExp = new RegExp('^[a-z0-9][a-z0-9.-]*$');
export const imageTweakRequestOutputsDefault = 1;
export const imageTweakRequestOutputsMax = 16;

export const imageTweakRequestProductIdsMax = 16;

export const imageTweakRequestPromptMax = 32000;


export const imageTweakRequestPromptRegExp = new RegExp('[^\\t\\n\\v\\f\\r \\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000\\ufeff]');
export const imageTweakRequestReferencesMax = 16;



export const ImageTweakRequest = zod.object({
  "aspect_ratio": zod.union([zod.string(),zod.null()]).exactOptional(),
  "edit": zod.union([zod.literal("tweak"),zod.null()]).exactOptional(),
  "expected_quote_max": zod.union([zod.int().min(imageTweakRequestExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "model": zod.string().max(imageTweakRequestModelMax).regex(imageTweakRequestModelRegExp).describe('A catalog model id.'),
  "outputs": zod.int().min(1).max(imageTweakRequestOutputsMax).default(imageTweakRequestOutputsDefault),
  "product_ids": zod.array(zod.uuid()).max(imageTweakRequestProductIdsMax).exactOptional(),
  "prompt": zod.string().min(1).max(imageTweakRequestPromptMax).regex(imageTweakRequestPromptRegExp),
  "prompt_template_id": zod.union([zod.uuid(),zod.null()]).exactOptional(),
  "references": zod.array(ReferenceSource).min(1).max(imageTweakRequestReferencesMax),
  "type": zod.enum(['image.tweak'])
}).describe('An image from one or more reference images (earlier outputs or library images), as the\nprompt says: live\'s image to image. Without an aspect ratio, keep the first\'s.');

export type ImageTweakRequest = zod.input<typeof ImageTweakRequest>;
export type ImageTweakRequestOutput = zod.output<typeof ImageTweakRequest>;

export const ImportMime = zod.enum(['image/jpeg', 'image/png', 'image/webp']).describe('The picture types an import keeps (D9): the library\'s images.');

export type ImportMime = zod.input<typeof ImportMime>;
export type ImportMimeOutput = zod.output<typeof ImportMime>;

export const ImportedGeneration = zod.object({
  "ad_specification": zod.union([AdSpecification,zod.null()]),
  "aspect_ratio": zod.union([zod.string(),zod.null()]),
  "asset_id": zod.uuid(),
  "generation_type": zod.union([zod.string(),zod.null()]),
  "prompt": zod.union([zod.string(),zod.null()])
}).describe('`GET .../imported-generations/{asset_id}`: how another product made a library file a brand\nimport brought in as a generation (live\'s, #828 bug 14\'s follow-up), as ⓘ and Clone read a\njob\'s: live\'s prompt, the picture\'s aspect ratio, live\'s kind of generation (`SIMPLE`,\n`ADCOPY`), and an Advanced image\'s specification. 404 for a file with none.');

export type ImportedGeneration = zod.input<typeof ImportedGeneration>;
export type ImportedGenerationOutput = zod.output<typeof ImportedGeneration>;

export const InsufficientCreditsDetails = zod.object({
  "available": zod.int(),
  "required": zod.int()
}).describe('What the action needs and what the team has available (D5: a hard stop at zero).');

export type InsufficientCreditsDetails = zod.input<typeof InsufficientCreditsDetails>;
export type InsufficientCreditsDetailsOutput = zod.output<typeof InsufficientCreditsDetails>;

export const Invitation = zod.object({
  "created_at": zod.iso.datetime({"offset":true}),
  "email": zod.string(),
  "expired": zod.boolean(),
  "expires_at": zod.iso.datetime({"offset":true}),
  "id": zod.uuid(),
  "invited_by": zod.uuid(),
  "role": TeamRole
}).describe('A pending invitation. Never its token or the token\'s hash: the token is only in the email.');

export type Invitation = zod.input<typeof Invitation>;
export type InvitationOutput = zod.output<typeof Invitation>;

export const invitationAcceptTokenRegExp = new RegExp('^cai_inv_[A-Za-z0-9_-]{43}$');


export const InvitationAccept = zod.object({
  "token": zod.string().regex(invitationAcceptTokenRegExp)
}).describe('`POST /v1/me/invitations/accept`: the token from the email link.');

export type InvitationAccept = zod.input<typeof InvitationAccept>;
export type InvitationAcceptOutput = zod.output<typeof InvitationAccept>;

export const InvitationAccepted = zod.object({
  "role": TeamRole,
  "team_id": zod.uuid()
});

export type InvitationAccepted = zod.input<typeof InvitationAccepted>;
export type InvitationAcceptedOutput = zod.output<typeof InvitationAccepted>;

export const invitationCreateEmailMin = 3;
export const invitationCreateEmailMax = 320;


export const invitationCreateEmailRegExp = new RegExp('^[a-zA-Z0-9.!#$%&\'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?)+$');


export const InvitationCreate = zod.object({
  "email": zod.string().min(invitationCreateEmailMin).max(invitationCreateEmailMax).regex(invitationCreateEmailRegExp),
  "role": TeamRole
}).describe('`POST .../invitations`: who to invite, with a role within the inviter\'s ceiling.');

export type InvitationCreate = zod.input<typeof InvitationCreate>;
export type InvitationCreateOutput = zod.output<typeof InvitationCreate>;

export const InvitationForYou = zod.object({
  "expires_at": zod.iso.datetime({"offset":true}),
  "id": zod.uuid(),
  "invited_by_name": zod.union([zod.string(),zod.null()]),
  "role": TeamRole,
  "team_id": zod.uuid(),
  "team_name": zod.string()
}).describe('`GET /v1/me/invitations`: a pending, unexpired invitation to the caller\'s verified email,\nas "Invitations for you" shows it (spec A2, 2026-10-18). The team\'s name and the inviter\'s\n(null once their account is gone); never the token or its hash.');

export type InvitationForYou = zod.input<typeof InvitationForYou>;
export type InvitationForYouOutput = zod.output<typeof InvitationForYou>;

export const lipsyncSettingsSyncModeOneRegExp = new RegExp('^[a-z_]{1,32}$');


export const LipsyncSettings = zod.object({
  "auto_detect": zod.union([zod.boolean(),zod.null()]).exactOptional(),
  "sync_mode": zod.union([zod.string().regex(lipsyncSettingsSyncModeOneRegExp),zod.null()]).exactOptional()
}).describe('Lip-Sync\'s choices (live\'s `syncMode`, `autoDetect`): left out, the model\'s default mode\nand the speaker detected, as live\'s form sends them.');

export type LipsyncSettings = zod.input<typeof LipsyncSettings>;
export type LipsyncSettingsOutput = zod.output<typeof LipsyncSettings>;

export const ScriptTool = zod.enum(['talking_head', 'audio_generation', 'lip_sync', 'templates']).describe('The tool a script is for, live\'s `ScriptGenerationType` (#224): kept with the job as live\nkeeps it, never sent to the model.');

export type ScriptTool = zod.input<typeof ScriptTool>;
export type ScriptToolOutput = zod.output<typeof ScriptTool>;

export const ScriptParams = zod.object({
  "product_id": zod.union([zod.uuid(),zod.null()]).exactOptional(),
  "tool": ScriptTool
}).describe('A script job\'s ask beyond its `prompt` (the brief, or the script to enhance): the tool it\nis for, and the product a script names (#224).');

export type ScriptParams = zod.input<typeof ScriptParams>;
export type ScriptParamsOutput = zod.output<typeof ScriptParams>;

export const shotDurationSecondsMax = 600;

export const shotPromptDefault = ``;
export const shotPromptMax = 50000;



export const Shot = zod.object({
  "duration_seconds": zod.int().min(1).max(shotDurationSecondsMax),
  "prompt": zod.string().max(shotPromptMax).default(shotPromptDefault)
}).describe('One shot of a multi-shot video: its prompt and its length. A quote may leave the prompt\nempty; a start needs it (spec G6-studio-api, section 4).');

export type Shot = zod.input<typeof Shot>;
export type ShotOutput = zod.output<typeof Shot>;

export const TalkingHeadParams = zod.object({
  "actor": ActorSource,
  "group": zod.union([zod.uuid(),zod.null()]).exactOptional(),
  "source_audio": SourceRef
}).describe('A talking head\'s actor and the audio it speaks, as the request named them, and the\nclient\'s group (#222).');

export type TalkingHeadParams = zod.input<typeof TalkingHeadParams>;
export type TalkingHeadParamsOutput = zod.output<typeof TalkingHeadParams>;

export const TalkingHeadAdvancedParams = zod.object({
  "actor": ReferenceSource,
  "aspect_ratio": zod.string(),
  "group": zod.union([zod.uuid(),zod.null()]).exactOptional(),
  "product_id": zod.union([zod.uuid(),zod.null()]).exactOptional(),
  "resolution": zod.union([zod.string(),zod.null()]).exactOptional(),
  "script": zod.string(),
  "vibe": zod.string(),
  "video_model": zod.string(),
  "voice_id": zod.uuid()
}).describe('An Advanced talking head\'s actor, voice, script, vibe and product, as the request named\nthem, and the client\'s group (#223). A template\'s step may name its card\'s example portrait\n(Promote Your Product\'s "Reuse example", #749).');

export type TalkingHeadAdvancedParams = zod.input<typeof TalkingHeadAdvancedParams>;
export type TalkingHeadAdvancedParamsOutput = zod.output<typeof TalkingHeadAdvancedParams>;

export const VideoCaptionPosition = zod.enum(['top', 'center', 'bottom']).describe('The third of the frame the captions sit in (live\'s `position`).');

export type VideoCaptionPosition = zod.input<typeof VideoCaptionPosition>;
export type VideoCaptionPositionOutput = zod.output<typeof VideoCaptionPosition>;

export const promoteExampleProductDescriptionMax = 5000;

export const promoteExampleProductNameMax = 200;



export const PromoteExampleProduct = zod.object({
  "description": zod.string().min(1).max(promoteExampleProductDescriptionMax),
  "image": ExampleRef,
  "name": zod.string().min(1).max(promoteExampleProductNameMax)
}).describe('Promote Your Product\'s example product (live\'s `exampleProductSchema`, #749): its name, the\ndescription its shot list and keyframes read in place of a product row, and its main\npicture, the card\'s own example input, which its keyframes and clips show. A run\'s start\ntakes the card\'s own example product alone, equal to the catalog\'s: a client cannot spell\nout a product of its own.');

export type PromoteExampleProduct = zod.input<typeof PromoteExampleProduct>;
export type PromoteExampleProductOutput = zod.output<typeof PromoteExampleProduct>;

export const promoteYourProductInputsActorDescriptionOneMax = 10000;

export const promoteYourProductInputsCaptionPositionDefault = 'bottom';
export const promoteYourProductInputsCaptionStyleDefault = `bold-cinematic`;
export const promoteYourProductInputsCaptionStyleMax = 40;


export const promoteYourProductInputsCaptionStyleRegExp = new RegExp('^[a-z][a-z0-9-]*$');
export const promoteYourProductInputsDirectionMax = 2000;


export const promoteYourProductInputsDirectionRegExp = new RegExp('[^\\t\\n\\v\\f\\r \\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000\\ufeff]');
export const promoteYourProductInputsScriptMin = 10;
export const promoteYourProductInputsScriptMax = 10000;


export const promoteYourProductInputsScriptRegExp = new RegExp('[^\\t\\n\\v\\f\\r \\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000\\ufeff]');
export const promoteYourProductInputsSubtitlesDefault = true;

export const PromoteYourProductInputs = zod.object({
  "actor": ReferenceSource,
  "actor_description": zod.union([zod.string().min(1).max(promoteYourProductInputsActorDescriptionOneMax),zod.null()]).exactOptional(),
  "caption_position": VideoCaptionPosition.default(promoteYourProductInputsCaptionPositionDefault),
  "caption_style": zod.string().max(promoteYourProductInputsCaptionStyleMax).regex(promoteYourProductInputsCaptionStyleRegExp).default(promoteYourProductInputsCaptionStyleDefault),
  "direction": zod.string().min(1).max(promoteYourProductInputsDirectionMax).regex(promoteYourProductInputsDirectionRegExp),
  "product": zod.union([PromoteExampleProduct,zod.null()]).exactOptional(),
  "product_id": zod.union([zod.uuid(),zod.null()]).exactOptional(),
  "script": zod.string().min(promoteYourProductInputsScriptMin).max(promoteYourProductInputsScriptMax).regex(promoteYourProductInputsScriptRegExp),
  "subtitles": zod.boolean().default(promoteYourProductInputsSubtitlesDefault),
  "template": zod.enum(['promote-your-product']),
  "voice_id": zod.uuid()
}).describe('Promote Your Product\'s form (live\'s library view): the AI Actor ("Add an AI Actor"), the\nvoice it speaks with ("Select a voice"), the direction ("Describe the direction of the\nvideo"), the script ("Write or generate a script"), the product (optional, one of the\nbrand\'s: without one the video shows none), and the subtitles: on by default, in one of\nlive\'s caption styles (Bold cinematic by default) at the top, the centre or the bottom\n(the bottom by default). One tile. Its "Reuse example" (#749) names the card\'s example\nportrait with its written description (`actor_description`, live\'s `ACTOR_ORIGINS.EXAMPLE`)\nand its example product (`product`, live\'s `PRODUCT_SOURCES.EXAMPLE`).');

export type PromoteYourProductInputs = zod.input<typeof PromoteYourProductInputs>;
export type PromoteYourProductInputsOutput = zod.output<typeof PromoteYourProductInputs>;

export const PersonalCloneInputs = zod.object({
  "actor": SourceRef,
  "audio": SourceRef,
  "template": zod.enum(['your-personal-clone'])
}).describe('Your Personal Clone\'s form (live\'s library view): the actor\'s portrait ("Upload an actor\nimage": a picture uploaded to the library, or of it), and its voiceover, made before the run\nby the form\'s Generate Audio ("Generate the audio first"): the voice reading the script, a\nspeech of the brand\'s. One tile: the portrait speaking it.');

export type PersonalCloneInputs = zod.input<typeof PersonalCloneInputs>;
export type PersonalCloneInputsOutput = zod.output<typeof PersonalCloneInputs>;

export const OverlayPosition = zod.enum(['top-left', 'top-center', 'top-right', 'middle-left', 'center', 'middle-right', 'bottom-left', 'bottom-center', 'bottom-right']).describe('Where the cut-out sits on the base: live\'s 9 places, its form\'s values (Talking Head\nOverlay\'s `overlay-positions.ts`), each a cell of a 3 by 3 grid.');

export type OverlayPosition = zod.input<typeof OverlayPosition>;
export type OverlayPositionOutput = zod.output<typeof OverlayPosition>;

export const OverlayVoiceSource = zod.enum(['script', 'base_video_audio']).describe('Where Talking Head Overlay\'s head gets its speech (live\'s `VOICE_SOURCE_MODE`): a voice\nreading a script (its voiceover made before the run), or the base video\'s own sound.');

export type OverlayVoiceSource = zod.input<typeof OverlayVoiceSource>;
export type OverlayVoiceSourceOutput = zod.output<typeof OverlayVoiceSource>;

export const talkingHeadOverlayInputsPositionDefault = 'bottom-right';
export const talkingHeadOverlayInputsVoiceSourceDefault = 'script';

export const TalkingHeadOverlayInputs = zod.object({
  "actor": ActorSource,
  "audio": zod.union([SourceRef,zod.null()]).exactOptional(),
  "base_video": SourceRef,
  "position": OverlayPosition.default(talkingHeadOverlayInputsPositionDefault),
  "template": zod.enum(['talking-head-overlay']),
  "voice_source": OverlayVoiceSource.default(talkingHeadOverlayInputsVoiceSourceDefault)
}).describe('Talking Head Overlay\'s form (live\'s library view): the base video ("Add a base video"),\nthe AI Actor ("Add an AI Actor": a global or team actor, or a picture), where its speech\ncomes from (live\'s Voice source: Script, the default, with its voiceover made before the run\nby Generate Audio, "Generate the audio first"; or Base video audio, with none), and its\nplace, one of live\'s 9 cells (the bottom right by default). One tile: the actor speaking,\ncut out, over the base.');

export type TalkingHeadOverlayInputs = zod.input<typeof TalkingHeadOverlayInputs>;
export type TalkingHeadOverlayInputsOutput = zod.output<typeof TalkingHeadOverlayInputs>;

export const languageChangerInputsCaptionPositionDefault = 'bottom';
export const languageChangerInputsCaptionStyleDefault = `bold-cinematic`;
export const languageChangerInputsCaptionStyleMax = 40;


export const languageChangerInputsCaptionStyleRegExp = new RegExp('^[a-z][a-z0-9-]*$');
export const languageChangerInputsLipSyncDefault = true;
export const languageChangerInputsSubtitlesDefault = true;
export const languageChangerInputsSyncModeOneRegExp = new RegExp('^[a-z_]{1,32}$');


export const LanguageChangerInputs = zod.object({
  "caption_position": VideoCaptionPosition.default(languageChangerInputsCaptionPositionDefault),
  "caption_style": zod.string().max(languageChangerInputsCaptionStyleMax).regex(languageChangerInputsCaptionStyleRegExp).default(languageChangerInputsCaptionStyleDefault),
  "languages": zod.array(DubLanguage),
  "lip_sync": zod.boolean().default(languageChangerInputsLipSyncDefault),
  "subtitles": zod.boolean().default(languageChangerInputsSubtitlesDefault),
  "sync_mode": zod.union([zod.string().regex(languageChangerInputsSyncModeOneRegExp),zod.null()]).exactOptional(),
  "template": zod.enum(['language-changer']),
  "video": TemplateSource
}).describe('Language Changer\'s form (live\'s `languageChangerSchema`): the clip to translate ("Pick the\nvideo to translate"); the languages to dub it into, the dubbing model\'s codes in pick order,\n1 to 5, one tile each; live\'s Lip Sync Mode, on by default, and its sync mode (None: the\nlip-sync model\'s default, live\'s \'\'); and the subtitles, on by default, their position\n(bottom) and caption style (one a picker offers, Bold cinematic by default, live\'s \'\').');

export type LanguageChangerInputs = zod.input<typeof LanguageChangerInputs>;
export type LanguageChangerInputsOutput = zod.output<typeof LanguageChangerInputs>;

export const PodcastSpeaker = zod.enum(['HOST', 'GUEST']);

export type PodcastSpeaker = zod.input<typeof PodcastSpeaker>;
export type PodcastSpeakerOutput = zod.output<typeof PodcastSpeaker>;

export const scriptLineBeatMax = 40;

export const scriptLineClaimIdsMax = 60;

export const scriptLineTextMax = 2000;



export const ScriptLine = zod.object({
  "beat": zod.string().max(scriptLineBeatMax),
  "claim_ids": zod.array(zod.string()).max(scriptLineClaimIdsMax),
  "id": zod.int(),
  "speaker": PodcastSpeaker,
  "text": zod.string().max(scriptLineTextMax)
}).describe('One line, one clip: its number, beat, speaker, words and the claims it states.');

export type ScriptLine = zod.input<typeof ScriptLine>;
export type ScriptLineOutput = zod.output<typeof ScriptLine>;

export const podcastScriptClaimsMax = 60;

export const podcastScriptLinesMax = 60;

export const podcastScriptMechanismMax = 2000;

export const podcastScriptPronunciationsMax = 60;

export const podcastScriptTopicMax = 2000;



export const PodcastScript = zod.object({
  "claims": zod.array(ScriptClaim).max(podcastScriptClaimsMax),
  "end_card": EndCard,
  "estimated_duration_s": zod.number(),
  "length_s": zod.int(),
  "lines": zod.array(ScriptLine).min(1).max(podcastScriptLinesMax),
  "mechanism": zod.string().max(podcastScriptMechanismMax),
  "pronunciations": zod.array(Pronunciation).max(podcastScriptPronunciationsMax),
  "topic": zod.string().max(podcastScriptTopicMax),
  "word_count": zod.int()
}).describe('Live\'s podcast script (`podcastScriptSchema`): the script director\'s answer, edited in the\nform before approval. A number is a JSON number, as live\'s zod reads it; the length and the\nword count are whole, as live\'s director schema has them (`integer`), kept as integers.');

export type PodcastScript = zod.input<typeof PodcastScript>;
export type PodcastScriptOutput = zod.output<typeof PodcastScript>;

export const ShotCast = zod.object({
  "guest": CastPerson,
  "host": CastPerson
});

export type ShotCast = zod.input<typeof ShotCast>;
export type ShotCastOutput = zod.output<typeof ShotCast>;

export const ProductState = zod.enum(['on_table', 'lift', 'in_hand']);

export type ProductState = zod.input<typeof ProductState>;
export type ProductStateOutput = zod.output<typeof ProductState>;

export const shotClipActionsItemMax = 2000;

export const shotClipActionsMax = 60;

export const shotClipIdMax = 40;

export const shotClipPerformanceVibeMax = 2000;

export const shotClipPreparedLineMax = 2000;

export const shotClipSceneMax = 2000;



export const ShotClip = zod.object({
  "actions": zod.array(zod.string().max(shotClipActionsItemMax)).min(1).max(shotClipActionsMax),
  "camera": CameraName,
  "end_still": zod.union([zod.literal("guest_hold"),zod.null()]),
  "has_letter_groups": zod.boolean(),
  "id": zod.string().max(shotClipIdMax),
  "is_last": zod.boolean(),
  "line_id": zod.int(),
  "performance_vibe": zod.string().max(shotClipPerformanceVibeMax),
  "prepared_line": zod.string().min(1).max(shotClipPreparedLineMax),
  "product_state": ProductState,
  "scene": zod.string().max(shotClipSceneMax),
  "speaker": PodcastSpeaker,
  "start_still": zod.enum(['master', 'host_close', 'guest_close', 'guest_hold'])
}).describe('One line\'s clip (live\'s `clipSchema`): the line it speaks, its camera, the stills it\nstarts and ends on, the product\'s state, the line as the video model is to say it, and its\nscene, vibe and actions.');

export type ShotClip = zod.input<typeof ShotClip>;
export type ShotClipOutput = zod.output<typeof ShotClip>;

export const shotProductLabelKeyWordsMax = 2000;

export const shotProductPackTypeMax = 2000;

export const shotProductProductLockMax = 8000;

export const shotProductSizeLineMax = 2000;



export const ShotProduct = zod.object({
  "label_key_words": zod.string().max(shotProductLabelKeyWordsMax),
  "pack_type": zod.string().min(1).max(shotProductPackTypeMax),
  "product_lock": zod.string().min(1).max(shotProductProductLockMax),
  "size_line": zod.string().max(shotProductSizeLineMax)
}).describe('The product as every still and clip names it (live\'s `product`).');

export type ShotProduct = zod.input<typeof ShotProduct>;
export type ShotProductOutput = zod.output<typeof ShotProduct>;

export const shotSpecClipsMax = 60;



export const ShotSpec = zod.object({
  "cast": ShotCast,
  "clips": zod.array(ShotClip).min(1).max(shotSpecClipsMax),
  "product": ShotProduct
}).describe('Live\'s shot spec (`shotSpecSchema`): the shot director\'s answer, what the stills and the\nclips are rendered from.');

export type ShotSpec = zod.input<typeof ShotSpec>;
export type ShotSpecOutput = zod.output<typeof ShotSpec>;

export const PodcastStills = zod.object({
  "end_card": OutputRef,
  "guest_close": OutputRef,
  "guest_hold": OutputRef,
  "host_close": OutputRef,
  "master": OutputRef
}).describe('The cast\'s five stills a Podcast Ad video starts from (live\'s `stillUrls`): each the\ndraft\'s still\'s picture, an earlier output.');

export type PodcastStills = zod.input<typeof PodcastStills>;
export type PodcastStillsOutput = zod.output<typeof PodcastStills>;

export const podcastAdVideoInputsCaptionPositionDefault = `bottom`;
export const podcastAdVideoInputsCaptionStyleIdDefault = ``;
export const podcastAdVideoInputsCaptionStyleIdMax = 64;

export const podcastAdVideoInputsSubtitlesDefault = true;

export const PodcastAdVideoInputs = zod.object({
  "caption_position": zod.enum(['top', 'center', 'bottom']).default(podcastAdVideoInputsCaptionPositionDefault),
  "caption_style_id": zod.string().max(podcastAdVideoInputsCaptionStyleIdMax).default(podcastAdVideoInputsCaptionStyleIdDefault),
  "script": PodcastScript,
  "spec": ShotSpec,
  "stills": PodcastStills,
  "subtitles": zod.boolean().default(podcastAdVideoInputsSubtitlesDefault),
  "template": zod.enum(['podcast-ad'])
}).describe('Podcast Ad\'s "Generate video" (live\'s hand-off, G14 PR 16 B): the approved script, the\nshot spec, the five stills and the captions. One tile: a clip a line, each checked for its\nwords and retaken once where one is missing, the end card\'s clip, and the merge.');

export type PodcastAdVideoInputs = zod.input<typeof PodcastAdVideoInputs>;
export type PodcastAdVideoInputsOutput = zod.output<typeof PodcastAdVideoInputs>;

export const StreetCrowd = zod.enum(['men', 'women', 'mixed']);

export type StreetCrowd = zod.input<typeof StreetCrowd>;
export type StreetCrowdOutput = zod.output<typeof StreetCrowd>;

export const offerEndCardCtaButtonMax = 200;

export const offerEndCardHeadlineMax = 2000;

export const offerEndCardOfferLineMax = 2000;



export const OfferEndCard = zod.object({
  "cta_button": zod.string().max(offerEndCardCtaButtonMax),
  "headline": zod.string().max(offerEndCardHeadlineMax),
  "offer_line": zod.string().max(offerEndCardOfferLineMax)
}).describe('The designed card the ad ends on: its headline, its button and an optional offer.');

export type OfferEndCard = zod.input<typeof OfferEndCard>;
export type OfferEndCardOutput = zod.output<typeof OfferEndCard>;

export const StreetSpeaker = zod.enum(['INTERVIEWER', 'P1', 'P2', 'P3', 'P4']);

export type StreetSpeaker = zod.input<typeof StreetSpeaker>;
export type StreetSpeakerOutput = zod.output<typeof StreetSpeaker>;

export const streetScriptLineBeatMax = 40;

export const streetScriptLineClaimIdsMax = 60;

export const streetScriptLineTextMax = 2000;



export const StreetScriptLine = zod.object({
  "beat": zod.string().max(streetScriptLineBeatMax),
  "claim_ids": zod.array(zod.string()).max(streetScriptLineClaimIdsMax),
  "id": zod.int(),
  "speaker": StreetSpeaker,
  "text": zod.string().max(streetScriptLineTextMax)
}).describe('One beat of the 17: its number, beat, speaker, words and the claims it states.');

export type StreetScriptLine = zod.input<typeof StreetScriptLine>;
export type StreetScriptLineOutput = zod.output<typeof StreetScriptLine>;

export const saidPronunciationRespellingMax = 200;

export const saidPronunciationSaidMax = 2000;

export const saidPronunciationWordMax = 200;



export const SaidPronunciation = zod.object({
  "respelling": zod.string().max(saidPronunciationRespellingMax),
  "said": zod.string().max(saidPronunciationSaidMax),
  "word": zod.string().max(saidPronunciationWordMax)
}).describe('A word a voice model could misread, how to spell it for the model, and how it is said\n(live\'s `pronunciations`: the clip prompt names `said`).');

export type SaidPronunciation = zod.input<typeof SaidPronunciation>;
export type SaidPronunciationOutput = zod.output<typeof SaidPronunciation>;

export const streetScriptClaimsMax = 60;

export const streetScriptLinesMax = 60;

export const streetScriptLowerThirdMax = 2000;

export const streetScriptMechanismMax = 2000;

export const streetScriptPainMax = 2000;

export const streetScriptPronunciationsMax = 60;

export const streetScriptQuestionMax = 2000;

export const streetScriptTopicNounMax = 2000;



export const StreetScript = zod.object({
  "claims": zod.array(ScriptClaim).max(streetScriptClaimsMax),
  "crowd": StreetCrowd,
  "end_card": OfferEndCard,
  "estimated_duration_s": zod.number(),
  "lines": zod.array(StreetScriptLine).min(1).max(streetScriptLinesMax),
  "lower_third": zod.string().max(streetScriptLowerThirdMax),
  "mechanism": zod.string().max(streetScriptMechanismMax),
  "pain": zod.string().max(streetScriptPainMax),
  "pronunciations": zod.array(SaidPronunciation).max(streetScriptPronunciationsMax),
  "question": zod.string().max(streetScriptQuestionMax),
  "topic_noun": zod.string().max(streetScriptTopicNounMax),
  "word_count": zod.int()
}).describe('Live\'s street script (`streetScriptSchema`): the script director\'s answer, edited in the\nform before approval. `lower_third` is the title\'s words. The word count is whole, as live\'s\ndirector schema has it (`integer`).');

export type StreetScript = zod.input<typeof StreetScript>;
export type StreetScriptOutput = zod.output<typeof StreetScript>;

export const streetCastPersonExpressionMax = 2000;

export const streetCastPersonIdentityMax = 2000;

export const streetCastPersonOutfitMax = 2000;

export const streetCastPersonVoiceMax = 2000;



export const StreetCastPerson = zod.object({
  "expression": zod.string().min(1).max(streetCastPersonExpressionMax),
  "identity": zod.string().min(1).max(streetCastPersonIdentityMax),
  "outfit": zod.string().min(1).max(streetCastPersonOutfitMax),
  "pronoun": CastPronoun,
  "voice": zod.string().min(1).max(streetCastPersonVoiceMax)
}).describe('One of the five as the director casts them (live\'s `personSchema`).');

export type StreetCastPerson = zod.input<typeof StreetCastPerson>;
export type StreetCastPersonOutput = zod.output<typeof StreetCastPerson>;

export const StreetCast = zod.object({
  "interviewer": StreetCastPerson,
  "p1": StreetCastPerson,
  "p2": StreetCastPerson,
  "p3": StreetCastPerson,
  "p4": StreetCastPerson
});

export type StreetCast = zod.input<typeof StreetCast>;
export type StreetCastOutput = zod.output<typeof StreetCast>;

export const StreetClipId = zod.enum(['k01', 'k02', 'k03', 'k04', 'k05', 'k06', 'k07', 'k08', 'k09', 'k10', 'k11']);

export type StreetClipId = zod.input<typeof StreetClipId>;
export type StreetClipIdOutput = zod.output<typeof StreetClipId>;

export const streetClipLinePreparedLineMax = 2000;



export const StreetClipLine = zod.object({
  "line_id": zod.int(),
  "prepared_line": zod.string().min(1).max(streetClipLinePreparedLineMax),
  "speaker": StreetSpeaker
}).describe('A script line a clip speaks, as the video model is to say it.');

export type StreetClipLine = zod.input<typeof StreetClipLine>;
export type StreetClipLineOutput = zod.output<typeof StreetClipLine>;

export const streetClipActionsItemMax = 2000;

export const streetClipActionsMax = 60;

export const streetClipLinesMax = 60;

export const streetClipPerformanceVibeMax = 2000;

export const streetClipSceneMax = 2000;



export const StreetClip = zod.object({
  "actions": zod.array(zod.string().max(streetClipActionsItemMax)).min(1).max(streetClipActionsMax),
  "has_letter_groups": zod.boolean(),
  "id": StreetClipId,
  "lines": zod.array(StreetClipLine).min(1).max(streetClipLinesMax),
  "performance_vibe": zod.string().max(streetClipPerformanceVibeMax),
  "scene": zod.string().max(streetClipSceneMax)
}).describe('One clip (live\'s `clipSchema`): the lines it speaks, whether they spell letters out, and\nits scene, vibe and actions. Its still, who is on screen and who holds the product are live\'s\nfixed clip plan\'s.');

export type StreetClip = zod.input<typeof StreetClip>;
export type StreetClipOutput = zod.output<typeof StreetClip>;

export const streetShotProductGripMax = 2000;

export const streetShotProductLabelKeyWordsMax = 2000;

export const streetShotProductPackTypeMax = 2000;

export const streetShotProductProductLockMax = 8000;

export const streetShotProductSensoryActionMax = 2000;

export const streetShotProductSizeLineMax = 2000;



export const StreetShotProduct = zod.object({
  "grip": zod.string().min(1).max(streetShotProductGripMax),
  "label_key_words": zod.string().max(streetShotProductLabelKeyWordsMax),
  "pack_type": zod.string().min(1).max(streetShotProductPackTypeMax),
  "product_lock": zod.string().min(1).max(streetShotProductProductLockMax),
  "sensory_action": zod.string().min(1).max(streetShotProductSensoryActionMax),
  "size_line": zod.string().max(streetShotProductSizeLineMax)
}).describe('The product as every still and clip names it (live\'s `product`): with how one hand holds\nit and what the skeptic does with it at the handover.');

export type StreetShotProduct = zod.input<typeof StreetShotProduct>;
export type StreetShotProductOutput = zod.output<typeof StreetShotProduct>;

export const streetShotSpecClipsMax = 60;



export const StreetShotSpec = zod.object({
  "cast": StreetCast,
  "clips": zod.array(StreetClip).min(1).max(streetShotSpecClipsMax),
  "product": StreetShotProduct
}).describe('Live\'s street shot spec (`shotSpecSchema`): the shot director\'s answer, what the stills\nand the clips are drawn from.');

export type StreetShotSpec = zod.input<typeof StreetShotSpec>;
export type StreetShotSpecOutput = zod.output<typeof StreetShotSpec>;

export const StreetStills = zod.object({
  "end_card": OutputRef,
  "handover_3": OutputRef,
  "hold_1": OutputRef,
  "hold_2": OutputRef,
  "hold_3": OutputRef,
  "signoff": OutputRef,
  "single_2": OutputRef,
  "single_3": OutputRef,
  "single_4": OutputRef,
  "two_1": OutputRef,
  "two_3_hold": OutputRef
}).describe('The eleven keyframes a Street Interview Ad video starts from (live\'s `stillUrls` that a\nclip reads): ten start frames and the end card, each the draft\'s still\'s picture, an earlier\noutput. The six cast stills they were drawn from are no clip\'s.');

export type StreetStills = zod.input<typeof StreetStills>;
export type StreetStillsOutput = zod.output<typeof StreetStills>;

export const streetInterviewVideoInputsCaptionPositionDefault = `bottom`;
export const streetInterviewVideoInputsCaptionStyleIdDefault = ``;
export const streetInterviewVideoInputsCaptionStyleIdMax = 64;

export const streetInterviewVideoInputsSubtitlesDefault = true;
export const streetInterviewVideoInputsTitleDefault = false;

export const StreetInterviewVideoInputs = zod.object({
  "caption_position": zod.enum(['top', 'center', 'bottom']).default(streetInterviewVideoInputsCaptionPositionDefault),
  "caption_style_id": zod.string().max(streetInterviewVideoInputsCaptionStyleIdMax).default(streetInterviewVideoInputsCaptionStyleIdDefault),
  "script": StreetScript,
  "spec": StreetShotSpec,
  "stills": StreetStills,
  "subtitles": zod.boolean().default(streetInterviewVideoInputsSubtitlesDefault),
  "template": zod.enum(['street-interview-ad']),
  "title": zod.boolean().default(streetInterviewVideoInputsTitleDefault)
}).describe('Street Interview Ad\'s "Generate final video" (live\'s hand-off, G14 PR 17): the approved\nscript, the shot spec, the eleven keyframes, the captions and the title. One tile: eleven\nclips, each checked for its words and retaken once where one is missing, the end card\'s\nclip, the merge, the captions, the title.');

export type StreetInterviewVideoInputs = zod.input<typeof StreetInterviewVideoInputs>;
export type StreetInterviewVideoInputsOutput = zod.output<typeof StreetInterviewVideoInputs>;

export const pixarScriptLineBeatMax = 40;

export const pixarScriptLineClaimIdsMax = 60;

export const pixarScriptLineTextMax = 2000;



export const PixarScriptLine = zod.object({
  "beat": zod.string().max(pixarScriptLineBeatMax),
  "claim_ids": zod.array(zod.string()).max(pixarScriptLineClaimIdsMax),
  "id": zod.int(),
  "text": zod.string().max(pixarScriptLineTextMax)
}).describe('One of the 8 beats: its number, beat, words and the claims it states.');

export type PixarScriptLine = zod.input<typeof PixarScriptLine>;
export type PixarScriptLineOutput = zod.output<typeof PixarScriptLine>;

export const pixarScriptClaimsMax = 60;

export const pixarScriptLinesMax = 60;

export const pixarScriptMechanismMax = 2000;

export const pixarScriptOldHabitMax = 2000;

export const pixarScriptProblemMax = 2000;

export const pixarScriptProductShortNameMax = 2000;

export const pixarScriptPronunciationsMax = 60;



export const PixarScript = zod.object({
  "claims": zod.array(ScriptClaim).max(pixarScriptClaimsMax),
  "end_card": OfferEndCard,
  "estimated_duration_s": zod.number(),
  "lines": zod.array(PixarScriptLine).min(1).max(pixarScriptLinesMax),
  "mechanism": zod.string().max(pixarScriptMechanismMax),
  "old_habit": zod.string().max(pixarScriptOldHabitMax),
  "problem": zod.string().max(pixarScriptProblemMax),
  "product_short_name": zod.string().max(pixarScriptProductShortNameMax),
  "pronunciations": zod.array(SaidPronunciation).max(pixarScriptPronunciationsMax),
  "word_count": zod.number()
}).describe('Live\'s Pixar script (`pixarScriptSchema`): the script director\'s answer, edited in the\nform before approval, or the 8 blank lines a member writes (live\'s pencil).');

export type PixarScript = zod.input<typeof PixarScript>;
export type PixarScriptOutput = zod.output<typeof PixarScript>;

export const pixarCharacterIdentityMax = 2000;

export const pixarCharacterOpeningExpressionMax = 2000;

export const pixarCharacterOutfitMax = 2000;

export const pixarCharacterVoiceMax = 2000;



export const PixarCharacter = zod.object({
  "identity": zod.string().min(1).max(pixarCharacterIdentityMax),
  "opening_expression": zod.string().min(1).max(pixarCharacterOpeningExpressionMax),
  "outfit": zod.string().min(1).max(pixarCharacterOutfitMax),
  "pronoun": CastPronoun,
  "voice": zod.string().min(1).max(pixarCharacterVoiceMax)
}).describe('The one character as the director designs it (live\'s `character`).');

export type PixarCharacter = zod.input<typeof PixarCharacter>;
export type PixarCharacterOutput = zod.output<typeof PixarCharacter>;

export const pixarFirstClipGestureMax = 2000;

export const pixarFirstClipPerformanceVibeMax = 2000;



export const PixarFirstClip = zod.object({
  "gesture": zod.string().max(pixarFirstClipGestureMax),
  "performance_vibe": zod.string().max(pixarFirstClipPerformanceVibeMax)
}).describe('Lines 1 to 4 as acted (live\'s `clip1`): the mood and the gesture on its cue.');

export type PixarFirstClip = zod.input<typeof PixarFirstClip>;
export type PixarFirstClipOutput = zod.output<typeof PixarFirstClip>;

export const pixarSecondClipClosingExpressionMax = 2000;

export const pixarSecondClipClosingGestureMax = 2000;

export const pixarSecondClipPerformanceVibeMax = 2000;

export const pixarSecondClipProductActionMax = 2000;



export const PixarSecondClip = zod.object({
  "closing_expression": zod.string().max(pixarSecondClipClosingExpressionMax),
  "closing_gesture": zod.string().max(pixarSecondClipClosingGestureMax),
  "performance_vibe": zod.string().max(pixarSecondClipPerformanceVibeMax),
  "product_action": zod.string().max(pixarSecondClipProductActionMax)
}).describe('Lines 5 to 8 as acted (live\'s `clip2`): the mood, what the product does, and the closing\ngesture and expression.');

export type PixarSecondClip = zod.input<typeof PixarSecondClip>;
export type PixarSecondClipOutput = zod.output<typeof PixarSecondClip>;

export const pixarPreparedLinePreparedLineMax = 2000;



export const PixarPreparedLine = zod.object({
  "line_id": zod.int(),
  "prepared_line": zod.string().min(1).max(pixarPreparedLinePreparedLineMax)
}).describe('A script line as the video model is to say it: its respellings applied, its numbers in\nwords.');

export type PixarPreparedLine = zod.input<typeof PixarPreparedLine>;
export type PixarPreparedLineOutput = zod.output<typeof PixarPreparedLine>;

export const pixarShotProductGripMax = 2000;

export const pixarShotProductPackTypeMax = 2000;

export const pixarShotProductProductLockMax = 8000;

export const pixarShotProductSizeLineMax = 2000;



export const PixarShotProduct = zod.object({
  "grip": zod.string().min(1).max(pixarShotProductGripMax),
  "pack_type": zod.string().min(1).max(pixarShotProductPackTypeMax),
  "product_lock": zod.string().min(1).max(pixarShotProductProductLockMax),
  "size_line": zod.string().max(pixarShotProductSizeLineMax)
}).describe('The product as every still and clip names it (live\'s `product`), with how the character\'s\nhand holds it.');

export type PixarShotProduct = zod.input<typeof PixarShotProduct>;
export type PixarShotProductOutput = zod.output<typeof PixarShotProduct>;

export const pixarSetDescriptionMax = 2000;

export const pixarSetPlaceMax = 2000;



export const PixarSet = zod.object({
  "description": zod.string().min(1).max(pixarSetDescriptionMax),
  "place": zod.string().min(1).max(pixarSetPlaceMax)
}).describe('Where the character stands behind its counter (live\'s `set`).');

export type PixarSet = zod.input<typeof PixarSet>;
export type PixarSetOutput = zod.output<typeof PixarSet>;

export const pixarShotSpecLinesMax = 60;



export const PixarShotSpec = zod.object({
  "character": PixarCharacter,
  "clip1": PixarFirstClip,
  "clip2": PixarSecondClip,
  "lines": zod.array(PixarPreparedLine).min(1).max(pixarShotSpecLinesMax),
  "product": PixarShotProduct,
  "set": PixarSet
}).describe('Live\'s shot spec (`shotSpecSchema`): the shot director\'s answer, what the stills and the\nclips are drawn from.');

export type PixarShotSpec = zod.input<typeof PixarShotSpec>;
export type PixarShotSpecOutput = zod.output<typeof PixarShotSpec>;

export const PixarStills = zod.object({
  "closing": OutputRef,
  "end_card": zod.union([OutputRef,zod.null()]).exactOptional(),
  "hold": OutputRef,
  "opening": OutputRef
}).describe('The pictures a Pixar Talking Ad video is drawn between (live\'s `stillUrls` a clip reads):\nthe opening, the hold and the closing, and the end card with the end card on, each the\ndraft\'s still\'s picture, an earlier output. The character sheet is no clip\'s.');

export type PixarStills = zod.input<typeof PixarStills>;
export type PixarStillsOutput = zod.output<typeof PixarStills>;

export const PixarTakes = zod.object({
  "k1": zod.union([OutputRef,zod.null()]).exactOptional(),
  "k2": zod.union([OutputRef,zod.null()]).exactOptional(),
  "k3": zod.union([OutputRef,zod.null()]).exactOptional()
}).describe('The clips an earlier run from this draft delivered, taken as they are (live\'s\n`isTakeCurrent`: a take whose frames and resolution are unchanged is kept, its clip not\nrendered or charged again; Pixar Talking Ad-2, G14-engine Engine-8): each its clip step\'s\noutput in that run, as the draft\'s `run` lists them. The form names a take only while its\nframes and the resolution match; one named with the end card off, or whose frames changed,\nis refused at its field.');

export type PixarTakes = zod.input<typeof PixarTakes>;
export type PixarTakesOutput = zod.output<typeof PixarTakes>;

export const pixarTalkingVideoInputsCaptionPositionDefault = `bottom`;
export const pixarTalkingVideoInputsCaptionStyleIdDefault = ``;
export const pixarTalkingVideoInputsCaptionStyleIdMax = 64;

export const pixarTalkingVideoInputsEndCardDefault = true;
export const pixarTalkingVideoInputsResolutionDefault = `1080p`;
export const pixarTalkingVideoInputsSubtitlesDefault = true;
export const pixarTalkingVideoInputsTakesDefault = {};

export const PixarTalkingVideoInputs = zod.object({
  "caption_position": zod.enum(['top', 'center', 'bottom']).default(pixarTalkingVideoInputsCaptionPositionDefault),
  "caption_style_id": zod.string().max(pixarTalkingVideoInputsCaptionStyleIdMax).default(pixarTalkingVideoInputsCaptionStyleIdDefault),
  "end_card": zod.boolean().default(pixarTalkingVideoInputsEndCardDefault),
  "resolution": zod.enum(['1080p', '720p']).default(pixarTalkingVideoInputsResolutionDefault),
  "script": PixarScript,
  "spec": PixarShotSpec,
  "stills": PixarStills,
  "subtitles": zod.boolean().default(pixarTalkingVideoInputsSubtitlesDefault),
  "takes": PixarTakes.default(pixarTalkingVideoInputsTakesDefault),
  "template": zod.enum(['pixar-talking-ad'])
}).describe('Pixar Talking Ad\'s "Generate final video" (live\'s hand-off, G14 PR 18c): the approved\nscript and shot spec, the stills, the captions and their look and place, the end card and\nthe clips\' resolution. One tile: two talking clips between their frames and the end card\'s\nclip, the merge, the captions in two passes, the end card joined. `takes`: the clips an\nearlier run delivered, kept as they are (Engine-8: the run never starts or charges them).');

export type PixarTalkingVideoInputs = zod.input<typeof PixarTalkingVideoInputs>;
export type PixarTalkingVideoInputsOutput = zod.output<typeof PixarTalkingVideoInputs>;

export const PixarSingingPronoun = zod.enum(['she', 'he']).describe('The character\'s pronoun (`ui-templates/src/utils/pronouns.ts:1-4`).');

export type PixarSingingPronoun = zod.input<typeof PixarSingingPronoun>;
export type PixarSingingPronounOutput = zod.output<typeof PixarSingingPronoun>;

export const pixarSingingCharacterIdentityMax = 2000;

export const pixarSingingCharacterOutfitMax = 2000;

export const pixarSingingCharacterPersonalityMax = 2000;

export const pixarSingingCharacterStartExpressionMax = 2000;



export const PixarSingingCharacter = zod.object({
  "identity": zod.string().min(1).max(pixarSingingCharacterIdentityMax),
  "outfit": zod.string().min(1).max(pixarSingingCharacterOutfitMax),
  "personality": zod.string().max(pixarSingingCharacterPersonalityMax),
  "pronoun": PixarSingingPronoun,
  "start_expression": zod.string().max(pixarSingingCharacterStartExpressionMax)
}).describe('The one animated character.');

export type PixarSingingCharacter = zod.input<typeof PixarSingingCharacter>;
export type PixarSingingCharacterOutput = zod.output<typeof PixarSingingCharacter>;

export const pixarSingingShotProductGripMax = 2000;

export const pixarSingingShotProductPackTypeMax = 2000;

export const pixarSingingShotProductProductLockMax = 8000;

export const pixarSingingShotProductSizeLineMax = 2000;

export const pixarSingingShotProductStartSpotMax = 2000;



export const PixarSingingShotProduct = zod.object({
  "grip": zod.string().max(pixarSingingShotProductGripMax),
  "pack_type": zod.string().min(1).max(pixarSingingShotProductPackTypeMax),
  "product_lock": zod.string().min(1).max(pixarSingingShotProductProductLockMax),
  "size_line": zod.string().max(pixarSingingShotProductSizeLineMax),
  "start_spot": zod.string().max(pixarSingingShotProductStartSpotMax)
}).describe('The pack as it is drawn and held.');

export type PixarSingingShotProduct = zod.input<typeof PixarSingingShotProduct>;
export type PixarSingingShotProductOutput = zod.output<typeof PixarSingingShotProduct>;

export const pixarSingingBeatActionMax = 2000;



export const PixarSingingBeat = zod.object({
  "action": zod.string().max(pixarSingingBeatActionMax),
  "line_id": zod.int()
}).describe('What the character does while a lyric line is sung.');

export type PixarSingingBeat = zod.input<typeof PixarSingingBeat>;
export type PixarSingingBeatOutput = zod.output<typeof PixarSingingBeat>;

export const PixarSingingCamera = zod.enum(['static', 'follow']).describe('A locked-off camera, or one that follows a walking character (`shot.ts:23-26`).');

export type PixarSingingCamera = zod.input<typeof PixarSingingCamera>;
export type PixarSingingCameraOutput = zod.output<typeof PixarSingingCamera>;

export const pixarSingingLocationDescriptionMax = 2000;

export const pixarSingingLocationPlaceMax = 2000;



export const PixarSingingLocation = zod.object({
  "description": zod.string().max(pixarSingingLocationDescriptionMax),
  "place": zod.string().max(pixarSingingLocationPlaceMax)
}).describe('Where a shot happens.');

export type PixarSingingLocation = zod.input<typeof PixarSingingLocation>;
export type PixarSingingLocationOutput = zod.output<typeof PixarSingingLocation>;

export const PixarSingingStaging = zod.enum(['sitting', 'standing', 'leaning', 'walking', 'lying', 'crouching']).describe('How the body is placed in a shot (`W/director/shot.ts:14-21`).');

export type PixarSingingStaging = zod.input<typeof PixarSingingStaging>;
export type PixarSingingStagingOutput = zod.output<typeof PixarSingingStaging>;

export const pixarSingingSpecShotBeatsMax = 60;

export const pixarSingingSpecShotFirstFrameMax = 2000;

export const pixarSingingSpecShotFramingMax = 2000;

export const pixarSingingSpecShotMouthMax = 2000;

export const pixarSingingSpecShotMovementMax = 2000;

export const pixarSingingSpecShotObjectPathMax = 2000;



export const PixarSingingSpecShot = zod.object({
  "beats": zod.array(PixarSingingBeat).min(1).max(pixarSingingSpecShotBeatsMax),
  "camera": PixarSingingCamera,
  "first_frame": zod.string().max(pixarSingingSpecShotFirstFrameMax),
  "framing": zod.string().max(pixarSingingSpecShotFramingMax),
  "location": PixarSingingLocation,
  "mouth": zod.string().max(pixarSingingSpecShotMouthMax),
  "movement": zod.string().max(pixarSingingSpecShotMovementMax),
  "object_path": zod.string().max(pixarSingingSpecShotObjectPathMax),
  "shot_id": zod.int(),
  "staging": PixarSingingStaging
}).describe('One shot of the spec (`shot.ts:30-50`).');

export type PixarSingingSpecShot = zod.input<typeof PixarSingingSpecShot>;
export type PixarSingingSpecShotOutput = zod.output<typeof PixarSingingSpecShot>;

export const pixarSingingWorldConceptMax = 2000;

export const pixarSingingWorldLightMax = 2000;

export const pixarSingingWorldPaletteMax = 2000;



export const PixarSingingWorld = zod.object({
  "concept": zod.string().max(pixarSingingWorldConceptMax),
  "light": zod.string().max(pixarSingingWorldLightMax),
  "palette": zod.string().max(pixarSingingWorldPaletteMax)
}).describe('The world the ad is set in.');

export type PixarSingingWorld = zod.input<typeof PixarSingingWorld>;
export type PixarSingingWorldOutput = zod.output<typeof PixarSingingWorld>;

export const pixarSingingShotSpecPainPropMax = 2000;

export const pixarSingingShotSpecShotsMax = 60;



export const PixarSingingShotSpec = zod.object({
  "character": PixarSingingCharacter,
  "pain_prop": zod.string().max(pixarSingingShotSpecPainPropMax),
  "product": PixarSingingShotProduct,
  "shots": zod.array(PixarSingingSpecShot).min(1).max(pixarSingingShotSpecShotsMax),
  "world": PixarSingingWorld
}).describe('Live\'s shot spec (`shot.ts:54-76`): the shot director\'s answer, what the stills and the\nclips are drawn from. Its schema (`shot-schema.json`) has exactly these keys, each object\nclosed, so an answer that fits it reads as a spec.');

export type PixarSingingShotSpec = zod.input<typeof PixarSingingShotSpec>;
export type PixarSingingShotSpecOutput = zod.output<typeof PixarSingingShotSpec>;

export const PixarSingingVideoStills = zod.object({
  "end_card": zod.union([OutputRef,zod.null()]).exactOptional(),
  "shot_1": OutputRef,
  "shot_2": OutputRef,
  "shot_3": zod.union([OutputRef,zod.null()]).exactOptional()
}).describe('The stills the clips start on, each the draft\'s drawn picture: a start frame for each of\nthe plan\'s shots (2 or 3), and the end card where the plan has one.');

export type PixarSingingVideoStills = zod.input<typeof PixarSingingVideoStills>;
export type PixarSingingVideoStillsOutput = zod.output<typeof PixarSingingVideoStills>;

export const pixarSingingTakeLineEndSOneMin = 0;
export const pixarSingingTakeLineEndSOneMax = 600;

export const pixarSingingTakeLineLineIdMax = 7;

export const pixarSingingTakeLineStartSOneMin = 0;
export const pixarSingingTakeLineStartSOneMax = 600;

export const pixarSingingTakeLineTextMax = 2000;



export const PixarSingingTakeLine = zod.object({
  "end_s": zod.union([zod.number().min(pixarSingingTakeLineEndSOneMin).max(pixarSingingTakeLineEndSOneMax),zod.null()]),
  "line_id": zod.int().min(1).max(pixarSingingTakeLineLineIdMax),
  "start_s": zod.union([zod.number().min(pixarSingingTakeLineStartSOneMin).max(pixarSingingTakeLineStartSOneMax),zod.null()]),
  "text": zod.string().max(pixarSingingTakeLineTextMax)
}).describe('A lyric line of a take (7 is the punch line) and when it is heard, in seconds; `None`\nwhen it is not.');

export type PixarSingingTakeLine = zod.input<typeof PixarSingingTakeLine>;
export type PixarSingingTakeLineOutput = zod.output<typeof PixarSingingTakeLine>;

export const pixarSingingTakeWordEndMin = 0;
export const pixarSingingTakeWordEndMax = 600;

export const pixarSingingTakeWordLineIdMax = 7;

export const pixarSingingTakeWordStartMin = 0;
export const pixarSingingTakeWordStartMax = 600;

export const pixarSingingTakeWordTextMax = 200;



export const PixarSingingTakeWord = zod.object({
  "end": zod.number().min(pixarSingingTakeWordEndMin).max(pixarSingingTakeWordEndMax),
  "line_end": zod.boolean(),
  "line_id": zod.int().min(1).max(pixarSingingTakeWordLineIdMax),
  "start": zod.number().min(pixarSingingTakeWordStartMin).max(pixarSingingTakeWordStartMax),
  "text": zod.string().min(1).max(pixarSingingTakeWordTextMax)
}).describe('A word of a take in its lyric spelling (an extra sung word as heard), its line, its times\nand whether it ends its line. Never blank: the captions take it as a `VideoCaptionWordTiming`,\nwhich takes no empty text, so a blank is refused here, before any paid clip.');

export type PixarSingingTakeWord = zod.input<typeof PixarSingingTakeWord>;
export type PixarSingingTakeWordOutput = zod.output<typeof PixarSingingTakeWord>;

export const pixarSingingTakeTimingDurationSExclusiveMin = 0;
export const pixarSingingTakeTimingDurationSMax = 600;

export const pixarSingingTakeTimingLinesMax = 7;

export const pixarSingingTakeTimingWordsMax = 1000;



export const PixarSingingTakeTiming = zod.object({
  "duration_s": zod.number().gt(pixarSingingTakeTimingDurationSExclusiveMin).max(pixarSingingTakeTimingDurationSMax),
  "lines": zod.array(PixarSingingTakeLine).max(pixarSingingTakeTimingLinesMax),
  "words": zod.array(PixarSingingTakeWord).max(pixarSingingTakeTimingWordsMax)
}).describe('A take\'s length and its timing map (live\'s `TimingMap`): when each line and each word is\nheard. The shot plan is cut from it, and the captions are its words.');

export type PixarSingingTakeTiming = zod.input<typeof PixarSingingTakeTiming>;
export type PixarSingingTakeTimingOutput = zod.output<typeof PixarSingingTakeTiming>;

export const PixarSingingVideoTake = zod.object({
  "song": OutputRef,
  "timing": PixarSingingTakeTiming
}).describe('The picked take: its song (the take\'s output) and its timing map.');

export type PixarSingingVideoTake = zod.input<typeof PixarSingingVideoTake>;
export type PixarSingingVideoTakeOutput = zod.output<typeof PixarSingingVideoTake>;

export const pixarSingingAdVideoInputsCaptionPositionDefault = `bottom`;
export const pixarSingingAdVideoInputsCaptionStyleIdDefault = ``;
export const pixarSingingAdVideoInputsCaptionStyleIdMax = 64;

export const pixarSingingAdVideoInputsResolutionDefault = `1080p`;
export const pixarSingingAdVideoInputsSubtitlesDefault = true;

export const PixarSingingAdVideoInputs = zod.object({
  "caption_position": zod.enum(['top', 'center', 'bottom']).default(pixarSingingAdVideoInputsCaptionPositionDefault),
  "caption_style_id": zod.string().max(pixarSingingAdVideoInputsCaptionStyleIdMax).default(pixarSingingAdVideoInputsCaptionStyleIdDefault),
  "resolution": zod.enum(['720p', '1080p']).default(pixarSingingAdVideoInputsResolutionDefault),
  "spec": PixarSingingShotSpec,
  "stills": PixarSingingVideoStills,
  "subtitles": zod.boolean().default(pixarSingingAdVideoInputsSubtitlesDefault),
  "take": PixarSingingVideoTake,
  "template": zod.enum(['pixar-singing-ad'])
}).describe('Pixar Singing Ad\'s "Generate final video" (live\'s hand-off, G14 PR 19d): the picked take,\nthe shot spec, the stills, the captions and the resolution. One tile: a silent clip per shot\nand the end card\'s, merged, captioned in two passes, the song laid under it.');

export type PixarSingingAdVideoInputs = zod.input<typeof PixarSingingAdVideoInputs>;
export type PixarSingingAdVideoInputsOutput = zod.output<typeof PixarSingingAdVideoInputs>;

export const whiteboardEndCardCtaButtonMax = 2000;

export const whiteboardEndCardHeadlineMax = 2000;

export const whiteboardEndCardSupportLineMax = 2000;



export const WhiteboardEndCard = zod.object({
  "cta_button": zod.string().max(whiteboardEndCardCtaButtonMax),
  "headline": zod.string().max(whiteboardEndCardHeadlineMax),
  "support_line": zod.string().max(whiteboardEndCardSupportLineMax)
});

export type WhiteboardEndCard = zod.input<typeof WhiteboardEndCard>;
export type WhiteboardEndCardOutput = zod.output<typeof WhiteboardEndCard>;

export const whiteboardLineBoardHeadlineMax = 2000;

export const whiteboardLineBoardIconMax = 2000;



export const WhiteboardLineBoard = zod.object({
  "headline": zod.string().max(whiteboardLineBoardHeadlineMax),
  "icon": zod.string().max(whiteboardLineBoardIconMax)
}).describe('What a line adds to the board: a headline in capitals (\'\' on line 10) and one simple\nicon (\'\' on lines 6 and 10).');

export type WhiteboardLineBoard = zod.input<typeof WhiteboardLineBoard>;
export type WhiteboardLineBoardOutput = zod.output<typeof WhiteboardLineBoard>;

export const WhiteboardClip = zod.enum(['A', 'B', 'C']).describe('Live\'s three talking clips: A the problem, B the product, C the close.');

export type WhiteboardClip = zod.input<typeof WhiteboardClip>;
export type WhiteboardClipOutput = zod.output<typeof WhiteboardClip>;

export const WhiteboardLineRole = zod.enum(['hook', 'what_you_do', 'the_limit', 'the_gap', 'bad_result', 'product', 'mechanism', 'second_benefit', 'closer', 'cta']).describe('The ten lines\' roles, in their order (`W/director/script.ts:58-69`).');

export type WhiteboardLineRole = zod.input<typeof WhiteboardLineRole>;
export type WhiteboardLineRoleOutput = zod.output<typeof WhiteboardLineRole>;

export const whiteboardScriptLineClaimIdsItemMax = 40;

export const whiteboardScriptLineClaimIdsMax = 60;

export const whiteboardScriptLineSpokenMax = 2000;

export const whiteboardScriptLineTextMax = 2000;



export const WhiteboardScriptLine = zod.object({
  "board": WhiteboardLineBoard,
  "claim_ids": zod.array(zod.string().max(whiteboardScriptLineClaimIdsItemMax)).max(whiteboardScriptLineClaimIdsMax),
  "clip": WhiteboardClip,
  "id": zod.int(),
  "role": WhiteboardLineRole,
  "spoken": zod.string().max(whiteboardScriptLineSpokenMax),
  "text": zod.string().max(whiteboardScriptLineTextMax)
}).describe('A line: what is written and what is said, its clip, its role, its claims and its board.');

export type WhiteboardScriptLine = zod.input<typeof WhiteboardScriptLine>;
export type WhiteboardScriptLineOutput = zod.output<typeof WhiteboardScriptLine>;

export const whiteboardPresenterIdentityMax = 2000;

export const whiteboardPresenterOutfitMax = 2000;

export const whiteboardPresenterPersonalityMax = 2000;

export const whiteboardPresenterVoiceMax = 2000;



export const WhiteboardPresenter = zod.object({
  "identity": zod.string().max(whiteboardPresenterIdentityMax),
  "outfit": zod.string().max(whiteboardPresenterOutfitMax),
  "personality": zod.string().max(whiteboardPresenterPersonalityMax),
  "pronoun": CastPronoun,
  "voice": zod.string().max(whiteboardPresenterVoiceMax)
}).describe('The presenter the director designs for the buyer; `voice` goes word for word into every\nclip\'s prompt.');

export type WhiteboardPresenter = zod.input<typeof WhiteboardPresenter>;
export type WhiteboardPresenterOutput = zod.output<typeof WhiteboardPresenter>;

export const whiteboardPronunciationRespellingMax = 200;

export const whiteboardPronunciationWordMax = 200;



export const WhiteboardPronunciation = zod.object({
  "respelling": zod.string().max(whiteboardPronunciationRespellingMax),
  "word": zod.string().max(whiteboardPronunciationWordMax)
}).describe('How a written word is said (`word_check.Respelling`).');

export type WhiteboardPronunciation = zod.input<typeof WhiteboardPronunciation>;
export type WhiteboardPronunciationOutput = zod.output<typeof WhiteboardPronunciation>;

export const whiteboardRoomDescriptionMax = 2000;

export const whiteboardRoomLightMax = 2000;

export const whiteboardRoomPaletteMax = 2000;

export const whiteboardRoomPlaceMax = 2000;

export const whiteboardRoomWhyMax = 2000;



export const WhiteboardRoom = zod.object({
  "description": zod.string().max(whiteboardRoomDescriptionMax),
  "light": zod.string().max(whiteboardRoomLightMax),
  "palette": zod.string().max(whiteboardRoomPaletteMax),
  "place": zod.string().max(whiteboardRoomPlaceMax),
  "why": zod.string().max(whiteboardRoomWhyMax)
}).describe('The room the presenter and the board stand in.');

export type WhiteboardRoom = zod.input<typeof WhiteboardRoom>;
export type WhiteboardRoomOutput = zod.output<typeof WhiteboardRoom>;

export const whiteboardScriptClaimsMax = 60;

export const whiteboardScriptLinesMax = 60;

export const whiteboardScriptPackTypeMax = 2000;

export const whiteboardScriptProblemMax = 2000;

export const whiteboardScriptProductNameMax = 2000;

export const whiteboardScriptPronunciationsMax = 60;



export const WhiteboardScript = zod.object({
  "claims": zod.array(ScriptClaim).max(whiteboardScriptClaimsMax),
  "end_card": WhiteboardEndCard,
  "lines": zod.array(WhiteboardScriptLine).min(1).max(whiteboardScriptLinesMax),
  "pack_type": zod.string().max(whiteboardScriptPackTypeMax),
  "presenter": WhiteboardPresenter,
  "problem": zod.string().max(whiteboardScriptProblemMax),
  "product_name": zod.string().max(whiteboardScriptProductNameMax),
  "pronunciations": zod.array(WhiteboardPronunciation).max(whiteboardScriptPronunciationsMax),
  "room": WhiteboardRoom
}).describe('The script director\'s answer (`whiteboardScriptSchema`), edited in the form before\napproval, or the ten blank lines a member writes ("Write the 10 lines yourself").');

export type WhiteboardScript = zod.input<typeof WhiteboardScript>;
export type WhiteboardScriptOutput = zod.output<typeof WhiteboardScript>;

export const pixarWhiteboardHeardWordEndMin = 0;
export const pixarWhiteboardHeardWordEndMax = 60;

export const pixarWhiteboardHeardWordStartMin = 0;
export const pixarWhiteboardHeardWordStartMax = 60;

export const pixarWhiteboardHeardWordTextMax = 200;



export const PixarWhiteboardHeardWord = zod.object({
  "end": zod.number().min(pixarWhiteboardHeardWordEndMin).max(pixarWhiteboardHeardWordEndMax),
  "start": zod.number().min(pixarWhiteboardHeardWordStartMin).max(pixarWhiteboardHeardWordStartMax),
  "text": zod.string().min(1).max(pixarWhiteboardHeardWordTextMax)
}).describe('A word heard in a picked take, in seconds from the take\'s start (its transcript, as the\ndraft keeps it).');

export type PixarWhiteboardHeardWord = zod.input<typeof PixarWhiteboardHeardWord>;
export type PixarWhiteboardHeardWordOutput = zod.output<typeof PixarWhiteboardHeardWord>;

export const pixarWhiteboardVideoTakeHeardDefault = [];
export const pixarWhiteboardVideoTakeHeardMax = 500;

export const pixarWhiteboardVideoTakeSecondsExclusiveMin = 0;
export const pixarWhiteboardVideoTakeSecondsMax = 60;



export const PixarWhiteboardVideoTake = zod.object({
  "heard": zod.array(PixarWhiteboardHeardWord).max(pixarWhiteboardVideoTakeHeardMax).default(pixarWhiteboardVideoTakeHeardDefault),
  "seconds": zod.number().gt(pixarWhiteboardVideoTakeSecondsExclusiveMin).max(pixarWhiteboardVideoTakeSecondsMax),
  "video": OutputRef
}).describe('A talking clip\'s picked take: its video, its delivered seconds (live\'s `realSeconds`)\nand the words its check heard (none: left uncaptioned).');

export type PixarWhiteboardVideoTake = zod.input<typeof PixarWhiteboardVideoTake>;
export type PixarWhiteboardVideoTakeOutput = zod.output<typeof PixarWhiteboardVideoTake>;

export const PixarWhiteboardVideoTakes = zod.object({
  "a": PixarWhiteboardVideoTake,
  "b": PixarWhiteboardVideoTake,
  "c": PixarWhiteboardVideoTake,
  "end_card": OutputRef
}).describe('The picked takes of A, B and C, and the end card\'s video.');

export type PixarWhiteboardVideoTakes = zod.input<typeof PixarWhiteboardVideoTakes>;
export type PixarWhiteboardVideoTakesOutput = zod.output<typeof PixarWhiteboardVideoTakes>;

export const pixarWhiteboardAdVideoInputsCaptionPositionDefault = `bottom`;
export const pixarWhiteboardAdVideoInputsCaptionStyleIdDefault = ``;
export const pixarWhiteboardAdVideoInputsCaptionStyleIdMax = 64;

export const pixarWhiteboardAdVideoInputsSubtitlesDefault = true;

export const PixarWhiteboardAdVideoInputs = zod.object({
  "caption_position": zod.enum(['top', 'center', 'bottom']).default(pixarWhiteboardAdVideoInputsCaptionPositionDefault),
  "caption_style_id": zod.string().max(pixarWhiteboardAdVideoInputsCaptionStyleIdMax).default(pixarWhiteboardAdVideoInputsCaptionStyleIdDefault),
  "script": WhiteboardScript,
  "subtitles": zod.boolean().default(pixarWhiteboardAdVideoInputsSubtitlesDefault),
  "takes": PixarWhiteboardVideoTakes,
  "template": zod.enum(['pixar-whiteboard-ad'])
}).describe('Pixar Whiteboard Ad\'s "Generate final video" (G14-pixar-whiteboard-ad PR f): the approved\nscript, each clip\'s picked take and the end card\'s, and the captions\' choice. One tile: the\nfour takes merged whole, or, captioned, A to C merged, live\'s two caption passes burned on\nthe written words at their heard times, then the end card joined.');

export type PixarWhiteboardAdVideoInputs = zod.input<typeof PixarWhiteboardAdVideoInputs>;
export type PixarWhiteboardAdVideoInputsOutput = zod.output<typeof PixarWhiteboardAdVideoInputs>;

export const YapperAdGivenBubble = zod.object({
  "clip": OutputRef,
  "cut": OutputRef
}).describe('The reply bubble an earlier run made, to keep: the clip of its still and the cut-out of that\nclip (the cut-out waits on the clip, so a rerun takes both).');

export type YapperAdGivenBubble = zod.input<typeof YapperAdGivenBubble>;
export type YapperAdGivenBubbleOutput = zod.output<typeof YapperAdGivenBubble>;

export const yapperAdAdaptationsArchetypeMax = 2000;

export const yapperAdAdaptationsProductHandlingMax = 2000;

export const yapperAdAdaptationsSettingMax = 2000;



export const YapperAdAdaptations = zod.object({
  "archetype": zod.string().max(yapperAdAdaptationsArchetypeMax),
  "product_handling": zod.string().max(yapperAdAdaptationsProductHandlingMax),
  "setting": zod.string().max(yapperAdAdaptationsSettingMax)
}).describe('The script director\'s three sentences of the setting, made to fit the product.');

export type YapperAdAdaptations = zod.input<typeof YapperAdAdaptations>;
export type YapperAdAdaptationsOutput = zod.output<typeof YapperAdAdaptations>;

export const YapperAdClipKind = zod.enum(['talk', 'insert']);

export type YapperAdClipKind = zod.input<typeof YapperAdClipKind>;
export type YapperAdClipKindOutput = zod.output<typeof YapperAdClipKind>;

export const YapperAdClipState = zod.enum(['static', 'walking', 'stopped', 'treadmill', 'lying']);

export type YapperAdClipState = zod.input<typeof YapperAdClipState>;
export type YapperAdClipStateOutput = zod.output<typeof YapperAdClipState>;

export const yapperAdClipBeatsItemMax = 2000;

export const yapperAdClipBeatsMax = 60;

export const yapperAdClipClaimIdsMax = 60;

export const yapperAdClipSpokenMax = 2000;

export const yapperAdClipTextMax = 2000;



export const YapperAdClip = zod.object({
  "beats": zod.array(zod.string().max(yapperAdClipBeatsItemMax)).max(yapperAdClipBeatsMax),
  "claim_ids": zod.array(zod.string()).max(yapperAdClipClaimIdsMax),
  "id": zod.int(),
  "kind": YapperAdClipKind,
  "spoken": zod.string().max(yapperAdClipSpokenMax),
  "state": YapperAdClipState,
  "text": zod.string().max(yapperAdClipTextMax),
  "topic_shift_before": zod.boolean()
}).describe('One clip of the script: its id (its place, from 1), its muse\'s beats, talk or insert, how\nthe person moves, whether the topic shifts before it, its line and how it is said, and the\nclaims it states.');

export type YapperAdClip = zod.input<typeof YapperAdClip>;
export type YapperAdClipOutput = zod.output<typeof YapperAdClip>;

export const yapperAdBubbleOnClipsMax = 60;

export const yapperAdBubblePositionMax = 2000;

export const yapperAdBubbleStyleMax = 2000;



export const YapperAdBubble = zod.object({
  "on_clips": zod.array(zod.int()).max(yapperAdBubbleOnClipsMax),
  "position": zod.string().max(yapperAdBubblePositionMax),
  "style": zod.string().max(yapperAdBubbleStyleMax)
}).describe('The reply bubble of a comment-bubble setting: the clips it covers, its look and place.');

export type YapperAdBubble = zod.input<typeof YapperAdBubble>;
export type YapperAdBubbleOutput = zod.output<typeof YapperAdBubble>;

export const YapperAdCameraRig = zod.enum(['handheld_selfie', 'overhead_selfie', 'propped', 'walking_selfie', 'car_selfie']);

export type YapperAdCameraRig = zod.input<typeof YapperAdCameraRig>;
export type YapperAdCameraRigOutput = zod.output<typeof YapperAdCameraRig>;

export const yapperAdCaptionsActiveColorMax = 40;



export const YapperAdCaptions = zod.object({
  "active_color": zod.string().max(yapperAdCaptionsActiveColorMax)
});

export type YapperAdCaptions = zod.input<typeof YapperAdCaptions>;
export type YapperAdCaptionsOutput = zod.output<typeof YapperAdCaptions>;

export const YapperAdMotion = zod.enum(['static', 'walking', 'walk_and_stop', 'treadmill', 'lying']);

export type YapperAdMotion = zod.input<typeof YapperAdMotion>;
export type YapperAdMotionOutput = zod.output<typeof YapperAdMotion>;

export const YapperAdMuseId = zod.enum(['yapper_muse', 'morning_story', 'confession', 'best_part', 'myth_reply']);

export type YapperAdMuseId = zod.input<typeof YapperAdMuseId>;
export type YapperAdMuseIdOutput = zod.output<typeof YapperAdMuseId>;

export const YapperAdPauses = zod.object({
  "between_s": zod.number(),
  "topic_s": zod.number()
}).describe('The silence kept between two clips, and before a clip that shifts the topic.');

export type YapperAdPauses = zod.input<typeof YapperAdPauses>;
export type YapperAdPausesOutput = zod.output<typeof YapperAdPauses>;

export const YapperAdFeature = zod.enum(['comment_bubble', 'pet', 'inserts', 'product_worn']);

export type YapperAdFeature = zod.input<typeof YapperAdFeature>;
export type YapperAdFeatureOutput = zod.output<typeof YapperAdFeature>;

export const yapperAdVoiceAccentMax = 2000;

export const yapperAdVoiceAmbienceMax = 2000;

export const yapperAdVoiceAudioMax = 2000;

export const yapperAdVoiceToneMax = 2000;



export const YapperAdVoice = zod.object({
  "accent": zod.string().max(yapperAdVoiceAccentMax),
  "ambience": zod.string().max(yapperAdVoiceAmbienceMax),
  "audio": zod.string().max(yapperAdVoiceAudioMax),
  "tone": zod.string().max(yapperAdVoiceToneMax)
}).describe('How the person sounds: the accent line, the tone, the voice and the room.');

export type YapperAdVoice = zod.input<typeof YapperAdVoice>;
export type YapperAdVoiceOutput = zod.output<typeof YapperAdVoice>;

export const yapperAdSettingApprovedCommentOneMax = 2000;

export const yapperAdSettingApprovedScriptOneItemMax = 2000;

export const yapperAdSettingApprovedScriptOneMax = 60;

export const yapperAdSettingArchetypeMax = 2000;

export const yapperAdSettingBriefOneMax = 2000;

export const yapperAdSettingCameraClipMax = 2000;

export const yapperAdSettingClipPlanItemItemMax = 2000;

export const yapperAdSettingClipPlanItemMax = 60;

export const yapperAdSettingClipPlanMax = 60;

export const yapperAdSettingExampleProductOneMax = 2000;

export const yapperAdSettingFramingStillMax = 2000;

export const yapperAdSettingIdMax = 64;

export const yapperAdSettingInsertRolesOneItemMax = 2000;

export const yapperAdSettingInsertRolesOneMax = 60;

export const yapperAdSettingInsertsMax = 2000;

export const yapperAdSettingLabelMax = 2000;

export const yapperAdSettingPetMax = 2000;

export const yapperAdSettingProductHandlingMax = 2000;

export const yapperAdSettingPropsItemMax = 2000;

export const yapperAdSettingPropsMax = 60;

export const yapperAdSettingRigLockMax = 2000;

export const yapperAdSettingRigNegativesMax = 2000;

export const yapperAdSettingSafetyItemMax = 2000;

export const yapperAdSettingSafetyMax = 60;

export const yapperAdSettingSettingMax = 2000;

export const yapperAdSettingSpecialFeaturesMax = 4;

export const yapperAdSettingTimeOfDayMax = 2000;

export const yapperAdSettingWalkStatesOneMax = 60;



export const YapperAdSetting = zod.object({
  "approved_comment": zod.union([zod.string().max(yapperAdSettingApprovedCommentOneMax),zod.null()]).exactOptional(),
  "approved_script": zod.union([zod.array(zod.string().max(yapperAdSettingApprovedScriptOneItemMax)).max(yapperAdSettingApprovedScriptOneMax),zod.null()]).exactOptional(),
  "archetype": zod.string().max(yapperAdSettingArchetypeMax),
  "bed": zod.enum(['none', 'music', 'ambience']),
  "brief": zod.union([zod.string().max(yapperAdSettingBriefOneMax),zod.null()]).exactOptional(),
  "bubble": zod.union([YapperAdBubble,zod.null()]).exactOptional(),
  "camera_clip": zod.string().max(yapperAdSettingCameraClipMax),
  "camera_rig": YapperAdCameraRig,
  "captions": YapperAdCaptions,
  "clip_count": zod.int(),
  "clip_plan": zod.array(zod.array(zod.string().max(yapperAdSettingClipPlanItemItemMax)).max(yapperAdSettingClipPlanItemMax)).max(yapperAdSettingClipPlanMax),
  "end_card": zod.boolean(),
  "example_product": zod.union([zod.string().max(yapperAdSettingExampleProductOneMax),zod.null()]).exactOptional(),
  "framing_still": zod.string().max(yapperAdSettingFramingStillMax),
  "id": zod.string().max(yapperAdSettingIdMax),
  "insert_roles": zod.union([zod.array(zod.string().max(yapperAdSettingInsertRolesOneItemMax)).max(yapperAdSettingInsertRolesOneMax),zod.null()]).exactOptional(),
  "inserts": zod.string().max(yapperAdSettingInsertsMax),
  "label": zod.string().max(yapperAdSettingLabelMax),
  "motion": YapperAdMotion,
  "muse": YapperAdMuseId,
  "pauses": YapperAdPauses,
  "pet": zod.string().max(yapperAdSettingPetMax),
  "product_handling": zod.string().max(yapperAdSettingProductHandlingMax),
  "pronoun": CastPronoun,
  "props": zod.array(zod.string().max(yapperAdSettingPropsItemMax)).max(yapperAdSettingPropsMax),
  "rig_lock": zod.string().max(yapperAdSettingRigLockMax),
  "rig_negatives": zod.string().max(yapperAdSettingRigNegativesMax),
  "safety": zod.array(zod.string().max(yapperAdSettingSafetyItemMax)).max(yapperAdSettingSafetyMax),
  "setting": zod.string().max(yapperAdSettingSettingMax),
  "special_features": zod.array(YapperAdFeature).max(yapperAdSettingSpecialFeaturesMax),
  "time_of_day": zod.string().max(yapperAdSettingTimeOfDayMax),
  "voice": YapperAdVoice,
  "walk_states": zod.union([zod.array(YapperAdClipState).max(yapperAdSettingWalkStatesOneMax),zod.null()]).exactOptional()
}).describe('A settled setting (live\'s `settledSettingSchema`): one of live\'s 13 presets without its\napproved locks, its three sentences adapted by the directors, or the setting the setting\ndirector designed (Auto). Its fields in live\'s order, the order the directors read it in.');

export type YapperAdSetting = zod.input<typeof YapperAdSetting>;
export type YapperAdSettingOutput = zod.output<typeof YapperAdSetting>;

export const yapperAdScriptCategoryMax = 2000;

export const yapperAdScriptClaimsMax = 60;

export const yapperAdScriptClipsMax = 60;

export const yapperAdScriptCommentMax = 2000;

export const yapperAdScriptProductNameMax = 2000;

export const yapperAdScriptPronunciationsMax = 60;

export const yapperAdScriptSettingIdMax = 64;

export const yapperAdScriptTopicMax = 2000;



export const YapperAdScript = zod.object({
  "adaptations": YapperAdAdaptations,
  "category": zod.string().max(yapperAdScriptCategoryMax),
  "claims": zod.array(ScriptClaim).max(yapperAdScriptClaimsMax),
  "clips": zod.array(YapperAdClip).max(yapperAdScriptClipsMax),
  "comment": zod.string().max(yapperAdScriptCommentMax),
  "end_card": EndCard,
  "product_name": zod.string().max(yapperAdScriptProductNameMax),
  "pronunciations": zod.array(Pronunciation).max(yapperAdScriptPronunciationsMax),
  "setting": YapperAdSetting,
  "setting_id": zod.string().max(yapperAdScriptSettingIdMax),
  "topic": zod.string().max(yapperAdScriptTopicMax)
}).describe('The script as approval 1 holds it (live\'s `yapperScriptSchema`): the director\'s answer\nwith the setting the template settled from it, edited in the form before approval.');

export type YapperAdScript = zod.input<typeof YapperAdScript>;
export type YapperAdScriptOutput = zod.output<typeof YapperAdScript>;

export const YapperAdProductState = zod.enum(['none', 'in_scene', 'held', 'worn']);

export type YapperAdProductState = zod.input<typeof YapperAdProductState>;
export type YapperAdProductStateOutput = zod.output<typeof YapperAdProductState>;

export const yapperAdPlannedShotActionMax = 2000;

export const yapperAdPlannedShotExtraNegativeMax = 2000;

export const yapperAdPlannedShotInsertCameraMax = 2000;

export const yapperAdPlannedShotPerformanceMax = 2000;

export const yapperAdPlannedShotPoseMax = 2000;

export const yapperAdPlannedShotProductNoteMax = 2000;



export const YapperAdPlannedShot = zod.object({
  "action": zod.string().max(yapperAdPlannedShotActionMax),
  "extra_negative": zod.string().max(yapperAdPlannedShotExtraNegativeMax),
  "id": zod.int(),
  "insert_camera": zod.string().max(yapperAdPlannedShotInsertCameraMax),
  "performance": zod.string().max(yapperAdPlannedShotPerformanceMax),
  "pet_in_frame": zod.boolean(),
  "pose": zod.string().max(yapperAdPlannedShotPoseMax),
  "product_note": zod.string().max(yapperAdPlannedShotProductNoteMax),
  "product_state": YapperAdProductState
}).describe('One clip as the clip director plans it (live\'s `plannedShotSchema`): its pose, action and\nperformance, where the product is, whether the pet shows, an insert\'s camera, and what to\nkeep out.');

export type YapperAdPlannedShot = zod.input<typeof YapperAdPlannedShot>;
export type YapperAdPlannedShotOutput = zod.output<typeof YapperAdPlannedShot>;

export const yapperAdShotAudioLineMax = 2000;

export const yapperAdShotCharLockMax = 2000;

export const yapperAdShotClipsMax = 60;

export const yapperAdShotInsertSetLockMax = 2000;

export const yapperAdShotPetLockMax = 2000;

export const yapperAdShotProductLockMax = 2000;

export const yapperAdShotProductLockClipMax = 2000;

export const yapperAdShotSetLockMax = 2000;

export const yapperAdShotSizeLineMax = 2000;

export const yapperAdShotVoiceLineMax = 2000;



export const YapperAdShot = zod.object({
  "audio_line": zod.string().max(yapperAdShotAudioLineMax),
  "char_lock": zod.string().max(yapperAdShotCharLockMax),
  "clips": zod.array(YapperAdPlannedShot).max(yapperAdShotClipsMax),
  "insert_set_lock": zod.string().max(yapperAdShotInsertSetLockMax),
  "pet_lock": zod.string().max(yapperAdShotPetLockMax),
  "product_lock": zod.string().max(yapperAdShotProductLockMax),
  "product_lock_clip": zod.string().max(yapperAdShotProductLockClipMax),
  "set_lock": zod.string().max(yapperAdShotSetLockMax),
  "sheet_wears_product": zod.boolean(),
  "size_line": zod.string().max(yapperAdShotSizeLineMax),
  "voice_line": zod.string().max(yapperAdShotVoiceLineMax)
}).describe('The shot the stills and the clips are made from (live\'s `Shot`): the locks and the settled\nclip plan.');

export type YapperAdShot = zod.input<typeof YapperAdShot>;
export type YapperAdShotOutput = zod.output<typeof YapperAdShot>;

export const YapperAdClipStill = zod.object({
  "clip": zod.int(),
  "still": OutputRef
}).describe('The picture clip `clip` starts on (`f<k>`, a talk clip\'s, or `i<k>`, an insert\'s): an\nearlier output, the draft\'s still.');

export type YapperAdClipStill = zod.input<typeof YapperAdClipStill>;
export type YapperAdClipStillOutput = zod.output<typeof YapperAdClipStill>;

export const yapperAdStillsClipsMax = 60;



export const YapperAdStills = zod.object({
  "bubble": zod.union([OutputRef,zod.null()]).exactOptional(),
  "clips": zod.array(YapperAdClipStill).max(yapperAdStillsClipsMax),
  "end_card": zod.union([OutputRef,zod.null()]).exactOptional(),
  "pet": zod.union([OutputRef,zod.null()]).exactOptional(),
  "sheet": OutputRef
}).describe('The pictures the run is made from (live\'s `stillUrls`): the character sheet, the pet where\nthe ad has one, each clip\'s still, the end card with the end card on, and the reply bubble\nwith a comment to show.');

export type YapperAdStills = zod.input<typeof YapperAdStills>;
export type YapperAdStillsOutput = zod.output<typeof YapperAdStills>;

export const YapperAdGivenTake = zod.object({
  "clip": zod.int(),
  "take": OutputRef
}).describe('A clip\'s take an earlier run delivered, taken as it is (Engine-8): the run never starts or\ncharges it, and checks it as any take.');

export type YapperAdGivenTake = zod.input<typeof YapperAdGivenTake>;
export type YapperAdGivenTakeOutput = zod.output<typeof YapperAdGivenTake>;

export const yapperAdVideoInputsCaptionPositionDefault = `bottom`;
export const yapperAdVideoInputsCaptionStyleIdDefault = ``;
export const yapperAdVideoInputsCaptionStyleIdMax = 64;

export const yapperAdVideoInputsEndCardDefault = true;
export const yapperAdVideoInputsHeldDefault = [];
export const yapperAdVideoInputsHeldMax = 60;

export const yapperAdVideoInputsResolutionDefault = `720p`;
export const yapperAdVideoInputsSubtitlesDefault = true;
export const yapperAdVideoInputsTakesDefault = [];
export const yapperAdVideoInputsTakesMax = 60;

export const yapperAdVideoInputsWalkLeadInDefault = false;

export const YapperAdVideoInputs = zod.object({
  "bubble_clip": zod.union([YapperAdGivenBubble,zod.null()]).exactOptional(),
  "caption_position": zod.enum(['top', 'center', 'bottom']).default(yapperAdVideoInputsCaptionPositionDefault),
  "caption_style_id": zod.string().max(yapperAdVideoInputsCaptionStyleIdMax).default(yapperAdVideoInputsCaptionStyleIdDefault),
  "end_card": zod.boolean().default(yapperAdVideoInputsEndCardDefault),
  "end_card_clip": zod.union([OutputRef,zod.null()]).exactOptional(),
  "held": zod.array(zod.int()).max(yapperAdVideoInputsHeldMax).default(yapperAdVideoInputsHeldDefault),
  "packshot": TemplateSource,
  "person": zod.union([ActorSource,zod.null()]).exactOptional(),
  "product_id": zod.union([zod.uuid(),zod.null()]).exactOptional(),
  "resolution": zod.enum(['720p', '1080p']).default(yapperAdVideoInputsResolutionDefault),
  "script": YapperAdScript,
  "shot": YapperAdShot,
  "stills": YapperAdStills,
  "subtitles": zod.boolean().default(yapperAdVideoInputsSubtitlesDefault),
  "takes": zod.array(YapperAdGivenTake).max(yapperAdVideoInputsTakesMax).default(yapperAdVideoInputsTakesDefault),
  "template": zod.enum(['yapper-ad']),
  "walk_lead_in": zod.boolean().default(yapperAdVideoInputsWalkLeadInDefault)
}).describe('Yapper Ad\'s "Generate video" (live\'s hand-off, spec G14-yapper-ad): the approved script and\nshot, every still, the person\'s photo where there is one, the product\'s packshot (the brand\nproduct\'s picture, an upload or the card\'s example, resolved into the snapshot at the start),\nthe captions, the resolution, the end card and the walking lead-in. One tile. `takes`: the\nclips an earlier run delivered, taken as they are, whether the first take or the retake; `held`:\nthe clips whose take the member accepted as it is ("Use the take as it is"); `end_card_clip` and\n`bubble_clip`: the end card\'s clip and the bubble an earlier run made, kept for the next press\nas live keeps them. A given take is accepted: it is checked again for its words but never\njudged again.');

export type YapperAdVideoInputs = zod.input<typeof YapperAdVideoInputs>;
export type YapperAdVideoInputsOutput = zod.output<typeof YapperAdVideoInputs>;

export const VideoTemplateInputs = zod.union([AnimateStaticAdInputs,ActorSwapInputs,HooksInputs,PromoteYourProductInputs,PersonalCloneInputs,TalkingHeadOverlayInputs,LanguageChangerInputs,HeroShotInputs,PodcastAdVideoInputs,StreetInterviewVideoInputs,PixarTalkingVideoInputs,PixarSingingAdVideoInputs,ChalkExplainerVideoInputs,GreenScreenVideoInputs,CartoonVideoInputs,FlatCartoonVideoInputs,ClaymationAdVideoInputs,AdSwapVideoInputs,PixarWhiteboardAdVideoInputs,GrwmVideoInputs,YapperAdVideoInputs]);

export type VideoTemplateInputs = zod.input<typeof VideoTemplateInputs>;
export type VideoTemplateInputsOutput = zod.output<typeof VideoTemplateInputs>;

export const TemplateInputs = zod.union([ImageTemplateInputs,VideoTemplateInputs]);

export type TemplateInputs = zod.input<typeof TemplateInputs>;
export type TemplateInputsOutput = zod.output<typeof TemplateInputs>;

export const UpscaleSettings = zod.object({
  "compression": zod.union([zod.number(),zod.null()]).exactOptional(),
  "grain": zod.union([zod.number(),zod.null()]).exactOptional(),
  "halo": zod.union([zod.number(),zod.null()]).exactOptional(),
  "noise": zod.union([zod.number(),zod.null()]).exactOptional(),
  "recover_detail": zod.union([zod.number(),zod.null()]).exactOptional(),
  "target_fps": zod.union([zod.int(),zod.null()]).exactOptional(),
  "upscale_factor": zod.union([zod.number(),zod.null()]).exactOptional()
}).describe('Video Upscale\'s settings, each within its model\'s range (live\'s `upscaleFactor`, ...): a\nsetting left out is not sent, but the factor, which takes the model\'s default.');

export type UpscaleSettings = zod.input<typeof UpscaleSettings>;
export type UpscaleSettingsOutput = zod.output<typeof UpscaleSettings>;

export const VoiceSwapParams = zod.object({
  "voice_id": zod.uuid()
}).describe('A voice swap\'s voice (#223); its source is the job\'s `source_video`.');

export type VoiceSwapParams = zod.input<typeof VoiceSwapParams>;
export type VoiceSwapParamsOutput = zod.output<typeof VoiceSwapParams>;

export const JobParams = zod.object({
  "actor": zod.union([AiActorParams,zod.null()]).exactOptional(),
  "ad_copy": zod.union([AdCopyBrief,zod.null()]).exactOptional(),
  "advanced": zod.union([AdvancedSettings,zod.null()]).exactOptional(),
  "aspect_ratio": zod.union([zod.string(),zod.null()]).exactOptional(),
  "audio": zod.union([AudioParams,zod.null()]).exactOptional(),
  "background": zod.union([BackgroundSettings,zod.null()]).exactOptional(),
  "dubbing": zod.union([DubbingSettings,zod.null()]).exactOptional(),
  "duration_seconds": zod.union([zod.int(),zod.null()]).exactOptional(),
  "elements": zod.union([zod.array(Element),zod.null()]).exactOptional(),
  "end_frame": zod.union([SourceRef,zod.null()]).exactOptional(),
  "generate_audio": zod.union([zod.boolean(),zod.null()]).exactOptional(),
  "keep_source_audio": zod.union([zod.boolean(),zod.null()]).exactOptional(),
  "lipsync": zod.union([LipsyncSettings,zod.null()]).exactOptional(),
  "middle_frames": zod.union([zod.array(SourceRef),zod.null()]).exactOptional(),
  "prompt": zod.union([zod.string(),zod.null()]),
  "reference_audios": zod.union([zod.array(AssetRef),zod.null()]).exactOptional(),
  "reference_images": zod.union([zod.array(ReferenceSource),zod.null()]).exactOptional(),
  "reference_videos": zod.union([zod.array(SourceRef),zod.null()]).exactOptional(),
  "references": zod.union([zod.array(ReferenceSource),zod.null()]).exactOptional(),
  "resolution": zod.union([zod.string(),zod.null()]).exactOptional(),
  "script": zod.union([ScriptParams,zod.null()]).exactOptional(),
  "shots": zod.union([zod.array(Shot),zod.null()]).exactOptional(),
  "source_audio": zod.union([SourceRef,zod.null()]).exactOptional(),
  "source_video": zod.union([TemplateSource,zod.null()]).exactOptional(),
  "start_frame": zod.union([TemplateSource,zod.null()]).exactOptional(),
  "style": zod.union([zod.string(),zod.null()]).exactOptional(),
  "talking_head": zod.union([TalkingHeadParams,zod.null()]).exactOptional(),
  "talking_head_advanced": zod.union([TalkingHeadAdvancedParams,zod.null()]).exactOptional(),
  "template": zod.union([TemplateInputs,zod.null()]).exactOptional(),
  "template_title": zod.union([zod.string(),zod.null()]).exactOptional(),
  "upscale": zod.union([UpscaleSettings,zod.null()]).exactOptional(),
  "voice_swap": zod.union([VoiceSwapParams,zod.null()]).exactOptional()
}).describe('What the job was asked to make, with the catalog\'s defaults applied.');

export type JobParams = zod.input<typeof JobParams>;
export type JobParamsOutput = zod.output<typeof JobParams>;

export const JobQuote = zod.object({
  "approximate": zod.boolean(),
  "credits_max": zod.int(),
  "credits_min": zod.int()
}).describe('What a job costs in credits: `credits_max` if every output is delivered (the hold),\n`credits_min` for one delivered output (a failed output costs nothing, D8). A template\nrun\'s, where its recipe quotes the run as live\'s form does (G14-template-costs): its steps\'\nholds summed, the minimums and the maximums each, approximate where live\'s is; else 0, the\nrun holding nothing itself (each step holds its own), and the form shows the stored figure.');

export type JobQuote = zod.input<typeof JobQuote>;
export type JobQuoteOutput = zod.output<typeof JobQuote>;

export const Job = zod.object({
  "brand_id": zod.union([zod.uuid(),zod.null()]),
  "catalog_version": zod.union([zod.string(),zod.null()]),
  "created_at": zod.iso.datetime({"offset":true}),
  "created_by": zod.union([zod.uuid(),zod.null()]),
  "deadline_at": zod.iso.datetime({"offset":true}),
  "error": zod.union([JobError,zod.null()]),
  "finished_at": zod.union([zod.iso.datetime({"offset":true}),zod.null()]),
  "id": zod.uuid(),
  "model": zod.union([zod.string(),zod.null()]),
  "outputs": zod.array(GenerationOutput),
  "params": zod.union([JobParams,zod.null()]),
  "quote": JobQuote,
  "started_at": zod.union([zod.iso.datetime({"offset":true}),zod.null()]),
  "status": JobStatus,
  "type": GenerationType,
  "urls_expire_at": zod.union([zod.iso.datetime({"offset":true}),zod.null()])
}).describe('A generation job. Status changes arrive as events (proposal 6.5); refetch this then.');

export type Job = zod.input<typeof Job>;
export type JobOutput = zod.output<typeof Job>;

export const JobActiveDetails = zod.object({
  "status": zod.enum(['queued', 'submitting', 'running', 'finalizing'])
}).describe('The status of a job that has not settled yet, so it cannot be deleted.');

export type JobActiveDetails = zod.input<typeof JobActiveDetails>;
export type JobActiveDetailsOutput = zod.output<typeof JobActiveDetails>;

export const JobGlobalActor = zod.object({
  "id": zod.uuid(),
  "image_url": zod.string(),
  "name": zod.string()
}).describe('A global actor the job took, with its portrait\'s signed URL (a team\'s own actor is read\nby `GET .../actors/{actor_id}`).');

export type JobGlobalActor = zod.input<typeof JobGlobalActor>;
export type JobGlobalActorOutput = zod.output<typeof JobGlobalActor>;

export const JobPromptTemplate = zod.object({
  "id": zod.uuid(),
  "name": zod.string()
}).describe('The prompt template a job was started from, by its name now.');

export type JobPromptTemplate = zod.input<typeof JobPromptTemplate>;
export type JobPromptTemplateOutput = zod.output<typeof JobPromptTemplate>;

export const JobVoice = zod.object({
  "id": zod.uuid(),
  "name": zod.string()
}).describe('A voice the job read with, by its name now.');

export type JobVoice = zod.input<typeof JobVoice>;
export type JobVoiceOutput = zod.output<typeof JobVoice>;

export const JobDetails = zod.object({
  "charged_credits": zod.union([zod.int(),zod.null()]),
  "global_actors": zod.array(JobGlobalActor),
  "job_id": zod.uuid(),
  "prompt_template": zod.union([JobPromptTemplate,zod.null()]).exactOptional(),
  "urls_expire_at": zod.union([zod.iso.datetime({"offset":true}),zod.null()]),
  "voices": zod.array(JobVoice)
}).describe('`GET /v1/teams/{team_id}/jobs/{job_id}/details`: what the lightbox\'s ⓘ shows of a job\nbeyond the job read (G1 decision 30): the credits it was charged in the end, its capture\nless any refund (null until it is charged: the quote stands), and the names and pictures of\nwhat its params name by id. A voice or a global actor gone since is left out.');

export type JobDetails = zod.input<typeof JobDetails>;
export type JobDetailsOutput = zod.output<typeof JobDetails>;

export const jobEventFrameProgressOneMin = 0;
export const jobEventFrameProgressOneMax = 1;

export const jobEventFrameProgressDefault = null;

export const JobEventFrame = zod.object({
  "job_id": zod.uuid(),
  "output_index": zod.union([zod.int(),zod.null()]),
  "output_status": zod.union([OutputStatus,zod.null()]),
  "progress": zod.union([zod.number().min(jobEventFrameProgressOneMin).max(jobEventFrameProgressOneMax),zod.null()]).default(jobEventFrameProgressDefault),
  "status": JobStatus
}).describe('The `data:` of a `job.transitioned` frame: one `platform.job_event` row, whose id is the\nframe\'s `id:`. Status only, so prompts and signed URLs never reach the channel; the client\nrefetches the job for the rest. `output_index` and `output_status` name the output that\nmoved, or are both null when the job itself did. `progress` is how far the running job was\nthen, 0 to 1, when its vendor says (#269); a new whole percent is a frame of its own, with\nthe status unchanged.');

export type JobEventFrame = zod.input<typeof JobEventFrame>;
export type JobEventFrameOutput = zod.output<typeof JobEventFrame>;

export const JobFinalizingDetails = zod.object({
  "job_id": zod.uuid()
}).describe('The job whose result is being collected: the vendor delivered and is paid.');

export type JobFinalizingDetails = zod.input<typeof JobFinalizingDetails>;
export type JobFinalizingDetailsOutput = zod.output<typeof JobFinalizingDetails>;

export const JobListStatus = zod.enum(['active', 'all']).describe('`active`: jobs not yet settled, the list a client reloads after missing events (proposal\n6.5). `all`: every job, the history.');

export type JobListStatus = zod.input<typeof JobListStatus>;
export type JobListStatusOutput = zod.output<typeof JobListStatus>;

export const JobPage = zod.object({
  "items": zod.array(Job),
  "next": zod.union([zod.string(),zod.null()])
}).describe('A page of a team\'s jobs, newest first (`GET /v1/teams/{team_id}/jobs`).');

export type JobPage = zod.input<typeof JobPage>;
export type JobPageOutput = zod.output<typeof JobPage>;

export const textActorDescriptionQuoteExpectedQuoteMaxOneMin = 0;

export const textActorDescriptionQuoteOutputsDefault = 1;
export const textActorDescriptionQuoteOutputsMax = 1;



export const TextActorDescriptionQuote = zod.object({
  "actor": ActorSource,
  "expected_quote_max": zod.union([zod.int().min(textActorDescriptionQuoteExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "outputs": zod.int().min(1).max(textActorDescriptionQuoteOutputsMax).default(textActorDescriptionQuoteOutputsDefault),
  "type": zod.enum(['text.actor_description'])
}).describe('A `TextActorDescriptionRequest` to price: the same body (it has no prompt).');

export type TextActorDescriptionQuote = zod.input<typeof TextActorDescriptionQuote>;
export type TextActorDescriptionQuoteOutput = zod.output<typeof TextActorDescriptionQuote>;

export const textAdCopyQuoteAwarenessLevelOneMax = 100;

export const textAdCopyQuoteCopiesDefault = 3;
export const textAdCopyQuoteCopiesMax = 5;

export const textAdCopyQuoteCurrencyOneMax = 10;

export const textAdCopyQuoteCurrentPriceOneMax = 50;

export const textAdCopyQuoteDiscountOffersOneMax = 500;

export const textAdCopyQuoteExpectedQuoteMaxOneMin = 0;

export const textAdCopyQuoteFreeGiftOffersOneMax = 500;

export const textAdCopyQuoteFunnelStageOneMax = 100;

export const textAdCopyQuoteOriginalPriceOneMax = 50;

export const textAdCopyQuoteOutputsDefault = 1;
export const textAdCopyQuoteOutputsMax = 1;

export const textAdCopyQuoteSavingsOneMax = 50;

export const textAdCopyQuoteTargetAudienceOneMax = 2000;

export const textAdCopyQuoteToneOfVoiceOneMax = 100;



export const TextAdCopyQuote = zod.object({
  "awareness_level": zod.union([zod.string().max(textAdCopyQuoteAwarenessLevelOneMax),zod.null()]).exactOptional(),
  "copies": zod.int().min(1).max(textAdCopyQuoteCopiesMax).default(textAdCopyQuoteCopiesDefault),
  "currency": zod.union([zod.string().max(textAdCopyQuoteCurrencyOneMax),zod.null()]).exactOptional(),
  "current_price": zod.union([zod.string().max(textAdCopyQuoteCurrentPriceOneMax),zod.null()]).exactOptional(),
  "discount_offers": zod.union([zod.string().max(textAdCopyQuoteDiscountOffersOneMax),zod.null()]).exactOptional(),
  "expected_quote_max": zod.union([zod.int().min(textAdCopyQuoteExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "free_gift_offers": zod.union([zod.string().max(textAdCopyQuoteFreeGiftOffersOneMax),zod.null()]).exactOptional(),
  "funnel_stage": zod.union([zod.string().max(textAdCopyQuoteFunnelStageOneMax),zod.null()]).exactOptional(),
  "original_price": zod.union([zod.string().max(textAdCopyQuoteOriginalPriceOneMax),zod.null()]).exactOptional(),
  "outputs": zod.int().min(1).max(textAdCopyQuoteOutputsMax).default(textAdCopyQuoteOutputsDefault),
  "product_data": zod.union([ProductData,zod.null()]).exactOptional(),
  "product_id": zod.union([zod.uuid(),zod.null()]).exactOptional(),
  "reference": zod.union([SourceRef,zod.null()]).exactOptional(),
  "savings": zod.union([zod.string().max(textAdCopyQuoteSavingsOneMax),zod.null()]).exactOptional(),
  "structure": zod.union([AdCreativeStructure,zod.null()]).exactOptional(),
  "target_audience": zod.union([zod.string().max(textAdCopyQuoteTargetAudienceOneMax),zod.null()]).exactOptional(),
  "tone_of_voice": zod.union([zod.string().max(textAdCopyQuoteToneOfVoiceOneMax),zod.null()]).exactOptional(),
  "type": zod.enum(['text.ad_copy'])
}).describe('A `TextAdCopyRequest` to price: the same body, since it has no prompt.');

export type TextAdCopyQuote = zod.input<typeof TextAdCopyQuote>;
export type TextAdCopyQuoteOutput = zod.output<typeof TextAdCopyQuote>;

export const textEnhanceQuoteExpectedQuoteMaxOneMin = 0;

export const textEnhanceQuoteOutputsDefault = 1;
export const textEnhanceQuoteOutputsMax = 1;

export const textEnhanceQuoteScriptDefault = ``;
export const textEnhanceQuoteScriptMax = 10000;



export const TextEnhanceQuote = zod.object({
  "expected_quote_max": zod.union([zod.int().min(textEnhanceQuoteExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "outputs": zod.int().min(1).max(textEnhanceQuoteOutputsMax).default(textEnhanceQuoteOutputsDefault),
  "script": zod.string().max(textEnhanceQuoteScriptMax).default(textEnhanceQuoteScriptDefault),
  "tool": ScriptTool,
  "type": zod.enum(['text.enhance'])
}).describe('A `TextEnhanceRequest` to price; its script may be empty.');

export type TextEnhanceQuote = zod.input<typeof TextEnhanceQuote>;
export type TextEnhanceQuoteOutput = zod.output<typeof TextEnhanceQuote>;

export const textGenerateQuoteExpectedQuoteMaxOneMin = 0;

export const textGenerateQuoteImagesMax = 16;

export const textGenerateQuoteModelMax = 64;


export const textGenerateQuoteModelRegExp = new RegExp('^[a-z0-9][a-z0-9.-]*$');
export const textGenerateQuoteOutputSchemaOneMin = 2;
export const textGenerateQuoteOutputSchemaOneMax = 100000;

export const textGenerateQuoteOutputTokensMax = 65536;

export const textGenerateQuoteOutputsDefault = 1;
export const textGenerateQuoteOutputsMax = 1;

export const textGenerateQuotePromptDefault = ``;
export const textGenerateQuotePromptMax = 32000;

export const textGenerateQuoteSystemDefault = ``;
export const textGenerateQuoteSystemMax = 100000;

export const textGenerateQuoteTemperatureOneMin = 0;
export const textGenerateQuoteTemperatureOneMax = 1;



export const TextGenerateQuote = zod.object({
  "claude": zod.union([ClaudeOptions,zod.null()]).exactOptional(),
  "expected_quote_max": zod.union([zod.int().min(textGenerateQuoteExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "gemini": zod.union([GeminiOptions,zod.null()]).exactOptional(),
  "images": zod.array(ReferenceSource).max(textGenerateQuoteImagesMax).exactOptional(),
  "model": zod.string().max(textGenerateQuoteModelMax).regex(textGenerateQuoteModelRegExp).describe('A catalog model id.'),
  "output_schema": zod.union([zod.string().min(textGenerateQuoteOutputSchemaOneMin).max(textGenerateQuoteOutputSchemaOneMax),zod.null()]).exactOptional(),
  "output_tokens": zod.int().min(1).max(textGenerateQuoteOutputTokensMax),
  "outputs": zod.int().min(1).max(textGenerateQuoteOutputsMax).default(textGenerateQuoteOutputsDefault),
  "prompt": zod.string().max(textGenerateQuotePromptMax).default(textGenerateQuotePromptDefault),
  "system": zod.string().max(textGenerateQuoteSystemMax).default(textGenerateQuoteSystemDefault),
  "temperature": zod.union([zod.number().min(textGenerateQuoteTemperatureOneMin).max(textGenerateQuoteTemperatureOneMax),zod.null()]).exactOptional(),
  "type": zod.enum(['text.generate'])
}).describe('A `TextGenerateRequest` to price; its prompts may be empty (the price reads neither).');

export type TextGenerateQuote = zod.input<typeof TextGenerateQuote>;
export type TextGenerateQuoteOutput = zod.output<typeof TextGenerateQuote>;

export const textScriptQuoteExpectedQuoteMaxOneMin = 0;

export const textScriptQuoteOutputsDefault = 1;
export const textScriptQuoteOutputsMax = 1;

export const textScriptQuotePromptDefault = ``;
export const textScriptQuotePromptMax = 32000;

export const textScriptQuoteToolDefault = 'talking_head';

export const TextScriptQuote = zod.object({
  "expected_quote_max": zod.union([zod.int().min(textScriptQuoteExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "outputs": zod.int().min(1).max(textScriptQuoteOutputsMax).default(textScriptQuoteOutputsDefault),
  "product_id": zod.union([zod.uuid(),zod.null()]).exactOptional(),
  "prompt": zod.string().max(textScriptQuotePromptMax).default(textScriptQuotePromptDefault),
  "tool": ScriptTool.default(textScriptQuoteToolDefault),
  "type": zod.enum(['text.script'])
}).describe('A `TextScriptRequest` to price; its brief may be empty.');

export type TextScriptQuote = zod.input<typeof TextScriptQuote>;
export type TextScriptQuoteOutput = zod.output<typeof TextScriptQuote>;

export const textShotListQuoteAvatarDescriptionDefault = ``;
export const textShotListQuoteAvatarDescriptionMax = 10000;

export const textShotListQuoteExpectedQuoteMaxOneMin = 0;

export const textShotListQuoteOutputsDefault = 1;
export const textShotListQuoteOutputsMax = 1;

export const textShotListQuoteProductDescriptionOneMax = 5000;

export const textShotListQuoteScriptMin = 10;
export const textShotListQuoteScriptMax = 10000;


export const textShotListQuoteScriptRegExp = new RegExp('[^\\t\\n\\v\\f\\r \\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000\\ufeff]');
export const textShotListQuoteVibeMax = 10000;


export const textShotListQuoteVibeRegExp = new RegExp('[^\\t\\n\\v\\f\\r \\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000\\ufeff]');


export const TextShotListQuote = zod.object({
  "avatar_description": zod.string().max(textShotListQuoteAvatarDescriptionMax).default(textShotListQuoteAvatarDescriptionDefault),
  "expected_quote_max": zod.union([zod.int().min(textShotListQuoteExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "outputs": zod.int().min(1).max(textShotListQuoteOutputsMax).default(textShotListQuoteOutputsDefault),
  "product_description": zod.union([zod.string().min(1).max(textShotListQuoteProductDescriptionOneMax),zod.null()]).exactOptional(),
  "product_id": zod.union([zod.uuid(),zod.null()]).exactOptional(),
  "script": zod.string().min(textShotListQuoteScriptMin).max(textShotListQuoteScriptMax).regex(textShotListQuoteScriptRegExp),
  "type": zod.enum(['text.shot_list']),
  "vibe": zod.string().min(1).max(textShotListQuoteVibeMax).regex(textShotListQuoteVibeRegExp)
}).describe('A `TextShotListRequest` to price: the same body (its prompts are the price\'s bound).');

export type TextShotListQuote = zod.input<typeof TextShotListQuote>;
export type TextShotListQuoteOutput = zod.output<typeof TextShotListQuote>;

export const VideoAudioLength = zod.enum(['video', 'audio']).describe('Which input sets the output\'s length: live\'s `VideoAudioLength`, lower case on our API.');

export type VideoAudioLength = zod.input<typeof VideoAudioLength>;
export type VideoAudioLengthOutput = zod.output<typeof VideoAudioLength>;

export const VideoAudioMode = zod.enum(['replace', 'mix']).describe('What becomes of the video\'s own sound: live\'s `VideoAudioMode`, lower case on our API.');

export type VideoAudioMode = zod.input<typeof VideoAudioMode>;
export type VideoAudioModeOutput = zod.output<typeof VideoAudioMode>;

export const videoAudioQuoteAudioGainDbDefault = 0;
export const videoAudioQuoteAudioGainDbMin = -60;
export const videoAudioQuoteAudioGainDbMax = 20;

export const videoAudioQuoteExpectedQuoteMaxOneMin = 0;

export const videoAudioQuoteLengthDefault = 'video';
export const videoAudioQuoteModeDefault = 'replace';
export const videoAudioQuoteModelMax = 64;


export const videoAudioQuoteModelRegExp = new RegExp('^[a-z0-9][a-z0-9.-]*$');
export const videoAudioQuoteOutputsDefault = 1;
export const videoAudioQuoteOutputsMax = 1;



export const VideoAudioQuote = zod.object({
  "audio": SourceRef,
  "audio_gain_db": zod.number().min(videoAudioQuoteAudioGainDbMin).max(videoAudioQuoteAudioGainDbMax).default(videoAudioQuoteAudioGainDbDefault),
  "expected_quote_max": zod.union([zod.int().min(videoAudioQuoteExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "length": VideoAudioLength.default(videoAudioQuoteLengthDefault),
  "mode": VideoAudioMode.default(videoAudioQuoteModeDefault),
  "model": zod.string().max(videoAudioQuoteModelMax).regex(videoAudioQuoteModelRegExp).describe('A catalog model id.'),
  "outputs": zod.int().min(1).max(videoAudioQuoteOutputsMax).default(videoAudioQuoteOutputsDefault),
  "type": zod.enum(['video.audio']),
  "video": SourceRef
}).describe('A `VideoAudioRequest` to price: the same body, since it has no prompt.');

export type VideoAudioQuote = zod.input<typeof VideoAudioQuote>;
export type VideoAudioQuoteOutput = zod.output<typeof VideoAudioQuote>;

export const videoBackgroundQuoteExpectedQuoteMaxOneMin = 0;

export const videoBackgroundQuoteModelMax = 64;


export const videoBackgroundQuoteModelRegExp = new RegExp('^[a-z0-9][a-z0-9.-]*$');


export const VideoBackgroundQuote = zod.object({
  "background_color": zod.union([zod.string(),zod.null()]).exactOptional(),
  "expected_quote_max": zod.union([zod.int().min(videoBackgroundQuoteExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "model": zod.string().max(videoBackgroundQuoteModelMax).regex(videoBackgroundQuoteModelRegExp).describe('A catalog model id.'),
  "preserve_audio": zod.union([zod.boolean(),zod.null()]).exactOptional(),
  "source_video": SourceRef,
  "subject_is_person": zod.union([zod.boolean(),zod.null()]).exactOptional(),
  "type": zod.enum(['video.background'])
}).describe('A `VideoBackgroundRequest` to price: the same body, since it has no prompt.');

export type VideoBackgroundQuote = zod.input<typeof VideoBackgroundQuote>;
export type VideoBackgroundQuoteOutput = zod.output<typeof VideoBackgroundQuote>;

export const VideoCaptionFont = zod.enum(['Inter-Bold', 'Fredoka-Bold', 'Montserrat-ExtraBold', 'Poppins-Bold']).describe('Live\'s four caption fonts (ui-templates\' `CAPTION_FONTS`), by their files\' names: each\nin `backend/data/fonts/captions/`.');

export type VideoCaptionFont = zod.input<typeof VideoCaptionFont>;
export type VideoCaptionFontOutput = zod.output<typeof VideoCaptionFont>;

export const VideoCaptionColorRegExp = new RegExp('^#(?:[0-9a-fA-F]{6}|[0-9a-fA-F]{8})$');


export const VideoCaptionColor = zod.string().regex(VideoCaptionColorRegExp);

export type VideoCaptionColor = zod.input<typeof VideoCaptionColor>;
export type VideoCaptionColorOutput = zod.output<typeof VideoCaptionColor>;

export const videoCaptionShadowBlurDefault = 8;
export const videoCaptionShadowBlurMin = 0;
export const videoCaptionShadowBlurMax = 64;

export const videoCaptionShadowColorDefault = '#000000AA';
export const videoCaptionShadowDxDefault = 0;
export const videoCaptionShadowDxMin = -64;
export const videoCaptionShadowDxMax = 64;

export const videoCaptionShadowDyDefault = 4;
export const videoCaptionShadowDyMin = -64;
export const videoCaptionShadowDyMax = 64;



export const VideoCaptionShadow = zod.object({
  "blur": zod.int().min(videoCaptionShadowBlurMin).max(videoCaptionShadowBlurMax).default(videoCaptionShadowBlurDefault),
  "color": VideoCaptionColor.default(videoCaptionShadowColorDefault),
  "dx": zod.int().min(videoCaptionShadowDxMin).max(videoCaptionShadowDxMax).default(videoCaptionShadowDxDefault),
  "dy": zod.int().min(videoCaptionShadowDyMin).max(videoCaptionShadowDyMax).default(videoCaptionShadowDyDefault)
}).describe('A drop shadow under the text (live\'s `SubtitleShadow`): its offset and blur in pixels at\na 1080 px short side, and its colour.');

export type VideoCaptionShadow = zod.input<typeof VideoCaptionShadow>;
export type VideoCaptionShadowOutput = zod.output<typeof VideoCaptionShadow>;

export const videoCaptionStyleActiveColorDefault = '#FFFFFF';
export const videoCaptionStyleAppearedColorDefault = '#FFFFFF';
export const videoCaptionStyleColorDefault = '#DADADA';
export const videoCaptionStyleFontSizeDefault = 64;
export const videoCaptionStyleFontSizeMin = 8;
export const videoCaptionStyleFontSizeMax = 400;

export const videoCaptionStyleOutlineColorDefault = '#000000';
export const videoCaptionStyleOutlineWidthDefault = 0;
export const videoCaptionStyleOutlineWidthMin = 0;
export const videoCaptionStyleOutlineWidthMax = 32;



export const VideoCaptionStyle = zod.object({
  "active_color": VideoCaptionColor.default(videoCaptionStyleActiveColorDefault),
  "active_fill_color": zod.union([VideoCaptionColor,zod.null()]).exactOptional(),
  "appeared_color": VideoCaptionColor.default(videoCaptionStyleAppearedColorDefault),
  "background_color": zod.union([VideoCaptionColor,zod.null()]).exactOptional(),
  "color": VideoCaptionColor.default(videoCaptionStyleColorDefault),
  "font_size": zod.int().min(videoCaptionStyleFontSizeMin).max(videoCaptionStyleFontSizeMax).default(videoCaptionStyleFontSizeDefault),
  "outline_color": VideoCaptionColor.default(videoCaptionStyleOutlineColorDefault),
  "outline_width": zod.int().min(videoCaptionStyleOutlineWidthMin).max(videoCaptionStyleOutlineWidthMax).default(videoCaptionStyleOutlineWidthDefault),
  "shadow": zod.union([VideoCaptionShadow,zod.null()]).exactOptional(),
  "text_transform": zod.union([zod.literal("uppercase"),zod.null()]).exactOptional()
}).describe('Live\'s caption look (`SubtitleStyle`, its defaults and bounds): the text\'s size at a\n1080 px short side; the colour of words not yet said, said, and being said; a box behind the\nword being said and one behind the line (none: no box); the outline; the shadow; the case.');

export type VideoCaptionStyle = zod.input<typeof VideoCaptionStyle>;
export type VideoCaptionStyleOutput = zod.output<typeof VideoCaptionStyle>;

export const videoCaptionWordTimingEndMin = 0;

export const videoCaptionWordTimingStartMin = 0;

export const videoCaptionWordTimingTextMax = 200;



export const VideoCaptionWordTiming = zod.object({
  "end": zod.number().min(videoCaptionWordTimingEndMin),
  "start": zod.number().min(videoCaptionWordTimingStartMin),
  "text": zod.string().min(1).max(videoCaptionWordTimingTextMax)
}).describe('A word as given, with its times in seconds from the video\'s start (live\'s\n`CaptionWordTimingPayloadDto`).');

export type VideoCaptionWordTiming = zod.input<typeof VideoCaptionWordTiming>;
export type VideoCaptionWordTimingOutput = zod.output<typeof VideoCaptionWordTiming>;

export const videoCaptionQuoteExpectedQuoteMaxOneMin = 0;

export const videoCaptionQuoteLanguageCodeOneMax = 16;


export const videoCaptionQuoteLanguageCodeOneRegExp = new RegExp('^[A-Za-z]{2,3}(?:[-_][A-Za-z0-9]{2,8})?$');
export const videoCaptionQuoteModelMax = 64;


export const videoCaptionQuoteModelRegExp = new RegExp('^[a-z0-9][a-z0-9.-]*$');
export const videoCaptionQuoteOutputsDefault = 1;
export const videoCaptionQuoteOutputsMax = 1;

export const videoCaptionQuotePositionDefault = 'bottom';
export const videoCaptionQuoteScriptOneMax = 20000;

export const videoCaptionQuoteStyleDefault = { active_color: '#FFFFFF', appeared_color: '#FFFFFF', color: '#DADADA', font_size: 64, outline_color: '#000000', outline_width: 0, };
export const videoCaptionQuoteWordsOneMax = 5000;



export const VideoCaptionQuote = zod.object({
  "expected_quote_max": zod.union([zod.int().min(videoCaptionQuoteExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "font": VideoCaptionFont,
  "language_code": zod.union([zod.string().max(videoCaptionQuoteLanguageCodeOneMax).regex(videoCaptionQuoteLanguageCodeOneRegExp),zod.null()]).exactOptional(),
  "model": zod.string().max(videoCaptionQuoteModelMax).regex(videoCaptionQuoteModelRegExp).describe('A catalog model id.'),
  "outputs": zod.int().min(1).max(videoCaptionQuoteOutputsMax).default(videoCaptionQuoteOutputsDefault),
  "position": VideoCaptionPosition.default(videoCaptionQuotePositionDefault),
  "script": zod.union([zod.string().min(1).max(videoCaptionQuoteScriptOneMax),zod.null()]).exactOptional(),
  "style": VideoCaptionStyle.default(videoCaptionQuoteStyleDefault),
  "type": zod.enum(['video.caption']),
  "video": SourceRef,
  "words": zod.union([zod.array(VideoCaptionWordTiming).min(1).max(videoCaptionQuoteWordsOneMax),zod.null()]).exactOptional()
}).describe('A `VideoCaptionRequest` to price: the same body, since it has no prompt.');

export type VideoCaptionQuote = zod.input<typeof VideoCaptionQuote>;
export type VideoCaptionQuoteOutput = zod.output<typeof VideoCaptionQuote>;

export const videoDubQuoteExpectedQuoteMaxOneMin = 0;

export const videoDubQuoteModelMax = 64;


export const videoDubQuoteModelRegExp = new RegExp('^[a-z0-9][a-z0-9.-]*$');
export const videoDubQuoteNumSpeakersOneMin = 0;
export const videoDubQuoteNumSpeakersOneMax = 100;

export const videoDubQuoteSourceLangOneRegExp = new RegExp('^[a-z]{2,4}$');
export const videoDubQuoteTargetLangOneRegExp = new RegExp('^[a-z]{2,4}$');


export const VideoDubQuote = zod.object({
  "drop_background_audio": zod.union([zod.boolean(),zod.null()]).exactOptional(),
  "expected_quote_max": zod.union([zod.int().min(videoDubQuoteExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "model": zod.string().max(videoDubQuoteModelMax).regex(videoDubQuoteModelRegExp).describe('A catalog model id.'),
  "num_speakers": zod.union([zod.int().min(videoDubQuoteNumSpeakersOneMin).max(videoDubQuoteNumSpeakersOneMax),zod.null()]).exactOptional(),
  "source_lang": zod.union([zod.string().regex(videoDubQuoteSourceLangOneRegExp),zod.null()]).exactOptional(),
  "source_video": TemplateSource,
  "target_lang": zod.union([zod.string().regex(videoDubQuoteTargetLangOneRegExp),zod.null()]).exactOptional(),
  "type": zod.enum(['video.dub'])
}).describe('A `VideoDubRequest` to price: the same body, since it has no prompt.');

export type VideoDubQuote = zod.input<typeof VideoDubQuote>;
export type VideoDubQuoteOutput = zod.output<typeof VideoDubQuote>;

export const videoEditQuoteDurationSecondsOneMin = 0;
export const videoEditQuoteDurationSecondsOneMax = 600;

export const videoEditQuoteElementsMax = 16;

export const videoEditQuoteExpectedQuoteMaxOneMin = 0;

export const videoEditQuoteKeepSourceAudioDefault = false;
export const videoEditQuoteModelMax = 64;


export const videoEditQuoteModelRegExp = new RegExp('^[a-z0-9][a-z0-9.-]*$');
export const videoEditQuoteOutputsDefault = 1;
export const videoEditQuoteOutputsMax = 16;

export const videoEditQuotePromptDefault = ``;
export const videoEditQuotePromptMax = 50000;

export const videoEditQuoteReferenceImagesMax = 64;

export const videoEditQuoteReferenceVideosMax = 64;



export const VideoEditQuote = zod.object({
  "advanced": zod.union([AdvancedSettings,zod.null()]).exactOptional(),
  "aspect_ratio": zod.union([zod.string(),zod.null()]).exactOptional(),
  "duration_seconds": zod.union([zod.int().min(videoEditQuoteDurationSecondsOneMin).max(videoEditQuoteDurationSecondsOneMax),zod.null()]).exactOptional(),
  "elements": zod.array(Element).max(videoEditQuoteElementsMax).exactOptional(),
  "expected_quote_max": zod.union([zod.int().min(videoEditQuoteExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "keep_source_audio": zod.boolean().default(videoEditQuoteKeepSourceAudioDefault),
  "model": zod.string().max(videoEditQuoteModelMax).regex(videoEditQuoteModelRegExp).describe('A catalog model id.'),
  "outputs": zod.int().min(1).max(videoEditQuoteOutputsMax).default(videoEditQuoteOutputsDefault),
  "prompt": zod.string().max(videoEditQuotePromptMax).default(videoEditQuotePromptDefault),
  "reference_images": zod.array(ReferenceSource).max(videoEditQuoteReferenceImagesMax).exactOptional(),
  "reference_videos": zod.array(SourceRef).max(videoEditQuoteReferenceVideosMax).exactOptional(),
  "resolution": zod.union([zod.string(),zod.null()]).exactOptional(),
  "source_video": TemplateSource,
  "type": zod.enum(['video.edit'])
}).describe('A `VideoEditRequest` to price; its prompt may be empty.');

export type VideoEditQuote = zod.input<typeof VideoEditQuote>;
export type VideoEditQuoteOutput = zod.output<typeof VideoEditQuote>;

export const videoExtendQuoteDurationSecondsOneMax = 600;

export const videoExtendQuoteExpectedQuoteMaxOneMin = 0;

export const videoExtendQuoteModelMax = 64;


export const videoExtendQuoteModelRegExp = new RegExp('^[a-z0-9][a-z0-9.-]*$');
export const videoExtendQuoteOutputsDefault = 1;
export const videoExtendQuoteOutputsMax = 16;

export const videoExtendQuotePromptDefault = ``;
export const videoExtendQuotePromptMax = 50000;



export const VideoExtendQuote = zod.object({
  "advanced": zod.union([AdvancedSettings,zod.null()]).exactOptional(),
  "duration_seconds": zod.union([zod.int().min(1).max(videoExtendQuoteDurationSecondsOneMax),zod.null()]).exactOptional(),
  "expected_quote_max": zod.union([zod.int().min(videoExtendQuoteExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "model": zod.string().max(videoExtendQuoteModelMax).regex(videoExtendQuoteModelRegExp).describe('A catalog model id.'),
  "outputs": zod.int().min(1).max(videoExtendQuoteOutputsMax).default(videoExtendQuoteOutputsDefault),
  "prompt": zod.string().max(videoExtendQuotePromptMax).default(videoExtendQuotePromptDefault),
  "resolution": zod.union([zod.string(),zod.null()]).exactOptional(),
  "source_video": SourceRef,
  "type": zod.enum(['video.extend'])
}).describe('A `VideoExtendRequest` to price; its prompt may be empty.');

export type VideoExtendQuote = zod.input<typeof VideoExtendQuote>;
export type VideoExtendQuoteOutput = zod.output<typeof VideoExtendQuote>;

export const videoFramesQuoteAtSecondsOneMax = 16;

export const videoFramesQuoteExpectedQuoteMaxOneMin = 0;

export const videoFramesQuoteModelMax = 64;


export const videoFramesQuoteModelRegExp = new RegExp('^[a-z0-9][a-z0-9.-]*$');
export const videoFramesQuoteOutputsDefault = 4;
export const videoFramesQuoteOutputsMax = 16;



export const VideoFramesQuote = zod.object({
  "at_seconds": zod.union([zod.array(zod.number()).min(1).max(videoFramesQuoteAtSecondsOneMax),zod.null()]).exactOptional(),
  "expected_quote_max": zod.union([zod.int().min(videoFramesQuoteExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "model": zod.string().max(videoFramesQuoteModelMax).regex(videoFramesQuoteModelRegExp).describe('A catalog model id.'),
  "outputs": zod.int().min(1).max(videoFramesQuoteOutputsMax).default(videoFramesQuoteOutputsDefault),
  "source_video": SourceRef,
  "type": zod.enum(['video.frames'])
}).describe('A `VideoFramesRequest` to price: the same body, since it has no prompt.');

export type VideoFramesQuote = zod.input<typeof VideoFramesQuote>;
export type VideoFramesQuoteOutput = zod.output<typeof VideoFramesQuote>;

export const videoImageQuoteDurationSecondsOneMax = 600;

export const videoImageQuoteElementsMax = 16;

export const videoImageQuoteExpectedQuoteMaxOneMin = 0;

export const videoImageQuoteMiddleFramesMax = 16;

export const videoImageQuoteModelMax = 64;


export const videoImageQuoteModelRegExp = new RegExp('^[a-z0-9][a-z0-9.-]*$');
export const videoImageQuoteOutputsDefault = 1;
export const videoImageQuoteOutputsMax = 16;

export const videoImageQuotePromptOneMax = 50000;

export const videoImageQuotePromptDefault = ``;
export const videoImageQuoteShotsOneMax = 30;



export const VideoImageQuote = zod.object({
  "advanced": zod.union([AdvancedSettings,zod.null()]).exactOptional(),
  "aspect_ratio": zod.union([zod.string(),zod.null()]).exactOptional(),
  "duration_seconds": zod.union([zod.int().min(1).max(videoImageQuoteDurationSecondsOneMax),zod.null()]).exactOptional(),
  "elements": zod.array(Element).max(videoImageQuoteElementsMax).exactOptional(),
  "end_frame": zod.union([SourceRef,zod.null()]).exactOptional(),
  "expected_quote_max": zod.union([zod.int().min(videoImageQuoteExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "generate_audio": zod.union([zod.boolean(),zod.null()]).exactOptional(),
  "middle_frames": zod.array(SourceRef).max(videoImageQuoteMiddleFramesMax).exactOptional(),
  "model": zod.string().max(videoImageQuoteModelMax).regex(videoImageQuoteModelRegExp).describe('A catalog model id.'),
  "outputs": zod.int().min(1).max(videoImageQuoteOutputsMax).default(videoImageQuoteOutputsDefault),
  "prompt": zod.union([zod.string().max(videoImageQuotePromptOneMax),zod.null()]).default(videoImageQuotePromptDefault),
  "resolution": zod.union([zod.string(),zod.null()]).exactOptional(),
  "shots": zod.union([zod.array(Shot).min(1).max(videoImageQuoteShotsOneMax),zod.null()]).exactOptional(),
  "start_frame": TemplateSource,
  "type": zod.enum(['video.image'])
}).describe('A `VideoImageRequest` to price; its prompt may be empty.');

export type VideoImageQuote = zod.input<typeof VideoImageQuote>;
export type VideoImageQuoteOutput = zod.output<typeof VideoImageQuote>;

export const videoLipsyncQuoteExpectedQuoteMaxOneMin = 0;

export const videoLipsyncQuoteModelMax = 64;


export const videoLipsyncQuoteModelRegExp = new RegExp('^[a-z0-9][a-z0-9.-]*$');
export const videoLipsyncQuoteSyncModeOneRegExp = new RegExp('^[a-z_]{1,32}$');


export const VideoLipsyncQuote = zod.object({
  "auto_detect": zod.union([zod.boolean(),zod.null()]).exactOptional(),
  "expected_quote_max": zod.union([zod.int().min(videoLipsyncQuoteExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "model": zod.string().max(videoLipsyncQuoteModelMax).regex(videoLipsyncQuoteModelRegExp).describe('A catalog model id.'),
  "source_audio": SourceRef,
  "source_video": SourceRef,
  "sync_mode": zod.union([zod.string().regex(videoLipsyncQuoteSyncModeOneRegExp),zod.null()]).exactOptional(),
  "type": zod.enum(['video.lipsync'])
}).describe('A `VideoLipsyncRequest` to price: the same body, since it has no prompt.');

export type VideoLipsyncQuote = zod.input<typeof VideoLipsyncQuote>;
export type VideoLipsyncQuoteOutput = zod.output<typeof VideoLipsyncQuote>;

export const mergeOutputFpsMax = 120;

export const mergeOutputHeightMin = 2;
export const mergeOutputHeightMax = 7680;

export const mergeOutputWidthMin = 2;
export const mergeOutputWidthMax = 7680;



export const MergeOutput = zod.object({
  "fps": zod.int().min(1).max(mergeOutputFpsMax),
  "height": zod.int().min(mergeOutputHeightMin).max(mergeOutputHeightMax),
  "width": zod.int().min(mergeOutputWidthMin).max(mergeOutputWidthMax)
}).describe('The joined video\'s frame and rate (live\'s `output`).');

export type MergeOutput = zod.input<typeof MergeOutput>;
export type MergeOutputOutput = zod.output<typeof MergeOutput>;

export const mergeSegmentEndSecondsOneExclusiveMin = 0;

export const mergeSegmentPunchInDefault = 1;
export const mergeSegmentPunchInMax = 1.3;

export const mergeSegmentSpeedDefault = 1;
export const mergeSegmentSpeedMin = 0.5;
export const mergeSegmentSpeedMax = 2;

export const mergeSegmentStartSecondsDefault = 0;
export const mergeSegmentStartSecondsMin = 0;



export const MergeSegment = zod.object({
  "end_seconds": zod.union([zod.number().gt(mergeSegmentEndSecondsOneExclusiveMin),zod.null()]).exactOptional(),
  "punch_in": zod.number().min(1).max(mergeSegmentPunchInMax).default(mergeSegmentPunchInDefault),
  "speed": zod.number().min(mergeSegmentSpeedMin).max(mergeSegmentSpeedMax).default(mergeSegmentSpeedDefault),
  "start_seconds": zod.number().min(mergeSegmentStartSecondsMin).default(mergeSegmentStartSecondsDefault),
  "video": SourceRef
}).describe('One cut of a video (live\'s segment): from `start_seconds` (0 by default) to `end_seconds`\n(none: the video\'s end), with an optional punch-in, a centred zoom held for the cut, and an\noptional `speed`, the cut played faster or slower, picture and sound (ours, G14-cartoon-clone:\na picture re-timed onto a voice).');

export type MergeSegment = zod.input<typeof MergeSegment>;
export type MergeSegmentOutput = zod.output<typeof MergeSegment>;

export const videoMergeQuoteAudioFadeMsOneMin = 0;
export const videoMergeQuoteAudioFadeMsOneMax = 50;

export const videoMergeQuoteExpectedQuoteMaxOneMin = 0;

export const videoMergeQuoteModelMax = 64;


export const videoMergeQuoteModelRegExp = new RegExp('^[a-z0-9][a-z0-9.-]*$');
export const videoMergeQuoteMuteDefault = false;
export const videoMergeQuoteOutputsDefault = 1;
export const videoMergeQuoteOutputsMax = 1;

export const videoMergeQuoteSegmentsOneMax = 50;

export const videoMergeQuoteVideosOneMax = 50;



export const VideoMergeQuote = zod.object({
  "audio_fade_ms": zod.union([zod.int().min(videoMergeQuoteAudioFadeMsOneMin).max(videoMergeQuoteAudioFadeMsOneMax),zod.null()]).exactOptional(),
  "expected_quote_max": zod.union([zod.int().min(videoMergeQuoteExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "model": zod.string().max(videoMergeQuoteModelMax).regex(videoMergeQuoteModelRegExp).describe('A catalog model id.'),
  "mute": zod.boolean().default(videoMergeQuoteMuteDefault),
  "output": zod.union([MergeOutput,zod.null()]).exactOptional(),
  "outputs": zod.int().min(1).max(videoMergeQuoteOutputsMax).default(videoMergeQuoteOutputsDefault),
  "segments": zod.union([zod.array(MergeSegment).min(1).max(videoMergeQuoteSegmentsOneMax),zod.null()]).exactOptional(),
  "type": zod.enum(['video.merge']),
  "videos": zod.union([zod.array(SourceRef).min(1).max(videoMergeQuoteVideosOneMax),zod.null()]).exactOptional()
}).describe('A `VideoMergeRequest` to price: the same body, since it has no prompt.');

export type VideoMergeQuote = zod.input<typeof VideoMergeQuote>;
export type VideoMergeQuoteOutput = zod.output<typeof VideoMergeQuote>;

export const videoMotionQuoteExpectedQuoteMaxOneMin = 0;

export const videoMotionQuoteModelMax = 64;


export const videoMotionQuoteModelRegExp = new RegExp('^[a-z0-9][a-z0-9.-]*$');
export const videoMotionQuotePromptOneMax = 50000;



export const VideoMotionQuote = zod.object({
  "expected_quote_max": zod.union([zod.int().min(videoMotionQuoteExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "model": zod.string().max(videoMotionQuoteModelMax).regex(videoMotionQuoteModelRegExp).describe('A catalog model id.'),
  "prompt": zod.union([zod.string().max(videoMotionQuotePromptOneMax),zod.null()]).exactOptional(),
  "source_video": SourceRef,
  "start_frame": SourceRef,
  "type": zod.enum(['video.motion'])
}).describe('A `VideoMotionRequest` to price: the same body, its prompt optional already.');

export type VideoMotionQuote = zod.input<typeof VideoMotionQuote>;
export type VideoMotionQuoteOutput = zod.output<typeof VideoMotionQuote>;

export const videoOverlayQuoteBaseAudioDbOneMin = -60;
export const videoOverlayQuoteBaseAudioDbOneMax = 0;

export const videoOverlayQuoteCanvasHeightOneMin = 2;
export const videoOverlayQuoteCanvasHeightOneMax = 7680;

export const videoOverlayQuoteCanvasWidthOneMin = 2;
export const videoOverlayQuoteCanvasWidthOneMax = 7680;

export const videoOverlayQuoteExpectedQuoteMaxOneMin = 0;

export const videoOverlayQuoteFpsOneMax = 120;

export const videoOverlayQuoteModelMax = 64;


export const videoOverlayQuoteModelRegExp = new RegExp('^[a-z0-9][a-z0-9.-]*$');
export const videoOverlayQuoteOutputsDefault = 1;
export const videoOverlayQuoteOutputsMax = 1;

export const videoOverlayQuoteOverlayWidthFracDefault = 0.4;
export const videoOverlayQuoteOverlayWidthFracExclusiveMin = 0;
export const videoOverlayQuoteOverlayWidthFracMax = 1;

export const videoOverlayQuotePositionDefault = 'bottom-right';
export const videoOverlayQuoteTightCropDefault = true;

export const VideoOverlayQuote = zod.object({
  "base_audio_db": zod.union([zod.number().min(videoOverlayQuoteBaseAudioDbOneMin).max(videoOverlayQuoteBaseAudioDbOneMax),zod.null()]).exactOptional(),
  "base_video": SourceRef,
  "canvas_height": zod.union([zod.int().min(videoOverlayQuoteCanvasHeightOneMin).max(videoOverlayQuoteCanvasHeightOneMax),zod.null()]).exactOptional(),
  "canvas_width": zod.union([zod.int().min(videoOverlayQuoteCanvasWidthOneMin).max(videoOverlayQuoteCanvasWidthOneMax),zod.null()]).exactOptional(),
  "expected_quote_max": zod.union([zod.int().min(videoOverlayQuoteExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "fps": zod.union([zod.int().min(1).max(videoOverlayQuoteFpsOneMax),zod.null()]).exactOptional(),
  "model": zod.string().max(videoOverlayQuoteModelMax).regex(videoOverlayQuoteModelRegExp).describe('A catalog model id.'),
  "outputs": zod.int().min(1).max(videoOverlayQuoteOutputsMax).default(videoOverlayQuoteOutputsDefault),
  "overlay_video": SourceRef,
  "overlay_width_frac": zod.number().gt(videoOverlayQuoteOverlayWidthFracExclusiveMin).max(videoOverlayQuoteOverlayWidthFracMax).default(videoOverlayQuoteOverlayWidthFracDefault),
  "position": OverlayPosition.default(videoOverlayQuotePositionDefault),
  "tight_crop": zod.boolean().default(videoOverlayQuoteTightCropDefault),
  "type": zod.enum(['video.overlay'])
}).describe('A `VideoOverlayRequest` to price: the same body, since it has no prompt.');

export type VideoOverlayQuote = zod.input<typeof VideoOverlayQuote>;
export type VideoOverlayQuoteOutput = zod.output<typeof VideoOverlayQuote>;

export const videoPixelSnapQuoteColorsDefault = 32;
export const videoPixelSnapQuoteColorsMin = 2;
export const videoPixelSnapQuoteColorsMax = 64;

export const videoPixelSnapQuoteColumnsDefault = 180;
export const videoPixelSnapQuoteColumnsMin = 16;
export const videoPixelSnapQuoteColumnsMax = 540;

export const videoPixelSnapQuoteExpectedQuoteMaxOneMin = 0;

export const videoPixelSnapQuoteModelMax = 64;


export const videoPixelSnapQuoteModelRegExp = new RegExp('^[a-z0-9][a-z0-9.-]*$');
export const videoPixelSnapQuoteOutputsDefault = 1;
export const videoPixelSnapQuoteOutputsMax = 1;

export const videoPixelSnapQuoteRowsDefault = 320;
export const videoPixelSnapQuoteRowsMin = 16;
export const videoPixelSnapQuoteRowsMax = 960;



export const VideoPixelSnapQuote = zod.object({
  "colors": zod.int().min(videoPixelSnapQuoteColorsMin).max(videoPixelSnapQuoteColorsMax).default(videoPixelSnapQuoteColorsDefault),
  "columns": zod.int().min(videoPixelSnapQuoteColumnsMin).max(videoPixelSnapQuoteColumnsMax).default(videoPixelSnapQuoteColumnsDefault),
  "expected_quote_max": zod.union([zod.int().min(videoPixelSnapQuoteExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "model": zod.string().max(videoPixelSnapQuoteModelMax).regex(videoPixelSnapQuoteModelRegExp).describe('A catalog model id.'),
  "outputs": zod.int().min(1).max(videoPixelSnapQuoteOutputsMax).default(videoPixelSnapQuoteOutputsDefault),
  "palette_image": SourceRef,
  "rows": zod.int().min(videoPixelSnapQuoteRowsMin).max(videoPixelSnapQuoteRowsMax).default(videoPixelSnapQuoteRowsDefault),
  "source_video": SourceRef,
  "type": zod.enum(['video.pixel_snap'])
}).describe('A `VideoPixelSnapRequest` to price: the same body, since it has no prompt.');

export type VideoPixelSnapQuote = zod.input<typeof VideoPixelSnapQuote>;
export type VideoPixelSnapQuoteOutput = zod.output<typeof VideoPixelSnapQuote>;

export const videoReferenceQuoteDurationSecondsOneMax = 600;

export const videoReferenceQuoteElementsMax = 16;

export const videoReferenceQuoteExpectedQuoteMaxOneMin = 0;

export const videoReferenceQuoteMiddleFramesMax = 16;

export const videoReferenceQuoteModelMax = 64;


export const videoReferenceQuoteModelRegExp = new RegExp('^[a-z0-9][a-z0-9.-]*$');
export const videoReferenceQuoteOutputsDefault = 1;
export const videoReferenceQuoteOutputsMax = 16;

export const videoReferenceQuotePromptOneMax = 50000;

export const videoReferenceQuotePromptDefault = ``;
export const videoReferenceQuoteReferenceAudiosMax = 64;

export const videoReferenceQuoteReferenceImagesMax = 64;

export const videoReferenceQuoteReferenceVideosMax = 64;

export const videoReferenceQuoteShotsOneMax = 30;



export const VideoReferenceQuote = zod.object({
  "advanced": zod.union([AdvancedSettings,zod.null()]).exactOptional(),
  "aspect_ratio": zod.union([zod.string(),zod.null()]).exactOptional(),
  "duration_seconds": zod.union([zod.int().min(1).max(videoReferenceQuoteDurationSecondsOneMax),zod.null()]).exactOptional(),
  "elements": zod.array(Element).max(videoReferenceQuoteElementsMax).exactOptional(),
  "end_frame": zod.union([SourceRef,zod.null()]).exactOptional(),
  "expected_quote_max": zod.union([zod.int().min(videoReferenceQuoteExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "generate_audio": zod.union([zod.boolean(),zod.null()]).exactOptional(),
  "middle_frames": zod.array(SourceRef).max(videoReferenceQuoteMiddleFramesMax).exactOptional(),
  "model": zod.string().max(videoReferenceQuoteModelMax).regex(videoReferenceQuoteModelRegExp).describe('A catalog model id.'),
  "outputs": zod.int().min(1).max(videoReferenceQuoteOutputsMax).default(videoReferenceQuoteOutputsDefault),
  "prompt": zod.union([zod.string().max(videoReferenceQuotePromptOneMax),zod.null()]).default(videoReferenceQuotePromptDefault),
  "reference_audios": zod.array(AssetRef).max(videoReferenceQuoteReferenceAudiosMax).exactOptional(),
  "reference_images": zod.array(ReferenceSource).max(videoReferenceQuoteReferenceImagesMax).exactOptional(),
  "reference_videos": zod.array(SourceRef).max(videoReferenceQuoteReferenceVideosMax).exactOptional(),
  "resolution": zod.union([zod.string(),zod.null()]).exactOptional(),
  "shots": zod.union([zod.array(Shot).min(1).max(videoReferenceQuoteShotsOneMax),zod.null()]).exactOptional(),
  "start_frame": zod.union([SourceRef,zod.null()]).exactOptional(),
  "type": zod.enum(['video.reference'])
}).describe('A `VideoReferenceRequest` to price; its prompt may be empty.');

export type VideoReferenceQuote = zod.input<typeof VideoReferenceQuote>;
export type VideoReferenceQuoteOutput = zod.output<typeof VideoReferenceQuote>;

export const videoReframeQuoteExpectedQuoteMaxOneMin = 0;

export const videoReframeQuoteModelMax = 64;


export const videoReframeQuoteModelRegExp = new RegExp('^[a-z0-9][a-z0-9.-]*$');


export const VideoReframeQuote = zod.object({
  "aspect_ratio": zod.union([zod.string(),zod.null()]).exactOptional(),
  "expected_quote_max": zod.union([zod.int().min(videoReframeQuoteExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "model": zod.string().max(videoReframeQuoteModelMax).regex(videoReframeQuoteModelRegExp).describe('A catalog model id.'),
  "resolution": zod.union([zod.string(),zod.null()]).exactOptional(),
  "source_video": SourceRef,
  "type": zod.enum(['video.reframe'])
}).describe('A `VideoReframeRequest` to price: the same body, since it has no prompt.');

export type VideoReframeQuote = zod.input<typeof VideoReframeQuote>;
export type VideoReframeQuoteOutput = zod.output<typeof VideoReframeQuote>;

export const videoShotsQuoteExpectedQuoteMaxOneMin = 0;

export const videoShotsQuoteModelMax = 64;


export const videoShotsQuoteModelRegExp = new RegExp('^[a-z0-9][a-z0-9.-]*$');
export const videoShotsQuoteOutputsDefault = 1;
export const videoShotsQuoteOutputsMax = 1;



export const VideoShotsQuote = zod.object({
  "expected_quote_max": zod.union([zod.int().min(videoShotsQuoteExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "model": zod.string().max(videoShotsQuoteModelMax).regex(videoShotsQuoteModelRegExp).describe('A catalog model id.'),
  "outputs": zod.int().min(1).max(videoShotsQuoteOutputsMax).default(videoShotsQuoteOutputsDefault),
  "source_video": SourceRef,
  "type": zod.enum(['video.shots'])
}).describe('A `VideoShotsRequest` to price: the same body, since it has no prompt.');

export type VideoShotsQuote = zod.input<typeof VideoShotsQuote>;
export type VideoShotsQuoteOutput = zod.output<typeof VideoShotsQuote>;

export const videoSpliceQuoteExpectedQuoteMaxOneMin = 0;

export const videoSpliceQuoteModelMax = 64;


export const videoSpliceQuoteModelRegExp = new RegExp('^[a-z0-9][a-z0-9.-]*$');
export const videoSpliceQuoteOutputsDefault = 1;
export const videoSpliceQuoteOutputsMax = 1;

export const videoSpliceQuoteSecondsExclusiveMin = 0;
export const videoSpliceQuoteSecondsMax = 60;

export const videoSpliceQuoteStartSecondsMin = 0;
export const videoSpliceQuoteStartSecondsMax = 600;



export const VideoSpliceQuote = zod.object({
  "base_video": SourceRef,
  "expected_quote_max": zod.union([zod.int().min(videoSpliceQuoteExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "insert_video": SourceRef,
  "model": zod.string().max(videoSpliceQuoteModelMax).regex(videoSpliceQuoteModelRegExp).describe('A catalog model id.'),
  "outputs": zod.int().min(1).max(videoSpliceQuoteOutputsMax).default(videoSpliceQuoteOutputsDefault),
  "seconds": zod.number().gt(videoSpliceQuoteSecondsExclusiveMin).max(videoSpliceQuoteSecondsMax),
  "start_seconds": zod.number().min(videoSpliceQuoteStartSecondsMin).max(videoSpliceQuoteStartSecondsMax),
  "type": zod.enum(['video.splice'])
}).describe('A `VideoSpliceRequest` to price: the same body, since it has no prompt.');

export type VideoSpliceQuote = zod.input<typeof VideoSpliceQuote>;
export type VideoSpliceQuoteOutput = zod.output<typeof VideoSpliceQuote>;

export const videoTalkingHeadQuoteExpectedQuoteMaxOneMin = 0;

export const videoTalkingHeadQuoteModelMax = 64;


export const videoTalkingHeadQuoteModelRegExp = new RegExp('^[a-z0-9][a-z0-9.-]*$');
export const videoTalkingHeadQuoteOutputsDefault = 1;
export const videoTalkingHeadQuoteOutputsMax = 1;



export const VideoTalkingHeadQuote = zod.object({
  "actor": ActorSource,
  "expected_quote_max": zod.union([zod.int().min(videoTalkingHeadQuoteExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "group": zod.union([zod.uuid(),zod.null()]).exactOptional(),
  "model": zod.string().max(videoTalkingHeadQuoteModelMax).regex(videoTalkingHeadQuoteModelRegExp).describe('A catalog model id.'),
  "outputs": zod.int().min(1).max(videoTalkingHeadQuoteOutputsMax).default(videoTalkingHeadQuoteOutputsDefault),
  "resolution": zod.union([zod.string(),zod.null()]).exactOptional(),
  "source_audio": SourceRef,
  "type": zod.enum(['video.talking_head'])
}).describe('A `VideoTalkingHeadRequest` to price: the same body, since it has no prompt (the audio\'s\nlength is the price, so it is named).');

export type VideoTalkingHeadQuote = zod.input<typeof VideoTalkingHeadQuote>;
export type VideoTalkingHeadQuoteOutput = zod.output<typeof VideoTalkingHeadQuote>;

export const videoTalkingHeadAdvancedQuoteActorDescriptionOneMax = 10000;

export const videoTalkingHeadAdvancedQuoteExpectedQuoteMaxOneMin = 0;

export const videoTalkingHeadAdvancedQuoteModelOneMax = 64;


export const videoTalkingHeadAdvancedQuoteModelOneRegExp = new RegExp('^[a-z0-9][a-z0-9.-]*$');
export const videoTalkingHeadAdvancedQuoteOutputsDefault = 1;
export const videoTalkingHeadAdvancedQuoteOutputsMax = 1;

export const videoTalkingHeadAdvancedQuoteProductDescriptionOneMax = 5000;

export const videoTalkingHeadAdvancedQuoteScriptDefault = ``;
export const videoTalkingHeadAdvancedQuoteScriptMax = 10000;

export const videoTalkingHeadAdvancedQuoteVibeDefault = ``;
export const videoTalkingHeadAdvancedQuoteVibeMax = 10000;

export const videoTalkingHeadAdvancedQuoteVideoModelOneMax = 64;


export const videoTalkingHeadAdvancedQuoteVideoModelOneRegExp = new RegExp('^[a-z0-9][a-z0-9.-]*$');


export const VideoTalkingHeadAdvancedQuote = zod.object({
  "actor": ReferenceSource,
  "actor_description": zod.union([zod.string().min(1).max(videoTalkingHeadAdvancedQuoteActorDescriptionOneMax),zod.null()]).exactOptional(),
  "aspect_ratio": zod.union([zod.string(),zod.null()]).exactOptional(),
  "every_product_picture": zod.union([zod.boolean(),zod.null()]).exactOptional(),
  "expected_quote_max": zod.union([zod.int().min(videoTalkingHeadAdvancedQuoteExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "group": zod.union([zod.uuid(),zod.null()]).exactOptional(),
  "model": zod.union([zod.string().max(videoTalkingHeadAdvancedQuoteModelOneMax).regex(videoTalkingHeadAdvancedQuoteModelOneRegExp),zod.null()]).exactOptional().describe('A catalog model id.'),
  "outputs": zod.int().min(1).max(videoTalkingHeadAdvancedQuoteOutputsMax).default(videoTalkingHeadAdvancedQuoteOutputsDefault),
  "product_description": zod.union([zod.string().min(1).max(videoTalkingHeadAdvancedQuoteProductDescriptionOneMax),zod.null()]).exactOptional(),
  "product_id": zod.union([zod.uuid(),zod.null()]).exactOptional(),
  "product_picture": zod.union([ExampleRef,zod.null()]).exactOptional(),
  "resolution": zod.union([zod.enum(['720p', '480p']),zod.null()]).exactOptional(),
  "script": zod.string().max(videoTalkingHeadAdvancedQuoteScriptMax).default(videoTalkingHeadAdvancedQuoteScriptDefault),
  "type": zod.enum(['video.talking_head_advanced']),
  "vibe": zod.string().max(videoTalkingHeadAdvancedQuoteVibeMax).default(videoTalkingHeadAdvancedQuoteVibeDefault),
  "video_model": zod.union([zod.string().max(videoTalkingHeadAdvancedQuoteVideoModelOneMax).regex(videoTalkingHeadAdvancedQuoteVideoModelOneRegExp),zod.null()]).exactOptional().describe('The clips\' catalog model.'),
  "voice_id": zod.uuid()
}).describe('A `VideoTalkingHeadAdvancedRequest` to price (nothing: each step holds its own price at its\nstart, as live\'s are charged); the script and the vibe may be empty.');

export type VideoTalkingHeadAdvancedQuote = zod.input<typeof VideoTalkingHeadAdvancedQuote>;
export type VideoTalkingHeadAdvancedQuoteOutput = zod.output<typeof VideoTalkingHeadAdvancedQuote>;

export const videoTemplateQuoteExpectedQuoteMaxOneMin = 0;

export const videoTemplateQuoteModelOneMax = 64;


export const videoTemplateQuoteModelOneRegExp = new RegExp('^[a-z0-9][a-z0-9.-]*$');


export const VideoTemplateQuote = zod.object({
  "expected_quote_max": zod.union([zod.int().min(videoTemplateQuoteExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "inputs": VideoTemplateInputs,
  "model": zod.union([zod.string().max(videoTemplateQuoteModelOneMax).regex(videoTemplateQuoteModelOneRegExp),zod.null()]).exactOptional().describe('A catalog model id.'),
  "type": zod.enum(['video.template'])
}).describe('A `VideoTemplateRequest` to price: nothing, as each step holds its own price at its\nstart, as live charges each step.');

export type VideoTemplateQuote = zod.input<typeof VideoTemplateQuote>;
export type VideoTemplateQuoteOutput = zod.output<typeof VideoTemplateQuote>;

export const videoTextQuoteDurationSecondsOneMax = 600;

export const videoTextQuoteElementsMax = 16;

export const videoTextQuoteExpectedQuoteMaxOneMin = 0;

export const videoTextQuoteModelMax = 64;


export const videoTextQuoteModelRegExp = new RegExp('^[a-z0-9][a-z0-9.-]*$');
export const videoTextQuoteOutputsDefault = 1;
export const videoTextQuoteOutputsMax = 16;

export const videoTextQuotePromptOneMax = 50000;

export const videoTextQuotePromptDefault = ``;
export const videoTextQuoteShotsOneMax = 30;



export const VideoTextQuote = zod.object({
  "advanced": zod.union([AdvancedSettings,zod.null()]).exactOptional(),
  "aspect_ratio": zod.union([zod.string(),zod.null()]).exactOptional(),
  "duration_seconds": zod.union([zod.int().min(1).max(videoTextQuoteDurationSecondsOneMax),zod.null()]).exactOptional(),
  "elements": zod.array(Element).max(videoTextQuoteElementsMax).exactOptional(),
  "expected_quote_max": zod.union([zod.int().min(videoTextQuoteExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "generate_audio": zod.union([zod.boolean(),zod.null()]).exactOptional(),
  "model": zod.string().max(videoTextQuoteModelMax).regex(videoTextQuoteModelRegExp).describe('A catalog model id.'),
  "outputs": zod.int().min(1).max(videoTextQuoteOutputsMax).default(videoTextQuoteOutputsDefault),
  "prompt": zod.union([zod.string().max(videoTextQuotePromptOneMax),zod.null()]).default(videoTextQuotePromptDefault),
  "resolution": zod.union([zod.string(),zod.null()]).exactOptional(),
  "shots": zod.union([zod.array(Shot).min(1).max(videoTextQuoteShotsOneMax),zod.null()]).exactOptional(),
  "type": zod.enum(['video.text'])
}).describe('A `VideoTextRequest` to price; its prompt may be empty.');

export type VideoTextQuote = zod.input<typeof VideoTextQuote>;
export type VideoTextQuoteOutput = zod.output<typeof VideoTextQuote>;

export const videoUpscaleQuoteExpectedQuoteMaxOneMin = 0;

export const videoUpscaleQuoteModelMax = 64;


export const videoUpscaleQuoteModelRegExp = new RegExp('^[a-z0-9][a-z0-9.-]*$');


export const VideoUpscaleQuote = zod.object({
  "compression": zod.union([zod.number(),zod.null()]).exactOptional(),
  "expected_quote_max": zod.union([zod.int().min(videoUpscaleQuoteExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "grain": zod.union([zod.number(),zod.null()]).exactOptional(),
  "halo": zod.union([zod.number(),zod.null()]).exactOptional(),
  "model": zod.string().max(videoUpscaleQuoteModelMax).regex(videoUpscaleQuoteModelRegExp).describe('A catalog model id.'),
  "noise": zod.union([zod.number(),zod.null()]).exactOptional(),
  "recover_detail": zod.union([zod.number(),zod.null()]).exactOptional(),
  "source_video": SourceRef,
  "target_fps": zod.union([zod.int(),zod.null()]).exactOptional(),
  "type": zod.enum(['video.upscale']),
  "upscale_factor": zod.union([zod.number(),zod.null()]).exactOptional()
}).describe('A `VideoUpscaleRequest` to price: the same body, since it has no prompt.');

export type VideoUpscaleQuote = zod.input<typeof VideoUpscaleQuote>;
export type VideoUpscaleQuoteOutput = zod.output<typeof VideoUpscaleQuote>;

export const videoVoiceSwapQuoteExpectedQuoteMaxOneMin = 0;

export const videoVoiceSwapQuoteModelMax = 64;


export const videoVoiceSwapQuoteModelRegExp = new RegExp('^[a-z0-9][a-z0-9.-]*$');
export const videoVoiceSwapQuoteOutputsDefault = 1;
export const videoVoiceSwapQuoteOutputsMax = 1;



export const VideoVoiceSwapQuote = zod.object({
  "expected_quote_max": zod.union([zod.int().min(videoVoiceSwapQuoteExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "model": zod.string().max(videoVoiceSwapQuoteModelMax).regex(videoVoiceSwapQuoteModelRegExp).describe('A catalog model id.'),
  "outputs": zod.int().min(1).max(videoVoiceSwapQuoteOutputsMax).default(videoVoiceSwapQuoteOutputsDefault),
  "source_video": SourceRef,
  "type": zod.enum(['video.voice_swap']),
  "voice_id": zod.union([zod.uuid(),zod.null()]).exactOptional()
}).describe('A `VideoVoiceSwapRequest` to price: the source\'s length is the price; the voice may be\nleft out until it is chosen.');

export type VideoVoiceSwapQuote = zod.input<typeof VideoVoiceSwapQuote>;
export type VideoVoiceSwapQuoteOutput = zod.output<typeof VideoVoiceSwapQuote>;

export const voiceCloneQuoteExpectedQuoteMaxOneMin = 0;

export const voiceCloneQuoteModelMax = 64;


export const voiceCloneQuoteModelRegExp = new RegExp('^[a-z0-9][a-z0-9.-]*$');
export const voiceCloneQuoteNameMax = 99;

export const voiceCloneQuoteOutputsDefault = 1;
export const voiceCloneQuoteOutputsMax = 1;



export const VoiceCloneQuote = zod.object({
  "expected_quote_max": zod.union([zod.int().min(voiceCloneQuoteExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "model": zod.string().max(voiceCloneQuoteModelMax).regex(voiceCloneQuoteModelRegExp).describe('A catalog model id.'),
  "name": zod.string().min(1).max(voiceCloneQuoteNameMax),
  "outputs": zod.int().min(1).max(voiceCloneQuoteOutputsMax).default(voiceCloneQuoteOutputsDefault),
  "source_audio": SourceRef,
  "type": zod.enum(['voice.clone'])
}).describe('A `VoiceCloneRequest` to price: the same body, since it has no prompt.');

export type VoiceCloneQuote = zod.input<typeof VoiceCloneQuote>;
export type VoiceCloneQuoteOutput = zod.output<typeof VoiceCloneQuote>;

export const voiceDesignQuoteExpectedQuoteMaxOneMin = 0;

export const voiceDesignQuoteModelMax = 64;


export const voiceDesignQuoteModelRegExp = new RegExp('^[a-z0-9][a-z0-9.-]*$');
export const voiceDesignQuoteOutputsDefault = 1;
export const voiceDesignQuoteOutputsMax = 1;

export const voiceDesignQuotePromptDefault = ``;
export const voiceDesignQuotePromptMax = 32000;



export const VoiceDesignQuote = zod.object({
  "expected_quote_max": zod.union([zod.int().min(voiceDesignQuoteExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "model": zod.string().max(voiceDesignQuoteModelMax).regex(voiceDesignQuoteModelRegExp).describe('A catalog model id.'),
  "outputs": zod.int().min(1).max(voiceDesignQuoteOutputsMax).default(voiceDesignQuoteOutputsDefault),
  "prompt": zod.string().max(voiceDesignQuotePromptMax).default(voiceDesignQuotePromptDefault),
  "type": zod.enum(['voice.design'])
}).describe('A `VoiceDesignRequest` to price (free, as live\'s); its prompt may be empty.');

export type VoiceDesignQuote = zod.input<typeof VoiceDesignQuote>;
export type VoiceDesignQuoteOutput = zod.output<typeof VoiceDesignQuote>;

export const VoiceNameMax = 99;


export const VoiceNameRegExp = new RegExp('[^\\t\\n\\v\\f\\r \\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000\\ufeff]');


export const VoiceName = zod.string().min(1).max(VoiceNameMax).regex(VoiceNameRegExp);

export type VoiceName = zod.input<typeof VoiceName>;
export type VoiceNameOutput = zod.output<typeof VoiceName>;

export const voiceProfileQuoteExpectedQuoteMaxOneMin = 0;

export const voiceProfileQuoteModelMax = 64;


export const voiceProfileQuoteModelRegExp = new RegExp('^[a-z0-9][a-z0-9.-]*$');
export const voiceProfileQuoteOutputsDefault = 1;
export const voiceProfileQuoteOutputsMax = 1;



export const VoiceProfileQuote = zod.object({
  "expected_quote_max": zod.union([zod.int().min(voiceProfileQuoteExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "model": zod.string().max(voiceProfileQuoteModelMax).regex(voiceProfileQuoteModelRegExp).describe('A catalog model id.'),
  "name": VoiceName,
  "outputs": zod.int().min(1).max(voiceProfileQuoteOutputsMax).default(voiceProfileQuoteOutputsDefault),
  "source": SourceRef,
  "type": zod.enum(['voice.profile'])
}).describe('A `VoiceProfileRequest` to price: the same body, since it has no prompt.');

export type VoiceProfileQuote = zod.input<typeof VoiceProfileQuote>;
export type VoiceProfileQuoteOutput = zod.output<typeof VoiceProfileQuote>;

export const JobQuoteRequest = zod.union([AudioExtractQuote,AudioMusicQuote,AudioSfxQuote,AudioTtsQuote,AudioVoiceoverQuote,CaptionTranscribeQuote,ExtractBrandQuote,ExtractProductQuote,ImageActorQuote,ImageAdvancedQuote,ImageAnalysisQuote,ImageLayerEditQuote,ImageLayerizeQuote,ImageSimpleQuote,ImageTemplateQuote,ImageTweakQuote,TextActorDescriptionQuote,TextAdCopyQuote,TextEnhanceQuote,TextGenerateQuote,TextScriptQuote,TextShotListQuote,VideoAudioQuote,VideoBackgroundQuote,VideoCaptionQuote,VideoDubQuote,VideoEditQuote,VideoExtendQuote,VideoFramesQuote,VideoImageQuote,VideoLipsyncQuote,VideoMergeQuote,VideoMotionQuote,VideoOverlayQuote,VideoPixelSnapQuote,VideoReferenceQuote,VideoReframeQuote,VideoShotsQuote,VideoSpliceQuote,VideoTalkingHeadQuote,VideoTalkingHeadAdvancedQuote,VideoTemplateQuote,VideoTextQuote,VideoUpscaleQuote,VideoVoiceSwapQuote,VoiceCloneQuote,VoiceDesignQuote,VoiceProfileQuote]);

export type JobQuoteRequest = zod.input<typeof JobQuoteRequest>;
export type JobQuoteRequestOutput = zod.output<typeof JobQuoteRequest>;

export const textActorDescriptionRequestExpectedQuoteMaxOneMin = 0;

export const textActorDescriptionRequestOutputsDefault = 1;
export const textActorDescriptionRequestOutputsMax = 1;



export const TextActorDescriptionRequest = zod.object({
  "actor": ActorSource,
  "expected_quote_max": zod.union([zod.int().min(textActorDescriptionRequestExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "outputs": zod.int().min(1).max(textActorDescriptionRequestOutputsMax).default(textActorDescriptionRequestOutputsDefault),
  "type": zod.enum(['text.actor_description'])
}).describe('An actor\'s description from its portrait (#223, live\'s step A\'): the portrait (`actor`),\nsent alone, and Claude\'s description of it, one plain-text output. The Advanced Talking\nHead\'s run starts it for a team\'s actor that has no description yet; no form does. No\nprompt and no model: its AI task runs it on its row (spec G9-ai-tasks).');

export type TextActorDescriptionRequest = zod.input<typeof TextActorDescriptionRequest>;
export type TextActorDescriptionRequestOutput = zod.output<typeof TextActorDescriptionRequest>;

export const textAdCopyRequestAwarenessLevelOneMax = 100;

export const textAdCopyRequestCopiesDefault = 3;
export const textAdCopyRequestCopiesMax = 5;

export const textAdCopyRequestCurrencyOneMax = 10;

export const textAdCopyRequestCurrentPriceOneMax = 50;

export const textAdCopyRequestDiscountOffersOneMax = 500;

export const textAdCopyRequestExpectedQuoteMaxOneMin = 0;

export const textAdCopyRequestFreeGiftOffersOneMax = 500;

export const textAdCopyRequestFunnelStageOneMax = 100;

export const textAdCopyRequestOriginalPriceOneMax = 50;

export const textAdCopyRequestOutputsDefault = 1;
export const textAdCopyRequestOutputsMax = 1;

export const textAdCopyRequestSavingsOneMax = 50;

export const textAdCopyRequestTargetAudienceOneMax = 2000;

export const textAdCopyRequestToneOfVoiceOneMax = 100;



export const TextAdCopyRequest = zod.object({
  "awareness_level": zod.union([zod.string().max(textAdCopyRequestAwarenessLevelOneMax),zod.null()]).exactOptional(),
  "copies": zod.int().min(1).max(textAdCopyRequestCopiesMax).default(textAdCopyRequestCopiesDefault),
  "currency": zod.union([zod.string().max(textAdCopyRequestCurrencyOneMax),zod.null()]).exactOptional(),
  "current_price": zod.union([zod.string().max(textAdCopyRequestCurrentPriceOneMax),zod.null()]).exactOptional(),
  "discount_offers": zod.union([zod.string().max(textAdCopyRequestDiscountOffersOneMax),zod.null()]).exactOptional(),
  "expected_quote_max": zod.union([zod.int().min(textAdCopyRequestExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "free_gift_offers": zod.union([zod.string().max(textAdCopyRequestFreeGiftOffersOneMax),zod.null()]).exactOptional(),
  "funnel_stage": zod.union([zod.string().max(textAdCopyRequestFunnelStageOneMax),zod.null()]).exactOptional(),
  "original_price": zod.union([zod.string().max(textAdCopyRequestOriginalPriceOneMax),zod.null()]).exactOptional(),
  "outputs": zod.int().min(1).max(textAdCopyRequestOutputsMax).default(textAdCopyRequestOutputsDefault),
  "product_data": zod.union([ProductData,zod.null()]).exactOptional(),
  "product_id": zod.union([zod.uuid(),zod.null()]).exactOptional(),
  "reference": zod.union([SourceRef,zod.null()]).exactOptional(),
  "savings": zod.union([zod.string().max(textAdCopyRequestSavingsOneMax),zod.null()]).exactOptional(),
  "structure": zod.union([AdCreativeStructure,zod.null()]).exactOptional(),
  "target_audience": zod.union([zod.string().max(textAdCopyRequestTargetAudienceOneMax),zod.null()]).exactOptional(),
  "tone_of_voice": zod.union([zod.string().max(textAdCopyRequestToneOfVoiceOneMax),zod.null()]).exactOptional(),
  "type": zod.enum(['text.ad_copy'])
}).describe('AI-generated ad copies (G8, #217): one JSON output, a title and up to ten ad texts,\neach with `copies` variations. No prompt: live\'s prompt is built from the brief and the\nproduct. No model: the AI task `ad_copy.text` picks the row (spec G9-ai-tasks).');

export type TextAdCopyRequest = zod.input<typeof TextAdCopyRequest>;
export type TextAdCopyRequestOutput = zod.output<typeof TextAdCopyRequest>;

export const textEnhanceRequestExpectedQuoteMaxOneMin = 0;

export const textEnhanceRequestOutputsDefault = 1;
export const textEnhanceRequestOutputsMax = 1;

export const textEnhanceRequestScriptMax = 10000;


export const textEnhanceRequestScriptRegExp = new RegExp('[^\\t\\n\\v\\f\\r \\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000\\ufeff]');


export const TextEnhanceRequest = zod.object({
  "expected_quote_max": zod.union([zod.int().min(textEnhanceRequestExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "outputs": zod.int().min(1).max(textEnhanceRequestOutputsMax).default(textEnhanceRequestOutputsDefault),
  "script": zod.string().min(1).max(textEnhanceRequestScriptMax).regex(textEnhanceRequestScriptRegExp),
  "tool": ScriptTool,
  "type": zod.enum(['text.enhance'])
}).describe('Live\'s Enhance Script (#224): the script as written, with ElevenLabs v3 audio tags\ninserted. One plain-text output. No prompt: live\'s prompt is built from the script.');

export type TextEnhanceRequest = zod.input<typeof TextEnhanceRequest>;
export type TextEnhanceRequestOutput = zod.output<typeof TextEnhanceRequest>;

export const textGenerateRequestExpectedQuoteMaxOneMin = 0;

export const textGenerateRequestImagesMax = 16;

export const textGenerateRequestModelMax = 64;


export const textGenerateRequestModelRegExp = new RegExp('^[a-z0-9][a-z0-9.-]*$');
export const textGenerateRequestOutputSchemaOneMin = 2;
export const textGenerateRequestOutputSchemaOneMax = 100000;

export const textGenerateRequestOutputTokensMax = 65536;

export const textGenerateRequestOutputsDefault = 1;
export const textGenerateRequestOutputsMax = 1;

export const textGenerateRequestPromptMax = 100000;


export const textGenerateRequestPromptRegExp = new RegExp('[^\\t\\n\\v\\f\\r \\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000\\ufeff]');
export const textGenerateRequestSystemMax = 100000;


export const textGenerateRequestSystemRegExp = new RegExp('[^\\t\\n\\v\\f\\r \\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000\\ufeff]');
export const textGenerateRequestTemperatureOneMin = 0;
export const textGenerateRequestTemperatureOneMax = 1;



export const TextGenerateRequest = zod.object({
  "claude": zod.union([ClaudeOptions,zod.null()]).exactOptional(),
  "expected_quote_max": zod.union([zod.int().min(textGenerateRequestExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "gemini": zod.union([GeminiOptions,zod.null()]).exactOptional(),
  "images": zod.array(ReferenceSource).max(textGenerateRequestImagesMax).exactOptional(),
  "model": zod.string().max(textGenerateRequestModelMax).regex(textGenerateRequestModelRegExp).describe('A catalog model id.'),
  "output_schema": zod.union([zod.string().min(textGenerateRequestOutputSchemaOneMin).max(textGenerateRequestOutputSchemaOneMax),zod.null()]).exactOptional(),
  "output_tokens": zod.int().min(1).max(textGenerateRequestOutputTokensMax),
  "outputs": zod.int().min(1).max(textGenerateRequestOutputsMax).default(textGenerateRequestOutputsDefault),
  "prompt": zod.string().min(1).max(textGenerateRequestPromptMax).regex(textGenerateRequestPromptRegExp),
  "system": zod.string().min(1).max(textGenerateRequestSystemMax).regex(textGenerateRequestSystemRegExp),
  "temperature": zod.union([zod.number().min(textGenerateRequestTemperatureOneMin).max(textGenerateRequestTemperatureOneMax),zod.null()]).exactOptional(),
  "type": zod.enum(['text.generate'])
}).describe('One LLM call (live\'s `TEXT_GENERATION`): the catalog row (`model`), the system instruction\nand the prompt, the pictures it shows (each an earlier output, a library image, an actor\'s\nportrait or an example input, shown before the prompt), the answer\'s JSON schema (none: plain\ntext), the most it may write (`output_tokens`), and Claude\'s options or Gemini\'s, as the row\'s\nmaker takes. One output.');

export type TextGenerateRequest = zod.input<typeof TextGenerateRequest>;
export type TextGenerateRequestOutput = zod.output<typeof TextGenerateRequest>;

export const textScriptRequestExpectedQuoteMaxOneMin = 0;

export const textScriptRequestOutputsDefault = 1;
export const textScriptRequestOutputsMax = 1;

export const textScriptRequestPromptMin = 10;
export const textScriptRequestPromptMax = 32000;


export const textScriptRequestPromptRegExp = new RegExp('[^\\t\\n\\v\\f\\r \\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000\\ufeff]');
export const textScriptRequestToolDefault = 'talking_head';

export const TextScriptRequest = zod.object({
  "expected_quote_max": zod.union([zod.int().min(textScriptRequestExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "outputs": zod.int().min(1).max(textScriptRequestOutputsMax).default(textScriptRequestOutputsDefault),
  "product_id": zod.union([zod.uuid(),zod.null()]).exactOptional(),
  "prompt": zod.string().min(textScriptRequestPromptMin).max(textScriptRequestPromptMax).regex(textScriptRequestPromptRegExp),
  "tool": ScriptTool.default(textScriptRequestToolDefault),
  "type": zod.enum(['text.script'])
}).describe('Live\'s Generate Script (#224): a spoken ad script from the user\'s brief and, if named, a\nproduct of the brand. One plain-text output. The brief is live\'s `userPrompt`, which its\npanel asks for at 10 characters or more.');

export type TextScriptRequest = zod.input<typeof TextScriptRequest>;
export type TextScriptRequestOutput = zod.output<typeof TextScriptRequest>;

export const textShotListRequestAvatarDescriptionDefault = ``;
export const textShotListRequestAvatarDescriptionMax = 10000;

export const textShotListRequestExpectedQuoteMaxOneMin = 0;

export const textShotListRequestOutputsDefault = 1;
export const textShotListRequestOutputsMax = 1;

export const textShotListRequestProductDescriptionOneMax = 5000;

export const textShotListRequestScriptMin = 10;
export const textShotListRequestScriptMax = 10000;


export const textShotListRequestScriptRegExp = new RegExp('[^\\t\\n\\v\\f\\r \\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000\\ufeff]');
export const textShotListRequestVibeMax = 10000;


export const textShotListRequestVibeRegExp = new RegExp('[^\\t\\n\\v\\f\\r \\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000\\ufeff]');


export const TextShotListRequest = zod.object({
  "avatar_description": zod.string().max(textShotListRequestAvatarDescriptionMax).default(textShotListRequestAvatarDescriptionDefault),
  "expected_quote_max": zod.union([zod.int().min(textShotListRequestExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "outputs": zod.int().min(1).max(textShotListRequestOutputsMax).default(textShotListRequestOutputsDefault),
  "product_description": zod.union([zod.string().min(1).max(textShotListRequestProductDescriptionOneMax),zod.null()]).exactOptional(),
  "product_id": zod.union([zod.uuid(),zod.null()]).exactOptional(),
  "script": zod.string().min(textShotListRequestScriptMin).max(textShotListRequestScriptMax).regex(textShotListRequestScriptRegExp),
  "type": zod.enum(['text.shot_list']),
  "vibe": zod.string().min(1).max(textShotListRequestVibeMax).regex(textShotListRequestVibeRegExp)
}).describe('One actor\'s shot list for live\'s Talking Head Advanced (#223): the script, the vibe (live\'s\n"Vibe / Direction"), the actor\'s description, and the product if one is named. One JSON\noutput. The Advanced run starts it; no form does. The description may be empty, as live\nsends it for an actor picked from the library\'s images.');

export type TextShotListRequest = zod.input<typeof TextShotListRequest>;
export type TextShotListRequestOutput = zod.output<typeof TextShotListRequest>;

export const videoAudioRequestAudioGainDbDefault = 0;
export const videoAudioRequestAudioGainDbMin = -60;
export const videoAudioRequestAudioGainDbMax = 20;

export const videoAudioRequestExpectedQuoteMaxOneMin = 0;

export const videoAudioRequestLengthDefault = 'video';
export const videoAudioRequestModeDefault = 'replace';
export const videoAudioRequestModelMax = 64;


export const videoAudioRequestModelRegExp = new RegExp('^[a-z0-9][a-z0-9.-]*$');
export const videoAudioRequestOutputsDefault = 1;
export const videoAudioRequestOutputsMax = 1;



export const VideoAudioRequest = zod.object({
  "audio": SourceRef,
  "audio_gain_db": zod.number().min(videoAudioRequestAudioGainDbMin).max(videoAudioRequestAudioGainDbMax).default(videoAudioRequestAudioGainDbDefault),
  "expected_quote_max": zod.union([zod.int().min(videoAudioRequestExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "length": VideoAudioLength.default(videoAudioRequestLengthDefault),
  "mode": VideoAudioMode.default(videoAudioRequestModeDefault),
  "model": zod.string().max(videoAudioRequestModelMax).regex(videoAudioRequestModelRegExp).describe('A catalog model id.'),
  "outputs": zod.int().min(1).max(videoAudioRequestOutputsMax).default(videoAudioRequestOutputsDefault),
  "type": zod.enum(['video.audio']),
  "video": SourceRef
}).describe('A track laid under a video (live\'s `VIDEO_AUDIO`): the catalog row (`model`), the video\nand the track (each an earlier output or a library file; the track an MP3, WAV or M4A),\nwhether the video\'s own sound is dropped or kept under it, the track\'s gain in decibels, and\nwhich of the two sets the length. One output.');

export type VideoAudioRequest = zod.input<typeof VideoAudioRequest>;
export type VideoAudioRequestOutput = zod.output<typeof VideoAudioRequest>;

export const videoBackgroundRequestExpectedQuoteMaxOneMin = 0;

export const videoBackgroundRequestModelMax = 64;


export const videoBackgroundRequestModelRegExp = new RegExp('^[a-z0-9][a-z0-9.-]*$');


export const VideoBackgroundRequest = zod.object({
  "background_color": zod.union([zod.string(),zod.null()]).exactOptional(),
  "expected_quote_max": zod.union([zod.int().min(videoBackgroundRequestExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "model": zod.string().max(videoBackgroundRequestModelMax).regex(videoBackgroundRequestModelRegExp).describe('A catalog model id.'),
  "preserve_audio": zod.union([zod.boolean(),zod.null()]).exactOptional(),
  "source_video": SourceRef,
  "subject_is_person": zod.union([zod.boolean(),zod.null()]).exactOptional(),
  "type": zod.enum(['video.background'])
}).describe('Remove or replace a video\'s background (an earlier output or a library video), live\'s\nEdit Background tool (G7, #213): no prompt, one video, free as live.');

export type VideoBackgroundRequest = zod.input<typeof VideoBackgroundRequest>;
export type VideoBackgroundRequestOutput = zod.output<typeof VideoBackgroundRequest>;

export const videoCaptionRequestExpectedQuoteMaxOneMin = 0;

export const videoCaptionRequestLanguageCodeOneMax = 16;


export const videoCaptionRequestLanguageCodeOneRegExp = new RegExp('^[A-Za-z]{2,3}(?:[-_][A-Za-z0-9]{2,8})?$');
export const videoCaptionRequestModelMax = 64;


export const videoCaptionRequestModelRegExp = new RegExp('^[a-z0-9][a-z0-9.-]*$');
export const videoCaptionRequestOutputsDefault = 1;
export const videoCaptionRequestOutputsMax = 1;

export const videoCaptionRequestPositionDefault = 'bottom';
export const videoCaptionRequestScriptOneMax = 20000;

export const videoCaptionRequestStyleDefault = { active_color: '#FFFFFF', appeared_color: '#FFFFFF', color: '#DADADA', font_size: 64, outline_color: '#000000', outline_width: 0, };
export const videoCaptionRequestWordsOneMax = 5000;



export const VideoCaptionRequest = zod.object({
  "expected_quote_max": zod.union([zod.int().min(videoCaptionRequestExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "font": VideoCaptionFont,
  "language_code": zod.union([zod.string().max(videoCaptionRequestLanguageCodeOneMax).regex(videoCaptionRequestLanguageCodeOneRegExp),zod.null()]).exactOptional(),
  "model": zod.string().max(videoCaptionRequestModelMax).regex(videoCaptionRequestModelRegExp).describe('A catalog model id.'),
  "outputs": zod.int().min(1).max(videoCaptionRequestOutputsMax).default(videoCaptionRequestOutputsDefault),
  "position": VideoCaptionPosition.default(videoCaptionRequestPositionDefault),
  "script": zod.union([zod.string().min(1).max(videoCaptionRequestScriptOneMax),zod.null()]).exactOptional(),
  "style": VideoCaptionStyle.default(videoCaptionRequestStyleDefault),
  "type": zod.enum(['video.caption']),
  "video": SourceRef,
  "words": zod.union([zod.array(VideoCaptionWordTiming).min(1).max(videoCaptionRequestWordsOneMax),zod.null()]).exactOptional()
}).describe('Captions burned into a video (live\'s `AUTO_CAPTION`): the catalog row (`model`), the\nvideo (an earlier output or a library video), the font, the style and the position, and\nwhere the words\' times come from, in live\'s order: `words` as given, else `script` aligned\nto the speech, else the speech transcribed (in `language_code` where given). One output.');

export type VideoCaptionRequest = zod.input<typeof VideoCaptionRequest>;
export type VideoCaptionRequestOutput = zod.output<typeof VideoCaptionRequest>;

export const videoDubRequestExpectedQuoteMaxOneMin = 0;

export const videoDubRequestModelMax = 64;


export const videoDubRequestModelRegExp = new RegExp('^[a-z0-9][a-z0-9.-]*$');
export const videoDubRequestNumSpeakersOneMin = 0;
export const videoDubRequestNumSpeakersOneMax = 100;

export const videoDubRequestSourceLangOneRegExp = new RegExp('^[a-z]{2,4}$');
export const videoDubRequestTargetLangOneRegExp = new RegExp('^[a-z]{2,4}$');


export const VideoDubRequest = zod.object({
  "drop_background_audio": zod.union([zod.boolean(),zod.null()]).exactOptional(),
  "expected_quote_max": zod.union([zod.int().min(videoDubRequestExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "model": zod.string().max(videoDubRequestModelMax).regex(videoDubRequestModelRegExp).describe('A catalog model id.'),
  "num_speakers": zod.union([zod.int().min(videoDubRequestNumSpeakersOneMin).max(videoDubRequestNumSpeakersOneMax),zod.null()]).exactOptional(),
  "source_lang": zod.union([zod.string().regex(videoDubRequestSourceLangOneRegExp),zod.null()]).exactOptional(),
  "source_video": TemplateSource,
  "target_lang": zod.union([zod.string().regex(videoDubRequestTargetLangOneRegExp),zod.null()]).exactOptional(),
  "type": zod.enum(['video.dub'])
}).describe('Dub a video (an earlier output or a library video) into another language, live\'s Video\nDubbing tool (G7-video-dubbing, #215): no prompt, one video, priced by its source\'s length.');

export type VideoDubRequest = zod.input<typeof VideoDubRequest>;
export type VideoDubRequestOutput = zod.output<typeof VideoDubRequest>;

export const videoEditRequestDurationSecondsOneMin = 0;
export const videoEditRequestDurationSecondsOneMax = 600;

export const videoEditRequestElementsMax = 16;

export const videoEditRequestExpectedQuoteMaxOneMin = 0;

export const videoEditRequestKeepSourceAudioDefault = false;
export const videoEditRequestModelMax = 64;


export const videoEditRequestModelRegExp = new RegExp('^[a-z0-9][a-z0-9.-]*$');
export const videoEditRequestOutputsDefault = 1;
export const videoEditRequestOutputsMax = 16;

export const videoEditRequestPromptMax = 32000;


export const videoEditRequestPromptRegExp = new RegExp('[^\\t\\n\\v\\f\\r \\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000\\ufeff]');
export const videoEditRequestReferenceImagesMax = 64;

export const videoEditRequestReferenceVideosMax = 64;



export const VideoEditRequest = zod.object({
  "advanced": zod.union([AdvancedSettings,zod.null()]).exactOptional(),
  "aspect_ratio": zod.union([zod.string(),zod.null()]).exactOptional(),
  "duration_seconds": zod.union([zod.int().min(videoEditRequestDurationSecondsOneMin).max(videoEditRequestDurationSecondsOneMax),zod.null()]).exactOptional(),
  "elements": zod.array(Element).max(videoEditRequestElementsMax).exactOptional(),
  "expected_quote_max": zod.union([zod.int().min(videoEditRequestExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "keep_source_audio": zod.boolean().default(videoEditRequestKeepSourceAudioDefault),
  "model": zod.string().max(videoEditRequestModelMax).regex(videoEditRequestModelRegExp).describe('A catalog model id.'),
  "outputs": zod.int().min(1).max(videoEditRequestOutputsMax).default(videoEditRequestOutputsDefault),
  "prompt": zod.string().min(1).max(videoEditRequestPromptMax).regex(videoEditRequestPromptRegExp),
  "reference_images": zod.array(ReferenceSource).max(videoEditRequestReferenceImagesMax).exactOptional(),
  "reference_videos": zod.array(SourceRef).max(videoEditRequestReferenceVideosMax).exactOptional(),
  "resolution": zod.union([zod.string(),zod.null()]).exactOptional(),
  "source_video": TemplateSource,
  "type": zod.enum(['video.edit'])
}).describe('Remake a video (an earlier output or a library video), live\'s Video Edit tool (G7, #209):\nwith reference images and elements where the model takes them, and the source\'s sound kept\nwhere the model can. Its length is the source\'s, or, where the model offers one, the chosen\n`duration_seconds` (0: the source\'s). A reference image may be an actor\'s portrait (Actor\nSwap\'s edit, G14).');

export type VideoEditRequest = zod.input<typeof VideoEditRequest>;
export type VideoEditRequestOutput = zod.output<typeof VideoEditRequest>;

export const videoExtendRequestDurationSecondsOneMax = 600;

export const videoExtendRequestExpectedQuoteMaxOneMin = 0;

export const videoExtendRequestModelMax = 64;


export const videoExtendRequestModelRegExp = new RegExp('^[a-z0-9][a-z0-9.-]*$');
export const videoExtendRequestOutputsDefault = 1;
export const videoExtendRequestOutputsMax = 16;

export const videoExtendRequestPromptMax = 32000;


export const videoExtendRequestPromptRegExp = new RegExp('[^\\t\\n\\v\\f\\r \\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000\\ufeff]');


export const VideoExtendRequest = zod.object({
  "advanced": zod.union([AdvancedSettings,zod.null()]).exactOptional(),
  "duration_seconds": zod.union([zod.int().min(1).max(videoExtendRequestDurationSecondsOneMax),zod.null()]).exactOptional(),
  "expected_quote_max": zod.union([zod.int().min(videoExtendRequestExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "model": zod.string().max(videoExtendRequestModelMax).regex(videoExtendRequestModelRegExp).describe('A catalog model id.'),
  "outputs": zod.int().min(1).max(videoExtendRequestOutputsMax).default(videoExtendRequestOutputsDefault),
  "prompt": zod.string().min(1).max(videoExtendRequestPromptMax).regex(videoExtendRequestPromptRegExp),
  "resolution": zod.union([zod.string(),zod.null()]).exactOptional(),
  "source_video": SourceRef,
  "type": zod.enum(['video.extend'])
}).describe('Continue a video (an earlier output or a library video), live\'s Video Extend tool (G7,\n#210), by `duration_seconds` of new footage, the length held and charged. The video keeps\nits source\'s shape; on a model that `follows_source_resolution`, its resolution too.');

export type VideoExtendRequest = zod.input<typeof VideoExtendRequest>;
export type VideoExtendRequestOutput = zod.output<typeof VideoExtendRequest>;

export const videoFramesRequestAtSecondsOneMax = 16;

export const videoFramesRequestExpectedQuoteMaxOneMin = 0;

export const videoFramesRequestModelMax = 64;


export const videoFramesRequestModelRegExp = new RegExp('^[a-z0-9][a-z0-9.-]*$');
export const videoFramesRequestOutputsDefault = 4;
export const videoFramesRequestOutputsMax = 16;



export const VideoFramesRequest = zod.object({
  "at_seconds": zod.union([zod.array(zod.number()).min(1).max(videoFramesRequestAtSecondsOneMax),zod.null()]).exactOptional(),
  "expected_quote_max": zod.union([zod.int().min(videoFramesRequestExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "model": zod.string().max(videoFramesRequestModelMax).regex(videoFramesRequestModelRegExp).describe('A catalog model id.'),
  "outputs": zod.int().min(1).max(videoFramesRequestOutputsMax).default(videoFramesRequestOutputsDefault),
  "source_video": SourceRef,
  "type": zod.enum(['video.frames'])
}).describe('Frames of a video: the catalog row (`model`) and the video, an earlier output or a library\nvideo. Live\'s picture check\'s four moments (Yapper Ad), or the times given (`at_seconds`, in\nseconds, in order, at most 16: a source ad\'s shots, G14-ad-swap), an output each in time\norder; a time past the video\'s end draws its last frame.');

export type VideoFramesRequest = zod.input<typeof VideoFramesRequest>;
export type VideoFramesRequestOutput = zod.output<typeof VideoFramesRequest>;

export const videoImageRequestDurationSecondsOneMax = 600;

export const videoImageRequestElementsMax = 16;

export const videoImageRequestExpectedQuoteMaxOneMin = 0;

export const videoImageRequestMiddleFramesMax = 16;

export const videoImageRequestModelMax = 64;


export const videoImageRequestModelRegExp = new RegExp('^[a-z0-9][a-z0-9.-]*$');
export const videoImageRequestOutputsDefault = 1;
export const videoImageRequestOutputsMax = 16;

export const videoImageRequestPromptOneMax = 50000;


export const videoImageRequestPromptOneRegExp = new RegExp('[^\\t\\n\\v\\f\\r \\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000\\ufeff]');
export const videoImageRequestShotsOneMax = 30;



export const VideoImageRequest = zod.object({
  "advanced": zod.union([AdvancedSettings,zod.null()]).exactOptional(),
  "aspect_ratio": zod.union([zod.string(),zod.null()]).exactOptional(),
  "duration_seconds": zod.union([zod.int().min(1).max(videoImageRequestDurationSecondsOneMax),zod.null()]).exactOptional(),
  "elements": zod.array(Element).max(videoImageRequestElementsMax).exactOptional(),
  "end_frame": zod.union([SourceRef,zod.null()]).exactOptional(),
  "expected_quote_max": zod.union([zod.int().min(videoImageRequestExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "generate_audio": zod.union([zod.boolean(),zod.null()]).exactOptional(),
  "middle_frames": zod.array(SourceRef).max(videoImageRequestMiddleFramesMax).exactOptional(),
  "model": zod.string().max(videoImageRequestModelMax).regex(videoImageRequestModelRegExp).describe('A catalog model id.'),
  "outputs": zod.int().min(1).max(videoImageRequestOutputsMax).default(videoImageRequestOutputsDefault),
  "prompt": zod.union([zod.string().min(1).max(videoImageRequestPromptOneMax).regex(videoImageRequestPromptOneRegExp),zod.null()]).exactOptional(),
  "resolution": zod.union([zod.string(),zod.null()]).exactOptional(),
  "shots": zod.union([zod.array(Shot).min(1).max(videoImageRequestShotsOneMax),zod.null()]).exactOptional(),
  "start_frame": TemplateSource,
  "type": zod.enum(['video.image'])
}).describe('Animate an image (an earlier output or a library image), to an end frame where the model\ntakes one. Without an aspect ratio, keep the start frame\'s.');

export type VideoImageRequest = zod.input<typeof VideoImageRequest>;
export type VideoImageRequestOutput = zod.output<typeof VideoImageRequest>;

export const videoLipsyncRequestExpectedQuoteMaxOneMin = 0;

export const videoLipsyncRequestModelMax = 64;


export const videoLipsyncRequestModelRegExp = new RegExp('^[a-z0-9][a-z0-9.-]*$');
export const videoLipsyncRequestSyncModeOneRegExp = new RegExp('^[a-z_]{1,32}$');


export const VideoLipsyncRequest = zod.object({
  "auto_detect": zod.union([zod.boolean(),zod.null()]).exactOptional(),
  "expected_quote_max": zod.union([zod.int().min(videoLipsyncRequestExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "model": zod.string().max(videoLipsyncRequestModelMax).regex(videoLipsyncRequestModelRegExp).describe('A catalog model id.'),
  "source_audio": SourceRef,
  "source_video": SourceRef,
  "sync_mode": zod.union([zod.string().regex(videoLipsyncRequestSyncModeOneRegExp),zod.null()]).exactOptional(),
  "type": zod.enum(['video.lipsync'])
}).describe('Re-drive a video\'s speaker to an audio track, live\'s Lip-Sync tool (G7-video-lipsync,\n#216): the video (an earlier output or a library video), the audio (a speech job\'s output,\nas live\'s form makes it, or a library audio), no prompt, one video priced by the source\nvideo\'s length.');

export type VideoLipsyncRequest = zod.input<typeof VideoLipsyncRequest>;
export type VideoLipsyncRequestOutput = zod.output<typeof VideoLipsyncRequest>;

export const videoMergeRequestAudioFadeMsOneMin = 0;
export const videoMergeRequestAudioFadeMsOneMax = 50;

export const videoMergeRequestExpectedQuoteMaxOneMin = 0;

export const videoMergeRequestModelMax = 64;


export const videoMergeRequestModelRegExp = new RegExp('^[a-z0-9][a-z0-9.-]*$');
export const videoMergeRequestMuteDefault = false;
export const videoMergeRequestOutputsDefault = 1;
export const videoMergeRequestOutputsMax = 1;

export const videoMergeRequestSegmentsOneMax = 50;

export const videoMergeRequestVideosOneMax = 50;



export const VideoMergeRequest = zod.object({
  "audio_fade_ms": zod.union([zod.int().min(videoMergeRequestAudioFadeMsOneMin).max(videoMergeRequestAudioFadeMsOneMax),zod.null()]).exactOptional(),
  "expected_quote_max": zod.union([zod.int().min(videoMergeRequestExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "model": zod.string().max(videoMergeRequestModelMax).regex(videoMergeRequestModelRegExp).describe('A catalog model id.'),
  "mute": zod.boolean().default(videoMergeRequestMuteDefault),
  "output": zod.union([MergeOutput,zod.null()]).exactOptional(),
  "outputs": zod.int().min(1).max(videoMergeRequestOutputsMax).default(videoMergeRequestOutputsDefault),
  "segments": zod.union([zod.array(MergeSegment).min(1).max(videoMergeRequestSegmentsOneMax),zod.null()]).exactOptional(),
  "type": zod.enum(['video.merge']),
  "videos": zod.union([zod.array(SourceRef).min(1).max(videoMergeRequestVideosOneMax),zod.null()]).exactOptional()
}).describe('Videos joined in the list\'s order (live\'s `VIDEO_MERGE`): the catalog row (`model`) and\nexactly one of `videos` (each joined whole) or `segments` (a cut of each), each an earlier\noutput or a library video. Cuts take the fade of each cut\'s sound in milliseconds (live\'s\n12 by default) and the joined video\'s frame and rate (none: the first cut\'s); `mute` drops\nthe joined video\'s sound (ours, G14-ad-swap). One output.');

export type VideoMergeRequest = zod.input<typeof VideoMergeRequest>;
export type VideoMergeRequestOutput = zod.output<typeof VideoMergeRequest>;

export const videoMotionRequestExpectedQuoteMaxOneMin = 0;

export const videoMotionRequestModelMax = 64;


export const videoMotionRequestModelRegExp = new RegExp('^[a-z0-9][a-z0-9.-]*$');
export const videoMotionRequestPromptOneMax = 50000;



export const VideoMotionRequest = zod.object({
  "expected_quote_max": zod.union([zod.int().min(videoMotionRequestExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "model": zod.string().max(videoMotionRequestModelMax).regex(videoMotionRequestModelRegExp).describe('A catalog model id.'),
  "prompt": zod.union([zod.string().max(videoMotionRequestPromptOneMax),zod.null()]).exactOptional(),
  "source_video": SourceRef,
  "start_frame": SourceRef,
  "type": zod.enum(['video.motion'])
}).describe('Make a character (an image) move as a video does, live\'s Motion Control tool (G7, #214):\nthe character image as `start_frame` (live\'s `startFrame`), the motion as `source_video`,\nan optional prompt, one video.');

export type VideoMotionRequest = zod.input<typeof VideoMotionRequest>;
export type VideoMotionRequestOutput = zod.output<typeof VideoMotionRequest>;

export const videoOverlayRequestBaseAudioDbOneMin = -60;
export const videoOverlayRequestBaseAudioDbOneMax = 0;

export const videoOverlayRequestCanvasHeightOneMin = 2;
export const videoOverlayRequestCanvasHeightOneMax = 7680;

export const videoOverlayRequestCanvasWidthOneMin = 2;
export const videoOverlayRequestCanvasWidthOneMax = 7680;

export const videoOverlayRequestExpectedQuoteMaxOneMin = 0;

export const videoOverlayRequestFpsOneMax = 120;

export const videoOverlayRequestModelMax = 64;


export const videoOverlayRequestModelRegExp = new RegExp('^[a-z0-9][a-z0-9.-]*$');
export const videoOverlayRequestOutputsDefault = 1;
export const videoOverlayRequestOutputsMax = 1;

export const videoOverlayRequestOverlayWidthFracDefault = 0.4;
export const videoOverlayRequestOverlayWidthFracExclusiveMin = 0;
export const videoOverlayRequestOverlayWidthFracMax = 1;

export const videoOverlayRequestPositionDefault = 'bottom-right';
export const videoOverlayRequestTightCropDefault = true;

export const VideoOverlayRequest = zod.object({
  "base_audio_db": zod.union([zod.number().min(videoOverlayRequestBaseAudioDbOneMin).max(videoOverlayRequestBaseAudioDbOneMax),zod.null()]).exactOptional(),
  "base_video": SourceRef,
  "canvas_height": zod.union([zod.int().min(videoOverlayRequestCanvasHeightOneMin).max(videoOverlayRequestCanvasHeightOneMax),zod.null()]).exactOptional(),
  "canvas_width": zod.union([zod.int().min(videoOverlayRequestCanvasWidthOneMin).max(videoOverlayRequestCanvasWidthOneMax),zod.null()]).exactOptional(),
  "expected_quote_max": zod.union([zod.int().min(videoOverlayRequestExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "fps": zod.union([zod.int().min(1).max(videoOverlayRequestFpsOneMax),zod.null()]).exactOptional(),
  "model": zod.string().max(videoOverlayRequestModelMax).regex(videoOverlayRequestModelRegExp).describe('A catalog model id.'),
  "outputs": zod.int().min(1).max(videoOverlayRequestOutputsMax).default(videoOverlayRequestOutputsDefault),
  "overlay_video": SourceRef,
  "overlay_width_frac": zod.number().gt(videoOverlayRequestOverlayWidthFracExclusiveMin).max(videoOverlayRequestOverlayWidthFracMax).default(videoOverlayRequestOverlayWidthFracDefault),
  "position": OverlayPosition.default(videoOverlayRequestPositionDefault),
  "tight_crop": zod.boolean().default(videoOverlayRequestTightCropDefault),
  "type": zod.enum(['video.overlay'])
}).describe('A cut-out over a base video (live\'s `VIDEO_OVERLAY`): the catalog row (`model`), the base\nand the cut-out (each an earlier output or a library video), the place, the cut-out\'s width\nas a share of the frame\'s, whether it is cropped to what its alpha shows, the base\'s sound\nin decibels (none: the base is silent), and the frame and rate (none: the base\'s). One\noutput, as long as the cut-out.');

export type VideoOverlayRequest = zod.input<typeof VideoOverlayRequest>;
export type VideoOverlayRequestOutput = zod.output<typeof VideoOverlayRequest>;

export const videoPixelSnapRequestColorsDefault = 32;
export const videoPixelSnapRequestColorsMin = 2;
export const videoPixelSnapRequestColorsMax = 64;

export const videoPixelSnapRequestColumnsDefault = 180;
export const videoPixelSnapRequestColumnsMin = 16;
export const videoPixelSnapRequestColumnsMax = 540;

export const videoPixelSnapRequestExpectedQuoteMaxOneMin = 0;

export const videoPixelSnapRequestModelMax = 64;


export const videoPixelSnapRequestModelRegExp = new RegExp('^[a-z0-9][a-z0-9.-]*$');
export const videoPixelSnapRequestOutputsDefault = 1;
export const videoPixelSnapRequestOutputsMax = 1;

export const videoPixelSnapRequestRowsDefault = 320;
export const videoPixelSnapRequestRowsMin = 16;
export const videoPixelSnapRequestRowsMax = 960;



export const VideoPixelSnapRequest = zod.object({
  "colors": zod.int().min(videoPixelSnapRequestColorsMin).max(videoPixelSnapRequestColorsMax).default(videoPixelSnapRequestColorsDefault),
  "columns": zod.int().min(videoPixelSnapRequestColumnsMin).max(videoPixelSnapRequestColumnsMax).default(videoPixelSnapRequestColumnsDefault),
  "expected_quote_max": zod.union([zod.int().min(videoPixelSnapRequestExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "model": zod.string().max(videoPixelSnapRequestModelMax).regex(videoPixelSnapRequestModelRegExp).describe('A catalog model id.'),
  "outputs": zod.int().min(1).max(videoPixelSnapRequestOutputsMax).default(videoPixelSnapRequestOutputsDefault),
  "palette_image": SourceRef,
  "rows": zod.int().min(videoPixelSnapRequestRowsMin).max(videoPixelSnapRequestRowsMax).default(videoPixelSnapRequestRowsDefault),
  "source_video": SourceRef,
  "type": zod.enum(['video.pixel_snap'])
}).describe('A clip to snap, on flat magenta, and the still that fixes its palette (each an earlier\noutput or a library file): the catalog row (`model`), the grid in cells, and the colors the\npalette keeps. One output: a WebM with alpha at 12 fps and two pixels a cell, each cell one\npalette color or, where the magenta wins it, transparent.');

export type VideoPixelSnapRequest = zod.input<typeof VideoPixelSnapRequest>;
export type VideoPixelSnapRequestOutput = zod.output<typeof VideoPixelSnapRequest>;

export const videoReferenceRequestDurationSecondsOneMax = 600;

export const videoReferenceRequestElementsMax = 16;

export const videoReferenceRequestExpectedQuoteMaxOneMin = 0;

export const videoReferenceRequestMiddleFramesMax = 16;

export const videoReferenceRequestModelMax = 64;


export const videoReferenceRequestModelRegExp = new RegExp('^[a-z0-9][a-z0-9.-]*$');
export const videoReferenceRequestOutputsDefault = 1;
export const videoReferenceRequestOutputsMax = 16;

export const videoReferenceRequestPromptOneMax = 50000;


export const videoReferenceRequestPromptOneRegExp = new RegExp('[^\\t\\n\\v\\f\\r \\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000\\ufeff]');
export const videoReferenceRequestReferenceAudiosMax = 64;

export const videoReferenceRequestReferenceImagesMax = 64;

export const videoReferenceRequestReferenceVideosMax = 64;

export const videoReferenceRequestShotsOneMax = 30;



export const VideoReferenceRequest = zod.object({
  "advanced": zod.union([AdvancedSettings,zod.null()]).exactOptional(),
  "aspect_ratio": zod.union([zod.string(),zod.null()]).exactOptional(),
  "duration_seconds": zod.union([zod.int().min(1).max(videoReferenceRequestDurationSecondsOneMax),zod.null()]).exactOptional(),
  "elements": zod.array(Element).max(videoReferenceRequestElementsMax).exactOptional(),
  "end_frame": zod.union([SourceRef,zod.null()]).exactOptional(),
  "expected_quote_max": zod.union([zod.int().min(videoReferenceRequestExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "generate_audio": zod.union([zod.boolean(),zod.null()]).exactOptional(),
  "middle_frames": zod.array(SourceRef).max(videoReferenceRequestMiddleFramesMax).exactOptional(),
  "model": zod.string().max(videoReferenceRequestModelMax).regex(videoReferenceRequestModelRegExp).describe('A catalog model id.'),
  "outputs": zod.int().min(1).max(videoReferenceRequestOutputsMax).default(videoReferenceRequestOutputsDefault),
  "prompt": zod.union([zod.string().min(1).max(videoReferenceRequestPromptOneMax).regex(videoReferenceRequestPromptOneRegExp),zod.null()]).exactOptional(),
  "reference_audios": zod.array(AssetRef).max(videoReferenceRequestReferenceAudiosMax).exactOptional(),
  "reference_images": zod.array(ReferenceSource).max(videoReferenceRequestReferenceImagesMax).exactOptional(),
  "reference_videos": zod.array(SourceRef).max(videoReferenceRequestReferenceVideosMax).exactOptional(),
  "resolution": zod.union([zod.string(),zod.null()]).exactOptional(),
  "shots": zod.union([zod.array(Shot).min(1).max(videoReferenceRequestShotsOneMax),zod.null()]).exactOptional(),
  "start_frame": zod.union([SourceRef,zod.null()]).exactOptional(),
  "type": zod.enum(['video.reference'])
}).describe('A video from reference images, videos and audios, live\'s reference to video (G6, #203,\n#257): up to the model\'s caps, with a start or an end frame where the model takes one. The\nprompt may name each by position (`@Image1`, `@Video1`, `@Audio1`). A reference image may be\nan actor\'s portrait, as live\'s Video Studio\'s global avatars (`GLOBAL_AVATAR`), or, on a\ntemplate\'s step alone, a card\'s example input (Hooks\', G14).');

export type VideoReferenceRequest = zod.input<typeof VideoReferenceRequest>;
export type VideoReferenceRequestOutput = zod.output<typeof VideoReferenceRequest>;

export const videoReframeRequestExpectedQuoteMaxOneMin = 0;

export const videoReframeRequestModelMax = 64;


export const videoReframeRequestModelRegExp = new RegExp('^[a-z0-9][a-z0-9.-]*$');


export const VideoReframeRequest = zod.object({
  "aspect_ratio": zod.union([zod.string(),zod.null()]).exactOptional(),
  "expected_quote_max": zod.union([zod.int().min(videoReframeRequestExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "model": zod.string().max(videoReframeRequestModelMax).regex(videoReframeRequestModelRegExp).describe('A catalog model id.'),
  "resolution": zod.union([zod.string(),zod.null()]).exactOptional(),
  "source_video": SourceRef,
  "type": zod.enum(['video.reframe'])
}).describe('Reshape a video to another aspect ratio, its new edges generated, live\'s Reframe tool\n(G7, #212): no prompt, one video as long as its source, priced by its source\'s length.');

export type VideoReframeRequest = zod.input<typeof VideoReframeRequest>;
export type VideoReframeRequestOutput = zod.output<typeof VideoReframeRequest>;

export const videoShotsRequestExpectedQuoteMaxOneMin = 0;

export const videoShotsRequestModelMax = 64;


export const videoShotsRequestModelRegExp = new RegExp('^[a-z0-9][a-z0-9.-]*$');
export const videoShotsRequestOutputsDefault = 1;
export const videoShotsRequestOutputsMax = 1;



export const VideoShotsRequest = zod.object({
  "expected_quote_max": zod.union([zod.int().min(videoShotsRequestExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "model": zod.string().max(videoShotsRequestModelMax).regex(videoShotsRequestModelRegExp).describe('A catalog model id.'),
  "outputs": zod.int().min(1).max(videoShotsRequestOutputsMax).default(videoShotsRequestOutputsDefault),
  "source_video": SourceRef,
  "type": zod.enum(['video.shots'])
}).describe('A video\'s shots, from one hard cut to the next (G14-ad-swap): the catalog row (`model`)\nand the video, an earlier output or a library video. One output, their times as JSON. No\nprompt. Free.');

export type VideoShotsRequest = zod.input<typeof VideoShotsRequest>;
export type VideoShotsRequestOutput = zod.output<typeof VideoShotsRequest>;

export const videoSpliceRequestExpectedQuoteMaxOneMin = 0;

export const videoSpliceRequestModelMax = 64;


export const videoSpliceRequestModelRegExp = new RegExp('^[a-z0-9][a-z0-9.-]*$');
export const videoSpliceRequestOutputsDefault = 1;
export const videoSpliceRequestOutputsMax = 1;

export const videoSpliceRequestSecondsExclusiveMin = 0;
export const videoSpliceRequestSecondsMax = 60;

export const videoSpliceRequestStartSecondsMin = 0;
export const videoSpliceRequestStartSecondsMax = 600;



export const VideoSpliceRequest = zod.object({
  "base_video": SourceRef,
  "expected_quote_max": zod.union([zod.int().min(videoSpliceRequestExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "insert_video": SourceRef,
  "model": zod.string().max(videoSpliceRequestModelMax).regex(videoSpliceRequestModelRegExp).describe('A catalog model id.'),
  "outputs": zod.int().min(1).max(videoSpliceRequestOutputsMax).default(videoSpliceRequestOutputsDefault),
  "seconds": zod.number().gt(videoSpliceRequestSecondsExclusiveMin).max(videoSpliceRequestSecondsMax),
  "start_seconds": zod.number().min(videoSpliceRequestStartSecondsMin).max(videoSpliceRequestStartSecondsMax),
  "type": zod.enum(['video.splice'])
}).describe('An insert over a base video (each an earlier output or a library video): the catalog row\n(`model`), the base and the insert, and the window: from `start_seconds` of the base for\n`seconds`, the insert\'s first `seconds` scaled to cover the base\'s frame. One output, the\nbase\'s length, frame, rate and timestamps, its sound stream copied.');

export type VideoSpliceRequest = zod.input<typeof VideoSpliceRequest>;
export type VideoSpliceRequestOutput = zod.output<typeof VideoSpliceRequest>;

export const videoTalkingHeadRequestExpectedQuoteMaxOneMin = 0;

export const videoTalkingHeadRequestModelMax = 64;


export const videoTalkingHeadRequestModelRegExp = new RegExp('^[a-z0-9][a-z0-9.-]*$');
export const videoTalkingHeadRequestOutputsDefault = 1;
export const videoTalkingHeadRequestOutputsMax = 1;



export const VideoTalkingHeadRequest = zod.object({
  "actor": ActorSource,
  "expected_quote_max": zod.union([zod.int().min(videoTalkingHeadRequestExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "group": zod.union([zod.uuid(),zod.null()]).exactOptional(),
  "model": zod.string().max(videoTalkingHeadRequestModelMax).regex(videoTalkingHeadRequestModelRegExp).describe('A catalog model id.'),
  "outputs": zod.int().min(1).max(videoTalkingHeadRequestOutputsMax).default(videoTalkingHeadRequestOutputsDefault),
  "resolution": zod.union([zod.string(),zod.null()]).exactOptional(),
  "source_audio": SourceRef,
  "type": zod.enum(['video.talking_head'])
}).describe('One actor of a talking head speaking (#222, live\'s Talking Head `start-simple`): its\nportrait (`actor`) and the audio it speaks (`source_audio`: its voiceover, a delivered\n`audio.voiceover`, or a library audio for speech to speech). One video, as long as the\naudio; one job per actor. No prompt and no ratio: the video keeps the portrait\'s shape.\nLeft out, the resolution is live\'s form\'s: 720p, else 480p. `group` is the client\'s: one id\nfor every actor\'s job of one talking head, so a list can show them together.');

export type VideoTalkingHeadRequest = zod.input<typeof VideoTalkingHeadRequest>;
export type VideoTalkingHeadRequestOutput = zod.output<typeof VideoTalkingHeadRequest>;

export const videoTalkingHeadAdvancedRequestActorDescriptionOneMax = 10000;

export const videoTalkingHeadAdvancedRequestExpectedQuoteMaxOneMin = 0;

export const videoTalkingHeadAdvancedRequestModelOneMax = 64;


export const videoTalkingHeadAdvancedRequestModelOneRegExp = new RegExp('^[a-z0-9][a-z0-9.-]*$');
export const videoTalkingHeadAdvancedRequestOutputsDefault = 1;
export const videoTalkingHeadAdvancedRequestOutputsMax = 1;

export const videoTalkingHeadAdvancedRequestProductDescriptionOneMax = 5000;

export const videoTalkingHeadAdvancedRequestScriptMin = 10;
export const videoTalkingHeadAdvancedRequestScriptMax = 10000;


export const videoTalkingHeadAdvancedRequestScriptRegExp = new RegExp('[^\\t\\n\\v\\f\\r \\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000\\ufeff]');
export const videoTalkingHeadAdvancedRequestVibeMax = 10000;


export const videoTalkingHeadAdvancedRequestVibeRegExp = new RegExp('[^\\t\\n\\v\\f\\r \\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000\\ufeff]');
export const videoTalkingHeadAdvancedRequestVideoModelOneMax = 64;


export const videoTalkingHeadAdvancedRequestVideoModelOneRegExp = new RegExp('^[a-z0-9][a-z0-9.-]*$');


export const VideoTalkingHeadAdvancedRequest = zod.object({
  "actor": ReferenceSource,
  "actor_description": zod.union([zod.string().min(1).max(videoTalkingHeadAdvancedRequestActorDescriptionOneMax),zod.null()]).exactOptional(),
  "aspect_ratio": zod.union([zod.string(),zod.null()]).exactOptional(),
  "every_product_picture": zod.union([zod.boolean(),zod.null()]).exactOptional(),
  "expected_quote_max": zod.union([zod.int().min(videoTalkingHeadAdvancedRequestExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "group": zod.union([zod.uuid(),zod.null()]).exactOptional(),
  "model": zod.union([zod.string().max(videoTalkingHeadAdvancedRequestModelOneMax).regex(videoTalkingHeadAdvancedRequestModelOneRegExp),zod.null()]).exactOptional().describe('A catalog model id.'),
  "outputs": zod.int().min(1).max(videoTalkingHeadAdvancedRequestOutputsMax).default(videoTalkingHeadAdvancedRequestOutputsDefault),
  "product_description": zod.union([zod.string().min(1).max(videoTalkingHeadAdvancedRequestProductDescriptionOneMax),zod.null()]).exactOptional(),
  "product_id": zod.union([zod.uuid(),zod.null()]).exactOptional(),
  "product_picture": zod.union([ExampleRef,zod.null()]).exactOptional(),
  "resolution": zod.union([zod.enum(['720p', '480p']),zod.null()]).exactOptional(),
  "script": zod.string().min(videoTalkingHeadAdvancedRequestScriptMin).max(videoTalkingHeadAdvancedRequestScriptMax).regex(videoTalkingHeadAdvancedRequestScriptRegExp),
  "type": zod.enum(['video.talking_head_advanced']),
  "vibe": zod.string().min(1).max(videoTalkingHeadAdvancedRequestVibeMax).regex(videoTalkingHeadAdvancedRequestVibeRegExp),
  "video_model": zod.union([zod.string().max(videoTalkingHeadAdvancedRequestVideoModelOneMax).regex(videoTalkingHeadAdvancedRequestVideoModelOneRegExp),zod.null()]).exactOptional().describe('The clips\' catalog model.'),
  "voice_id": zod.uuid()
}).describe('One actor of live\'s Talking Head with Advanced on (#223, live\'s `start-advanced`): the\nactor\'s portrait (`actor`), its voice (`voice_id`), the script, the vibe (live\'s "Vibe /\nDirection") and, optionally, a product of the brand. One video, the actor\'s shots cut\ntogether; one job per actor, grouped by `group` as the simple render\'s. No prompt. `model`\nis the type\'s one row when left out. Live\'s API\'s other three: `video_model` (its `modelId`)\nmakes the clips, Kling v3 Pro when left out (the form\'s, locked); `aspect_ratio` is the\nkeyframes\' (one of live\'s 8, 9:16 when left out, the form\'s "Auto"); `resolution` goes to\nthe clips; each reaches the clips\' model only where it takes it, as live\'s backend drops\nthem.');

export type VideoTalkingHeadAdvancedRequest = zod.input<typeof VideoTalkingHeadAdvancedRequest>;
export type VideoTalkingHeadAdvancedRequestOutput = zod.output<typeof VideoTalkingHeadAdvancedRequest>;

export const videoTemplateRequestExpectedQuoteMaxOneMin = 0;

export const videoTemplateRequestModelOneMax = 64;


export const videoTemplateRequestModelOneRegExp = new RegExp('^[a-z0-9][a-z0-9.-]*$');


export const VideoTemplateRequest = zod.object({
  "expected_quote_max": zod.union([zod.int().min(videoTemplateRequestExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "inputs": VideoTemplateInputs,
  "model": zod.union([zod.string().max(videoTemplateRequestModelOneMax).regex(videoTemplateRequestModelOneRegExp),zod.null()]).exactOptional().describe('A catalog model id.'),
  "type": zod.enum(['video.template'])
}).describe('One Generate of a video template\'s form: its inputs, by their `template` (the catalog\'s\nid). As many videos as the inputs make tiles (`slots()`). No prompt and no model: each step\'s\nmodel is the recipe\'s, as live\'s forms fix theirs.');

export type VideoTemplateRequest = zod.input<typeof VideoTemplateRequest>;
export type VideoTemplateRequestOutput = zod.output<typeof VideoTemplateRequest>;

export const videoTextRequestDurationSecondsOneMax = 600;

export const videoTextRequestElementsMax = 16;

export const videoTextRequestExpectedQuoteMaxOneMin = 0;

export const videoTextRequestModelMax = 64;


export const videoTextRequestModelRegExp = new RegExp('^[a-z0-9][a-z0-9.-]*$');
export const videoTextRequestOutputsDefault = 1;
export const videoTextRequestOutputsMax = 16;

export const videoTextRequestPromptOneMax = 50000;


export const videoTextRequestPromptOneRegExp = new RegExp('[^\\t\\n\\v\\f\\r \\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000\\ufeff]');
export const videoTextRequestShotsOneMax = 30;



export const VideoTextRequest = zod.object({
  "advanced": zod.union([AdvancedSettings,zod.null()]).exactOptional(),
  "aspect_ratio": zod.union([zod.string(),zod.null()]).exactOptional(),
  "duration_seconds": zod.union([zod.int().min(1).max(videoTextRequestDurationSecondsOneMax),zod.null()]).exactOptional(),
  "elements": zod.array(Element).max(videoTextRequestElementsMax).exactOptional(),
  "expected_quote_max": zod.union([zod.int().min(videoTextRequestExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "generate_audio": zod.union([zod.boolean(),zod.null()]).exactOptional(),
  "model": zod.string().max(videoTextRequestModelMax).regex(videoTextRequestModelRegExp).describe('A catalog model id.'),
  "outputs": zod.int().min(1).max(videoTextRequestOutputsMax).default(videoTextRequestOutputsDefault),
  "prompt": zod.union([zod.string().min(1).max(videoTextRequestPromptOneMax).regex(videoTextRequestPromptOneRegExp),zod.null()]).exactOptional(),
  "resolution": zod.union([zod.string(),zod.null()]).exactOptional(),
  "shots": zod.union([zod.array(Shot).min(1).max(videoTextRequestShotsOneMax),zod.null()]).exactOptional(),
  "type": zod.enum(['video.text'])
}).describe('Text to video.');

export type VideoTextRequest = zod.input<typeof VideoTextRequest>;
export type VideoTextRequestOutput = zod.output<typeof VideoTextRequest>;

export const videoUpscaleRequestExpectedQuoteMaxOneMin = 0;

export const videoUpscaleRequestModelMax = 64;


export const videoUpscaleRequestModelRegExp = new RegExp('^[a-z0-9][a-z0-9.-]*$');


export const VideoUpscaleRequest = zod.object({
  "compression": zod.union([zod.number(),zod.null()]).exactOptional(),
  "expected_quote_max": zod.union([zod.int().min(videoUpscaleRequestExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "grain": zod.union([zod.number(),zod.null()]).exactOptional(),
  "halo": zod.union([zod.number(),zod.null()]).exactOptional(),
  "model": zod.string().max(videoUpscaleRequestModelMax).regex(videoUpscaleRequestModelRegExp).describe('A catalog model id.'),
  "noise": zod.union([zod.number(),zod.null()]).exactOptional(),
  "recover_detail": zod.union([zod.number(),zod.null()]).exactOptional(),
  "source_video": SourceRef,
  "target_fps": zod.union([zod.int(),zod.null()]).exactOptional(),
  "type": zod.enum(['video.upscale']),
  "upscale_factor": zod.union([zod.number(),zod.null()]).exactOptional()
}).describe('Upscale a video (an earlier output or a library video), live\'s Video Upscale tool (G7,\n#211): no prompt, one video as long as its source, priced by its source\'s length.');

export type VideoUpscaleRequest = zod.input<typeof VideoUpscaleRequest>;
export type VideoUpscaleRequestOutput = zod.output<typeof VideoUpscaleRequest>;

export const videoVoiceSwapRequestExpectedQuoteMaxOneMin = 0;

export const videoVoiceSwapRequestModelMax = 64;


export const videoVoiceSwapRequestModelRegExp = new RegExp('^[a-z0-9][a-z0-9.-]*$');
export const videoVoiceSwapRequestOutputsDefault = 1;
export const videoVoiceSwapRequestOutputsMax = 1;



export const VideoVoiceSwapRequest = zod.object({
  "expected_quote_max": zod.union([zod.int().min(videoVoiceSwapRequestExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "model": zod.string().max(videoVoiceSwapRequestModelMax).regex(videoVoiceSwapRequestModelRegExp).describe('A catalog model id.'),
  "outputs": zod.int().min(1).max(videoVoiceSwapRequestOutputsMax).default(videoVoiceSwapRequestOutputsDefault),
  "source_video": SourceRef,
  "type": zod.enum(['video.voice_swap']),
  "voice_id": zod.uuid()
}).describe('A video\'s speech in another voice (#223, live\'s talking-head voice swap): the source\'s\nspeech isolated, then spoken again by `voice_id` (a team or global voice), and laid back on\nthe video, which is kept as it is. One video, as long as its source. No prompt.');

export type VideoVoiceSwapRequest = zod.input<typeof VideoVoiceSwapRequest>;
export type VideoVoiceSwapRequestOutput = zod.output<typeof VideoVoiceSwapRequest>;

export const voiceCloneRequestExpectedQuoteMaxOneMin = 0;

export const voiceCloneRequestModelMax = 64;


export const voiceCloneRequestModelRegExp = new RegExp('^[a-z0-9][a-z0-9.-]*$');
export const voiceCloneRequestNameMax = 99;

export const voiceCloneRequestOutputsDefault = 1;
export const voiceCloneRequestOutputsMax = 1;



export const VoiceCloneRequest = zod.object({
  "expected_quote_max": zod.union([zod.int().min(voiceCloneRequestExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "model": zod.string().max(voiceCloneRequestModelMax).regex(voiceCloneRequestModelRegExp).describe('A catalog model id.'),
  "name": zod.string().min(1).max(voiceCloneRequestNameMax),
  "outputs": zod.int().min(1).max(voiceCloneRequestOutputsMax).default(voiceCloneRequestOutputsDefault),
  "source_audio": SourceRef,
  "type": zod.enum(['voice.clone'])
}).describe('A brand\'s voice cloned from a sound (spec G14-yapper, the voice lock): the sound (an\nearlier output of the brand, or a library sound) and the name the voice gets in the brand\n(the next free one where taken). One output, the voice\'s id. No prompt. Free.');

export type VoiceCloneRequest = zod.input<typeof VoiceCloneRequest>;
export type VoiceCloneRequestOutput = zod.output<typeof VoiceCloneRequest>;

export const voiceDesignRequestExpectedQuoteMaxOneMin = 0;

export const voiceDesignRequestModelMax = 64;


export const voiceDesignRequestModelRegExp = new RegExp('^[a-z0-9][a-z0-9.-]*$');
export const voiceDesignRequestOutputsDefault = 1;
export const voiceDesignRequestOutputsMax = 1;

export const voiceDesignRequestPromptMax = 32000;


export const voiceDesignRequestPromptRegExp = new RegExp('[^\\t\\n\\v\\f\\r \\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000\\ufeff]');


export const VoiceDesignRequest = zod.object({
  "expected_quote_max": zod.union([zod.int().min(voiceDesignRequestExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "model": zod.string().max(voiceDesignRequestModelMax).regex(voiceDesignRequestModelRegExp).describe('A catalog model id.'),
  "outputs": zod.int().min(1).max(voiceDesignRequestOutputsMax).default(voiceDesignRequestOutputsDefault),
  "prompt": zod.string().min(1).max(voiceDesignRequestPromptMax).regex(voiceDesignRequestPromptRegExp),
  "type": zod.enum(['voice.design'])
}).describe('A voice from a description: its preview is the job\'s output, and saving it makes the\nbrand\'s voice (`POST .../voices/from-design`).');

export type VoiceDesignRequest = zod.input<typeof VoiceDesignRequest>;
export type VoiceDesignRequestOutput = zod.output<typeof VoiceDesignRequest>;

export const voiceProfileRequestExpectedQuoteMaxOneMin = 0;

export const voiceProfileRequestModelMax = 64;


export const voiceProfileRequestModelRegExp = new RegExp('^[a-z0-9][a-z0-9.-]*$');
export const voiceProfileRequestOutputsDefault = 1;
export const voiceProfileRequestOutputsMax = 1;



export const VoiceProfileRequest = zod.object({
  "expected_quote_max": zod.union([zod.int().min(voiceProfileRequestExpectedQuoteMaxOneMin),zod.null()]).exactOptional(),
  "model": zod.string().max(voiceProfileRequestModelMax).regex(voiceProfileRequestModelRegExp).describe('A catalog model id.'),
  "name": VoiceName,
  "outputs": zod.int().min(1).max(voiceProfileRequestOutputsMax).default(voiceProfileRequestOutputsDefault),
  "source": SourceRef,
  "type": zod.enum(['voice.profile'])
}).describe('A voice Kling 4.0 speaks with (spec G2-kling-v4-voices): the clip it is made from, a sound\nor a video of the brand (an earlier output, or a library file) in which one person speaks\nclearly, an MP3, WAV, MP4 or MOV of 5 to 30 seconds and at most 50 MB, and the name the\nvoice gets. One output, the voice\'s id at Kling. No prompt.');

export type VoiceProfileRequest = zod.input<typeof VoiceProfileRequest>;
export type VoiceProfileRequestOutput = zod.output<typeof VoiceProfileRequest>;

export const JobRequest = zod.union([AudioExtractRequest,AudioMusicRequest,AudioSfxRequest,AudioTtsRequest,AudioVoiceoverRequest,CaptionTranscribeRequest,ExtractBrandRequest,ExtractProductRequest,ImageActorRequest,ImageAdvancedRequest,ImageAnalysisRequest,ImageLayerEditRequest,ImageLayerizeRequest,ImageSimpleRequest,ImageTemplateRequest,ImageTweakRequest,TextActorDescriptionRequest,TextAdCopyRequest,TextEnhanceRequest,TextGenerateRequest,TextScriptRequest,TextShotListRequest,VideoAudioRequest,VideoBackgroundRequest,VideoCaptionRequest,VideoDubRequest,VideoEditRequest,VideoExtendRequest,VideoFramesRequest,VideoImageRequest,VideoLipsyncRequest,VideoMergeRequest,VideoMotionRequest,VideoOverlayRequest,VideoPixelSnapRequest,VideoReferenceRequest,VideoReframeRequest,VideoShotsRequest,VideoSpliceRequest,VideoTalkingHeadRequest,VideoTalkingHeadAdvancedRequest,VideoTemplateRequest,VideoTextRequest,VideoUpscaleRequest,VideoVoiceSwapRequest,VoiceCloneRequest,VoiceDesignRequest,VoiceProfileRequest]);

export type JobRequest = zod.input<typeof JobRequest>;
export type JobRequestOutput = zod.output<typeof JobRequest>;

export const JobTerminalDetails = zod.object({
  "status": zod.enum(['succeeded', 'failed', 'expired', 'canceled'])
}).describe('The status the job already settled in (`platform.contracts.TERMINAL_STATUSES`).');

export type JobTerminalDetails = zod.input<typeof JobTerminalDetails>;
export type JobTerminalDetailsOutput = zod.output<typeof JobTerminalDetails>;

export const UsageStatus = zod.enum(['open', 'succeeded', 'failed', 'expired', 'canceled']).describe('A job\'s usage line (spec platform/usage-analytics.md 2.3): `open` from its start, then,\nonce, the status its job settled at.');

export type UsageStatus = zod.input<typeof UsageStatus>;
export type UsageStatusOutput = zod.output<typeof UsageStatus>;

export const JobUsageView = zod.object({
  "brand_id": zod.union([zod.uuid(),zod.null()]),
  "catalog_version": zod.union([zod.string(),zod.null()]),
  "charged": zod.int(),
  "debt": zod.int(),
  "delivered": zod.int(),
  "failed_outputs": zod.int(),
  "held": zod.int(),
  "job_id": zod.uuid(),
  "job_type": zod.string(),
  "model_id": zod.union([zod.string(),zod.null()]),
  "outputs": zod.int(),
  "parent_job_id": zod.union([zod.uuid(),zod.null()]),
  "price_version_id": zod.union([zod.uuid(),zod.null()]),
  "refunded": zod.int(),
  "refunded_at": zod.union([zod.iso.datetime({"offset":true}),zod.null()]),
  "request_fingerprint": zod.union([zod.string(),zod.null()]),
  "settled_at": zod.union([zod.iso.datetime({"offset":true}),zod.null()]),
  "started_at": zod.iso.datetime({"offset":true}),
  "status": UsageStatus,
  "team_id": zod.uuid(),
  "unpriced": zod.array(zod.string()),
  "user_id": zod.union([zod.uuid(),zod.null()]),
  "vendor": zod.union([zod.string(),zod.null()]),
  "vendor_cost_complete": zod.boolean(),
  "vendor_cost_usd": zod.union([zod.string(),zod.null()]),
  "via": zod.union([zod.string(),zod.null()])
}).describe('One job\'s usage line (`billing.job_usage`): who started which job, its credits as the\nledger moved them, and what its vendor requests cost us as far as it is known. No prompt, no\nsetting, no key.');

export type JobUsageView = zod.input<typeof JobUsageView>;
export type JobUsageViewOutput = zod.output<typeof JobUsageView>;

export const LayerDocument = zod.object({
  "height": zod.int(),
  "layers": zod.array(DocumentLayer),
  "urls_expire_at": zod.union([zod.iso.datetime({"offset":true}),zod.null()]),
  "width": zod.int()
}).describe('`GET /v1/teams/{team_id}/jobs/{job_id}/layers` (spec G13b, PR A): a finished Layerize\'s\nlayers, bottom first, on a document of the base\'s size, for the layer editor. Any job that\nis not a finished Layerize of the team with a kept document is 404 (one from before).');

export type LayerDocument = zod.input<typeof LayerDocument>;
export type LayerDocumentOutput = zod.output<typeof LayerDocument>;

export const LayerEditList = zod.object({
  "items": zod.array(Job)
}).describe('`GET /v1/teams/{team_id}/jobs/{job_id}/layer-edits` (spec G13b, PR B1): a Layerize\'s AI\nedits (`image.layer_edit` jobs), newest first, at most 200 (live\'s list), each as the job\nread answers it. A job that is not a Layerize of the team is 404.');

export type LayerEditList = zod.input<typeof LayerEditList>;
export type LayerEditListOutput = zod.output<typeof LayerEditList>;

export const ledgerEntryViewChargedOneMin = 0;



export const LedgerEntryView = zod.object({
  "actor_kind": ActorKind,
  "actor_user_id": zod.union([zod.uuid(),zod.null()]),
  "amount": zod.int(),
  "charged": zod.union([zod.int().min(ledgerEntryViewChargedOneMin),zod.null()]),
  "created_at": zod.iso.datetime({"offset":true}),
  "id": zod.int(),
  "job_id": zod.union([zod.uuid(),zod.null()]),
  "kind": EntryKind,
  "reason": zod.union([zod.string(),zod.null()])
}).describe('One ledger entry as staff reads it: the movement, the job it belongs to, who made it and\nwhy. No hold or price internals.');

export type LedgerEntryView = zod.input<typeof LedgerEntryView>;
export type LedgerEntryViewOutput = zod.output<typeof LedgerEntryView>;

export const LimitDetails = zod.object({
  "limit": zod.int()
}).describe('A count limit was reached; `limit` is the number allowed.');

export type LimitDetails = zod.input<typeof LimitDetails>;
export type LimitDetailsOutput = zod.output<typeof LimitDetails>;

export const TermsStatus = zod.object({
  "accepted_at": zod.union([zod.iso.datetime({"offset":true}),zod.null()]),
  "accepted_version": zod.union([zod.string(),zod.null()]),
  "current_url": zod.string(),
  "current_version": zod.string()
}).describe('The terms in force and the version the user last accepted. The SPA shows a banner while\nthe two differ (decision O7); nothing blocks on it.');

export type TermsStatus = zod.input<typeof TermsStatus>;
export type TermsStatusOutput = zod.output<typeof TermsStatus>;

export const Me = zod.object({
  "consents": Consents,
  "created_at": zod.iso.datetime({"offset":true}),
  "email": zod.string(),
  "id": zod.uuid(),
  "is_staff": zod.boolean(),
  "name": zod.union([zod.string(),zod.null()]),
  "picture_url": zod.union([zod.string(),zod.null()]),
  "terms": TermsStatus
}).describe('`GET /v1/me`: the signed-in user.');

export type Me = zod.input<typeof Me>;
export type MeOutput = zod.output<typeof Me>;

export const meUpdateNameMax = 100;


export const meUpdateNameRegExp = new RegExp('[^\\t\\n\\v\\f\\r \\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000\\ufeff]');


export const MeUpdate = zod.object({
  "name": zod.string().min(1).max(meUpdateNameMax).regex(meUpdateNameRegExp)
}).describe('`PATCH /v1/me`: the user\'s display name. The picture is Google\'s, never a client URL.');

export type MeUpdate = zod.input<typeof MeUpdate>;
export type MeUpdateOutput = zod.output<typeof MeUpdate>;

export const MediaAccess = zod.object({
  "enabled": zod.boolean(),
  "expires_at": zod.union([zod.iso.datetime({"offset":true}),zod.null()]),
  "expires_in": zod.union([zod.int(),zod.null()]),
  "paths": zod.array(zod.string())
}).describe('`POST /teams/{team_id}/media-access`: the browser now holds the team\'s media cookies, one\nper path in `paths` (the team\'s files, then the shared ones), until `expires_at`, which is\n`expires_in` seconds from this answer (count from its arrival, never against the browser\'s\nclock). With cookies off, `enabled` is false, the rest is empty, and every URL stays signed\n(spec assets/media-cookies).');

export type MediaAccess = zod.input<typeof MediaAccess>;
export type MediaAccessOutput = zod.output<typeof MediaAccess>;

export const Member = zod.object({
  "email": zod.union([zod.string(),zod.null()]),
  "joined_at": zod.iso.datetime({"offset":true}),
  "name": zod.union([zod.string(),zod.null()]),
  "picture_url": zod.union([zod.string(),zod.null()]),
  "role": TeamRole,
  "user_id": zod.uuid()
}).describe('One member of the team, with identity\'s profile; the profile fields are None for a user\nidentity no longer has.');

export type Member = zod.input<typeof Member>;
export type MemberOutput = zod.output<typeof Member>;

export const MemberAchievements = zod.object({
  "best_tier": zod.union([Tier,zod.null()]),
  "earned": zod.int(),
  "user_id": zod.uuid()
}).describe('A member who shares in this team and does not hide: how many achievements they earned in\nit, and the rarest tier among them (the Members screen, 7.1).');

export type MemberAchievements = zod.input<typeof MemberAchievements>;
export type MemberAchievementsOutput = zod.output<typeof MemberAchievements>;

export const MemberUpdate = zod.object({
  "role": TeamRole
}).describe('`PATCH .../members/{user_id}`: the new role, within the actor\'s role ceiling.');

export type MemberUpdate = zod.input<typeof MemberUpdate>;
export type MemberUpdateOutput = zod.output<typeof MemberUpdate>;

export const MyTeam = zod.object({
  "created_at": zod.iso.datetime({"offset":true}),
  "id": zod.uuid(),
  "name": zod.string(),
  "role": TeamRole
}).describe('One of the caller\'s teams and their role in it (`GET /v1/me/teams`).');

export type MyTeam = zod.input<typeof MyTeam>;
export type MyTeamOutput = zod.output<typeof MyTeam>;

export const NoDetails = zod.object({

}).describe('The details of a code that carries none: always `{}`.');

export type NoDetails = zod.input<typeof NoDetails>;
export type NoDetailsOutput = zod.output<typeof NoDetails>;

export const pixarClaimClaimMax = 2000;

export const pixarClaimIdMax = 16;

export const pixarClaimSourceQuoteMax = 2000;



export const PixarClaim = zod.object({
  "claim": zod.string().max(pixarClaimClaimMax),
  "id": zod.string().max(pixarClaimIdMax),
  "source_quote": zod.string().max(pixarClaimSourceQuoteMax)
}).describe('A product claim the lyrics make, with the product text\'s words it rests on.');

export type PixarClaim = zod.input<typeof PixarClaim>;
export type PixarClaimOutput = zod.output<typeof PixarClaim>;

export const PixarRunClip = zod.enum(['k1', 'k2', 'k3']);

export type PixarRunClip = zod.input<typeof PixarRunClip>;
export type PixarRunClipOutput = zod.output<typeof PixarRunClip>;

export const PixarDraftTake = zod.object({
  "clip": PixarRunClip,
  "output": zod.union([OutputRef,zod.null()]),
  "refused": zod.boolean()
}).describe('One clip of the draft\'s last run: its output once the run has ended and the clip was\ndelivered (the next run\'s take), and whether the video model refused it (its frames\nflagged); neither for a clip that failed otherwise or has not ended.');

export type PixarDraftTake = zod.input<typeof PixarDraftTake>;
export type PixarDraftTakeOutput = zod.output<typeof PixarDraftTake>;

export const PixarDraftRun = zod.object({
  "clips": zod.array(PixarDraftTake),
  "end_card": zod.boolean(),
  "ended": zod.boolean(),
  "error_code": zod.union([JobErrorCode,zod.null()]),
  "job_id": zod.uuid(),
  "resolution": zod.enum(['1080p', '720p']),
  "stills": PixarStills
}).describe('The member\'s last "Generate final video" from this draft (live keeps a run\'s takes in\nits widget and loses them with the panel; ours reads them from the run, Pixar Talking Ad-2):\nits job, whether it has ended and how its tile failed (`frame_refused`, `end_card_refused`,\nor another code), the stills and the resolution it was made from and whether it had the end\ncard, and each clip. The form flags the frames of a refused clip and names each delivered\nclip whose frames and resolution are unchanged as a take of the next run (`PixarTakes`).');

export type PixarDraftRun = zod.input<typeof PixarDraftRun>;
export type PixarDraftRunOutput = zod.output<typeof PixarDraftRun>;

export const PixarDraftStage = zod.enum(['lyrics', 'song', 'cast']).describe('Live\'s stages: the lyrics, the song once they are approved, the cast and set once a take\nis.');

export type PixarDraftStage = zod.input<typeof PixarDraftStage>;
export type PixarDraftStageOutput = zod.output<typeof PixarDraftStage>;

export const PixarDraftStillName = zod.enum(['char_sheet', 'opening', 'hold', 'closing', 'end_card']);

export type PixarDraftStillName = zod.input<typeof PixarDraftStillName>;
export type PixarDraftStillNameOutput = zod.output<typeof PixarDraftStillName>;

export const PixarDraftStill = zod.object({
  "name": PixarDraftStillName,
  "output": zod.union([OutputRef,zod.null()]).exactOptional(),
  "problem": zod.union([zod.string(),zod.null()]),
  "status": StillStatus,
  "url": zod.union([zod.string(),zod.null()])
}).describe('One of the 5 stills (live\'s `StillState`), as `DraftStill`.');

export type PixarDraftStill = zod.input<typeof PixarDraftStill>;
export type PixarDraftStillOutput = zod.output<typeof PixarDraftStill>;

export const pixarEndCardCtaButtonMax = 200;

export const pixarEndCardOfferLineMax = 2000;



export const PixarEndCard = zod.object({
  "cta_button": zod.string().max(pixarEndCardCtaButtonMax),
  "offer_line": zod.string().max(pixarEndCardOfferLineMax)
}).describe('The end card\'s button and its lasting offer line (empty for none).');

export type PixarEndCard = zod.input<typeof PixarEndCard>;
export type PixarEndCardOutput = zod.output<typeof PixarEndCard>;

export const pixarLyricLineClaimIdsMax = 60;

export const pixarLyricLineDeliveryMax = 2000;

export const pixarLyricLineOnScreenMax = 2000;

export const pixarLyricLinePartMax = 40;

export const pixarLyricLineTextMax = 2000;



export const PixarLyricLine = zod.object({
  "claim_ids": zod.array(zod.string()).max(pixarLyricLineClaimIdsMax),
  "delivery": zod.string().max(pixarLyricLineDeliveryMax),
  "id": zod.int(),
  "on_screen": zod.string().max(pixarLyricLineOnScreenMax),
  "part": zod.string().max(pixarLyricLinePartMax),
  "text": zod.string().max(pixarLyricLineTextMax)
}).describe('One sung line: its number (1 to 6), its part, the words, how it is sung, what the\ncharacter does meanwhile and the claims it makes.');

export type PixarLyricLine = zod.input<typeof PixarLyricLine>;
export type PixarLyricLineOutput = zod.output<typeof PixarLyricLine>;

export const pixarPronunciationRespellingMax = 200;

export const pixarPronunciationSaidMax = 2000;

export const pixarPronunciationWordMax = 200;



export const PixarPronunciation = zod.object({
  "respelling": zod.string().max(pixarPronunciationRespellingMax),
  "said": zod.string().max(pixarPronunciationSaidMax),
  "word": zod.string().max(pixarPronunciationWordMax)
}).describe('How a written word is sung: its respelling and, for the singer, in plain words.');

export type PixarPronunciation = zod.input<typeof PixarPronunciation>;
export type PixarPronunciationOutput = zod.output<typeof PixarPronunciation>;

export const pixarLyricsClaimsMax = 60;

export const pixarLyricsLinesMax = 60;

export const pixarLyricsPainMomentMax = 2000;

export const pixarLyricsProblemMax = 2000;

export const pixarLyricsProductShortNameMax = 200;

export const pixarLyricsPronunciationsMax = 60;

export const pixarLyricsTagMax = 2000;



export const PixarLyrics = zod.object({
  "claims": zod.array(PixarClaim).max(pixarLyricsClaimsMax),
  "end_card": PixarEndCard,
  "lines": zod.array(PixarLyricLine).min(1).max(pixarLyricsLinesMax),
  "pain_moment": zod.string().max(pixarLyricsPainMomentMax),
  "problem": zod.string().max(pixarLyricsProblemMax),
  "product_short_name": zod.string().max(pixarLyricsProductShortNameMax),
  "pronunciations": zod.array(PixarPronunciation).max(pixarLyricsPronunciationsMax),
  "song_seconds": zod.int(),
  "syllables": zod.union([zod.int(),zod.null()]).exactOptional(),
  "tag": zod.string().max(pixarLyricsTagMax),
  "word_count": zod.int()
}).describe('Live\'s lyrics (`lyrics.ts:56-71`): the lyrics director\'s answer (its schema forbids other\nkeys), edited in the form before approval. `syllables` is code\'s count, never the\ndirector\'s. The fields keep live\'s order, the order of the JSON the shot director is shown.');

export type PixarLyrics = zod.input<typeof PixarLyrics>;
export type PixarLyricsOutput = zod.output<typeof PixarLyrics>;

export const PixarMusicStyle = zod.enum(['showtune', 'pop_jingle', 'acoustic', 'country', 'swing', 'kids_tv', 'rnb']).describe('The music styles live\'s `music-styles.json` lists, the form\'s picker.');

export type PixarMusicStyle = zod.input<typeof PixarMusicStyle>;
export type PixarMusicStyleOutput = zod.output<typeof PixarMusicStyle>;

export const PixarSinger = zod.enum(['female', 'male']).describe('The solo voice (live\'s `W/director/music-styles.ts:30-33`).');

export type PixarSinger = zod.input<typeof PixarSinger>;
export type PixarSingerOutput = zod.output<typeof PixarSinger>;

export const pixarSingingAdInputsCaptionPositionDefault = `bottom`;
export const pixarSingingAdInputsCaptionStyleIdDefault = ``;
export const pixarSingingAdInputsCaptionStyleIdMax = 64;

export const pixarSingingAdInputsCtaDefault = ``;
export const pixarSingingAdInputsCtaMax = 100;

export const pixarSingingAdInputsMusicStyleDefault = 'showtune';
export const pixarSingingAdInputsProblemDefault = ``;
export const pixarSingingAdInputsProblemMax = 500;

export const pixarSingingAdInputsProductCategoryDefault = ``;
export const pixarSingingAdInputsProductCategoryMax = 200;

export const pixarSingingAdInputsProductNameDefault = ``;
export const pixarSingingAdInputsProductNameMax = 200;

export const pixarSingingAdInputsProductTextDefault = ``;
export const pixarSingingAdInputsProductTextMax = 20000;

export const pixarSingingAdInputsPronunciationDefault = ``;
export const pixarSingingAdInputsPronunciationMax = 100;

export const pixarSingingAdInputsResolutionDefault = `1080p`;
export const pixarSingingAdInputsSingerDefault = 'female';
export const pixarSingingAdInputsSubtitlesDefault = true;

export const PixarSingingAdInputs = zod.object({
  "caption_position": zod.enum(['top', 'center', 'bottom']).default(pixarSingingAdInputsCaptionPositionDefault),
  "caption_style_id": zod.string().max(pixarSingingAdInputsCaptionStyleIdMax).default(pixarSingingAdInputsCaptionStyleIdDefault),
  "character": zod.union([ActorSource,zod.null()]).exactOptional(),
  "cta": zod.string().max(pixarSingingAdInputsCtaMax).default(pixarSingingAdInputsCtaDefault),
  "music_style": PixarMusicStyle.default(pixarSingingAdInputsMusicStyleDefault),
  "problem": zod.string().max(pixarSingingAdInputsProblemMax).default(pixarSingingAdInputsProblemDefault),
  "product": zod.union([PackshotProduct,zod.null()]).exactOptional(),
  "product_category": zod.string().max(pixarSingingAdInputsProductCategoryMax).default(pixarSingingAdInputsProductCategoryDefault),
  "product_name": zod.string().max(pixarSingingAdInputsProductNameMax).default(pixarSingingAdInputsProductNameDefault),
  "product_text": zod.string().max(pixarSingingAdInputsProductTextMax).default(pixarSingingAdInputsProductTextDefault),
  "pronunciation": zod.string().max(pixarSingingAdInputsPronunciationMax).default(pixarSingingAdInputsPronunciationDefault),
  "resolution": zod.enum(['720p', '1080p']).default(pixarSingingAdInputsResolutionDefault),
  "singer": PixarSinger.default(pixarSingingAdInputsSingerDefault),
  "subtitles": zod.boolean().default(pixarSingingAdInputsSubtitlesDefault)
}).describe('Pixar Singing Ad\'s form so far: the product (none until picked), and the rest.');

export type PixarSingingAdInputs = zod.input<typeof PixarSingingAdInputs>;
export type PixarSingingAdInputsOutput = zod.output<typeof PixarSingingAdInputs>;

export const PixarSingingStillName = zod.enum(['char_sheet', 'shot_1', 'shot_2', 'shot_3', 'end_card']);

export type PixarSingingStillName = zod.input<typeof PixarSingingStillName>;
export type PixarSingingStillNameOutput = zod.output<typeof PixarSingingStillName>;

export const PixarSingingDraftStill = zod.object({
  "name": PixarSingingStillName,
  "output": zod.union([OutputRef,zod.null()]).exactOptional(),
  "problem": zod.union([zod.string(),zod.null()]),
  "status": StillStatus,
  "url": zod.union([zod.string(),zod.null()])
}).describe('One of the cast\'s stills (live\'s `StillState`), as `DraftStill`.');

export type PixarSingingDraftStill = zod.input<typeof PixarSingingDraftStill>;
export type PixarSingingDraftStillOutput = zod.output<typeof PixarSingingDraftStill>;

export const PixarSongTake = zod.object({
  "duration_s": zod.union([zod.number(),zod.null()]),
  "fails": zod.array(zod.string()),
  "notes": zod.array(zod.string()),
  "number": zod.int(),
  "output": zod.union([OutputRef,zod.null()]).exactOptional(),
  "pickable": zod.boolean(),
  "problem": zod.union([zod.string(),zod.null()]),
  "status": StillStatus,
  "url": zod.union([zod.string(),zod.null()]),
  "verdict": zod.union([PixarTakeVerdict,zod.null()])
}).describe('One sung take (live\'s take card): `working` while it is made or heard, `done` with its\nsong at `url` and its check, or `failed` (`problem` says why). `pickable`: done, heard\nwhole, and not failed by its check; `output` names the song, as the video\'s run takes it.');

export type PixarSongTake = zod.input<typeof PixarSongTake>;
export type PixarSongTakeOutput = zod.output<typeof PixarSongTake>;

export const PixarSingingStillTiming = zod.object({
  "end_s": zod.int(),
  "name": PixarSingingStillName,
  "start_s": zod.int()
}).describe('Where a shot or the end card sits in the video, in whole seconds (live\'s timing line).');

export type PixarSingingStillTiming = zod.input<typeof PixarSingingStillTiming>;
export type PixarSingingStillTimingOutput = zod.output<typeof PixarSingingStillTiming>;

export const PixarSingingAdDraft = zod.object({
  "inputs": PixarSingingAdInputs,
  "lyrics": zod.union([PixarLyrics,zod.null()]),
  "lyrics_director": DirectorState,
  "lyrics_warning": zod.union([zod.string(),zod.null()]),
  "pack_director": DirectorState,
  "pack_warning": zod.boolean(),
  "picked_take": zod.union([zod.int(),zod.null()]),
  "problem": zod.union([zod.string(),zod.null()]),
  "shot_director": DirectorState,
  "spec": zod.union([PixarSingingShotSpec,zod.null()]),
  "stage": PixarDraftStage,
  "stills": zod.array(PixarSingingDraftStill),
  "take_timing": zod.union([PixarSingingTakeTiming,zod.null()]),
  "takes": zod.array(PixarSongTake),
  "takes_note": zod.union([zod.string(),zod.null()]),
  "timings": zod.array(PixarSingingStillTiming),
  "updated_at": zod.iso.datetime({"offset":true}),
  "urls_expire_at": zod.union([zod.iso.datetime({"offset":true}),zod.null()])
}).describe('A member\'s Pixar Singing Ad draft in the brand: the form, the stage, the lyrics and their\ndirectors (the pack reader\'s, then the lyrics\'), the song\'s takes, and once a take is picked\nits shot plan\'s timings, the shot director and the cast\'s stills. `pack_warning`: the pack\nwas hard to read (live\'s words); `lyrics_warning`: live\'s words for lyrics that still break\nits rules after the director\'s redo. `takes_note`: live\'s note on the takes (fewer than two\npassed, none passed, six made). `problem`: live\'s words for the last director that failed.\n`stills` is empty before a take is picked. "Generate final video" sends the picked take\'s\n`output` and `take_timing`, the `spec` and the stills\' `output`s\n(`PixarSingingAdVideoInputs`).');

export type PixarSingingAdDraft = zod.input<typeof PixarSingingAdDraft>;
export type PixarSingingAdDraftOutput = zod.output<typeof PixarSingingAdDraft>;

export const PixarSingingAdDraftWrite = zod.object({
  "inputs": PixarSingingAdInputs,
  "lyrics": zod.union([PixarLyrics,zod.null()]).exactOptional()
}).describe('`PUT .../templates/pixar-singing-ad/draft`: the form as it stands, its lyrics as edited.');

export type PixarSingingAdDraftWrite = zod.input<typeof PixarSingingAdDraftWrite>;
export type PixarSingingAdDraftWriteOutput = zod.output<typeof PixarSingingAdDraftWrite>;

export const pixarSingingAdPickedInputsCaptionPositionDefault = `bottom`;
export const pixarSingingAdPickedInputsCaptionStyleIdDefault = ``;
export const pixarSingingAdPickedInputsCaptionStyleIdMax = 64;

export const pixarSingingAdPickedInputsCtaDefault = ``;
export const pixarSingingAdPickedInputsCtaMax = 100;

export const pixarSingingAdPickedInputsMusicStyleDefault = 'showtune';
export const pixarSingingAdPickedInputsProblemDefault = ``;
export const pixarSingingAdPickedInputsProblemMax = 500;

export const pixarSingingAdPickedInputsProductCategoryDefault = ``;
export const pixarSingingAdPickedInputsProductCategoryMax = 200;

export const pixarSingingAdPickedInputsProductNameDefault = ``;
export const pixarSingingAdPickedInputsProductNameMax = 200;

export const pixarSingingAdPickedInputsProductTextDefault = ``;
export const pixarSingingAdPickedInputsProductTextMax = 20000;

export const pixarSingingAdPickedInputsPronunciationDefault = ``;
export const pixarSingingAdPickedInputsPronunciationMax = 100;

export const pixarSingingAdPickedInputsResolutionDefault = `1080p`;
export const pixarSingingAdPickedInputsSingerDefault = 'female';
export const pixarSingingAdPickedInputsSubtitlesDefault = true;

export const PixarSingingAdPickedInputs = zod.object({
  "caption_position": zod.enum(['top', 'center', 'bottom']).default(pixarSingingAdPickedInputsCaptionPositionDefault),
  "caption_style_id": zod.string().max(pixarSingingAdPickedInputsCaptionStyleIdMax).default(pixarSingingAdPickedInputsCaptionStyleIdDefault),
  "character": zod.union([ActorSource,zod.null()]).exactOptional(),
  "cta": zod.string().max(pixarSingingAdPickedInputsCtaMax).default(pixarSingingAdPickedInputsCtaDefault),
  "music_style": PixarMusicStyle.default(pixarSingingAdPickedInputsMusicStyleDefault),
  "problem": zod.string().max(pixarSingingAdPickedInputsProblemMax).default(pixarSingingAdPickedInputsProblemDefault),
  "product": PackshotProduct,
  "product_category": zod.string().max(pixarSingingAdPickedInputsProductCategoryMax).default(pixarSingingAdPickedInputsProductCategoryDefault),
  "product_name": zod.string().max(pixarSingingAdPickedInputsProductNameMax).default(pixarSingingAdPickedInputsProductNameDefault),
  "product_text": zod.string().max(pixarSingingAdPickedInputsProductTextMax).default(pixarSingingAdPickedInputsProductTextDefault),
  "pronunciation": zod.string().max(pixarSingingAdPickedInputsPronunciationMax).default(pixarSingingAdPickedInputsPronunciationDefault),
  "resolution": zod.enum(['720p', '1080p']).default(pixarSingingAdPickedInputsResolutionDefault),
  "singer": PixarSinger.default(pixarSingingAdPickedInputsSingerDefault),
  "subtitles": zod.boolean().default(pixarSingingAdPickedInputsSubtitlesDefault)
}).describe('The form with its product picked, as the wand and Approve lyrics need it (live\'s "Pick a\nproduct and its packshot", 422 at `product`).');

export type PixarSingingAdPickedInputs = zod.input<typeof PixarSingingAdPickedInputs>;
export type PixarSingingAdPickedInputsOutput = zod.output<typeof PixarSingingAdPickedInputs>;

export const PixarSingingAdLyricsApproval = zod.object({
  "inputs": PixarSingingAdPickedInputs,
  "lyrics": PixarLyrics
}).describe('`POST .../draft/approve-lyrics`: live\'s Approve lyrics, the form and the lyrics as\nedited.');

export type PixarSingingAdLyricsApproval = zod.input<typeof PixarSingingAdLyricsApproval>;
export type PixarSingingAdLyricsApprovalOutput = zod.output<typeof PixarSingingAdLyricsApproval>;

export const PixarSingingAdLyricsAsk = zod.object({
  "inputs": PixarSingingAdPickedInputs
}).describe('`POST .../draft/lyrics`: live\'s wand ("Generate Script"), on the form as it stands.');

export type PixarSingingAdLyricsAsk = zod.input<typeof PixarSingingAdLyricsAsk>;
export type PixarSingingAdLyricsAskOutput = zod.output<typeof PixarSingingAdLyricsAsk>;

export const pixarSingingAdSongApprovalTakeMax = 6;



export const PixarSingingAdSongApproval = zod.object({
  "take": zod.int().min(1).max(pixarSingingAdSongApprovalTakeMax)
}).describe('`POST .../draft/approve-song`: live\'s Approve song, the take picked by its number.');

export type PixarSingingAdSongApproval = zod.input<typeof PixarSingingAdSongApproval>;
export type PixarSingingAdSongApprovalOutput = zod.output<typeof PixarSingingAdSongApproval>;

export const pixarTalkingAdPickedInputsCaptionPositionDefault = `bottom`;
export const pixarTalkingAdPickedInputsCaptionStyleIdDefault = ``;
export const pixarTalkingAdPickedInputsCaptionStyleIdMax = 64;

export const pixarTalkingAdPickedInputsCtaDefault = ``;
export const pixarTalkingAdPickedInputsCtaMax = 100;

export const pixarTalkingAdPickedInputsEndCardDefault = true;
export const pixarTalkingAdPickedInputsProblemDefault = ``;
export const pixarTalkingAdPickedInputsProblemMax = 500;

export const pixarTalkingAdPickedInputsProductCategoryDefault = ``;
export const pixarTalkingAdPickedInputsProductCategoryMax = 200;

export const pixarTalkingAdPickedInputsProductNameDefault = ``;
export const pixarTalkingAdPickedInputsProductNameMax = 200;

export const pixarTalkingAdPickedInputsProductTextDefault = ``;
export const pixarTalkingAdPickedInputsProductTextMax = 20000;

export const pixarTalkingAdPickedInputsPronunciationDefault = ``;
export const pixarTalkingAdPickedInputsPronunciationMax = 100;

export const pixarTalkingAdPickedInputsResolutionDefault = `1080p`;
export const pixarTalkingAdPickedInputsSubtitlesDefault = true;

export const PixarTalkingAdPickedInputs = zod.object({
  "caption_position": zod.enum(['top', 'center', 'bottom']).default(pixarTalkingAdPickedInputsCaptionPositionDefault),
  "caption_style_id": zod.string().max(pixarTalkingAdPickedInputsCaptionStyleIdMax).default(pixarTalkingAdPickedInputsCaptionStyleIdDefault),
  "character": zod.union([ActorSource,zod.null()]).exactOptional(),
  "cta": zod.string().max(pixarTalkingAdPickedInputsCtaMax).default(pixarTalkingAdPickedInputsCtaDefault),
  "end_card": zod.boolean().default(pixarTalkingAdPickedInputsEndCardDefault),
  "problem": zod.string().max(pixarTalkingAdPickedInputsProblemMax).default(pixarTalkingAdPickedInputsProblemDefault),
  "product": PackshotProduct,
  "product_category": zod.string().max(pixarTalkingAdPickedInputsProductCategoryMax).default(pixarTalkingAdPickedInputsProductCategoryDefault),
  "product_name": zod.string().max(pixarTalkingAdPickedInputsProductNameMax).default(pixarTalkingAdPickedInputsProductNameDefault),
  "product_text": zod.string().max(pixarTalkingAdPickedInputsProductTextMax).default(pixarTalkingAdPickedInputsProductTextDefault),
  "pronunciation": zod.string().max(pixarTalkingAdPickedInputsPronunciationMax).default(pixarTalkingAdPickedInputsPronunciationDefault),
  "resolution": zod.enum(['1080p', '720p']).default(pixarTalkingAdPickedInputsResolutionDefault),
  "subtitles": zod.boolean().default(pixarTalkingAdPickedInputsSubtitlesDefault)
}).describe('The form with its product picked, as Generate script and Approve script need it (live\'s\n"Pick a product and its packshot", 422 at `product`).');

export type PixarTalkingAdPickedInputs = zod.input<typeof PixarTalkingAdPickedInputs>;
export type PixarTalkingAdPickedInputsOutput = zod.output<typeof PixarTalkingAdPickedInputs>;

export const PixarTalkingAdApproval = zod.object({
  "inputs": PixarTalkingAdPickedInputs,
  "script": PixarScript
}).describe('`POST .../draft/approve`: live\'s Approve script, the form and the script as edited.');

export type PixarTalkingAdApproval = zod.input<typeof PixarTalkingAdApproval>;
export type PixarTalkingAdApprovalOutput = zod.output<typeof PixarTalkingAdApproval>;

export const pixarTalkingAdInputsCaptionPositionDefault = `bottom`;
export const pixarTalkingAdInputsCaptionStyleIdDefault = ``;
export const pixarTalkingAdInputsCaptionStyleIdMax = 64;

export const pixarTalkingAdInputsCtaDefault = ``;
export const pixarTalkingAdInputsCtaMax = 100;

export const pixarTalkingAdInputsEndCardDefault = true;
export const pixarTalkingAdInputsProblemDefault = ``;
export const pixarTalkingAdInputsProblemMax = 500;

export const pixarTalkingAdInputsProductCategoryDefault = ``;
export const pixarTalkingAdInputsProductCategoryMax = 200;

export const pixarTalkingAdInputsProductNameDefault = ``;
export const pixarTalkingAdInputsProductNameMax = 200;

export const pixarTalkingAdInputsProductTextDefault = ``;
export const pixarTalkingAdInputsProductTextMax = 20000;

export const pixarTalkingAdInputsPronunciationDefault = ``;
export const pixarTalkingAdInputsPronunciationMax = 100;

export const pixarTalkingAdInputsResolutionDefault = `1080p`;
export const pixarTalkingAdInputsSubtitlesDefault = true;

export const PixarTalkingAdInputs = zod.object({
  "caption_position": zod.enum(['top', 'center', 'bottom']).default(pixarTalkingAdInputsCaptionPositionDefault),
  "caption_style_id": zod.string().max(pixarTalkingAdInputsCaptionStyleIdMax).default(pixarTalkingAdInputsCaptionStyleIdDefault),
  "character": zod.union([ActorSource,zod.null()]).exactOptional(),
  "cta": zod.string().max(pixarTalkingAdInputsCtaMax).default(pixarTalkingAdInputsCtaDefault),
  "end_card": zod.boolean().default(pixarTalkingAdInputsEndCardDefault),
  "problem": zod.string().max(pixarTalkingAdInputsProblemMax).default(pixarTalkingAdInputsProblemDefault),
  "product": zod.union([PackshotProduct,zod.null()]).exactOptional(),
  "product_category": zod.string().max(pixarTalkingAdInputsProductCategoryMax).default(pixarTalkingAdInputsProductCategoryDefault),
  "product_name": zod.string().max(pixarTalkingAdInputsProductNameMax).default(pixarTalkingAdInputsProductNameDefault),
  "product_text": zod.string().max(pixarTalkingAdInputsProductTextMax).default(pixarTalkingAdInputsProductTextDefault),
  "pronunciation": zod.string().max(pixarTalkingAdInputsPronunciationMax).default(pixarTalkingAdInputsPronunciationDefault),
  "resolution": zod.enum(['1080p', '720p']).default(pixarTalkingAdInputsResolutionDefault),
  "subtitles": zod.boolean().default(pixarTalkingAdInputsSubtitlesDefault)
}).describe('Pixar Talking Ad\'s form so far: the product (none until picked), and the rest.');

export type PixarTalkingAdInputs = zod.input<typeof PixarTalkingAdInputs>;
export type PixarTalkingAdInputsOutput = zod.output<typeof PixarTalkingAdInputs>;

export const PixarTalkingAdDraft = zod.object({
  "inputs": PixarTalkingAdInputs,
  "pack_director": DirectorState,
  "pack_warning": zod.boolean(),
  "problem": zod.union([zod.string(),zod.null()]),
  "run": zod.union([PixarDraftRun,zod.null()]),
  "script": zod.union([PixarScript,zod.null()]),
  "script_director": DirectorState,
  "script_problems": zod.array(zod.string()),
  "shot_director": DirectorState,
  "spec": zod.union([PixarShotSpec,zod.null()]),
  "stage": DraftStage,
  "stills": zod.array(PixarDraftStill),
  "updated_at": zod.iso.datetime({"offset":true}),
  "urls_expire_at": zod.union([zod.iso.datetime({"offset":true}),zod.null()])
}).describe('A member\'s Pixar Talking Ad draft in the brand: the form, the stage, the script and its\ndirectors (the pack reader\'s, then the script\'s), the shot spec and its director, and the\nstills. `pack_warning`: the pack was hard to read (live\'s "The pack was hard to read ...").\n`script_problems`: what is still off in the script after the director\'s redo, each in live\'s\nwords ("line 3 is out of the beat order"), which live shows as "The script check failed\ntwice: ... Fix the lines before approving."; empty for a script that keeps its checks.\n`problem`: live\'s words for the last director that failed. `stills` is empty until the shot\nspec is kept. `run`: the member\'s last "Generate final video" from this draft, its takes and\nits refused clips (G14 PR 18c); none before one, and after Start over.');

export type PixarTalkingAdDraft = zod.input<typeof PixarTalkingAdDraft>;
export type PixarTalkingAdDraftOutput = zod.output<typeof PixarTalkingAdDraft>;

export const PixarTalkingAdDraftWrite = zod.object({
  "inputs": PixarTalkingAdInputs,
  "script": zod.union([PixarScript,zod.null()]).exactOptional()
}).describe('`PUT .../templates/pixar-talking-ad/draft`: the form as it stands, its script as\nedited.');

export type PixarTalkingAdDraftWrite = zod.input<typeof PixarTalkingAdDraftWrite>;
export type PixarTalkingAdDraftWriteOutput = zod.output<typeof PixarTalkingAdDraftWrite>;

export const PixarTalkingAdScriptAsk = zod.object({
  "inputs": PixarTalkingAdPickedInputs
}).describe('`POST .../draft/script`: live\'s Generate Script, on the form as it stands.');

export type PixarTalkingAdScriptAsk = zod.input<typeof PixarTalkingAdScriptAsk>;
export type PixarTalkingAdScriptAskOutput = zod.output<typeof PixarTalkingAdScriptAsk>;

export const pixarWhiteboardAdPickedInputsCaptionPositionDefault = `bottom`;
export const pixarWhiteboardAdPickedInputsCaptionStyleIdDefault = ``;
export const pixarWhiteboardAdPickedInputsCaptionStyleIdMax = 64;

export const pixarWhiteboardAdPickedInputsCtaDefault = ``;
export const pixarWhiteboardAdPickedInputsCtaMax = 100;

export const pixarWhiteboardAdPickedInputsProblemDefault = ``;
export const pixarWhiteboardAdPickedInputsProblemMax = 500;

export const pixarWhiteboardAdPickedInputsProductCategoryDefault = ``;
export const pixarWhiteboardAdPickedInputsProductCategoryMax = 200;

export const pixarWhiteboardAdPickedInputsProductNameDefault = ``;
export const pixarWhiteboardAdPickedInputsProductNameMax = 200;

export const pixarWhiteboardAdPickedInputsProductTextDefault = ``;
export const pixarWhiteboardAdPickedInputsProductTextMax = 20000;

export const pixarWhiteboardAdPickedInputsPronunciationDefault = ``;
export const pixarWhiteboardAdPickedInputsPronunciationMax = 100;

export const pixarWhiteboardAdPickedInputsResolutionDefault = `1080p`;
export const pixarWhiteboardAdPickedInputsSubtitlesDefault = true;
export const pixarWhiteboardAdPickedInputsTakesPerClipDefault = 1;
export const pixarWhiteboardAdPickedInputsTakesPerClipMax = 3;



export const PixarWhiteboardAdPickedInputs = zod.object({
  "caption_position": zod.enum(['top', 'center', 'bottom']).default(pixarWhiteboardAdPickedInputsCaptionPositionDefault),
  "caption_style_id": zod.string().max(pixarWhiteboardAdPickedInputsCaptionStyleIdMax).default(pixarWhiteboardAdPickedInputsCaptionStyleIdDefault),
  "cta": zod.string().max(pixarWhiteboardAdPickedInputsCtaMax).default(pixarWhiteboardAdPickedInputsCtaDefault),
  "problem": zod.string().max(pixarWhiteboardAdPickedInputsProblemMax).default(pixarWhiteboardAdPickedInputsProblemDefault),
  "product": PackshotProduct,
  "product_category": zod.string().max(pixarWhiteboardAdPickedInputsProductCategoryMax).default(pixarWhiteboardAdPickedInputsProductCategoryDefault),
  "product_name": zod.string().max(pixarWhiteboardAdPickedInputsProductNameMax).default(pixarWhiteboardAdPickedInputsProductNameDefault),
  "product_text": zod.string().max(pixarWhiteboardAdPickedInputsProductTextMax).default(pixarWhiteboardAdPickedInputsProductTextDefault),
  "pronunciation": zod.string().max(pixarWhiteboardAdPickedInputsPronunciationMax).default(pixarWhiteboardAdPickedInputsPronunciationDefault),
  "resolution": zod.enum(['1080p', '720p']).default(pixarWhiteboardAdPickedInputsResolutionDefault),
  "subtitles": zod.boolean().default(pixarWhiteboardAdPickedInputsSubtitlesDefault),
  "takes_per_clip": zod.int().min(1).max(pixarWhiteboardAdPickedInputsTakesPerClipMax).default(pixarWhiteboardAdPickedInputsTakesPerClipDefault)
}).describe('The form with its product picked, as Generate Script and Approve script need it (live\'s\n"Pick a product and its packshot", 422 at `product`).');

export type PixarWhiteboardAdPickedInputs = zod.input<typeof PixarWhiteboardAdPickedInputs>;
export type PixarWhiteboardAdPickedInputsOutput = zod.output<typeof PixarWhiteboardAdPickedInputs>;

export const PixarWhiteboardAdApproval = zod.object({
  "inputs": PixarWhiteboardAdPickedInputs,
  "script": WhiteboardScript
}).describe('`POST .../draft/approve`: live\'s Approve script, the form and the script as edited.');

export type PixarWhiteboardAdApproval = zod.input<typeof PixarWhiteboardAdApproval>;
export type PixarWhiteboardAdApprovalOutput = zod.output<typeof PixarWhiteboardAdApproval>;

export const whiteboardBoardLineCueMax = 2000;

export const whiteboardBoardLineHeadlineMax = 2000;

export const whiteboardBoardLineIconDesignMax = 2000;



export const WhiteboardBoardLine = zod.object({
  "cue": zod.string().max(whiteboardBoardLineCueMax),
  "headline": zod.string().max(whiteboardBoardLineHeadlineMax),
  "icon_design": zod.string().max(whiteboardBoardLineIconDesignMax),
  "line_id": zod.int()
}).describe('A line\'s board as the board director plans it: the script\'s headline, the icon\'s design\nwith its pastel colours, and the 1 to 4 spoken words it appears on.');

export type WhiteboardBoardLine = zod.input<typeof WhiteboardBoardLine>;
export type WhiteboardBoardLineOutput = zod.output<typeof WhiteboardBoardLine>;

export const whiteboardBoardProductBoardPoseMax = 2000;

export const whiteboardBoardProductDescriptionMax = 2000;

export const whiteboardBoardProductProportionsMax = 2000;



export const WhiteboardBoardProduct = zod.object({
  "board_pose": zod.string().max(whiteboardBoardProductBoardPoseMax),
  "description": zod.string().max(whiteboardBoardProductDescriptionMax),
  "proportions": zod.string().max(whiteboardBoardProductProportionsMax)
}).describe('The real pack as the board director writes it out from the packshot.');

export type WhiteboardBoardProduct = zod.input<typeof WhiteboardBoardProduct>;
export type WhiteboardBoardProductOutput = zod.output<typeof WhiteboardBoardProduct>;

export const whiteboardBoardLinesMax = 60;



export const WhiteboardBoard = zod.object({
  "lines": zod.array(WhiteboardBoardLine).min(1).max(whiteboardBoardLinesMax),
  "product": WhiteboardBoardProduct
}).describe('The board director\'s answer (`boardSpecSchema`).');

export type WhiteboardBoard = zod.input<typeof WhiteboardBoard>;
export type WhiteboardBoardOutput = zod.output<typeof WhiteboardBoard>;

export const pixarWhiteboardAdInputsCaptionPositionDefault = `bottom`;
export const pixarWhiteboardAdInputsCaptionStyleIdDefault = ``;
export const pixarWhiteboardAdInputsCaptionStyleIdMax = 64;

export const pixarWhiteboardAdInputsCtaDefault = ``;
export const pixarWhiteboardAdInputsCtaMax = 100;

export const pixarWhiteboardAdInputsProblemDefault = ``;
export const pixarWhiteboardAdInputsProblemMax = 500;

export const pixarWhiteboardAdInputsProductCategoryDefault = ``;
export const pixarWhiteboardAdInputsProductCategoryMax = 200;

export const pixarWhiteboardAdInputsProductNameDefault = ``;
export const pixarWhiteboardAdInputsProductNameMax = 200;

export const pixarWhiteboardAdInputsProductTextDefault = ``;
export const pixarWhiteboardAdInputsProductTextMax = 20000;

export const pixarWhiteboardAdInputsPronunciationDefault = ``;
export const pixarWhiteboardAdInputsPronunciationMax = 100;

export const pixarWhiteboardAdInputsResolutionDefault = `1080p`;
export const pixarWhiteboardAdInputsSubtitlesDefault = true;
export const pixarWhiteboardAdInputsTakesPerClipDefault = 1;
export const pixarWhiteboardAdInputsTakesPerClipMax = 3;



export const PixarWhiteboardAdInputs = zod.object({
  "caption_position": zod.enum(['top', 'center', 'bottom']).default(pixarWhiteboardAdInputsCaptionPositionDefault),
  "caption_style_id": zod.string().max(pixarWhiteboardAdInputsCaptionStyleIdMax).default(pixarWhiteboardAdInputsCaptionStyleIdDefault),
  "cta": zod.string().max(pixarWhiteboardAdInputsCtaMax).default(pixarWhiteboardAdInputsCtaDefault),
  "problem": zod.string().max(pixarWhiteboardAdInputsProblemMax).default(pixarWhiteboardAdInputsProblemDefault),
  "product": zod.union([PackshotProduct,zod.null()]).exactOptional(),
  "product_category": zod.string().max(pixarWhiteboardAdInputsProductCategoryMax).default(pixarWhiteboardAdInputsProductCategoryDefault),
  "product_name": zod.string().max(pixarWhiteboardAdInputsProductNameMax).default(pixarWhiteboardAdInputsProductNameDefault),
  "product_text": zod.string().max(pixarWhiteboardAdInputsProductTextMax).default(pixarWhiteboardAdInputsProductTextDefault),
  "pronunciation": zod.string().max(pixarWhiteboardAdInputsPronunciationMax).default(pixarWhiteboardAdInputsPronunciationDefault),
  "resolution": zod.enum(['1080p', '720p']).default(pixarWhiteboardAdInputsResolutionDefault),
  "subtitles": zod.boolean().default(pixarWhiteboardAdInputsSubtitlesDefault),
  "takes_per_clip": zod.int().min(1).max(pixarWhiteboardAdInputsTakesPerClipMax).default(pixarWhiteboardAdInputsTakesPerClipDefault)
}).describe('Pixar Whiteboard Ad\'s form so far: the product (none until picked), and the rest.');

export type PixarWhiteboardAdInputs = zod.input<typeof PixarWhiteboardAdInputs>;
export type PixarWhiteboardAdInputsOutput = zod.output<typeof PixarWhiteboardAdInputs>;

export const PixarWhiteboardStage = zod.enum(['script', 'cast', 'takes']).describe('Live\'s three stages: the script, the storyboard (`cast`, as the draft\'s row keeps it),\nand the takes once the clips are shot (live\'s `isTakesStage`).');

export type PixarWhiteboardStage = zod.input<typeof PixarWhiteboardStage>;
export type PixarWhiteboardStageOutput = zod.output<typeof PixarWhiteboardStage>;

export const PixarWhiteboardStillName = zod.enum(['sheet', 'master_board', 'char_ref', 'opening', 'anchor_a', 'anchor_b', 'anchor_c', 'end_card']);

export type PixarWhiteboardStillName = zod.input<typeof PixarWhiteboardStillName>;
export type PixarWhiteboardStillNameOutput = zod.output<typeof PixarWhiteboardStillName>;

export const PixarWhiteboardDraftStill = zod.object({
  "name": PixarWhiteboardStillName,
  "output": zod.union([OutputRef,zod.null()]).exactOptional(),
  "problem": zod.union([zod.string(),zod.null()]),
  "status": StillStatus,
  "url": zod.union([zod.string(),zod.null()])
}).describe('One of the eight stills (live\'s `StillState`), as `DraftStill`.');

export type PixarWhiteboardDraftStill = zod.input<typeof PixarWhiteboardDraftStill>;
export type PixarWhiteboardDraftStillOutput = zod.output<typeof PixarWhiteboardDraftStill>;

export const PixarWhiteboardTakeClip = zod.enum(['A', 'B', 'C', 'end_card']);

export type PixarWhiteboardTakeClip = zod.input<typeof PixarWhiteboardTakeClip>;
export type PixarWhiteboardTakeClipOutput = zod.output<typeof PixarWhiteboardTakeClip>;

export const PixarWhiteboardTakeWord = zod.object({
  "end": zod.number(),
  "start": zod.number(),
  "text": zod.string()
}).describe('A word heard in a take, in seconds from its start, as the draft keeps it.');

export type PixarWhiteboardTakeWord = zod.input<typeof PixarWhiteboardTakeWord>;
export type PixarWhiteboardTakeWordOutput = zod.output<typeof PixarWhiteboardTakeWord>;

export const WhiteboardVerdict = zod.enum(['pass', 'trim', 'check', 'retake']).describe('A take\'s word check (live\'s `WORD_CHECK_VERDICTS`), best first; none is "Unchecked".');

export type WhiteboardVerdict = zod.input<typeof WhiteboardVerdict>;
export type WhiteboardVerdictOutput = zod.output<typeof WhiteboardVerdict>;

export const pixarWhiteboardTakeHeardDefault = [];

export const PixarWhiteboardTake = zod.object({
  "check_problem": zod.union([zod.string(),zod.null()]),
  "duration_s": zod.union([zod.number(),zod.null()]),
  "flagged_cues": zod.int(),
  "heard": zod.array(PixarWhiteboardTakeWord).default(pixarWhiteboardTakeHeardDefault),
  "number": zod.int(),
  "output": zod.union([OutputRef,zod.null()]).exactOptional(),
  "problem": zod.union([zod.string(),zod.null()]),
  "status": StillStatus,
  "url": zod.union([zod.string(),zod.null()]),
  "verdict": zod.union([WhiteboardVerdict,zod.null()])
}).describe('One take (live\'s take row): `working` while it is shot or heard, `done` with its video\nat `url`, its length, its verdict ("Unchecked" when none) and its flagged cues, or `failed`\n(`problem` says why). `check_problem`: why it is unchecked. `output` names the video and\n`heard` its words, as the video\'s run takes them.');

export type PixarWhiteboardTake = zod.input<typeof PixarWhiteboardTake>;
export type PixarWhiteboardTakeOutput = zod.output<typeof PixarWhiteboardTake>;

export const PixarWhiteboardClipTakes = zod.object({
  "clip": PixarWhiteboardTakeClip,
  "picked": zod.union([zod.int(),zod.null()]),
  "takes": zod.array(PixarWhiteboardTake)
}).describe('A clip\'s takes in the order shot, and the picked one by its number.');

export type PixarWhiteboardClipTakes = zod.input<typeof PixarWhiteboardClipTakes>;
export type PixarWhiteboardClipTakesOutput = zod.output<typeof PixarWhiteboardClipTakes>;

export const WhiteboardLineTiming = zod.object({
  "beat_end_s": zod.number(),
  "beat_start_s": zod.number(),
  "end_s": zod.number(),
  "line_id": zod.int(),
  "start_s": zod.number(),
  "words": zod.int()
}).describe('When a line is said inside its clip, and the beat its board line may appear in.');

export type WhiteboardLineTiming = zod.input<typeof WhiteboardLineTiming>;
export type WhiteboardLineTimingOutput = zod.output<typeof WhiteboardLineTiming>;

export const WhiteboardClipTiming = zod.object({
  "clip": WhiteboardClip,
  "duration_s": zod.int(),
  "lines": zod.array(WhiteboardLineTiming),
  "pace_wps": zod.number(),
  "speech_start_s": zod.number(),
  "tail_s": zod.number(),
  "words": zod.int()
}).describe('A clip\'s whole seconds (4 to 15), when its speech starts, its tail, words and pace.');

export type WhiteboardClipTiming = zod.input<typeof WhiteboardClipTiming>;
export type WhiteboardClipTimingOutput = zod.output<typeof WhiteboardClipTiming>;

export const WhiteboardTimingPlan = zod.object({
  "clips": zod.array(WhiteboardClipTiming),
  "end_card_s": zod.int(),
  "pace_target_wps": zod.int(),
  "total_s": zod.int(),
  "warnings": zod.array(zod.string())
}).describe('Live\'s timing plan of an approved script (`TimingPlan`): the board director\'s\n`TIMING_PLAN` and the clips\' beat times; its warnings shown at approval.');

export type WhiteboardTimingPlan = zod.input<typeof WhiteboardTimingPlan>;
export type WhiteboardTimingPlanOutput = zod.output<typeof WhiteboardTimingPlan>;

export const PixarWhiteboardAdDraft = zod.object({
  "board": zod.union([WhiteboardBoard,zod.null()]),
  "board_director": DirectorState,
  "cue_warnings": zod.array(zod.string()),
  "inputs": PixarWhiteboardAdInputs,
  "pack_director": DirectorState,
  "problem": zod.union([zod.string(),zod.null()]),
  "script": zod.union([WhiteboardScript,zod.null()]),
  "script_director": DirectorState,
  "script_issue": zod.union([zod.string(),zod.null()]),
  "script_warning": zod.union([zod.string(),zod.null()]),
  "stage": PixarWhiteboardStage,
  "stills": zod.array(PixarWhiteboardDraftStill),
  "takes": zod.array(PixarWhiteboardClipTakes),
  "timing": zod.union([WhiteboardTimingPlan,zod.null()]),
  "updated_at": zod.iso.datetime({"offset":true}),
  "urls_expire_at": zod.union([zod.iso.datetime({"offset":true}),zod.null()])
}).describe('The member\'s Pixar Whiteboard Ad draft: the form, the stage, the script with its\ndirectors\' states and live\'s warning, its timing plan, the board spec with its cue\nwarnings, the eight stills, the takes once shot (A, B, C and the end card), and the last\ndirector\'s problem.');

export type PixarWhiteboardAdDraft = zod.input<typeof PixarWhiteboardAdDraft>;
export type PixarWhiteboardAdDraftOutput = zod.output<typeof PixarWhiteboardAdDraft>;

export const PixarWhiteboardAdDraftWrite = zod.object({
  "inputs": PixarWhiteboardAdInputs,
  "script": zod.union([WhiteboardScript,zod.null()]).exactOptional()
}).describe('`PUT .../templates/pixar-whiteboard-ad/draft`: the form as it stands, its script as\nedited ("Write the 10 lines yourself" sends the blank one).');

export type PixarWhiteboardAdDraftWrite = zod.input<typeof PixarWhiteboardAdDraftWrite>;
export type PixarWhiteboardAdDraftWriteOutput = zod.output<typeof PixarWhiteboardAdDraftWrite>;

export const pixarWhiteboardAdPickTakeMax = 10;



export const PixarWhiteboardAdPick = zod.object({
  "take": zod.int().min(1).max(pixarWhiteboardAdPickTakeMax)
}).describe('`POST .../draft/takes/{clip}/pick`: a finished take of the clip, by its number.');

export type PixarWhiteboardAdPick = zod.input<typeof PixarWhiteboardAdPick>;
export type PixarWhiteboardAdPickOutput = zod.output<typeof PixarWhiteboardAdPick>;

export const PixarWhiteboardAdScriptAsk = zod.object({
  "inputs": PixarWhiteboardAdPickedInputs
}).describe('`POST .../draft/script`: live\'s Generate Script, on the form as it stands.');

export type PixarWhiteboardAdScriptAsk = zod.input<typeof PixarWhiteboardAdScriptAsk>;
export type PixarWhiteboardAdScriptAskOutput = zod.output<typeof PixarWhiteboardAdScriptAsk>;

export const pixarWhiteboardAdShootResolutionDefault = `1080p`;
export const pixarWhiteboardAdShootTakesPerClipDefault = 1;
export const pixarWhiteboardAdShootTakesPerClipMax = 3;



export const PixarWhiteboardAdShoot = zod.object({
  "resolution": zod.enum(['1080p', '720p']).default(pixarWhiteboardAdShootResolutionDefault),
  "takes_per_clip": zod.int().min(1).max(pixarWhiteboardAdShootTakesPerClipMax).default(pixarWhiteboardAdShootTakesPerClipDefault)
}).describe('`POST .../draft/shoot`: live\'s "Shoot the clips", at the form\'s resolution and takes per\nclip.');

export type PixarWhiteboardAdShoot = zod.input<typeof PixarWhiteboardAdShoot>;
export type PixarWhiteboardAdShootOutput = zod.output<typeof PixarWhiteboardAdShoot>;

export const PodcastLength = zod.enum(['45', '60', '80']);

export type PodcastLength = zod.input<typeof PodcastLength>;
export type PodcastLengthOutput = zod.output<typeof PodcastLength>;

export const PodcastProductPick = zod.object({
  "image_id": zod.uuid(),
  "product_id": zod.uuid()
}).describe('The product the ad sells and its packshot: one of the product\'s own pictures (live\'s\nproduct tile: "Pick a product, then the packshot image").');

export type PodcastProductPick = zod.input<typeof PodcastProductPick>;
export type PodcastProductPickOutput = zod.output<typeof PodcastProductPick>;

export const podcastAdPickedInputsCaptionPositionDefault = `bottom`;
export const podcastAdPickedInputsCaptionStyleIdDefault = ``;
export const podcastAdPickedInputsCaptionStyleIdMax = 64;

export const podcastAdPickedInputsCtaDefault = ``;
export const podcastAdPickedInputsCtaMax = 100;

export const podcastAdPickedInputsLengthDefault = '60';
export const podcastAdPickedInputsPronunciationDefault = ``;
export const podcastAdPickedInputsPronunciationMax = 100;

export const podcastAdPickedInputsSubtitlesDefault = true;
export const podcastAdPickedInputsTopicDefault = ``;
export const podcastAdPickedInputsTopicMax = 500;



export const PodcastAdPickedInputs = zod.object({
  "caption_position": zod.enum(['top', 'center', 'bottom']).default(podcastAdPickedInputsCaptionPositionDefault),
  "caption_style_id": zod.string().max(podcastAdPickedInputsCaptionStyleIdMax).default(podcastAdPickedInputsCaptionStyleIdDefault),
  "cta": zod.string().max(podcastAdPickedInputsCtaMax).default(podcastAdPickedInputsCtaDefault),
  "guest": zod.union([ActorSource,zod.null()]).exactOptional(),
  "host": zod.union([ActorSource,zod.null()]).exactOptional(),
  "length": PodcastLength.default(podcastAdPickedInputsLengthDefault),
  "product": PodcastProductPick,
  "pronunciation": zod.string().max(podcastAdPickedInputsPronunciationMax).default(podcastAdPickedInputsPronunciationDefault),
  "subtitles": zod.boolean().default(podcastAdPickedInputsSubtitlesDefault),
  "topic": zod.string().max(podcastAdPickedInputsTopicMax).default(podcastAdPickedInputsTopicDefault)
}).describe('The form with its product picked, as Generate script and Approve script need it (live\'s\n"Pick a product and its packshot", 422 at `product`, its words kept).');

export type PodcastAdPickedInputs = zod.input<typeof PodcastAdPickedInputs>;
export type PodcastAdPickedInputsOutput = zod.output<typeof PodcastAdPickedInputs>;

export const PodcastAdApproval = zod.object({
  "inputs": PodcastAdPickedInputs,
  "script": PodcastScript
}).describe('`POST .../templates/podcast-ad/draft/approve`: live\'s Approve script, on the form as it\nstands (its product picked) and the script as edited.');

export type PodcastAdApproval = zod.input<typeof PodcastAdApproval>;
export type PodcastAdApprovalOutput = zod.output<typeof PodcastAdApproval>;

export const podcastAdInputsCaptionPositionDefault = `bottom`;
export const podcastAdInputsCaptionStyleIdDefault = ``;
export const podcastAdInputsCaptionStyleIdMax = 64;

export const podcastAdInputsCtaDefault = ``;
export const podcastAdInputsCtaMax = 100;

export const podcastAdInputsLengthDefault = '60';
export const podcastAdInputsPronunciationDefault = ``;
export const podcastAdInputsPronunciationMax = 100;

export const podcastAdInputsSubtitlesDefault = true;
export const podcastAdInputsTopicDefault = ``;
export const podcastAdInputsTopicMax = 500;



export const PodcastAdInputs = zod.object({
  "caption_position": zod.enum(['top', 'center', 'bottom']).default(podcastAdInputsCaptionPositionDefault),
  "caption_style_id": zod.string().max(podcastAdInputsCaptionStyleIdMax).default(podcastAdInputsCaptionStyleIdDefault),
  "cta": zod.string().max(podcastAdInputsCtaMax).default(podcastAdInputsCtaDefault),
  "guest": zod.union([ActorSource,zod.null()]).exactOptional(),
  "host": zod.union([ActorSource,zod.null()]).exactOptional(),
  "length": PodcastLength.default(podcastAdInputsLengthDefault),
  "product": zod.union([PodcastProductPick,zod.null()]).exactOptional(),
  "pronunciation": zod.string().max(podcastAdInputsPronunciationMax).default(podcastAdInputsPronunciationDefault),
  "subtitles": zod.boolean().default(podcastAdInputsSubtitlesDefault),
  "topic": zod.string().max(podcastAdInputsTopicMax).default(podcastAdInputsTopicDefault)
}).describe('Podcast Ad\'s form so far: the product and its packshot (none yet until picked), and the\nrest of the form.');

export type PodcastAdInputs = zod.input<typeof PodcastAdInputs>;
export type PodcastAdInputsOutput = zod.output<typeof PodcastAdInputs>;

export const PodcastAdDraft = zod.object({
  "inputs": PodcastAdInputs,
  "problem": zod.union([zod.string(),zod.null()]),
  "script": zod.union([PodcastScript,zod.null()]),
  "script_director": DirectorState,
  "script_warning": zod.boolean(),
  "shot_director": DirectorState,
  "spec": zod.union([ShotSpec,zod.null()]),
  "stage": DraftStage,
  "stills": zod.array(DraftStill),
  "updated_at": zod.iso.datetime({"offset":true}),
  "urls_expire_at": zod.union([zod.iso.datetime({"offset":true}),zod.null()])
}).describe('A member\'s Podcast Ad draft in the brand: the form, the stage, the script and its\ndirector, the shot spec and its director, and the cast\'s stills. `script_warning`: a product\nfact still not quoted from the page after the director\'s redo (live\'s "Some product facts are\nnot quoted from the product page"). `problem`: live\'s words for the last director that\nfailed, its problems with them. `stills` is empty until the shot spec is kept.');

export type PodcastAdDraft = zod.input<typeof PodcastAdDraft>;
export type PodcastAdDraftOutput = zod.output<typeof PodcastAdDraft>;

export const PodcastAdDraftWrite = zod.object({
  "inputs": PodcastAdInputs,
  "script": zod.union([PodcastScript,zod.null()]).exactOptional()
}).describe('`PUT .../templates/podcast-ad/draft`: the form as it stands, its script as edited.');

export type PodcastAdDraftWrite = zod.input<typeof PodcastAdDraftWrite>;
export type PodcastAdDraftWriteOutput = zod.output<typeof PodcastAdDraftWrite>;

export const PodcastAdScriptAsk = zod.object({
  "inputs": PodcastAdPickedInputs
}).describe('`POST .../templates/podcast-ad/draft/script`: live\'s Generate script, on the form as it\nstands, its product picked.');

export type PodcastAdScriptAsk = zod.input<typeof PodcastAdScriptAsk>;
export type PodcastAdScriptAskOutput = zod.output<typeof PodcastAdScriptAsk>;

export const Preference = zod.object({
  "cases_hidden": zod.boolean(),
  "theme": ThemeId
}).describe('The person\'s saved theme and whether they hid the free daily case.');

export type Preference = zod.input<typeof Preference>;
export type PreferenceOutput = zod.output<typeof Preference>;

export const PreferenceUpdate = zod.object({
  "cases_hidden": zod.union([zod.boolean(),zod.null()]).exactOptional(),
  "theme": zod.union([ThemeId,zod.null()]).exactOptional()
}).describe('`PATCH /v1/me/appearance`: the person\'s theme (one they own) and their own switch. A field\nleft out, or null, stays as it is.');

export type PreferenceUpdate = zod.input<typeof PreferenceUpdate>;
export type PreferenceUpdateOutput = zod.output<typeof PreferenceUpdate>;

export const ProductImageTag = zod.enum(['product_shot', 'in_use', 'packaging', 'other']);

export type ProductImageTag = zod.input<typeof ProductImageTag>;
export type ProductImageTagOutput = zod.output<typeof ProductImageTag>;

export const productImageIsMainDefault = false;

export const ProductImage = zod.object({
  "asset_id": zod.uuid(),
  "height": zod.union([zod.int(),zod.null()]).exactOptional(),
  "is_main": zod.boolean().default(productImageIsMainDefault),
  "tag": ProductImageTag,
  "thumb_url": zod.union([zod.string(),zod.null()]).exactOptional(),
  "url": zod.union([zod.string(),zod.null()]),
  "width": zod.union([zod.int(),zod.null()]).exactOptional()
}).describe('One image of a product in a response, with its asset\'s signed URL.');

export type ProductImage = zod.input<typeof ProductImage>;
export type ProductImageOutput = zod.output<typeof ProductImage>;

export const Product = zod.object({
  "ai_description": zod.union([zod.string(),zod.null()]),
  "colors": zod.array(Color),
  "created_at": zod.iso.datetime({"offset":true}),
  "created_by": zod.uuid(),
  "description": zod.union([zod.string(),zod.null()]),
  "id": zod.uuid(),
  "images": zod.array(ProductImage),
  "key_benefits": zod.array(zod.string()),
  "name": zod.string(),
  "offer": zod.union([zod.string(),zod.null()]),
  "price": zod.union([zod.string(),zod.null()]),
  "tagline": zod.union([zod.string(),zod.null()]),
  "updated_at": zod.iso.datetime({"offset":true}),
  "urls_expire_at": zod.union([zod.iso.datetime({"offset":true}),zod.null()]),
  "use_cases": zod.array(zod.string())
});

export type Product = zod.input<typeof Product>;
export type ProductOutput = zod.output<typeof Product>;

export const ProductExtract = zod.object({
  "compare_price": zod.union([zod.string(),zod.null()]),
  "description": zod.string(),
  "images": zod.array(ExtractedImage),
  "key_benefits": zod.array(zod.string()),
  "name": zod.string(),
  "price": zod.union([zod.string(),zod.null()]),
  "tagline": zod.string(),
  "use_cases": zod.array(zod.string())
}).describe('An `extract.product` job\'s one output, its JSON file (#249, live\'s `ProductExtract` for a\nShopify product): what live\'s product form fills. The name, price and images are the\nstore\'s; the description, tagline, benefits and use cases are Gemini\'s.');

export type ProductExtract = zod.input<typeof ProductExtract>;
export type ProductExtractOutput = zod.output<typeof ProductExtract>;

export const productImageInIsMainDefault = false;

export const ProductImageIn = zod.object({
  "asset_id": zod.uuid(),
  "is_main": zod.boolean().default(productImageInIsMainDefault),
  "tag": ProductImageTag
}).describe('One image of a product in a request: an asset of the team.');

export type ProductImageIn = zod.input<typeof ProductImageIn>;
export type ProductImageInOutput = zod.output<typeof ProductImageIn>;

export const productInColorsMax = 5;

export const productInDescriptionOneMax = 20000;


export const productInDescriptionOneRegExp = new RegExp('[^\\t\\n\\v\\f\\r \\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000\\ufeff]');
export const productInImagesMax = 5;

export const productInKeyBenefitsItemMax = 300;


export const productInKeyBenefitsItemRegExp = new RegExp('[^\\t\\n\\v\\f\\r \\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000\\ufeff]');
export const productInKeyBenefitsMax = 10;

export const productInNameMax = 200;


export const productInNameRegExp = new RegExp('[^\\t\\n\\v\\f\\r \\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000\\ufeff]');
export const productInOfferOneMax = 500;


export const productInOfferOneRegExp = new RegExp('[^\\t\\n\\v\\f\\r \\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000\\ufeff]');
export const productInPriceOneMax = 100;


export const productInPriceOneRegExp = new RegExp('[^\\t\\n\\v\\f\\r \\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000\\ufeff]');
export const productInTaglineOneMax = 200;


export const productInTaglineOneRegExp = new RegExp('[^\\t\\n\\v\\f\\r \\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000\\ufeff]');
export const productInUseCasesItemMax = 300;


export const productInUseCasesItemRegExp = new RegExp('[^\\t\\n\\v\\f\\r \\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000\\ufeff]');
export const productInUseCasesMax = 10;



export const ProductIn = zod.object({
  "colors": zod.array(Color).max(productInColorsMax).exactOptional(),
  "description": zod.union([zod.string().min(1).max(productInDescriptionOneMax).regex(productInDescriptionOneRegExp),zod.null()]).exactOptional(),
  "images": zod.array(ProductImageIn).max(productInImagesMax).exactOptional(),
  "key_benefits": zod.array(zod.string().min(1).max(productInKeyBenefitsItemMax).regex(productInKeyBenefitsItemRegExp)).max(productInKeyBenefitsMax).exactOptional(),
  "name": zod.string().min(1).max(productInNameMax).regex(productInNameRegExp),
  "offer": zod.union([zod.string().min(1).max(productInOfferOneMax).regex(productInOfferOneRegExp),zod.null()]).exactOptional(),
  "price": zod.union([zod.string().min(1).max(productInPriceOneMax).regex(productInPriceOneRegExp),zod.null()]).exactOptional(),
  "tagline": zod.union([zod.string().min(1).max(productInTaglineOneMax).regex(productInTaglineOneRegExp),zod.null()]).exactOptional(),
  "use_cases": zod.array(zod.string().min(1).max(productInUseCasesItemMax).regex(productInUseCasesItemRegExp)).max(productInUseCasesMax).exactOptional()
}).describe('`POST .../products` and `PUT .../products/{product_id}`: the whole product. The brand is\nthe one in the path; a product never moves to another brand.');

export type ProductIn = zod.input<typeof ProductIn>;
export type ProductInOutput = zod.output<typeof ProductIn>;

export const ProductOrder = zod.enum(['newest', 'oldest', 'a_to_z', 'z_to_a', 'most_popular']).describe('The brand\'s products list\'s order, live\'s menu (spec A3d): Created Date\'s "Recently\nAdded" and "Oldest First", Product Name\'s "A-Z" and "Z-A", Popularity\'s "Most Popular" (the\nproducts the team\'s generations showed most).');

export type ProductOrder = zod.input<typeof ProductOrder>;
export type ProductOrderOutput = zod.output<typeof ProductOrder>;

export const ProductSummary = zod.object({
  "brand_id": zod.uuid(),
  "id": zod.uuid(),
  "name": zod.string()
}).describe('A product in the team-wide list (live\'s Product menus list every brand\'s): its name and\nthe brand it belongs to.');

export type ProductSummary = zod.input<typeof ProductSummary>;
export type ProductSummaryOutput = zod.output<typeof ProductSummary>;

export const PromptTemplateKind = zod.enum(['custom', 'global']).describe('Live\'s two tabs: the brand\'s own (Custom, first) and live\'s (Global).');

export type PromptTemplateKind = zod.input<typeof PromptTemplateKind>;
export type PromptTemplateKindOutput = zod.output<typeof PromptTemplateKind>;

export const PromptTemplate = zod.object({
  "cover_url": zod.union([zod.string(),zod.null()]),
  "created_at": zod.iso.datetime({"offset":true}),
  "height": zod.union([zod.int(),zod.null()]),
  "id": zod.uuid(),
  "kind": PromptTemplateKind,
  "name": zod.string(),
  "prompt": zod.string(),
  "references": zod.array(ActorSource),
  "width": zod.union([zod.int(),zod.null()])
}).describe('A template: its prompt, a custom one\'s reference images (none for a global one), and its\ncover, signed like a job\'s outputs until the page\'s `urls_expire_at`; none when it has no\ncover or its picture is gone. A custom one\'s size is its cover\'s to read; a global one\'s is\nlive\'s.');

export type PromptTemplate = zod.input<typeof PromptTemplate>;
export type PromptTemplateOutput = zod.output<typeof PromptTemplate>;

export const PromptTemplatePage = zod.object({
  "items": zod.array(PromptTemplate),
  "next": zod.union([zod.string(),zod.null()]),
  "urls_expire_at": zod.union([zod.iso.datetime({"offset":true}),zod.null()])
}).describe('A page of templates, newest first (live\'s "Recently Added") or oldest first.');

export type PromptTemplatePage = zod.input<typeof PromptTemplatePage>;
export type PromptTemplatePageOutput = zod.output<typeof PromptTemplatePage>;

export const PromptTemplateRequest = zod.object({
  "asset_id": zod.uuid()
}).describe('`POST .../prompt-templates`: live\'s one-click "Save Prompt" on a picture saved from a\nsimple image job; the prompt and its reference images are that job\'s.');

export type PromptTemplateRequest = zod.input<typeof PromptTemplateRequest>;
export type PromptTemplateRequestOutput = zod.output<typeof PromptTemplateRequest>;

export const QuoteChangedDetails = zod.object({
  "expected": zod.int(),
  "quoted": zod.int()
}).describe('The job now costs more than the client showed: what it costs, and what was expected.');

export type QuoteChangedDetails = zod.input<typeof QuoteChangedDetails>;
export type QuoteChangedDetailsOutput = zod.output<typeof QuoteChangedDetails>;

export const RateLimitedDetails = zod.object({
  "limit": zod.string(),
  "max": zod.int(),
  "retry_after_seconds": zod.int()
}).describe('Which limit was reached (`free_sku:<sku>`, ...), its maximum, and when to try again.');

export type RateLimitedDetails = zod.input<typeof RateLimitedDetails>;
export type RateLimitedDetailsOutput = zod.output<typeof RateLimitedDetails>;

export const RecentFolder = zod.object({
  "asset_count": zod.int(),
  "id": zod.uuid(),
  "name": zod.string()
}).describe('One of Home\'s Recent Projects (#247, live\'s `GET /brand-projects/recent`): a folder of the\nbrand the member used lately, and how many assets it holds itself (not its subfolders\').');

export type RecentFolder = zod.input<typeof RecentFolder>;
export type RecentFolderOutput = zod.output<typeof RecentFolder>;

export const saveRequestNameOneMax = 255;


export const saveRequestNameOneRegExp = new RegExp('[^\\t\\n\\v\\f\\r \\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000\\ufeff]');
export const saveRequestOutputIndexMin = 0;



export const SaveRequest = zod.object({
  "folder_id": zod.union([zod.uuid(),zod.null()]).exactOptional(),
  "job_id": zod.uuid(),
  "name": zod.union([zod.string().min(1).max(saveRequestNameOneMax).regex(saveRequestNameOneRegExp),zod.null()]).exactOptional(),
  "output_index": zod.int().min(saveRequestOutputIndexMin)
}).describe('`POST .../brands/{brand_id}/assets/from-generation`: which job output to keep.');

export type SaveRequest = zod.input<typeof SaveRequest>;
export type SaveRequestOutput = zod.output<typeof SaveRequest>;

export const seenAwardsAwardIdsMax = 500;



export const SeenAwards = zod.object({
  "award_ids": zod.array(zod.uuid()).min(1).max(seenAwardsAwardIdsMax)
}).describe('`POST /v1/me/achievements/seen`: the unlocks the popover or the card showed, by award, so\none that arrives meanwhile still waits.');

export type SeenAwards = zod.input<typeof SeenAwards>;
export type SeenAwardsOutput = zod.output<typeof SeenAwards>;

export const sharedAchievementIdRegExp = new RegExp('^[a-z0-9][a-z0-9_.:-]{0,63}$');


export const SharedAchievement = zod.object({
  "description": zod.string(),
  "earned_at": zod.iso.datetime({"offset":true}),
  "glyph": zod.string(),
  "id": zod.string().regex(sharedAchievementIdRegExp),
  "name": zod.string(),
  "secret": zod.boolean(),
  "stage": Stage,
  "tier": Tier
}).describe('An achievement a sharing teammate earned in this team, all of it.');

export type SharedAchievement = zod.input<typeof SharedAchievement>;
export type SharedAchievementOutput = zod.output<typeof SharedAchievement>;

export const Sharing = zod.object({
  "shared": zod.boolean()
}).describe('Whether the user shares the awards they earned in this team with its members.');

export type Sharing = zod.input<typeof Sharing>;
export type SharingOutput = zod.output<typeof Sharing>;

export const SharingUpdate = zod.object({
  "shared": zod.boolean()
}).describe('`PUT /v1/teams/{team_id}/achievements/sharing`: share the awards earned in this team with\nits members, or stop.');

export type SharingUpdate = zod.input<typeof SharingUpdate>;
export type SharingUpdateOutput = zod.output<typeof SharingUpdate>;

export const signedInRedirectOneMax = 2048;


export const signedInRedirectOneRegExp = new RegExp('^/([^/\\\\\\t\\n\\v\\f\\r \\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000\\ufeff][^\\\\\\t\\n\\v\\f\\r \\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000\\ufeff]*)?$');


export const SignedIn = zod.object({
  "created": zod.boolean(),
  "redirect": zod.union([zod.string().max(signedInRedirectOneMax).regex(signedInRedirectOneRegExp),zod.null()]).exactOptional(),
  "user": Me
}).describe('The session itself travels only in `Set-Cookie`. `redirect` is Google\'s way back.');

export type SignedIn = zod.input<typeof SignedIn>;
export type SignedInOutput = zod.output<typeof SignedIn>;

export const staffAdjustmentCreditsMin = -10000000;
export const staffAdjustmentCreditsMax = 10000000;

export const staffAdjustmentReasonMax = 500;


export const staffAdjustmentReasonRegExp = new RegExp('[^\\t\\n\\v\\f\\r \\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000\\ufeff]');


export const StaffAdjustment = zod.object({
  "credits": zod.int().min(staffAdjustmentCreditsMin).max(staffAdjustmentCreditsMax),
  "expires_at": zod.union([zod.iso.datetime({"offset":true}),zod.null()]).exactOptional(),
  "reason": zod.string().min(1).max(staffAdjustmentReasonMax).regex(staffAdjustmentReasonRegExp)
}).describe('A signed correction with its reason (D5, D8). A positive one is a lot of its own and may\nexpire; a negative one draws from the lots and is refused past `available`.');

export type StaffAdjustment = zod.input<typeof StaffAdjustment>;
export type StaffAdjustmentOutput = zod.output<typeof StaffAdjustment>;

export const StaffAdjustmentResult = zod.object({
  "available_after": zod.int()
});

export type StaffAdjustmentResult = zod.input<typeof StaffAdjustmentResult>;
export type StaffAdjustmentResultOutput = zod.output<typeof StaffAdjustmentResult>;

export const StaffGrantResult = zod.object({
  "credits": zod.int(),
  "expires_at": zod.union([zod.iso.datetime({"offset":true}),zod.null()]),
  "lot_id": zod.uuid()
});

export type StaffGrantResult = zod.input<typeof StaffGrantResult>;
export type StaffGrantResultOutput = zod.output<typeof StaffGrantResult>;

export const staffJobCancelReasonMax = 500;


export const staffJobCancelReasonRegExp = new RegExp('[^\\t\\n\\v\\f\\r \\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000\\ufeff]');


export const StaffJobCancel = zod.object({
  "reason": zod.string().min(1).max(staffJobCancelReasonMax).regex(staffJobCancelReasonRegExp)
}).describe('Why staff stops a job (D10: staff only in M1).');

export type StaffJobCancel = zod.input<typeof StaffJobCancel>;
export type StaffJobCancelOutput = zod.output<typeof StaffJobCancel>;

export const StaffJobCanceled = zod.object({
  "job_id": zod.uuid(),
  "previous_status": JobStatus,
  "status": JobStatus
});

export type StaffJobCanceled = zod.input<typeof StaffJobCanceled>;
export type StaffJobCanceledOutput = zod.output<typeof StaffJobCanceled>;

export const staffLotGrantCreditsMax = 10000000;

export const staffLotGrantReasonMax = 500;


export const staffLotGrantReasonRegExp = new RegExp('[^\\t\\n\\v\\f\\r \\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000\\ufeff]');


export const StaffLotGrant = zod.object({
  "credits": zod.int().min(1).max(staffLotGrantCreditsMax),
  "expires_at": zod.union([zod.iso.datetime({"offset":true}),zod.null()]).exactOptional(),
  "kind": zod.literal("lot").meta({ title: 'Kind' }),
  "reason": zod.string().min(1).max(staffLotGrantReasonMax).regex(staffLotGrantReasonRegExp)
}).describe('Credits in a lot of their own: `grant` source, `origin_ref` "staff", the reason kept.');

export type StaffLotGrant = zod.input<typeof StaffLotGrant>;
export type StaffLotGrantOutput = zod.output<typeof StaffLotGrant>;

export const StaffMembership = zod.object({
  "role": TeamRole,
  "team_deleted_at": zod.union([zod.iso.datetime({"offset":true}),zod.null()]),
  "team_id": zod.uuid(),
  "team_name": zod.string()
}).describe('One team a user belongs to, as staff sees it; `team_deleted_at` for a deleted team.');

export type StaffMembership = zod.input<typeof StaffMembership>;
export type StaffMembershipOutput = zod.output<typeof StaffMembership>;

export const staffPlanPeriodGrantPlanCodeRegExp = new RegExp('^[a-z][a-z0-9_]{0,49}$');
export const staffPlanPeriodGrantReasonMax = 500;


export const staffPlanPeriodGrantReasonRegExp = new RegExp('[^\\t\\n\\v\\f\\r \\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000\\ufeff]');


export const StaffPlanPeriodGrant = zod.object({
  "kind": zod.literal("plan_period").meta({ title: 'Kind' }),
  "period_start": zod.union([zod.iso.date(),zod.null()]).exactOptional(),
  "plan_code": zod.string().regex(staffPlanPeriodGrantPlanCodeRegExp),
  "reason": zod.string().min(1).max(staffPlanPeriodGrantReasonMax).regex(staffPlanPeriodGrantReasonRegExp)
}).describe('One calendar month (UTC) of an active plan\'s credits, expiring at the month\'s end and\nkeyed as `createdai seed` keys it: a month already granted replays (decision O1).');

export type StaffPlanPeriodGrant = zod.input<typeof StaffPlanPeriodGrant>;
export type StaffPlanPeriodGrantOutput = zod.output<typeof StaffPlanPeriodGrant>;

export const StaffTeam = zod.object({
  "created_at": zod.iso.datetime({"offset":true}),
  "deleted_at": zod.union([zod.iso.datetime({"offset":true}),zod.null()]),
  "held_by_staff": zod.boolean(),
  "id": zod.uuid(),
  "member_count": zod.int(),
  "name": zod.string(),
  "owner_user_id": zod.uuid()
}).describe('A team as staff sees it. `held_by_staff` until the named owner accepts.');

export type StaffTeam = zod.input<typeof StaffTeam>;
export type StaffTeamOutput = zod.output<typeof StaffTeam>;

export const staffTeamCreateNameMax = 100;


export const staffTeamCreateNameRegExp = new RegExp('[^\\t\\n\\v\\f\\r \\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000\\ufeff]');
export const staffTeamCreateOwnerEmailMin = 3;
export const staffTeamCreateOwnerEmailMax = 320;


export const staffTeamCreateOwnerEmailRegExp = new RegExp('^[a-zA-Z0-9.!#$%&\'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?)+$');


export const StaffTeamCreate = zod.object({
  "name": zod.string().min(1).max(staffTeamCreateNameMax).regex(staffTeamCreateNameRegExp),
  "owner_email": zod.string().min(staffTeamCreateOwnerEmailMin).max(staffTeamCreateOwnerEmailMax).regex(staffTeamCreateOwnerEmailRegExp)
}).describe('The staff action "create a team for an owner email" (proposal 6.3).');

export type StaffTeamCreate = zod.input<typeof StaffTeamCreate>;
export type StaffTeamCreateOutput = zod.output<typeof StaffTeamCreate>;

export const Team = zod.object({
  "created_at": zod.iso.datetime({"offset":true}),
  "id": zod.uuid(),
  "name": zod.string(),
  "owner_user_id": zod.uuid()
});

export type Team = zod.input<typeof Team>;
export type TeamOutput = zod.output<typeof Team>;

export const StaffTeamCreated = zod.object({
  "invitation": zod.union([Invitation,zod.null()]),
  "team": Team
});

export type StaffTeamCreated = zod.input<typeof StaffTeamCreated>;
export type StaffTeamCreatedOutput = zod.output<typeof StaffTeamCreated>;

export const TeamCredits = zod.object({
  "balance": Balance,
  "entries": zod.array(LedgerEntryView)
}).describe('A team\'s balance and its newest ledger entries, newest first (the staff team detail).');

export type TeamCredits = zod.input<typeof TeamCredits>;
export type TeamCreditsOutput = zod.output<typeof TeamCredits>;

export const StaffTeamDetail = zod.object({
  "credits": TeamCredits,
  "invitations": zod.array(Invitation),
  "members": zod.array(Member),
  "team": StaffTeam
}).describe('One team as staff reads it: members, open invitations, balance and newest entries.');

export type StaffTeamDetail = zod.input<typeof StaffTeamDetail>;
export type StaffTeamDetailOutput = zod.output<typeof StaffTeamDetail>;

export const StaffTeamListed = zod.object({
  "cost_incomplete": zod.int(),
  "created_at": zod.iso.datetime({"offset":true}),
  "credits_used": zod.int(),
  "deleted_at": zod.union([zod.iso.datetime({"offset":true}),zod.null()]),
  "held_by_staff": zod.boolean(),
  "id": zod.uuid(),
  "member_count": zod.int(),
  "name": zod.string(),
  "owner_user_id": zod.uuid(),
  "vendor_cost_usd": zod.union([zod.string(),zod.null()])
}).describe('A team in staff\'s Teams list, with its usage over its whole life (billing\'s\n`TeamLifetimeUsage`): the credits its jobs used, charged less refunded, the known part of\ntheir vendor cost, and the jobs whose cost is not known whole.');

export type StaffTeamListed = zod.input<typeof StaffTeamListed>;
export type StaffTeamListedOutput = zod.output<typeof StaffTeamListed>;

export const UsageJob = zod.object({
  "charged": zod.int(),
  "line": JobUsageView,
  "refunded": zod.int(),
  "step_lines": zod.array(JobUsageView),
  "steps": zod.int(),
  "vendor_cost_complete": zod.boolean(),
  "vendor_cost_usd": zod.union([zod.string(),zod.null()])
}).describe('A generation in staff\'s list: its line, and its run\'s totals (itself and every step under\nit, nested runs\' too); its steps\' lines in start order when asked for.');

export type UsageJob = zod.input<typeof UsageJob>;
export type UsageJobOutput = zod.output<typeof UsageJob>;

export const UsageUser = zod.object({
  "deleted_at": zod.union([zod.iso.datetime({"offset":true}),zod.null()]),
  "email": zod.string(),
  "id": zod.uuid(),
  "name": zod.union([zod.string(),zod.null()])
}).describe('A user a usage page or a trace names, as identity keeps them: a deleted one too, with\n`deleted_at`, since their lines keep their id (spec 4).');

export type UsageUser = zod.input<typeof UsageUser>;
export type UsageUserOutput = zod.output<typeof UsageUser>;

export const UsageNames = zod.object({
  "models": zod.record(zod.string(), zod.string()),
  "teams": zod.record(zod.string(), zod.string()),
  "users": zod.record(zod.string(), UsageUser)
}).describe('What a page\'s ids name, for the ids it holds: each user\'s account, each team\'s name and\neach model\'s catalog name. An id without an entry names nothing the records still have. A\nbrand is named by its id alone: `teams.brand` holds a brand\'s guidelines, and no staff\npolicy reads it (spec 4, decision 4).');

export type UsageNames = zod.input<typeof UsageNames>;
export type UsageNamesOutput = zod.output<typeof UsageNames>;

export const StaffUsageJobPage = zod.object({
  "items": zod.array(UsageJob),
  "names": UsageNames,
  "next": zod.union([zod.string(),zod.null()])
}).describe('`GET /v1/staff/usage/jobs`: the generations, newest start first, with the names of their\nusers, teams and models, each step\'s own model among them (the owner\'s v1 choice: a run\'s\nbreakdown names each step\'s own).');

export type StaffUsageJobPage = zod.input<typeof StaffUsageJobPage>;
export type StaffUsageJobPageOutput = zod.output<typeof StaffUsageJobPage>;

export const UsageRow = zod.object({
  "charged": zod.int(),
  "cost_incomplete": zod.int(),
  "delivered": zod.int(),
  "failed": zod.int(),
  "generations": zod.int(),
  "jobs": zod.int(),
  "key": zod.union([zod.string(),zod.null()]),
  "net": zod.int(),
  "open": zod.int(),
  "refunded": zod.int(),
  "succeeded": zod.int(),
  "unpriced": zod.int(),
  "vendor_cost_usd": zod.union([zod.string(),zod.null()])
}).describe('One group\'s measures (spec 3): statuses and outputs count generations (jobs with no\nparent); jobs, credits, cost and their flags count every job, a run\'s steps under their\ngeneration. `key` is the group\'s: a user\'s, team\'s or brand\'s id, a model id, a job type, a\nUTC day (ISO); None for no user, brand or model, and on the totals.');

export type UsageRow = zod.input<typeof UsageRow>;
export type UsageRowOutput = zod.output<typeof UsageRow>;

export const StaffUsagePage = zod.object({
  "more": zod.boolean(),
  "names": UsageNames,
  "rows": zod.array(UsageRow),
  "total": UsageRow
}).describe('`GET /v1/staff/usage`: billing\'s groups and totals, with the names of the users, teams or\nmodels the groups\' keys are.');

export type StaffUsagePage = zod.input<typeof StaffUsagePage>;
export type StaffUsagePageOutput = zod.output<typeof StaffUsagePage>;

export const StaffUser = zod.object({
  "created_at": zod.iso.datetime({"offset":true}),
  "deleted_at": zod.union([zod.iso.datetime({"offset":true}),zod.null()]),
  "email": zod.string(),
  "id": zod.uuid(),
  "is_staff": zod.boolean(),
  "memberships": zod.array(StaffMembership),
  "name": zod.union([zod.string(),zod.null()])
}).describe('A user found by email, tombstoned or not, with every team they belong to.');

export type StaffUser = zod.input<typeof StaffUser>;
export type StaffUserOutput = zod.output<typeof StaffUser>;

export const StorageLimitDetails = zod.object({
  "limit_bytes": zod.int(),
  "requested_bytes": zod.int(),
  "used_bytes": zod.int()
}).describe('The team\'s storage limit, what it stores or has reserved, and what was asked for, in\nbytes. Originals count; trashed files count until they are purged (D9).');

export type StorageLimitDetails = zod.input<typeof StorageLimitDetails>;
export type StorageLimitDetailsOutput = zod.output<typeof StorageLimitDetails>;

export const StreamEventName = zod.enum(['job.transitioned', 'resync', 'edit_project.saved', 'achievement_unlocked']).describe('The `event:` line of each frame of `GET /api/events`.');

export type StreamEventName = zod.input<typeof StreamEventName>;
export type StreamEventNameOutput = zod.output<typeof StreamEventName>;

export const StreetCastPicks = zod.object({
  "interviewer": zod.union([ActorSource,zod.null()]).exactOptional(),
  "p1": zod.union([ActorSource,zod.null()]).exactOptional(),
  "p2": zod.union([ActorSource,zod.null()]).exactOptional(),
  "p3": zod.union([ActorSource,zod.null()]).exactOptional(),
  "p4": zod.union([ActorSource,zod.null()]).exactOptional()
}).describe('The interviewer and the four people as picked (an actor or a picture each); one left\nempty is cast by the director. Read only when the cast is customised (`cast_mode`).');

export type StreetCastPicks = zod.input<typeof StreetCastPicks>;
export type StreetCastPicksOutput = zod.output<typeof StreetCastPicks>;

export const StreetDraftStage = zod.enum(['script', 'cast', 'keyframes']).describe('Live\'s stages: the script, the location and cast once it is approved, the keyframes once\nthe cast is.');

export type StreetDraftStage = zod.input<typeof StreetDraftStage>;
export type StreetDraftStageOutput = zod.output<typeof StreetDraftStage>;

export const StreetDraftStillName = zod.enum(['street', 'sheet_int', 'sheet_p1', 'sheet_p2', 'sheet_p3', 'sheet_p4', 'two_1', 'single_2', 'single_3', 'single_4', 'handover_3', 'hold_2', 'hold_1', 'two_3_hold', 'hold_3', 'signoff', 'end_card']);

export type StreetDraftStillName = zod.input<typeof StreetDraftStillName>;
export type StreetDraftStillNameOutput = zod.output<typeof StreetDraftStillName>;

export const StreetDraftStill = zod.object({
  "name": StreetDraftStillName,
  "output": zod.union([OutputRef,zod.null()]).exactOptional(),
  "problem": zod.union([zod.string(),zod.null()]),
  "status": StillStatus,
  "url": zod.union([zod.string(),zod.null()])
}).describe('One of the 17 stills (live\'s `StillState`), as `DraftStill`.');

export type StreetDraftStill = zod.input<typeof StreetDraftStill>;
export type StreetDraftStillOutput = zod.output<typeof StreetDraftStill>;

export const streetInterviewAdPickedInputsCaptionPositionDefault = `bottom`;
export const streetInterviewAdPickedInputsCaptionStyleIdDefault = ``;
export const streetInterviewAdPickedInputsCaptionStyleIdMax = 64;

export const streetInterviewAdPickedInputsCastDefault = {};
export const streetInterviewAdPickedInputsCastModeDefault = `auto`;
export const streetInterviewAdPickedInputsCrowdDefault = `auto`;
export const streetInterviewAdPickedInputsCtaDefault = ``;
export const streetInterviewAdPickedInputsCtaMax = 100;

export const streetInterviewAdPickedInputsProductCategoryDefault = ``;
export const streetInterviewAdPickedInputsProductCategoryMax = 200;

export const streetInterviewAdPickedInputsProductNameDefault = ``;
export const streetInterviewAdPickedInputsProductNameMax = 200;

export const streetInterviewAdPickedInputsProductTextDefault = ``;
export const streetInterviewAdPickedInputsProductTextMax = 20000;

export const streetInterviewAdPickedInputsPronunciationDefault = ``;
export const streetInterviewAdPickedInputsPronunciationMax = 100;

export const streetInterviewAdPickedInputsQuestionDefault = ``;
export const streetInterviewAdPickedInputsQuestionMax = 500;

export const streetInterviewAdPickedInputsSubtitlesDefault = true;
export const streetInterviewAdPickedInputsTitleDefault = false;

export const StreetInterviewAdPickedInputs = zod.object({
  "caption_position": zod.enum(['top', 'center', 'bottom']).default(streetInterviewAdPickedInputsCaptionPositionDefault),
  "caption_style_id": zod.string().max(streetInterviewAdPickedInputsCaptionStyleIdMax).default(streetInterviewAdPickedInputsCaptionStyleIdDefault),
  "cast": StreetCastPicks.default(streetInterviewAdPickedInputsCastDefault),
  "cast_mode": zod.enum(['auto', 'choose']).default(streetInterviewAdPickedInputsCastModeDefault),
  "crowd": zod.enum(['auto', 'men', 'women', 'mixed']).default(streetInterviewAdPickedInputsCrowdDefault),
  "cta": zod.string().max(streetInterviewAdPickedInputsCtaMax).default(streetInterviewAdPickedInputsCtaDefault),
  "product": PackshotProduct,
  "product_category": zod.string().max(streetInterviewAdPickedInputsProductCategoryMax).default(streetInterviewAdPickedInputsProductCategoryDefault),
  "product_name": zod.string().max(streetInterviewAdPickedInputsProductNameMax).default(streetInterviewAdPickedInputsProductNameDefault),
  "product_text": zod.string().max(streetInterviewAdPickedInputsProductTextMax).default(streetInterviewAdPickedInputsProductTextDefault),
  "pronunciation": zod.string().max(streetInterviewAdPickedInputsPronunciationMax).default(streetInterviewAdPickedInputsPronunciationDefault),
  "question": zod.string().max(streetInterviewAdPickedInputsQuestionMax).default(streetInterviewAdPickedInputsQuestionDefault),
  "subtitles": zod.boolean().default(streetInterviewAdPickedInputsSubtitlesDefault),
  "title": zod.boolean().default(streetInterviewAdPickedInputsTitleDefault)
}).describe('The form with its product picked, as Generate script and Approve script need it (live\'s\n"Pick a product and its packshot", 422 at `product`).');

export type StreetInterviewAdPickedInputs = zod.input<typeof StreetInterviewAdPickedInputs>;
export type StreetInterviewAdPickedInputsOutput = zod.output<typeof StreetInterviewAdPickedInputs>;

export const StreetInterviewAdApproval = zod.object({
  "inputs": StreetInterviewAdPickedInputs,
  "script": StreetScript
}).describe('`POST .../draft/approve`: live\'s Approve script, the form and the script as edited.');

export type StreetInterviewAdApproval = zod.input<typeof StreetInterviewAdApproval>;
export type StreetInterviewAdApprovalOutput = zod.output<typeof StreetInterviewAdApproval>;

export const streetInterviewAdInputsCaptionPositionDefault = `bottom`;
export const streetInterviewAdInputsCaptionStyleIdDefault = ``;
export const streetInterviewAdInputsCaptionStyleIdMax = 64;

export const streetInterviewAdInputsCastDefault = {};
export const streetInterviewAdInputsCastModeDefault = `auto`;
export const streetInterviewAdInputsCrowdDefault = `auto`;
export const streetInterviewAdInputsCtaDefault = ``;
export const streetInterviewAdInputsCtaMax = 100;

export const streetInterviewAdInputsProductCategoryDefault = ``;
export const streetInterviewAdInputsProductCategoryMax = 200;

export const streetInterviewAdInputsProductNameDefault = ``;
export const streetInterviewAdInputsProductNameMax = 200;

export const streetInterviewAdInputsProductTextDefault = ``;
export const streetInterviewAdInputsProductTextMax = 20000;

export const streetInterviewAdInputsPronunciationDefault = ``;
export const streetInterviewAdInputsPronunciationMax = 100;

export const streetInterviewAdInputsQuestionDefault = ``;
export const streetInterviewAdInputsQuestionMax = 500;

export const streetInterviewAdInputsSubtitlesDefault = true;
export const streetInterviewAdInputsTitleDefault = false;

export const StreetInterviewAdInputs = zod.object({
  "caption_position": zod.enum(['top', 'center', 'bottom']).default(streetInterviewAdInputsCaptionPositionDefault),
  "caption_style_id": zod.string().max(streetInterviewAdInputsCaptionStyleIdMax).default(streetInterviewAdInputsCaptionStyleIdDefault),
  "cast": StreetCastPicks.default(streetInterviewAdInputsCastDefault),
  "cast_mode": zod.enum(['auto', 'choose']).default(streetInterviewAdInputsCastModeDefault),
  "crowd": zod.enum(['auto', 'men', 'women', 'mixed']).default(streetInterviewAdInputsCrowdDefault),
  "cta": zod.string().max(streetInterviewAdInputsCtaMax).default(streetInterviewAdInputsCtaDefault),
  "product": zod.union([PackshotProduct,zod.null()]).exactOptional(),
  "product_category": zod.string().max(streetInterviewAdInputsProductCategoryMax).default(streetInterviewAdInputsProductCategoryDefault),
  "product_name": zod.string().max(streetInterviewAdInputsProductNameMax).default(streetInterviewAdInputsProductNameDefault),
  "product_text": zod.string().max(streetInterviewAdInputsProductTextMax).default(streetInterviewAdInputsProductTextDefault),
  "pronunciation": zod.string().max(streetInterviewAdInputsPronunciationMax).default(streetInterviewAdInputsPronunciationDefault),
  "question": zod.string().max(streetInterviewAdInputsQuestionMax).default(streetInterviewAdInputsQuestionDefault),
  "subtitles": zod.boolean().default(streetInterviewAdInputsSubtitlesDefault),
  "title": zod.boolean().default(streetInterviewAdInputsTitleDefault)
}).describe('Street Interview Ad\'s form so far: the product (none until picked), and the rest.');

export type StreetInterviewAdInputs = zod.input<typeof StreetInterviewAdInputs>;
export type StreetInterviewAdInputsOutput = zod.output<typeof StreetInterviewAdInputs>;

export const StreetInterviewAdDraft = zod.object({
  "inputs": StreetInterviewAdInputs,
  "pack_director": DirectorState,
  "pack_warning": zod.boolean(),
  "problem": zod.union([zod.string(),zod.null()]),
  "script": zod.union([StreetScript,zod.null()]),
  "script_director": DirectorState,
  "script_warning": zod.boolean(),
  "shot_director": DirectorState,
  "spec": zod.union([StreetShotSpec,zod.null()]),
  "stage": StreetDraftStage,
  "stills": zod.array(StreetDraftStill),
  "updated_at": zod.iso.datetime({"offset":true}),
  "urls_expire_at": zod.union([zod.iso.datetime({"offset":true}),zod.null()])
}).describe('A member\'s Street Interview Ad draft in the brand: the form, the stage, the script and\nits directors (the pack reader\'s, then the script\'s), the shot spec and its director, and\nthe 17 stills. `pack_warning`: the pack was hard to read (live\'s "The pack was hard to read\n...", kept, G14 Street Interview-4); `script_warning`: a product fact still not quoted, or a\nline out of its beat, after the director\'s redo (live\'s "Some product facts are not quoted\nfrom the product text ..."). `problem`: live\'s words for the last director that failed.\n`stills` is empty until the shot spec is kept; the keyframes are pending until the cast is\napproved.');

export type StreetInterviewAdDraft = zod.input<typeof StreetInterviewAdDraft>;
export type StreetInterviewAdDraftOutput = zod.output<typeof StreetInterviewAdDraft>;

export const StreetInterviewAdDraftWrite = zod.object({
  "inputs": StreetInterviewAdInputs,
  "script": zod.union([StreetScript,zod.null()]).exactOptional()
}).describe('`PUT .../templates/street-interview-ad/draft`: the form as it stands, its script as\nedited.');

export type StreetInterviewAdDraftWrite = zod.input<typeof StreetInterviewAdDraftWrite>;
export type StreetInterviewAdDraftWriteOutput = zod.output<typeof StreetInterviewAdDraftWrite>;

export const streetInterviewAdExampleCaptionPositionDefault = `bottom`;
export const streetInterviewAdExampleCaptionStyleIdDefault = ``;
export const streetInterviewAdExampleCaptionStyleIdMax = 64;

export const streetInterviewAdExampleCastDefault = {};
export const streetInterviewAdExampleCastModeDefault = `auto`;
export const streetInterviewAdExampleCrowdDefault = `auto`;
export const streetInterviewAdExampleCtaDefault = ``;
export const streetInterviewAdExampleCtaMax = 100;

export const streetInterviewAdExampleProductCategoryDefault = ``;
export const streetInterviewAdExampleProductCategoryMax = 200;

export const streetInterviewAdExampleProductNameDefault = ``;
export const streetInterviewAdExampleProductNameMax = 200;

export const streetInterviewAdExampleProductTextDefault = ``;
export const streetInterviewAdExampleProductTextMax = 20000;

export const streetInterviewAdExamplePronunciationDefault = ``;
export const streetInterviewAdExamplePronunciationMax = 100;

export const streetInterviewAdExampleQuestionDefault = ``;
export const streetInterviewAdExampleQuestionMax = 500;

export const streetInterviewAdExampleSubtitlesDefault = true;
export const streetInterviewAdExampleTitleDefault = false;

export const StreetInterviewAdExample = zod.object({
  "caption_position": zod.enum(['top', 'center', 'bottom']).default(streetInterviewAdExampleCaptionPositionDefault),
  "caption_style_id": zod.string().max(streetInterviewAdExampleCaptionStyleIdMax).default(streetInterviewAdExampleCaptionStyleIdDefault),
  "cast": StreetCastPicks.default(streetInterviewAdExampleCastDefault),
  "cast_mode": zod.enum(['auto', 'choose']).default(streetInterviewAdExampleCastModeDefault),
  "crowd": zod.enum(['auto', 'men', 'women', 'mixed']).default(streetInterviewAdExampleCrowdDefault),
  "cta": zod.string().max(streetInterviewAdExampleCtaMax).default(streetInterviewAdExampleCtaDefault),
  "product": ExampleRef,
  "product_category": zod.string().max(streetInterviewAdExampleProductCategoryMax).default(streetInterviewAdExampleProductCategoryDefault),
  "product_name": zod.string().max(streetInterviewAdExampleProductNameMax).default(streetInterviewAdExampleProductNameDefault),
  "product_text": zod.string().max(streetInterviewAdExampleProductTextMax).default(streetInterviewAdExampleProductTextDefault),
  "pronunciation": zod.string().max(streetInterviewAdExamplePronunciationMax).default(streetInterviewAdExamplePronunciationDefault),
  "question": zod.string().max(streetInterviewAdExampleQuestionMax).default(streetInterviewAdExampleQuestionDefault),
  "script": StreetScript,
  "subtitles": zod.boolean().default(streetInterviewAdExampleSubtitlesDefault),
  "template": zod.enum(['street-interview-ad']),
  "title": zod.boolean().default(streetInterviewAdExampleTitleDefault)
}).describe('Street Interview Ad\'s "Reuse example" (live\'s `buildExampleValues`, G14 Street\nInterview-13): the Overdrive run\'s form, its packshot the card\'s own example input, typed\nlike an upload, and its approved script, which the form approves as it is.');

export type StreetInterviewAdExample = zod.input<typeof StreetInterviewAdExample>;
export type StreetInterviewAdExampleOutput = zod.output<typeof StreetInterviewAdExample>;

export const StreetInterviewAdScriptAsk = zod.object({
  "inputs": StreetInterviewAdPickedInputs
}).describe('`POST .../draft/script`: live\'s Generate Script, on the form as it stands.');

export type StreetInterviewAdScriptAsk = zod.input<typeof StreetInterviewAdScriptAsk>;
export type StreetInterviewAdScriptAskOutput = zod.output<typeof StreetInterviewAdScriptAsk>;

export const teamCreateNameMax = 100;


export const teamCreateNameRegExp = new RegExp('[^\\t\\n\\v\\f\\r \\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000\\ufeff]');


export const TeamCreate = zod.object({
  "name": zod.string().min(1).max(teamCreateNameMax).regex(teamCreateNameRegExp)
}).describe('`POST /v1/me/teams`: a team the caller owns (self-serve only).');

export type TeamCreate = zod.input<typeof TeamCreate>;
export type TeamCreateOutput = zod.output<typeof TeamCreate>;

export const TeamSetting = zod.object({
  "cases_hidden": zod.boolean()
}).describe('Whether the team\'s owner or an admin hid the free daily case for every member.');

export type TeamSetting = zod.input<typeof TeamSetting>;
export type TeamSettingOutput = zod.output<typeof TeamSetting>;

export const TeamSettingUpdate = zod.object({
  "cases_hidden": zod.boolean()
}).describe('`PATCH /v1/teams/{team_id}/appearance/settings`: the team\'s switch (owner and admins).');

export type TeamSettingUpdate = zod.input<typeof TeamSettingUpdate>;
export type TeamSettingUpdateOutput = zod.output<typeof TeamSettingUpdate>;

export const TeamStorage = zod.object({
  "limit_bytes": zod.union([zod.int(),zod.null()]),
  "used_bytes": zod.int()
}).describe('`GET /v1/teams/{team_id}/storage` (spec assets/storage-usage): the bytes the team\'s files\nhold (its library\'s, its voices\' samples and its actors\' portraits) and its limit, null for\nunlimited; the header\'s usage pill shows them in live\'s GB, 1024³ bytes.');

export type TeamStorage = zod.input<typeof TeamStorage>;
export type TeamStorageOutput = zod.output<typeof TeamStorage>;

export const teamUpdateNameMax = 100;


export const teamUpdateNameRegExp = new RegExp('[^\\t\\n\\v\\f\\r \\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000\\ufeff]');


export const TeamUpdate = zod.object({
  "name": zod.string().min(1).max(teamUpdateNameMax).regex(teamUpdateNameRegExp)
}).describe('`PATCH /v1/teams/{team_id}`: a new name (admins and the owner, `manage_team`).');

export type TeamUpdate = zod.input<typeof TeamUpdate>;
export type TeamUpdateOutput = zod.output<typeof TeamUpdate>;

export const TemplateCaptionStyle = zod.object({
  "id": zod.string(),
  "name": zod.string()
}).describe('One of live\'s caption styles a template\'s subtitles picker offers: its id (what a run\'s\ninputs name) and its name (live\'s tile\'s).');

export type TemplateCaptionStyle = zod.input<typeof TemplateCaptionStyle>;
export type TemplateCaptionStyleOutput = zod.output<typeof TemplateCaptionStyle>;

export const TemplateCaptionStyleList = zod.object({
  "default": zod.string(),
  "styles": zod.array(TemplateCaptionStyle)
}).describe('Live\'s caption styles in its order (ui-templates\' `caption-styles.ts`), and the one a\nfresh form picks (`default`, live\'s Bold cinematic).');

export type TemplateCaptionStyleList = zod.input<typeof TemplateCaptionStyleList>;
export type TemplateCaptionStyleListOutput = zod.output<typeof TemplateCaptionStyleList>;

export const TemplateCategory = zod.enum(['Ad Creatives', 'Ad Formats', 'Enhance & Animate', 'Localize & Translate', 'Product Visuals', 'Resize & Reformat', 'UGC & Avatars']).describe('Live\'s template categories, in the order live\'s categories route sorts them.');

export type TemplateCategory = zod.input<typeof TemplateCategory>;
export type TemplateCategoryOutput = zod.output<typeof TemplateCategory>;

export const templateEstimateCreditsMaxMax = 1000000;

export const templateEstimateCreditsMinMax = 1000000;



export const TemplateEstimate = zod.object({
  "credits_max": zod.int().min(1).max(templateEstimateCreditsMaxMax),
  "credits_min": zod.int().min(1).max(templateEstimateCreditsMinMax),
  "tier": zod.int()
}).describe('What one output of a template costs, as live\'s record says (its `estimate`): credits\nfrom and to, and live\'s tier of 1 to 5 bolts, which live derives from them, never stores\n(`toCostTier`): the range\'s middle, rounded up, against live\'s four bounds.');

export type TemplateEstimate = zod.input<typeof TemplateEstimate>;
export type TemplateEstimateOutput = zod.output<typeof TemplateEstimate>;

export const TemplateNeed = zod.enum(['video', 'image', 'product', 'actor', 'voice', 'script', 'logo', 'prompt', 'hooks']).describe('What a template asks for, live\'s "What you\'ll need" rows: each has live\'s own label and\nicon on the page, which a template may relabel ("AI Actors", "Character").');

export type TemplateNeed = zod.input<typeof TemplateNeed>;
export type TemplateNeedOutput = zod.output<typeof TemplateNeed>;

export const templateRequirementLabelOneMax = 40;

export const templateRequirementOptionalDefault = false;

export const TemplateRequirement = zod.object({
  "kind": TemplateNeed,
  "label": zod.union([zod.string().min(1).max(templateRequirementLabelOneMax),zod.null()]).exactOptional(),
  "optional": zod.boolean().default(templateRequirementOptionalDefault)
}).describe('One of live\'s "What you\'ll need" rows: its kind, when the template words it its own way,\nits label (null: the kind\'s own), and whether the template runs without it (`optional`,\nlive\'s `isOptional`; its chip reads the same either way, as live\'s does).');

export type TemplateRequirement = zod.input<typeof TemplateRequirement>;
export type TemplateRequirementOutput = zod.output<typeof TemplateRequirement>;

export const TemplateCard = zod.object({
  "available": zod.boolean(),
  "category": TemplateCategory,
  "coming_soon": zod.boolean(),
  "cover_card_url": zod.union([zod.string(),zod.null()]).exactOptional(),
  "cover_poster_url": zod.union([zod.string(),zod.null()]).exactOptional(),
  "cover_url": zod.union([zod.string(),zod.null()]),
  "description": zod.union([zod.string(),zod.null()]),
  "estimate": zod.union([TemplateEstimate,zod.null()]),
  "example_urls": zod.array(zod.string()),
  "has_example": zod.boolean(),
  "id": zod.string(),
  "media": Medium,
  "requirements": zod.array(TemplateRequirement),
  "title": zod.string()
}).describe('A card of live\'s templates library (spec G14-templates): its title, live\'s description\nand category, whether it makes pictures or videos, its cover, a video cover\'s first-frame\nposter (`cover_poster_url`, shown until the cover plays, #828 bug 17) and examples (signed\nuntil the page\'s `urls_expire_at`; none until they are imported), live\'s "What you\'ll\nneed", whether it can be run (`available`: its recipe is built), whether it is one of live\'s\nComing soon cards (`coming_soon`: listed, never opened) and whether it has an example to\nreplicate.');

export type TemplateCard = zod.input<typeof TemplateCard>;
export type TemplateCardOutput = zod.output<typeof TemplateCard>;

export const TemplateCategoryList = zod.object({
  "categories": zod.array(TemplateCategory)
}).describe('The categories that hold a template, in live\'s order: the page\'s pills after "All".');

export type TemplateCategoryList = zod.input<typeof TemplateCategoryList>;
export type TemplateCategoryListOutput = zod.output<typeof TemplateCategoryList>;

export const TemplateExample = zod.union([BackgroundSwapInputs,InstantResizeInputs,TranslateImageInputs,SceneVariationsInputs,StaticAdInputs,StreetInterviewAdExample,AnimateStaticAdInputs,ActorSwapInputs,HooksInputs,LanguageChangerInputs,HeroShotInputs,PromoteYourProductInputs]);

export type TemplateExample = zod.input<typeof TemplateExample>;
export type TemplateExampleOutput = zod.output<typeof TemplateExample>;

export const TemplateVoice = zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "preview_url": zod.union([zod.string(),zod.null()])
}).describe('A voice a template\'s example speaks with: its id (the example\'s `voice_id`), its name,\nand its sample\'s signed URL.');

export type TemplateVoice = zod.input<typeof TemplateVoice>;
export type TemplateVoiceOutput = zod.output<typeof TemplateVoice>;

export const TemplateOptionView = zod.object({
  "clip_url": zod.union([zod.string(),zod.null()]),
  "group": zod.union([zod.string(),zod.null()]),
  "hint": zod.union([zod.string(),zod.null()]),
  "id": zod.string(),
  "label": zod.string(),
  "poster_url": zod.union([zod.string(),zod.null()])
}).describe('One of the choices a template\'s form offers (live\'s widget\'s catalog: one of Hooks\'\nhooks): its id (what the form sends), its name, its tab and hint where live shows them, its\nposter and the clip that plays while it is hovered, each signed until the detail\'s\n`urls_expire_at`.');

export type TemplateOptionView = zod.input<typeof TemplateOptionView>;
export type TemplateOptionViewOutput = zod.output<typeof TemplateOptionView>;

export const TemplateDetail = zod.object({
  "available": zod.boolean(),
  "category": TemplateCategory,
  "coming_soon": zod.boolean(),
  "cover_card_url": zod.union([zod.string(),zod.null()]).exactOptional(),
  "cover_poster_url": zod.union([zod.string(),zod.null()]).exactOptional(),
  "cover_url": zod.union([zod.string(),zod.null()]),
  "description": zod.union([zod.string(),zod.null()]),
  "estimate": zod.union([TemplateEstimate,zod.null()]),
  "example": zod.union([TemplateExample,zod.null()]),
  "example_input_urls": zod.record(zod.string(), zod.string()),
  "example_urls": zod.array(zod.string()),
  "example_voices": zod.array(TemplateVoice),
  "has_example": zod.boolean(),
  "id": zod.string(),
  "media": Medium,
  "options": zod.array(TemplateOptionView),
  "requirements": zod.array(TemplateRequirement),
  "title": zod.string(),
  "urls_expire_at": zod.union([zod.iso.datetime({"offset":true}),zod.null()])
}).describe('A template as Use and Replicate open it (`GET .../templates/{id}`): its card and its\nexample\'s inputs, the form\'s "Reuse example" (live\'s, where its record has one; each file an\n`ExampleRef` to the card\'s own, used where it lies), with their files\' URLs; its files\nsigned until `urls_expire_at`.');

export type TemplateDetail = zod.input<typeof TemplateDetail>;
export type TemplateDetailOutput = zod.output<typeof TemplateDetail>;

export const TemplatePage = zod.object({
  "items": zod.array(TemplateCard),
  "next": zod.union([zod.string(),zod.null()]),
  "urls_expire_at": zod.union([zod.iso.datetime({"offset":true}),zod.null()])
}).describe('A page of the library, in live\'s order: live\'s templates first, its Coming soon cards\nafter.');

export type TemplatePage = zod.input<typeof TemplatePage>;
export type TemplatePageOutput = zod.output<typeof TemplatePage>;

export const termsAcceptVersionMax = 40;


export const termsAcceptVersionRegExp = new RegExp('[^\\t\\n\\v\\f\\r \\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000\\ufeff]');


export const TermsAccept = zod.object({
  "version": zod.string().min(1).max(termsAcceptVersionMax).regex(termsAcceptVersionRegExp)
}).describe('`POST /v1/me/terms/accept`: the version the user was shown.');

export type TermsAccept = zod.input<typeof TermsAccept>;
export type TermsAcceptOutput = zod.output<typeof TermsAccept>;

export const TermsVersionStaleDetails = zod.object({
  "current_version": zod.string()
}).describe('The version of the terms in force, to show and accept instead.');

export type TermsVersionStaleDetails = zod.input<typeof TermsVersionStaleDetails>;
export type TermsVersionStaleDetailsOutput = zod.output<typeof TermsVersionStaleDetails>;

export const TokenScope = zod.enum(['read', 'write']).describe('What a personal access token may do in its team. `read`: safe methods only.');

export type TokenScope = zod.input<typeof TokenScope>;
export type TokenScopeOutput = zod.output<typeof TokenScope>;

export const Token = zod.object({
  "created_at": zod.iso.datetime({"offset":true}),
  "expires_at": zod.iso.datetime({"offset":true}),
  "id": zod.uuid(),
  "last_used_at": zod.union([zod.iso.datetime({"offset":true}),zod.null()]),
  "name": zod.string(),
  "scopes": zod.array(TokenScope),
  "team_id": zod.uuid()
}).describe('A personal access token as listed: never the secret.');

export type Token = zod.input<typeof Token>;
export type TokenOutput = zod.output<typeof Token>;

export const tokenCreateExpiresInDaysDefault = 30;
export const tokenCreateExpiresInDaysMax = 90;

export const tokenCreateNameMax = 100;


export const tokenCreateNameRegExp = new RegExp('[^\\t\\n\\v\\f\\r \\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000\\ufeff]');



export const TokenCreate = zod.object({
  "expires_in_days": zod.int().min(1).max(tokenCreateExpiresInDaysMax).default(tokenCreateExpiresInDaysDefault),
  "name": zod.string().min(1).max(tokenCreateNameMax).regex(tokenCreateNameRegExp),
  "scopes": zod.array(TokenScope).min(1)
}).describe('A personal access token for an agent, in the team of the path (proposal 6.1).');

export type TokenCreate = zod.input<typeof TokenCreate>;
export type TokenCreateOutput = zod.output<typeof TokenCreate>;

export const TokenCreated = zod.object({
  "created_at": zod.iso.datetime({"offset":true}),
  "expires_at": zod.iso.datetime({"offset":true}),
  "id": zod.uuid(),
  "last_used_at": zod.union([zod.iso.datetime({"offset":true}),zod.null()]),
  "name": zod.string(),
  "scopes": zod.array(TokenScope),
  "team_id": zod.uuid(),
  "token": zod.string()
}).describe('The one response that carries a secret, once: `Authorization: Bearer <token>`.');

export type TokenCreated = zod.input<typeof TokenCreated>;
export type TokenCreatedOutput = zod.output<typeof TokenCreated>;

export const topUpStartPackCodeMax = 64;



export const TopUpStart = zod.object({
  "pack_code": zod.string().min(1).max(topUpStartPackCodeMax)
}).describe('`POST /v1/teams/{team_id}/billing/top-ups/checkout` (spec B2-5): the pack to buy, a code\nof `top_ups.yaml`.');

export type TopUpStart = zod.input<typeof TopUpStart>;
export type TopUpStartOutput = zod.output<typeof TopUpStart>;

export const TraceBody = zod.object({
  "bytes": zod.int(),
  "created_at": zod.iso.datetime({"offset":true}),
  "error_detail": zod.union([zod.string(),zod.null()]),
  "request": JsonValue,
  "response": JsonValue,
  "truncated": zod.boolean()
}).describe('What one request carried, as the engine kept it, redacted at write (spec 4): the request\nas sent, the answer\'s summary and the vendor\'s error text.');

export type TraceBody = zod.input<typeof TraceBody>;
export type TraceBodyOutput = zod.output<typeof TraceBody>;

export const TraceCost = zod.object({
  "complete": zod.boolean(),
  "usd": zod.union([zod.string(),zod.null()])
}).describe('What the job\'s requests cost us as far as they are known: the sum of the known costs (None\nwhen none is), `complete` once every request\'s is known (never with no request).');

export type TraceCost = zod.input<typeof TraceCost>;
export type TraceCostOutput = zod.output<typeof TraceCost>;

export const TraceFile = zod.object({
  "bytes": zod.int(),
  "content_type": zod.string(),
  "storage_key": zod.string(),
  "url": zod.string()
}).describe('A file of the traced job, one of its sources or outputs, while it exists: its URL, bound\nto that object alone until `UsageTrace.files_expire_at` (Cloud CDN\'s signed URL of one object,\nnever the team\'s prefix nor the media cookie: spec decision 13), its size and its type.');

export type TraceFile = zod.input<typeof TraceFile>;
export type TraceFileOutput = zod.output<typeof TraceFile>;

export const TraceSource = zod.object({
  "actor_id": zod.union([zod.uuid(),zod.null()]).exactOptional(),
  "asset_id": zod.union([zod.uuid(),zod.null()]).exactOptional(),
  "bytes": zod.union([zod.int(),zod.null()]).exactOptional(),
  "duration_ms": zod.union([zod.int(),zod.null()]).exactOptional(),
  "height": zod.union([zod.int(),zod.null()]).exactOptional(),
  "job_id": zod.union([zod.uuid(),zod.null()]).exactOptional(),
  "kind": zod.enum(['job_output', 'asset', 'actor', 'global_actor', 'example', 'voice']),
  "loc": zod.array(zod.union([zod.string(),zod.int()])),
  "mime": zod.union([zod.string(),zod.null()]).exactOptional(),
  "output_index": zod.union([zod.int(),zod.null()]).exactOptional(),
  "storage_key": zod.string(),
  "voice_id": zod.union([zod.uuid(),zod.null()]).exactOptional(),
  "width": zod.union([zod.int(),zod.null()]).exactOptional()
}).describe('A file a job\'s snapshot names, where it names it (`loc`, a path into the snapshot as\nstored, an older shape\'s too): a source as the start resolved it, with every fact the start\nkept of it, or a voice\'s sample the vendor clones the voice from (`voice`).');

export type TraceSource = zod.input<typeof TraceSource>;
export type TraceSourceOutput = zod.output<typeof TraceSource>;

export const TraceInputs = zod.object({
  "prompt": zod.union([zod.string(),zod.null()]),
  "settings": zod.union([JobParams,zod.null()]),
  "snapshot": zod.record(zod.string(), JsonValue),
  "sources": zod.array(TraceSource)
}).describe('A job\'s inputs: its snapshot as stored and, beside it, rendered by its type, the prompt\nthe start wrote into it (built where its type builds one: an ad copy\'s, a script\'s; None for\nnone, and a multi-shot video\'s are its shots\'), its settings as the job\'s reader sees them,\nand every file it names. A type generation does not own (the editor\'s render) shows its\nsnapshot alone.');

export type TraceInputs = zod.input<typeof TraceInputs>;
export type TraceInputsOutput = zod.output<typeof TraceInputs>;

export const TraceModel = zod.object({
  "id": zod.string(),
  "name": zod.union([zod.string(),zod.null()]),
  "vendor": zod.union([VendorName,zod.null()]),
  "vendor_model": zod.union([zod.string(),zod.null()])
}).describe('A job\'s model: the catalog row\'s id and its name (None once the catalog no longer has the\nrow), and the vendor and the vendor\'s model id it ran on, from its snapshot (None once\nretention cleared it).');

export type TraceModel = zod.input<typeof TraceModel>;
export type TraceModelOutput = zod.output<typeof TraceModel>;

export const TraceJob = zod.object({
  "created_at": zod.iso.datetime({"offset":true}),
  "finished_at": zod.union([zod.iso.datetime({"offset":true}),zod.null()]),
  "id": zod.uuid(),
  "line": zod.union([JobUsageView,zod.null()]),
  "model": zod.union([TraceModel,zod.null()]),
  "status": JobStatus,
  "type": zod.string()
}).describe('A job of the traced job\'s runs, its parent or one of its steps, as a summary whose own\ntrace opens it: its own type, status and model, and its own credits and cost (billing\'s\nline, None before its line is written).');

export type TraceJob = zod.input<typeof TraceJob>;
export type TraceJobOutput = zod.output<typeof TraceJob>;

export const UsageUnit = zod.object({
  "quantity": zod.string(),
  "sku": zod.string()
}).describe('Metered usage, read from the vendor\'s response at the adapter, never from a trace.');

export type UsageUnit = zod.input<typeof UsageUnit>;
export type UsageUnitOutput = zod.output<typeof UsageUnit>;

export const TraceOutput = zod.object({
  "duration_ms": zod.union([zod.int(),zod.null()]),
  "error_code": zod.union([JobErrorCode,zod.null()]),
  "height": zod.union([zod.int(),zod.null()]),
  "index": zod.int(),
  "mime": zod.union([zod.string(),zod.null()]),
  "saved_asset_id": zod.union([zod.uuid(),zod.null()]),
  "status": OutputStatus,
  "storage_key": zod.union([zod.string(),zod.null()]),
  "usage": zod.array(UsageUnit),
  "vendor_cost_usd": zod.union([zod.string(),zod.null()]),
  "width": zod.union([zod.int(),zod.null()])
}).describe('One output of the traced job, as its row keeps it; its file is in `UsageTrace.files`\nwhile it exists (30 days from its write).');

export type TraceOutput = zod.input<typeof TraceOutput>;
export type TraceOutputOutput = zod.output<typeof TraceOutput>;

export const TraceRequest = zod.object({
  "ai_task": zod.union([zod.string(),zod.null()]),
  "answered_at": zod.union([zod.iso.datetime({"offset":true}),zod.null()]),
  "attempt": zod.int(),
  "body": zod.union([TraceBody,zod.null()]),
  "body_expired": zod.boolean(),
  "cost_source": zod.union([CostSource,zod.null()]),
  "cost_usd": zod.union([zod.string(),zod.null()]),
  "cost_version": zod.union([zod.string(),zod.null()]),
  "endpoint": zod.union([zod.string(),zod.null()]),
  "error_code": zod.union([JobErrorCode,zod.null()]),
  "finished_at": zod.union([zod.iso.datetime({"offset":true}),zod.null()]),
  "http_status": zod.union([zod.int(),zod.null()]),
  "id": zod.uuid(),
  "last_polled_at": zod.union([zod.iso.datetime({"offset":true}),zod.null()]),
  "operation": CallOperation,
  "outcome": CallOutcome,
  "output_count": zod.union([zod.int(),zod.null()]),
  "output_first": zod.union([zod.int(),zod.null()]),
  "polls": zod.int(),
  "reconstructed": zod.boolean(),
  "requested_at": zod.iso.datetime({"offset":true}),
  "trace_id": zod.union([zod.string(),zod.null()]),
  "units": zod.array(CallUnit),
  "vendor": zod.string(),
  "vendor_ref": zod.union([zod.string(),zod.null()]),
  "vendor_state": zod.union([zod.string(),zod.null()])
}).describe('One request at a vendor (`platform.vendor_call`), with its status reads folded in, and what\nit carried: `body` None when none is kept, `body_expired` when it is older than the bodies\'\nretention (90 days), which has deleted it.');

export type TraceRequest = zod.input<typeof TraceRequest>;
export type TraceRequestOutput = zod.output<typeof TraceRequest>;

export const TraceRunStep = zod.object({
  "attempt": zod.int(),
  "name": zod.string(),
  "shot": zod.union([zod.int(),zod.null()]),
  "tile": zod.union([zod.int(),zod.null()]),
  "unused": zod.boolean()
}).describe('A job\'s place in a run, as the run\'s table keeps it: its step (a template recipe\'s\n`clip_a`, a talking head\'s `keyframe`), its tile or shot, its attempt, and whether the run let\ngo of it (`unused`: its success was given back).');

export type TraceRunStep = zod.input<typeof TraceRunStep>;
export type TraceRunStepOutput = zod.output<typeof TraceRunStep>;

export const TraceStep = zod.object({
  "attempt": zod.int(),
  "job": TraceJob,
  "name": zod.string(),
  "shot": zod.union([zod.int(),zod.null()]),
  "tile": zod.union([zod.int(),zod.null()]),
  "unused": zod.boolean()
}).describe('A step the traced job\'s run started, with that step\'s job.');

export type TraceStep = zod.input<typeof TraceStep>;
export type TraceStepOutput = zod.output<typeof TraceStep>;

export const TraceWebhook = zod.object({
  "processed_at": zod.union([zod.iso.datetime({"offset":true}),zod.null()]),
  "received_at": zod.iso.datetime({"offset":true}),
  "ref": zod.string(),
  "state": DeliveryState,
  "vendor": zod.string()
}).describe('A verified webhook the job\'s vendor sent: the request it named, what it said, when it came\nand when the engine read it.');

export type TraceWebhook = zod.input<typeof TraceWebhook>;
export type TraceWebhookOutput = zod.output<typeof TraceWebhook>;

export const TrashEmptied = zod.object({
  "bytes_freed": zod.int(),
  "purged": zod.int()
}).describe('`POST .../assets/trash/empty`: the files purged and the bytes of the team\'s storage they\nfreed at once. A second call finds none.');

export type TrashEmptied = zod.input<typeof TrashEmptied>;
export type TrashEmptiedOutput = zod.output<typeof TrashEmptied>;

export const TrashSummary = zod.object({
  "bytes": zod.int(),
  "days": zod.int(),
  "files": zod.int()
}).describe('`GET .../assets/trash`: what the brand\'s trash holds, its ready files and their bytes,\nwhich count toward the team\'s storage until purged, and the days a file stays there.');

export type TrashSummary = zod.input<typeof TrashSummary>;
export type TrashSummaryOutput = zod.output<typeof TrashSummary>;

export const twoSpeakerPickedInputsBrandColorsDefault = ``;
export const twoSpeakerPickedInputsBrandColorsMax = 200;

export const twoSpeakerPickedInputsBrandNameDefault = ``;
export const twoSpeakerPickedInputsBrandNameMax = 100;

export const twoSpeakerPickedInputsBrandSaidDefault = ``;
export const twoSpeakerPickedInputsBrandSaidMax = 200;

export const twoSpeakerPickedInputsCaptionsDefault = true;
export const twoSpeakerPickedInputsProductNameDefault = ``;
export const twoSpeakerPickedInputsProductNameMax = 200;

export const twoSpeakerPickedInputsProductTextDefault = ``;
export const twoSpeakerPickedInputsProductTextMax = 20000;

export const twoSpeakerPickedInputsResolutionDefault = `1080p`;
export const twoSpeakerPickedInputsWordmarkDefault = ``;
export const twoSpeakerPickedInputsWordmarkMax = 30;



export const TwoSpeakerPickedInputs = zod.object({
  "brand_colors": zod.string().max(twoSpeakerPickedInputsBrandColorsMax).default(twoSpeakerPickedInputsBrandColorsDefault),
  "brand_name": zod.string().max(twoSpeakerPickedInputsBrandNameMax).default(twoSpeakerPickedInputsBrandNameDefault),
  "brand_said": zod.string().max(twoSpeakerPickedInputsBrandSaidMax).default(twoSpeakerPickedInputsBrandSaidDefault),
  "captions": zod.boolean().default(twoSpeakerPickedInputsCaptionsDefault),
  "guest_voice": zod.union([zod.uuid(),zod.null()]).exactOptional(),
  "product": PackshotProduct,
  "product_name": zod.string().max(twoSpeakerPickedInputsProductNameMax).default(twoSpeakerPickedInputsProductNameDefault),
  "product_text": zod.string().max(twoSpeakerPickedInputsProductTextMax).default(twoSpeakerPickedInputsProductTextDefault),
  "resolution": zod.enum(['1080p', '720p']).default(twoSpeakerPickedInputsResolutionDefault),
  "wordmark": zod.string().max(twoSpeakerPickedInputsWordmarkMax).default(twoSpeakerPickedInputsWordmarkDefault)
}).describe('The form with its product picked, as Generate script and Approve script need it (422 at\n`product`, as Podcast Ad\'s).');

export type TwoSpeakerPickedInputs = zod.input<typeof TwoSpeakerPickedInputs>;
export type TwoSpeakerPickedInputsOutput = zod.output<typeof TwoSpeakerPickedInputs>;

export const twoSpeakerEndCardButtonMax = 60;

export const twoSpeakerEndCardHeadlineMax = 200;

export const twoSpeakerEndCardOfferMax = 200;

export const twoSpeakerEndCardSublineMax = 200;



export const TwoSpeakerEndCard = zod.object({
  "button": zod.string().max(twoSpeakerEndCardButtonMax),
  "headline": zod.string().max(twoSpeakerEndCardHeadlineMax),
  "offer": zod.string().max(twoSpeakerEndCardOfferMax),
  "subline": zod.string().max(twoSpeakerEndCardSublineMax)
}).describe('The end card\'s words (L4579, L4826): the headline, the line below it, the button and the\noffer under the button.');

export type TwoSpeakerEndCard = zod.input<typeof TwoSpeakerEndCard>;
export type TwoSpeakerEndCardOutput = zod.output<typeof TwoSpeakerEndCard>;

export const twoSpeakerLineFirstThirdMax = 2000;

export const twoSpeakerLineLastThirdMax = 2000;

export const twoSpeakerLineMiddleMax = 2000;

export const twoSpeakerLineSpeakerRegExp = new RegExp('^[a-z][a-z_]{0,19}$');
export const twoSpeakerLineTextMax = 2000;

export const twoSpeakerLineTimingMax = 2000;

export const twoSpeakerLineVibeMax = 2000;



export const TwoSpeakerLine = zod.object({
  "first_third": zod.string().max(twoSpeakerLineFirstThirdMax),
  "last_third": zod.string().max(twoSpeakerLineLastThirdMax),
  "middle": zod.string().max(twoSpeakerLineMiddleMax),
  "speaker": zod.string().regex(twoSpeakerLineSpeakerRegExp),
  "text": zod.string().max(twoSpeakerLineTextMax),
  "timing": zod.string().max(twoSpeakerLineTimingMax),
  "vibe": zod.string().max(twoSpeakerLineVibeMax)
}).describe('One line of the script: its speaker (an id of the format\'s preset), its words, and how it\nis played, the director\'s (HotSeat-2): the vibe, what the hands do in each third, and the\ntiming sentence (the playbook\'s filled example, L4767-4789).');

export type TwoSpeakerLine = zod.input<typeof TwoSpeakerLine>;
export type TwoSpeakerLineOutput = zod.output<typeof TwoSpeakerLine>;

export const twoSpeakerScriptClaimsMax = 60;

export const twoSpeakerScriptLinesMax = 60;



export const TwoSpeakerScript = zod.object({
  "claims": zod.array(ScriptClaim).max(twoSpeakerScriptClaimsMax),
  "end_card": TwoSpeakerEndCard,
  "lines": zod.array(TwoSpeakerLine).min(1).max(twoSpeakerScriptLinesMax)
}).describe('The script director\'s answer, edited in the form before approval: one line a beat of the\nformat, the end card\'s words, and every product fact they state with its quote from the\nproduct\'s texts (`claims`, Podcast Ad\'s), what the grounding check reads.');

export type TwoSpeakerScript = zod.input<typeof TwoSpeakerScript>;
export type TwoSpeakerScriptOutput = zod.output<typeof TwoSpeakerScript>;

export const TwoSpeakerApproval = zod.object({
  "inputs": TwoSpeakerPickedInputs,
  "script": TwoSpeakerScript
}).describe('`POST .../draft/approve`: Approve script, the form and the script as edited.');

export type TwoSpeakerApproval = zod.input<typeof TwoSpeakerApproval>;
export type TwoSpeakerApprovalOutput = zod.output<typeof TwoSpeakerApproval>;

export const twoSpeakerInputsBrandColorsDefault = ``;
export const twoSpeakerInputsBrandColorsMax = 200;

export const twoSpeakerInputsBrandNameDefault = ``;
export const twoSpeakerInputsBrandNameMax = 100;

export const twoSpeakerInputsBrandSaidDefault = ``;
export const twoSpeakerInputsBrandSaidMax = 200;

export const twoSpeakerInputsCaptionsDefault = true;
export const twoSpeakerInputsProductNameDefault = ``;
export const twoSpeakerInputsProductNameMax = 200;

export const twoSpeakerInputsProductTextDefault = ``;
export const twoSpeakerInputsProductTextMax = 20000;

export const twoSpeakerInputsResolutionDefault = `1080p`;
export const twoSpeakerInputsWordmarkDefault = ``;
export const twoSpeakerInputsWordmarkMax = 30;



export const TwoSpeakerInputs = zod.object({
  "brand_colors": zod.string().max(twoSpeakerInputsBrandColorsMax).default(twoSpeakerInputsBrandColorsDefault),
  "brand_name": zod.string().max(twoSpeakerInputsBrandNameMax).default(twoSpeakerInputsBrandNameDefault),
  "brand_said": zod.string().max(twoSpeakerInputsBrandSaidMax).default(twoSpeakerInputsBrandSaidDefault),
  "captions": zod.boolean().default(twoSpeakerInputsCaptionsDefault),
  "guest_voice": zod.union([zod.uuid(),zod.null()]).exactOptional(),
  "product": zod.union([PackshotProduct,zod.null()]).exactOptional(),
  "product_name": zod.string().max(twoSpeakerInputsProductNameMax).default(twoSpeakerInputsProductNameDefault),
  "product_text": zod.string().max(twoSpeakerInputsProductTextMax).default(twoSpeakerInputsProductTextDefault),
  "resolution": zod.enum(['1080p', '720p']).default(twoSpeakerInputsResolutionDefault),
  "wordmark": zod.string().max(twoSpeakerInputsWordmarkMax).default(twoSpeakerInputsWordmarkDefault)
}).describe('A two-speaker format\'s form so far: the product (none until picked), and the rest.');

export type TwoSpeakerInputs = zod.input<typeof TwoSpeakerInputs>;
export type TwoSpeakerInputsOutput = zod.output<typeof TwoSpeakerInputs>;

export const twoSpeakerDraftStillNameRegExp = new RegExp('^[a-z][a-z_]{0,19}$');


export const TwoSpeakerDraftStill = zod.object({
  "name": zod.string().regex(twoSpeakerDraftStillNameRegExp),
  "output": zod.union([OutputRef,zod.null()]).exactOptional(),
  "problem": zod.union([zod.string(),zod.null()]),
  "status": StillStatus,
  "url": zod.union([zod.string(),zod.null()])
}).describe('One of the draft\'s stills (a speaker\'s, by its id, then `end_card`), as `DraftStill`.');

export type TwoSpeakerDraftStill = zod.input<typeof TwoSpeakerDraftStill>;
export type TwoSpeakerDraftStillOutput = zod.output<typeof TwoSpeakerDraftStill>;

export const TwoSpeakerDraft = zod.object({
  "inputs": TwoSpeakerInputs,
  "problem": zod.union([zod.string(),zod.null()]),
  "script": zod.union([TwoSpeakerScript,zod.null()]),
  "script_director": DirectorState,
  "script_problems": zod.array(zod.string()),
  "stage": DraftStage,
  "stills": zod.array(TwoSpeakerDraftStill),
  "updated_at": zod.iso.datetime({"offset":true}),
  "urls_expire_at": zod.union([zod.iso.datetime({"offset":true}),zod.null()])
}).describe('A member\'s draft of a two-speaker format in the brand: the form, the stage, the script and\nits director, and the stills (empty until the script is approved). `script_problems`: what\nthe check still refuses in the director\'s script after its redo, in the form\'s words (empty\nfor a script that passes); `problem`: the words of the director that last failed.');

export type TwoSpeakerDraft = zod.input<typeof TwoSpeakerDraft>;
export type TwoSpeakerDraftOutput = zod.output<typeof TwoSpeakerDraft>;

export const TwoSpeakerDraftWrite = zod.object({
  "inputs": TwoSpeakerInputs,
  "script": zod.union([TwoSpeakerScript,zod.null()]).exactOptional()
}).describe('`PUT .../templates/{card}/draft`: the form as it stands, its script as edited.');

export type TwoSpeakerDraftWrite = zod.input<typeof TwoSpeakerDraftWrite>;
export type TwoSpeakerDraftWriteOutput = zod.output<typeof TwoSpeakerDraftWrite>;

export const TwoSpeakerScriptAsk = zod.object({
  "inputs": TwoSpeakerPickedInputs
}).describe('`POST .../templates/{card}/draft/script`: Generate script, on the form as it stands, its\nproduct picked.');

export type TwoSpeakerScriptAsk = zod.input<typeof TwoSpeakerScriptAsk>;
export type TwoSpeakerScriptAskOutput = zod.output<typeof TwoSpeakerScriptAsk>;

export const UnpricedDetails = zod.object({
  "skus": zod.array(zod.string())
}).describe('The SKUs that have no price in the active version. A missing price is never zero.');

export type UnpricedDetails = zod.input<typeof UnpricedDetails>;
export type UnpricedDetailsOutput = zod.output<typeof UnpricedDetails>;

export const UploadMismatchDetails = zod.object({
  "actual_bytes": zod.int(),
  "actual_mime": zod.string(),
  "expected_bytes": zod.int(),
  "expected_mime": zod.string()
}).describe('What the upload was prepared for and what reached the bucket.');

export type UploadMismatchDetails = zod.input<typeof UploadMismatchDetails>;
export type UploadMismatchDetailsOutput = zod.output<typeof UploadMismatchDetails>;


export const uploadRequestNameMax = 255;


export const uploadRequestNameRegExp = new RegExp('[^\\t\\n\\v\\f\\r \\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000\\ufeff]');


export const UploadRequest = zod.object({
  "bytes": zod.int().min(1),
  "folder_id": zod.union([zod.uuid(),zod.null()]).exactOptional(),
  "mime": MediaMime,
  "name": zod.string().min(1).max(uploadRequestNameMax).regex(uploadRequestNameRegExp)
}).describe('`POST .../brands/{brand_id}/uploads`: what the browser is about to send.');

export type UploadRequest = zod.input<typeof UploadRequest>;
export type UploadRequestOutput = zod.output<typeof UploadRequest>;

export const UploadTicket = zod.object({
  "asset": Asset,
  "form": zod.union([UploadForm,zod.null()])
}).describe('The pending asset and the form to post its file with; `form` is null once the asset\nno longer waits for a file (a repeated request after `complete`).');

export type UploadTicket = zod.input<typeof UploadTicket>;
export type UploadTicketOutput = zod.output<typeof UploadTicket>;

export const urlImportRequestBytesExclusiveMin = 0;
export const urlImportRequestBytesMax = 50000000;

export const urlImportRequestNameOneMax = 255;


export const urlImportRequestNameOneRegExp = new RegExp('[^\\t\\n\\v\\f\\r \\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000\\ufeff]');
export const urlImportRequestUrlMin = 9;
export const urlImportRequestUrlMax = 2048;


export const urlImportRequestUrlRegExp = new RegExp('^https://[A-Za-z0-9.-]+(:[0-9]{1,5})?([/?#][^\\t\\n\\v\\f\\r \\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000\\ufeff]*)?$');


export const UrlImportRequest = zod.object({
  "bytes": zod.int().gt(urlImportRequestBytesExclusiveMin).max(urlImportRequestBytesMax),
  "mime": ImportMime,
  "name": zod.union([zod.string().min(1).max(urlImportRequestNameOneMax).regex(urlImportRequestNameOneRegExp),zod.null()]).exactOptional(),
  "url": zod.string().min(urlImportRequestUrlMin).max(urlImportRequestUrlMax).regex(urlImportRequestUrlRegExp)
}).describe('`POST .../brands/{brand_id}/assets/from-url` (#249): a picture on the web, as an\nextraction read it (its type and size), kept in the library once the worker has fetched it\nagain and found the same file. Live copies an extracted logo or product image into storage\nwhen its form is saved; nothing is kept before.');

export type UrlImportRequest = zod.input<typeof UrlImportRequest>;
export type UrlImportRequestOutput = zod.output<typeof UrlImportRequest>;

export const UsageGroup = zod.enum(['user', 'team', 'brand', 'model', 'type', 'day']);

export type UsageGroup = zod.input<typeof UsageGroup>;
export type UsageGroupOutput = zod.output<typeof UsageGroup>;

export const UsageTrace = zod.object({
  "attempt": zod.int(),
  "brand_id": zod.union([zod.uuid(),zod.null()]),
  "catalog_version": zod.union([zod.string(),zod.null()]),
  "cost": TraceCost,
  "created_at": zod.iso.datetime({"offset":true}),
  "deleted": zod.boolean(),
  "error_code": zod.union([JobErrorCode,zod.null()]),
  "error_message": zod.union([zod.string(),zod.null()]),
  "files": zod.array(TraceFile),
  "files_expire_at": zod.iso.datetime({"offset":true}),
  "finished_at": zod.union([zod.iso.datetime({"offset":true}),zod.null()]),
  "id": zod.uuid(),
  "inputs": zod.union([TraceInputs,zod.null()]),
  "line": zod.union([JobUsageView,zod.null()]),
  "model": zod.union([TraceModel,zod.null()]),
  "output_count": zod.int(),
  "outputs": zod.array(TraceOutput),
  "parent": zod.union([TraceJob,zod.null()]),
  "price_version_id": zod.union([zod.uuid(),zod.null()]),
  "requests": zod.array(TraceRequest),
  "started_at": zod.union([zod.iso.datetime({"offset":true}),zod.null()]),
  "status": JobStatus,
  "step": zod.union([TraceRunStep,zod.null()]),
  "steps": zod.array(TraceStep),
  "team_id": zod.uuid(),
  "team_name": zod.union([zod.string(),zod.null()]),
  "type": zod.string(),
  "user": zod.union([UsageUser,zod.null()]),
  "webhooks": zod.array(TraceWebhook)
}).describe('`GET /v1/staff/teams/{team_id}/jobs/{job_id}/trace`: one job down to each vendor request\nit made (spec platform/usage-analytics.md 3), read under its team\'s scope. Every read is\naudited (`usage.trace_read`), written before the answer.');

export type UsageTrace = zod.input<typeof UsageTrace>;
export type UsageTraceOutput = zod.output<typeof UsageTrace>;

export const UserOwnsTeamsDetails = zod.object({
  "team_ids": zod.array(zod.uuid())
}).describe('The live teams the user owns: ownership moves, or the team is deleted, first.');

export type UserOwnsTeamsDetails = zod.input<typeof UserOwnsTeamsDetails>;
export type UserOwnsTeamsDetailsOutput = zod.output<typeof UserOwnsTeamsDetails>;

export const ValidationDetails = zod.object({
  "errors": zod.array(FieldError)
}).describe('Which request fields failed and why. Never the submitted values.');

export type ValidationDetails = zod.input<typeof ValidationDetails>;
export type ValidationDetailsOutput = zod.output<typeof ValidationDetails>;

export const VersionConflictDetails = zod.object({
  "current_version": zod.int()
}).describe('A write was based on an older version of the row: reload `current_version`, then\nwrite again (the editor\'s projects).');

export type VersionConflictDetails = zod.input<typeof VersionConflictDetails>;
export type VersionConflictDetailsOutput = zod.output<typeof VersionConflictDetails>;

export const videoShotsDurationSecondsExclusiveMin = 0;




export const VideoShots = zod.object({
  "duration_seconds": zod.number().gt(videoShotsDurationSecondsExclusiveMin),
  "shots": zod.array(VideoShot).min(1)
}).describe('A `video.shots` job\'s one output, its JSON file (G14-ad-swap): the video\'s length and its\nshots in order, the first from 0 and the last to the length, each ending where the next\nstarts. A video with no hard cut is one shot.');

export type VideoShots = zod.input<typeof VideoShots>;
export type VideoShotsOutput = zod.output<typeof VideoShots>;

export const VoiceGender = zod.enum(['female', 'male']).describe('Live\'s Gender filter: Female, Male.');

export type VoiceGender = zod.input<typeof VoiceGender>;
export type VoiceGenderOutput = zod.output<typeof VoiceGender>;

export const Voice = zod.object({
  "age": zod.union([VoiceAge,zod.null()]),
  "created_at": zod.union([zod.iso.datetime({"offset":true}),zod.null()]).exactOptional(),
  "duration_ms": zod.union([zod.int(),zod.null()]).exactOptional(),
  "gender": zod.union([VoiceGender,zod.null()]),
  "id": zod.uuid(),
  "kind": VoiceKind,
  "name": zod.string(),
  "preview_url": zod.string()
}).describe('A voice to pick: its sample is `preview_url`, signed like a job\'s outputs, until\n`VoicePage.urls_expire_at`. A speech job takes its `id` as `voice_id`.');

export type Voice = zod.input<typeof Voice>;
export type VoiceOutput = zod.output<typeof Voice>;

export const VoiceMime = zod.enum(['audio/mpeg', 'audio/mp3', 'audio/mp4', 'audio/x-m4a', 'audio/wav', 'audio/wave', 'audio/x-wav', 'audio/x-pn-wav']).describe('A voice sample\'s type, as live\'s upload takes them (`VOICE_ALLOWED_TYPES`): MP3, M4A and\nWAV under each name browsers give them, and `audio/mp4`.');

export type VoiceMime = zod.input<typeof VoiceMime>;
export type VoiceMimeOutput = zod.output<typeof VoiceMime>;

export const VoiceCompleteRequest = zod.object({
  "mime": VoiceMime,
  "name": VoiceName
}).describe('The uploaded sample becomes a voice, once read: 15 to 60 seconds. A name the brand has\ntakes the next free one (`name_1`), as live\'s.');

export type VoiceCompleteRequest = zod.input<typeof VoiceCompleteRequest>;
export type VoiceCompleteRequestOutput = zod.output<typeof VoiceCompleteRequest>;

export const VoiceFromDesignRequest = zod.object({
  "job_id": zod.uuid(),
  "name": zod.union([VoiceName,zod.null()]).exactOptional()
}).describe('Save a designed voice: the `voice.design` job and, optionally, a name (live\'s default is\n`AI Voice - YYYY-MM-DD`).');

export type VoiceFromDesignRequest = zod.input<typeof VoiceFromDesignRequest>;
export type VoiceFromDesignRequestOutput = zod.output<typeof VoiceFromDesignRequest>;

export const VoicePage = zod.object({
  "items": zod.array(Voice),
  "next": zod.union([zod.string(),zod.null()]),
  "urls_expire_at": zod.union([zod.iso.datetime({"offset":true}),zod.null()])
}).describe('A page of voices, by name (live lists Aida to Zara).');

export type VoicePage = zod.input<typeof VoicePage>;
export type VoicePageOutput = zod.output<typeof VoicePage>;

export const voiceProfileAnswerVendorVoiceIdRegExp = new RegExp('^[A-Za-z0-9_-]{1,64}$');


export const VoiceProfileAnswer = zod.object({
  "vendor_voice_id": zod.string().regex(voiceProfileAnswerVendorVoiceIdRegExp)
}).describe('What `voice.profile`\'s one output holds (spec G2-kling-v4-voices): the voice Kling made\nfrom the clip, by Kling\'s own id (FAL\'s create-voice `voice_id`), which a Kling 4.0 video\nnames in its `voice_ids`.');

export type VoiceProfileAnswer = zod.input<typeof VoiceProfileAnswer>;
export type VoiceProfileAnswerOutput = zod.output<typeof VoiceProfileAnswer>;

export const voiceUploadRequestBytesMax = 20971520;



export const VoiceUploadRequest = zod.object({
  "bytes": zod.int().min(1).max(voiceUploadRequestBytesMax),
  "mime": VoiceMime,
  "name": VoiceName
}).describe('`POST .../voices/uploads`: the sample the browser is about to send (an upload or a\nrecording).');

export type VoiceUploadRequest = zod.input<typeof VoiceUploadRequest>;
export type VoiceUploadRequestOutput = zod.output<typeof VoiceUploadRequest>;

export const VoiceUploadTicket = zod.object({
  "form": UploadForm,
  "voice_id": zod.uuid()
}).describe('Post the form, then `POST .../voices/{voice_id}/complete` with the same name and type.');

export type VoiceUploadTicket = zod.input<typeof VoiceUploadTicket>;
export type VoiceUploadTicketOutput = zod.output<typeof VoiceUploadTicket>;

export const YapperAdSettingId = zod.enum(['auto', 'bathroom_vanity', 'city_walk', 'bed_at_night', 'kitchen_coffee', 'parked_car_reply', 'treadmill_garage', 'garden_bed', 'airport_gate', 'stovetop', 'pool_lounger', 'stroller_walk', 'dorm_bunk', 'porch_steps_pet']);

export type YapperAdSettingId = zod.input<typeof YapperAdSettingId>;
export type YapperAdSettingIdOutput = zod.output<typeof YapperAdSettingId>;

export const yapperAdPickedInputsCaptionPositionDefault = `bottom`;
export const yapperAdPickedInputsCaptionStyleIdDefault = ``;
export const yapperAdPickedInputsCaptionStyleIdMax = 64;

export const yapperAdPickedInputsCommentDefault = ``;
export const yapperAdPickedInputsCommentMax = 500;

export const yapperAdPickedInputsCtaDefault = ``;
export const yapperAdPickedInputsCtaMax = 100;

export const yapperAdPickedInputsEndCardDefault = true;
export const yapperAdPickedInputsPersonNoteDefault = ``;
export const yapperAdPickedInputsPersonNoteMax = 500;

export const yapperAdPickedInputsProductNameDefault = ``;
export const yapperAdPickedInputsProductNameMax = 200;

export const yapperAdPickedInputsProductTextDefault = ``;
export const yapperAdPickedInputsProductTextMax = 20000;

export const yapperAdPickedInputsPronunciationDefault = ``;
export const yapperAdPickedInputsPronunciationMax = 100;

export const yapperAdPickedInputsResolutionDefault = `720p`;
export const yapperAdPickedInputsSettingIdDefault = 'bathroom_vanity';
export const yapperAdPickedInputsSubtitlesDefault = true;
export const yapperAdPickedInputsTopicDefault = ``;
export const yapperAdPickedInputsTopicMax = 500;

export const yapperAdPickedInputsWalkLeadInDefault = false;

export const YapperAdPickedInputs = zod.object({
  "caption_position": zod.enum(['top', 'center', 'bottom']).default(yapperAdPickedInputsCaptionPositionDefault),
  "caption_style_id": zod.string().max(yapperAdPickedInputsCaptionStyleIdMax).default(yapperAdPickedInputsCaptionStyleIdDefault),
  "comment": zod.string().max(yapperAdPickedInputsCommentMax).default(yapperAdPickedInputsCommentDefault),
  "cta": zod.string().max(yapperAdPickedInputsCtaMax).default(yapperAdPickedInputsCtaDefault),
  "end_card": zod.boolean().default(yapperAdPickedInputsEndCardDefault),
  "person": zod.union([ActorSource,zod.null()]).exactOptional(),
  "person_note": zod.string().max(yapperAdPickedInputsPersonNoteMax).default(yapperAdPickedInputsPersonNoteDefault),
  "product": PackshotProduct,
  "product_name": zod.string().max(yapperAdPickedInputsProductNameMax).default(yapperAdPickedInputsProductNameDefault),
  "product_text": zod.string().max(yapperAdPickedInputsProductTextMax).default(yapperAdPickedInputsProductTextDefault),
  "pronunciation": zod.string().max(yapperAdPickedInputsPronunciationMax).default(yapperAdPickedInputsPronunciationDefault),
  "resolution": zod.enum(['720p', '1080p']).default(yapperAdPickedInputsResolutionDefault),
  "setting_id": YapperAdSettingId.default(yapperAdPickedInputsSettingIdDefault),
  "subtitles": zod.boolean().default(yapperAdPickedInputsSubtitlesDefault),
  "topic": zod.string().max(yapperAdPickedInputsTopicMax).default(yapperAdPickedInputsTopicDefault),
  "walk_lead_in": zod.boolean().default(yapperAdPickedInputsWalkLeadInDefault)
}).describe('The form with its product picked, as Generate script needs it (live\'s "Pick a product and\nits packshot", 422 at `product`).');

export type YapperAdPickedInputs = zod.input<typeof YapperAdPickedInputs>;
export type YapperAdPickedInputsOutput = zod.output<typeof YapperAdPickedInputs>;

export const YapperAdApproval = zod.object({
  "inputs": YapperAdPickedInputs,
  "script": YapperAdScript
}).describe('`POST .../draft/approve`: live\'s approval 1, the form and the script as edited.');

export type YapperAdApproval = zod.input<typeof YapperAdApproval>;
export type YapperAdApprovalOutput = zod.output<typeof YapperAdApproval>;

export const yapperAdInputsCaptionPositionDefault = `bottom`;
export const yapperAdInputsCaptionStyleIdDefault = ``;
export const yapperAdInputsCaptionStyleIdMax = 64;

export const yapperAdInputsCommentDefault = ``;
export const yapperAdInputsCommentMax = 500;

export const yapperAdInputsCtaDefault = ``;
export const yapperAdInputsCtaMax = 100;

export const yapperAdInputsEndCardDefault = true;
export const yapperAdInputsPersonNoteDefault = ``;
export const yapperAdInputsPersonNoteMax = 500;

export const yapperAdInputsProductNameDefault = ``;
export const yapperAdInputsProductNameMax = 200;

export const yapperAdInputsProductTextDefault = ``;
export const yapperAdInputsProductTextMax = 20000;

export const yapperAdInputsPronunciationDefault = ``;
export const yapperAdInputsPronunciationMax = 100;

export const yapperAdInputsResolutionDefault = `720p`;
export const yapperAdInputsSettingIdDefault = 'bathroom_vanity';
export const yapperAdInputsSubtitlesDefault = true;
export const yapperAdInputsTopicDefault = ``;
export const yapperAdInputsTopicMax = 500;

export const yapperAdInputsWalkLeadInDefault = false;

export const YapperAdInputs = zod.object({
  "caption_position": zod.enum(['top', 'center', 'bottom']).default(yapperAdInputsCaptionPositionDefault),
  "caption_style_id": zod.string().max(yapperAdInputsCaptionStyleIdMax).default(yapperAdInputsCaptionStyleIdDefault),
  "comment": zod.string().max(yapperAdInputsCommentMax).default(yapperAdInputsCommentDefault),
  "cta": zod.string().max(yapperAdInputsCtaMax).default(yapperAdInputsCtaDefault),
  "end_card": zod.boolean().default(yapperAdInputsEndCardDefault),
  "person": zod.union([ActorSource,zod.null()]).exactOptional(),
  "person_note": zod.string().max(yapperAdInputsPersonNoteMax).default(yapperAdInputsPersonNoteDefault),
  "product": zod.union([PackshotProduct,zod.null()]).exactOptional(),
  "product_name": zod.string().max(yapperAdInputsProductNameMax).default(yapperAdInputsProductNameDefault),
  "product_text": zod.string().max(yapperAdInputsProductTextMax).default(yapperAdInputsProductTextDefault),
  "pronunciation": zod.string().max(yapperAdInputsPronunciationMax).default(yapperAdInputsPronunciationDefault),
  "resolution": zod.enum(['720p', '1080p']).default(yapperAdInputsResolutionDefault),
  "setting_id": YapperAdSettingId.default(yapperAdInputsSettingIdDefault),
  "subtitles": zod.boolean().default(yapperAdInputsSubtitlesDefault),
  "topic": zod.string().max(yapperAdInputsTopicMax).default(yapperAdInputsTopicDefault),
  "walk_lead_in": zod.boolean().default(yapperAdInputsWalkLeadInDefault)
}).describe('Yapper Ad\'s form so far: the product (none until picked), and the rest.');

export type YapperAdInputs = zod.input<typeof YapperAdInputs>;
export type YapperAdInputsOutput = zod.output<typeof YapperAdInputs>;

export const YapperAdDraftStill = zod.object({
  "label": zod.string(),
  "name": zod.string(),
  "output": zod.union([OutputRef,zod.null()]).exactOptional(),
  "problem": zod.union([zod.string(),zod.null()]),
  "status": StillStatus,
  "url": zod.union([zod.string(),zod.null()])
}).describe('One of the draft\'s stills (live\'s `StillState`): its name (`sheet`, `pet`, `end_card`,\n`bubble`, `f<k>` a talk clip\'s, `i<k>` an insert\'s), its label in live\'s words ("Character\nsheet", "Clip 1 · hook · anchor"), its state, its signed picture and the picture\'s\nreference once done, and why it failed.');

export type YapperAdDraftStill = zod.input<typeof YapperAdDraftStill>;
export type YapperAdDraftStillOutput = zod.output<typeof YapperAdDraftStill>;

export const YapperAdDraft = zod.object({
  "inputs": YapperAdInputs,
  "problem": zod.union([zod.string(),zod.null()]),
  "script": zod.union([YapperAdScript,zod.null()]),
  "script_director": DirectorState,
  "script_problems": zod.array(zod.string()),
  "script_warning": zod.boolean(),
  "setting_director": DirectorState,
  "shot": zod.union([YapperAdShot,zod.null()]),
  "shot_director": DirectorState,
  "shot_problems": zod.array(zod.string()),
  "stage": DraftStage,
  "stills": zod.array(YapperAdDraftStill),
  "updated_at": zod.iso.datetime({"offset":true}),
  "urls_expire_at": zod.union([zod.iso.datetime({"offset":true}),zod.null()])
}).describe('A member\'s Yapper Ad draft in the brand: the form, the stage, the script and its two\ndirectors (the setting director\'s, for Auto, then the script director\'s). `script_warning`:\nthe kept script still failed its checks after its tries (live\'s "Script check failed 3\ntimes. Fix the clips before approving."); `script_problems`: what is off in the script as it\nstands, each in live\'s words, which live shows as warnings, never a stop. `problem`: live\'s\nwords for the last director that failed. Past approval 1 (`stage` `cast`, live\'s stills\nstage): the shot director\'s state (the locks, then the clip plan), the settled `shot` once\nplanned, and `shot_problems`, what its tries still failed and how the product was settled,\nwhich live shows as notes.');

export type YapperAdDraft = zod.input<typeof YapperAdDraft>;
export type YapperAdDraftOutput = zod.output<typeof YapperAdDraft>;

export const YapperAdDraftWrite = zod.object({
  "inputs": YapperAdInputs,
  "script": zod.union([YapperAdScript,zod.null()]).exactOptional()
}).describe('`PUT .../templates/yapper-ad/draft`: the form as it stands, its script as edited.');

export type YapperAdDraftWrite = zod.input<typeof YapperAdDraftWrite>;
export type YapperAdDraftWriteOutput = zod.output<typeof YapperAdDraftWrite>;

export const YapperAdScriptAsk = zod.object({
  "inputs": YapperAdPickedInputs
}).describe('`POST .../draft/script`: live\'s ✦ Generate script, on the form as it stands.');

export type YapperAdScriptAsk = zod.input<typeof YapperAdScriptAsk>;
export type YapperAdScriptAskOutput = zod.output<typeof YapperAdScriptAsk>;
/**
 * Liveness and the code that is running. Touches no dependency.
 * @summary Healthz
 */
export const HealthzResponse = HealthResponse


/**
 * The models a job can use, with every option and default, and the job types.
 * @summary Get Catalog
 */
export const GetCatalogResponse = Catalog


/**
 * Which optional features are on: any signed-in user may ask; 401 signed out.
 * @summary Get Features
 */
export const GetFeaturesResponse = Features


/**
 * The signed-in user.
 * @summary Get Me
 */
export const GetMeResponse = Me


/**
 * Change the display name. Browser sessions only.
 * @summary Update Me
 */
export const UpdateMeBody = MeUpdate

export const UpdateMeResponse = Me


/**
 * The actor's teams with their role and brand ids: the one source for the SPA's gates.
 * @summary Get Access Scope
 */
export const GetAccessScopeResponse = AccessScope


/**
 * The user's board across every team they are in: each offered achievement as they may
 * see it, the totals, the unseen unlocks and their switches. From a session only (403
 * `FORBIDDEN` for a token, which is bound to one team).
 * @summary Get My Achievements
 */
export const GetMyAchievementsResponse = AchievementBoard


/**
 * Hide achievements, on or off: the trophy, the cards, the popover, the tab and the
 * shared lists. Awards still accrue. From a session only.
 * @summary Set Achievements Hidden
 */
export const SetAchievementsHiddenBody = HiddenUpdate

export const SetAchievementsHiddenResponse = Hidden


/**
 * The named unlocks seen: the popover opened, or the card was read. One the user does
 * not hold, or saw already, changes nothing. From a session only.
 * @summary Mark Achievements Seen
 */
export const MarkAchievementsSeenBody = SeenAwards

export const MarkAchievementsSeenResponse = zod.void()


/**
 * Save the person's theme (409 `THEME_LOCKED` for one not theirs) or their own switch.
 * @summary Update My Appearance
 */
export const UpdateMyAppearanceBody = PreferenceUpdate

export const UpdateMyAppearanceResponse = Preference


/**
 * Give or withdraw marketing and ads consent. Browser sessions only.
 * @summary Set My Consents
 */
export const SetMyConsentsBody = ConsentsUpdate

export const SetMyConsentsResponse = Me


/**
 * The pending invitations to the caller's verified email, with each team's and inviter's
 * name: "Invitations for you" after sign-in. A session only, never a personal access token.
 * @summary List Invitations For Me
 */
export const ListInvitationsForMeResponseItem = InvitationForYou
export const ListInvitationsForMeResponse = zod.array(ListInvitationsForMeResponseItem)


/**
 * Join the team of the invitation in the email link, as the email it was sent to.
 * @summary Accept Invitation
 */
export const AcceptInvitationBody = InvitationAccept

export const AcceptInvitationResponse = InvitationAccepted


/**
 * Join the team of one of "Invitations for you", as the email it was sent to: the token
 * accept's rules, the invitation found by id. Another email's is 404.
 * @summary Accept Invitation For Me
 */
export const AcceptInvitationForMeParams = zod.object({
  "invitation_id": zod.uuid()
})

export const AcceptInvitationForMeResponse = InvitationAccepted


/**
 * Email a 6-digit code. The answer is the same whether or not the email has an account:
 * 202, or 503 `EMAIL_UNAVAILABLE` for every address while the email provider is busy or
 * down.
 * @summary Request Sign In Code
 */
export const RequestSignInCodeBody = EmailCodeRequest

export const RequestSignInCodeResponse = CodeSent


/**
 * Sign in with the code: one session, in the cookie.
 * @summary Verify Sign In Code
 */
export const VerifySignInCodeBody = EmailCodeVerify

export const VerifySignInCodeResponse = SignedIn


/**
 * Where to send the browser for Google; the attempt waits in a cookie.
 * @summary Start Google Sign In
 */
export const StartGoogleSignInBody = GoogleStart

export const StartGoogleSignInResponse = GoogleAuthorization


/**
 * Finish Google sign-in with what Google sent back to `/sign-in/google`.
 * @summary Complete Google Sign In
 */
export const CompleteGoogleSignInBody = GoogleComplete

export const CompleteGoogleSignInResponse = SignedIn


/**
 * End this browser's session, and clear its media cookies.
 * @summary Sign Out
 */
export const SignOutResponse = zod.void()


/**
 * End every session of the user, this one included, and clear this browser's media
 * cookies. Personal access tokens stay.
 * @summary Sign Out Everywhere
 */
export const SignOutEverywhereResponse = zod.void()


/**
 * The caller's teams and their role in each.
 * @summary List My Teams
 */
export const ListMyTeamsResponseItem = MyTeam
export const ListMyTeamsResponse = zod.array(ListMyTeamsResponseItem)


/**
 * A team the caller owns. Self-serve only: with the flag off, staff create teams (D1).
 * @summary Create My Team
 */
export const CreateMyTeamBody = TeamCreate

export const CreateMyTeamResponse = Team


/**
 * Accept the terms in force; 409 `TERMS_VERSION_STALE` for another version.
 * @summary Accept Terms
 */
export const AcceptTermsBody = TermsAccept

export const AcceptTermsResponse = Me


/**
 * The user's live personal access tokens, in every team. Browser sessions only.
 * @summary List Tokens
 */
export const ListTokensResponseItem = Token
export const ListTokensResponse = zod.array(ListTokensResponseItem)


/**
 * Revoke one of the user's tokens; it stops working on its next request.
 * @summary Revoke Token
 */
export const RevokeTokenParams = zod.object({
  "token_id": zod.uuid()
})

export const RevokeTokenResponse = zod.void()


/**
 * Every AI task (spec G9-ai-tasks): live's model, the one it runs on now and the switch
 * behind it, and each row it may run on with its price and whether it may be chosen here.
 * @summary List Staff Ai Tasks
 */
export const ListStaffAiTasksResponse = AiTaskList


/**
 * Switch the task to one of its rows, with a reason, for every start after this one.
 * 404 for an unknown task; 422 at `model` for a catalog tool, a row outside the task's,
 * one not offered here, or, in prod, one with no real run on dev.
 * @summary Set Staff Ai Task Model
 */
export const setStaffAiTaskModelPathTaskIdMax = 64;



export const SetStaffAiTaskModelParams = zod.object({
  "task_id": zod.string().max(setStaffAiTaskModelPathTaskIdMax)
})

export const setStaffAiTaskModelHeaderIdempotencyKeyMax = 200;



export const SetStaffAiTaskModelHeader = zod.object({
  "Idempotency-Key": zod.string().min(1).max(setStaffAiTaskModelHeaderIdempotencyKeyMax).describe('A repeat of the same request returns the first answer; another request with the same key is 409 IDEMPOTENCY_CONFLICT.')
})

export const SetStaffAiTaskModelBody = AiTaskModelSet

export const SetStaffAiTaskModelResponse = AiTaskView


/**
 * Every staff mutation, newest first.
 * @summary List Staff Audit
 */
export const listStaffAuditQueryAfterOneMax = 500;

export const listStaffAuditQueryLimitDefault = 50;
export const listStaffAuditQueryLimitMax = 100;



export const ListStaffAuditQueryParams = zod.object({
  "after": zod.union([zod.string().max(listStaffAuditQueryAfterOneMax),zod.null()]).exactOptional(),
  "limit": zod.int().min(1).max(listStaffAuditQueryLimitMax).default(listStaffAuditQueryLimitDefault)
})

export const ListStaffAuditResponse = AuditPage


/**
 * Every team, deleted ones too (with `deleted_at`), with its usage over its whole life:
 * the credits its jobs used, charged less refunded, and the known part of their vendor
 * cost.
 * @summary List Staff Teams
 */
export const ListStaffTeamsResponseItem = StaffTeamListed
export const ListStaffTeamsResponse = zod.array(ListStaffTeamsResponseItem)


/**
 * A team for an owner email: staff holds it until the owner accepts the emailed
 * invitation (for the staff user's own email, there is none).
 * @summary Create Staff Team
 */
export const createStaffTeamHeaderIdempotencyKeyMax = 200;



export const CreateStaffTeamHeader = zod.object({
  "Idempotency-Key": zod.string().min(1).max(createStaffTeamHeaderIdempotencyKeyMax).describe('A repeat of the same request returns the first answer; another request with the same key is 409 IDEMPOTENCY_CONFLICT.')
})

export const CreateStaffTeamBody = StaffTeamCreate

export const CreateStaffTeamResponse = StaffTeamCreated


/**
 * A team's members, open invitations, balance and newest 50 ledger entries.
 * @summary Get Staff Team
 */
export const GetStaffTeamParams = zod.object({
  "team_id": zod.uuid()
})

export const GetStaffTeamResponse = StaffTeamDetail


/**
 * A signed correction with a reason. 402 when a debit is more than `available`.
 * @summary Adjust Staff Credits
 */
export const AdjustStaffCreditsParams = zod.object({
  "team_id": zod.uuid()
})

export const adjustStaffCreditsHeaderIdempotencyKeyMax = 200;



export const AdjustStaffCreditsHeader = zod.object({
  "Idempotency-Key": zod.string().min(1).max(adjustStaffCreditsHeaderIdempotencyKeyMax).describe('A repeat of the same request returns the first answer; another request with the same key is 409 IDEMPOTENCY_CONFLICT.')
})

export const AdjustStaffCreditsBody = StaffAdjustment

export const AdjustStaffCreditsResponse = StaffAdjustmentResult


/**
 * Credits for a live team: a lot, or a month of a plan. 409 `TEAM_DELETED`.
 * @summary Grant Staff Credits
 */
export const GrantStaffCreditsParams = zod.object({
  "team_id": zod.uuid()
})

export const grantStaffCreditsHeaderIdempotencyKeyMax = 200;



export const GrantStaffCreditsHeader = zod.object({
  "Idempotency-Key": zod.string().min(1).max(grantStaffCreditsHeaderIdempotencyKeyMax).describe('A repeat of the same request returns the first answer; another request with the same key is 409 IDEMPOTENCY_CONFLICT.')
})

export const GrantStaffCreditsBody = zod.union([StaffLotGrant,StaffPlanPeriodGrant])

export const GrantStaffCreditsResponse = StaffGrantResult


/**
 * Stop a job that has not delivered and release its hold. 409 `JOB_FINALIZING` once
 * the provider delivered, `JOB_TERMINAL` once it ended.
 * @summary Cancel Staff Job
 */
export const CancelStaffJobParams = zod.object({
  "team_id": zod.uuid(),
  "job_id": zod.uuid()
})

export const cancelStaffJobHeaderIdempotencyKeyMax = 200;



export const CancelStaffJobHeader = zod.object({
  "Idempotency-Key": zod.string().min(1).max(cancelStaffJobHeaderIdempotencyKeyMax).describe('A repeat of the same request returns the first answer; another request with the same key is 409 IDEMPOTENCY_CONFLICT.')
})

export const CancelStaffJobBody = StaffJobCancel

export const CancelStaffJobResponse = StaffJobCanceled


/**
 * One job of a team down to each vendor request: its inputs, outputs and their files
 * (each URL bound to its one object, for 15 minutes), its requests with their bodies, its
 * webhooks, credits, parent and steps. Each read writes its audit row
 * (`usage.trace_read`) before it answers: 404 with none for a job of another team or none,
 * 500 with nothing when the row cannot be written.
 * @summary Get Staff Job Trace
 */
export const GetStaffJobTraceParams = zod.object({
  "team_id": zod.uuid(),
  "job_id": zod.uuid()
})

export const GetStaffJobTraceResponse = UsageTrace


/**
 * Every team's usage grouped by `group_by`: user (the default), team, brand, model,
 * type or day, a run's steps under their generation. At most 500 groups, the most net
 * credits first (days newest first), the totals of all of them, and the names of the users,
 * teams or models the groups are. No prompt and no file: those are in a trace alone.
 * @summary List Staff Usage
 */
export const listStaffUsageQueryModelIdOneMax = 200;

export const listStaffUsageQueryTypeOneMax = 200;



export const ListStaffUsageQueryParams = zod.object({
  "from": zod.union([zod.iso.date(),zod.null()]).exactOptional(),
  "to": zod.union([zod.iso.date(),zod.null()]).exactOptional(),
  "team_id": zod.union([zod.uuid(),zod.null()]).exactOptional(),
  "brand_id": zod.union([zod.uuid(),zod.null()]).exactOptional(),
  "user_id": zod.union([zod.uuid(),zod.null()]).exactOptional(),
  "model_id": zod.union([zod.string().max(listStaffUsageQueryModelIdOneMax),zod.null()]).exactOptional(),
  "type": zod.union([zod.string().max(listStaffUsageQueryTypeOneMax),zod.null()]).exactOptional(),
  "group_by": zod.enum(['user', 'team', 'brand', 'model', 'type', 'day']).exactOptional()
})

export const ListStaffUsageResponse = StaffUsagePage


/**
 * The generations behind the filters, newest start first, open ones included, each
 * with its run's totals and, with `steps`, its steps' lines; `group_by` plays no part.
 * @summary List Staff Usage Jobs
 */
export const listStaffUsageJobsQueryAfterOneMax = 500;

export const listStaffUsageJobsQueryLimitDefault = 50;
export const listStaffUsageJobsQueryLimitMax = 100;

export const listStaffUsageJobsQueryStepsDefault = false;
export const listStaffUsageJobsQueryModelIdOneMax = 200;

export const listStaffUsageJobsQueryTypeOneMax = 200;



export const ListStaffUsageJobsQueryParams = zod.object({
  "after": zod.union([zod.string().max(listStaffUsageJobsQueryAfterOneMax),zod.null()]).exactOptional(),
  "limit": zod.int().min(1).max(listStaffUsageJobsQueryLimitMax).default(listStaffUsageJobsQueryLimitDefault),
  "steps": zod.boolean().default(listStaffUsageJobsQueryStepsDefault),
  "from": zod.union([zod.iso.date(),zod.null()]).exactOptional(),
  "to": zod.union([zod.iso.date(),zod.null()]).exactOptional(),
  "team_id": zod.union([zod.uuid(),zod.null()]).exactOptional(),
  "brand_id": zod.union([zod.uuid(),zod.null()]).exactOptional(),
  "user_id": zod.union([zod.uuid(),zod.null()]).exactOptional(),
  "model_id": zod.union([zod.string().max(listStaffUsageJobsQueryModelIdOneMax),zod.null()]).exactOptional(),
  "type": zod.union([zod.string().max(listStaffUsageJobsQueryTypeOneMax),zod.null()]).exactOptional(),
  "group_by": zod.enum(['user', 'team', 'brand', 'model', 'type', 'day']).exactOptional()
})

export const ListStaffUsageJobsResponse = StaffUsageJobPage


/**
 * The user with this email, tombstoned or not, and their teams; 404 when none.
 * @summary Find Staff User
 */
export const findStaffUserQueryEmailMin = 3;
export const findStaffUserQueryEmailMax = 320;


export const findStaffUserQueryEmailRegExp = new RegExp('^[a-zA-Z0-9.!#$%&\'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?)+$');


export const FindStaffUserQueryParams = zod.object({
  "email": zod.string().min(findStaffUserQueryEmailMin).max(findStaffUserQueryEmailMax).regex(findStaffUserQueryEmailRegExp)
})

export const FindStaffUserResponse = StaffUser


/**
 * Delete a user: memberships, sessions and tokens go, the row is tombstoned and the
 * email can never sign up again. 409 for staff and for the owner of a live team.
 * @summary Delete Staff User
 */
export const DeleteStaffUserParams = zod.object({
  "user_id": zod.uuid()
})

export const deleteStaffUserHeaderIdempotencyKeyMax = 200;



export const DeleteStaffUserHeader = zod.object({
  "Idempotency-Key": zod.string().min(1).max(deleteStaffUserHeaderIdempotencyKeyMax).describe('A repeat of the same request returns the first answer; another request with the same key is 409 IDEMPOTENCY_CONFLICT.')
})

export const DeleteStaffUserResponse = zod.void()


/**
 * Delete the team (the owner only). Its jobs that have not delivered are canceled.
 * @summary Delete Team
 */
export const DeleteTeamParams = zod.object({
  "team_id": zod.uuid()
})

export const DeleteTeamResponse = zod.void()


/**
 * @summary Get Team
 */
export const GetTeamParams = zod.object({
  "team_id": zod.uuid()
})

export const GetTeamResponse = Team


/**
 * A new name for the team (admins and the owner).
 * @summary Rename Team
 */
export const RenameTeamParams = zod.object({
  "team_id": zod.uuid()
})

export const RenameTeamBody = TeamUpdate

export const RenameTeamResponse = Team


/**
 * Each member who shares in this team and does not hide: their count and best tier
 * here.
 * @summary List Member Achievements
 */
export const ListMemberAchievementsParams = zod.object({
  "team_id": zod.uuid()
})

export const ListMemberAchievementsResponseItem = MemberAchievements
export const ListMemberAchievementsResponse = zod.array(ListMemberAchievementsResponseItem)


/**
 * Share the awards earned in this team with its members, or stop; private by default.
 * Any member, for themselves, from a session only.
 * @summary Set Achievements Shared
 */
export const SetAchievementsSharedParams = zod.object({
  "team_id": zod.uuid()
})

export const SetAchievementsSharedBody = SharingUpdate

export const SetAchievementsSharedResponse = Sharing


/**
 * One of the team's actors, from any brand, by its maker, an admin or the owner. A
 * global actor is not found here.
 * @summary Delete Actor
 */
export const DeleteActorParams = zod.object({
  "actor_id": zod.uuid(),
  "team_id": zod.uuid()
})

export const DeleteActorResponse = zod.void()


/**
 * One of the team's actors, from any brand, with its signed portrait (a picture clip's
 * source in the editor). A global actor is not found here.
 * @summary Get Team Actor
 */
export const GetTeamActorParams = zod.object({
  "actor_id": zod.uuid(),
  "team_id": zod.uuid()
})

export const GetTeamActorResponse = AiActor


/**
 * Everything a page load needs: the person's theme and own switch, the team's switch,
 * each theme with its rarity and whether it is theirs, and today's case.
 * @summary Get Appearance
 */
export const GetAppearanceParams = zod.object({
  "team_id": zod.uuid()
})

export const GetAppearanceResponse = AppearanceView


/**
 * Open the person's free case of today: a theme they lack, or rarely the jackpot,
 * credits for this team. Every open that day, in any of their teams, answers the same case.
 * From the person's session only (403 `FORBIDDEN` for a token); 409 `CASES_HIDDEN` when
 * the person or the team hid the cases; 409 `ALL_THEMES_OWNED` when every theme is theirs.
 * @summary Open Daily Case
 */
export const OpenDailyCaseParams = zod.object({
  "team_id": zod.uuid()
})

export const OpenDailyCaseResponse = CaseResult


/**
 * Hide or show the free daily case for every member: the owner and admins only (403
 * `PERMISSION_DENIED`).
 * @summary Update Team Appearance
 */
export const UpdateTeamAppearanceParams = zod.object({
  "team_id": zod.uuid()
})

export const UpdateTeamAppearanceBody = TeamSettingUpdate

export const UpdateTeamAppearanceResponse = TeamSetting


/**
 * The team's credits: `available` to spend now, `held` by running jobs. Zeros before
 * the first grant. The same stored balance the staff team detail shows.
 * @summary Get Team Balance
 */
export const GetTeamBalanceParams = zod.object({
  "team_id": zod.uuid()
})

export const GetTeamBalanceResponse = Balance


/**
 * The team's Checkout for the plan and cycle: its open one again, or a new one, under
 * live's refusals. Only Stripe's webhooks then give the team its plan.
 * @summary Start Checkout
 */
export const StartCheckoutParams = zod.object({
  "team_id": zod.uuid()
})

export const StartCheckoutBody = CheckoutStart

export const StartCheckoutResponse = CheckoutUrl


/**
 * Stripe's Portal for the team's subscription: a plan change, a cancel at the period's
 * end, the payment method and the invoices. A team whose subscription ended gets a
 * Checkout for its last plan instead, as on live.
 * @summary Open Portal
 */
export const OpenPortalParams = zod.object({
  "team_id": zod.uuid()
})

export const OpenPortalResponse = BillingUrl


/**
 * A new Checkout for a pack of `top_ups.yaml`, under live's refusals. Only Stripe's
 * webhook then gives the team its credits.
 * @summary Start Top Up
 */
export const StartTopUpParams = zod.object({
  "team_id": zod.uuid()
})

export const StartTopUpBody = TopUpStart

export const StartTopUpResponse = CheckoutUrl


/**
 * The team's live brands, by name, for every member (D6).
 * @summary List Brands
 */
export const ListBrandsParams = zod.object({
  "team_id": zod.uuid()
})

export const ListBrandsResponseItem = Brand
export const ListBrandsResponse = zod.array(ListBrandsResponseItem)


/**
 * @summary Create Brand
 */
export const CreateBrandParams = zod.object({
  "team_id": zod.uuid()
})

export const CreateBrandBody = BrandIn

export const CreateBrandResponse = Brand


/**
 * @summary Delete Brand
 */
export const DeleteBrandParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const DeleteBrandResponse = zod.void()


/**
 * @summary Get Brand
 */
export const GetBrandParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const GetBrandResponse = Brand


/**
 * Replace the whole brand with the request.
 * @summary Replace Brand
 */
export const ReplaceBrandParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const ReplaceBrandBody = BrandIn

export const ReplaceBrandResponse = Brand


/**
 * Live's Global Actors, newest first, each with its portrait's and preview's signed
 * URLs and its voice; `kind=team`, My Actors: every actor of the team, from every brand.
 * Each facet may repeat: OR within one, AND across them, as live's. My Actors takes
 * `gender`, `created_by` and `product_id` (the actors saved from a generation that showed
 * it); a global actor has neither a maker nor a product.
 * @summary List Actors
 */
export const ListActorsParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const listActorsQuerySearchOneMax = 100;

export const listActorsQueryAfterOneMax = 500;

export const listActorsQueryLimitDefault = 50;
export const listActorsQueryLimitMax = 100;



export const ListActorsQueryParams = zod.object({
  "kind": zod.enum(['global', 'team']).exactOptional(),
  "gender": zod.union([zod.array(AiActorGender),zod.null()]).exactOptional(),
  "age": zod.union([zod.array(VoiceAge),zod.null()]).exactOptional(),
  "skin_tone": zod.union([zod.array(SkinTone),zod.null()]).exactOptional(),
  "situation": zod.union([zod.array(AiActorSituation),zod.null()]).exactOptional(),
  "clothing": zod.union([zod.array(AiActorClothingTag),zod.null()]).exactOptional(),
  "accessories": zod.union([zod.array(AiActorAccessory),zod.null()]).exactOptional(),
  "created_by": zod.union([zod.array(zod.uuid()),zod.null()]).exactOptional(),
  "product_id": zod.union([zod.uuid(),zod.null()]).exactOptional(),
  "search": zod.union([zod.string().min(1).max(listActorsQuerySearchOneMax),zod.null()]).exactOptional(),
  "order": zod.enum(['newest', 'oldest']).exactOptional().describe('The library\'s order, as live\'s Sounds page sorts it: "Recently Added" or "Oldest First".'),
  "after": zod.union([zod.string().max(listActorsQueryAfterOneMax),zod.null()]).exactOptional(),
  "limit": zod.int().min(1).max(listActorsQueryLimitMax).default(listActorsQueryLimitDefault)
})

export const ListActorsResponse = AiActorPage


/**
 * Keep portraits of one of your `image.actor` generations in this brand as the team's
 * actors (live's Save, on one image or all of them), in the order asked. A portrait saved
 * before returns its actor. 404 for a generation not yours here or an image it lacks, as
 * live's; 422 for an image not delivered.
 * @summary Save Generated Actors
 */
export const SaveGeneratedActorsParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const SaveGeneratedActorsBody = AiActorFromGenerationRequest

export const SaveGeneratedActorsResponse = AiActorList


/**
 * Move one of the team's library images into a team actor (live's Add From Library):
 * the actor takes the image's name and gender other, and the image goes to the library's
 * trash. 422 at `asset_id` for anything but a ready image of the team's library; 403 for
 * an image you may not delete there; 409 for a brand's logo or a product's image.
 * @summary Move Library Image To Actor
 */
export const MoveLibraryImageToActorParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const MoveLibraryImageToActorBody = AiActorFromLibraryRequest

export const MoveLibraryImageToActorResponse = AiActor


/**
 * A new actor's id and the form to post its portrait with: a PNG, JPEG or WebP of up
 * to 20 MB. Nothing is kept until `complete`.
 * @summary Prepare Actor Upload
 */
export const PrepareActorUploadParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const PrepareActorUploadBody = AiActorUploadRequest

export const PrepareActorUploadResponse = AiActorUploadTicket


/**
 * The posted portrait becomes the team's actor once read, with gender other and a
 * random name, as live's. 404 while no file is there (none uploaded under this id, or
 * another team's or brand's id); 422 for a file that is not an image.
 * @summary Complete Actor Upload
 */
export const CompleteActorUploadParams = zod.object({
  "actor_id": zod.uuid(),
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const CompleteActorUploadBody = AiActorCompleteRequest

export const CompleteActorUploadResponse = AiActor


/**
 * The brand's copies of its live products, last changed first, as live's Ad copies
 * modal lists them: for one product, and whose name or product's name holds `search`. A
 * job's draft is listed `in_progress` from its start until its output fills it.
 * @summary List Ad Copies
 */
export const ListAdCopiesParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const listAdCopiesQuerySearchOneMax = 100;



export const ListAdCopiesQueryParams = zod.object({
  "product_id": zod.union([zod.uuid(),zod.null()]).exactOptional(),
  "search": zod.union([zod.string().min(1).max(listAdCopiesQuerySearchOneMax),zod.null()]).exactOptional()
})

export const ListAdCopiesResponse = AdCopyList


/**
 * Live's Write tab: a copy of one of the brand's products, written by hand. 422 for
 * another brand's product or a deleted one ("Product not found").
 * @summary Create Ad Copy
 */
export const CreateAdCopyParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const CreateAdCopyBody = AdCopyCreate

export const CreateAdCopyResponse = AdCopy


/**
 * By its creator, an admin or the owner.
 * @summary Delete Ad Copy
 */
export const DeleteAdCopyParams = zod.object({
  "copy_id": zod.uuid(),
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const DeleteAdCopyResponse = zod.void()


/**
 * A new name, and each text sent in place of its values (null clears one); the texts
 * left out stay. By its creator, an admin or the owner.
 * @summary Update Ad Copy
 */
export const UpdateAdCopyParams = zod.object({
  "copy_id": zod.uuid(),
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const UpdateAdCopyBody = AdCopyUpdate

export const UpdateAdCopyResponse = AdCopy


/**
 * The same texts under live's next name: "Name (copy)", then "Name (copy 2)".
 * @summary Duplicate Ad Copy
 */
export const DuplicateAdCopyParams = zod.object({
  "copy_id": zod.uuid(),
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const DuplicateAdCopyResponse = AdCopy


/**
 * A library image's latest analysis: `in_progress`, `failed`, or `completed` with what it
 * read. 404 while it has none.
 * @summary Get Asset Ad Structure
 */
export const GetAssetAdStructureParams = zod.object({
  "source_asset_id": zod.uuid(),
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const GetAssetAdStructureResponse = AdStructure


/**
 * Live's edit of a completed structure: the texts and the visual pairs sent replace
 * theirs, the categories sent replace the list. 404 while there is none to edit.
 * @summary Update Asset Ad Structure
 */
export const UpdateAssetAdStructureParams = zod.object({
  "source_asset_id": zod.uuid(),
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const UpdateAssetAdStructureBody = AdStructureUpdate

export const UpdateAssetAdStructureResponse = AdStructure


/**
 * A job output's latest analysis, as a library image's.
 * @summary Get Output Ad Structure
 */
export const getOutputAdStructurePathOutputIndexMin = 0;
export const getOutputAdStructurePathOutputIndexMax = 99;



export const GetOutputAdStructureParams = zod.object({
  "source_job_id": zod.uuid(),
  "output_index": zod.int().min(getOutputAdStructurePathOutputIndexMin).max(getOutputAdStructurePathOutputIndexMax),
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const GetOutputAdStructureResponse = AdStructure


/**
 * Live's edit of a job output's completed structure, as a library image's.
 * @summary Update Output Ad Structure
 */
export const updateOutputAdStructurePathOutputIndexMin = 0;
export const updateOutputAdStructurePathOutputIndexMax = 99;



export const UpdateOutputAdStructureParams = zod.object({
  "source_job_id": zod.uuid(),
  "output_index": zod.int().min(updateOutputAdStructurePathOutputIndexMin).max(updateOutputAdStructurePathOutputIndexMax),
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const UpdateOutputAdStructureBody = AdStructureUpdate

export const UpdateOutputAdStructureResponse = AdStructure


/**
 * The brand's ready assets, newest first or oldest first; `trash=true` lists the trash
 * instead. Each filter narrows the page: the kind, the folder (with `recursive=true` the
 * folders under it too, live's "Show nested"; 422 without `folder_id`), part of the name
 * (`search`),
 * where it came from (`source`, repeatable: any of them; `upload` is live's "Manual
 * Uploads"), the job type it was
 * generated by (`generation_type`, as `audio.sfx`), who added it (`created_by`, repeatable:
 * any of them) and a product its generation shows (`product_id`).
 * @summary List Assets
 */
export const ListAssetsParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const listAssetsQueryRecursiveDefault = false;
export const listAssetsQuerySearchOneMax = 255;

export const listAssetsQueryGenerationTypeOneMax = 40;


export const listAssetsQueryGenerationTypeOneRegExp = new RegExp('^[a-z]+\\.[a-z_]+$');
export const listAssetsQueryTrashDefault = false;
export const listAssetsQueryLimitDefault = 50;
export const listAssetsQueryLimitMax = 100;



export const ListAssetsQueryParams = zod.object({
  "kind": zod.union([AssetKind,zod.null()]).exactOptional(),
  "folder_id": zod.union([zod.uuid(),zod.null()]).exactOptional(),
  "recursive": zod.boolean().default(listAssetsQueryRecursiveDefault),
  "search": zod.union([zod.string().min(1).max(listAssetsQuerySearchOneMax),zod.null()]).exactOptional(),
  "source": zod.union([zod.array(AssetSource),zod.null()]).exactOptional(),
  "generation_type": zod.union([zod.string().max(listAssetsQueryGenerationTypeOneMax).regex(listAssetsQueryGenerationTypeOneRegExp),zod.null()]).exactOptional(),
  "created_by": zod.union([zod.array(zod.uuid()),zod.null()]).exactOptional(),
  "product_id": zod.union([zod.uuid(),zod.null()]).exactOptional(),
  "order": zod.enum(['newest', 'oldest']).exactOptional().describe('The library\'s order, as live\'s Sounds page sorts it: "Recently Added" or "Oldest First".'),
  "trash": zod.boolean().default(listAssetsQueryTrashDefault),
  "after": zod.union([zod.string(),zod.null()]).exactOptional(),
  "limit": zod.int().min(1).max(listAssetsQueryLimitMax).default(listAssetsQueryLimitDefault)
})

export const ListAssetsResponse = AssetPage


/**
 * Keep a delivered job output in the library: a pending asset that the worker copies into
 * place. A second save of the same output returns the same asset.
 * @summary Save Job Output
 */
export const SaveJobOutputParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const saveJobOutputHeaderIdempotencyKeyMax = 255;



export const SaveJobOutputHeader = zod.object({
  "Idempotency-Key": zod.string().min(1).max(saveJobOutputHeaderIdempotencyKeyMax)
})

export const SaveJobOutputBody = SaveRequest

export const SaveJobOutputResponse = Asset


/**
 * Keep a picture on the web in the library (#249): a pending asset that the worker fetches
 * into place if it is still the file declared, else fails. A replayed key returns the same
 * asset.
 * @summary Import From Url
 */
export const ImportFromUrlParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const importFromUrlHeaderIdempotencyKeyMax = 255;



export const ImportFromUrlHeader = zod.object({
  "Idempotency-Key": zod.string().min(1).max(importFromUrlHeaderIdempotencyKeyMax)
})

export const ImportFromUrlBody = UrlImportRequest

export const ImportFromUrlResponse = Asset


/**
 * Live's Move to project (#668, spec S1c), from a card's menu or the bulk bar: every named
 * file into the folder, or to the brand's top level with `folder_id` null, all or nothing.
 * A file the library does not list, or a folder of another brand, is 422 at its field. Any
 * member, as on live.
 * @summary Move Assets
 */
export const MoveAssetsParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const MoveAssetsBody = AssetMove

export const MoveAssetsResponse = zod.void()


/**
 * Re-index all (spec S3, "At scale"): every ready image and video the brand's library lists
 * is indexed again, fairly with other teams' requests; one already pending is not asked again.
 * Any member, as the file's Re-index.
 * @summary Reindex All Assets
 */
export const ReindexAllAssetsParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const ReindexAllAssetsResponse = AssetReindexAll


/**
 * Live's semantic search of the library (spec S3): the brand's assets nearest in meaning
 * to `q`, best first, at most 256 points in all, a video once per matching scene. The list's
 * filters narrow it first: the kind, one folder (never its subfolders), where it came from
 * (`source`, repeatable), the job type it was generated by and a product its generation
 * shows. 404 while `CREATEDAI_FLAGS__SEMANTIC_SEARCH` is off; 503 `SEARCH_UNAVAILABLE` when
 * the search model does not answer; 60 searches a minute per member.
 * @summary Search Assets
 */
export const SearchAssetsParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const searchAssetsQueryQMax = 500;


export const searchAssetsQueryQRegExp = new RegExp('\\S');
export const searchAssetsQueryGenerationTypeOneMax = 40;


export const searchAssetsQueryGenerationTypeOneRegExp = new RegExp('^[a-z]+\\.[a-z_]+$');
export const searchAssetsQueryLimitDefault = 20;
export const searchAssetsQueryLimitMax = 50;



export const SearchAssetsQueryParams = zod.object({
  "q": zod.string().min(1).max(searchAssetsQueryQMax).regex(searchAssetsQueryQRegExp),
  "kind": zod.union([AssetKind,zod.null()]).exactOptional(),
  "folder_id": zod.union([zod.uuid(),zod.null()]).exactOptional(),
  "source": zod.union([zod.array(AssetSource),zod.null()]).exactOptional(),
  "generation_type": zod.union([zod.string().max(searchAssetsQueryGenerationTypeOneMax).regex(searchAssetsQueryGenerationTypeOneRegExp),zod.null()]).exactOptional(),
  "product_id": zod.union([zod.uuid(),zod.null()]).exactOptional(),
  "after": zod.union([zod.string(),zod.null()]).exactOptional(),
  "limit": zod.int().min(1).max(searchAssetsQueryLimitMax).default(searchAssetsQueryLimitDefault)
})

export const SearchAssetsResponse = AssetSearchPage


/**
 * What the brand's trash holds: its files, their bytes (which count toward the team's
 * storage until purged) and the days a file stays there. Any member.
 * @summary Get Trash
 */
export const GetTrashParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const GetTrashResponse = TrashSummary


/**
 * Empty trash: every file of the brand's trash purged, for good, its bytes freed from the
 * team's storage at once and the files gone for every reader; the sweep's next run (within 15
 * minutes) deletes their objects. It deletes others' files too, so an admin or the owner (403
 * for anyone else). A second call purges none.
 * @summary Empty Trash
 */
export const EmptyTrashParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const EmptyTrashResponse = TrashEmptied


/**
 * Live's bulk Download as one `downloads.zip` (spec zip-download): 2 to 1,000 files the
 * library lists, 10 GiB at most in all (422 at the field otherwise), zipped by the worker.
 * Free, capped per team and hour; poll its `GET` for the URL.
 * @summary Start Zip
 */
export const StartZipParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const startZipHeaderIdempotencyKeyMax = 255;



export const StartZipHeader = zod.object({
  "Idempotency-Key": zod.string().min(1).max(startZipHeaderIdempotencyKeyMax)
})

export const StartZipBody = AssetZipRequest

export const StartZipResponse = AssetZip


/**
 * A ZIP's job: its status, what it holds, and its signed URL once made; 404 for any other
 * job.
 * @summary Get Zip
 */
export const GetZipParams = zod.object({
  "job_id": zod.uuid(),
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const GetZipResponse = AssetZip


/**
 * Into the trash for `TRASH_DAYS` (7). The creator, an admin or the owner.
 * @summary Delete Asset
 */
export const DeleteAssetParams = zod.object({
  "asset_id": zod.uuid(),
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const DeleteAssetResponse = zod.void()


/**
 * One asset of the brand, in any status, in the trash or not.
 * @summary Get Asset
 */
export const GetAssetParams = zod.object({
  "asset_id": zod.uuid(),
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const GetAssetResponse = Asset


/**
 * Live's Re-index (spec S3): the image or video is indexed for search again by the worker,
 * `pending` until it is; `skipped` for a kind the index leaves out. Any member.
 * @summary Reindex Asset
 */
export const ReindexAssetParams = zod.object({
  "asset_id": zod.uuid(),
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const ReindexAssetResponse = AssetReindex


/**
 * Out of the trash, within its `TRASH_DAYS` (7). The creator, an admin or the owner.
 * @summary Restore Asset
 */
export const RestoreAssetParams = zod.object({
  "asset_id": zod.uuid(),
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const RestoreAssetResponse = Asset


/**
 * The brand's projects, the latest changed first, a page of summaries with each one's
 * picture (spec editor/project-list-pages.md), for every member (D6).
 * @summary List Edit Projects
 */
export const ListEditProjectsParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const listEditProjectsQueryAfterOneMax = 500;

export const listEditProjectsQueryLimitDefault = 24;
export const listEditProjectsQueryLimitMax = 100;



export const ListEditProjectsQueryParams = zod.object({
  "after": zod.union([zod.string().max(listEditProjectsQueryAfterOneMax),zod.null()]).exactOptional(),
  "limit": zod.int().min(1).max(listEditProjectsQueryLimitMax).default(listEditProjectsQueryLimitDefault)
})

export const ListEditProjectsResponse = EditProjectPage


/**
 * A new project of the brand, empty unless the request has a timeline.
 * @summary Create Edit Project
 */
export const CreateEditProjectParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const CreateEditProjectBody = EditProjectCreate

export const CreateEditProjectResponse = EditProject


/**
 * Live's Open in the editor (#668, spec S1c): the brand's project opened from this
 * library video (200), else a new one (201): from the body, or, for a video the editor
 * saved, as its render made it (live's `projectFile`, spec editor/reopen-saved-video.md).
 * Anything but a ready video of the brand's library is 422 at `asset_id`.
 * @summary Open Edit Project From Asset
 */
export const OpenEditProjectFromAssetParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const OpenEditProjectFromAssetBody = EditProjectFromAsset

export const OpenEditProjectFromAssetResponse = EditProject


/**
 * Delete the project, its renders' rows and its chat; the videos it saved stay in the
 * library. Its creator or an admin deletes it.
 * @summary Delete Edit Project
 */
export const DeleteEditProjectParams = zod.object({
  "project_id": zod.uuid(),
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const DeleteEditProjectResponse = zod.void()


/**
 * @summary Get Edit Project
 */
export const GetEditProjectParams = zod.object({
  "project_id": zod.uuid(),
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const GetEditProjectResponse = EditProject


/**
 * Replace the whole project. 409 `VERSION_CONFLICT` when `version` is not current.
 * @summary Replace Edit Project
 */
export const ReplaceEditProjectParams = zod.object({
  "project_id": zod.uuid(),
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const ReplaceEditProjectBody = EditProjectUpdate

export const ReplaceEditProjectResponse = EditProject


/**
 * Ask the AI assistant about the saved `version` (409 when it is not current): an
 * `editor.assist` job answers with a plan of edits. Free, within an hourly cap (429). Its
 * status arrives as the job's events.
 * @summary Start Assist Answer
 */
export const StartAssistAnswerParams = zod.object({
  "project_id": zod.uuid(),
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const startAssistAnswerHeaderIdempotencyKeyMax = 200;



export const StartAssistAnswerHeader = zod.object({
  "Idempotency-Key": zod.string().min(1).max(startAssistAnswerHeaderIdempotencyKeyMax).describe('A repeat of the same request returns the first answer; another request with the same key is 409 IDEMPOTENCY_CONFLICT.')
})

export const StartAssistAnswerBody = AssistRequest

export const StartAssistAnswerResponse = AssistAnswer


/**
 * One answer, with its plan once the job succeeded.
 * @summary Get Assist Answer
 */
export const GetAssistAnswerParams = zod.object({
  "project_id": zod.uuid(),
  "job_id": zod.uuid(),
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const GetAssistAnswerResponse = AssistAnswer


/**
 * Live's Reset chat: every message of the project's chat deleted.
 * @summary Reset Assist Messages
 */
export const ResetAssistMessagesParams = zod.object({
  "project_id": zod.uuid(),
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const ResetAssistMessagesResponse = zod.void()


/**
 * The project's AI assistant chat, newest first, for every member (G11).
 * @summary List Assist Messages
 */
export const ListAssistMessagesParams = zod.object({
  "project_id": zod.uuid(),
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const listAssistMessagesQueryAfterOneMax = 500;

export const listAssistMessagesQueryLimitDefault = 30;
export const listAssistMessagesQueryLimitMax = 100;



export const ListAssistMessagesQueryParams = zod.object({
  "after": zod.union([zod.string().max(listAssistMessagesQueryAfterOneMax),zod.null()]).exactOptional(),
  "limit": zod.int().min(1).max(listAssistMessagesQueryLimitMax).default(listAssistMessagesQueryLimitDefault)
})

export const ListAssistMessagesResponse = AssistMessagePage


/**
 * Save one message of the chat: the user's, or the assistant's answer or plan step. A
 * project keeps its newest 1,000.
 * @summary Append Assist Message
 */
export const AppendAssistMessageParams = zod.object({
  "project_id": zod.uuid(),
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const AppendAssistMessageBody = AssistMessageCreate

export const AppendAssistMessageResponse = AssistMessage


/**
 * What each save after version `after` changed, oldest first (spec editor/live-sync.md),
 * for an open editor that is behind. `complete` is false, with no changes, when the log
 * cannot give them all: read the project whole. For every member (D6).
 * @summary Get Edit Project Changes
 */
export const GetEditProjectChangesParams = zod.object({
  "project_id": zod.uuid(),
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const getEditProjectChangesQueryAfterMax = 9007199254740991;



export const GetEditProjectChangesQueryParams = zod.object({
  "after": zod.int().min(1).max(getEditProjectChangesQueryAfterMax)
})

export const GetEditProjectChangesResponse = EditProjectChanges


/**
 * Every distinct source of the saved timeline, with what the editor plays and shows
 * (spec editor/project-media.md), so a project opens with one read; one a render would
 * refuse is `gone`. For every member (D6).
 * @summary Get Edit Project Media
 */
export const GetEditProjectMediaParams = zod.object({
  "project_id": zod.uuid(),
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const GetEditProjectMediaResponse = EditProjectMedia


/**
 * The project's latest renders, newest first.
 * @summary List Edit Renders
 */
export const ListEditRendersParams = zod.object({
  "project_id": zod.uuid(),
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const ListEditRendersResponseItem = EditRender
export const ListEditRendersResponse = zod.array(ListEditRendersResponseItem)


/**
 * Render the saved `version` to an MP4, saved to the brand's library when it is done.
 * Free, within an hourly cap (429). Its status arrives as the job's events.
 * @summary Start Edit Render
 */
export const StartEditRenderParams = zod.object({
  "project_id": zod.uuid(),
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const startEditRenderHeaderIdempotencyKeyMax = 200;



export const StartEditRenderHeader = zod.object({
  "Idempotency-Key": zod.string().min(1).max(startEditRenderHeaderIdempotencyKeyMax).describe('A repeat of the same request returns the first answer; another request with the same key is 409 IDEMPOTENCY_CONFLICT.')
})

export const StartEditRenderBody = EditRenderRequest

export const StartEditRenderResponse = EditRender


/**
 * @summary Get Edit Render
 */
export const GetEditRenderParams = zod.object({
  "project_id": zod.uuid(),
  "job_id": zod.uuid(),
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const GetEditRenderResponse = EditRender


/**
 * Where the browser making a render's file (`made_in` browser) posts it: a policy for
 * the render's own object, of `video/mp4` and exactly `bytes`, for 15 minutes (spec
 * editor/fast-save). The render's maker's alone (403); 409 once it is taking its file in
 * or has settled; 404 for a render made on the server.
 * @summary Start Edit Render File
 */
export const StartEditRenderFileParams = zod.object({
  "project_id": zod.uuid(),
  "job_id": zod.uuid(),
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const StartEditRenderFileBody = EditRenderFileRequest

export const StartEditRenderFileResponse = EditRenderFile


/**
 * The browser posted the render's file: the render takes it in now, not at its next
 * poll. Harmless before the file. The render's maker's alone (403).
 * @summary Sent Edit Render File
 */
export const SentEditRenderFileParams = zod.object({
  "project_id": zod.uuid(),
  "job_id": zod.uuid(),
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const SentEditRenderFileResponse = EditRender


/**
 * The browser could not finish this render's file: the render making it now. One
 * waiting for its file is canceled and its snapshot rendered on the server, with its own
 * job; one that has its file, or is made on the server, is answered as it is. The
 * render's maker's alone (403).
 * @summary Hand Edit Render To Server
 */
export const HandEditRenderToServerParams = zod.object({
  "project_id": zod.uuid(),
  "job_id": zod.uuid(),
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const handEditRenderToServerHeaderIdempotencyKeyMax = 200;



export const HandEditRenderToServerHeader = zod.object({
  "Idempotency-Key": zod.string().min(1).max(handEditRenderToServerHeaderIdempotencyKeyMax).describe('A repeat of the same request returns the first answer; another request with the same key is 409 IDEMPOTENCY_CONFLICT.')
})

export const HandEditRenderToServerResponse = EditRender


/**
 * The brand's folders, by name, each with its `parent_id` (null at the top level; the
 * client builds the tree) and marked if the caller made it a favorite.
 * @summary List Folders
 */
export const ListFoldersParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const ListFoldersResponseItem = Folder
export const ListFoldersResponse = zod.array(ListFoldersResponseItem)


/**
 * A folder at the brand's top level, or in `parent_id` (422 when not one of the brand's).
 * Its name is unique among its siblings (409).
 * @summary Create Folder
 */
export const CreateFolderParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const CreateFolderBody = FolderCreate

export const CreateFolderResponse = Folder


/**
 * Delete a folder (its creator or an admin), as live's two choices (A3b). `keep`, the
 * default: its assets are filed in `target` and its child folders move there (the brand's
 * top level when no `target`; 422 for a target under the folder or not the brand's, 409 when
 * a child is named as one of the target's). `delete`: every asset under it goes to the trash
 * and every folder under it goes (403 unless the actor may delete each, 409 `ASSET_IN_USE`
 * for a brand logo or a product image).
 * @summary Delete Folder
 */
export const DeleteFolderParams = zod.object({
  "folder_id": zod.uuid(),
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const DeleteFolderQueryParams = zod.object({
  "contents": zod.enum(['delete', 'keep']).exactOptional().describe('What deleting a folder does with what it holds (A3b): live\'s "Delete the project and all\ncontents" (the subtree\'s assets into the trash, its folders gone) or "Delete project but\nkeep assets" (its assets and child folders to a target, the top level when none).'),
  "target": zod.union([zod.uuid(),zod.null()]).exactOptional()
})

export const DeleteFolderResponse = zod.void()


/**
 * Rename a folder: its creator or an admin (D6).
 * @summary Rename Folder
 */
export const RenameFolderParams = zod.object({
  "folder_id": zod.uuid(),
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const RenameFolderBody = FolderIn

export const RenameFolderResponse = Folder


/**
 * @summary Remove Folder Favorite
 */
export const RemoveFolderFavoriteParams = zod.object({
  "folder_id": zod.uuid(),
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const RemoveFolderFavoriteResponse = zod.void()


/**
 * Mark the folder a favorite of the caller; doing it twice is the same.
 * @summary Add Folder Favorite
 */
export const AddFolderFavoriteParams = zod.object({
  "folder_id": zod.uuid(),
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const AddFolderFavoriteResponse = zod.void()


/**
 * Move a folder and everything under it into `parent_id`, or to the top level with null
 * (its creator or an admin). 422 into itself, a folder under it or a folder that is not the
 * brand's; 409 when the new siblings have its name.
 * @summary Move Folder
 */
export const MoveFolderParams = zod.object({
  "folder_id": zod.uuid(),
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const MoveFolderBody = FolderMove

export const MoveFolderResponse = Folder


/**
 * A file of this brand that live's generation made: its prompt, aspect ratio, live's
 * kind of generation and an Advanced image's specification. 404 for any other file.
 * @summary Get Imported Generation
 */
export const GetImportedGenerationParams = zod.object({
  "asset_id": zod.uuid(),
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const GetImportedGenerationResponse = ImportedGeneration


/**
 * Quote the job, hold its credits and queue it. 402 when the team's credits do not
 * cover it, 429 at a cap, 409 when it costs more than `expected_quote_max`.
 * @summary Start Job
 */
export const StartJobParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const startJobHeaderIdempotencyKeyMax = 200;



export const StartJobHeader = zod.object({
  "Idempotency-Key": zod.string().min(1).max(startJobHeaderIdempotencyKeyMax).describe('A repeat of the same request returns the first answer; another request with the same key is 409 IDEMPOTENCY_CONFLICT.')
})

export const StartJobBody = JobRequest

export const StartJobResponse = Job


/**
 * What the same request would cost now, before its prompt is written too, as the price
 * never reads it. Holds nothing.
 * @summary Quote Job
 */
export const QuoteJobParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const QuoteJobBody = JobQuoteRequest

export const QuoteJobResponse = JobQuote


/**
 * The brand's live products, for every member (D6), by name unless `order` says otherwise:
 * live's `newest`, `oldest`, `a_to_z`, `z_to_a` and `most_popular` (the products the team's
 * generations showed most). `created_by` keeps those any of these members made (repeatable).
 * @summary List Products
 */
export const ListProductsParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const ListProductsQueryParams = zod.object({
  "order": zod.enum(['newest', 'oldest', 'a_to_z', 'z_to_a', 'most_popular']).exactOptional().describe('The brand\'s products list\'s order, live\'s menu (spec A3d): Created Date\'s "Recently\nAdded" and "Oldest First", Product Name\'s "A-Z" and "Z-A", Popularity\'s "Most Popular" (the\nproducts the team\'s generations showed most).'),
  "created_by": zod.union([zod.array(zod.uuid()),zod.null()]).exactOptional()
})

export const ListProductsResponseItem = Product
export const ListProductsResponse = zod.array(ListProductsResponseItem)


/**
 * @summary Create Product
 */
export const CreateProductParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const CreateProductBody = ProductIn

export const CreateProductResponse = Product


/**
 * @summary Delete Product
 */
export const DeleteProductParams = zod.object({
  "product_id": zod.uuid(),
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const DeleteProductResponse = zod.void()


/**
 * @summary Get Product
 */
export const GetProductParams = zod.object({
  "product_id": zod.uuid(),
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const GetProductResponse = Product


/**
 * Replace the whole product with the request.
 * @summary Replace Product
 */
export const ReplaceProductParams = zod.object({
  "product_id": zod.uuid(),
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const ReplaceProductBody = ProductIn

export const ReplaceProductResponse = Product


/**
 * Live's two tabs, newest first (`order=oldest`: Oldest First), 24 a page: `custom`,
 * the brand's own (`search` in the name or the prompt), or `global`, live's (`search` in
 * the prompt). Covers are signed until `urls_expire_at`.
 * @summary List Prompt Templates
 */
export const ListPromptTemplatesParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const listPromptTemplatesQuerySearchOneMax = 255;

export const listPromptTemplatesQueryAfterOneMax = 500;

export const listPromptTemplatesQueryLimitDefault = 24;
export const listPromptTemplatesQueryLimitMax = 100;



export const ListPromptTemplatesQueryParams = zod.object({
  "kind": zod.enum(['custom', 'global']).exactOptional().describe('Live\'s two tabs: the brand\'s own (Custom, first) and live\'s (Global).'),
  "search": zod.union([zod.string().min(1).max(listPromptTemplatesQuerySearchOneMax),zod.null()]).exactOptional(),
  "order": zod.enum(['newest', 'oldest']).exactOptional().describe('The library\'s order, as live\'s Sounds page sorts it: "Recently Added" or "Oldest First".'),
  "after": zod.union([zod.string().max(listPromptTemplatesQueryAfterOneMax),zod.null()]).exactOptional(),
  "limit": zod.int().min(1).max(listPromptTemplatesQueryLimitMax).default(listPromptTemplatesQueryLimitDefault)
})

export const ListPromptTemplatesResponse = PromptTemplatePage


/**
 * Live's "Save Prompt": a library picture of this brand, saved from a simple image
 * job, becomes a template's cover, with that job's prompt and reference images. 404 for a
 * file the team cannot see, 422 at `asset_id` for any other file; 409
 * `PROMPT_TEMPLATE_EXISTS` for a picture that is one's cover already.
 * @summary Save Prompt Template
 */
export const SavePromptTemplateParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const SavePromptTemplateBody = PromptTemplateRequest

export const SavePromptTemplateResponse = PromptTemplate


/**
 * Home's Recent Projects (live's `GET /brand-projects/recent`): the brand's folders the
 * caller used last, newest first, at most five, each with how many assets it holds itself. A
 * folder counts as used when the caller makes it, opens it in the library (`GET .../assets`
 * with its `folder_id`), or saves, moves or uploads files into it.
 * @summary List Recent Folders
 */
export const ListRecentFoldersParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const ListRecentFoldersResponseItem = RecentFolder
export const ListRecentFoldersResponse = zod.array(ListRecentFoldersResponseItem)


/**
 * Start over: an empty draft. `TEMPLATE_DRAFT_LOCKED` (409) while anything works.
 * @summary Reset Ad Swap Draft
 */
export const ResetAdSwapDraftParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const ResetAdSwapDraftResponse = AdSwapDraft


/**
 * The member's draft, or an empty one: what the form opens with.
 * @summary Get Ad Swap Draft
 */
export const GetAdSwapDraftParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const GetAdSwapDraftResponse = AdSwapDraft


/**
 * The form as it stands and its script as edited. `TEMPLATE_DRAFT_LOCKED` (409) while
 * a step works or once the script is approved.
 * @summary Write Ad Swap Draft
 */
export const WriteAdSwapDraftParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const WriteAdSwapDraftBody = AdSwapDraftWrite

export const WriteAdSwapDraftResponse = AdSwapDraft


/**
 * Approve script: every part's line, the actor and both packs (422 at `script`); then
 * the new actor's still, a paid picture.
 * @summary Approve Ad Swap Script
 */
export const ApproveAdSwapScriptParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const ApproveAdSwapScriptBody = AdSwapApproval

export const ApproveAdSwapScriptResponse = AdSwapDraft


/**
 * Generate Script: the product, the source ad (a ready video of 4 to 30 s, 300 px or
 * more) and the rights checked (422 at each); an uploaded packshot with no name or no text
 * read first; the source ad's cuts, words and one frame a shot read (`reading_director`);
 * then the swap director, its script off its plan or its page redone once, then kept with
 * its problems (`script_problems`).
 * @summary Write Ad Swap Script
 */
export const WriteAdSwapScriptParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const WriteAdSwapScriptBody = AdSwapScriptAsk

export const WriteAdSwapScriptResponse = AdSwapDraft


/**
 * The actor's still drawn again, a paid picture. `TEMPLATE_DRAFT_LOCKED` (409) before
 * the cast or while anything works.
 * @summary Regenerate Ad Swap Actor
 */
export const RegenerateAdSwapActorParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const RegenerateAdSwapActorResponse = AdSwapDraft


/**
 * Start over: an empty draft. `TEMPLATE_DRAFT_LOCKED` (409) while anything works.
 * @summary Reset Balloon Ad Draft
 */
export const ResetBalloonAdDraftParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const ResetBalloonAdDraftResponse = BalloonAdDraft


/**
 * The member's draft, or an empty one: what the form opens with.
 * @summary Get Balloon Ad Draft
 */
export const GetBalloonAdDraftParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const GetBalloonAdDraftResponse = BalloonAdDraft


/**
 * The form as it stands and its script as edited, its words recounted.
 * `TEMPLATE_DRAFT_LOCKED` (409) while a step works or once the script is approved, as live
 * locks the form.
 * @summary Write Balloon Ad Draft
 */
export const WriteBalloonAdDraftParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const WriteBalloonAdDraftBody = BalloonAdDraftWrite

export const WriteBalloonAdDraftResponse = BalloonAdDraft


/**
 * Live's Approve script: a narrator in voiceover mode (422 at `inputs.voice`), a script
 * that passes live's gate (422 at `script`), then the stage the storyboard's.
 * @summary Approve Balloon Ad Script
 */
export const ApproveBalloonAdScriptParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const ApproveBalloonAdScriptBody = BalloonAdScriptApproval

export const ApproveBalloonAdScriptResponse = BalloonAdDraft


/**
 * Live's "Write it myself": eight empty sentences in their beats, three empty benefit
 * banners, the end card headed by the product's name; nothing generated.
 * `TEMPLATE_DRAFT_LOCKED` (409) as the write.
 * @summary Write Balloon Ad Blank
 */
export const WriteBalloonAdBlankParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const WriteBalloonAdBlankBody = BalloonAdBlankScript

export const WriteBalloonAdBlankResponse = BalloonAdDraft


/**
 * Live's wand: an uploaded packshot with no name or no text typed is read first
 * (`pack_director`; an unreadable one sets `pack_warning`), then the script director, up
 * to three tries each told the last answer's problems; the try with the fewest is kept,
 * with live's words on what the editor can still fix (`script_warning`).
 * @summary Write Balloon Ad Script
 */
export const WriteBalloonAdScriptParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const WriteBalloonAdScriptBody = BalloonAdScriptAsk

export const WriteBalloonAdScriptResponse = BalloonAdDraft


/**
 * Start over: an empty draft. `TEMPLATE_DRAFT_LOCKED` (409) while anything works.
 * @summary Reset Cartoon Character In The Real World Draft
 */
export const ResetCartoonCharacterInTheRealWorldDraftParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const ResetCartoonCharacterInTheRealWorldDraftResponse = CartoonDraft


/**
 * The member's draft, or an empty one: what the form opens with.
 * @summary Get Cartoon Character In The Real World Draft
 */
export const GetCartoonCharacterInTheRealWorldDraftParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const GetCartoonCharacterInTheRealWorldDraftResponse = CartoonDraft


/**
 * The form as it stands and its script as edited. `TEMPLATE_DRAFT_LOCKED` (409) while
 * a director works or once the script is approved.
 * @summary Write Cartoon Character In The Real World Draft
 */
export const WriteCartoonCharacterInTheRealWorldDraftParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const WriteCartoonCharacterInTheRealWorldDraftBody = CartoonDraftWrite

export const WriteCartoonCharacterInTheRealWorldDraftResponse = CartoonDraft


/**
 * Approve script: eleven lines on the fixed speakers, the hero's super at most eight
 * words, 80 to 120 words, no on-screen line past 4.5 s, every lock filled with a hex color
 * in the creature's (422 at `script` in its words); then the stills with no source, the
 * sheets, the room master and the product sheet, each other still once those it is drawn
 * from are done.
 * @summary Approve Cartoon Character In The Real World Script
 */
export const ApproveCartoonCharacterInTheRealWorldScriptParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const ApproveCartoonCharacterInTheRealWorldScriptBody = CartoonApproval

export const ApproveCartoonCharacterInTheRealWorldScriptResponse = CartoonDraft


/**
 * Generate script: an uploaded packshot with no name or no text typed is read first
 * (`pack_director`; an unreadable one sets `pack_warning`), then the script director. A
 * script Approve would refuse is redone once, then kept with that problem
 * (`script_problems`).
 * @summary Write Cartoon Character In The Real World Script
 */
export const WriteCartoonCharacterInTheRealWorldScriptParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const WriteCartoonCharacterInTheRealWorldScriptBody = CartoonScriptAsk

export const WriteCartoonCharacterInTheRealWorldScriptResponse = CartoonDraft


/**
 * Regenerate a still: it and every still drawn from it drawn again (a shot draws the
 * later shots again), each a paid image as the first was. `TEMPLATE_DRAFT_LOCKED` (409)
 * before the stills or while anything works.
 * @summary Regenerate Cartoon Character In The Real World Still
 */
export const RegenerateCartoonCharacterInTheRealWorldStillParams = zod.object({
  "name": zod.enum(['creature_sheet', 'scale_plate', 'woman_sheet', 'room_master', 'product_sheet', 's1', 's2', 's3', 's4', 's5', 's6', 's7', 's8', 's9', 's10', 's11']),
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const RegenerateCartoonCharacterInTheRealWorldStillResponse = CartoonDraft


/**
 * Start over: an empty draft. `TEMPLATE_DRAFT_LOCKED` (409) while anything works.
 * @summary Reset Cartoon Clone Draft
 */
export const ResetCartoonCloneDraftParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const ResetCartoonCloneDraftResponse = CartoonCloneDraft


/**
 * The member's draft, or an empty one: what the form opens with.
 * @summary Get Cartoon Clone Draft
 */
export const GetCartoonCloneDraftParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const GetCartoonCloneDraftResponse = CartoonCloneDraft


/**
 * The form as it stands and its script as edited. `TEMPLATE_DRAFT_LOCKED` (409) while
 * a step works or once the script is approved.
 * @summary Write Cartoon Clone Draft
 */
export const WriteCartoonCloneDraftParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const WriteCartoonCloneDraftBody = CartoonCloneDraftWrite

export const WriteCartoonCloneDraftResponse = CartoonCloneDraft


/**
 * Approve script: the line, the locks, the pack, the set and the voice (422 at
 * `script`); then the cast, paid pictures, and the voice's design.
 * @summary Approve Cartoon Clone Script
 */
export const ApproveCartoonCloneScriptParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const ApproveCartoonCloneScriptBody = CartoonCloneApproval

export const ApproveCartoonCloneScriptResponse = CartoonCloneDraft


/**
 * Generate Script: the product, the source ad and the rights checked (422 at each); an
 * uploaded packshot with no name or no text read first; the source ad read where the draft
 * has no reading of it (`reading_director`); then the clone director, its script off the
 * source or its page redone once, then kept with its problems (`script_problems`).
 * @summary Write Cartoon Clone Script
 */
export const WriteCartoonCloneScriptParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const WriteCartoonCloneScriptBody = CartoonCloneScriptAsk

export const WriteCartoonCloneScriptResponse = CartoonCloneDraft


/**
 * A still of the cast drawn again with every still drawn from it, or `voice` designed
 * again. 404 for a name the cast lacks; `TEMPLATE_DRAFT_LOCKED` (409) before the cast or
 * while anything works.
 * @summary Regenerate Cartoon Clone Still
 */
export const RegenerateCartoonCloneStillParams = zod.object({
  "name": zod.string(),
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const RegenerateCartoonCloneStillResponse = CartoonCloneDraft


/**
 * Start over: an empty draft. `TEMPLATE_DRAFT_LOCKED` (409) while anything works.
 * @summary Reset Cartoon Villain Ad Draft
 */
export const ResetCartoonVillainAdDraftParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const ResetCartoonVillainAdDraftResponse = CartoonVillainDraft


/**
 * The member's draft, or an empty one: what the form opens with.
 * @summary Get Cartoon Villain Ad Draft
 */
export const GetCartoonVillainAdDraftParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const GetCartoonVillainAdDraftResponse = CartoonVillainDraft


/**
 * The form as it stands and its script as edited. `TEMPLATE_DRAFT_LOCKED` (409) while
 * a director works or once the script is approved.
 * @summary Write Cartoon Villain Ad Draft
 */
export const WriteCartoonVillainAdDraftParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const WriteCartoonVillainAdDraftBody = CartoonVillainDraftWrite

export const WriteCartoonVillainAdDraftResponse = CartoonVillainDraft


/**
 * Approve script: every value given, the brag 10 to 14 words and the colours hex (422
 * at `script` in our words); then the stills: the sheet, the home plate and the end card
 * at once, `s1` and `s2` as their pictures are done.
 * @summary Approve Cartoon Villain Ad Script
 */
export const ApproveCartoonVillainAdScriptParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const ApproveCartoonVillainAdScriptBody = CartoonVillainApproval

export const ApproveCartoonVillainAdScriptResponse = CartoonVillainDraft


/**
 * Generate script: an uploaded packshot with no name or no text typed is read first
 * (`pack_director`; an unreadable one sets `pack_warning`), then the script director,
 * shown the packshot, fills every value of the playbook's locks and lines.
 * @summary Write Cartoon Villain Ad Script
 */
export const WriteCartoonVillainAdScriptParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const WriteCartoonVillainAdScriptBody = CartoonVillainScriptAsk

export const WriteCartoonVillainAdScriptResponse = CartoonVillainDraft


/**
 * A still and every still drawn from it drawn again, each a paid image as the first
 * was. `TEMPLATE_DRAFT_LOCKED` (409) before the stills or while anything works.
 * @summary Regenerate Cartoon Villain Ad Still
 */
export const RegenerateCartoonVillainAdStillParams = zod.object({
  "name": zod.enum(['sheet', 'home', 's1', 's2', 'end_card']),
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const RegenerateCartoonVillainAdStillResponse = CartoonVillainDraft


/**
 * Start over: an empty draft. `TEMPLATE_DRAFT_LOCKED` (409) while anything works.
 * @summary Reset Chalk Explainer Ad Draft
 */
export const ResetChalkExplainerAdDraftParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const ResetChalkExplainerAdDraftResponse = ChalkExplainerAdDraft


/**
 * The member's draft, or an empty one: what the form opens with.
 * @summary Get Chalk Explainer Ad Draft
 */
export const GetChalkExplainerAdDraftParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const GetChalkExplainerAdDraftResponse = ChalkExplainerAdDraft


/**
 * The form as it stands and its script as edited, the script's problems read again.
 * `TEMPLATE_DRAFT_LOCKED` (409) while a director works or once the script is approved.
 * @summary Write Chalk Explainer Ad Draft
 */
export const WriteChalkExplainerAdDraftParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const WriteChalkExplainerAdDraftBody = ChalkExplainerAdDraftWrite

export const WriteChalkExplainerAdDraftResponse = ChalkExplainerAdDraft


/**
 * Live's Approve script: its ten lines, each written and said, a board part on every
 * line but the last, the end card's headline and button (422 at `script` with live's
 * words); then the blank board, the end card and the board director. A board off the
 * script is asked once more, then refused (`problem`), the draft back at its script. A kept
 * board starts the three boards, each as the one before is done.
 * @summary Approve Chalk Explainer Ad Script
 */
export const ApproveChalkExplainerAdScriptParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const ApproveChalkExplainerAdScriptBody = ChalkExplainerAdApproval

export const ApproveChalkExplainerAdScriptResponse = ChalkExplainerAdDraft


/**
 * Live's "Back to script": the board and the stills forgotten. `TEMPLATE_DRAFT_LOCKED`
 * (409) before approval or while anything works.
 * @summary Back To Chalk Explainer Ad Script
 */
export const BackToChalkExplainerAdScriptParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const BackToChalkExplainerAdScriptResponse = ChalkExplainerAdDraft


/**
 * Live's Generate Script: an uploaded packshot with no name or no text typed is read
 * first, then the script director, up to three tries, each told what the last one failed;
 * the try with the fewest problems is kept with them (`script_warning`,
 * `script_problems`). An empty CTA chip takes the script's button.
 * @summary Write Chalk Explainer Ad Script
 */
export const WriteChalkExplainerAdScriptParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const WriteChalkExplainerAdScriptBody = ChalkExplainerAdScriptAsk

export const WriteChalkExplainerAdScriptResponse = ChalkExplainerAdDraft


/**
 * Live's ↻ on a still: it and every still drawn from it drawn again, each a paid image
 * as the first was. `TEMPLATE_DRAFT_LOCKED` (409) before the still is asked, or while
 * anything works.
 * @summary Regenerate Chalk Explainer Ad Still
 */
export const RegenerateChalkExplainerAdStillParams = zod.object({
  "name": zod.enum(['board0', 'end_a', 'end_b', 'end_c', 'end_card']),
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const RegenerateChalkExplainerAdStillResponse = ChalkExplainerAdDraft


/**
 * Start over: an empty draft. `TEMPLATE_DRAFT_LOCKED` (409) while anything works.
 * @summary Reset Claymation Ad Draft
 */
export const ResetClaymationAdDraftParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const ResetClaymationAdDraftResponse = ClaymationAdDraft


/**
 * The member's draft, or an empty one: what the form opens with.
 * @summary Get Claymation Ad Draft
 */
export const GetClaymationAdDraftParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const GetClaymationAdDraftResponse = ClaymationAdDraft


/**
 * The form as it stands and its script as edited, what is off in it checked again
 * (`script_problems`). `TEMPLATE_DRAFT_LOCKED` (409) while a step works or once the script
 * is approved, as live locks the form.
 * @summary Write Claymation Ad Draft
 */
export const WriteClaymationAdDraftParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const WriteClaymationAdDraftBody = ClaymationAdDraftWrite

export const WriteClaymationAdDraftResponse = ClaymationAdDraft


/**
 * Live's Approve script: a narrator (422 at `inputs.narrator`) and live's gate on the
 * script (422 at `script` with live's words), then the script approved, the stage the
 * voice's, and three takes of the voiceover, each made, heard in English and checked.
 * @summary Approve Claymation Ad Script
 */
export const ApproveClaymationAdScriptParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const ApproveClaymationAdScriptBody = ClaymationAdScriptApproval

export const ApproveClaymationAdScriptResponse = ClaymationAdDraft


/**
 * Live's Approve voice: the picked take's shot plan (422 at `take` with live's words for
 * a take not made or not checked, one with a line not heard, or one the shots do not fit),
 * the stage the storyboard's. `TEMPLATE_DRAFT_LOCKED` (409) outside the voice or while a
 * take works.
 * @summary Approve Claymation Ad Voice
 */
export const ApproveClaymationAdVoiceParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const ApproveClaymationAdVoiceBody = ClaymationAdVoiceApproval

export const ApproveClaymationAdVoiceResponse = ClaymationAdDraft


/**
 * Live's Back to voice: the plan forgotten, the takes kept. `TEMPLATE_DRAFT_LOCKED`
 * (409) outside the storyboard.
 * @summary Back To Claymation Ad Voice
 */
export const BackToClaymationAdVoiceParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const BackToClaymationAdVoiceResponse = ClaymationAdDraft


/**
 * Live's Retry the shot director, once it failed for good: a new ask of three tries,
 * then the stills its spec needs, drawn anew. `TEMPLATE_DRAFT_LOCKED` (409) before the
 * script is approved, unless the shot director failed, or while anything works.
 * @summary Retry Claymation Ad Shot Director
 */
export const RetryClaymationAdShotDirectorParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const RetryClaymationAdShotDirectorResponse = ClaymationAdDraft


/**
 * Live's wand: an uploaded packshot with no name or no text typed is read first
 * (`pack_director`; an unreadable one sets `pack_warning`), then the script director, up
 * to three tries each told the last one's problems; the try with the fewest is kept, with
 * live's words when it is still off (`script_warning`, `script_problems`).
 * @summary Write Claymation Ad Script
 */
export const WriteClaymationAdScriptParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const WriteClaymationAdScriptBody = ClaymationAdScriptAsk

export const WriteClaymationAdScriptResponse = ClaymationAdDraft


/**
 * Live's ↻ on a still: it and every still drawn from it drawn again, each a paid image as
 * the first was. `TEMPLATE_DRAFT_LOCKED` (409) before the script is approved, for a still
 * the storyboard lacks (any but the end card before the spec), or while anything works,
 * the takes included.
 * @summary Regenerate Claymation Ad Still
 */
export const RegenerateClaymationAdStillParams = zod.object({
  "name": zod.enum(['end_card', 'sheet_character', 'product_sheet', 'plate_s1', 'plate_s2', 'plate_s3', 'shot_1', 'shot_2', 'shot_3', 'shot_4', 'shot_5', 'shot_6', 'shot_7', 'shot_8', 'shot_1_turn', 'shot_2_turn', 'shot_3_turn', 'shot_4_turn', 'shot_5_turn', 'shot_6_turn', 'shot_7_turn', 'shot_8_turn']),
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const RegenerateClaymationAdStillResponse = ClaymationAdDraft


/**
 * Live's "Add a take": one more take of the same text; at six, live's note instead.
 * `TEMPLATE_DRAFT_LOCKED` (409) outside the voice or while a take works.
 * @summary Add Claymation Ad Take
 */
export const AddClaymationAdTakeParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const AddClaymationAdTakeResponse = ClaymationAdDraft


/**
 * Start over: an empty draft. `TEMPLATE_DRAFT_LOCKED` (409) while anything works.
 * @summary Reset Flat Cartoon Draft
 */
export const ResetFlatCartoonDraftParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const ResetFlatCartoonDraftResponse = FlatCartoonDraft


/**
 * The member's draft, or an empty one: what the form opens with.
 * @summary Get Flat Cartoon Draft
 */
export const GetFlatCartoonDraftParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const GetFlatCartoonDraftResponse = FlatCartoonDraft


/**
 * The form as it stands and its script as edited. `TEMPLATE_DRAFT_LOCKED` (409) while
 * a director works or once the script is approved.
 * @summary Write Flat Cartoon Draft
 */
export const WriteFlatCartoonDraftParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const WriteFlatCartoonDraftBody = FlatCartoonDraftWrite

export const WriteFlatCartoonDraftResponse = FlatCartoonDraft


/**
 * Approve script: six lines in the beats' order, the prescription's opening, a hex color
 * in every lock, no line past 10 s and 45 to 80 words (422 at `script` in its words); then
 * the stills, the two character sheets first, each other still once those it is drawn
 * from are done.
 * @summary Approve Flat Cartoon Script
 */
export const ApproveFlatCartoonScriptParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const ApproveFlatCartoonScriptBody = FlatCartoonApproval

export const ApproveFlatCartoonScriptResponse = FlatCartoonDraft


/**
 * Generate script: the brand as said is needed (422 at `inputs.brand`); an uploaded
 * packshot with no name or no text typed is read first (`pack_director`; an unreadable one
 * sets `pack_warning`), then the script director. A script Approve would refuse is redone
 * once, then kept with that problem (`script_problems`).
 * @summary Write Flat Cartoon Script
 */
export const WriteFlatCartoonScriptParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const WriteFlatCartoonScriptBody = FlatCartoonScriptAsk

export const WriteFlatCartoonScriptResponse = FlatCartoonDraft


/**
 * Regenerate a still: it and every still drawn from it drawn again, each a paid image
 * as the first was. `TEMPLATE_DRAFT_LOCKED` (409) before the stills or while anything
 * works.
 * @summary Regenerate Flat Cartoon Still
 */
export const RegenerateFlatCartoonStillParams = zod.object({
  "name": zod.enum(['host_sheet', 'caller_sheet', 'studio', 'car', 'metaphor', 'prescribe', 'closeup', 'hero']),
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const RegenerateFlatCartoonStillResponse = FlatCartoonDraft


/**
 * Start over: an empty draft. `TEMPLATE_DRAFT_LOCKED` (409) while anything works.
 * @summary Reset Green Screen Ad Draft
 */
export const ResetGreenScreenAdDraftParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const ResetGreenScreenAdDraftResponse = GreenScreenDraft


/**
 * The member's draft, or an empty one: what the form opens with.
 * @summary Get Green Screen Ad Draft
 */
export const GetGreenScreenAdDraftParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const GetGreenScreenAdDraftResponse = GreenScreenDraft


/**
 * The form as it stands and its script as edited, what is off in it checked again on
 * the picked clip model (`script_problems`). `TEMPLATE_DRAFT_LOCKED` (409) while the
 * director works, as live locks the form.
 * @summary Write Green Screen Ad Draft
 */
export const WriteGreenScreenAdDraftParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const WriteGreenScreenAdDraftBody = GreenScreenDraftWrite

export const WriteGreenScreenAdDraftResponse = GreenScreenDraft


/**
 * Live's "Approve script": approval 1's issues refused at `script` in live's words (422);
 * then the images: the creator (from the look, or recreated from the picked person) and
 * the card at once, the three poses from the creator. Each card is read back against the
 * approved title and lines, up to three; the first that reads exactly is kept, else the
 * one with the fewest problems (`card_check`).
 * @summary Approve Green Screen Ad Script
 */
export const ApproveGreenScreenAdScriptParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const ApproveGreenScreenAdScriptBody = GreenScreenApproval

export const ApproveGreenScreenAdScriptResponse = GreenScreenDraft


/**
 * Live's "Approve and generate final video" while revising: approval 1's issues, then a
 * change outside the refused clips' lines and beats, refused at `script` in live's words
 * (422); the images kept. The form then starts the run with the kept clips' `takes`.
 * `TEMPLATE_DRAFT_LOCKED` (409) unless revising, or while anything works.
 * @summary Approve Green Screen Ad Revision
 */
export const ApproveGreenScreenAdRevisionParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const ApproveGreenScreenAdRevisionBody = GreenScreenApproval

export const ApproveGreenScreenAdRevisionResponse = GreenScreenDraft


/**
 * Live's "Back to script": every image forgotten, the script open again.
 * `TEMPLATE_DRAFT_LOCKED` (409) before approval or while anything works.
 * @summary Back To Green Screen Ad Script
 */
export const BackToGreenScreenAdScriptParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const BackToGreenScreenAdScriptResponse = GreenScreenDraft


/**
 * Live's Revise, after a run whose video model refused a talking clip (the draft's
 * `run.refused`): the script open again with only those clips' lines and beats to change,
 * the images and the other clips kept. `TEMPLATE_DRAFT_LOCKED` (409) with no such run,
 * before approval or while anything works.
 * @summary Revise Green Screen Ad Clips
 */
export const ReviseGreenScreenAdClipsParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const ReviseGreenScreenAdClipsResponse = GreenScreenDraft


/**
 * Live's "Generate script": the script director, shown the packshot and the picked
 * person, up to three tries each told what the last one failed; the try with the fewest
 * problems is kept, with live's words when it is still off or its slogan was written from
 * the page (`script_warnings`, `script_problems`). A person not the team's ready picture,
 * or an actor that does not exist, is refused at `inputs.creator`.
 * @summary Write Green Screen Ad Script
 */
export const WriteGreenScreenAdScriptParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const WriteGreenScreenAdScriptBody = GreenScreenScriptAsk

export const WriteGreenScreenAdScriptResponse = GreenScreenDraft


/**
 * Live's ↻ on a still (`GreenScreenStillName`; any other name is not found): the
 * creator with the poses drawn from it, a pose alone, or the card's three tries again;
 * each a paid image as the first was. `TEMPLATE_DRAFT_LOCKED` (409) before approval or
 * while anything works.
 * @summary Regenerate Green Screen Ad Still
 */
export const RegenerateGreenScreenAdStillParams = zod.object({
  "name": zod.string(),
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const RegenerateGreenScreenAdStillResponse = GreenScreenDraft


/**
 * Start over: an empty draft. `TEMPLATE_DRAFT_LOCKED` (409) while anything works.
 * @summary Reset Grwm Draft
 */
export const ResetGrwmDraftParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const ResetGrwmDraftResponse = GrwmDraft


/**
 * The member's draft, or an empty one with the playbook's approved locks written in:
 * what the form opens with.
 * @summary Get Grwm Draft
 */
export const GetGrwmDraftParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const GetGrwmDraftResponse = GrwmDraft


/**
 * The form as it stands and its script as edited. `TEMPLATE_DRAFT_LOCKED` (409) while
 * the director works or once the script is approved.
 * @summary Write Grwm Draft
 */
export const WriteGrwmDraftParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const WriteGrwmDraftBody = GrwmDraftWrite

export const WriteGrwmDraftResponse = GrwmDraft


/**
 * Approve script: its ten beats in order, each a line of at most 14 words, 50 to 95
 * words in all and an entryway action (422 at `script` with the reason); then the stills
 * from their roots, each as its sources are done.
 * @summary Approve Grwm Script
 */
export const ApproveGrwmScriptParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const ApproveGrwmScriptBody = GrwmApproval

export const ApproveGrwmScriptResponse = GrwmDraft


/**
 * Generate script: the director on the product, shown its picture. An answer missing a
 * beat is redone once, then fails (`problem`); a kept one carries what is still off
 * (`script_problems`).
 * @summary Write Grwm Script
 */
export const WriteGrwmScriptParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const WriteGrwmScriptBody = GrwmScriptAsk

export const WriteGrwmScriptResponse = GrwmDraft


/**
 * ↻ on a still: it and every still drawn from it drawn again, each a paid image as the
 * first was. `TEMPLATE_DRAFT_LOCKED` (409) before the stills, or while anything works.
 * @summary Regenerate Grwm Still
 */
export const RegenerateGrwmStillParams = zod.object({
  "name": zod.enum(['img1', 'img2c', 'img3c', 'img2', 'img3', 'dress', 'body', 'wear_front', 'wear_side', 'img4', 'img5', 'door', 'img6s', 'rest_plate', 'img7r', 'img8r']),
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const RegenerateGrwmStillResponse = GrwmDraft


/**
 * Start over: an empty draft. `TEMPLATE_DRAFT_LOCKED` (409) while anything works.
 * @summary Reset Hot Seat Ad Draft
 */
export const ResetHotSeatAdDraftParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const ResetHotSeatAdDraftResponse = TwoSpeakerDraft


/**
 * The member's draft, or an empty one: what the form opens with.
 * @summary Get Hot Seat Ad Draft
 */
export const GetHotSeatAdDraftParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const GetHotSeatAdDraftResponse = TwoSpeakerDraft


/**
 * The form as it stands and its script as edited. `TEMPLATE_DRAFT_LOCKED` (409) while
 * the director works or once the script is approved.
 * @summary Write Hot Seat Ad Draft
 */
export const WriteHotSeatAdDraftParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const WriteHotSeatAdDraftBody = TwoSpeakerDraftWrite

export const WriteHotSeatAdDraftResponse = TwoSpeakerDraft


/**
 * Approve script: the script checked (422 at `script` with the check's words, at
 * `inputs.wordmark` without one), approved, and the three stills started, each a paid
 * image: each speaker's picture and the end card's.
 * @summary Approve Hot Seat Ad Script
 */
export const ApproveHotSeatAdScriptParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const ApproveHotSeatAdScriptBody = TwoSpeakerApproval

export const ApproveHotSeatAdScriptResponse = TwoSpeakerDraft


/**
 * Generate script: the script director on the product's texts (a product and its
 * packshot first, and the brand's name, 422). An answer the check refuses is redone once,
 * then kept with the check's words in `script_problems`.
 * @summary Write Hot Seat Ad Script
 */
export const WriteHotSeatAdScriptParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const WriteHotSeatAdScriptBody = TwoSpeakerScriptAsk

export const WriteHotSeatAdScriptResponse = TwoSpeakerDraft


/**
 * ↻ on a still (a speaker's id, or `end_card`): it drawn again, a paid image as the
 * first was. 404 for a still the card has none of; `TEMPLATE_DRAFT_LOCKED` (409) before
 * the stills or while anything works.
 * @summary Regenerate Hot Seat Ad Still
 */
export const regenerateHotSeatAdStillPathNameMax = 20;



export const RegenerateHotSeatAdStillParams = zod.object({
  "name": zod.string().max(regenerateHotSeatAdStillPathNameMax),
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const RegenerateHotSeatAdStillResponse = TwoSpeakerDraft


/**
 * Start over: an empty draft. `TEMPLATE_DRAFT_LOCKED` (409) while anything works.
 * @summary Reset Pixar Singing Ad Draft
 */
export const ResetPixarSingingAdDraftParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const ResetPixarSingingAdDraftResponse = PixarSingingAdDraft


/**
 * The member's draft, or an empty one: what the form opens with.
 * @summary Get Pixar Singing Ad Draft
 */
export const GetPixarSingingAdDraftParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const GetPixarSingingAdDraftResponse = PixarSingingAdDraft


/**
 * The form as it stands and its lyrics as edited. `TEMPLATE_DRAFT_LOCKED` (409) while
 * a step works or once the lyrics are approved, as live locks the form.
 * @summary Write Pixar Singing Ad Draft
 */
export const WritePixarSingingAdDraftParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const WritePixarSingingAdDraftBody = PixarSingingAdDraftWrite

export const WritePixarSingingAdDraftResponse = PixarSingingAdDraft


/**
 * Live's Approve lyrics: six lines, each with its text, a punch line and a button
 * (422 at `lyrics` with live's words), approved; then three takes of the song, each made,
 * heard in English and checked; three more when fewer than two pass.
 * @summary Approve Pixar Singing Ad Lyrics
 */
export const ApprovePixarSingingAdLyricsParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const ApprovePixarSingingAdLyricsBody = PixarSingingAdLyricsApproval

export const ApprovePixarSingingAdLyricsResponse = PixarSingingAdDraft


/**
 * Live's Approve song: the picked take's shot plan (422 at `take` with live's words for
 * a take not made, not checked, or with a sung line not heard), then the shot director and
 * the end card; once the spec keeps to the plan, the character sheet and each shot. A spec
 * that breaks the plan is redone once, then refused (`problem`) and the draft goes back to
 * the song.
 * @summary Approve Pixar Singing Ad Song
 */
export const ApprovePixarSingingAdSongParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const ApprovePixarSingingAdSongBody = PixarSingingAdSongApproval

export const ApprovePixarSingingAdSongResponse = PixarSingingAdDraft


/**
 * Back to the lyrics, the takes forgotten (ours: live's notes ask for it).
 * `TEMPLATE_DRAFT_LOCKED` (409) before the song or while anything works.
 * @summary Back To Pixar Singing Ad Lyrics
 */
export const BackToPixarSingingAdLyricsParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const BackToPixarSingingAdLyricsResponse = PixarSingingAdDraft


/**
 * Live's Back to takes: the plan and the stills forgotten, the takes kept.
 * `TEMPLATE_DRAFT_LOCKED` (409) outside the cast or while anything works.
 * @summary Back To Pixar Singing Ad Takes
 */
export const BackToPixarSingingAdTakesParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const BackToPixarSingingAdTakesResponse = PixarSingingAdDraft


/**
 * Live's wand: an uploaded packshot with no name or no text typed is read first
 * (`pack_director`; an unreadable one sets `pack_warning`), then the lyrics director;
 * lyrics off live's rules are redone once, then kept with live's words
 * (`lyrics_warning`).
 * @summary Write Pixar Singing Ad Lyrics
 */
export const WritePixarSingingAdLyricsParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const WritePixarSingingAdLyricsBody = PixarSingingAdLyricsAsk

export const WritePixarSingingAdLyricsResponse = PixarSingingAdDraft


/**
 * Live's ↻ on a still: it and every still drawn from it drawn again, each a paid image as
 * the first was. `TEMPLATE_DRAFT_LOCKED` (409) outside the cast, for a still the plan
 * lacks, before the spec for a still that needs it, or while anything works.
 * @summary Regenerate Pixar Singing Ad Still
 */
export const RegeneratePixarSingingAdStillParams = zod.object({
  "name": zod.enum(['char_sheet', 'shot_1', 'shot_2', 'shot_3', 'end_card']),
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const RegeneratePixarSingingAdStillResponse = PixarSingingAdDraft


/**
 * Live's "+": one more take with the same prompt; at six, live's note instead.
 * `TEMPLATE_DRAFT_LOCKED` (409) before the song or while anything works.
 * @summary Add Pixar Singing Ad Take
 */
export const AddPixarSingingAdTakeParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const AddPixarSingingAdTakeResponse = PixarSingingAdDraft


/**
 * Start over: an empty draft. `TEMPLATE_DRAFT_LOCKED` (409) while anything works.
 * @summary Reset Pixar Talking Ad Draft
 */
export const ResetPixarTalkingAdDraftParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const ResetPixarTalkingAdDraftResponse = PixarTalkingAdDraft


/**
 * The member's draft, or an empty one: what the form opens with.
 * @summary Get Pixar Talking Ad Draft
 */
export const GetPixarTalkingAdDraftParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const GetPixarTalkingAdDraftResponse = PixarTalkingAdDraft


/**
 * The form as it stands and its script as edited. `TEMPLATE_DRAFT_LOCKED` (409) while
 * a director works or once the script is approved, as live locks the form.
 * @summary Write Pixar Talking Ad Draft
 */
export const WritePixarTalkingAdDraftParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const WritePixarTalkingAdDraftBody = PixarTalkingAdDraftWrite

export const WritePixarTalkingAdDraftResponse = PixarTalkingAdDraft


/**
 * Live's Approve script: its 8 lines in their beats, each with its text (422 at
 * `script` with live's words), approved; then the shot director. A spec that breaks the
 * script or its schema is redone once, then refused (`problem`), the draft back at its
 * script. A kept spec starts the stills: the character chain, each as the one before is
 * done, and with the end card on, the end card beside the sheet.
 * @summary Approve Pixar Talking Ad Script
 */
export const ApprovePixarTalkingAdScriptParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const ApprovePixarTalkingAdScriptBody = PixarTalkingAdApproval

export const ApprovePixarTalkingAdScriptResponse = PixarTalkingAdDraft


/**
 * Live's Generate Script: an uploaded packshot with no name or no text typed is read
 * first (`pack_director`; an unreadable one sets `pack_warning`), then the script
 * director; a script off its beats or quoting off the product text is redone once, then
 * kept with what is still off (`script_problems`). An empty Problem chip takes the
 * script's problem.
 * @summary Write Pixar Talking Ad Script
 */
export const WritePixarTalkingAdScriptParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const WritePixarTalkingAdScriptBody = PixarTalkingAdScriptAsk

export const WritePixarTalkingAdScriptResponse = PixarTalkingAdDraft


/**
 * Live's ↻ on a still: it and every still drawn from it drawn again, each a paid image
 * as the first was. `TEMPLATE_DRAFT_LOCKED` (409) before the stills, for the end card with
 * the end card off, or while anything works.
 * @summary Regenerate Pixar Talking Ad Still
 */
export const RegeneratePixarTalkingAdStillParams = zod.object({
  "name": zod.enum(['char_sheet', 'opening', 'hold', 'closing', 'end_card']),
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const RegeneratePixarTalkingAdStillResponse = PixarTalkingAdDraft


/**
 * Start over: an empty draft. `TEMPLATE_DRAFT_LOCKED` (409) while anything works.
 * @summary Reset Pixar Whiteboard Ad Draft
 */
export const ResetPixarWhiteboardAdDraftParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const ResetPixarWhiteboardAdDraftResponse = PixarWhiteboardAdDraft


/**
 * The member's draft, or an empty one: what the form opens with.
 * @summary Get Pixar Whiteboard Ad Draft
 */
export const GetPixarWhiteboardAdDraftParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const GetPixarWhiteboardAdDraftResponse = PixarWhiteboardAdDraft


/**
 * The form as it stands and its script as edited ("Write the 10 lines yourself" sends
 * the blank one). `TEMPLATE_DRAFT_LOCKED` (409) while a director works or once the script
 * is approved, as live locks the form.
 * @summary Write Pixar Whiteboard Ad Draft
 */
export const WritePixarWhiteboardAdDraftParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const WritePixarWhiteboardAdDraftBody = PixarWhiteboardAdDraftWrite

export const WritePixarWhiteboardAdDraftResponse = PixarWhiteboardAdDraft


/**
 * Live's Approve script: its gate (422 at `script` in live's words), then the character
 * sheet and the end card at once and the board director. A spec off its schema or check
 * is asked once more, then refused (`problem`), the draft back at its script. A kept spec
 * starts the board stills, each when its sources are done.
 * @summary Approve Pixar Whiteboard Ad Script
 */
export const ApprovePixarWhiteboardAdScriptParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const ApprovePixarWhiteboardAdScriptBody = PixarWhiteboardAdApproval

export const ApprovePixarWhiteboardAdScriptResponse = PixarWhiteboardAdDraft


/**
 * Live's Generate Script: an uploaded packshot with no name or no text typed is read
 * first, then the script director; a script with problems is asked once more, then kept
 * with live's warning (`script_warning`). Empty Problem and CTA chips take the
 * director's.
 * @summary Write Pixar Whiteboard Ad Script
 */
export const WritePixarWhiteboardAdScriptParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const WritePixarWhiteboardAdScriptBody = PixarWhiteboardAdScriptAsk

export const WritePixarWhiteboardAdScriptResponse = PixarWhiteboardAdDraft


/**
 * Live's "Shoot the clips": with every still done (else 422 in live's words), each
 * talking clip's takes and the end card's at once, each a paid clip; each delivered
 * talking take is heard and checked, and once none works each clip's best take is picked.
 * `TEMPLATE_DRAFT_LOCKED` (409) before the board spec, once shot, or while anything
 * works.
 * @summary Approve Pixar Whiteboard Ad Storyboard
 */
export const ApprovePixarWhiteboardAdStoryboardParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const ApprovePixarWhiteboardAdStoryboardBody = PixarWhiteboardAdShoot

export const ApprovePixarWhiteboardAdStoryboardResponse = PixarWhiteboardAdDraft


/**
 * Live's ↻ on a still: it and every still drawn from it drawn again, each a paid image
 * as the first was. `TEMPLATE_DRAFT_LOCKED` (409) before the board spec, or while anything
 * works.
 * @summary Regenerate Pixar Whiteboard Ad Still
 */
export const RegeneratePixarWhiteboardAdStillParams = zod.object({
  "name": zod.enum(['sheet', 'master_board', 'char_ref', 'opening', 'anchor_a', 'anchor_b', 'anchor_c', 'end_card']),
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const RegeneratePixarWhiteboardAdStillResponse = PixarWhiteboardAdDraft


/**
 * Live's New take: one more paid take of the clip, picked only where the clip had no
 * finished take. `TEMPLATE_DRAFT_LOCKED` (409) before the shoot or while a take works.
 * @summary Write Pixar Whiteboard Ad Take
 */
export const WritePixarWhiteboardAdTakeParams = zod.object({
  "clip": zod.enum(['A', 'B', 'C', 'end_card']),
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const WritePixarWhiteboardAdTakeResponse = PixarWhiteboardAdDraft


/**
 * Live's radio: a finished take of the clip picked (422 at `take` for any other).
 * `TEMPLATE_DRAFT_LOCKED` (409) before the shoot or while a take works.
 * @summary Write Pixar Whiteboard Ad Pick
 */
export const WritePixarWhiteboardAdPickParams = zod.object({
  "clip": zod.enum(['A', 'B', 'C', 'end_card']),
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const WritePixarWhiteboardAdPickBody = PixarWhiteboardAdPick

export const WritePixarWhiteboardAdPickResponse = PixarWhiteboardAdDraft


/**
 * Start over: an empty draft. A director still running changes nothing once it ends.
 * @summary Reset Podcast Ad Draft
 */
export const ResetPodcastAdDraftParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const ResetPodcastAdDraftResponse = PodcastAdDraft


/**
 * The member's draft, or an empty one: what the form opens with.
 * @summary Get Podcast Ad Draft
 */
export const GetPodcastAdDraftParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const GetPodcastAdDraftResponse = PodcastAdDraft


/**
 * The form as it stands and its script as edited. `TEMPLATE_DRAFT_LOCKED` (409) while
 * a director works or once the script is approved, as live locks the form.
 * @summary Write Podcast Ad Draft
 */
export const WritePodcastAdDraftParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const WritePodcastAdDraftBody = PodcastAdDraftWrite

export const WritePodcastAdDraftResponse = PodcastAdDraft


/**
 * Live's Approve script: the script checked as live's form checks it (422 at `script`
 * with live's words), approved, and the shot director started. A spec that breaks the
 * script is redone once, then refused (`problem`) and the draft goes back to its
 * script.
 * @summary Approve Podcast Ad Script
 */
export const ApprovePodcastAdScriptParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const ApprovePodcastAdScriptBody = PodcastAdApproval

export const ApprovePodcastAdScriptResponse = PodcastAdDraft


/**
 * Live's Fix label: the master drawn again from itself and the packshot, its label
 * made the product's, and the close-ups drawn from it again. `TEMPLATE_DRAFT_LOCKED` (409)
 * unless the master is done and nothing works.
 * @summary Fix Podcast Ad Label
 */
export const FixPodcastAdLabelParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const FixPodcastAdLabelResponse = PodcastAdDraft


/**
 * Live's Generate script: the script director on the product's page (a product and
 * its packshot first, live's "Pick a product and its packshot", 422). Its answer fills
 * the draft when it ends: a claim not quoted from the page is redone once, then flagged
 * (`script_warning`).
 * @summary Write Podcast Ad Script
 */
export const WritePodcastAdScriptParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const WritePodcastAdScriptBody = PodcastAdScriptAsk

export const WritePodcastAdScriptResponse = PodcastAdDraft


/**
 * Live's ↻ on a cast still (`master`, `host_close`, `guest_close`, `guest_hold`,
 * `end_card`): it and every still drawn from it drawn again, each a paid image as the
 * first was. `TEMPLATE_DRAFT_LOCKED` (409) before the cast or while anything works.
 * @summary Regenerate Podcast Ad Still
 */
export const RegeneratePodcastAdStillParams = zod.object({
  "name": zod.enum(['master', 'host_close', 'guest_close', 'guest_hold', 'end_card']),
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const RegeneratePodcastAdStillResponse = PodcastAdDraft


/**
 * Start over: an empty draft. `TEMPLATE_DRAFT_LOCKED` (409) while anything works.
 * @summary Reset Street Interview Ad Draft
 */
export const ResetStreetInterviewAdDraftParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const ResetStreetInterviewAdDraftResponse = StreetInterviewAdDraft


/**
 * The member's draft, or an empty one: what the form opens with.
 * @summary Get Street Interview Ad Draft
 */
export const GetStreetInterviewAdDraftParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const GetStreetInterviewAdDraftResponse = StreetInterviewAdDraft


/**
 * The form as it stands and its script as edited. `TEMPLATE_DRAFT_LOCKED` (409) while
 * a director works or once the script is approved, as live locks the form.
 * @summary Write Street Interview Ad Draft
 */
export const WriteStreetInterviewAdDraftParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const WriteStreetInterviewAdDraftBody = StreetInterviewAdDraftWrite

export const WriteStreetInterviewAdDraftResponse = StreetInterviewAdDraft


/**
 * Live's Approve script: its 17 lines in their beats, each with its text (422 at
 * `script` with live's words), approved; the shot director, then the location and the
 * five people. A spec that breaks the script is redone once, then refused (`problem`).
 * @summary Approve Street Interview Ad Script
 */
export const ApproveStreetInterviewAdScriptParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const ApproveStreetInterviewAdScriptBody = StreetInterviewAdApproval

export const ApproveStreetInterviewAdScriptResponse = StreetInterviewAdDraft


/**
 * Live's Approve cast: the keyframes, each as the stills it is drawn from are done.
 * `TEMPLATE_DRAFT_LOCKED` (409) until the location and the five people are.
 * @summary Approve Street Interview Ad Cast
 */
export const ApproveStreetInterviewAdCastParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const ApproveStreetInterviewAdCastResponse = StreetInterviewAdDraft


/**
 * Live's Generate Script: an uploaded packshot with no name or no text typed is read
 * first (`pack_director`; an unreadable one sets `pack_warning`), then the script
 * director; a script off its beats or quoting off the product text is redone once, then
 * flagged (`script_warning`).
 * @summary Write Street Interview Ad Script
 */
export const WriteStreetInterviewAdScriptParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const WriteStreetInterviewAdScriptBody = StreetInterviewAdScriptAsk

export const WriteStreetInterviewAdScriptResponse = StreetInterviewAdDraft


/**
 * Live's ↻ on a still: it and every still drawn from it in the stage drawn again,
 * each a paid image as the first was. `TEMPLATE_DRAFT_LOCKED` (409) before the cast, for
 * a keyframe before Approve cast, or while anything works.
 * @summary Regenerate Street Interview Ad Still
 */
export const RegenerateStreetInterviewAdStillParams = zod.object({
  "name": zod.enum(['street', 'sheet_int', 'sheet_p1', 'sheet_p2', 'sheet_p3', 'sheet_p4', 'two_1', 'single_2', 'single_3', 'single_4', 'handover_3', 'hold_2', 'hold_1', 'two_3_hold', 'hold_3', 'signoff', 'end_card']),
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const RegenerateStreetInterviewAdStillResponse = StreetInterviewAdDraft


/**
 * Start over: an empty draft. `TEMPLATE_DRAFT_LOCKED` (409) while a director works.
 * @summary Reset Yapper Ad Draft
 */
export const ResetYapperAdDraftParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const ResetYapperAdDraftResponse = YapperAdDraft


/**
 * The member's draft, or an empty one: what the form opens with.
 * @summary Get Yapper Ad Draft
 */
export const GetYapperAdDraftParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const GetYapperAdDraftResponse = YapperAdDraft


/**
 * The form as it stands and its script as edited, the script's problems read again.
 * `TEMPLATE_DRAFT_LOCKED` (409) while a director works, as live locks the form.
 * @summary Write Yapper Ad Draft
 */
export const WriteYapperAdDraftParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const WriteYapperAdDraftBody = YapperAdDraftWrite

export const WriteYapperAdDraftResponse = YapperAdDraft


/**
 * Live's approval 1: the script checked (422 at `script` in live's words: 4 to 10
 * clips, none empty, the first a talk clip), kept, and the stage the stills'; then the
 * shot director: the locks, then the clip plan (2 tries each, the best kept), the product
 * settled. Either failing for good: `shot_director` `failed` with live's words, the
 * draft kept at its stills.
 * @summary Approve Yapper Ad Script
 */
export const ApproveYapperAdScriptParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const ApproveYapperAdScriptBody = YapperAdApproval

export const ApproveYapperAdScriptResponse = YapperAdDraft


/**
 * Live's Back to script: the script kept, the shot let go, the form open again.
 * `TEMPLATE_DRAFT_LOCKED` (409) before approval 1 or while anything works.
 * @summary Back To Yapper Ad Script
 */
export const BackToYapperAdScriptParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const BackToYapperAdScriptResponse = YapperAdDraft


/**
 * Live's ✦ Generate script: for Auto the setting director (2 tries), then the script
 * director (3 tries), each try told what the last failed; the try with the fewest failed
 * checks kept, with live's warning where it still fails (`script_warning`).
 * @summary Write Yapper Ad Script
 */
export const WriteYapperAdScriptParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const WriteYapperAdScriptBody = YapperAdScriptAsk

export const WriteYapperAdScriptResponse = YapperAdDraft


/**
 * Live's retry of a failed shot director: the locks asked again, then the clip plan.
 * `TEMPLATE_DRAFT_LOCKED` (409) unless the shot director failed and nothing works.
 * @summary Retry Yapper Ad Shot
 */
export const RetryYapperAdShotParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const RetryYapperAdShotResponse = YapperAdDraft


/**
 * Live's ↻ on a still: it and every still drawn from it drawn again, each a paid image
 * as the first was (a new sheet draws every clip's still again, the end card and the
 * bubble are drawn alone). `TEMPLATE_DRAFT_LOCKED` (409) before approval 1, for a still
 * the draft does not draw (yet), or while anything works.
 * @summary Regenerate Yapper Ad Still
 */
export const regenerateYapperAdStillPathNameRegExp = new RegExp('^(sheet|pet|end_card|bubble|[fi](10|[1-9]))$');


export const RegenerateYapperAdStillParams = zod.object({
  "name": zod.string().regex(regenerateYapperAdStillPathNameRegExp),
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const RegenerateYapperAdStillResponse = YapperAdDraft


/**
 * Announce a file: a pending asset and the form to post it to the bucket with. With
 * `folder_id` the file lands in that folder of the brand (live's project; 422 at it for any
 * other), and its complete counts the folder as the caller's use.
 * @summary Prepare Upload
 */
export const PrepareUploadParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const prepareUploadHeaderIdempotencyKeyMax = 255;



export const PrepareUploadHeader = zod.object({
  "Idempotency-Key": zod.string().min(1).max(prepareUploadHeaderIdempotencyKeyMax)
})

export const PrepareUploadBody = UploadRequest

export const PrepareUploadResponse = UploadTicket


/**
 * After the post: the asset becomes ready, or the mismatch is refused.
 * @summary Complete Upload
 */
export const CompleteUploadParams = zod.object({
  "asset_id": zod.uuid(),
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const CompleteUploadResponse = Asset


/**
 * Live's voice picker: the global voices (its actors') by name, narrowed by gender, age
 * and part of a name, each with its sample's signed URL; `kind=team`, the brand's own,
 * newest first.
 * @summary List Voices
 */
export const ListVoicesParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const listVoicesQuerySearchOneMax = 100;

export const listVoicesQueryAfterOneMax = 500;

export const listVoicesQueryLimitDefault = 50;
export const listVoicesQueryLimitMax = 100;



export const ListVoicesQueryParams = zod.object({
  "kind": zod.enum(['global', 'team']).exactOptional(),
  "gender": zod.union([VoiceGender,zod.null()]).exactOptional(),
  "age": zod.union([VoiceAge,zod.null()]).exactOptional(),
  "search": zod.union([zod.string().min(1).max(listVoicesQuerySearchOneMax),zod.null()]).exactOptional(),
  "after": zod.union([zod.string().max(listVoicesQueryAfterOneMax),zod.null()]).exactOptional(),
  "limit": zod.int().min(1).max(listVoicesQueryLimitMax).default(listVoicesQueryLimitDefault)
})

export const ListVoicesResponse = VoicePage


/**
 * Keep a designed voice (a delivered `voice.design` job of the brand) as the brand's:
 * its preview becomes the sample. A second save returns the same voice. 404 when the job is
 * missing, not a voice design or another brand's; 422 while it is not designed yet or once
 * its preview has expired.
 * @summary Save Designed Voice
 */
export const SaveDesignedVoiceParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const SaveDesignedVoiceBody = VoiceFromDesignRequest

export const SaveDesignedVoiceResponse = Voice


/**
 * A new voice's id and the form to post its sample with (an upload or a recording): an
 * MP3, M4A or WAV of up to 20 MB. Nothing is kept until `complete`.
 * @summary Prepare Voice Upload
 */
export const PrepareVoiceUploadParams = zod.object({
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const PrepareVoiceUploadBody = VoiceUploadRequest

export const PrepareVoiceUploadResponse = VoiceUploadTicket


/**
 * One of the brand's voices, by its creator, an admin or the owner. A global voice is
 * not found here.
 * @summary Delete Voice
 */
export const DeleteVoiceParams = zod.object({
  "voice_id": zod.uuid(),
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const DeleteVoiceResponse = zod.void()


/**
 * The posted sample becomes the brand's voice, once read: 15 to 60 seconds, as live's.
 * 404 while no file is there (none uploaded under this id, or another team's id); 422 for a
 * file of another length.
 * @summary Complete Voice Upload
 */
export const CompleteVoiceUploadParams = zod.object({
  "voice_id": zod.uuid(),
  "team_id": zod.uuid(),
  "brand_id": zod.uuid()
})

export const CompleteVoiceUploadBody = VoiceCompleteRequest

export const CompleteVoiceUploadResponse = Voice


/**
 * The member's own caption presets, oldest first, then live's six system presets.
 * @summary List Caption Presets
 */
export const ListCaptionPresetsParams = zod.object({
  "team_id": zod.uuid()
})

export const ListCaptionPresetsResponseItem = CaptionPreset
export const ListCaptionPresetsResponse = zod.array(ListCaptionPresetsResponseItem)


/**
 * Live's "Save style as preset": the look, named, kept for the member who saved it.
 * @summary Create Caption Preset
 */
export const CreateCaptionPresetParams = zod.object({
  "team_id": zod.uuid()
})

export const CreateCaptionPresetBody = CaptionPresetCreate

export const CreateCaptionPresetResponse = CaptionPreset


/**
 * Its maker deletes their preset (anyone else's is 404); live's system presets stay.
 * @summary Delete Caption Preset
 */
export const DeleteCaptionPresetParams = zod.object({
  "preset_id": zod.uuid(),
  "team_id": zod.uuid()
})

export const DeleteCaptionPresetResponse = zod.void()


/**
 * @summary List Invitations
 */
export const ListInvitationsParams = zod.object({
  "team_id": zod.uuid()
})

export const ListInvitationsResponseItem = Invitation
export const ListInvitationsResponse = zod.array(ListInvitationsResponseItem)


/**
 * Invite an email with a role; the token goes only into the email. 503 `EMAIL_UNAVAILABLE`:
 * the invitation is made but its email could not be sent, so resend it.
 * @summary Create Invitation
 */
export const CreateInvitationParams = zod.object({
  "team_id": zod.uuid()
})

export const CreateInvitationBody = InvitationCreate

export const CreateInvitationResponse = Invitation


/**
 * @summary Revoke Invitation
 */
export const RevokeInvitationParams = zod.object({
  "invitation_id": zod.uuid(),
  "team_id": zod.uuid()
})

export const RevokeInvitationResponse = zod.void()


/**
 * A new token and expiry in a new email; the old link stops working. 503
 * `EMAIL_UNAVAILABLE`: the new invitation is made but its email could not be sent.
 * @summary Resend Invitation
 */
export const ResendInvitationParams = zod.object({
  "invitation_id": zod.uuid(),
  "team_id": zod.uuid()
})

export const ResendInvitationResponse = Invitation


/**
 * The team's jobs, newest first: the Studio's (every type but `image.actor`, as
 * live's), or those of the types `type` names (`image.actor`: the AI Actors page's My
 * Generations; `image.template` and `video.template`: the Templates page's); `medium` keeps
 * those of one medium (the Image, Video and Sounds pages' My Generations, a page of their
 * own jobs alone: live's 5 at a time); `status=active` after missed events, `after` for the
 * next page (its cursor is `next` of the previous one).
 * @summary List Jobs
 */
export const ListJobsParams = zod.object({
  "team_id": zod.uuid()
})

export const listJobsQueryTypeOneMax = 8;

export const listJobsQueryAfterOneMax = 500;

export const listJobsQueryLimitDefault = 50;
export const listJobsQueryLimitMax = 100;



export const ListJobsQueryParams = zod.object({
  "status": zod.enum(['active', 'all']).exactOptional().describe('`active`: jobs not yet settled, the list a client reloads after missing events (proposal\n6.5). `all`: every job, the history.'),
  "brand_id": zod.union([zod.uuid(),zod.null()]).exactOptional(),
  "type": zod.union([zod.array(GenerationType).max(listJobsQueryTypeOneMax),zod.null()]).exactOptional(),
  "medium": zod.union([Medium,zod.null()]).exactOptional(),
  "after": zod.union([zod.string().max(listJobsQueryAfterOneMax),zod.null()]).exactOptional(),
  "limit": zod.int().min(1).max(listJobsQueryLimitMax).default(listJobsQueryLimitDefault)
})

export const ListJobsResponse = JobPage


/**
 * Live's "Delete generation": its maker hides a settled job for good (404 after);
 * `JOB_ACTIVE` (409) while it runs, `PERMISSION_DENIED` (403) for anyone else.
 * @summary Delete Job
 */
export const DeleteJobParams = zod.object({
  "job_id": zod.uuid(),
  "team_id": zod.uuid()
})

export const DeleteJobResponse = zod.void()


/**
 * @summary Get Job
 */
export const GetJobParams = zod.object({
  "job_id": zod.uuid(),
  "team_id": zod.uuid()
})

export const GetJobResponse = Job


/**
 * What the lightbox's ⓘ shows beyond the job (G1 decision 30): the credits charged,
 * null until charged; the names of its voices; its global actors with their portraits.
 * @summary Get Job Details
 */
export const GetJobDetailsParams = zod.object({
  "job_id": zod.uuid(),
  "team_id": zod.uuid()
})

export const GetJobDetailsResponse = JobDetails


/**
 * A Layerize's AI edits, newest first, at most 200, for the layer editor (G13b PR B1);
 * 404 for any job that is not a Layerize of the team.
 * @summary List Layer Edits
 */
export const ListLayerEditsParams = zod.object({
  "job_id": zod.uuid(),
  "team_id": zod.uuid()
})

export const ListLayerEditsResponse = LayerEditList


/**
 * A finished Layerize's layers and where each sits, for the layer editor (G13b PR A);
 * 404 for any other job, and for a Layerize from before its document was kept.
 * @summary Get Layer Document
 */
export const GetLayerDocumentParams = zod.object({
  "job_id": zod.uuid(),
  "team_id": zod.uuid()
})

export const GetLayerDocumentResponse = LayerDocument


/**
 * Clear the team's media cookies in this browser. Browser sessions only.
 * @summary Clear Media Access
 */
export const ClearMediaAccessParams = zod.object({
  "team_id": zod.uuid()
})

export const ClearMediaAccessResponse = zod.void()


/**
 * Set the team's media cookies (spec assets/media-cookies), so this browser reads the
 * team's files and the shared ones at their own URLs until `expires_at`, at most 1 h 15 min.
 * Each call checks the membership again and signs anew. Browser sessions only (403
 * `FORBIDDEN` otherwise); with cookies off, `enabled: false` and no cookie.
 * @summary Grant Media Access
 */
export const GrantMediaAccessParams = zod.object({
  "team_id": zod.uuid()
})

export const GrantMediaAccessResponse = MediaAccess


/**
 * Every member of the team, for every member (D6).
 * @summary List Members
 */
export const ListMembersParams = zod.object({
  "team_id": zod.uuid()
})

export const ListMembersResponseItem = Member
export const ListMembersResponse = zod.array(ListMembersResponseItem)


/**
 * Remove a member, or leave when it is the caller.
 * @summary Remove Member
 */
export const RemoveMemberParams = zod.object({
  "user_id": zod.uuid(),
  "team_id": zod.uuid()
})

export const RemoveMemberResponse = zod.void()


/**
 * @summary Change Member Role
 */
export const ChangeMemberRoleParams = zod.object({
  "user_id": zod.uuid(),
  "team_id": zod.uuid()
})

export const ChangeMemberRoleBody = MemberUpdate

export const ChangeMemberRoleResponse = Member


/**
 * A teammate's awards earned in this team, while they share here and do not hide; else
 * 404, the same for every reason, an admin's call included.
 * @summary Get Member Achievements
 */
export const GetMemberAchievementsParams = zod.object({
  "user_id": zod.uuid(),
  "team_id": zod.uuid()
})

export const GetMemberAchievementsResponseItem = SharedAchievement
export const GetMemberAchievementsResponse = zod.array(GetMemberAchievementsResponseItem)


/**
 * Every live product of the team's live brands, by name, for every member: live's Product
 * menus (the library's, the AI Actors') list every brand's.
 * @summary List Team Products
 */
export const ListTeamProductsParams = zod.object({
  "team_id": zod.uuid()
})

export const ListTeamProductsResponseItem = ProductSummary
export const ListTeamProductsResponse = zod.array(ListTeamProductsResponseItem)


/**
 * The team's storage (spec assets/storage-usage): the bytes its files hold, its library's,
 * its voices' samples and its actors' portraits, and its limit; the header's usage pill reads
 * it. Any member, as live's `GET /team/:id/storage/summary`.
 * @summary Get Team Storage
 */
export const GetTeamStorageParams = zod.object({
  "team_id": zod.uuid()
})

export const GetTeamStorageResponse = TeamStorage


/**
 * The library, 24 a page, in live's order (its templates, then Coming soon). `search`
 * in the title (live's "Search by templates name"), one category, one medium, `available`
 * for the cards that can be run. A live template whose run is not built shows as Coming
 * soon in its place. `next` names the last card of the page. Covers and examples are
 * signed until `urls_expire_at`.
 * @summary List Templates
 */
export const ListTemplatesParams = zod.object({
  "team_id": zod.uuid()
})

export const listTemplatesQuerySearchOneMax = 100;

export const listTemplatesQueryAfterOneMax = 64;

export const listTemplatesQueryLimitDefault = 24;
export const listTemplatesQueryLimitMax = 100;



export const ListTemplatesQueryParams = zod.object({
  "search": zod.union([zod.string().min(1).max(listTemplatesQuerySearchOneMax),zod.null()]).exactOptional(),
  "category": zod.union([TemplateCategory,zod.null()]).exactOptional(),
  "media": zod.union([Medium,zod.null()]).exactOptional(),
  "available": zod.union([zod.boolean(),zod.null()]).exactOptional(),
  "after": zod.union([zod.string().max(listTemplatesQueryAfterOneMax),zod.null()]).exactOptional(),
  "limit": zod.int().min(1).max(listTemplatesQueryLimitMax).default(listTemplatesQueryLimitDefault)
})

export const ListTemplatesResponse = TemplatePage


/**
 * Live's caption styles a template's subtitles picker offers, in live's order, and the
 * one a fresh form picks (Promote Your Product's picker; its run burns the one picked).
 * @summary List Template Caption Styles
 */
export const ListTemplateCaptionStylesParams = zod.object({
  "team_id": zod.uuid()
})

export const ListTemplateCaptionStylesResponse = TemplateCaptionStyleList


/**
 * The categories that hold a card, in live's order: the page's pills after "All".
 * @summary List Template Categories
 */
export const ListTemplateCategoriesParams = zod.object({
  "team_id": zod.uuid()
})

export const ListTemplateCategoriesResponse = TemplateCategoryList


/**
 * One template as Use and Replicate open it: its card and its example's inputs. No
 * such template, or a retired one, is 404.
 * @summary Get Template
 */
export const getTemplatePathTemplateIdMax = 64;


export const getTemplatePathTemplateIdRegExp = new RegExp('^[a-z0-9]+(?:-[a-z0-9]+)*$');


export const GetTemplateParams = zod.object({
  "template_id": zod.string().max(getTemplatePathTemplateIdMax).regex(getTemplatePathTemplateIdRegExp),
  "team_id": zod.uuid()
})

export const GetTemplateResponse = TemplateDetail


/**
 * A personal access token for this team, shown once. Browser sessions only.
 * @summary Create Token
 */
export const CreateTokenParams = zod.object({
  "team_id": zod.uuid()
})

export const CreateTokenBody = TokenCreate

export const CreateTokenResponse = TokenCreated
